/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./app/common/helpers/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("./app/common/helpers/randomDate.ts"));
__export(__webpack_require__("./app/common/helpers/monthName.ts"));
__export(__webpack_require__("./app/common/helpers/toPath.ts"));


/***/ }),

/***/ "./app/common/helpers/monthName.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
exports.monthName = function (monthNumber) {
    return monthNumber > 12
        ? months[11]
        : monthNumber < 1
            ? months[0]
            : months[monthNumber - 1];
};


/***/ }),

/***/ "./app/common/helpers/randomDate.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.randomDate = function (start, end) { return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime())); };


/***/ }),

/***/ "./app/common/helpers/toPath.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.toPath = function (name) {
    return name.replace(/-/g, '')
        .replace(/\s/g, '-')
        .replace(/[.,]/g, '')
        .toLowerCase();
};


/***/ }),

/***/ "./app/common/interfaces/activity.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NewActivityStatus;
(function (NewActivityStatus) {
    NewActivityStatus[NewActivityStatus["None"] = 0] = "None";
    NewActivityStatus[NewActivityStatus["Saving"] = 1] = "Saving";
    NewActivityStatus[NewActivityStatus["Error"] = 2] = "Error";
    NewActivityStatus[NewActivityStatus["Success"] = 3] = "Success";
})(NewActivityStatus = exports.NewActivityStatus || (exports.NewActivityStatus = {}));


/***/ }),

/***/ "./app/common/interfaces/businessPartner.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StatusOfBusinessPartner;
(function (StatusOfBusinessPartner) {
    StatusOfBusinessPartner[StatusOfBusinessPartner["None"] = 0] = "None";
    StatusOfBusinessPartner[StatusOfBusinessPartner["Saving"] = 1] = "Saving";
    StatusOfBusinessPartner[StatusOfBusinessPartner["ErrorTryAgain"] = 2] = "ErrorTryAgain";
    StatusOfBusinessPartner[StatusOfBusinessPartner["ErrorCustomerAlreadyCreated"] = 3] = "ErrorCustomerAlreadyCreated";
    StatusOfBusinessPartner[StatusOfBusinessPartner["Success"] = 4] = "Success";
})(StatusOfBusinessPartner = exports.StatusOfBusinessPartner || (exports.StatusOfBusinessPartner = {}));


/***/ }),

/***/ "./app/common/interfaces/pricing.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StatusOfNewPricingRequest;
(function (StatusOfNewPricingRequest) {
    StatusOfNewPricingRequest[StatusOfNewPricingRequest["None"] = 0] = "None";
    StatusOfNewPricingRequest[StatusOfNewPricingRequest["Saving"] = 1] = "Saving";
    StatusOfNewPricingRequest[StatusOfNewPricingRequest["ErrorNotAllItemsHaveQuantityAndPrice"] = 2] = "ErrorNotAllItemsHaveQuantityAndPrice";
    StatusOfNewPricingRequest[StatusOfNewPricingRequest["ErrorTryAgain"] = 3] = "ErrorTryAgain";
    StatusOfNewPricingRequest[StatusOfNewPricingRequest["Success"] = 4] = "Success";
})(StatusOfNewPricingRequest = exports.StatusOfNewPricingRequest || (exports.StatusOfNewPricingRequest = {}));


/***/ }),

/***/ "./app/common/interfaces/provider.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EDashboardView;
(function (EDashboardView) {
    EDashboardView["Grid"] = "grid";
    EDashboardView["List"] = "list";
})(EDashboardView = exports.EDashboardView || (exports.EDashboardView = {}));
var CreateNewLeadStatus;
(function (CreateNewLeadStatus) {
    CreateNewLeadStatus[CreateNewLeadStatus["None"] = 0] = "None";
    CreateNewLeadStatus[CreateNewLeadStatus["Saving"] = 1] = "Saving";
    CreateNewLeadStatus[CreateNewLeadStatus["ProviderIdRequired"] = 2] = "ProviderIdRequired";
    CreateNewLeadStatus[CreateNewLeadStatus["LegalBusNameRequired"] = 3] = "LegalBusNameRequired";
    CreateNewLeadStatus[CreateNewLeadStatus["ServerSideError"] = 4] = "ServerSideError";
    CreateNewLeadStatus[CreateNewLeadStatus["Success"] = 5] = "Success";
})(CreateNewLeadStatus = exports.CreateNewLeadStatus || (exports.CreateNewLeadStatus = {}));
var EVisibility;
(function (EVisibility) {
    EVisibility[EVisibility["Visible"] = 0] = "Visible";
    EVisibility[EVisibility["Hidden"] = 1] = "Hidden";
})(EVisibility = exports.EVisibility || (exports.EVisibility = {}));
var LeadGroupModalStatus;
(function (LeadGroupModalStatus) {
    LeadGroupModalStatus[LeadGroupModalStatus["Closed"] = 0] = "Closed";
    LeadGroupModalStatus[LeadGroupModalStatus["OpenedOnGroupList"] = 1] = "OpenedOnGroupList";
    LeadGroupModalStatus[LeadGroupModalStatus["OpenedOnSpecificGroup"] = 2] = "OpenedOnSpecificGroup";
    LeadGroupModalStatus[LeadGroupModalStatus["OpenedOnCreateGroup"] = 3] = "OpenedOnCreateGroup";
})(LeadGroupModalStatus = exports.LeadGroupModalStatus || (exports.LeadGroupModalStatus = {}));
var CreateLeadModalStatus;
(function (CreateLeadModalStatus) {
    CreateLeadModalStatus[CreateLeadModalStatus["Closed"] = 0] = "Closed";
    CreateLeadModalStatus[CreateLeadModalStatus["Opened"] = 1] = "Opened";
})(CreateLeadModalStatus = exports.CreateLeadModalStatus || (exports.CreateLeadModalStatus = {}));


/***/ }),

/***/ "./app/common/interfaces/resources.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UploadStatus;
(function (UploadStatus) {
    UploadStatus[UploadStatus["None"] = 0] = "None";
    UploadStatus[UploadStatus["Saving"] = 1] = "Saving";
    UploadStatus[UploadStatus["Error"] = 2] = "Error";
    UploadStatus[UploadStatus["Success"] = 3] = "Success";
})(UploadStatus = exports.UploadStatus || (exports.UploadStatus = {}));


/***/ }),

/***/ "./app/common/interfaces/state.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AssignUserStatus;
(function (AssignUserStatus) {
    AssignUserStatus[AssignUserStatus["None"] = 0] = "None";
    AssignUserStatus[AssignUserStatus["Saving"] = 1] = "Saving";
    AssignUserStatus[AssignUserStatus["Error"] = 2] = "Error";
    AssignUserStatus[AssignUserStatus["Success"] = 3] = "Success";
})(AssignUserStatus = exports.AssignUserStatus || (exports.AssignUserStatus = {}));
var StateModalStatus;
(function (StateModalStatus) {
    StateModalStatus[StateModalStatus["Closed"] = 0] = "Closed";
    StateModalStatus[StateModalStatus["OpenOnRepAreasList"] = 1] = "OpenOnRepAreasList";
    StateModalStatus[StateModalStatus["OpenOnSpecificRepArea"] = 2] = "OpenOnSpecificRepArea";
    StateModalStatus[StateModalStatus["OpenOnStatesList"] = 3] = "OpenOnStatesList";
    StateModalStatus[StateModalStatus["OpenOnSpecificArea"] = 4] = "OpenOnSpecificArea";
    StateModalStatus[StateModalStatus["OpenOnLeadReps"] = 5] = "OpenOnLeadReps";
})(StateModalStatus = exports.StateModalStatus || (exports.StateModalStatus = {}));
var AreasFilterType;
(function (AreasFilterType) {
    AreasFilterType["All"] = "Show both assigned and unassigned areas";
    AreasFilterType["OnlyUnassigned"] = "Show only unassigned areas";
    AreasFilterType["OnlyAssigned"] = "Show already assigned areas";
})(AreasFilterType = exports.AreasFilterType || (exports.AreasFilterType = {}));


/***/ }),

/***/ "./app/common/interfaces/user.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserType;
(function (UserType) {
    UserType["Admin"] = "M";
    UserType["SalesManager"] = "G";
    UserType["SalesRep"] = "S";
})(UserType = exports.UserType || (exports.UserType = {}));


/***/ }),

/***/ "./app/common/methods/activities.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__("./node_modules/moment/moment.js");
var ActivitiesMethods = /** @class */ (function () {
    function ActivitiesMethods() {
    }
    ActivitiesMethods.parseActivitiesGroups = function (activities) {
        var now = moment();
        var completeGroup = {
            title: 'Complete',
            key: 'complete',
            allFinished: true,
            activities: [],
        };
        var pastDueGroup = {
            title: 'Past due',
            key: 'pastdue',
            allFinished: false,
            activities: [],
        };
        var beforeTodayGroup = {
            title: 'In the past',
            key: 'pastdue',
            allFinished: false,
            activities: [],
        };
        var todayGroup = {
            title: 'Today',
            key: 'today',
            allFinished: true,
            activities: [],
        };
        var tomorrowGroup = {
            title: 'Tomorrow',
            key: 'tomorrow',
            allFinished: true,
            activities: [],
        };
        var thisWeekGroup = {
            title: 'Later this week',
            key: 'thisweek',
            allFinished: true,
            activities: [],
        };
        var nextWeekGroup = {
            title: 'Next week',
            key: 'nextweek',
            allFinished: true,
            activities: [],
        };
        var futureGroup = {
            title: 'In the future',
            key: 'future',
            allFinished: true,
            activities: [],
        };
        var noDateGroup = {
            title: 'No due date',
            key: 'nodue',
            allFinished: false,
            activities: [],
        };
        var completeGroupFinishedCount = 0;
        var pastDueGroupFinishedCount = 0;
        var beforeTodayGroupFinishedCount = 0;
        var todayGroupFinishedCount = 0;
        var tomorrowGroupFinishedCount = 0;
        var thisWeekGroupFinishedCount = 0;
        var nextWeekGroupFinishedCount = 0;
        var futureGroupFinishedCount = 0;
        var noDateGroupFinishedCount = 0;
        if (activities) {
            var today_1 = now.clone().startOf('day');
            var tomorrow_1 = now
                .clone()
                .subtract(-1, 'days')
                .startOf('day');
            var isPastDue_1 = function (date) {
                return date.isBefore(today_1, 'd');
            };
            var isToday_1 = function (date) { return date.isSame(today_1, 'd'); };
            var isTomorrow_1 = function (date) {
                return date.isSame(tomorrow_1, 'd');
            };
            var isInThisWeek_1 = function (date) {
                return date.isBetween(tomorrow_1.endOf('day'), moment().endOf('isoWeek'));
            };
            var isInNextWeek_1 = function (date) {
                return date.isBetween(moment()
                    .add(1, 'weeks')
                    .startOf('isoWeek'), moment()
                    .add(1, 'weeks')
                    .endOf('isoWeek'));
            };
            var isInFuture_1 = function (date) {
                return date.isAfter(moment()
                    .add(1, 'weeks')
                    .endOf('isoWeek'));
            };
            activities.map(function (activity) {
                var activityShort = {
                    id: activity.id,
                    time: activity.activityTime
                        ? moment(activity.activityTime)
                        : null,
                    title: activity.activityType.name,
                    note: activity.note,
                    author: activity.createdByUser,
                    assignedToUser: activity.assignedToUser,
                    provider: activity.provider,
                    finished: activity.finished,
                    savingComplete: activity.savingComplete,
                };
                if (activityShort.finished) {
                    completeGroupFinishedCount++;
                    completeGroup.activities.push(activityShort);
                }
                else if (activityShort.time === null) {
                    noDateGroupFinishedCount += activity.finished ? 1 : 0;
                    noDateGroup.activities.push(activityShort);
                }
                else if (isPastDue_1(activityShort.time) &&
                    !activityShort.finished) {
                    pastDueGroupFinishedCount += activity.finished ? 1 : 0;
                    pastDueGroup.activities.push(activityShort);
                }
                else if (isPastDue_1(activityShort.time) &&
                    activityShort.finished) {
                    beforeTodayGroupFinishedCount += activity.finished ? 1 : 0;
                    beforeTodayGroup.activities.push(activityShort);
                }
                else if (isToday_1(activityShort.time)) {
                    todayGroupFinishedCount += activity.finished ? 1 : 0;
                    todayGroup.activities.push(activityShort);
                }
                else if (isTomorrow_1(activityShort.time)) {
                    tomorrowGroupFinishedCount += activity.finished ? 1 : 0;
                    tomorrowGroup.activities.push(activityShort);
                }
                else if (isInThisWeek_1(activityShort.time)) {
                    thisWeekGroupFinishedCount += activity.finished ? 1 : 0;
                    thisWeekGroup.activities.push(activityShort);
                }
                else if (isInNextWeek_1(activityShort.time)) {
                    nextWeekGroupFinishedCount += activity.finished ? 1 : 0;
                    nextWeekGroup.activities.push(activityShort);
                }
                else if (isInFuture_1(activityShort.time)) {
                    futureGroupFinishedCount += activity.finished ? 1 : 0;
                    futureGroup.activities.push(activityShort);
                }
            });
        }
        var r = [];
        if (completeGroup.activities.length > 0) {
            completeGroup.allFinished =
                completeGroup.activities.length <= completeGroupFinishedCount;
            r.push(completeGroup);
        }
        if (pastDueGroup.activities.length > 0) {
            pastDueGroup.allFinished =
                pastDueGroup.activities.length <= pastDueGroupFinishedCount;
            r.push(pastDueGroup);
        }
        if (beforeTodayGroup.activities.length > 0) {
            beforeTodayGroup.allFinished =
                beforeTodayGroup.activities.length <=
                    beforeTodayGroupFinishedCount;
            r.push(beforeTodayGroup);
        }
        if (todayGroup.activities.length > 0) {
            todayGroup.allFinished =
                todayGroup.activities.length <= todayGroupFinishedCount;
            r.push(todayGroup);
        }
        if (tomorrowGroup.activities.length > 0) {
            tomorrowGroup.allFinished =
                tomorrowGroup.activities.length <= tomorrowGroupFinishedCount;
            r.push(tomorrowGroup);
        }
        if (thisWeekGroup.activities.length > 0) {
            thisWeekGroup.allFinished =
                thisWeekGroup.activities.length <= thisWeekGroupFinishedCount;
            r.push(thisWeekGroup);
        }
        if (nextWeekGroup.activities.length > 0) {
            nextWeekGroup.allFinished =
                nextWeekGroup.activities.length <= nextWeekGroupFinishedCount;
            r.push(nextWeekGroup);
        }
        if (futureGroup.activities.length > 0) {
            futureGroup.allFinished =
                futureGroup.activities.length <= futureGroupFinishedCount;
            r.push(futureGroup);
        }
        if (noDateGroup.activities.length > 0) {
            noDateGroup.allFinished =
                noDateGroup.activities.length <= noDateGroupFinishedCount;
            r.push(noDateGroup);
        }
        return r;
    };
    return ActivitiesMethods;
}());
exports.ActivitiesMethods = ActivitiesMethods;


/***/ }),

/***/ "./app/common/methods/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/common/methods/activities.ts"));


/***/ }),

/***/ "./app/web/data/location/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/data/location/states.ts"));


/***/ }),

/***/ "./app/web/data/location/states.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var usaStatesList;
(function (usaStatesList) {
    usaStatesList["AL"] = "Alabama";
    usaStatesList["AK"] = "Alaska";
    usaStatesList["AZ"] = "Arizona";
    usaStatesList["AR"] = "Arkansas";
    usaStatesList["CA"] = "California";
    usaStatesList["CO"] = "Colorado";
    usaStatesList["CT"] = "Connecticut";
    usaStatesList["DE"] = "Delaware";
    usaStatesList["DC"] = "District Of Columbia";
    usaStatesList["FL"] = "Florida";
    usaStatesList["GA"] = "Georgia";
    usaStatesList["GU"] = "Guam";
    usaStatesList["HI"] = "Hawaii";
    usaStatesList["ID"] = "Idaho";
    usaStatesList["IL"] = "Illinois";
    usaStatesList["IN"] = "Indiana";
    usaStatesList["IA"] = "Iowa";
    usaStatesList["KS"] = "Kansas";
    usaStatesList["KY"] = "Kentucky";
    usaStatesList["LA"] = "Louisiana";
    usaStatesList["ME"] = "Maine";
    usaStatesList["MD"] = "Maryland";
    usaStatesList["MA"] = "Massachusetts";
    usaStatesList["MI"] = "Michigan";
    usaStatesList["MN"] = "Minnesota";
    usaStatesList["MS"] = "Mississippi";
    usaStatesList["MO"] = "Missouri";
    usaStatesList["MT"] = "Montana";
    usaStatesList["NE"] = "Nebraska";
    usaStatesList["NV"] = "Nevada";
    usaStatesList["NH"] = "New Hampshire";
    usaStatesList["NJ"] = "New Jersey";
    usaStatesList["NM"] = "New Mexico";
    usaStatesList["NY"] = "New York";
    usaStatesList["NC"] = "North Carolina";
    usaStatesList["ND"] = "North Dakota";
    usaStatesList["OH"] = "Ohio";
    usaStatesList["OK"] = "Oklahoma";
    usaStatesList["OR"] = "Oregon";
    usaStatesList["PA"] = "Pennsylvania";
    usaStatesList["PR"] = "Puerto Rico";
    usaStatesList["RI"] = "Rhode Island";
    usaStatesList["SC"] = "South Carolina";
    usaStatesList["SD"] = "South Dakota";
    usaStatesList["TN"] = "Tennessee";
    usaStatesList["TX"] = "Texas";
    usaStatesList["UT"] = "Utah";
    usaStatesList["VT"] = "Vermont";
    usaStatesList["VA"] = "Virginia";
    usaStatesList["WA"] = "Washington";
    usaStatesList["WV"] = "West Virginia";
    usaStatesList["WI"] = "Wisconsin";
    usaStatesList["WY"] = "Wyoming";
    usaStatesList["CHAINS"] = "Chains";
})(usaStatesList = exports.usaStatesList || (exports.usaStatesList = {}));


/***/ }),

/***/ "./app/web/data/sales/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/data/sales/leadsInfo.ts"));
__export(__webpack_require__("./app/web/data/sales/leadsActivityDateFilter.ts"));


/***/ }),

/***/ "./app/web/data/sales/leadsActivityDateFilter.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__("./node_modules/moment/moment.js");
exports.activityDatesDropdownOptions = function () {
    var formatting = 'YYYY-MM-DD';
    var now = moment();
    var oldDateString = '1901-01-01';
    return [
        {
            key: 'all',
            value: '0',
            label: 'All',
        },
        {
            key: 'last7days',
            value: now.clone().subtract(7, 'days').format(formatting) +
                '/' +
                now.clone().add(1, 'days').format(formatting),
            label: 'Last completed activity in last 7 days',
        },
        {
            key: 'last10days',
            value: now.clone().subtract(10, 'days').format(formatting) +
                '/' +
                now.clone().add(1, 'days').format(formatting),
            label: 'Last completed activity in last 10 days',
        },
        {
            key: 'last2weeks',
            value: now.clone().subtract(2, 'weeks').format(formatting) +
                '/' +
                now.clone().add(1, 'days').format(formatting),
            label: 'Last completed activity in last 2 weeks',
        },
        {
            key: 'last1months',
            value: now.clone().subtract(1, 'months').format(formatting) +
                '/' +
                now.clone().add(1, 'days').format(formatting),
            label: 'Last completed activity in last month',
        },
        {
            key: 'last2months',
            value: now.clone().subtract(2, 'months').format(formatting) +
                '/' +
                now.clone().add(1, 'days').format(formatting),
            label: 'Last completed activity in last 2 months',
        },
        {
            key: 'last6months',
            value: now.clone().subtract(6, 'months').format(formatting) +
                '/' +
                now.clone().add(1, 'days').format(formatting),
            label: 'Last completed activity in last 6 months',
        },
        {
            key: 'last12months',
            value: now.clone().subtract(1, 'years').format(formatting) +
                '/' +
                now.clone().add(1, 'days').format(formatting),
            label: 'Last completed activity in last year',
        },
        {
            key: 'lastolderthan7days',
            value: oldDateString +
                '/' +
                now.clone().subtract(7, 'days').format(formatting),
            label: 'Last completed activity older than 7 days',
        },
        {
            key: 'lastolderthan10days',
            value: oldDateString +
                '/' +
                now.clone().subtract(10, 'days').format(formatting),
            label: 'Last completed activity older than 10 days',
        },
        {
            key: 'lastolderthan2weeks',
            value: oldDateString +
                '/' +
                now.clone().subtract(2, 'weeks').format(formatting),
            label: 'Last completed activity older than 2 weeks',
        },
        {
            key: 'lastolderthan1month',
            value: oldDateString +
                '/' +
                now.clone().subtract(1, 'months').format(formatting),
            label: 'Last completed activity older than a month',
        },
        {
            key: 'lastolderthan2months',
            value: oldDateString +
                '/' +
                now.clone().subtract(2, 'months').format(formatting),
            label: 'Last completed activity older than 2 months',
        },
        {
            key: 'lastolderthan6months',
            value: oldDateString +
                '/' +
                now.clone().subtract(6, 'months').format(formatting),
            label: 'Last completed activity older than 6 months',
        },
        {
            key: 'lastolderthan1year',
            value: oldDateString +
                '/' +
                now.clone().subtract(1, 'years').format(formatting),
            label: 'Last completed activity older than 1 year',
        },
        {
            key: 'no-activities',
            value: '-1',
            label: 'Leads with no activities ever created',
        },
    ];
};


/***/ }),

/***/ "./app/web/data/sales/leadsInfo.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.leadsInfo = [
    [{ 'Legal Business Name: ': 'legalBusName' }],
    [{ 'DBA: ': 'dba' }],
    [
        { 'Physical Address: ': '' },
        { '': 'plAddress1', COMMA: 'plAddress2' },
        { 'Phone: ': 'plPhone', 'Extn: ': 'plExt' },
    ],
    [
        { '': '' },
        { '': 'plCity', COMMA: 'plState', ' ': 'plZipcode' },
        { 'Fax: ': 'plFax' },
    ],
    [
        { 'Contact: ': 'contactFName', '': 'contactLName' },
        { '': '' },
        { 'Phone: ': 'contactPhone', 'Extn: ': 'contactExt' },
    ],
    [{ 'Title: ': 'contactTitle' }, { '': '' }, { 'Email: ': 'contactEmail' }],
];


/***/ }),

/***/ "./app/web/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var ReactDOM = __webpack_require__("./node_modules/react-dom/index.js");
var react_hot_loader_1 = __webpack_require__("./node_modules/react-hot-loader/index.js");
// Components
var App_1 = __webpack_require__("./app/web/src/App.tsx");
// Store
var AllStores_1 = __webpack_require__("./app/web/src/stores/AllStores.ts");
// Initialize React
ReactDOM.render(React.createElement(mobx_react_1.Provider, { store: AllStores_1.default },
    React.createElement(react_hot_loader_1.AppContainer, null,
        React.createElement(App_1.default, null))), document.getElementById('root'));
if (typeof module !== 'undefined' &&
    typeof module.hot !== 'undefined' &&
    module.hot) {
    module.hot.accept('./src/App', function () {
        ReactDOM.render(React.createElement(mobx_react_1.Provider, { store: AllStores_1.default },
            React.createElement(react_hot_loader_1.AppContainer, null,
                React.createElement(App_1.default, null))), document.getElementById('root'));
    });
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./app/web/src/App.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var layout_1 = __webpack_require__("./app/web/src/components/layout/index.tsx");
var history_1 = __webpack_require__("./node_modules/history/esm/history.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var mobx_react_devtools_1 = __webpack_require__("./node_modules/mobx-react-devtools/index.js");
var React = __webpack_require__("./node_modules/react/react.js");
var react_router_1 = __webpack_require__("./node_modules/react-router/es/index.js");
var sales_1 = __webpack_require__("./app/web/src/routes/sales/index.tsx");
var user_1 = __webpack_require__("./app/web/src/routes/user/index.tsx");
var PrivateRoute_1 = __webpack_require__("./app/web/src/components/route/private/PrivateRoute.tsx");
var routes_1 = __webpack_require__("./app/web/src/routes/index.tsx");
var PageNotFound_1 = __webpack_require__("./app/web/src/routes/errors/PageNotFound/PageNotFound.tsx");
var authentication = __webpack_require__("./node_modules/feathers-authentication-client/lib/index.js");
var hooks = __webpack_require__("./node_modules/feathers-hooks/lib/hooks.js");
var socketio = __webpack_require__("./node_modules/feathers-socketio/client.js");
var feathers = __webpack_require__("./node_modules/feathers/client.js");
var localForage = __webpack_require__("./node_modules/localforage/dist/localforage.js");
var io = __webpack_require__("./node_modules/socket.io-client/lib/index.js");
// History
exports.browserHistory = history_1.createBrowserHistory({
    forceRefresh: false,
});
var isDevEnvironment = typeof process !== 'undefined' &&
    typeof process.env !== 'undefined' &&
    "string" !== 'undefined' &&
    "production" === 'development'
    ? true
    : false;
var apiHost = typeof process !== 'undefined' &&
    typeof process.env !== 'undefined' &&
    "string" !== 'undefined'
    ? "https://crmapi.spykawholesale.com/"
    : 'http://localhost:3030/';
// API connection
exports.socket = io(apiHost);
exports.app = feathers();
// Initialize FeathersJS client
exports.app
    .configure(socketio(exports.socket, { timeout: 60000 }))
    .configure(hooks())
    .configure(authentication({
    storage: localForage,
}));
// Component
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.isLocalStorageTokenChecked = false;
        var utilities = _this.props.store.utilities;
        if (typeof _this.props.store !== 'undefined') {
            // Relogin user if they have a token stored locally
            _this.props.store.user
                .relogin()
                .then(function (response) {
                _this.isLocalStorageTokenChecked = true;
            })
                .catch(function (error) {
                _this.isLocalStorageTokenChecked = true;
            });
            // Track connectivity to the back-end via web sockets and inform user when things go wrong
            exports.socket.on('connect', function () {
                utilities.changeConnectionStatus(true);
            });
            exports.socket.on('reconnect', function () {
                utilities.changeConnectionStatus(true);
            });
            exports.socket.on('disconnect', function () {
                utilities.changeConnectionStatus(false);
            });
            exports.socket.on('error', function () {
                utilities.changeConnectionStatus(false);
            });
        }
        return _this;
    }
    App.prototype.render = function () {
        var _a = this.props.store, user = _a.user, utilities = _a.utilities;
        return (React.createElement("div", { id: "app" },
            this.isLocalStorageTokenChecked && (React.createElement(react_router_1.Router, { history: exports.browserHistory },
                React.createElement(react_router_1.Switch, null,
                    React.createElement(react_router_1.Route, { path: "/user/login", exact: true, component: user_1.Login }),
                    React.createElement(react_router_1.Route, { path: "/user/logout", exact: true, component: user_1.Logout }),
                    React.createElement(PrivateRoute_1.PrivateRoute, { path: "/sales", exact: true, component: sales_1.SalesDashboard }),
                    React.createElement(PrivateRoute_1.PrivateRoute, { path: "/sales/lead/:providerId", component: sales_1.SalesLead }),
                    React.createElement(react_router_1.Route, { path: "/", exact: true, component: routes_1.default }),
                    React.createElement(react_router_1.Route, { component: PageNotFound_1.PageNotFound })))),
            React.createElement(layout_1.OfflineArea, { show: utilities.showOfflineArea }),
            isDevEnvironment && React.createElement(mobx_react_devtools_1.default, null)));
    };
    __decorate([
        mobx_1.observable
    ], App.prototype, "isLocalStorageTokenChecked", void 0);
    App = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], App);
    return App;
}(React.Component));
exports.default = App;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./app/web/src/assets/back icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/back icon-78b489b9.svg";

/***/ }),

/***/ "./app/web/src/assets/blue arrow.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/blue arrow-0df6d830.svg";

/***/ }),

/***/ "./app/web/src/assets/briefcase icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/briefcase icon-ae3385f6.svg";

/***/ }),

/***/ "./app/web/src/assets/building icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/building icon-ba4f8e58.svg";

/***/ }),

/***/ "./app/web/src/assets/close blue icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/close blue icon-e660caf5.svg";

/***/ }),

/***/ "./app/web/src/assets/close orange icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/close orange icon-4b9889e6.svg";

/***/ }),

/***/ "./app/web/src/assets/contact icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/contact icon-3c00d32d.svg";

/***/ }),

/***/ "./app/web/src/assets/conversation icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/conversation icon-174f20a2.svg";

/***/ }),

/***/ "./app/web/src/assets/crm-logo.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/raster/app/web/src/assets/crm-logo-35311649.png";

/***/ }),

/***/ "./app/web/src/assets/document profile icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/document profile icon-a0a1d044.svg";

/***/ }),

/***/ "./app/web/src/assets/documents icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/documents icon-66dd6128.svg";

/***/ }),

/***/ "./app/web/src/assets/dropdown arrow.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/dropdown arrow-fcf2a854.svg";

/***/ }),

/***/ "./app/web/src/assets/filetypes/acrobat icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/filetypes/acrobat icon-b0b17b2b.svg";

/***/ }),

/***/ "./app/web/src/assets/filetypes/file corner.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAgMAAABinRfyAAAACVBMVEVMaXHc3t7c3t5Rj3EMAAAAAnRSTlMAgJsrThgAAAAsSURBVAjXFcgxAQAgDMAwpCERETxUJUuPHll7TceuPQsGg8FgMBgMBoOz9wHGoBhl9MV0/wAAAABJRU5ErkJggg=="

/***/ }),

/***/ "./app/web/src/assets/filetypes/image icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/filetypes/image icon-f2842a2d.svg";

/***/ }),

/***/ "./app/web/src/assets/filetypes/office excel icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/filetypes/office excel icon-3d1d197b.svg";

/***/ }),

/***/ "./app/web/src/assets/filetypes/office powerpoint icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/filetypes/office powerpoint icon-b110cf3d.svg";

/***/ }),

/***/ "./app/web/src/assets/filetypes/office word icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/filetypes/office word icon-27224e99.svg";

/***/ }),

/***/ "./app/web/src/assets/filetypes/other format icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/filetypes/other format icon-4110a675.svg";

/***/ }),

/***/ "./app/web/src/assets/grey arrow.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/grey arrow-eff447f3.svg";

/***/ }),

/***/ "./app/web/src/assets/id icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/id icon-e12970e7.svg";

/***/ }),

/***/ "./app/web/src/assets/license icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/license icon-f70ea93c.svg";

/***/ }),

/***/ "./app/web/src/assets/loupe icon blue.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/loupe icon blue-b4a44e0c.svg";

/***/ }),

/***/ "./app/web/src/assets/note.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/note-20fafd88.svg";

/***/ }),

/***/ "./app/web/src/assets/padlock-icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/padlock-icon-50888bf5.svg";

/***/ }),

/***/ "./app/web/src/assets/pen icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/pen icon-3c200f55.svg";

/***/ }),

/***/ "./app/web/src/assets/person icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/person icon-9259fb5f.svg";

/***/ }),

/***/ "./app/web/src/assets/plus icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/plus icon-865067f2.svg";

/***/ }),

/***/ "./app/web/src/assets/primary icon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/primary icon-dfd4479f.svg";

/***/ }),

/***/ "./app/web/src/assets/tick dim.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/tick dim-9c841242.svg";

/***/ }),

/***/ "./app/web/src/assets/tick green.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/tick green-7346d9d3.svg";

/***/ }),

/***/ "./app/web/src/assets/tick white.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/tick white-2ab9d99c.svg";

/***/ }),

/***/ "./app/web/src/assets/visibility button.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/vector/app/web/src/assets/visibility button-1558c608.svg";

/***/ }),

/***/ "./app/web/src/components/action/Button.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/action/Button.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Button.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Button.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/action/Button.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/components/action/Button.css");
// Enumerables
var EButtonType;
(function (EButtonType) {
    EButtonType[EButtonType["Action"] = 0] = "Action";
    EButtonType[EButtonType["Important"] = 1] = "Important";
})(EButtonType = exports.EButtonType || (exports.EButtonType = {}));
// Default props
var defaultProps = {
    onClick: null,
    className: null,
    inBox: false,
    isDisabled: false,
    type: EButtonType.Action,
    icon: {
        element: null,
        onLeft: false,
    },
};
// Component
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button(props) {
        var _this = _super.call(this, props) || this;
        _this.handleButtonClick = function (e) {
            if (_this.props.onClick) {
                _this.props.onClick(e);
            }
        };
        return _this;
    }
    Button.prototype.render = function () {
        var _a;
        // Destructure
        var _b = this.props, className = _b.className, type = _b.type, inBox = _b.inBox, isDisabled = _b.isDisabled;
        // Render
        return (React.createElement("button", { disabled: isDisabled, onClick: this.handleButtonClick, className: classNames((_a = {
                    button: true
                },
                _a[s.button] = true,
                _a[s.box] = inBox,
                _a[s.action] = type === EButtonType.Action,
                _a[s.important] = type === EButtonType.Important,
                _a[className] = !!className,
                _a)) },
            (this.props.icon.element && this.props.icon.onLeft === true) && (React.createElement("span", { className: s.icon }, this.props.icon.element)),
            React.createElement("span", { className: s.children }, this.props.children),
            (this.props.icon.element && this.props.icon.onLeft === false) && (React.createElement("span", { className: s.icon }, this.props.icon.element))));
    };
    Button.defaultProps = defaultProps;
    Button = __decorate([
        mobx_react_1.observer
    ], Button);
    return Button;
}(React.Component));
exports.Button = Button;


/***/ }),

/***/ "./app/web/src/components/action/CardButton.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/action/CardButton.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./CardButton.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./CardButton.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/action/CardButton.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __webpack_require__("./node_modules/classnames/index.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/components/action/CardButton.css");
var arrowIcon = __webpack_require__("./app/web/src/assets/blue arrow.svg");
// Component
var CardButton = /** @class */ (function (_super) {
    __extends(CardButton, _super);
    function CardButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardButton.prototype.render = function () {
        var _a;
        return (React.createElement("button", { className: classnames_1.default(s.button, (_a = {}, _a[s.disabled] = this.props.isDisabled, _a), this.props.className), onClick: this.props.onClick, disabled: this.props.isDisabled },
            this.props.children,
            React.createElement("img", { className: classnames_1.default(s.arrow, this.props.classNameForIcon), src: this.props.icon || arrowIcon })));
    };
    CardButton = __decorate([
        mobx_react_1.observer
    ], CardButton);
    return CardButton;
}(React.Component));
exports.CardButton = CardButton;


/***/ }),

/***/ "./app/web/src/components/action/Checkbox.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/action/Checkbox.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Checkbox.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Checkbox.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/action/Checkbox.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/components/action/Checkbox.css");
var tickWhite = __webpack_require__("./app/web/src/assets/tick white.svg");
var tickDim = __webpack_require__("./app/web/src/assets/tick dim.svg");
// Component
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.checked = _this.props.checked;
        _this.renderLabel = function () {
            return React.createElement("p", null, _this.props.label);
        };
        _this.handleIconButtonClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.handleCheckboxToggle();
        };
        _this.handleCheckboxToggle = function () {
            if (_this.props.disabled === false) {
                var isChecked = !_this.checked;
                _this.checked = isChecked;
                if (_this.props.onChange) {
                    _this.props.onChange(isChecked, isChecked ? _this.props.value : _this.props.valueUnchecked);
                }
            }
        };
        return _this;
    }
    Object.defineProperty(Checkbox, "defaultProps", {
        get: function () {
            return {
                onChange: null,
                className: null,
                align: 'left',
                checked: false,
                disabled: false,
                value: true,
                valueUnchecked: null,
                label: '',
                labelOnLeft: false,
            };
        },
        enumerable: true,
        configurable: true
    });
    Checkbox.prototype.componentWillUpdate = function (nextProps) {
        if (this.props.checked !== nextProps.checked &&
            nextProps.checked !== this.checked) {
            this.checked = nextProps.checked;
        }
    };
    Checkbox.prototype.render = function () {
        var _a;
        return (React.createElement("label", { className: classNames(s.checkbox, this.props.className, (_a = {},
                _a[s.alignLeft] = this.props.align === 'left',
                _a[s.alignCenter] = this.props.align === 'center',
                _a[s.alignRight] = this.props.align === 'right',
                _a[s.labelOnLeft] = this.props.labelOnLeft,
                _a[s.checked] = this.checked,
                _a[s.disabled] = this.props.disabled,
                _a)) },
            this.props.labelOnLeft === true && this.renderLabel(),
            React.createElement("input", { tabIndex: -1, onChange: this.handleCheckboxToggle, disabled: this.props.disabled, type: "checkbox", value: this.props.value, checked: this.checked }),
            this.props.labelOnLeft === false && this.renderLabel(),
            React.createElement("button", { tabIndex: this.props.disabled ? -1 : undefined, onClick: this.handleIconButtonClick, className: s.icon },
                React.createElement("img", { src: this.checked ? tickWhite : tickDim }))));
    };
    __decorate([
        mobx_1.observable
    ], Checkbox.prototype, "checked", void 0);
    Checkbox = __decorate([
        mobx_react_1.observer
    ], Checkbox);
    return Checkbox;
}(React.Component));
exports.Checkbox = Checkbox;


/***/ }),

/***/ "./app/web/src/components/action/FileUpload.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/action/FileUpload.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./FileUpload.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./FileUpload.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/action/FileUpload.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
// Imports
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/components/action/FileUpload.css");
// Component
var FileUpload = /** @class */ (function (_super) {
    __extends(FileUpload, _super);
    function FileUpload(props) {
        var _this = _super.call(this, props) || this;
        _this.fileField = null;
        _this.referenceFileField = function (ref) { return _this.fileField = ref; };
        _this.fileUploadForm = null;
        _this.referenceFileUploadForm = function (ref) { return _this.fileUploadForm = ref; };
        _this.handleDragEnter = function (e) {
            if (_this.fileField) {
                _this.fileField.value = '';
            }
            if (_this.fileUploadForm) {
                _this.fileUploadForm.classList.add('dragging');
            }
        };
        _this.handleDragLeave = function (e) {
            _this.fileUploadForm.classList.remove('dragging');
        };
        _this.handleDragDrop = function (e) {
            console.log('drop', e);
        };
        _this.handleClick = function (e) {
            if (_this.fileField) {
                _this.fileField.value = '';
            }
        };
        _this.handleChange = function (e) {
            _this.props.onChange(_this.fileField.files);
        };
        return _this;
    }
    Object.defineProperty(FileUpload, "defaultProps", {
        get: function () {
            return {
                uploading: false,
                files: null,
                name: null,
                title: null,
                label: 'Drag file or click to upload',
                disabled: false,
                multiple: false,
                acceptedExtensions: null,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileUpload.prototype, "hasFiles", {
        get: function () {
            return this.props.files && this.props.files.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FileUpload.prototype, "label", {
        get: function () {
            if (this.hasFiles) {
                var label = 'Upload: ';
                for (var i = 0; i < this.props.files.length; i++) {
                    var file = this.props.files[i];
                    if (i > 0) {
                        label += ', ';
                    }
                    label += file.name;
                }
                return label;
            }
            else {
                return this.props.label;
            }
        },
        enumerable: true,
        configurable: true
    });
    FileUpload.prototype.render = function () {
        var _a;
        return (React.createElement("div", { ref: this.referenceFileUploadForm, className: classNames(s.fileUploadForm, (_a = {},
                _a[s.disabled] = this.props.disabled,
                _a[s.active] = this.hasFiles,
                _a)) },
            (this.props.title) && (React.createElement("h1", { className: s.title }, this.props.title)),
            React.createElement("div", { className: s.container },
                React.createElement("div", { className: s.uploadGroup },
                    (this.label) && (React.createElement("p", null, this.label)),
                    React.createElement("input", { type: "file", ref: this.referenceFileField, id: this.props.name || undefined, name: this.props.name || undefined, disabled: this.props.disabled, multiple: this.props.multiple, accept: this.props.acceptedExtensions || undefined, draggable: true, onDragLeave: this.handleDragLeave, onDragEnd: this.handleDragLeave, onDragEnter: this.handleDragEnter, onDrop: this.handleDragDrop, onClick: this.handleClick, onChange: this.handleChange })),
                React.createElement(indicator_1.LoadingFullScreen, { active: this.props.uploading, fitInContainer: true }))));
    };
    __decorate([
        mobx_1.computed
    ], FileUpload.prototype, "hasFiles", null);
    __decorate([
        mobx_1.computed
    ], FileUpload.prototype, "label", null);
    FileUpload = __decorate([
        mobx_react_1.observer
    ], FileUpload);
    return FileUpload;
}(React.Component));
exports.FileUpload = FileUpload;


/***/ }),

/***/ "./app/web/src/components/action/IconButton.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/action/IconButton.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./IconButton.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./IconButton.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/action/IconButton.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/components/action/IconButton.css");
// Component
var IconButton = /** @class */ (function (_super) {
    __extends(IconButton, _super);
    function IconButton(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(IconButton, "defaultProps", {
        get: function () {
            return {
                onClick: null,
                className: null,
                labelClassName: null,
                iconClassName: null,
                labelOnRight: false,
                showLabel: false,
                label: '',
                icon: null,
                removePadding: false,
            };
        },
        enumerable: true,
        configurable: true
    });
    IconButton.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, iconClassName = _b.iconClassName, labelOnRight = _b.labelOnRight, showLabel = _b.showLabel, label = _b.label, icon = _b.icon, removePadding = _b.removePadding;
        return (React.createElement("button", { onClick: this.props.onClick, className: classNames(s.button, (_a = {},
                _a[s.labelOnRight] = labelOnRight,
                _a[s.alwaysVisible] = showLabel,
                _a[s.noPadding] = removePadding,
                _a), className) },
            label && labelOnRight === false && this.renderLabel(),
            icon && (React.createElement("span", { className: classNames(s.icon, iconClassName) },
                React.createElement("img", { src: icon }))),
            label && labelOnRight === true && this.renderLabel()));
    };
    IconButton.prototype.renderLabel = function () {
        return (React.createElement("span", { className: classNames(s.label, this.props.labelClassName) }, this.props.label));
    };
    IconButton = __decorate([
        mobx_react_1.observer
    ], IconButton);
    return IconButton;
}(React.Component));
exports.IconButton = IconButton;


/***/ }),

/***/ "./app/web/src/components/action/Search.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/action/Search.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Search.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Search.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/action/Search.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var accounting_1 = __webpack_require__("./node_modules/accounting/accounting.js");
var classnames_1 = __webpack_require__("./node_modules/classnames/index.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var IconButton_1 = __webpack_require__("./app/web/src/components/action/IconButton.tsx");
// Styles
var s = __webpack_require__("./app/web/src/components/action/Search.css");
var cancelIcon = __webpack_require__("./app/web/src/assets/close orange icon.svg");
// Component
var Search = /** @class */ (function (_super) {
    __extends(Search, _super);
    function Search() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.optionsList = null;
        _this.referenceContainer = function (ref) {
            if (_this.props.innerRef) {
                _this.props.innerRef(ref);
            }
        };
        _this.referenceOptionsList = function (ref) {
            return (_this.optionsList = ref);
        };
        _this.changeOption = function (e) {
            if (_this.optionsList && _this.props.onOptionChange) {
                var val = _this.optionsList.value;
                // Return null
                if (val === null || val === 'null' || val === 'NULL') {
                    _this.props.onOptionChange(null);
                    return;
                }
                // Check if value is a number
                if (isNaN(val) ? /^[0-9|,|.|-| ]*$/.test(val) : val !== null) {
                    _this.props.onOptionChange(accounting_1.unformat(val));
                    return;
                }
                _this.props.onOptionChange(val);
            }
        };
        _this.changeValue = function (e) {
            if (_this.props.onValueChange) {
                _this.props.onValueChange(e.target.value);
            }
        };
        _this.clearSearch = function () {
            if (_this.props.onValueChange && _this.props.value) {
                _this.props.onValueChange('');
            }
            if (_this.props.clearOnlySearchValue === false &&
                _this.props.onOptionChange &&
                _this.props.options &&
                _this.props.selectedOption !== null) {
                _this.props.onOptionChange(null);
            }
        };
        return _this;
    }
    Object.defineProperty(Search.prototype, "defaultProps", {
        get: function () {
            return {
                label: '',
                options: [],
                selectedOption: null,
                placeholder: '',
                autoFocus: false,
                value: '',
                isValueClearable: false,
                clearOnlySearchValue: false,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Search.prototype, "searchNotEmpty", {
        get: function () {
            return typeof this.props.onValueChange !== 'undefined' &&
                this.props.value
                ? true
                : false;
        },
        enumerable: true,
        configurable: true
    });
    Search.prototype.render = function () {
        var _a;
        return (React.createElement("div", { ref: this.referenceContainer, className: classnames_1.default(s.container, this.props.className) },
            React.createElement("label", { className: s.wrapper, htmlFor: this.props.id || undefined },
                this.props.label && (React.createElement("p", { className: classnames_1.default(s.label, this.props.classNameForLabel) },
                    React.createElement("span", null, this.props.label))),
                this.props.onValueChange && (React.createElement("input", { id: this.props.id || undefined, className: classnames_1.default(s.field, this.props.classNameForField), type: "text", autoFocus: this.props.autoFocus, placeholder: this.props.placeholder, value: this.props.value, onChange: this.changeValue })),
                this.props.options && this.props.options.length > 0 && (React.createElement("select", { ref: this.referenceOptionsList, id: this.props.id &&
                        typeof this.props.onValueChange === 'undefined'
                        ? this.props.id
                        : undefined, className: classnames_1.default(s.options, this.props.classNameForOptions), onChange: this.changeOption, value: typeof this.props.selectedOption ===
                        'undefined' ||
                        this.props.selectedOption === null
                        ? 'null'
                        : this.props.selectedOption }, this.props.options.map(function (activity) { return (React.createElement("option", { key: activity.key || activity.value, value: activity.value }, activity.label)); }))),
                this.props.onValueChange && this.props.isValueClearable && (React.createElement(IconButton_1.IconButton, { className: classnames_1.default(s.clearButton, (_a = {},
                        _a[s.visible] = this.searchNotEmpty,
                        _a)), iconClassName: s.clearIcon, labelClassName: s.clearLabel, onClick: this.clearSearch, icon: cancelIcon, label: "Clear", labelOnRight: false })))));
    };
    __decorate([
        mobx_1.computed
    ], Search.prototype, "searchNotEmpty", null);
    Search = __decorate([
        mobx_react_1.observer
    ], Search);
    return Search;
}(React.Component));
exports.Search = Search;


/***/ }),

/***/ "./app/web/src/components/action/Toggle.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/action/Toggle.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Toggle.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Toggle.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/action/Toggle.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var isEqual_1 = __webpack_require__("./node_modules/lodash-es/isEqual.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/components/action/Toggle.css");
// Component
var Toggle = /** @class */ (function (_super) {
    __extends(Toggle, _super);
    function Toggle(props) {
        var _this = _super.call(this, props) || this;
        _this.sizing = {
            left: 0,
            right: 0,
        };
        _this.leftLabel = null;
        _this.rightLabel = null;
        _this.referenceLeftLabel = function (ref) {
            return (_this.leftLabel = ref);
        };
        _this.referenceRightLabel = function (ref) {
            return (_this.rightLabel = ref);
        };
        _this.handleToggle = function (e) {
            _this.calculateSliderPositionAndSize();
            if (_this.props.onChange) {
                _this.props.onChange(_this.value === 'unknown' || _this.value === 'right'
                    ? _this.props.left
                    : _this.value === 'left'
                        ? _this.props.right
                        : null);
            }
        };
        _this.calculateSliderPositionAndSize = function () {
            _this.sizing = {
                left: _this.leftLabel ? _this.leftLabel.offsetWidth : 0,
                right: _this.rightLabel ? _this.rightLabel.offsetWidth : 0,
            };
        };
        setTimeout(function () {
            _this.calculateSliderPositionAndSize();
        }, 128);
        return _this;
    }
    Object.defineProperty(Toggle, "defaultProps", {
        get: function () {
            return {
                onChange: null,
                left: {
                    value: false,
                    label: null,
                    type: 'default',
                },
                right: {
                    value: true,
                    label: null,
                    type: 'default',
                },
                value: null,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Toggle.prototype, "value", {
        get: function () {
            return this.props.value !== null
                ? this.props.value === this.props.left.value
                    ? 'left'
                    : this.props.value === this.props.right.value
                        ? 'right'
                        : 'unknown'
                : 'unknown';
        },
        enumerable: true,
        configurable: true
    });
    Toggle.prototype.componentDidUpdate = function (prevProps) {
        if (!isEqual_1.default(this.props.left, prevProps.left) ||
            !isEqual_1.default(this.props.right, prevProps.right)) {
            this.calculateSliderPositionAndSize();
        }
    };
    Toggle.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f;
        return (React.createElement("button", { onClick: this.handleToggle, className: classNames(s.toggle, (_a = {},
                _a[s.isUnknown] = this.value === 'unknown',
                _a[s.isLeft] = this.value === 'left',
                _a[s.isRight] = this.value === 'right',
                _a)) },
            React.createElement("p", { ref: this.referenceLeftLabel, className: classNames(s.left, (_b = {},
                    _b[s.important] = typeof this.props.left.type !== 'undefined' &&
                        this.props.left.type === 'important',
                    _b[s.success] = typeof this.props.left.type !== 'undefined' &&
                        this.props.left.type === 'success',
                    _b)) },
                React.createElement("span", null, typeof this.props.left.label !== 'undefined' &&
                    this.props.left.label
                    ? this.props.left.label
                    : '')),
            React.createElement("p", { ref: this.referenceRightLabel, className: classNames(s.right, (_c = {},
                    _c[s.important] = typeof this.props.right.type !== 'undefined' &&
                        this.props.right.type === 'important',
                    _c[s.success] = typeof this.props.right.type !== 'undefined' &&
                        this.props.right.type === 'success',
                    _c)) },
                React.createElement("span", null, typeof this.props.right.label !== 'undefined' &&
                    this.props.right.label
                    ? this.props.right.label
                    : '')),
            React.createElement("div", { className: s.slider, style: {
                    opacity: (this.sizing.left !== 0 &&
                        this.sizing.right !== 0) ||
                        this.value === 'unknown'
                        ? 1
                        : 0,
                    left: this.value === 'unknown'
                        ? '0px'
                        : this.value === 'right'
                            ? '0px'
                            : this.sizing.left + 'px',
                    width: this.value === 'unknown'
                        ? this.sizing.left + this.sizing.right + 'px'
                        : this.value === 'right'
                            ? this.sizing.left + 'px'
                            : this.sizing.right + 'px',
                } },
                React.createElement("p", null, this.value === 'unknown' ? 'Answer' : ''),
                React.createElement("span", { className: classNames(s.ridge, s.ridgeLeft, (_d = {},
                        _d[s.hidden] = this.value === 'unknown',
                        _d)) }),
                React.createElement("span", { className: classNames(s.ridge, (_e = {},
                        _e[s.hidden] = this.value === 'unknown',
                        _e)) }),
                React.createElement("span", { className: classNames(s.ridge, s.ridgeRight, (_f = {},
                        _f[s.hidden] = this.value === 'unknown',
                        _f)) }))));
    };
    __decorate([
        mobx_1.observable
    ], Toggle.prototype, "sizing", void 0);
    __decorate([
        mobx_1.computed
    ], Toggle.prototype, "value", null);
    Toggle = __decorate([
        mobx_react_1.observer
    ], Toggle);
    return Toggle;
}(React.Component));
exports.Toggle = Toggle;


/***/ }),

/***/ "./app/web/src/components/action/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/components/action/Button.tsx"));
__export(__webpack_require__("./app/web/src/components/action/IconButton.tsx"));
__export(__webpack_require__("./app/web/src/components/action/CardButton.tsx"));
__export(__webpack_require__("./app/web/src/components/action/Checkbox.tsx"));
__export(__webpack_require__("./app/web/src/components/action/Toggle.tsx"));
__export(__webpack_require__("./app/web/src/components/action/FileUpload.tsx"));
__export(__webpack_require__("./app/web/src/components/action/Search.tsx"));


/***/ }),

/***/ "./app/web/src/components/activity/Activities.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/activity/Activities.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Activities.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Activities.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/activity/ActivitiesGroup.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var activity_1 = __webpack_require__("./app/web/src/components/activity/index.tsx");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
// Styles
var s = __webpack_require__("./app/web/src/components/activity/Activities.css");
// Component
var ActivitiesGroup = /** @class */ (function (_super) {
    __extends(ActivitiesGroup, _super);
    function ActivitiesGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.now = moment();
        _this.handleActivityClick = function (activityId) {
            var activityIndex = -1;
            _this.props.activities.some(function (activity, i) {
                if (activity.id === activityId) {
                    activityIndex = i;
                    return true;
                }
            });
            if (activityIndex !== -1) {
                var activity = _this.props.activities[activityIndex];
                _this.props.store.sidebar.closeSidebar();
                App_1.browserHistory.push('/sales/lead/' + activity.provider.databaseId);
            }
        };
        _this.handleActivityEdit = function (activityId) {
            _this.props.store.activitiesCreateOrEdit.startEditingExistingActivity(activityId);
        };
        _this.handleActivityMarkAsComplete = function (activityId) { return __awaiter(_this, void 0, void 0, function () {
            var _a, activities, leadActivities, userActivityIndex, leadActivityIndex, finished, service, patch, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props.store, activities = _a.activities, leadActivities = _a.leadActivities;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        userActivityIndex = activities.userActivitiesIds.indexOf(activityId);
                        leadActivityIndex = leadActivities.openLeadActivitiesIds.indexOf(activityId);
                        finished = false;
                        if (userActivityIndex !== -1) {
                            finished =
                                activities.userActivities[activities.userActivitiesIndex]
                                    .activities[userActivityIndex].finished;
                            activities.userActivities[activities.userActivitiesIndex].activities[userActivityIndex].savingComplete = true;
                        }
                        if (leadActivityIndex !== -1) {
                            finished =
                                leadActivities.leadActivities[leadActivities.openLeadActivitiesIndex].activities[leadActivityIndex].finished;
                            leadActivities.leadActivities[leadActivities.openLeadActivitiesIndex].activities[leadActivityIndex].savingComplete = true;
                        }
                        return [4 /*yield*/, App_1.app.service('activity')];
                    case 2:
                        service = _b.sent();
                        return [4 /*yield*/, service.patch(activityId, {
                                finished: !finished,
                            })];
                    case 3:
                        patch = _b.sent();
                        if (userActivityIndex !== -1) {
                            activities.userActivities[activities.userActivitiesIndex].activities[userActivityIndex].savingComplete = false;
                            activities.userActivities[activities.userActivitiesIndex].activities[userActivityIndex].finished = !finished;
                        }
                        if (leadActivityIndex !== -1) {
                            leadActivities.leadActivities[leadActivities.openLeadActivitiesIndex].activities[leadActivityIndex].savingComplete = false;
                            leadActivities.leadActivities[leadActivities.openLeadActivitiesIndex].activities[leadActivityIndex].finished = !finished;
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _b.sent();
                        console.error(err_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    Object.defineProperty(ActivitiesGroup, "defaultProps", {
        get: function () {
            return {
                className: null,
                activities: [],
                allFinished: false,
                title: null,
                isOnLeadPage: false,
            };
        },
        enumerable: true,
        configurable: true
    });
    ActivitiesGroup.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, activities = _b.activities, title = _b.title, isOnLeadPage = _b.isOnLeadPage, allFinished = _b.allFinished;
        return (React.createElement("div", { className: classNames(s.activityGroup, this.props.className, (_a = {},
                _a[s.activityGroupWide] = isOnLeadPage,
                _a[s.activitiesAllFinished] = allFinished,
                _a)) },
            React.createElement("div", { className: s.groupTitle }, title),
            React.createElement("div", { className: s.groupList }, activities.map(function (activity) {
                return _this.props.store.activitiesCreateOrEdit.editingActivitiesIds.indexOf(activity.id) === -1 ? (React.createElement(activity_1.Activity, { key: "view-" + activity.id, activity: activity, onClick: _this.handleActivityClick, onEdit: _this.handleActivityEdit, onMarkAsComplete: _this.handleActivityMarkAsComplete, loggedInUserId: _this.props.store.user.id, loggedInUserType: _this.props.store.user.userType, isOnLeadPage: isOnLeadPage, now: _this.now })) : (React.createElement(activity_1.ActivityCreateOrEdit, { key: "edit-" + activity.id, activityId: activity.id }));
            }))));
    };
    ActivitiesGroup = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], ActivitiesGroup);
    return ActivitiesGroup;
}(React.Component));
exports.ActivitiesGroup = ActivitiesGroup;


/***/ }),

/***/ "./app/web/src/components/activity/Activity.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var user_1 = __webpack_require__("./app/common/interfaces/user.ts");
// Styles
var s = __webpack_require__("./app/web/src/components/activity/Activities.css");
var editIcon = __webpack_require__("./app/web/src/assets/pen icon.svg");
var greenTickIcon = __webpack_require__("./app/web/src/assets/tick green.svg");
var greyTickIcon = __webpack_require__("./app/web/src/assets/tick dim.svg");
// Component
var Activity = /** @class */ (function (_super) {
    __extends(Activity, _super);
    function Activity(props) {
        var _this = _super.call(this, props) || this;
        _this.handleActivityClick = function (e) {
            e.preventDefault();
            if (_this.props.isOnLeadPage === false && _this.props.onClick) {
                _this.props.onClick(_this.props.activity.id);
            }
        };
        _this.handleActivityEdit = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (_this.props.onEdit) {
                _this.props.onEdit(_this.props.activity.id);
            }
        };
        _this.handleActivityMarkAsComplete = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (_this.props.onMarkAsComplete) {
                _this.props.onMarkAsComplete(_this.props.activity.id);
            }
        };
        return _this;
    }
    Object.defineProperty(Activity, "defaultProps", {
        get: function () {
            return {
                onClick: null,
                onMarkAsComplete: null,
                onEdit: null,
                loggedInUserId: null,
                loggedInUserType: null,
                activity: null,
                isOnLeadPage: false,
                now: null,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "activityTimeFormatted", {
        get: function () {
            var time = this.props.activity.time;
            return time === null
                ? ''
                : time.isSame(this.props.now, 'day')
                    ? 'Today at ' + time.format('hh:mm A')
                    : time.format('dddd, MMM Do, YYYY - hh:mm A');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "canActivityBeMarkesAsComplete", {
        get: function () {
            if (!this.props.onMarkAsComplete) {
                return false;
            }
            if (this.props.activity.savingComplete) {
                return false;
            }
            if (this.props.loggedInUserId === null) {
                return false;
            }
            if (this.props.loggedInUserType !== user_1.UserType.SalesManager) {
                if (this.props.loggedInUserId !==
                    this.props.activity.assignedToUser.id) {
                    return false;
                }
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Activity.prototype.render = function () {
        var _a;
        // Destructure
        var _b = this.props, activity = _b.activity, isOnLeadPage = _b.isOnLeadPage, loggedInUserId = _b.loggedInUserId;
        // Render
        return (React.createElement("div", { onClick: this.handleActivityClick, className: classNames(s.activity, (_a = {},
                _a[s.activityWide] = this.props.isOnLeadPage,
                _a[s.finished] = activity.finished,
                _a)) },
            React.createElement("p", { className: s.activityTime },
                this.props.now !== null &&
                    this.activityTimeFormatted !== '' && (React.createElement("strong", null, this.activityTimeFormatted)),
                React.createElement("span", null, activity.time ? activity.time.format('A') : 'No date')),
            React.createElement("h4", { className: s.activityTitle }, activity.title),
            activity.note && (React.createElement("p", { className: s.activityNote }, activity.note)),
            ((isOnLeadPage === true && activity.author) ||
                (isOnLeadPage === false && activity.provider)) && (React.createElement("p", { className: s.activityAuthorAndLead }, isOnLeadPage
                ? activity.assignedToUser.name
                : activity.provider.dba)),
            isOnLeadPage &&
                !activity.finished &&
                loggedInUserId !== null &&
                activity.author.id === loggedInUserId &&
                (typeof activity.savingComplete === 'undefined' ||
                    activity.savingComplete === false) &&
                this.props.onEdit && (React.createElement(action_1.IconButton, { className: s.editActivity, onClick: this.handleActivityEdit, icon: editIcon, label: "Edit activity", showLabel: false, labelOnRight: false })),
            this.canActivityBeMarkesAsComplete && (React.createElement(action_1.IconButton, { className: s.markAsComplete, iconClassName: s.markAsCompleteIcon, onClick: this.handleActivityMarkAsComplete, icon: activity.finished ? greyTickIcon : greenTickIcon, label: activity.finished
                    ? 'Reopen activity'
                    : 'Mark as complete', showLabel: isOnLeadPage ? true : false, labelOnRight: false })),
            React.createElement(indicator_1.SavingIndicator, { className: s.markingAsComplete, labels: { saving: 'Saving...' }, status: activity.savingComplete
                    ? indicator_1.SavingIndicatorStatus.Saving
                    : indicator_1.SavingIndicatorStatus.None })));
    };
    __decorate([
        mobx_1.computed
    ], Activity.prototype, "activityTimeFormatted", null);
    __decorate([
        mobx_1.computed
    ], Activity.prototype, "canActivityBeMarkesAsComplete", null);
    Activity = __decorate([
        mobx_react_1.observer
    ], Activity);
    return Activity;
}(React.Component));
exports.Activity = Activity;


/***/ }),

/***/ "./app/web/src/components/activity/ActivityCreateOrEdit.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/activity/ActivityCreateOrEdit.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./ActivityCreateOrEdit.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./ActivityCreateOrEdit.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/activity/ActivityCreateOrEdit.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var activity_1 = __webpack_require__("./app/common/interfaces/activity.ts");
var user_1 = __webpack_require__("./app/common/interfaces/user.ts");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
var list_1 = __webpack_require__("./app/web/src/components/list/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var calendar_1 = __webpack_require__("./app/web/src/components/calendar/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/components/activity/ActivityCreateOrEdit.css");
var addIcon = __webpack_require__("./app/web/src/assets/plus icon.svg");
// Component
var ActivityCreateOrEdit = /** @class */ (function (_super) {
    __extends(ActivityCreateOrEdit, _super);
    function ActivityCreateOrEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.allFieldsAreRequiredError = false;
        _this.activityTypeDropdown = null;
        _this.referenceActivityTypeDropdown = function (ref) {
            return (_this.activityTypeDropdown = ref);
        };
        _this.activityAssignedUserDropdown = null;
        _this.referenceActivityAssignedUserDropdown = function (ref) {
            return (_this.activityAssignedUserDropdown = ref);
        };
        _this.handleActivityTypeChange = function (changed) {
            _this.activityToEdit.typeId = changed.value;
            _this.activityToEdit.typeName = changed.label;
            _this.allFieldsAreRequiredError = false;
            if (_this.activityTypeDropdown) {
                _this.activityTypeDropdown.closeDropdown();
            }
        };
        _this.handleActivityDateChange = function (date) {
            var updateTimeToo = _this.activityToEdit.date === null;
            if (updateTimeToo) {
                date = date.hours(12);
            }
            _this.activityToEdit.date = date;
            _this.allFieldsAreRequiredError = false;
            if (updateTimeToo) {
                _this.activityToEdit.time.value = {
                    hours: date.hours(),
                    minutes: date.minutes(),
                    totalMinutes: date.hours() * 60 + date.minutes(),
                };
            }
        };
        _this.handleActivityTimeChange = function (time) {
            _this.activityToEdit.time.value = time.value;
            _this.activityToEdit.time.label = time.label;
            _this.allFieldsAreRequiredError = false;
        };
        _this.handleActivityRemindAtTimeChange = function (time) {
            _this.activityToEdit.remindAt.value = time.value;
            _this.activityToEdit.remindAt.label = time.label;
            _this.allFieldsAreRequiredError = false;
        };
        _this.handleActivityAssignedUserChange = function (changed) {
            _this.activityToEdit.assignedToUserId = changed.value;
            _this.activityToEdit.assignedToUserName = changed.label;
            _this.allFieldsAreRequiredError = false;
            if (_this.activityAssignedUserDropdown) {
                _this.activityAssignedUserDropdown.closeDropdown();
            }
        };
        _this.handleDescriptionChange = function (html, text, isOverCharacterLimit) {
            _this.activityToEdit.descriptionHtml = html;
            _this.activityToEdit.descriptionText = text;
            _this.activityToEdit.descriptionTooLong = isOverCharacterLimit;
            _this.allFieldsAreRequiredError = false;
        };
        _this.handleActivitySave = function () {
            if (_this.isReadyToBeSaved) {
                _this.allFieldsAreRequiredError = false;
                if (_this.props.activityId === null) {
                    _this.props.store.activitiesCreateOrEdit.createActivity();
                }
                else {
                    _this.props.store.activitiesCreateOrEdit.editActivity(_this.props.activityId);
                }
            }
            else {
                if (_this.activityToEdit.descriptionTooLong === false) {
                    _this.allFieldsAreRequiredError = true;
                }
            }
        };
        if (_this.props.activityId === null) {
            _this.props.store.activitiesCreateOrEdit.initializeNewActivity(_this.props.store.lead.openLeadId);
        }
        return _this;
    }
    Object.defineProperty(ActivityCreateOrEdit, "defaultProps", {
        get: function () {
            return {
                activityId: null,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivityCreateOrEdit.prototype, "loadingOptions", {
        get: function () {
            return (this.props.store.activities.loadingAllActivityTypes ||
                this.props.store.users.loadingAll);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivityCreateOrEdit.prototype, "openLeadSalesRepIds", {
        get: function () {
            return this.props.store.lead.openLeadDetails.salesReps.map(function (rep) { return rep.id; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivityCreateOrEdit.prototype, "usersOptions", {
        get: function () {
            var _this = this;
            var _a = this.props.store, user = _a.user, users = _a.users;
            return users.allActiveSalesUsers
                .filter(function (activeUser) {
                return activeUser.id === user.id ||
                    activeUser.type === user_1.UserType.SalesManager ||
                    _this.openLeadSalesRepIds.indexOf(activeUser.id) !== -1;
            })
                .map(function (filteredUser) { return ({
                value: filteredUser.id,
                label: filteredUser.name,
            }); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivityCreateOrEdit.prototype, "activityToEdit", {
        get: function () {
            var activitiesCreateOrEdit = this.props.store.activitiesCreateOrEdit;
            if (this.props.activityId !== null) {
                var indexOfActivity = activitiesCreateOrEdit.editingActivitiesIds.indexOf(this.props.activityId);
                return indexOfActivity !== -1
                    ? activitiesCreateOrEdit.editingActivities[indexOfActivity]
                    : null;
            }
            else {
                return activitiesCreateOrEdit.newActivity;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivityCreateOrEdit.prototype, "isReadyToBeSaved", {
        get: function () {
            var _a = this.activityToEdit, typeId = _a.typeId, date = _a.date, assignedToUserId = _a.assignedToUserId, descriptionTooLong = _a.descriptionTooLong;
            if (descriptionTooLong) {
                return false;
            }
            return this.activityToEdit !== null
                ? typeId !== null && date !== null && assignedToUserId !== null
                : false;
        },
        enumerable: true,
        configurable: true
    });
    ActivityCreateOrEdit.prototype.render = function () {
        var _a = this.props.store, activities = _a.activities, leadActivities = _a.leadActivities, activitiesCreateOrEdit = _a.activitiesCreateOrEdit, users = _a.users, user = _a.user;
        return (React.createElement("div", { className: s.define },
            React.createElement("div", { className: s.row },
                React.createElement("div", { className: s.col },
                    React.createElement("p", null, "Activity"),
                    React.createElement(list_1.DropdownContainer, { ref: this.referenceActivityTypeDropdown, value: this.activityToEdit !== null
                            ? this.activityToEdit.typeName
                            : null, label: this.activityToEdit !== null
                            ? this.activityToEdit.typeName === null
                                ? 'Activity type'
                                : null
                            : null },
                        React.createElement(list_1.OptionsList, { label: "Activities", onChange: this.handleActivityTypeChange, value: this.activityToEdit !== null
                                ? this.activityToEdit.typeId
                                : null, options: this.activityToEdit !== null
                                ? activities.allActivityTypes
                                : [] }))),
                React.createElement("div", { className: s.col },
                    React.createElement("p", null, "Due by"),
                    React.createElement(calendar_1.DatePickerDropdown, { onChange: this.handleActivityDateChange, valueCanBeCleared: true, value: this.activityToEdit !== null
                            ? this.activityToEdit.date
                            : null, label: this.activityToEdit !== null
                            ? this.activityToEdit.date === null
                                ? 'Date'
                                : null
                            : null })),
                this.activityToEdit !== null &&
                    this.activityToEdit.date !== null && (React.createElement("div", { className: s.col },
                    React.createElement("p", null, "Due at"),
                    React.createElement(calendar_1.SelectTime, { onChange: this.handleActivityTimeChange, value: this.activityToEdit !== null
                            ? this.activityToEdit.time.value
                            : null, label: this.activityToEdit !== null
                            ? this.activityToEdit.time.value ===
                                null
                                ? 'Time'
                                : null
                            : null }))),
                this.activityToEdit !== null &&
                    this.activityToEdit.date !== null && (React.createElement("div", { className: s.col },
                    React.createElement("p", null, "Remind"),
                    React.createElement(calendar_1.RemindTime, { onChange: this.handleActivityRemindAtTimeChange, value: typeof this.activityToEdit.remindAt !==
                            'undefined'
                            ? this.activityToEdit.remindAt.value
                            : undefined, label: typeof this.activityToEdit.remindAt !==
                            'undefined'
                            ? this.activityToEdit.remindAt.label
                            : undefined }))),
                React.createElement("div", { className: s.col },
                    React.createElement("p", null, "Assign to"),
                    React.createElement(list_1.DropdownContainer, { ref: this.referenceActivityAssignedUserDropdown, value: this.activityToEdit !== null
                            ? this.activityToEdit.assignedToUserName
                            : null, label: this.activityToEdit !== null
                            ? this.activityToEdit.assignedToUserName ===
                                null
                                ? 'Pick person'
                                : null
                            : null },
                        React.createElement(list_1.OptionsList, { label: "People", onChange: this.handleActivityAssignedUserChange, value: [
                                {
                                    user: user.id,
                                    value: user.name,
                                },
                            ], options: this.usersOptions })))),
            React.createElement("div", { className: s.details },
                React.createElement(content_1.ContentEditable, { className: s.descriptionContainer, classNameForField: s.description, contentEditable: true, charactersLimit: 50, html: this.activityToEdit !== null
                        ? this.activityToEdit.descriptionHtml
                        : '', placeholder: "Activity description...", onChange: this.handleDescriptionChange }),
                React.createElement(action_1.IconButton, { className: s.saveButton, label: this.props.activityId === null
                        ? 'Create activity'
                        : 'Save changes', labelOnRight: true, showLabel: true, icon: addIcon, onClick: this.handleActivitySave })),
            React.createElement(indicator_1.SavingIndicator, { className: s.savingIndicator, labels: {
                    saving: 'Saving activity...',
                    error: this.activityToEdit.descriptionTooLong
                        ? 'Shorten activity description'
                        : this.allFieldsAreRequiredError
                            ? 'Activity type, due date and assigned user are required'
                            : 'Could not save, try again',
                    success: 'Activity saved!',
                }, status: this.activityToEdit !== null
                    ? this.activityToEdit.status ===
                        activity_1.NewActivityStatus.Saving
                        ? indicator_1.SavingIndicatorStatus.Saving
                        : this.activityToEdit.status ===
                            activity_1.NewActivityStatus.Error ||
                            this.allFieldsAreRequiredError ||
                            this.activityToEdit.descriptionTooLong
                            ? indicator_1.SavingIndicatorStatus.Error
                            : this.activityToEdit.status ===
                                activity_1.NewActivityStatus.Success
                                ? indicator_1.SavingIndicatorStatus.Success
                                : indicator_1.SavingIndicatorStatus.None
                    : null }),
            React.createElement(indicator_1.LoadingFullScreen, { fitInContainer: true, active: this.loadingOptions })));
    };
    __decorate([
        mobx_1.observable
    ], ActivityCreateOrEdit.prototype, "allFieldsAreRequiredError", void 0);
    __decorate([
        mobx_1.computed
    ], ActivityCreateOrEdit.prototype, "loadingOptions", null);
    __decorate([
        mobx_1.computed
    ], ActivityCreateOrEdit.prototype, "openLeadSalesRepIds", null);
    __decorate([
        mobx_1.computed
    ], ActivityCreateOrEdit.prototype, "usersOptions", null);
    __decorate([
        mobx_1.computed
    ], ActivityCreateOrEdit.prototype, "activityToEdit", null);
    __decorate([
        mobx_1.computed
    ], ActivityCreateOrEdit.prototype, "isReadyToBeSaved", null);
    ActivityCreateOrEdit = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], ActivityCreateOrEdit);
    return ActivityCreateOrEdit;
}(React.Component));
exports.ActivityCreateOrEdit = ActivityCreateOrEdit;


/***/ }),

/***/ "./app/web/src/components/activity/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/components/activity/Activity.tsx"));
__export(__webpack_require__("./app/web/src/components/activity/ActivitiesGroup.tsx"));
__export(__webpack_require__("./app/web/src/components/activity/ActivityCreateOrEdit.tsx"));


/***/ }),

/***/ "./app/web/src/components/calendar/DatePickerCalendar.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/calendar/DatePickerCalendar.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./DatePickerCalendar.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./DatePickerCalendar.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/calendar/DatePickerCalendar.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var padStart_1 = __webpack_require__("./node_modules/lodash-es/padStart.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/components/calendar/DatePickerCalendar.css");
var iconBlueArrow = __webpack_require__("./app/web/src/assets/blue arrow.svg");
var DatePickerCalendar = /** @class */ (function (_super) {
    __extends(DatePickerCalendar, _super);
    function DatePickerCalendar(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.showDays = true;
        _this.displayedDate = _this.selectedDate;
        _this.onChangeCallback = function (date) {
            if (_this.props.onChange) {
                _this.props.onChange(date);
            }
        };
        _this.handlePeriodArrowClick = function (toRight) { return function (e) {
            // Calculate next date
            var nextDisplayedDate = _this.displayedDate.clone();
            nextDisplayedDate.date(15);
            if (toRight) {
                if (_this.showDays) {
                    nextDisplayedDate.add(1, 'month');
                }
                else {
                    nextDisplayedDate.add(1, 'year');
                }
            }
            else {
                if (_this.showDays) {
                    nextDisplayedDate.subtract(1, 'month');
                }
                else {
                    nextDisplayedDate.subtract(1, 'year');
                }
            }
            _this.displayedDate = nextDisplayedDate;
        }; };
        _this.handleDaysMonthsToggle = function () {
            _this.showDays = !_this.showDays;
        };
        _this.handleDateChange = function (dateString) { return function (e) {
            // Parse date string
            var nextDate = moment(dateString);
            // Update state
            if (nextDate.isValid()) {
                _this.displayedDate = nextDate;
                _this.onChangeCallback(nextDate);
            }
        }; };
        _this.handleDisplayedMonthChange = function (dateString) { return function (e) {
            // Parse date string
            var nextDisplayedDate = moment(dateString + '-15');
            // Update state
            if (nextDisplayedDate.isValid()) {
                _this.displayedDate = nextDisplayedDate;
                _this.showDays = true;
            }
        }; };
        _this.createDateObject = function (date) {
            return date && _this.selectedDate
                ? {
                    id: date.format('YYYY-MM-DD'),
                    date: date.date(),
                    dateString: date.format('DD'),
                    isSelected: date.isSame(_this.selectedDate, 'day'),
                    isCurrentMonth: date.isSame(_this.displayedDate, 'month'),
                    isToday: date.isSame(_this.now, 'day'),
                }
                : null;
        };
        _this.createMonthObject = function (date) {
            return date && _this.selectedDate
                ? {
                    id: date.format('YYYY-MM'),
                    month: date.month(),
                    monthString: date.format('MMMM'),
                    isSelected: date.isSame(_this.selectedDate, 'month'),
                }
                : null;
        };
        _this.state = {
            today: moment(),
            showDays: true,
            date: {
                selected: null,
                displayed: null,
            },
            weekDayNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        };
        return _this;
    }
    Object.defineProperty(DatePickerCalendar, "defaultProps", {
        get: function () {
            return {
                onChange: null,
                className: null,
                value: null,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerCalendar.prototype, "now", {
        get: function () {
            return moment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerCalendar.prototype, "weekDayNames", {
        get: function () {
            return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerCalendar.prototype, "selectedDate", {
        get: function () {
            var date = this.props.value &&
                typeof this.props.value.isValid !== 'undefined' &&
                this.props.value.isValid()
                ? this.props.value.clone()
                : moment(this.props.value);
            if (date.isValid() === false) {
                date = moment();
            }
            return date;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerCalendar.prototype, "daysToggleLabel", {
        get: function () {
            return this.displayedDate
                ? this.showDays
                    ? this.displayedDate.format('MMMM YYYY')
                    : this.displayedDate.format('YYYY')
                : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerCalendar.prototype, "weekDays", {
        get: function () {
            return this.showDays
                ? this.weekDayNames.map(function (dayName, dayId) { return ({
                    key: dayName,
                    label: dayName,
                }); })
                : [{ key: 'monthsLine', label: 'Jump to any month' }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerCalendar.prototype, "calendarWeeksAndDays", {
        get: function () {
            // Prepare object structure
            var weeks = [];
            var days = [];
            // Start from Sunday - might be in previous month
            var startDate = this.displayedDate.clone().date(1);
            while (startDate.day() > 0) {
                startDate.subtract(1, 'days');
            }
            // Iterate all days in 6 weeks
            var iteratedDate = startDate.clone();
            while (weeks.length < 6) {
                // Create day object
                days.push(this.createDateObject(iteratedDate));
                // If week ends, push all days to the week
                if (iteratedDate.day() >= 6) {
                    weeks.push({
                        days: days,
                        id: iteratedDate.year().toString() +
                            'W' +
                            padStart_1.default(iteratedDate.isoWeek().toString(), 2, '0'),
                    });
                    days = [];
                }
                // Move to next day
                iteratedDate.add(1, 'day');
            }
            iteratedDate = null;
            return weeks;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerCalendar.prototype, "calendarMonths", {
        get: function () {
            // Prepare object structure
            var rows = [];
            var months = [];
            // Start from January
            var startDate = this.displayedDate.clone().month(0);
            // Iterate all months
            var iteratedDate = startDate.clone();
            while (rows.length < 6) {
                // Create month object
                months.push(this.createMonthObject(iteratedDate));
                // If row ends, push all months to the row
                if (months.length >= 2) {
                    rows.push({
                        months: months,
                        id: iteratedDate.year().toString() +
                            'R' +
                            (rows.length + 1).toString(),
                    });
                    months = [];
                }
                // Move to next day
                iteratedDate.add(1, 'month');
            }
            iteratedDate = null;
            return rows;
        },
        enumerable: true,
        configurable: true
    });
    DatePickerCalendar.prototype.render = function () {
        var _this = this;
        // Render
        return (React.createElement("div", { className: classNames(s.calendar, this.props.className) },
            React.createElement("div", { className: classNames(s.row, s.navigation) },
                React.createElement("div", { className: s.col },
                    React.createElement("button", { onClick: this.handlePeriodArrowClick(false) },
                        React.createElement("img", { src: iconBlueArrow, style: { transform: 'scaleX(-1.0)' } }))),
                React.createElement("div", { className: s.col }, this.daysToggleLabel && (React.createElement("button", { onClick: this.handleDaysMonthsToggle, className: s.daysMonthsToggle }, this.daysToggleLabel))),
                React.createElement("div", { className: s.col },
                    React.createElement("button", { onClick: this.handlePeriodArrowClick(true) },
                        React.createElement("img", { src: iconBlueArrow })))),
            React.createElement("div", { className: classNames(s.row, s.weekDays) }, this.weekDays.map(function (day) { return (React.createElement("div", { className: s.col, key: day.key },
                React.createElement("p", null, day.label))); })),
            this.showDays &&
                this.selectedDate &&
                this.displayedDate &&
                this.calendarWeeksAndDays.length > 0 && (React.createElement("div", { className: s.days }, this.calendarWeeksAndDays.map(function (week) {
                return (React.createElement("div", { className: s.row, key: week.id }, week.days.map(function (day) {
                    var _a;
                    return (React.createElement("div", { key: week.id + ' ' + day.id, className: s.col },
                        React.createElement("button", { onClick: _this.handleDateChange(day.id), className: classNames((_a = {},
                                _a[s.daySelected] = day.isSelected,
                                _a[s.dayNotCurrentMonth] = day.isCurrentMonth ===
                                    false,
                                _a[s.dayToday] = day.isToday,
                                _a)) }, day.dateString)));
                })));
            }))),
            this.showDays === false &&
                this.selectedDate &&
                this.displayedDate &&
                this.calendarMonths.length > 0 && (React.createElement("div", { className: s.months }, this.calendarMonths.map(function (row) {
                return (React.createElement("div", { className: s.row, key: row.id }, row.months.map(function (month) {
                    var _a;
                    return (React.createElement("div", { key: month.id },
                        React.createElement("button", { onClick: _this.handleDisplayedMonthChange(month.id), className: classNames((_a = {},
                                _a[s.monthSelected] = month.isSelected,
                                _a)) }, month.monthString)));
                })));
            })))));
    };
    __decorate([
        mobx_1.observable
    ], DatePickerCalendar.prototype, "showDays", void 0);
    __decorate([
        mobx_1.computed
    ], DatePickerCalendar.prototype, "selectedDate", null);
    __decorate([
        mobx_1.observable
    ], DatePickerCalendar.prototype, "displayedDate", void 0);
    __decorate([
        mobx_1.computed
    ], DatePickerCalendar.prototype, "daysToggleLabel", null);
    __decorate([
        mobx_1.computed
    ], DatePickerCalendar.prototype, "weekDays", null);
    __decorate([
        mobx_1.computed
    ], DatePickerCalendar.prototype, "calendarWeeksAndDays", null);
    __decorate([
        mobx_1.computed
    ], DatePickerCalendar.prototype, "calendarMonths", null);
    DatePickerCalendar = __decorate([
        mobx_react_1.observer
    ], DatePickerCalendar);
    return DatePickerCalendar;
}(React.Component));
exports.DatePickerCalendar = DatePickerCalendar;


/***/ }),

/***/ "./app/web/src/components/calendar/DatePickerDropdown.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/calendar/DatePickerDropdown.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./DatePickerDropdown.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./DatePickerDropdown.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/calendar/DatePickerDropdown.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var calendar_1 = __webpack_require__("./app/web/src/components/calendar/index.tsx");
var list_1 = __webpack_require__("./app/web/src/components/list/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/components/calendar/DatePickerDropdown.css");
var iconTickWhite = __webpack_require__("./app/web/src/assets/tick white.svg");
var DatePickerDropdown = /** @class */ (function (_super) {
    __extends(DatePickerDropdown, _super);
    function DatePickerDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.dropdownContainer = null;
        _this.referenceDropdownContainer = function (ref) {
            return (_this.dropdownContainer = ref);
        };
        _this.clearValue = function () {
            _this.handleDateChange(null);
            _this.closeDropdown();
        };
        _this.closeDropdown = function () {
            if (_this.dropdownContainer) {
                _this.dropdownContainer.closeDropdown();
            }
        };
        _this.handleDateChange = function (date) {
            if (_this.props.onChange) {
                _this.props.onChange(date);
            }
            if (_this.props.closeOnChange) {
                _this.closeDropdown();
            }
        };
        _this.state = {
            date: null,
            dateSelected: '',
            dateLabel: '',
        };
        return _this;
    }
    Object.defineProperty(DatePickerDropdown, "defaultProps", {
        get: function () {
            return {
                onChange: null,
                className: null,
                label: null,
                noDateLabel: 'No date selected',
                value: null,
                valueCanBeCleared: false,
                dateFormat: 'M/DD/YYYY',
                closeOnChange: true,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerDropdown.prototype, "date", {
        get: function () {
            if (this.props.value !== null) {
                if (typeof this.props.value.isValid !== 'undefined' &&
                    this.props.value.isValid()) {
                    return {
                        value: this.props.value,
                        formatted: this.props.value.format(this.props.dateFormat),
                    };
                }
                else {
                    var parseDate = moment(this.props.value);
                    return parseDate.isValid()
                        ? {
                            value: parseDate,
                            formatted: parseDate.format(this.props.dateFormat),
                        }
                        : {
                            value: null,
                            formatted: null,
                        };
                }
            }
            else {
                return {
                    value: null,
                    formatted: null,
                };
            }
        },
        enumerable: true,
        configurable: true
    });
    DatePickerDropdown.prototype.render = function () {
        var _a;
        return (React.createElement(list_1.DropdownContainer, { ref: this.referenceDropdownContainer, className: classNames(this.props.className), minWidth: 318, maxWidth: 318, value: this.date.formatted, label: this.date.value ? this.props.label : this.props.noDateLabel },
            React.createElement(calendar_1.DatePickerCalendar, { onChange: this.handleDateChange, value: this.date.value }),
            React.createElement("div", { className: classNames(s.summary, (_a = {},
                    _a[s.approve] = this.date.formatted ? true : false,
                    _a)) },
                this.props.valueCanBeCleared && this.date.value !== null && (React.createElement("div", null,
                    React.createElement("button", { onClick: this.clearValue },
                        React.createElement("span", null, "Clear date")))),
                React.createElement("div", null,
                    React.createElement("button", { onClick: this.closeDropdown },
                        React.createElement("span", null, this.date.formatted || 'Cancel'),
                        React.createElement("i", null,
                            React.createElement("img", { src: iconTickWhite })))))));
    };
    __decorate([
        mobx_1.computed
    ], DatePickerDropdown.prototype, "date", null);
    DatePickerDropdown = __decorate([
        mobx_react_1.observer
    ], DatePickerDropdown);
    return DatePickerDropdown;
}(React.Component));
exports.DatePickerDropdown = DatePickerDropdown;


/***/ }),

/***/ "./app/web/src/components/calendar/RemindTime.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var list_1 = __webpack_require__("./app/web/src/components/list/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/components/calendar/SelectTime.css");
// Component
var RemindTime = /** @class */ (function (_super) {
    __extends(RemindTime, _super);
    function RemindTime(props) {
        var _this = _super.call(this, props) || this;
        _this.dropdown = null;
        _this.referenceDropdown = function (ref) {
            return (_this.dropdown = ref);
        };
        _this.handleValueChange = function (changed) {
            if (_this.props.onChange) {
                _this.props.onChange(changed);
            }
            if (_this.dropdown) {
                _this.dropdown.closeDropdown();
            }
        };
        return _this;
    }
    Object.defineProperty(RemindTime, "defaultProps", {
        get: function () {
            return {
                onChange: null,
                value: null,
                label: 'Time',
                formatting: 12,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RemindTime.prototype, "options", {
        get: function () {
            return [
                { value: null, label: 'Do not remind' },
                { value: 0, label: 'At the time' },
                { value: 5, label: '5 minutes before' },
                { value: 10, label: '10 minutes before' },
                { value: 15, label: '15 minutes before' },
                { value: 30, label: '30 minutes before' },
                { value: 60, label: '1 hour before' },
                { value: 120, label: '2 hours before' },
                { value: 180, label: '3 hours before' },
                { value: 360, label: '6 hours before' },
                { value: 1440, label: '1 day before' },
                { value: 2880, label: '2 days before' },
                { value: 4320, label: '3 days before' },
                { value: 10080, label: '1 week before' },
                { value: 20160, label: '2 weeks before' },
            ];
        },
        enumerable: true,
        configurable: true
    });
    RemindTime.prototype.render = function () {
        return (React.createElement(list_1.DropdownContainer, { ref: this.referenceDropdown, maxHeight: 400, label: null, value: typeof this.props.value !== 'undefined'
                ? this.props.label
                : undefined },
            React.createElement(list_1.OptionsList, { label: "Reminders", onChange: this.handleValueChange, options: this.options, value: this.props.value })));
    };
    __decorate([
        mobx_1.computed
    ], RemindTime.prototype, "options", null);
    RemindTime = __decorate([
        mobx_react_1.observer
    ], RemindTime);
    return RemindTime;
}(React.Component));
exports.RemindTime = RemindTime;


/***/ }),

/***/ "./app/web/src/components/calendar/SelectTime.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/calendar/SelectTime.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./SelectTime.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./SelectTime.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/calendar/SelectTime.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var list_1 = __webpack_require__("./app/web/src/components/list/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/components/calendar/SelectTime.css");
// Component
var SelectTime = /** @class */ (function (_super) {
    __extends(SelectTime, _super);
    function SelectTime(props) {
        var _this = _super.call(this, props) || this;
        _this.dropdown = null;
        _this.referenceDropdown = function (ref) {
            return (_this.dropdown = ref);
        };
        _this.handleValueChange = function (changed) {
            if (_this.props.onChange) {
                _this.props.onChange(changed);
            }
            if (_this.dropdown) {
                _this.dropdown.closeDropdown();
            }
        };
        _this.getLabel = function (hours, minutes) {
            var now = moment();
            now.hours(hours);
            now.minutes(minutes);
            return _this.isAmerican ? now.format('hh:mm A') : now.format('HH:mm');
        };
        return _this;
    }
    Object.defineProperty(SelectTime, "defaultProps", {
        get: function () {
            var now = new Date();
            return {
                onChange: null,
                value: {
                    hours: now.getHours(),
                    minutes: now.getMinutes(),
                    totalMinutes: now.getHours() * 60 + now.getMinutes(),
                },
                label: 'Time',
                formatting: 12,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectTime.prototype, "isAmerican", {
        get: function () {
            var formatting = typeof this.props.formatting === 'string'
                ? parseInt(this.props.formatting, 10)
                : this.props.formatting;
            return 12 ? true : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectTime.prototype, "options", {
        get: function () {
            var result = [];
            var everyMinutes = 15;
            var addedNow = 0;
            var nowTotalMinutes = this.props.value
                ? this.props.value.totalMinutes
                : moment().hours() * 60 + moment().minutes();
            var totalMinutes = 420;
            var maxTotalMinutes = 1160;
            while (totalMinutes <= maxTotalMinutes) {
                var hours = Math.floor(totalMinutes / 60);
                var minutes = totalMinutes - hours * 60;
                result.push({
                    value: {
                        hours: hours,
                        minutes: minutes,
                        totalMinutes: totalMinutes,
                    },
                    label: this.getLabel(hours, minutes),
                });
                totalMinutes = totalMinutes + everyMinutes;
                if (addedNow === 0 &&
                    (totalMinutes > nowTotalMinutes ||
                        (totalMinutes >= maxTotalMinutes &&
                            nowTotalMinutes > maxTotalMinutes))) {
                    if (nowTotalMinutes % everyMinutes > 0) {
                        var nowHours = Math.floor(nowTotalMinutes / 60);
                        var nowMinutes = nowTotalMinutes - nowHours * 60;
                        result.push({
                            value: {
                                hours: nowHours,
                                minutes: nowMinutes,
                                totalMinutes: nowTotalMinutes,
                            },
                            label: this.getLabel(nowHours, nowMinutes),
                        });
                        addedNow++;
                    }
                }
            }
            return result;
        },
        enumerable: true,
        configurable: true
    });
    SelectTime.prototype.render = function () {
        return (React.createElement(list_1.DropdownContainer, { ref: this.referenceDropdown, maxHeight: 400, label: this.props.label || null, value: this.props.value
                ? this.getLabel(this.props.value.hours, this.props.value.minutes)
                : undefined },
            React.createElement(list_1.OptionsList, { onChange: this.handleValueChange, options: this.options, label: "Pick time", value: this.props.value })));
    };
    __decorate([
        mobx_1.computed
    ], SelectTime.prototype, "isAmerican", null);
    __decorate([
        mobx_1.computed
    ], SelectTime.prototype, "options", null);
    SelectTime = __decorate([
        mobx_react_1.observer
    ], SelectTime);
    return SelectTime;
}(React.Component));
exports.SelectTime = SelectTime;


/***/ }),

/***/ "./app/web/src/components/calendar/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/components/calendar/DatePickerCalendar.tsx"));
__export(__webpack_require__("./app/web/src/components/calendar/DatePickerDropdown.tsx"));
__export(__webpack_require__("./app/web/src/components/calendar/SelectTime.tsx"));
__export(__webpack_require__("./app/web/src/components/calendar/RemindTime.tsx"));


/***/ }),

/***/ "./app/web/src/components/content/ContentEditable.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/content/ContentEditable.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./ContentEditable.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./ContentEditable.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/content/ContentEditable.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/components/content/ContentEditable.css");
// Component
var ContentEditable = /** @class */ (function (_super) {
    __extends(ContentEditable, _super);
    function ContentEditable(props) {
        var _this = _super.call(this, props) || this;
        _this.field = null;
        _this.placeholderClassName = 'contentEditablePlaceholderParagraph';
        _this.focusCount = 0;
        _this.content = '';
        _this.lastCaretOffset = 0;
        _this.lastCaretNodesIndexes = [];
        _this.isBeyondCharacterLimit = false;
        _this.selection = null;
        _this.referenceField = function (ref) { return (_this.field = ref); };
        _this.propagateChange = function (value) {
            // Get plain text
            var text = _this.field.innerText;
            // Check if text is too long
            _this.isBeyondCharacterLimit =
                _this.props.charactersLimit !== null
                    ? text.length > _this.props.charactersLimit
                    : false;
            // Update html content
            _this.content = value;
            // Let parent component know about the change inv alue
            if (_this.props.onChange) {
                _this.props.onChange(value, text, _this.isBeyondCharacterLimit);
            }
        };
        _this.handleChange = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var val;
            return __generator(this, function (_a) {
                if (this.field && this.props.onChange) {
                    e.preventDefault();
                    this.saveSelection();
                    val = this.field.innerHTML;
                    this.propagateChange(val);
                }
                return [2 /*return*/];
            });
        }); };
        _this.handlePaste = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var val;
            return __generator(this, function (_a) {
                if (this.field && this.props.onChange) {
                    val = this.field.innerHTML;
                    this.propagateChange(val);
                }
                return [2 /*return*/];
            });
        }); };
        _this.handleFocus = function (e) {
            if (_this.props.selectTextOnFirstFocus && _this.focusCount === 0) {
                _this.focusOnContainerAndSelectAll();
            }
            else if (_this.placeholderHtml === _this.field.innerHTML) {
                _this.focusOnContainerAndSelectAll();
            }
            _this.focusCount++;
        };
        _this.handleBlur = function (e) {
            if (_this.props.placeholder) {
                var currentText = _this.field.innerText.trim();
                if (currentText === '') {
                    _this.field.innerHTML = _this.placeholderHtml;
                }
            }
        };
        _this.focusOnContainerAndSelectAll = function () {
            var selection = window.getSelection();
            var range = document.createRange();
            range.selectNodeContents(_this.field);
            selection.removeAllRanges();
            selection.addRange(range);
        };
        _this.focusOnContainerAndSelectEnd = function () {
            var selection = window.getSelection();
            var range = document.createRange();
            range.selectNodeContents(_this.field);
            range.collapse(false);
            selection.removeAllRanges();
            selection.addRange(range);
        };
        _this.saveSelection = function () {
            if (_this.field) {
                var range = window.getSelection().getRangeAt(0);
                var preCaretRange = range.cloneRange();
                preCaretRange.selectNodeContents(_this.field);
                preCaretRange.setEnd(range.endContainer, range.endOffset);
                var childNodeIndexes = [];
                var endContainerNode = preCaretRange.endContainer;
                if (endContainerNode.parentElement.classList.contains(_this.placeholderClassName)) {
                    endContainerNode.parentElement.classList.remove(_this.placeholderClassName);
                }
                while (endContainerNode !== _this.field) {
                    var endContainerNodeParent = endContainerNode.parentNode;
                    var findIndex = -1;
                    for (var i = 0; i < endContainerNodeParent.childNodes.length; i++) {
                        var childNode = endContainerNodeParent.childNodes.item(i);
                        if (childNode === endContainerNode) {
                            findIndex = i;
                            childNodeIndexes = [i].concat(childNodeIndexes);
                            break;
                        }
                    }
                    endContainerNode = endContainerNodeParent;
                }
                _this.lastCaretOffset = preCaretRange.endOffset;
                _this.lastCaretNodesIndexes =
                    childNodeIndexes.length > 0 ? childNodeIndexes : [0];
            }
        };
        _this.restoreSelection = function () {
            if (_this.field) {
                var selection = window.getSelection();
                var range = document.createRange();
                if (_this.lastCaretNodesIndexes.length > 0) {
                    // Iterate children nodes until
                    var node_1 = _this.field;
                    if (!node_1 || !node_1.childNodes || node_1.childNodes.length <= 0) {
                        return;
                    }
                    _this.lastCaretNodesIndexes.forEach(function (index) {
                        node_1 = node_1.childNodes.item(index);
                    });
                    range.setStart(node_1.childNodes.length > 0 ? node_1.childNodes.item(0) : node_1, _this.lastCaretOffset);
                }
                else if (_this.field.lastChild) {
                    range.setStart(_this.field.lastChild.childNodes.length > 0
                        ? _this.field.lastChild.childNodes.item(0)
                        : _this.field.lastChild, 0);
                }
                else {
                    range.setStart(_this.field.childNodes.length > 0
                        ? _this.field.childNodes.item(0)
                        : _this.field, 0);
                }
                range.collapse(true);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        };
        _this.checkIfStringIsHtml = function (text) {
            try {
                var doc = new DOMParser().parseFromString(text, 'text/html');
                return [].slice
                    .call(doc.body.childNodes)
                    .some(function (node) { return node.nodeType === 1; });
            }
            catch (err) {
                return false;
            }
        };
        _this.getTextFromHtml = function (text) {
            try {
                var doc = new DOMParser().parseFromString(text, 'text/html');
                var html = doc.childNodes[0];
                var body = html.childNodes[1];
                return body.innerText;
            }
            catch (err) {
                return '';
            }
        };
        _this.addLineBreaksToText = function (text) {
            return text
                .replace(/\n\s*\n\s*\n/g, '\n\n')
                .replace(/(?:\r\n|\r|\n)/g, '<br>');
        };
        _this.content = _this.props.html
            ? _this.checkIfStringIsHtml(_this.props.html)
                ? _this.props.html
                : '<p>' + _this.addLineBreaksToText(_this.props.html) + '</p>'
            : _this.placeholderHtml;
        return _this;
    }
    Object.defineProperty(ContentEditable, "defaultProps", {
        get: function () {
            return {
                onChange: null,
                className: null,
                classNameForField: null,
                html: null,
                placeholder: null,
                charactersLimit: null,
                autoFocus: false,
                selectTextOnFirstFocus: false,
                contentEditable: false,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentEditable.prototype, "placeholderHtml", {
        get: function () {
            return ('<p class="' +
                this.placeholderClassName +
                '">' +
                (this.props.placeholder ? this.props.placeholder.trim() : '') +
                '</p>');
        },
        enumerable: true,
        configurable: true
    });
    ContentEditable.prototype.render = function () {
        var _a;
        var contentEditable = this.props.contentEditable;
        return (React.createElement("div", { className: classNames(s.container, this.props.className) },
            React.createElement("div", { ref: this.referenceField, className: classNames(s.field, this.props.classNameForField), onInput: this.handleChange, onPaste: this.handlePaste, onFocus: this.handleFocus, onBlur: this.handleBlur, contentEditable: contentEditable, dangerouslySetInnerHTML: {
                    __html: this.content,
                } }),
            React.createElement("div", { "aria-hidden": !this.isBeyondCharacterLimit, className: classNames(s.error, (_a = {},
                    _a[s.show] = this.isBeyondCharacterLimit,
                    _a)) },
                React.createElement("p", null, "Character limit of " + (this.props.charactersLimit ||
                    1) + " exceeded"))));
    };
    ContentEditable.prototype.componentDidMount = function () {
        // Limit characters count
        if (this.props.charactersLimit !== null &&
            this.field &&
            this.field.innerText.length > this.props.charactersLimit) {
            this.isBeyondCharacterLimit = true;
            if (this.props.html) {
                this.propagateChange(this.props.html);
            }
        }
        // When autofocus is true, select whole content of the container
        if (this.props.autoFocus && this.props.contentEditable && this.field) {
            this.focusOnContainerAndSelectAll();
            this.focusCount++;
        }
    };
    ContentEditable.prototype.shouldComponentUpdate = function (nextProps) {
        if (nextProps.html !== this.content) {
            return true;
        }
        else if (this.field && nextProps.html !== null) {
            // return this.container.innerText.trim() !== this.getTextFromHtml(nextProps.html).trim();
        }
        return (this.props.className !== nextProps.className ||
            this.props.onChange !== nextProps.onChange ||
            this.props.contentEditable !== nextProps.contentEditable);
    };
    ContentEditable.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.html !== nextProps.html &&
            (typeof nextProps.html === 'undefined' ||
                nextProps.html === null ||
                nextProps.html === '')) {
            this.content = '';
            this.isBeyondCharacterLimit = false;
        }
    };
    ContentEditable.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (this.field &&
            prevProps.html !== this.content &&
            this.content !== this.placeholderHtml) {
            this.restoreSelection();
        }
        if (prevProps.contentEditable === false &&
            this.props.contentEditable === true &&
            this.field &&
            this.props.autoFocus) {
            setTimeout(function () {
                _this.focusOnContainerAndSelectEnd();
            }, 128);
        }
        if (this.content === '') {
            this.field.innerHTML = this.placeholderHtml;
        }
    };
    __decorate([
        mobx_1.observable
    ], ContentEditable.prototype, "focusCount", void 0);
    __decorate([
        mobx_1.observable
    ], ContentEditable.prototype, "content", void 0);
    __decorate([
        mobx_1.observable
    ], ContentEditable.prototype, "lastCaretOffset", void 0);
    __decorate([
        mobx_1.observable
    ], ContentEditable.prototype, "lastCaretNodesIndexes", void 0);
    __decorate([
        mobx_1.observable
    ], ContentEditable.prototype, "isBeyondCharacterLimit", void 0);
    __decorate([
        mobx_1.computed
    ], ContentEditable.prototype, "placeholderHtml", null);
    ContentEditable = __decorate([
        mobx_react_1.observer
    ], ContentEditable);
    return ContentEditable;
}(React.Component));
exports.ContentEditable = ContentEditable;


/***/ }),

/***/ "./app/web/src/components/content/FullScreenMessage.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/content/FullScreenMessage.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./FullScreenMessage.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./FullScreenMessage.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/content/FullScreenMessage.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
// Styles
var s = __webpack_require__("./app/web/src/components/content/FullScreenMessage.css");
// Component
var FullScreenMessage = /** @class */ (function (_super) {
    __extends(FullScreenMessage, _super);
    function FullScreenMessage(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(FullScreenMessage, "defaultProps", {
        get: function () {
            return {
                className: null,
                dismiss: {
                    label: 'Dismiss',
                    onClick: null,
                },
            };
        },
        enumerable: true,
        configurable: true
    });
    FullScreenMessage.prototype.render = function () {
        return (React.createElement("div", { className: s.container },
            React.createElement("h5", { className: s.message }, this.props.label),
            (this.props.dismiss.onClick && this.props.dismiss.label) && (React.createElement("button", { className: s.dismiss, onClick: this.props.dismiss.onClick },
                this.props.dismiss.label,
                React.createElement("hr", null)))));
    };
    FullScreenMessage = __decorate([
        mobx_react_1.observer
    ], FullScreenMessage);
    return FullScreenMessage;
}(React.Component));
exports.FullScreenMessage = FullScreenMessage;


/***/ }),

/***/ "./app/web/src/components/content/Modal.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/content/Modal.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Modal.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Modal.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/content/Modal.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var react_transition_group_1 = __webpack_require__("./node_modules/react-transition-group/index.js");
// Styles
var s = __webpack_require__("./app/web/src/components/content/Modal.css");
var closeIcon = __webpack_require__("./app/web/src/assets/close orange icon.svg");
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.enterAnimationTime = 700;
        _this.leaveAnimationTime = 500;
        _this.show = false;
        _this.showModal = function () {
            _this.show = true;
            document.documentElement.style.overflow = 'hidden';
        };
        _this.hideModal = function () {
            _this.show = false;
            setTimeout(function () {
                document.documentElement.style.overflow = null;
            }, _this.leaveAnimationTime);
            if (_this.props.onModalClose) {
                _this.props.onModalClose();
            }
        };
        _this.handleContainerClick = function (e) {
            e.stopPropagation();
        };
        _this.handleBackgroundClick = function (e) {
            if (_this.props.closeModalOnBackgroundClick) {
                _this.hideModal();
            }
        };
        _this.handleIconButtonClick = function (iconButtonIndex) { return function (e) {
            var iconButton = _this.props.titleBarIcons[iconButtonIndex];
            if (typeof iconButton.onClick === 'function') {
                iconButton.onClick(e);
            }
            if (iconButton.onClickCloseModal) {
                _this.hideModal();
            }
        }; };
        if (_this.props.show) {
            setTimeout(function () {
                _this.showModal();
            }, 256);
        }
        return _this;
    }
    Object.defineProperty(Modal, "defaultProps", {
        get: function () {
            return {
                show: false,
                title: null,
                onModalClose: null,
                closeModalOnBackgroundClick: true,
                titleBarContent: null,
                titleBarIcons: [
                    {
                        key: 'default-close-icon',
                        onClick: null,
                        onClickCloseModal: true,
                        label: 'Close',
                        icon: closeIcon,
                    },
                ],
            };
        },
        enumerable: true,
        configurable: true
    });
    Modal.prototype.componentWillUpdate = function (nextProps) {
        var _this = this;
        if (this.props.show !== nextProps.show) {
            setTimeout(function () {
                if (nextProps.show) {
                    _this.showModal();
                }
                else {
                    _this.hideModal();
                }
            }, 128);
        }
    };
    Modal.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_transition_group_1.CSSTransitionGroup, { component: "div", transitionName: "modal", transitionAppear: true, transitionAppearTimeout: this.enterAnimationTime, transitionEnter: true, transitionEnterTimeout: this.enterAnimationTime, transitionLeave: true, transitionLeaveTimeout: this.leaveAnimationTime }, this.show && (React.createElement("div", { className: s.background, onClick: this.handleBackgroundClick },
            React.createElement("div", { className: s.wrapper },
                React.createElement("div", { className: s.container, onClick: this.handleContainerClick },
                    React.createElement("div", { className: s.titleBar },
                        React.createElement("h5", { className: s.titleBarHeadline }, this.props.title || ''),
                        this.props.titleBarContent && (React.createElement("div", { className: s.titleBarContent }, this.props.titleBarContent)),
                        React.createElement("div", { className: s.titleBarIcons }, this.props.titleBarIcons.map(function (iconButton, i) {
                            return (React.createElement(action_1.IconButton, { key: iconButton.key, className: typeof iconButton.className !==
                                    'undefined'
                                    ? iconButton.className
                                    : null, iconClassName: typeof iconButton.iconClassName !==
                                    'undefined'
                                    ? iconButton.iconClassName
                                    : null, onClick: _this.handleIconButtonClick(i), label: typeof iconButton.label !==
                                    'undefined'
                                    ? iconButton.label
                                    : undefined, icon: typeof iconButton !==
                                    'undefined'
                                    ? iconButton.icon
                                    : undefined, labelOnRight: false, removePadding: true }));
                        }))),
                    typeof this.props.children !== 'undefined' &&
                        this.props.children && (React.createElement("div", { className: s.content }, this.props.children))))))));
    };
    __decorate([
        mobx_1.observable
    ], Modal.prototype, "show", void 0);
    Modal = __decorate([
        mobx_react_1.observer
    ], Modal);
    return Modal;
}(React.Component));
exports.Modal = Modal;


/***/ }),

/***/ "./app/web/src/components/content/ModalBottomBar.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/content/ModalBottomBar.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./ModalBottomBar.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./ModalBottomBar.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/content/ModalBottomBar.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var classnames_1 = __webpack_require__("./node_modules/classnames/index.js");
// Styles
var s = __webpack_require__("./app/web/src/components/content/ModalBottomBar.css");
// Component
var ModalBottomBar = /** @class */ (function (_super) {
    __extends(ModalBottomBar, _super);
    function ModalBottomBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ModalBottomBar, "defaultProps", {
        get: function () {
            return {
                className: undefined,
                classNameForWrapper: undefined,
                classNameForContent: undefined,
                show: true,
            };
        },
        enumerable: true,
        configurable: true
    });
    ModalBottomBar.prototype.render = function () {
        var _a;
        return (React.createElement("div", { className: classnames_1.default(s.container, this.props.className, (_a = {},
                _a[s.show] = this.props.show,
                _a)), style: {
                pointerEvents: this.props.show ? undefined : 'none',
            } },
            React.createElement("div", { className: classnames_1.default(s.wrapper, this.props.classNameForWrapper) },
                React.createElement("div", { className: classnames_1.default(s.content, this.props.classNameForContent) }, this.props.children))));
    };
    ModalBottomBar = __decorate([
        mobx_react_1.observer
    ], ModalBottomBar);
    return ModalBottomBar;
}(React.Component));
exports.ModalBottomBar = ModalBottomBar;


/***/ }),

/***/ "./app/web/src/components/content/SectionHeadline.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/content/SectionHeadline.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./SectionHeadline.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./SectionHeadline.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/content/SectionHeadline.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/components/content/SectionHeadline.css");
// Component
var SectionHeadline = /** @class */ (function (_super) {
    __extends(SectionHeadline, _super);
    function SectionHeadline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Handle button click
        _this.handleButtonClick = function (e) {
            e.preventDefault();
            if (typeof _this.props.button !== 'undefined' &&
                _this.props.button.onClick) {
                _this.props.button.onClick(e);
            }
        };
        return _this;
    }
    Object.defineProperty(SectionHeadline, "defaultProps", {
        get: function () {
            return {
                title: null,
                details: null,
                button: null,
                placeChildrenInTheMiddle: false,
                className: null,
                classNameForHeadline: null,
            };
        },
        enumerable: true,
        configurable: true
    });
    SectionHeadline.prototype.render = function () {
        var _a = this.props, title = _a.title, details = _a.details, button = _a.button, placeChildrenInTheMiddle = _a.placeChildrenInTheMiddle, className = _a.className, classNameForHeadline = _a.classNameForHeadline;
        // Render
        return (React.createElement("div", { className: classNames(s.container, className) },
            React.createElement("h2", { className: classNames(s.headline, classNameForHeadline) },
                title && React.createElement("span", null, title),
                details && React.createElement("em", null, details)),
            placeChildrenInTheMiddle && this.props.children && (React.createElement("div", { className: s.middle }, this.props.children)),
            React.createElement("div", { className: s.right },
                placeChildrenInTheMiddle === false && this.props.children,
                button && (React.createElement(action_1.IconButton, { className: s.iconButton, onClick: this.handleButtonClick, label: typeof button.label !== 'undefined' &&
                        button.label
                        ? button.label
                        : undefined, labelClassName: typeof button.labelClassName !== 'undefined' &&
                        button.labelClassName
                        ? button.labelClassName
                        : undefined, iconClassName: typeof button.iconClassName !== 'undefined' &&
                        button.iconClassName
                        ? button.iconClassName
                        : undefined, showLabel: typeof button.showLabel !== 'undefined' &&
                        button.showLabel !== null
                        ? button.showLabel
                        : undefined, icon: typeof button.icon !== 'undefined' &&
                        button.icon
                        ? button.icon
                        : undefined })))));
    };
    SectionHeadline = __decorate([
        mobx_react_1.observer
    ], SectionHeadline);
    return SectionHeadline;
}(React.Component));
exports.SectionHeadline = SectionHeadline;


/***/ }),

/***/ "./app/web/src/components/content/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/components/content/SectionHeadline.tsx"));
__export(__webpack_require__("./app/web/src/components/content/FullScreenMessage.tsx"));
__export(__webpack_require__("./app/web/src/components/content/ContentEditable.tsx"));
__export(__webpack_require__("./app/web/src/components/content/Modal.tsx"));
__export(__webpack_require__("./app/web/src/components/content/ModalBottomBar.tsx"));


/***/ }),

/***/ "./app/web/src/components/createlead/CreateLeadForm.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/createlead/CreateLeadForm.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./CreateLeadForm.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./CreateLeadForm.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/createlead/CreateLeadForm.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var Leads_1 = __webpack_require__("./app/web/src/stores/Leads.ts");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var provider_1 = __webpack_require__("./app/common/interfaces/provider.ts");
// Styles
var s = __webpack_require__("./app/web/src/components/createlead/CreateLeadForm.css");
// Component
var CreateLeadForm = /** @class */ (function (_super) {
    __extends(CreateLeadForm, _super);
    function CreateLeadForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleNewLeadFieldsChange = function (property) { return function (e) {
            _this.props.store.leads.newLead[property] = e.currentTarget.value;
            _this.props.store.leads.newLead.status = provider_1.CreateNewLeadStatus.None;
        }; };
        _this.handleCreateClick = function () {
            _this.props.store.leads.createNewLead();
        };
        return _this;
    }
    CreateLeadForm.prototype.render = function () {
        var leads = this.props.store.leads;
        return (React.createElement("div", { className: s.container },
            React.createElement("div", { className: s.form },
                React.createElement("input", { autoFocus: true, type: "text", placeholder: "Provider ID", value: leads.newLead.providerId, onChange: this.handleNewLeadFieldsChange(Leads_1.CreateLeadProperties.providerId) }),
                React.createElement("input", { type: "text", placeholder: "Legal business name", value: leads.newLead.legalBusName, onChange: this.handleNewLeadFieldsChange(Leads_1.CreateLeadProperties.legalBusName) }),
                React.createElement("input", { type: "text", placeholder: "DBA (optional)", value: leads.newLead.dba, onChange: this.handleNewLeadFieldsChange(Leads_1.CreateLeadProperties.dba) }),
                React.createElement("button", { className: "boxButton", onClick: this.handleCreateClick }, "Create")),
            React.createElement("div", { className: s.saving },
                React.createElement(indicator_1.SavingIndicator, { align: "right", labels: {
                        success: 'Lead created',
                        saving: 'Creating new lead...',
                        error: leads.newLead.status ===
                            provider_1.CreateNewLeadStatus.ProviderIdRequired
                            ? 'Provider ID is required'
                            : leads.newLead.status ===
                                provider_1.CreateNewLeadStatus.LegalBusNameRequired
                                ? 'Legal business name is required'
                                : 'Something went wrong, try again',
                    }, status: leads.newLead.status ===
                        provider_1.CreateNewLeadStatus.LegalBusNameRequired ||
                        leads.newLead.status ===
                            provider_1.CreateNewLeadStatus.ServerSideError
                        ? indicator_1.SavingIndicatorStatus.Error
                        : leads.newLead.status ===
                            provider_1.CreateNewLeadStatus.Success
                            ? indicator_1.SavingIndicatorStatus.Success
                            : leads.newLead.status ===
                                provider_1.CreateNewLeadStatus.Saving
                                ? indicator_1.SavingIndicatorStatus.Saving
                                : indicator_1.SavingIndicatorStatus.None }))));
    };
    __decorate([
        mobx_1.action
    ], CreateLeadForm.prototype, "handleNewLeadFieldsChange", void 0);
    __decorate([
        mobx_1.action
    ], CreateLeadForm.prototype, "handleCreateClick", void 0);
    CreateLeadForm = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], CreateLeadForm);
    return CreateLeadForm;
}(React.Component));
exports.CreateLeadForm = CreateLeadForm;


/***/ }),

/***/ "./app/web/src/components/createlead/CreateLeadModal.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/createlead/CreateLeadModal.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./CreateLeadModal.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./CreateLeadModal.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/createlead/CreateLeadModal.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
var _1 = __webpack_require__("./app/web/src/components/createlead/index.ts");
var provider_1 = __webpack_require__("./app/common/interfaces/provider.ts");
// Styles
var s = __webpack_require__("./app/web/src/components/createlead/CreateLeadModal.css");
// Component
var CreateLeadModal = /** @class */ (function (_super) {
    __extends(CreateLeadModal, _super);
    function CreateLeadModal(props) {
        var _this = _super.call(this, props) || this;
        _this.closeModal = function () {
            _this.props.store.leads.modalStatus = provider_1.CreateLeadModalStatus.Closed;
        };
        return _this;
    }
    CreateLeadModal.prototype.render = function () {
        // Destructure
        var leads = this.props.store.leads;
        // Render
        return (React.createElement(content_1.Modal, { onModalClose: this.closeModal, show: leads.modalStatus !== provider_1.CreateLeadModalStatus.Closed, title: "Create new lead" },
            React.createElement(_1.CreateLeadForm, null)));
    };
    CreateLeadModal = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], CreateLeadModal);
    return CreateLeadModal;
}(React.Component));
exports.CreateLeadModal = CreateLeadModal;


/***/ }),

/***/ "./app/web/src/components/createlead/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/components/createlead/CreateLeadModal.tsx"));
__export(__webpack_require__("./app/web/src/components/createlead/CreateLeadForm.tsx"));


/***/ }),

/***/ "./app/web/src/components/indicator/LoadingFullScreen.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/indicator/LoadingFullScreen.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LoadingFullScreen.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LoadingFullScreen.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/indicator/LoadingFullScreen.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
// Libraries
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var react_transition_group_1 = __webpack_require__("./node_modules/react-transition-group/index.js");
// Components
var _1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
// Styles
__webpack_require__("./app/web/src/components/indicator/LoadingFullScreen.css");
var c = 'comp-loading-pane';
// Component
var LoadingFullScreen = /** @class */ (function (_super) {
    __extends(LoadingFullScreen, _super);
    function LoadingFullScreen() {
        return _super.call(this) || this;
    }
    LoadingFullScreen.prototype.render = function () {
        var _a;
        return (React.createElement(react_transition_group_1.CSSTransitionGroup, { component: "div", className: c + "-container", transitionName: "fade", transitionAppear: true, transitionAppearTimeout: 300, transitionEnter: true, transitionEnterTimeout: 300, transitionLeave: false, transitionLeaveTimeout: 0 }, this.props.active && (React.createElement("div", { className: classNames(c, this.props.className, (_a = {},
                _a[c + "-fit"] = this.props.fitInContainer,
                _a)) },
            React.createElement(_1.LoadingSpinner, { key: "spinner", active: true, className: this.props.spinnerClassName ? this.props.spinnerClassName : undefined })))));
    };
    LoadingFullScreen.defaultProps = {
        className: null,
        spinnerClassName: null,
        active: false,
        fitInContainer: false,
    };
    LoadingFullScreen = __decorate([
        mobx_react_1.observer
    ], LoadingFullScreen);
    return LoadingFullScreen;
}(React.Component));
exports.LoadingFullScreen = LoadingFullScreen;


/***/ }),

/***/ "./app/web/src/components/indicator/LoadingSpinner.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/indicator/LoadingSpinner.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LoadingSpinner.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LoadingSpinner.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/indicator/LoadingSpinner.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
// Libraries
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var react_transition_group_1 = __webpack_require__("./node_modules/react-transition-group/index.js");
// Styles
__webpack_require__("./app/web/src/components/indicator/LoadingSpinner.css");
var c = 'comp-spinner';
// Component
var LoadingSpinner = /** @class */ (function (_super) {
    __extends(LoadingSpinner, _super);
    function LoadingSpinner(props) {
        var _this = _super.call(this, props) || this;
        _this.handleWrapperReference = function (ref) { return _this.spinnerWrapper = ref; };
        return _this;
    }
    Object.defineProperty(LoadingSpinner, "defaultProps", {
        get: function () {
            return {
                size: 64,
                color: '#A0A3A3',
                active: false,
                className: null,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoadingSpinner.prototype, "wrapperClassName", {
        get: function () {
            var className = c + "-wrapper";
            className += this.props.className ? ' ' + this.props.className : '';
            return className;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoadingSpinner.prototype, "arcDimensions", {
        get: function () {
            // Calculate base values
            var sizeHalf = this.props.size / 2;
            var strokeWidth = this.props.size / 10;
            var arcRadius = sizeHalf - strokeWidth;
            // Return arc dimensions
            return {
                sizeHalf: sizeHalf, strokeWidth: strokeWidth, arcRadius: arcRadius,
                arcDescription: this.describeArc(sizeHalf, sizeHalf, arcRadius, -45, 45),
            };
        },
        enumerable: true,
        configurable: true
    });
    LoadingSpinner.prototype.render = function () {
        return (React.createElement("div", { ref: this.handleWrapperReference, className: this.wrapperClassName, style: { width: this.props.size + 'px', height: this.props.size + 'px' } },
            React.createElement(react_transition_group_1.CSSTransitionGroup, { component: "div", className: c + "-container", transitionName: "spin", transitionAppear: true, transitionAppearTimeout: 200, transitionEnter: true, transitionEnterTimeout: 200, transitionLeave: false, transitionLeaveTimeout: 0 }, this.props.active && (React.createElement("svg", { key: "spinner", className: c, width: this.props.size, height: this.props.size },
                React.createElement("path", { fill: "none", stroke: this.props.color, strokeWidth: this.arcDimensions.strokeWidth, d: this.arcDimensions.arcDescription }),
                React.createElement("circle", { cx: this.arcDimensions.sizeHalf, cy: this.arcDimensions.sizeHalf, r: this.arcDimensions.arcRadius, fill: "none", stroke: this.props.color, strokeWidth: this.arcDimensions.strokeWidth, opacity: 0.2 }))))));
    };
    LoadingSpinner.prototype.polarToCartesian = function (centerX, centerY, radius, angleInDegrees) {
        var angleInRadians = (angleInDegrees - 90) * Math.PI / 180;
        return {
            x: centerX + (radius * Math.cos(angleInRadians)),
            y: centerY + (radius * Math.sin(angleInRadians)),
        };
    };
    LoadingSpinner.prototype.describeArc = function (x, y, radius, startAngle, endAngle) {
        var start = this.polarToCartesian(x, y, radius, endAngle);
        var end = this.polarToCartesian(x, y, radius, startAngle);
        var largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
        var d = [
            'M', start.x, start.y,
            'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y,
        ].join(' ');
        return d;
    };
    __decorate([
        mobx_1.computed
    ], LoadingSpinner.prototype, "wrapperClassName", null);
    __decorate([
        mobx_1.computed
    ], LoadingSpinner.prototype, "arcDimensions", null);
    LoadingSpinner = __decorate([
        mobx_react_1.observer
    ], LoadingSpinner);
    return LoadingSpinner;
}(React.Component));
exports.LoadingSpinner = LoadingSpinner;


/***/ }),

/***/ "./app/web/src/components/indicator/SavingIndicator.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/indicator/SavingIndicator.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./SavingIndicator.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./SavingIndicator.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/indicator/SavingIndicator.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var react_transition_group_1 = __webpack_require__("./node_modules/react-transition-group/index.js");
var _1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/components/indicator/SavingIndicator.css");
// Enumerables
var SavingIndicatorStatus;
(function (SavingIndicatorStatus) {
    SavingIndicatorStatus[SavingIndicatorStatus["None"] = 0] = "None";
    SavingIndicatorStatus[SavingIndicatorStatus["Saving"] = 1] = "Saving";
    SavingIndicatorStatus[SavingIndicatorStatus["Success"] = 2] = "Success";
    SavingIndicatorStatus[SavingIndicatorStatus["Error"] = 3] = "Error";
})(SavingIndicatorStatus = exports.SavingIndicatorStatus || (exports.SavingIndicatorStatus = {}));
var SavingIndicator = /** @class */ (function (_super) {
    __extends(SavingIndicator, _super);
    function SavingIndicator(props) {
        var _this = _super.call(this, props) || this;
        _this.beginHiding = false;
        return _this;
    }
    Object.defineProperty(SavingIndicator, "defaultProps", {
        get: function () {
            return {
                className: null,
                status: SavingIndicatorStatus.None,
                dismissIn: 5000,
                align: 'right',
                labels: {
                    note: '',
                    saving: 'Saving...',
                    success: 'Saved',
                    error: 'Error',
                    retry: 'Retry',
                },
                onRetry: null,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SavingIndicator.prototype, "show", {
        get: function () {
            if (this.props.status === SavingIndicatorStatus.Success) {
                return this.beginHiding === false;
            }
            else {
                return this.props.status !== SavingIndicatorStatus.None ||
                    (this.props.status === SavingIndicatorStatus.None &&
                        typeof this.props.labels.note !== 'undefined' &&
                        this.props.labels.note.length > 0);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SavingIndicator.prototype, "label", {
        get: function () {
            var label = '';
            var className = [s.label];
            switch (this.props.status) {
                case SavingIndicatorStatus.Saving:
                    label = this.props.labels.saving;
                    break;
                case SavingIndicatorStatus.Success:
                    label = this.props.labels.success;
                    className.push(s.successMsg);
                    break;
                case SavingIndicatorStatus.Error:
                    label = this.props.labels.error;
                    className.push(s.errorMsg);
                    break;
                case SavingIndicatorStatus.None:
                    label = this.props.labels.note;
                    break;
                default:
                    break;
            }
            return {
                text: label,
                className: className,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SavingIndicator.prototype, "alignmentClassName", {
        get: function () {
            var align = this.props.align;
            return align === 'right'
                ? s.alignRight
                : align === 'left'
                    ? s.alignLeft
                    : align === 'center'
                        ? s.alignCenter
                        : null;
        },
        enumerable: true,
        configurable: true
    });
    SavingIndicator.prototype.componentWillUpdate = function (nextProps) {
        var _this = this;
        var status = nextProps.status, dismissIn = nextProps.dismissIn;
        if (status === SavingIndicatorStatus.Success) {
            setTimeout(function () {
                _this.beginHiding = true;
            }, nextProps.dismissIn);
        }
    };
    SavingIndicator.prototype.render = function () {
        var _a = this.props, onRetry = _a.onRetry, align = _a.align;
        return (React.createElement(react_transition_group_1.CSSTransitionGroup, { component: "div", className: classNames(s.container, this.alignmentClassName, this.props.className), transitionName: "fade", transitionAppear: true, transitionAppearTimeout: 300, transitionEnter: true, transitionEnterTimeout: 300, transitionLeave: true, transitionLeaveTimeout: 1000 }, (this.show) && (React.createElement("div", { key: "indicator", className: s.indicator },
            React.createElement(_1.LoadingSpinner, { size: 18, active: this.props.status === SavingIndicatorStatus.Saving }),
            React.createElement("p", { key: "label", className: classNames(this.label.className) },
                (this.label.text.length > 0) && (React.createElement("span", null, this.label.text)),
                (this.props.status === SavingIndicatorStatus.Error && this.props.onRetry !== null) && (React.createElement("button", { onClick: onRetry }, this.props.labels.retry)))))));
    };
    __decorate([
        mobx_1.observable
    ], SavingIndicator.prototype, "beginHiding", void 0);
    __decorate([
        mobx_1.computed
    ], SavingIndicator.prototype, "show", null);
    __decorate([
        mobx_1.computed
    ], SavingIndicator.prototype, "label", null);
    __decorate([
        mobx_1.computed
    ], SavingIndicator.prototype, "alignmentClassName", null);
    SavingIndicator = __decorate([
        mobx_react_1.observer
    ], SavingIndicator);
    return SavingIndicator;
}(React.Component));
exports.SavingIndicator = SavingIndicator;


/***/ }),

/***/ "./app/web/src/components/indicator/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/components/indicator/SavingIndicator.tsx"));
__export(__webpack_require__("./app/web/src/components/indicator/LoadingSpinner.tsx"));
__export(__webpack_require__("./app/web/src/components/indicator/LoadingFullScreen.tsx"));


/***/ }),

/***/ "./app/web/src/components/layout/Layout.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/Layout.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Layout.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Layout.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/layout/Layout.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__("./app/web/src/components/layout/index.tsx");
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var reminder_1 = __webpack_require__("./app/web/src/components/reminder/index.tsx");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var Sidebar_1 = __webpack_require__("./app/web/src/components/layout/Sidebar/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/components/layout/Layout.css");
// Component
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout(props) {
        return _super.call(this, props) || this;
    }
    Layout.prototype.render = function () {
        var _a;
        return (React.createElement("div", { className: s.layout },
            React.createElement(_1.Topbar, null),
            React.createElement("div", { className: classNames(s.page, (_a = {},
                    _a[s.paddedBottom] = this.props.store.utilities
                        .showOfflineArea,
                    _a)) }, this.props.children),
            React.createElement(Sidebar_1.Sidebar, null),
            React.createElement(reminder_1.RemindersAlert, null),
            React.createElement(reminder_1.RemindersCenter, null)));
    };
    Layout = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], Layout);
    return Layout;
}(React.Component));
exports.Layout = Layout;


/***/ }),

/***/ "./app/web/src/components/layout/Offline/OfflineArea.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/Offline/OfflineArea.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./OfflineArea.css", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./OfflineArea.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/layout/Offline/OfflineArea.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var react_transition_group_1 = __webpack_require__("./node_modules/react-transition-group/index.js");
// Styles
var s = __webpack_require__("./app/web/src/components/layout/Offline/OfflineArea.css");
// Component
var OfflineArea = /** @class */ (function (_super) {
    __extends(OfflineArea, _super);
    function OfflineArea(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(OfflineArea, "defaultProps", {
        get: function () {
            return {
                show: false,
                headline: 'You are currently offline.',
                message: 'We\'re attempting to reconnect with the server; however, the issue might be due to your network.',
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OfflineArea.prototype, "animationTime", {
        get: function () { return 500; },
        enumerable: true,
        configurable: true
    });
    OfflineArea.prototype.render = function () {
        return (React.createElement(react_transition_group_1.CSSTransitionGroup, { component: "div", className: s.offlineArea, transitionName: "slide", transitionAppear: true, transitionEnter: true, transitionLeave: true, transitionAppearTimeout: this.animationTime, transitionEnterTimeout: this.animationTime, transitionLeaveTimeout: this.animationTime }, (this.props.show) && (React.createElement("div", { key: "main-offline-bar", className: s.offlineBar },
            React.createElement("p", null,
                (this.props.headline) && (React.createElement("strong", null, this.props.headline)),
                (this.props.message) && (React.createElement("span", null, this.props.message)))))));
    };
    OfflineArea = __decorate([
        mobx_react_1.observer
    ], OfflineArea);
    return OfflineArea;
}(React.Component));
exports.OfflineArea = OfflineArea;


/***/ }),

/***/ "./app/web/src/components/layout/Offline/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/components/layout/Offline/OfflineArea.tsx"));


/***/ }),

/***/ "./app/web/src/components/layout/Sidebar/Activities/ActivitiesSidebar.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/Sidebar/Activities/ActivitiesSidebar.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./ActivitiesSidebar.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./ActivitiesSidebar.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/layout/Sidebar/Activities/ActivitiesSidebar.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var activity_1 = __webpack_require__("./app/web/src/components/activity/index.tsx");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/components/layout/Sidebar/Activities/ActivitiesSidebar.css");
// Pages
var ActivitiesSidebar = /** @class */ (function (_super) {
    __extends(ActivitiesSidebar, _super);
    function ActivitiesSidebar(props) {
        var _this = _super.call(this, props) || this;
        _this.renderActivitiesListByGroup = function () {
            return _this.props.store.activities.userActivitiesGroups.map(function (group, key) {
                return group.activities.length > 0 ? (React.createElement(activity_1.ActivitiesGroup, { key: group.key, title: group.title, allFinished: group.allFinished, activities: group.activities })) : null;
            });
        };
        return _this;
    }
    ActivitiesSidebar.prototype.render = function () {
        var activities = this.props.store.activities;
        return (React.createElement("div", { className: s.activitiesSidebar }, !activities.userActivitiesLoading
            ? activities.activitiesUserLength >= 0
                ? this.renderActivitiesListByGroup()
                : null
            : React.createElement(indicator_1.LoadingSpinner, { key: "spinner", active: true, className: s.spinner })));
    };
    ActivitiesSidebar = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], ActivitiesSidebar);
    return ActivitiesSidebar;
}(React.Component));
exports.ActivitiesSidebar = ActivitiesSidebar;


/***/ }),

/***/ "./app/web/src/components/layout/Sidebar/Activities/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/components/layout/Sidebar/Activities/ActivitiesSidebar.tsx"));


/***/ }),

/***/ "./app/web/src/components/layout/Sidebar/Profile/ChangePasswordForm.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var User_1 = __webpack_require__("./app/web/src/stores/User.ts");
var scroll_1 = __webpack_require__("./app/web/src/events/scroll.ts");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/components/layout/Sidebar/Profile/UserProfile.css");
// Component
var ChangePasswordForm = /** @class */ (function (_super) {
    __extends(ChangePasswordForm, _super);
    function ChangePasswordForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleUserChange = function (property) { return function (e) {
            _this.props.store.user.changeUserPassword[property] = e.currentTarget.value;
            _this.props.store.user.changeUserPassword.modified = true;
        }; };
        _this.handleSaveChanges = function () {
            _this.props.store.user.updateUserPassword().then(function (success) {
                scroll_1.scrollWindow.toY(0);
            });
        };
        return _this;
    }
    ChangePasswordForm.prototype.render = function () {
        var user = this.props.store.user;
        return (React.createElement("div", { className: s.editing },
            React.createElement("div", { className: s.group },
                React.createElement("label", null,
                    React.createElement("p", null,
                        React.createElement("span", null, "Current password")),
                    React.createElement("input", { type: "password", value: user.changeUserPassword.currentPassword, onChange: this.handleUserChange(User_1.UserEditableProperties.currentPassword) })),
                React.createElement("label", null,
                    React.createElement("p", null,
                        React.createElement("span", null, "New password")),
                    React.createElement("input", { type: "password", value: user.changeUserPassword.newPassword, onChange: this.handleUserChange(User_1.UserEditableProperties.newPassword) })),
                React.createElement("label", null,
                    React.createElement("p", null,
                        React.createElement("span", null, "Confirm new password")),
                    React.createElement("input", { type: "password", value: user.changeUserPassword.confirmPassword, onChange: this.handleUserChange(User_1.UserEditableProperties.confirmPassword) }))),
            React.createElement("div", { className: s.details },
                React.createElement("div", null,
                    React.createElement("button", { className: "boxButton", onClick: this.handleSaveChanges }, "Save changes")),
                React.createElement("div", null,
                    React.createElement(indicator_1.SavingIndicator, { labels: {
                            saving: 'Saving changes...',
                            error: 'All fields are required and current password needs to match your existing password, try again',
                            success: 'Password has been changed',
                        }, status: user.userChangePasswordSavingError
                            ? indicator_1.SavingIndicatorStatus.Error
                            : user.userChangePasswordSavingSuccess
                                ? indicator_1.SavingIndicatorStatus.Success
                                : user.userChangePasswordSaving
                                    ? indicator_1.SavingIndicatorStatus.Saving
                                    : indicator_1.SavingIndicatorStatus.None })))));
    };
    __decorate([
        mobx_1.action
    ], ChangePasswordForm.prototype, "handleUserChange", void 0);
    ChangePasswordForm = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], ChangePasswordForm);
    return ChangePasswordForm;
}(React.Component));
exports.ChangePasswordForm = ChangePasswordForm;


/***/ }),

/***/ "./app/web/src/components/layout/Sidebar/Profile/ProfileSidebar.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/Sidebar/Profile/ProfileSidebar.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./ProfileSidebar.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./ProfileSidebar.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/layout/Sidebar/Profile/ProfileSidebar.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var App_1 = __webpack_require__("./app/web/src/App.tsx");
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var _1 = __webpack_require__("./app/web/src/components/layout/Sidebar/Profile/index.tsx");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
var editIcon = __webpack_require__("./app/web/src/assets/pen icon.svg");
var cancelIcon = __webpack_require__("./app/web/src/assets/close orange icon.svg");
// Styles
var s = __webpack_require__("./app/web/src/components/layout/Sidebar/Profile/ProfileSidebar.css");
var padlockIcon = __webpack_require__("./app/web/src/assets/padlock-icon.svg");
// Component
var ProfileSidebar = /** @class */ (function (_super) {
    __extends(ProfileSidebar, _super);
    function ProfileSidebar(props) {
        var _this = _super.call(this, props) || this;
        _this.handleLogout = function (e) {
            App_1.browserHistory.push('/user/logout');
        };
        return _this;
    }
    ProfileSidebar.prototype.render = function () {
        var _a = this.props.store, user = _a.user, sidebar = _a.sidebar;
        return (React.createElement("div", { className: s.profileSidebar },
            React.createElement("div", { className: s.profileSidebarInner },
                React.createElement(content_1.SectionHeadline, { title: "User Profile", button: user.userEdit
                        ? {
                            onClick: user.stopEditingUser,
                            label: 'Cancel editing',
                            icon: cancelIcon,
                        }
                        : {
                            onClick: user.startEditingUser,
                            label: '',
                            icon: editIcon,
                        } }),
                user.userEdit && React.createElement(_1.UserProfileForm, null) || React.createElement(_1.UserProfileInfo, null),
                React.createElement(content_1.SectionHeadline, { title: "Change Password", button: user.userChangePassword
                        ? {
                            onClick: user.stopEditingUserPassword,
                            label: 'Cancel editing',
                            icon: cancelIcon,
                        }
                        : {
                            onClick: user.startEditingUserPassword,
                            label: '',
                            icon: editIcon,
                        } }),
                user.userChangePassword && React.createElement(_1.ChangePasswordForm, null)),
            React.createElement("button", { className: s.logout, onClick: this.handleLogout, style: { width: sidebar.width + 'px' } },
                React.createElement("span", null, "Logout"),
                React.createElement("img", { src: padlockIcon }))));
    };
    ProfileSidebar = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], ProfileSidebar);
    return ProfileSidebar;
}(React.Component));
exports.ProfileSidebar = ProfileSidebar;


/***/ }),

/***/ "./app/web/src/components/layout/Sidebar/Profile/UserProfile.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/Sidebar/Profile/UserProfile.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./UserProfile.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./UserProfile.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/layout/Sidebar/Profile/UserProfileForm.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var User_1 = __webpack_require__("./app/web/src/stores/User.ts");
var scroll_1 = __webpack_require__("./app/web/src/events/scroll.ts");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/components/layout/Sidebar/Profile/UserProfile.css");
// Component
var UserProfileForm = /** @class */ (function (_super) {
    __extends(UserProfileForm, _super);
    function UserProfileForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleUserChange = function (property) { return function (e) {
            _this.props.store.user.editedUser[property] = e.currentTarget.value;
            _this.props.store.user.editedUser.modified = true;
        }; };
        _this.handleSaveChanges = function () {
            _this.props.store.user.saveUpdatedUser().then(function (success) {
                scroll_1.scrollWindow.toY(0);
            });
        };
        return _this;
    }
    UserProfileForm.prototype.render = function () {
        var user = this.props.store.user;
        return (React.createElement("div", { className: s.editing },
            React.createElement("div", { className: s.group },
                React.createElement("label", null,
                    React.createElement("p", null,
                        React.createElement("span", null, "Name")),
                    React.createElement("input", { type: "text", value: user.editedUser.name, onChange: this.handleUserChange(User_1.UserEditableProperties.name) })),
                React.createElement("label", null,
                    React.createElement("p", null,
                        React.createElement("span", null, "Email address")),
                    React.createElement("input", { type: "text", value: user.editedUser.email, onChange: this.handleUserChange(User_1.UserEditableProperties.email) }))),
            React.createElement("div", { className: s.details },
                React.createElement("div", null,
                    React.createElement("button", { className: "boxButton", onClick: this.handleSaveChanges }, "Save changes")),
                React.createElement("div", null,
                    React.createElement(indicator_1.SavingIndicator, { labels: {
                            saving: 'Saving changes...',
                            error: 'Could not save changes, try again',
                        }, status: user.userEditSavingError
                            ? indicator_1.SavingIndicatorStatus.Error
                            : user.userEditSaving
                                ? indicator_1.SavingIndicatorStatus.Saving
                                : indicator_1.SavingIndicatorStatus.None })))));
    };
    __decorate([
        mobx_1.action
    ], UserProfileForm.prototype, "handleUserChange", void 0);
    UserProfileForm = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], UserProfileForm);
    return UserProfileForm;
}(React.Component));
exports.UserProfileForm = UserProfileForm;


/***/ }),

/***/ "./app/web/src/components/layout/Sidebar/Profile/UserProfileInfo.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var user_1 = __webpack_require__("./app/common/interfaces/user.ts");
// Icon
var contactIcon = __webpack_require__("./app/web/src/assets/conversation icon.svg");
var companyIcon = __webpack_require__("./app/web/src/assets/document profile icon.svg");
// Styles
var s = __webpack_require__("./app/web/src/components/layout/Sidebar/Profile/UserProfile.css");
// Component
var UserProfileInfo = /** @class */ (function (_super) {
    __extends(UserProfileInfo, _super);
    function UserProfileInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(UserProfileInfo.prototype, "isKnownUserType", {
        get: function () {
            return this.props.store.user.userType === user_1.UserType.SalesManager || this.props.store.user.userType === user_1.UserType.SalesRep;
        },
        enumerable: true,
        configurable: true
    });
    UserProfileInfo.prototype.render = function () {
        var user = this.props.store.user;
        return (React.createElement("div", null,
            React.createElement("div", { className: s.group },
                React.createElement("img", { className: s.icon, src: companyIcon }),
                (user.name) && (React.createElement("h1", null, user.name)),
                (this.isKnownUserType) && (React.createElement("h3", null, user.userType === user_1.UserType.SalesRep
                    ? 'SALES REP'
                    : user.userType === user_1.UserType.SalesManager
                        ? 'SALES MANAGER'
                        : ''))),
            React.createElement("div", { className: s.group },
                React.createElement("img", { className: s.icon, src: contactIcon }),
                React.createElement("ul", null,
                    React.createElement("li", null,
                        React.createElement("p", null,
                            React.createElement("span", null,
                                "U. ",
                                user.username))),
                    (user.email) && (React.createElement("li", null,
                        React.createElement("p", { className: s.email },
                            React.createElement("span", null,
                                "E. ",
                                user.email))))))));
    };
    __decorate([
        mobx_1.computed
    ], UserProfileInfo.prototype, "isKnownUserType", null);
    UserProfileInfo = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], UserProfileInfo);
    return UserProfileInfo;
}(React.Component));
exports.UserProfileInfo = UserProfileInfo;


/***/ }),

/***/ "./app/web/src/components/layout/Sidebar/Profile/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/components/layout/Sidebar/Profile/ProfileSidebar.tsx"));
__export(__webpack_require__("./app/web/src/components/layout/Sidebar/Profile/UserProfileInfo.tsx"));
__export(__webpack_require__("./app/web/src/components/layout/Sidebar/Profile/UserProfileForm.tsx"));
__export(__webpack_require__("./app/web/src/components/layout/Sidebar/Profile/ChangePasswordForm.tsx"));


/***/ }),

/***/ "./app/web/src/components/layout/Sidebar/Sidebar.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/Sidebar/Sidebar.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Sidebar.css", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Sidebar.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/layout/Sidebar/Sidebar.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var react_transition_group_1 = __webpack_require__("./node_modules/react-transition-group/index.js");
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var Sidebar_1 = __webpack_require__("./app/web/src/stores/Sidebar.ts");
var _1 = __webpack_require__("./app/web/src/components/layout/Sidebar/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/components/layout/Sidebar/Sidebar.css");
// Component
var Sidebar = /** @class */ (function (_super) {
    __extends(Sidebar, _super);
    function Sidebar(props) {
        var _this = _super.call(this, props) || this;
        _this.referenceInner = function (ref) { return _this.inner = ref; };
        _this.inner = null;
        _this.handleScrollInnerToTop = function () {
            if (_this.inner) {
                _this.inner.scrollTop = 0;
            }
        };
        _this.handleSidebarClose = function (e) {
            _this.props.store.sidebar.closeSidebar();
            _this.props.store.user.userChangePassword = false;
            _this.props.store.user.userEdit = false;
        };
        _this.preventSidebarClose = function (e) {
            e.stopPropagation();
        };
        return _this;
    }
    Sidebar.prototype.render = function () {
        var _a;
        var sidebar = this.props.store.sidebar;
        return (React.createElement("div", { onClick: this.handleSidebarClose, className: classNames(s.sidebar, (_a = {},
                _a[s.open] = sidebar.open !== Sidebar_1.SidebarType.Closed,
                _a)) },
            React.createElement("div", { onClick: this.preventSidebarClose, ref: this.referenceInner, className: s.inner, style: {
                    width: sidebar.open !== Sidebar_1.SidebarType.Closed && sidebar.width
                        ? sidebar.width + 'px'
                        : '0px',
                } },
                React.createElement(react_transition_group_1.CSSTransitionGroup, { component: "div", className: s.transitionGroup, transitionName: "sidebar", transitionAppear: true, transitionAppearTimeout: 400, transitionEnter: true, transitionEnterTimeout: 400, transitionLeave: true, transitionLeaveTimeout: 400 }, (sidebar.open === Sidebar_1.SidebarType.Profile) && (React.createElement(_1.SidebarContent, { key: "profile", title: "Profile", width: sidebar.width, onClose: this.handleSidebarClose },
                    React.createElement(_1.ProfileSidebar, null)))))));
    };
    Sidebar = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], Sidebar);
    return Sidebar;
}(React.Component));
exports.Sidebar = Sidebar;


/***/ }),

/***/ "./app/web/src/components/layout/Sidebar/SidebarContent.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/Sidebar/SidebarContent.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./SidebarContent.css", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./SidebarContent.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/layout/Sidebar/SidebarContent.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/components/layout/Sidebar/SidebarContent.css");
var closeIcon = __webpack_require__("./app/web/src/assets/close blue icon.svg");
// Component
var SidebarContent = /** @class */ (function (_super) {
    __extends(SidebarContent, _super);
    function SidebarContent(props) {
        var _this = _super.call(this, props) || this;
        document.documentElement.style.overflow = 'hidden';
        return _this;
    }
    SidebarContent.prototype.componentWillUnmount = function () {
        document.documentElement.style.overflow = null;
    };
    SidebarContent.prototype.render = function () {
        return (React.createElement("div", { className: s.container },
            React.createElement("div", { className: s.top, style: { width: this.props.width + 'px' } },
                React.createElement("p", { className: s.title }, this.props.title),
                React.createElement("button", { className: s.close, onClick: this.props.onClose },
                    React.createElement("img", { src: closeIcon, alt: "" }))),
            React.createElement("div", { className: s.main }, this.props.children)));
    };
    SidebarContent = __decorate([
        mobx_react_1.observer
    ], SidebarContent);
    return SidebarContent;
}(React.Component));
exports.SidebarContent = SidebarContent;


/***/ }),

/***/ "./app/web/src/components/layout/Sidebar/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/components/layout/Sidebar/Sidebar.tsx"));
__export(__webpack_require__("./app/web/src/components/layout/Sidebar/SidebarContent.tsx"));
__export(__webpack_require__("./app/web/src/components/layout/Sidebar/Activities/index.tsx"));
__export(__webpack_require__("./app/web/src/components/layout/Sidebar/Profile/index.tsx"));


/***/ }),

/***/ "./app/web/src/components/layout/Topbar/Topbar.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/Topbar/Topbar.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Topbar.css", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Topbar.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/layout/Topbar/Topbar.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var react_router_dom_1 = __webpack_require__("./node_modules/react-router-dom/es/index.js");
var Sidebar_1 = __webpack_require__("./app/web/src/stores/Sidebar.ts");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
var Leads_1 = __webpack_require__("./app/web/src/stores/Leads.ts");
var zenscroll = __webpack_require__("./node_modules/zenscroll/zenscroll.js");
// Styles
var s = __webpack_require__("./app/web/src/components/layout/Topbar/Topbar.css");
var crmLogo = __webpack_require__("./app/web/src/assets/crm-logo.png");
var iconPerson = __webpack_require__("./app/web/src/assets/person icon.svg");
var closeIcon = __webpack_require__("./app/web/src/assets/close blue icon.svg");
// Component
var Topbar = /** @class */ (function (_super) {
    __extends(Topbar, _super);
    function Topbar(props) {
        var _this = _super.call(this, props) || this;
        _this.handleDashboardLinkClick = function (history) { return function (e) {
            var _a = _this.props.store, leads = _a.leads, activities = _a.activities;
            // Close activities reminders center if it's open
            activities.closeActivitiesReminders();
            // If user is on notes search section of sales dashboard, go back to leads search
            if (history.location.pathname === '/sales' &&
                leads.leadsSearchFilter === Leads_1.LeadsSearchFilter.Notes) {
                zenscroll.toY(0);
                leads.leadsSearchFilter = Leads_1.LeadsSearchFilter.All;
                leads.leadsSearch = '';
                leads.leadsFilterByActivityDate = null;
                leads.leadsFilterByActivityTypeId = null;
            }
        }; };
        _this.handleOpenSidebar = function (type) { return function (e) {
            e.preventDefault();
            _this.props.store.activities.closeActivitiesReminders();
            _this.props.store.sidebar.openSidebar(type);
        }; };
        _this.handleLeadNavClick = function (e) {
            e.preventDefault();
            _this.props.store.activities.closeActivitiesReminders();
            var href = e.currentTarget.getAttribute('data-href');
            if (href) {
                App_1.browserHistory.push(href);
            }
        };
        _this.handleLeadNavClose = function (id) { return function (e) {
            e.preventDefault();
            _this.props.store.lead.handleLeadClose(id);
        }; };
        return _this;
    }
    Topbar.prototype.render = function () {
        var _this = this;
        var _a = this.props.store, lead = _a.lead, user = _a.user;
        return (React.createElement("div", { className: s.topbar },
            React.createElement(react_router_dom_1.NavLink, { onClick: this.handleDashboardLinkClick(App_1.browserHistory), to: "/sales", exact: true, className: s.logo },
                React.createElement("img", { src: crmLogo })),
            React.createElement("ul", { className: s.navigation },
                React.createElement("li", null,
                    React.createElement(react_router_dom_1.NavLink, { onClick: this.handleDashboardLinkClick(App_1.browserHistory), to: "/sales", exact: true, className: s.navLink, activeClassName: s.navLinkActive },
                        React.createElement("strong", null, "Dashboard")))),
            lead.openLeadsIds.length > 0 && (React.createElement("ul", { className: classNames(s.navigation, s.navigationLeads) }, lead.openLeads.map(function (openLead) {
                var _a;
                return (React.createElement("li", { key: "lead-" + openLead.databaseId },
                    React.createElement("button", { key: "lead-" + openLead.databaseId + "-link", onClick: _this.handleLeadNavClick, className: classNames(s.navLink, (_a = {},
                            _a[s.navLinkActive] = lead.openLeadId ===
                                openLead.databaseId,
                            _a)), "data-href": "/sales/lead/" + openLead.databaseId },
                        React.createElement("em", null, openLead.dba ||
                            openLead.legalBusName)),
                    React.createElement("button", { key: "lead-" + openLead.databaseId + "-close", onClick: _this.handleLeadNavClose(openLead.databaseId), className: s.closeLead },
                        React.createElement("span", null, "Close"),
                        React.createElement("img", { src: closeIcon }))));
            }))),
            React.createElement("ul", { className: s.actions },
                React.createElement("li", null,
                    React.createElement("button", { onClick: this.handleOpenSidebar(Sidebar_1.SidebarType.Profile) },
                        React.createElement("strong", null, user.name || user.username),
                        React.createElement("img", { src: iconPerson }))))));
    };
    Topbar = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], Topbar);
    return Topbar;
}(React.Component));
exports.Topbar = Topbar;


/***/ }),

/***/ "./app/web/src/components/layout/Topbar/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/components/layout/Topbar/Topbar.tsx"));


/***/ }),

/***/ "./app/web/src/components/layout/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/components/layout/Layout.tsx"));
__export(__webpack_require__("./app/web/src/components/layout/Topbar/index.tsx"));
__export(__webpack_require__("./app/web/src/components/layout/Offline/index.tsx"));


/***/ }),

/***/ "./app/web/src/components/list/DropdownContainer.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/list/DropdownContainer.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./DropdownContainer.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./DropdownContainer.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/list/DropdownContainer.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var debounce_1 = __webpack_require__("./node_modules/lodash-es/debounce.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Components
var iconDropdownArrow = __webpack_require__("./app/web/src/assets/dropdown arrow.svg");
// Styles
__webpack_require__("./app/web/src/components/list/DropdownContainer.css");
var c = 'comp-dropdown-';
// Component
var DropdownContainer = /** @class */ (function (_super) {
    __extends(DropdownContainer, _super);
    function DropdownContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.open = false;
        _this.positionOnTop = false;
        _this.positionMarginLeft = 0;
        _this.positionMarginTop = 0;
        _this.maxHeight = 440;
        _this.openEvents = {
            window: [],
        };
        _this.delayedWindowResize = function (e) {
            _this.windowResizeDebounced(e);
        };
        _this.windowClicked = function (e) {
            _this.closeDropdown();
        };
        _this.windowKeyedUp = function (e) {
            // Base behavior on the logged key
            switch (e.keyCode) {
                // ESC key
                case 27:
                    _this.closeDropdown();
                    break;
                default:
                    break;
            }
        };
        _this.windowResize = function (e) {
            _this.delayedWindowResize(e);
        };
        _this.handleLabelClick = function (e) {
            // Close
            if (_this.open === true) {
                // Set closed state
                _this.closeDropdown();
                // Open
            }
            else {
                // Add events related to open dropdown
                _this.addOpenEvents();
                // Position dropdown
                _this.positionAndResizeDropdown();
            }
            // Stop propagation
            e.stopPropagation();
        };
        _this.handleDropdownGroupClick = function (e) {
            e.stopPropagation();
        };
        _this.label = null;
        _this.referenceLabel = function (ref) { return (_this.label = ref); };
        _this.windowResizeDebounced = debounce_1.default(_this.windowResizeDebounced, 256);
        return _this;
    }
    Object.defineProperty(DropdownContainer, "defaultProps", {
        get: function () {
            return {
                className: '',
                minWidth: 0,
                maxWidth: 0,
                maxHeight: 0,
                align: 'left',
                label: '',
                value: '',
            };
        },
        enumerable: true,
        configurable: true
    });
    DropdownContainer.prototype.componentWillUnmount = function () {
        // Clear component's events
        this.removeOpenEvents();
    };
    DropdownContainer.prototype.addOpenEvents = function () {
        // Create window click event
        var windowClick = this.windowClicked.bind(this);
        this.openEvents.window.push({ type: 'click', handler: windowClick });
        window.addEventListener('click', windowClick, false);
        // Create window key up event
        var windowKeyUp = this.windowKeyedUp.bind(this);
        this.openEvents.window.push({ type: 'keyup', handler: windowKeyUp });
        window.addEventListener('keyup', windowKeyUp, false);
        // Create window resize event
        var windowResize = this.windowResize.bind(this);
        this.openEvents.window.push({ type: 'resize', handler: windowResize });
        window.addEventListener('resize', windowResize, false);
    };
    DropdownContainer.prototype.removeOpenEvents = function () {
        // Remove window events
        this.openEvents.window.map(function (evt) {
            window.removeEventListener(evt.type, evt.handler);
        });
    };
    DropdownContainer.prototype.windowResizeDebounced = function (e) {
        this.positionAndResizeDropdown();
    };
    DropdownContainer.prototype.closeDropdown = function () {
        // Change state to closed
        this.open = false;
        this.positionMarginLeft = 0;
        this.positionMarginTop = 0;
        // Remove events associated with open dropdown
        this.removeOpenEvents();
    };
    DropdownContainer.prototype.openDropdown = function () {
        this.addOpenEvents();
        this.positionAndResizeDropdown();
    };
    DropdownContainer.prototype.positionAndResizeDropdown = function () {
        // Get dimensions needed for calculations
        var windowHeight = window.innerHeight;
        var windowWidth = window.innerWidth;
        var labelPosition = this.label
            ? this.label.getBoundingClientRect()
            : { top: 0, left: 0 };
        var labelWidth = this.label ? this.label.offsetWidth : 0;
        var labelHeight = this.label ? this.label.offsetHeight : 0;
        var dropdownWidth = labelWidth > 192 ? labelWidth : 192;
        // Determine top or bottom position
        var positionOnTop = windowHeight * 0.8 < labelPosition.top ? true : false;
        // Determine left margin
        var positionMarginLeft = 0;
        if (labelWidth < dropdownWidth) {
            switch (this.props.align) {
                case 'right':
                    positionMarginLeft = -(dropdownWidth - labelWidth);
                    break;
                case 'center':
                    positionMarginLeft = -((dropdownWidth - labelWidth) / 2);
                    break;
                default:
                    break;
            }
        }
        var rightDropdownEdgePosition = labelPosition.left + dropdownWidth + positionMarginLeft;
        if (windowWidth < rightDropdownEdgePosition) {
            positionMarginLeft =
                positionMarginLeft - (rightDropdownEdgePosition - windowWidth);
        }
        // Determine top margin
        var positionMarginTop = positionOnTop === true ? -labelHeight - 8 : labelHeight + 8;
        // Calculate max height
        var maxHeight = typeof this.props.maxHeight !== 'undefined'
            ? this.props.maxHeight
            : 0;
        var maxHeightOnTop = labelPosition.top + positionMarginTop - 12 - 64;
        // 64 above is height of the top bar
        var maxHeightOnBottom = windowHeight - (labelPosition.top + positionMarginTop + 12);
        positionOnTop =
            maxHeightOnBottom * 1.2 < maxHeightOnTop ? true : positionOnTop;
        maxHeight = positionOnTop
            ? maxHeight <= 0 || maxHeightOnTop < maxHeight
                ? maxHeightOnTop
                : maxHeight
            : maxHeight <= 0 || maxHeightOnBottom < maxHeight
                ? maxHeightOnBottom
                : maxHeight;
        // Set open state
        this.open = true;
        this.positionOnTop = positionOnTop;
        this.positionMarginLeft = positionMarginLeft;
        this.positionMarginTop = positionMarginTop;
        this.maxHeight = maxHeight;
    };
    DropdownContainer.prototype.render = function () {
        // Prepare class name
        var dropdownClassName = c + "container";
        dropdownClassName += this.open === true ? " " + c + "open" : '';
        dropdownClassName +=
            this.props.className !== '' ? ' ' + this.props.className : '';
        dropdownClassName += ' ' + this.props.align;
        // Label class name
        var labelClassName = c + "label";
        // Dropdown group class name
        var dropdownGroupClassName = c + "group";
        dropdownGroupClassName += this.positionOnTop === true ? ' top' : '';
        // Dropdown group style
        var dropdownGroupStyle = {
            marginLeft: this.positionMarginLeft !== 0
                ? this.positionMarginLeft + 'px'
                : undefined,
            marginTop: this.positionMarginTop > 0
                ? this.positionMarginTop + 'px'
                : undefined,
            marginBottom: this.positionMarginTop < 0
                ? -this.positionMarginTop + 'px'
                : undefined,
            maxWidth: typeof this.props.maxWidth !== 'undefined' &&
                this.props.maxWidth > 0
                ? this.props.maxWidth + 'px'
                : undefined,
            minWidth: typeof this.props.minWidth !== 'undefined' &&
                this.props.minWidth > 0
                ? this.props.minWidth + 'px'
                : undefined,
            maxHeight: this.maxHeight > 0 ? this.maxHeight + 'px' : undefined,
        };
        // Render
        return (React.createElement("div", { className: dropdownClassName },
            React.createElement("div", { className: labelClassName, onClick: this.handleLabelClick },
                React.createElement("p", { ref: this.referenceLabel },
                    this.props.label && React.createElement("span", null, this.props.label),
                    this.props.value && (React.createElement("strong", null, this.props.value))),
                React.createElement("img", { src: iconDropdownArrow, width: 8, height: 4 })),
            typeof this.props.children !== 'undefined' &&
                this.props.children && (React.createElement("div", { style: dropdownGroupStyle, className: dropdownGroupClassName, onClick: this.handleDropdownGroupClick }, this.open && this.props.children))));
    };
    __decorate([
        mobx_1.observable
    ], DropdownContainer.prototype, "open", void 0);
    __decorate([
        mobx_1.observable
    ], DropdownContainer.prototype, "positionOnTop", void 0);
    __decorate([
        mobx_1.observable
    ], DropdownContainer.prototype, "positionMarginLeft", void 0);
    __decorate([
        mobx_1.observable
    ], DropdownContainer.prototype, "positionMarginTop", void 0);
    __decorate([
        mobx_1.observable
    ], DropdownContainer.prototype, "maxHeight", void 0);
    __decorate([
        mobx_1.action
    ], DropdownContainer.prototype, "delayedWindowResize", void 0);
    __decorate([
        mobx_1.action
    ], DropdownContainer.prototype, "windowClicked", void 0);
    __decorate([
        mobx_1.action
    ], DropdownContainer.prototype, "windowKeyedUp", void 0);
    __decorate([
        mobx_1.action
    ], DropdownContainer.prototype, "windowResize", void 0);
    __decorate([
        mobx_1.action
    ], DropdownContainer.prototype, "windowResizeDebounced", null);
    __decorate([
        mobx_1.action
    ], DropdownContainer.prototype, "closeDropdown", null);
    __decorate([
        mobx_1.action
    ], DropdownContainer.prototype, "openDropdown", null);
    __decorate([
        mobx_1.action
    ], DropdownContainer.prototype, "handleLabelClick", void 0);
    __decorate([
        mobx_1.action
    ], DropdownContainer.prototype, "positionAndResizeDropdown", null);
    DropdownContainer = __decorate([
        mobx_react_1.observer
    ], DropdownContainer);
    return DropdownContainer;
}(React.Component));
exports.DropdownContainer = DropdownContainer;


/***/ }),

/***/ "./app/web/src/components/list/OptionsList.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/list/OptionsList.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./OptionsList.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./OptionsList.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/list/OptionsList.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var isEqual_1 = __webpack_require__("./node_modules/lodash-es/isEqual.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var zenscroll = __webpack_require__("./node_modules/zenscroll/zenscroll.js");
// Styles
__webpack_require__("./app/web/src/components/list/OptionsList.css");
var c = 'comp-options-list-';
// Component
var OptionsList = /** @class */ (function (_super) {
    __extends(OptionsList, _super);
    function OptionsList() {
        var _this = _super.call(this) || this;
        _this.initialScrollToSelectedValue = function () {
            if (_this.containerScroller === null) {
                if (_this.optionListContainer) {
                    var parent_1 = _this.optionListContainer.parentElement;
                    if (parent_1) {
                        _this.containerScroller = zenscroll.createScroller(parent_1, 100, 128);
                        if (_this.activeListItem) {
                            _this.containerScroller.intoView(_this.activeListItem);
                        }
                    }
                }
                else {
                    setTimeout(function () {
                        _this.initialScrollToSelectedValue();
                    }, 64);
                }
            }
        };
        _this.containerScroller = null;
        _this.activeListItem = null;
        _this.optionListContainer = null;
        _this.referenceActiveListItem = function (ref) { return (_this.activeListItem = ref); };
        _this.referenceOptionListContainer = function (ref) {
            return (_this.optionListContainer = ref);
        };
        _this.handleOptionClick = function (value, label) { return function (e) {
            if (_this.props.onChange) {
                _this.props.onChange({ value: value, label: label });
            }
            if (_this.props.onChangeOnlyValue) {
                _this.props.onChangeOnlyValue(value);
            }
        }; };
        _this.initialScrollToSelectedValue();
        return _this;
    }
    Object.defineProperty(OptionsList, "defaultProps", {
        get: function () {
            return {
                className: null,
                onChange: null,
                onChangeOnlyValue: null,
                label: 'Results:',
                value: null,
                options: [],
                optionsListMaxHeight: 0,
                optionToHighlightIndex: null,
                optionToHighlightClassName: null,
                alignOptions: 'default',
                loadingOptions: false,
                loadingMessage: 'Loading...',
                noOptionsMessage: 'No options',
                highlightFirstOption: false,
            };
        },
        enumerable: true,
        configurable: true
    });
    OptionsList.prototype.render = function () {
        var _this = this;
        var _a;
        // Options list class name
        var optionsListClassName = c + 'container';
        optionsListClassName += this.props.className
            ? ' ' + this.props.className
            : '';
        // Label text
        var labelText;
        var labelClassName = c + 'results-label';
        if (this.props.loadingOptions) {
            labelText = this.props.loadingMessage;
        }
        else if (this.props.options === null ||
            this.props.options.length === 0) {
            labelText = this.props.noOptionsMessage;
            labelClassName += ' ' + c + 'results-empty-label';
        }
        else {
            labelText = this.props.label;
        }
        // Render options list container
        return (React.createElement("div", { ref: this.referenceOptionListContainer, className: optionsListClassName },
            React.createElement("div", { className: c + 'results' },
                React.createElement("p", { className: labelClassName }, labelText),
                React.createElement("ul", { className: classNames((_a = {},
                        _a[c + 'align-' + this.props.alignOptions] = true,
                        _a)), style: {
                        maxHeight: this.props.optionsListMaxHeight
                            ? this.props.optionsListMaxHeight + 'px'
                            : undefined,
                    } }, this.props.options.map(function (option, optionIndex) {
                    var _a;
                    // Check if result is active
                    var resultIsActive = false;
                    if (_this.props.value !== null) {
                        if (typeof option.value === 'object' &&
                            option.value &&
                            typeof option.value.length !== 'undefined') {
                            resultIsActive = option.value.some(function (val) {
                                return _this.props.value === val
                                    ? true
                                    : false;
                            });
                        }
                        else {
                            resultIsActive = isEqual_1.default(option.value, _this.props.value);
                        }
                    }
                    else {
                        resultIsActive =
                            option.value === _this.props.value;
                    }
                    // Check if result is focused on
                    var resultIsInFocus = (typeof option.focus !== 'undefined' &&
                        option.focus) ||
                        (_this.props.optionToHighlightIndex !== null &&
                            _this.props.optionToHighlightIndex ===
                                optionIndex)
                        ? true
                        : false;
                    // Render result
                    return (React.createElement("li", { ref: resultIsActive
                            ? _this.referenceActiveListItem
                            : undefined, key: typeof option.value === 'string'
                            ? option.value + optionIndex
                            : JSON.stringify(option.value) +
                                optionIndex, className: classNames(option.className, (_a = {},
                            _a[c + 'result-active'] = resultIsActive,
                            _a[c +
                                'result-highlight'] = resultIsInFocus,
                            _a[_this.props
                                .optionToHighlightClassName] = resultIsInFocus,
                            _a)) },
                        React.createElement("button", { onClick: _this.handleOptionClick(option.value, option.label) }, typeof option.label !== 'undefined' &&
                            option.label !== null
                            ? option.label
                            : option.value)));
                })))));
    };
    OptionsList = __decorate([
        mobx_react_1.observer
    ], OptionsList);
    return OptionsList;
}(React.Component));
exports.OptionsList = OptionsList;


/***/ }),

/***/ "./app/web/src/components/list/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/components/list/DropdownContainer.tsx"));
__export(__webpack_require__("./app/web/src/components/list/OptionsList.tsx"));


/***/ }),

/***/ "./app/web/src/components/navigation/Pagination.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/navigation/Pagination.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Pagination.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Pagination.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/navigation/Pagination.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __webpack_require__("./node_modules/classnames/index.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/components/navigation/Pagination.css");
// Component
var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.changePage = '';
        _this.handleGoToPage = function (e) {
            e.preventDefault();
            var next = parseInt(_this.changePage, 10);
            if (!isNaN(next)) {
                _this.props.onPageClick(next <= 0 ? 1 : next > _this.pagesCount ? _this.pagesCount : next);
            }
            _this.changePage = '';
        };
        _this.handlePageChange = function (e) {
            _this.changePage = e.target.value;
        };
        _this.handlePageClick = function (page) { return function (e) {
            var next = _this.currentPage;
            if (page === '<') {
                next = _this.currentPage - 1;
            }
            else if (page === '>') {
                next = _this.currentPage + 1;
            }
            else {
                next = page;
            }
            _this.props.onPageClick(next <= 0 ? 1 : next > _this.pagesCount ? _this.pagesCount : next);
        }; };
        return _this;
    }
    Object.defineProperty(Pagination, "defaultProps", {
        get: function () {
            return {
                onPageClick: function () { return 1; },
                isLoading: false,
                totalEntries: 0,
                entriesPerPage: 1,
                showingFromOffset: 0,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Pagination.prototype, "pagesCount", {
        get: function () {
            return Math.ceil(this.props.totalEntries / this.props.entriesPerPage);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Pagination.prototype, "allPages", {
        get: function () {
            var pages = [];
            for (var page = 1; page <= this.pagesCount; page++) {
                pages.push(page);
            }
            return pages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Pagination.prototype, "currentPage", {
        get: function () {
            var _this = this;
            var currentPage = 1;
            if (this.props.totalEntries) {
                this.allPages.some(function (page) {
                    var rangeEnd = page * _this.props.entriesPerPage;
                    var rangeStart = rangeEnd - _this.props.entriesPerPage;
                    if (_this.props.showingFromOffset >= rangeStart &&
                        _this.props.showingFromOffset < rangeEnd) {
                        currentPage = page;
                        return true;
                    }
                    return false;
                });
            }
            return currentPage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Pagination.prototype, "pagination", {
        get: function () {
            if (this.allPages.length <= 1) {
                return [1];
            }
            var pagination = [this.currentPage];
            var left = 7;
            while (left > 0) {
                var mod = left % 2;
                if (mod > 0) {
                    if (pagination[pagination.length] >= this.pagesCount) {
                        pagination.unshift(pagination[0] - 1);
                    }
                    else if (pagination[pagination.length - 1] < this.pagesCount) {
                        pagination.push(pagination[pagination.length - 1] + 1);
                    }
                }
                else {
                    if (pagination[0] > 1) {
                        pagination.unshift(pagination[0] - 1);
                    }
                    else if (pagination[pagination.length - 1] < this.pagesCount) {
                        pagination.push(pagination[pagination.length - 1] + 1);
                    }
                }
                left--;
            }
            if (pagination[0] > 1) {
                pagination.unshift('<');
                pagination.unshift(1);
            }
            if (pagination[pagination.length - 1] < this.pagesCount) {
                pagination.push('>');
                pagination.push(this.pagesCount);
            }
            return pagination;
        },
        enumerable: true,
        configurable: true
    });
    Pagination.prototype.render = function () {
        var _this = this;
        var _a;
        if (this.props.isLoading && this.props.totalEntries <= 0) {
            return null;
        }
        return (React.createElement("div", { className: s.pagination },
            React.createElement("form", { onSubmit: this.handleGoToPage, className: classnames_1.default(s.goto, (_a = {},
                    _a[s.hidden] = this.pagination.length <= 1,
                    _a)) },
                React.createElement("p", null, "Change page:"),
                React.createElement("input", { onChange: this.handlePageChange, value: this.changePage, placeholder: this.currentPage.toString() }),
                React.createElement("button", null, "Go")),
            React.createElement("ul", { className: s.pages }, this.pagination.map(function (page) { return (React.createElement("li", { key: page },
                React.createElement("button", { onClick: _this.handlePageClick(page) }, ((page === '<' || page === '>') && (React.createElement("span", null, "..."))) ||
                    (page === _this.currentPage && (React.createElement("strong", null, page))) || React.createElement("em", null, page)))); }))));
    };
    __decorate([
        mobx_1.observable
    ], Pagination.prototype, "changePage", void 0);
    __decorate([
        mobx_1.computed
    ], Pagination.prototype, "pagesCount", null);
    __decorate([
        mobx_1.computed
    ], Pagination.prototype, "allPages", null);
    __decorate([
        mobx_1.computed
    ], Pagination.prototype, "currentPage", null);
    __decorate([
        mobx_1.computed
    ], Pagination.prototype, "pagination", null);
    Pagination = __decorate([
        mobx_react_1.observer
    ], Pagination);
    return Pagination;
}(React.Component));
exports.Pagination = Pagination;


/***/ }),

/***/ "./app/web/src/components/pricing/PendingPricingRequestsList.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/pricing/PendingPricingRequestsList.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./PendingPricingRequestsList.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./PendingPricingRequestsList.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/pricing/PendingPricingRequestsList.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var _1 = __webpack_require__("./app/web/src/components/pricing/index.ts");
// Styles
var s = __webpack_require__("./app/web/src/components/pricing/PendingPricingRequestsList.css");
// Component
var PendingPricingRequestsList = /** @class */ (function (_super) {
    __extends(PendingPricingRequestsList, _super);
    function PendingPricingRequestsList(props) {
        var _this = _super.call(this, props) || this;
        _this.openPricingRequest = function (request) {
            _this.props.store.pricingRequest.fetchSinglePricingRequest(request.id);
        };
        return _this;
    }
    PendingPricingRequestsList.prototype.render = function () {
        var _this = this;
        var pricingRequests = this.props.store.pricingRequest.pricingRequests;
        return (React.createElement("div", { className: s.list }, (pricingRequests.map(function (request, i) {
            return (React.createElement(_1.PricingRequestListItem, { key: 'request-' + request.id, onClick: _this.openPricingRequest, request: request }));
        }))));
    };
    PendingPricingRequestsList = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], PendingPricingRequestsList);
    return PendingPricingRequestsList;
}(React.Component));
exports.PendingPricingRequestsList = PendingPricingRequestsList;


/***/ }),

/***/ "./app/web/src/components/pricing/PricingRequestListItem.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/pricing/PricingRequestListItem.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./PricingRequestListItem.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./PricingRequestListItem.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/pricing/PricingRequestListItem.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var classNames = __webpack_require__("./node_modules/classnames/index.js");
// Styles
var s = __webpack_require__("./app/web/src/components/pricing/PricingRequestListItem.css");
var arrowIcon = __webpack_require__("./app/web/src/assets/grey arrow.svg");
var blueArrowIcon = __webpack_require__("./app/web/src/assets/blue arrow.svg");
// Component
var PricingRequestListItem = /** @class */ (function (_super) {
    __extends(PricingRequestListItem, _super);
    function PricingRequestListItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handlePricingRequestClick = function (e) {
            if (_this.props.onClick) {
                _this.props.onClick(_this.props.request);
            }
        };
        return _this;
    }
    Object.defineProperty(PricingRequestListItem, "defaultProps", {
        get: function () {
            return {
                className: null,
                showLeadAndAuthorName: true,
                onClick: null,
                request: null,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PricingRequestListItem.prototype, "leadDba", {
        get: function () {
            var request = this.props.request;
            return (typeof request.provider.dba !== 'undefined' && request.provider.dba)
                ? request.provider.dba : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PricingRequestListItem.prototype, "leadLegalBusName", {
        get: function () {
            var request = this.props.request;
            return (typeof request.provider.legalBusName !== 'undefined' && request.provider.legalBusName)
                ? request.provider.legalBusName : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PricingRequestListItem.prototype, "authorName", {
        get: function () {
            var request = this.props.request;
            return typeof request.createdByUser !== 'undefined' && typeof request.createdByUser.name !== 'undefined'
                ? request.createdByUser.name
                : typeof request.createdByUserId !== 'undefined'
                    ? request.createdByUserId.toString()
                    : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PricingRequestListItem.prototype, "createdAtDate", {
        get: function () {
            var request = this.props.request;
            return typeof request.createdAt !== 'undefined' && request.createdAt
                ? moment(request.createdAt).format('MMM Do, YYYY h:mm A')
                : '';
        },
        enumerable: true,
        configurable: true
    });
    PricingRequestListItem.prototype.render = function () {
        var request = this.props.request;
        return (React.createElement("div", { className: classNames(s.request, this.props.className), onClick: this.handlePricingRequestClick },
            (this.props.showLeadAndAuthorName) && (React.createElement("div", null,
                this.renderRequestId(),
                (typeof request.provider !== 'undefined' && request.provider) && (React.createElement("h4", { className: s.lead },
                    (this.leadDba) && (React.createElement("strong", null, this.leadDba)),
                    (this.leadLegalBusName && this.leadDba !== this.leadLegalBusName) && (React.createElement("em", null, this.leadLegalBusName)))) || (React.createElement("h4", { className: s.lead },
                    React.createElement("strong", null, request.providerId))))) || (React.createElement("div", null, this.renderRequestId())),
            (typeof request.note !== 'undefined' && request.note) && (React.createElement("p", { className: s.note }, request.note)),
            React.createElement("p", { className: s.author },
                (this.createdAtDate) && (React.createElement("span", null, this.createdAtDate)),
                (this.props.showLeadAndAuthorName && this.authorName && this.createdAtDate) && (React.createElement("img", { className: s.arrowIcon, src: arrowIcon })),
                (this.props.showLeadAndAuthorName && this.authorName) && (React.createElement("span", null, this.authorName))),
            React.createElement("img", { className: s.arrow, src: blueArrowIcon })));
    };
    PricingRequestListItem.prototype.renderRequestId = function () {
        return (React.createElement("h3", { className: s.id },
            React.createElement("span", null, "Request #"),
            React.createElement("strong", null, this.props.request.id)));
    };
    __decorate([
        mobx_1.computed
    ], PricingRequestListItem.prototype, "leadDba", null);
    __decorate([
        mobx_1.computed
    ], PricingRequestListItem.prototype, "leadLegalBusName", null);
    __decorate([
        mobx_1.computed
    ], PricingRequestListItem.prototype, "authorName", null);
    __decorate([
        mobx_1.computed
    ], PricingRequestListItem.prototype, "createdAtDate", null);
    PricingRequestListItem = __decorate([
        mobx_react_1.observer
    ], PricingRequestListItem);
    return PricingRequestListItem;
}(React.Component));
exports.PricingRequestListItem = PricingRequestListItem;


/***/ }),

/***/ "./app/web/src/components/pricing/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/components/pricing/PendingPricingRequestsList.tsx"));
__export(__webpack_require__("./app/web/src/components/pricing/PricingRequestListItem.tsx"));


/***/ }),

/***/ "./app/web/src/components/reminder/ReminderContent.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/reminder/ReminderContent.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./ReminderContent.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./ReminderContent.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/reminder/ReminderContent.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var React = __webpack_require__("./node_modules/react/react.js");
var react_transition_group_1 = __webpack_require__("./node_modules/react-transition-group/index.js");
var index_1 = __webpack_require__("./app/web/src/components/list/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/components/reminder/ReminderContent.css");
var cancelIcon = __webpack_require__("./app/web/src/assets/close orange icon.svg");
// Component
var ReminderContent = /** @class */ (function (_super) {
    __extends(ReminderContent, _super);
    function ReminderContent(props) {
        var _this = _super.call(this, props) || this;
        _this.show = false;
        _this.showSnoozeOptions = false;
        _this.showDismissConfirmation = false;
        _this.reminderDropdown = null;
        _this.referenceReminderDropdown = function (ref) { return (_this.reminderDropdown = ref); };
        _this.handleDismissValidation = function () {
            _this.showDismissConfirmation = true;
        };
        _this.handleDismissCancellation = function () {
            _this.showDismissConfirmation = false;
        };
        _this.handleReminderDismissal = function () {
            _this.showDismissConfirmation = false;
            if (_this.props.onDismissReminder) {
                _this.props.onDismissReminder(_this.props.activity.id);
            }
        };
        _this.handleNavigateToLead = function () {
            if (_this.props.onGoToLeadClick) {
                _this.props.onGoToLeadClick(_this.props.activity.providerId);
            }
        };
        _this.handleMarkAsComplete = function () {
            _this.props.onMarkAsComplete(_this.props.activity.id);
        };
        _this.handleToggleSnooze = function () {
            var next = !_this.showSnoozeOptions;
            _this.showSnoozeOptions = next;
            setTimeout(function () {
                if (_this.reminderDropdown) {
                    if (next === true) {
                        _this.reminderDropdown.openDropdown();
                        _this.props.onSnoozeOptionsDropdownOpen(_this.props.activity.id);
                    }
                    else {
                        _this.reminderDropdown.closeDropdown();
                    }
                }
            }, 128);
        };
        _this.handleSnooze = function (remindInMinutes) {
            if (remindInMinutes === null) {
                _this.handleToggleSnooze();
                return;
            }
            _this.props.onSnoozeOptionSelected(_this.props.activity.id, remindInMinutes);
        };
        setTimeout(function () {
            _this.show = true;
        }, 256);
        return _this;
    }
    Object.defineProperty(ReminderContent.prototype, "remindMeLaterOptions", {
        get: function () {
            return [
                {
                    value: null,
                    label: 'Cancel',
                },
                {
                    value: 3,
                    label: 'Remind me in 3 minutes',
                },
                {
                    value: 5,
                    label: 'Remind me in 5 minutes',
                },
                {
                    value: 10,
                    label: 'Remind me in 10 minutes',
                },
                {
                    value: 15,
                    label: 'Remind me in 15 minutes',
                },
                {
                    value: 30,
                    label: 'Remind me in 30 minutes',
                },
                {
                    value: 45,
                    label: 'Remind me in 45 minutes',
                },
                {
                    value: 60,
                    label: 'Remind me in 1 hour',
                },
                {
                    value: 120,
                    label: 'Remind me in 2 hours',
                },
                {
                    value: 180,
                    label: 'Remind me in 3 hours',
                },
                {
                    value: 720,
                    label: 'Remind me in 12 hours',
                },
                {
                    value: 1440,
                    label: 'Remind me in 24 hours',
                },
                {
                    value: 10080,
                    label: 'Remind me in 1 week',
                },
                {
                    value: 20160,
                    label: 'Remind me in 2 weeks',
                },
                {
                    value: 43200,
                    label: 'Remind me in 1 month',
                },
                {
                    value: 86400,
                    label: 'Remind me in 2 months',
                },
            ];
        },
        enumerable: true,
        configurable: true
    });
    ReminderContent.prototype.render = function () {
        var _a, _b;
        var activity = this.props.activity;
        return (React.createElement("div", { className: classNames(s.reminder, (_a = {},
                _a[s.show] = this.show,
                _a)), style: {
                zIndex: this.props.zIndex,
            } },
            React.createElement("div", { className: s.content },
                React.createElement("div", { className: s.activity },
                    React.createElement("p", { className: s.time },
                        React.createElement("strong", null, moment(activity.activityTime).format('dddd, MMM, Do - hh:mm')),
                        React.createElement("span", null, moment(activity.activityTime).format('A'))),
                    React.createElement("h3", { className: s.title }, activity.activityType !== null &&
                        typeof activity.activityType.name !== 'undefined'
                        ? activity.activityType.name
                        : activity.activityTypeId),
                    activity.note && (React.createElement("p", { className: s.note }, activity.note)),
                    React.createElement("h5", { className: s.lead },
                        activity.provider &&
                            typeof activity.provider.dba !== 'undefined' &&
                            activity.provider.dba && (React.createElement("strong", null, activity.provider.dba)),
                        activity.provider &&
                            typeof activity.provider.legalBusName !==
                                'undefined' &&
                            activity.provider.legalBusName && (React.createElement("em", null, activity.provider.legalBusName)),
                        activity.providerId !== null &&
                            this.props.onGoToLeadClick !== null && (React.createElement("button", { onClick: this.handleNavigateToLead }, "Go to lead")))),
                React.createElement("div", { className: s.actions },
                    this.showSnoozeOptions === false && (React.createElement("div", { className: s.quickActions },
                        React.createElement("button", { className: "boxButton boxButtonWhite", onClick: this.handleToggleSnooze }, "Remind me later"),
                        React.createElement("button", { className: "boxButton boxButtonWhiteSuccess", onClick: this.handleMarkAsComplete }, "Mark as complete"))),
                    React.createElement("div", { className: classNames(s.snoozeActions, (_b = {},
                            _b[s.show] = this.showSnoozeOptions,
                            _b)) },
                        React.createElement(index_1.DropdownContainer, { ref: this.referenceReminderDropdown, label: "Snooze and remind me later in..." },
                            React.createElement(index_1.OptionsList, { value: "none", label: "Snooze reminder", onChangeOnlyValue: this.handleSnooze, options: this.remindMeLaterOptions })))),
                React.createElement(action_1.IconButton, { className: s.dismiss, onClick: this.handleDismissValidation, icon: cancelIcon, label: "Dismiss", labelOnRight: false })),
            React.createElement(react_transition_group_1.CSSTransitionGroup, { component: "div", transitionName: "dismissal-transition", transitionAppear: true, transitionEnter: true, transitionLeave: true, transitionAppearTimeout: 500, transitionEnterTimeout: 500, transitionLeaveTimeout: 300 }, this.showDismissConfirmation && (React.createElement("div", { className: s.dismissConfirmation },
                React.createElement("p", { className: s.dismissLabel }, "Are you sure?"),
                React.createElement("div", { className: s.dismissContent },
                    React.createElement("p", null, "Reminder for this activity will be disabled."),
                    React.createElement("button", { className: classNames('boxButton', 'boxButtonImportant'), onClick: this.handleReminderDismissal }, "Yes, dismiss reminder"),
                    React.createElement("button", { className: s.dismissCancelButton, onClick: this.handleDismissCancellation }, "No, keep the reminder")))))));
    };
    __decorate([
        mobx_1.observable
    ], ReminderContent.prototype, "show", void 0);
    __decorate([
        mobx_1.observable
    ], ReminderContent.prototype, "showSnoozeOptions", void 0);
    __decorate([
        mobx_1.observable
    ], ReminderContent.prototype, "showDismissConfirmation", void 0);
    __decorate([
        mobx_1.computed
    ], ReminderContent.prototype, "remindMeLaterOptions", null);
    __decorate([
        mobx_1.action
    ], ReminderContent.prototype, "handleDismissValidation", void 0);
    __decorate([
        mobx_1.action
    ], ReminderContent.prototype, "handleDismissCancellation", void 0);
    __decorate([
        mobx_1.action
    ], ReminderContent.prototype, "handleReminderDismissal", void 0);
    ReminderContent = __decorate([
        mobx_react_1.observer
    ], ReminderContent);
    return ReminderContent;
}(React.Component));
exports.ReminderContent = ReminderContent;


/***/ }),

/***/ "./app/web/src/components/reminder/RemindersAlert.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/reminder/RemindersAlert.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./RemindersAlert.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./RemindersAlert.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/reminder/RemindersAlert.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __webpack_require__("./node_modules/classnames/index.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var react_transition_group_1 = __webpack_require__("./node_modules/react-transition-group/index.js");
// Styles
var s = __webpack_require__("./app/web/src/components/reminder/RemindersAlert.css");
var noteIcon = __webpack_require__("./app/web/src/assets/note.svg");
var closeIcon = __webpack_require__("./app/web/src/assets/close blue icon.svg");
// Component
var RemindersAlert = /** @class */ (function (_super) {
    __extends(RemindersAlert, _super);
    function RemindersAlert() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showReminders = function (e) {
            var toShowNext = !_this.props.store.activities.showRemindersCenter;
            if (toShowNext) {
                _this.props.store.activities.openActivitiesReminders();
            }
            else {
                _this.props.store.activities.closeActivitiesReminders();
            }
        };
        return _this;
    }
    Object.defineProperty(RemindersAlert.prototype, "remindersCount", {
        get: function () {
            return this.props.store.activities.activitiesToRemindAbout.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RemindersAlert.prototype, "hasPendingReminders", {
        get: function () {
            return this.remindersCount > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RemindersAlert.prototype, "remindersAreOpen", {
        get: function () {
            return this.props.store.activities.showRemindersCenter;
        },
        enumerable: true,
        configurable: true
    });
    RemindersAlert.prototype.render = function () {
        var _a;
        return (React.createElement(react_transition_group_1.CSSTransitionGroup, { className: s.container, component: "div", transitionName: "show", transitionAppear: true, transitionEnter: true, transitionLeave: true, transitionAppearTimeout: 800, transitionEnterTimeout: 800, transitionLeaveTimeout: 300 }, (this.hasPendingReminders || this.remindersAreOpen) && (React.createElement("button", { className: classnames_1.default(s.alert, (_a = {},
                _a[s.isOpen] = this.remindersAreOpen,
                _a)), onClick: this.showReminders },
            React.createElement("p", null, this.remindersCount > 99
                ? '99+'
                : this.remindersCount),
            React.createElement("img", { className: s.noteIcon, src: noteIcon, alt: "" }),
            React.createElement("img", { className: s.closeIcon, src: closeIcon, alt: "" })))));
    };
    __decorate([
        mobx_1.computed
    ], RemindersAlert.prototype, "remindersCount", null);
    __decorate([
        mobx_1.computed
    ], RemindersAlert.prototype, "hasPendingReminders", null);
    __decorate([
        mobx_1.computed
    ], RemindersAlert.prototype, "remindersAreOpen", null);
    __decorate([
        mobx_1.action
    ], RemindersAlert.prototype, "showReminders", void 0);
    RemindersAlert = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], RemindersAlert);
    return RemindersAlert;
}(React.Component));
exports.RemindersAlert = RemindersAlert;


/***/ }),

/***/ "./app/web/src/components/reminder/RemindersCenter.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/reminder/RemindersCenter.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./RemindersCenter.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./RemindersCenter.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/reminder/RemindersCenter.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__("./app/web/src/components/reminder/index.tsx");
var classnames_1 = __webpack_require__("./node_modules/classnames/index.js");
var scroll_1 = __webpack_require__("./app/web/src/events/scroll.ts");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/components/reminder/RemindersCenter.css");
// Component
var RemindersCenter = /** @class */ (function (_super) {
    __extends(RemindersCenter, _super);
    function RemindersCenter(props) {
        var _this = _super.call(this, props) || this;
        _this.container = null;
        _this.activeZIndex = 2;
        _this.activeId = null;
        _this.referenceContainer = function (ref) {
            return (_this.container = ref);
        };
        _this.handleSnoozeOptionsDropdownOpen = function (activityId) {
            _this.activeZIndex++;
            _this.activeId = activityId;
        };
        _this.handleContainerClick = function (e) {
            _this.props.store.activities.closeActivitiesReminders();
        };
        _this.handleCenterClick = function (e) {
            e.stopPropagation();
        };
        _this.handleLeadClick = function (leadId) {
            if (_this.props.store.lead.openLeadId === leadId) {
                scroll_1.scrollWindow.toY(0);
            }
            else {
                _this.props.store.lead.handleLeadSelect(leadId);
            }
        };
        _this.handleReminderDismiss = function (activityId) {
            _this.props.store.activities.disableActivityReminder(activityId);
        };
        _this.handleReminderMarkAsComplete = function (activityId) {
            _this.props.store.activities.markActivityAsComplete(activityId);
        };
        _this.handleSnoozeOptionSelected = function (activityId, remindInMinutes) {
            _this.props.store.activities.delayActivityReminder(activityId, remindInMinutes);
        };
        // Scroll to the bottom of the container when reminders center opens
        mobx_1.reaction(function () { return _this.props.store.activities.showRemindersCenter; }, function (show) {
            if (show && _this.container) {
                _this.container.scrollTop = 99999;
            }
        });
        return _this;
    }
    RemindersCenter.prototype.render = function () {
        var _this = this;
        var _a;
        var activities = this.props.store.activities;
        return (React.createElement("div", { ref: this.referenceContainer, className: classnames_1.default(s.container, (_a = {},
                _a[s.show] = activities.showRemindersCenter,
                _a)), onClick: activities.showRemindersCenter
                ? this.handleContainerClick
                : undefined },
            React.createElement("div", { className: s.center, onClick: this.handleCenterClick },
                activities.activitiesToRemindAbout.length <= 0 && (React.createElement("div", { className: s.noReminders },
                    React.createElement("p", null, "No reminders are currently pending."))),
                activities.activitiesToRemindAbout.map(function (activity, i) { return (React.createElement(_1.ReminderContent, { key: activity.id, activity: activity, zIndex: _this.activeId === activity.id
                        ? _this.activeZIndex
                        : 1, onSnoozeOptionsDropdownOpen: _this.handleSnoozeOptionsDropdownOpen, onSnoozeOptionSelected: _this.handleSnoozeOptionSelected, onGoToLeadClick: _this.handleLeadClick, onDismissReminder: _this.handleReminderDismiss, onMarkAsComplete: _this.handleReminderMarkAsComplete })); }))));
    };
    __decorate([
        mobx_1.observable
    ], RemindersCenter.prototype, "activeZIndex", void 0);
    __decorate([
        mobx_1.observable
    ], RemindersCenter.prototype, "activeId", void 0);
    __decorate([
        mobx_1.action
    ], RemindersCenter.prototype, "handleSnoozeOptionsDropdownOpen", void 0);
    RemindersCenter = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], RemindersCenter);
    return RemindersCenter;
}(React.Component));
exports.RemindersCenter = RemindersCenter;


/***/ }),

/***/ "./app/web/src/components/reminder/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/components/reminder/RemindersAlert.tsx"));
__export(__webpack_require__("./app/web/src/components/reminder/RemindersCenter.tsx"));
__export(__webpack_require__("./app/web/src/components/reminder/ReminderContent.tsx"));


/***/ }),

/***/ "./app/web/src/components/route/private/PrivateRoute.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var react_router_1 = __webpack_require__("./node_modules/react-router/es/index.js");
var PageForbidden_1 = __webpack_require__("./app/web/src/routes/errors/PageForbidden/PageForbidden.tsx");
// Component
var PrivateRoute = /** @class */ (function (_super) {
    __extends(PrivateRoute, _super);
    function PrivateRoute(props) {
        var _this = _super.call(this, props) || this;
        _this.validateRoute = function (props) {
            var _a = _this.props, store = _a.store, component = _a.component, authorizedUserTypes = _a.authorizedUserTypes;
            if (store.user.isLoggedIn && typeof component !== 'undefined') {
                return React.createElement(component, props);
            }
            else {
                return React.createElement(PageForbidden_1.PageForbidden, { user: _this.props.store.user, history: props.history, location: props.location });
            }
        };
        return _this;
    }
    PrivateRoute.prototype.render = function () {
        // Prepare props
        var _a = this.props, deleted = _a["store"], newProps = __rest(_a, ['store']);
        // Render
        return (React.createElement(react_router_1.Route, __assign({}, newProps, { component: null, render: this.validateRoute })));
    };
    PrivateRoute = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], PrivateRoute);
    return PrivateRoute;
}(React.Component));
exports.PrivateRoute = PrivateRoute;
exports.default = PrivateRoute;


/***/ }),

/***/ "./app/web/src/components/state/State.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/state/State.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./State.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./State.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/state/State.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __webpack_require__("./app/common/interfaces/state.ts");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var StateRepsList_1 = __webpack_require__("./app/web/src/components/state/StateRepsList.tsx");
var state_2 = __webpack_require__("./app/web/src/components/state/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/components/state/State.css");
var backArrow = __webpack_require__("./app/web/src/assets/back icon.svg");
// Component
var State = /** @class */ (function (_super) {
    __extends(State, _super);
    function State() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderRepsSearchBar = function () {
            return (React.createElement(action_1.Search, { classNameForField: s.repsSearchField, onValueChange: _this.handleRepsSearchChange, placeholder: "Search sales reps by name...", value: _this.props.store.state.repsSearch, isValueClearable: true }));
        };
        _this.handleRepsSearchChange = function (value) {
            _this.props.store.state.repsSearch = value;
        };
        _this.renderStatesSearchBar = function () {
            return (React.createElement(action_1.Search, { classNameForField: s.statesSearchField, onValueChange: _this.handleStateSearchChange, placeholder: "Search state...", value: _this.props.store.state.statesListSearch, isValueClearable: true }));
        };
        _this.handleStateSearchChange = function (value) {
            _this.props.store.state.statesListSearch = value;
        };
        _this.renderAreasBar = function () {
            var areasFilterTypeKeys = Object.keys(state_1.AreasFilterType);
            return (React.createElement("select", { className: s.statesSearchBar, value: _this.props.store.state.stateAreasSearch, onChange: _this.handleStateAreasFilterChange }, areasFilterTypeKeys.map(function (areaFilter, areaFilterIndex) {
                return (React.createElement("option", { key: areaFilter, value: state_1.AreasFilterType[areaFilter] }, state_1.AreasFilterType[areaFilter]));
            })));
        };
        _this.handleStateAreasFilterChange = function (e) {
            _this.props.store.state.stateAreasSearch = e.currentTarget
                .value;
        };
        _this.handleGoingBack = function () {
            var modalStatus = _this.props.store.state.modalStatus;
            _this.props.store.state.modalStatus =
                modalStatus === state_1.StateModalStatus.OpenOnSpecificArea
                    ? state_1.StateModalStatus.OpenOnStatesList
                    : state_1.StateModalStatus.OpenOnRepAreasList;
        };
        _this.closeModal = function () {
            _this.props.store.state.modalStatus = state_1.StateModalStatus.Closed;
        };
        return _this;
    }
    State.prototype.render = function () {
        // Destructure
        var state = this.props.store.state;
        // Render
        return (React.createElement(content_1.Modal, { onModalClose: this.closeModal, closeModalOnBackgroundClick: false, show: state.modalStatus !== state_1.StateModalStatus.Closed, title: state.modalStatus === state_1.StateModalStatus.OpenOnRepAreasList
                ? 'Sales reps areas'
                : state.modalStatus ===
                    state_1.StateModalStatus.OpenOnSpecificRepArea
                    ? 'Sales rep areas'
                    : 'Assign sales reps to leads', titleBarContent: state.modalStatus === state_1.StateModalStatus.OpenOnRepAreasList
                ? this.renderRepsSearchBar()
                : state.modalStatus ===
                    state_1.StateModalStatus.OpenOnSpecificArea
                    ? this.renderAreasBar()
                    : state.modalStatus ===
                        state_1.StateModalStatus.OpenOnStatesList
                        ? this.renderStatesSearchBar()
                        : null, titleBarIcons: state.modalStatus === state_1.StateModalStatus.OpenOnRepAreasList
                ? undefined
                : [
                    {
                        key: 'back-arrow',
                        label: state.modalStatus ===
                            state_1.StateModalStatus.OpenOnSpecificArea
                            ? 'Back to states list'
                            : 'Back',
                        showLabel: true,
                        icon: backArrow,
                        className: s.backArrow,
                        iconClassName: s.backArrowIcon,
                        onClick: this.handleGoingBack,
                    },
                ] },
            React.createElement("div", { className: s.state }, state.modalStatus ===
                state_1.StateModalStatus.OpenOnRepAreasList ? (React.createElement(StateRepsList_1.StateRepsList, null)) : state.modalStatus ===
                state_1.StateModalStatus.OpenOnSpecificRepArea ? (React.createElement(state_2.StateRepAssignedAreas, null)) : state.modalStatus ===
                state_1.StateModalStatus.OpenOnSpecificArea ? (React.createElement(state_2.StateAreaList, null)) : (React.createElement(state_2.StateList, null)))));
    };
    __decorate([
        mobx_1.action
    ], State.prototype, "handleRepsSearchChange", void 0);
    __decorate([
        mobx_1.action
    ], State.prototype, "handleStateAreasFilterChange", void 0);
    __decorate([
        mobx_1.action
    ], State.prototype, "handleGoingBack", void 0);
    __decorate([
        mobx_1.action
    ], State.prototype, "closeModal", void 0);
    State = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], State);
    return State;
}(React.Component));
exports.State = State;


/***/ }),

/***/ "./app/web/src/components/state/StateArea.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/state/StateArea.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./StateArea.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./StateArea.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/state/StateArea.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/components/state/StateArea.css");
var whiteTickIcon = __webpack_require__("./app/web/src/assets/tick white.svg");
// Component
var StateArea = /** @class */ (function (_super) {
    __extends(StateArea, _super);
    function StateArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setUserToArea = function (checked, value) {
            if (_this.props.onToggle) {
                _this.props.onToggle(_this.props.area.areaCode);
            }
        };
        return _this;
    }
    Object.defineProperty(StateArea, "defaultProps", {
        get: function () {
            return {
                onToggle: null,
                className: null,
                area: null,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateArea.prototype, "areaReps", {
        get: function () {
            return this.props.area && this.props.area.assignedTo
                ? this.props.area.assignedTo
                : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateArea.prototype, "primaryRep", {
        get: function () {
            var primaryRepIndex = -1;
            this.areaReps.some(function (rep, repIndex) {
                if (rep.primary === 1) {
                    primaryRepIndex = repIndex;
                    return true;
                }
            });
            return primaryRepIndex !== -1 ? this.areaReps[primaryRepIndex] : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateArea.prototype, "secondaryRep", {
        get: function () {
            var secondaryRepIndex = -1;
            this.areaReps.some(function (rep, repIndex) {
                if (rep.primary === 0) {
                    secondaryRepIndex = repIndex;
                    return true;
                }
            });
            return secondaryRepIndex !== -1
                ? this.areaReps[secondaryRepIndex]
                : null;
        },
        enumerable: true,
        configurable: true
    });
    StateArea.prototype.render = function () {
        // Destructure
        var area = this.props.area;
        // Render
        return (React.createElement("div", { className: classNames(s.stateArea, this.props.className) },
            React.createElement("div", null,
                React.createElement("p", null,
                    React.createElement("strong", null, area.areaCode))),
            React.createElement("div", null,
                React.createElement("p", null, area.providersInAreaCode || '')),
            React.createElement("div", null,
                React.createElement("p", null, this.primaryRep ? (React.createElement("span", null, this.primaryRep.name)) : (React.createElement("em", null, "Unassigned")))),
            React.createElement("div", null,
                React.createElement("p", null, this.secondaryRep ? (React.createElement("span", null, this.secondaryRep.name)) : (React.createElement("em", null, "Unassigned")))),
            React.createElement("div", null,
                React.createElement(action_1.Checkbox, { onChange: this.setUserToArea, checked: area.checked, value: area.areaCode, align: "right" }))));
    };
    __decorate([
        mobx_1.computed
    ], StateArea.prototype, "areaReps", null);
    __decorate([
        mobx_1.computed
    ], StateArea.prototype, "primaryRep", null);
    __decorate([
        mobx_1.computed
    ], StateArea.prototype, "secondaryRep", null);
    StateArea = __decorate([
        mobx_react_1.observer
    ], StateArea);
    return StateArea;
}(React.Component));
exports.StateArea = StateArea;


/***/ }),

/***/ "./app/web/src/components/state/StateAreaList.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/state/StateAreaList.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./StateAreaList.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./StateAreaList.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/state/StateAreaList.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__("./app/web/src/components/state/index.tsx");
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/components/state/StateAreaList.css");
// Component
var StateAreaList = /** @class */ (function (_super) {
    __extends(StateAreaList, _super);
    function StateAreaList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleToggleArea = function (areaCode) {
            _this.props.store.state.toggleAreaCheckbox(areaCode);
        };
        _this.handleToggleAll = function (check) { return function (checked, value) {
            _this.props.store.state.toggleAllAreaCheckboxes(check);
        }; };
        return _this;
    }
    Object.defineProperty(StateAreaList.prototype, "areAllSelected", {
        get: function () {
            var state = this.props.store.state;
            return (state.areasSearchedResults.length > 0 &&
                state.areasSearchedResults.length ===
                    state.checkedAreasSearchedResultsLength);
        },
        enumerable: true,
        configurable: true
    });
    StateAreaList.prototype.render = function () {
        var _this = this;
        // Destructure
        var state = this.props.store.state;
        // Render
        return (React.createElement("div", { className: s.container },
            React.createElement("h2", { className: s.stateName }, state.selectedState.name || state.selectedState.id),
            React.createElement("div", { className: s.header },
                React.createElement("div", { className: s.row },
                    React.createElement("div", null, "Area codes"),
                    React.createElement("div", null, "Leads count"),
                    React.createElement("div", null, "Primary rep"),
                    React.createElement("div", null, "Secondary rep"),
                    React.createElement("div", { className: s.selectCol }, state.areasSearchedResults.length > 0 && (React.createElement(action_1.Checkbox, { onChange: this.handleToggleAll(this.areAllSelected ? false : true), className: s.selectAll, label: this.areAllSelected
                            ? 'Deselect all'
                            : 'Select all', labelOnLeft: true, align: "right", value: "toggleall", checked: this.areAllSelected }))))),
            (state.selectedStateIsLoading && (React.createElement("div", { className: s.loading },
                React.createElement(indicator_1.LoadingSpinner, { active: true })))) ||
                (state.areasSearchedResults.length > 0 && (React.createElement("div", { className: s.items }, state.areasSearchedResults.map(function (area, i) { return (React.createElement(_1.StateArea, { key: area.areaCode, onToggle: _this.handleToggleArea, className: s.row, area: area })); })))) || (React.createElement("div", { className: classNames(s.items, s.empty) },
                React.createElement("p", null, "No areas found for this state matching criteria.")))));
    };
    __decorate([
        mobx_1.computed
    ], StateAreaList.prototype, "areAllSelected", null);
    StateAreaList = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], StateAreaList);
    return StateAreaList;
}(React.Component));
exports.StateAreaList = StateAreaList;


/***/ }),

/***/ "./app/web/src/components/state/StateAreaListPicker.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/state/StateAreaListPicker.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./StateAreaListPicker.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./StateAreaListPicker.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/state/StateAreaListPicker.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var state_1 = __webpack_require__("./app/common/interfaces/state.ts");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/components/state/StateAreaListPicker.css");
// Component
var StateAreaListPicker = /** @class */ (function (_super) {
    __extends(StateAreaListPicker, _super);
    function StateAreaListPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.noOneOptionValue = '0/0';
        _this.noOneOptionLabel = 'No one';
        _this.selectedAreaRole = null;
        _this.selectedUser = {
            value: null,
            id: null,
            name: null,
            slpcode: null,
        };
        _this.handleUserChange = function (e) {
            var val = e.currentTarget.value;
            var split = val.split('/');
            if (split.length >= 2) {
                var userId = parseInt(split[0], 10);
                var userSlpcode = parseInt(split[1], 10);
                var userName_1 = '';
                _this.usersOptions.some(function (user, i) {
                    if (user.value === val) {
                        userName_1 = user.label;
                        return true;
                    }
                });
                if (val === _this.noOneOptionValue) {
                    userName_1 = _this.noOneOptionLabel;
                }
                _this.selectedUser.value = val;
                _this.selectedUser.id = userId;
                _this.selectedUser.slpcode = userSlpcode;
                _this.selectedUser.name = userName_1;
                _this.selectedAreaRole = null;
            }
        };
        _this.handleRoleChange = function (e) {
            var val = e.currentTarget.value;
            if (val !== 'label') {
                _this.selectedAreaRole = val;
                if (_this.selectedUser.id !== null) {
                    _this.submit();
                }
            }
        };
        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.submit();
        };
        _this.submit = function () { return __awaiter(_this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.selectedUser.id !== null &&
                            this.selectedUser.slpcode !== null &&
                            this.selectedAreaRole &&
                            this.props.store.state.assignUser.status !== state_1.AssignUserStatus.Saving)) return [3 /*break*/, 10];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 9, , 10]);
                        if (!(this.selectedAreaRole === 'both')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.props.store.state.assignUserToCheckedAreas(this.selectedUser.id, this.selectedUser.slpcode, this.selectedUser.name, true)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.props.store.state.assignUserToCheckedAreas(this.selectedUser.id, this.selectedUser.slpcode, this.selectedUser.name, false)];
                    case 3:
                        _a.sent();
                        this.clear();
                        return [2 /*return*/];
                    case 4:
                        if (!(this.selectedAreaRole === 'sole')) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.props.store.state.assignUserToCheckedAreas(this.selectedUser.id, this.selectedUser.slpcode, this.selectedUser.name, true)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, this.props.store.state.assignUserToCheckedAreas(0, 0, this.noOneOptionLabel, false)];
                    case 6:
                        _a.sent();
                        this.clear();
                        return [2 /*return*/];
                    case 7: return [4 /*yield*/, this.props.store.state.assignUserToCheckedAreas(this.selectedUser.id, this.selectedUser.slpcode, this.selectedUser.name, this.selectedAreaRole === 'primary' ? true : false)];
                    case 8:
                        _a.sent();
                        this.clear();
                        return [3 /*break*/, 10];
                    case 9:
                        err_1 = _a.sent();
                        return [2 /*return*/, null];
                    case 10: return [2 /*return*/];
                }
            });
        }); };
        _this.clear = function () {
            _this.selectedUser.value = null;
            _this.selectedUser.id = null;
            _this.selectedUser.slpcode = null;
            _this.selectedUser.name = null;
            _this.selectedAreaRole = null;
            _this.props.store.state.toggleAllAreaCheckboxes(false);
        };
        return _this;
    }
    Object.defineProperty(StateAreaListPicker.prototype, "usersOptions", {
        get: function () {
            var checkedAreasSearchedResultsLength = this.props.store.state.checkedAreasSearchedResultsLength;
            return [
                {
                    value: 'label',
                    label: 'Assign selected area' +
                        (checkedAreasSearchedResultsLength > 1 ? 's' : '') +
                        ' to',
                }
            ].concat(mobx_1.toJS(this.props.store.users.allActiveSalesUsers.filter(function (user) {
                return typeof user.id !== 'undefined' &&
                    typeof user.slpcode !== 'undefined' &&
                    user.slpcode !== null;
            })).map(function (user) { return ({
                value: user.id.toString() + '/' + user.slpcode.toString(),
                label: user.name,
            }); }), [
                {
                    value: this.noOneOptionValue,
                    label: this.noOneOptionLabel,
                },
            ]);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateAreaListPicker.prototype, "areaRolesOptions", {
        get: function () {
            if (this.selectedUser.id === 0) {
                return [
                    {
                        value: 'label',
                        label: 'Select user to clear',
                    },
                    {
                        value: 'primary',
                        label: 'Clear primary sales rep',
                    },
                    {
                        value: 'secondary',
                        label: 'Clear secondary sales rep',
                    },
                    {
                        value: 'both',
                        label: 'Clear both sales reps',
                    },
                ];
            }
            return [
                {
                    value: 'label',
                    label: 'Select user role',
                },
                {
                    value: 'primary',
                    label: 'Set as primary sales rep',
                },
                {
                    value: 'secondary',
                    label: 'Set as secondary sales rep',
                },
                {
                    value: 'sole',
                    label: 'Set as only rep for the area (primary)',
                },
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateAreaListPicker.prototype, "showBottomBar", {
        get: function () {
            var state = this.props.store.state;
            return (state.checkedAreasSearchedResultsLength > 0 ||
                state.assignUser.status !== state_1.AssignUserStatus.None);
        },
        enumerable: true,
        configurable: true
    });
    StateAreaListPicker.prototype.render = function () {
        var _a = this.props.store.state, modalStatus = _a.modalStatus, assignUser = _a.assignUser;
        if (modalStatus !== state_1.StateModalStatus.OpenOnSpecificArea) {
            return null;
        }
        return (React.createElement(content_1.ModalBottomBar, { show: this.showBottomBar, classNameForContent: s.container },
            React.createElement("div", null,
                React.createElement("select", { value: this.selectedUser.value || 'label', onChange: this.handleUserChange }, this.usersOptions.map(function (option, i) { return (React.createElement("option", { key: option.value, value: option.value }, option.label)); }))),
            React.createElement("div", null,
                React.createElement("select", { value: this.selectedAreaRole || 'label', onChange: this.handleRoleChange }, this.areaRolesOptions.map(function (option, i) { return (React.createElement("option", { key: option.value, value: option.value }, option.label)); }))),
            React.createElement("div", { className: s.status }, (assignUser.status === state_1.AssignUserStatus.Error && (React.createElement("p", { className: s.error }, 'Could not change sales rep assigned to selected area(s), please try again'))) || (React.createElement(indicator_1.SavingIndicator, { labels: {
                    saving: 'Assigning sales rep...',
                    error: 'Could not assign rep, please try again',
                    success: 'Assigned rep to customers',
                }, status: assignUser.status === state_1.AssignUserStatus.Saving
                    ? indicator_1.SavingIndicatorStatus.Saving
                    : assignUser.status ===
                        state_1.AssignUserStatus.Error
                        ? indicator_1.SavingIndicatorStatus.Error
                        : assignUser.status ===
                            state_1.AssignUserStatus.Success
                            ? indicator_1.SavingIndicatorStatus.Success
                            : indicator_1.SavingIndicatorStatus.None })))));
    };
    __decorate([
        mobx_1.observable
    ], StateAreaListPicker.prototype, "selectedAreaRole", void 0);
    __decorate([
        mobx_1.observable
    ], StateAreaListPicker.prototype, "selectedUser", void 0);
    __decorate([
        mobx_1.computed
    ], StateAreaListPicker.prototype, "usersOptions", null);
    __decorate([
        mobx_1.computed
    ], StateAreaListPicker.prototype, "areaRolesOptions", null);
    __decorate([
        mobx_1.computed
    ], StateAreaListPicker.prototype, "showBottomBar", null);
    __decorate([
        mobx_1.action
    ], StateAreaListPicker.prototype, "handleUserChange", void 0);
    __decorate([
        mobx_1.action
    ], StateAreaListPicker.prototype, "handleRoleChange", void 0);
    __decorate([
        mobx_1.action
    ], StateAreaListPicker.prototype, "clear", void 0);
    StateAreaListPicker = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], StateAreaListPicker);
    return StateAreaListPicker;
}(React.Component));
exports.StateAreaListPicker = StateAreaListPicker;


/***/ }),

/***/ "./app/web/src/components/state/StateItem.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/state/StateItem.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./StateItem.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./StateItem.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/state/StateItem.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/components/state/StateItem.css");
var arrow = __webpack_require__("./app/web/src/assets/blue arrow.svg");
// Component
var StateItem = /** @class */ (function (_super) {
    __extends(StateItem, _super);
    function StateItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleStateClick = function (e) {
            if (_this.props.onClick &&
                (_this.props.state.leadsCount === null ||
                    _this.props.state.leadsCount > 0)) {
                _this.props.onClick(_this.props.state.id, _this.props.state.name);
            }
        };
        return _this;
    }
    Object.defineProperty(StateItem, "defaultProps", {
        get: function () {
            return {
                onClick: null,
                state: null,
            };
        },
        enumerable: true,
        configurable: true
    });
    StateItem.prototype.render = function () {
        // Destructure
        var state = this.props.state;
        // Render
        return (React.createElement("div", { className: s.stateListItem },
            React.createElement(action_1.CardButton, { className: s.stateListButton, onClick: this.handleStateClick },
                React.createElement("p", { className: s.stateName },
                    state.id && React.createElement("strong", null, state.id),
                    state.name && React.createElement("span", null, state.name)),
                state.leadsCount !== null && (React.createElement("p", { className: s.stateLeadsCount },
                    React.createElement("strong", null, state.leadsCount),
                    React.createElement("em", null, " lead" + (state.leadsCount > 0 ? 's' : '')))))));
    };
    StateItem = __decorate([
        mobx_react_1.observer
    ], StateItem);
    return StateItem;
}(React.Component));
exports.StateItem = StateItem;


/***/ }),

/***/ "./app/web/src/components/state/StateList.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/state/StateList.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./StateList.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./StateList.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/state/StateList.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var state_1 = __webpack_require__("./app/common/interfaces/state.ts");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var StateItem_1 = __webpack_require__("./app/web/src/components/state/StateItem.tsx");
// Styles
var s = __webpack_require__("./app/web/src/components/state/StateList.css");
// Component
var StateList = /** @class */ (function (_super) {
    __extends(StateList, _super);
    function StateList(props) {
        var _this = _super.call(this, props) || this;
        _this.handleStateClick = function (stateId, stateName) {
            _this.props.store.state.selectedState = {
                id: stateId,
                name: stateName,
            };
            _this.props.store.state.modalStatus =
                state_1.StateModalStatus.OpenOnSpecificArea;
            _this.props.store.state.stateAreasSearch = state_1.AreasFilterType.All;
        };
        return _this;
    }
    StateList.prototype.render = function () {
        var _this = this;
        // Destructure
        var state = this.props.store.state;
        // Render
        return (React.createElement("div", { className: s.stateListContainer }, (state.statesSearchedResults.length > 0 && (React.createElement("div", { className: s.stateList }, state.statesSearchedResults.map(function (stateSearchResult, stateSearchResultIndex) {
            return (React.createElement(StateItem_1.StateItem, { key: 'state' + stateSearchResult.id, onClick: _this.handleStateClick, state: stateSearchResult }));
        })))) || (React.createElement("div", { className: classNames(s.stateList, s.empty) },
            React.createElement("p", null, "No states have been found.")))));
    };
    __decorate([
        mobx_1.action
    ], StateList.prototype, "handleStateClick", void 0);
    StateList = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], StateList);
    return StateList;
}(React.Component));
exports.StateList = StateList;


/***/ }),

/***/ "./app/web/src/components/state/StateRepAssignedAreas.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/state/StateRepAssignedAreas.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./StateRepAssignedAreas.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./StateRepAssignedAreas.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/state/StateRepAssignedAreas.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __webpack_require__("./node_modules/classnames/index.js");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var location_1 = __webpack_require__("./app/web/data/location/index.ts");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/components/state/StateRepAssignedAreas.css");
// Component
var StateRepAssignedAreas = /** @class */ (function (_super) {
    __extends(StateRepAssignedAreas, _super);
    function StateRepAssignedAreas() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StateRepAssignedAreas.prototype.render = function () {
        var rep = this.props.store.state.selectedRepAssignedAreasDetails;
        if (rep === null) {
            return (React.createElement("div", { className: s.container },
                React.createElement("h2", { className: s.headline },
                    React.createElement(indicator_1.SavingIndicator, { labels: {
                            saving: 'Loading rep areas...',
                        }, status: indicator_1.SavingIndicatorStatus.Saving })),
                React.createElement("br", null),
                React.createElement("br", null)));
        }
        return (React.createElement("div", { className: s.container },
            React.createElement("h2", { className: s.headline }, rep.name || rep.slpcode),
            React.createElement("div", { className: s.header },
                React.createElement("div", { className: s.row },
                    React.createElement("div", null, "States"),
                    React.createElement("div", null, "Leads count"))),
            React.createElement("div", { className: s.items }, rep.states.map(function (state) { return (React.createElement("div", { key: state.stateCode },
                React.createElement("div", { className: s.row },
                    React.createElement("div", null,
                        React.createElement("p", null,
                            React.createElement("strong", null, location_1.usaStatesList[state.stateCode] ||
                                state.stateCode))),
                    React.createElement("div", null,
                        React.createElement("p", null, state.stateLeadsCount || 0))),
                state.areas.map(function (area) { return (React.createElement("div", { key: area.areaCode, className: classnames_1.default(s.row, s.subRow) },
                    React.createElement("div", null,
                        React.createElement("p", null, area.areaCode)),
                    React.createElement("div", null,
                        React.createElement("p", null, area.areaLeadsCount)))); }))); }))));
    };
    StateRepAssignedAreas = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], StateRepAssignedAreas);
    return StateRepAssignedAreas;
}(React.Component));
exports.StateRepAssignedAreas = StateRepAssignedAreas;


/***/ }),

/***/ "./app/web/src/components/state/StateRepsList.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/state/StateRepsList.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./StateRepsList.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./StateRepsList.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/components/state/StateRepsList.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __webpack_require__("./node_modules/classnames/index.js");
var state_1 = __webpack_require__("./app/common/interfaces/state.ts");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/components/state/StateRepsList.css");
var arrowToRightIcon = __webpack_require__("./app/web/src/assets/blue arrow.svg");
// Component
var StateRepsList = /** @class */ (function (_super) {
    __extends(StateRepsList, _super);
    function StateRepsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleGoingToAreasList = function (e) {
            _this.props.store.state.modalStatus = state_1.StateModalStatus.OpenOnStatesList;
        };
        _this.handleRepClick = function (rep) { return function (e) {
            _this.props.store.state.selectedRep = {
                id: rep.userId,
                slpcode: rep.slpcode,
                username: rep.username,
                name: rep.name,
            };
            _this.props.store.state.modalStatus =
                state_1.StateModalStatus.OpenOnSpecificRepArea;
        }; };
        return _this;
    }
    Object.defineProperty(StateRepsList.prototype, "allReps", {
        get: function () {
            return this.props.store.state.repsAreas;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateRepsList.prototype, "allRepsCount", {
        get: function () {
            return this.allReps.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateRepsList.prototype, "repsSearchQuery", {
        get: function () {
            return this.props.store.state.repsSearch.trim().toLowerCase();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateRepsList.prototype, "reps", {
        get: function () {
            var _this = this;
            return this.allReps.filter(function (rep) {
                return rep.name.toLowerCase().indexOf(_this.repsSearchQuery) !== -1 ||
                    rep.slpcode.toString() === _this.repsSearchQuery ||
                    rep.username.toLowerCase().indexOf(_this.repsSearchQuery) !== -1
                    ? true
                    : false;
            });
        },
        enumerable: true,
        configurable: true
    });
    StateRepsList.prototype.render = function () {
        var _this = this;
        var _a;
        return (React.createElement("div", { className: s.container },
            React.createElement("div", { className: s.header },
                React.createElement(content_1.SectionHeadline, { className: s.headline, title: this.allRepsCount + " active sales reps", button: {
                        onClick: this.handleGoingToAreasList,
                        icon: arrowToRightIcon,
                        iconClassName: s.assignIcon,
                        label: 'Assign reps to areas',
                        showLabel: true,
                    } })),
            (this.reps.length > 0 && (React.createElement("div", { className: classnames_1.default(s.repsList, (_a = {},
                    _a[s.oneResult] = this.reps.length === 1,
                    _a[s.twoResults] = this.reps.length === 2,
                    _a[s.threeResults] = this.reps.length === 3,
                    _a)) }, this.reps.map(function (rep) {
                var statesLabel = rep.statesCount +
                    ' state' +
                    (rep.statesCount > 1 ? 's' : '');
                var areasLabel = rep.areasCount +
                    ' area' +
                    (rep.areasCount > 1 ? 's' : '');
                return (React.createElement(action_1.CardButton, { key: rep.username, className: s.repButton, isDisabled: rep.areasCount <= 0, onClick: _this.handleRepClick(rep) },
                    React.createElement("p", { className: s.repName }, rep.name),
                    React.createElement("p", { className: s.repAreasCount },
                        React.createElement("strong", null, statesLabel),
                        rep.areasCount > 0 && (React.createElement("span", null, '(' + areasLabel + ')')))));
            })))) || (React.createElement("div", { className: classnames_1.default(s.repsList, s.empty) },
                React.createElement("p", null, "No sales reps have been found.")))));
    };
    __decorate([
        mobx_1.computed
    ], StateRepsList.prototype, "allReps", null);
    __decorate([
        mobx_1.computed
    ], StateRepsList.prototype, "allRepsCount", null);
    __decorate([
        mobx_1.computed
    ], StateRepsList.prototype, "repsSearchQuery", null);
    __decorate([
        mobx_1.computed
    ], StateRepsList.prototype, "reps", null);
    __decorate([
        mobx_1.action
    ], StateRepsList.prototype, "handleGoingToAreasList", void 0);
    __decorate([
        mobx_1.action
    ], StateRepsList.prototype, "handleRepClick", void 0);
    StateRepsList = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], StateRepsList);
    return StateRepsList;
}(React.Component));
exports.StateRepsList = StateRepsList;


/***/ }),

/***/ "./app/web/src/components/state/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/components/state/State.tsx"));
__export(__webpack_require__("./app/web/src/components/state/StateList.tsx"));
__export(__webpack_require__("./app/web/src/components/state/StateItem.tsx"));
__export(__webpack_require__("./app/web/src/components/state/StateAreaList.tsx"));
__export(__webpack_require__("./app/web/src/components/state/StateAreaListPicker.tsx"));
__export(__webpack_require__("./app/web/src/components/state/StateArea.tsx"));
__export(__webpack_require__("./app/web/src/components/state/StateRepsList.tsx"));
__export(__webpack_require__("./app/web/src/components/state/StateRepAssignedAreas.tsx"));


/***/ }),

/***/ "./app/web/src/components/svg/SvgGrid.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
// Component
var SvgGrid = /** @class */ (function (_super) {
    __extends(SvgGrid, _super);
    function SvgGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SvgGrid, "defaultProps", {
        get: function () {
            return {
                width: '100%',
                height: '100%',
            };
        },
        enumerable: true,
        configurable: true
    });
    SvgGrid.prototype.render = function () {
        return (React.createElement("svg", { width: this.props.width, height: this.props.height, viewBox: "0 0 28 28", version: "1.1", spacing: "preserve", style: {
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                strokeLineJoin: 'round',
                strokeMiterLimit: 2,
            } },
            React.createElement("g", { transform: "matrix(0.736842,0,0,0.736842,0,0)" },
                React.createElement("g", { transform: "matrix(1.35714,0,0,1.35714,0,0)" },
                    React.createElement("path", { d: "M8,1L7,0L1,0L0,1L0,7L1,8L7,8L8,7L8,1Z" })),
                React.createElement("g", { transform: "matrix(1.35714,0,0,1.35714,0,13.5714)" },
                    React.createElement("path", { d: "M8,1L7,0L1,0L0,1L0,7L1,8L7,8L8,7L8,1Z" })),
                React.createElement("g", { transform: "matrix(1.35714,0,0,1.35714,0,27.1429)" },
                    React.createElement("path", { d: "M8,1L7,0L1,0L0,1L0,7L1,8L7,8L8,7L8,1Z" })),
                React.createElement("g", { transform: "matrix(1.35714,0,0,1.35714,13.5714,0)" },
                    React.createElement("path", { d: "M8,1L7,0L1,0L0,1L0,7L1,8L7,8L8,7L8,1Z" })),
                React.createElement("g", { transform: "matrix(1.35714,0,0,1.35714,13.5714,13.5714)" },
                    React.createElement("path", { d: "M8,1L7,0L1,0L0,1L0,7L1,8L7,8L8,7L8,1Z" })),
                React.createElement("g", { transform: "matrix(1.35714,0,0,1.35714,13.5714,27.1429)" },
                    React.createElement("path", { d: "M8,1L7,0L1,0L0,1L0,7L1,8L7,8L8,7L8,1Z" })),
                React.createElement("g", { transform: "matrix(1.35714,0,0,1.35714,27.1429,0)" },
                    React.createElement("path", { d: "M8,1L7,0L1,0L0,1L0,7L1,8L7,8L8,7L8,1Z" })),
                React.createElement("g", { transform: "matrix(1.35714,0,0,1.35714,27.1429,13.5714)" },
                    React.createElement("path", { d: "M8,1L7,0L1,0L0,1L0,7L1,8L7,8L8,7L8,1Z" })),
                React.createElement("g", { transform: "matrix(1.35714,0,0,1.35714,27.1429,27.1429)" },
                    React.createElement("path", { d: "M8,1L7,0L1,0L0,1L0,7L1,8L7,8L8,7L8,1Z" })))));
    };
    return SvgGrid;
}(React.Component));
exports.SvgGrid = SvgGrid;


/***/ }),

/***/ "./app/web/src/components/svg/SvgList.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
// Component
var SvgList = /** @class */ (function (_super) {
    __extends(SvgList, _super);
    function SvgList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SvgList, "defaultProps", {
        get: function () {
            return {
                width: '100%',
                height: '100%',
            };
        },
        enumerable: true,
        configurable: true
    });
    SvgList.prototype.render = function () {
        return (React.createElement("svg", { width: this.props.width, height: this.props.height, viewBox: "0 0 28 28", version: "1.1", spacing: "preserve", style: {
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                strokeLineJoin: 'round',
                strokeMiterLimit: 2,
            } },
            React.createElement("g", { transform: "matrix(0.736842,0,0,0.736842,0,0)" },
                React.createElement("g", { transform: "matrix(4.75,0,0,1.01786,0,2.71429)" },
                    React.createElement("path", { d: "M8,1.333L7.714,0L0.286,0L0,1.333L0,6.667L0.286,8L7.714,8L8,6.667L8,1.333Z" })),
                React.createElement("g", { transform: "matrix(4.75,0,0,1.01786,0,14.9286)" },
                    React.createElement("path", { d: "M8,1.333L7.714,0L0.286,0L0,1.333L0,6.667L0.286,8L7.714,8L8,6.667L8,1.333Z" })),
                React.createElement("g", { transform: "matrix(4.75,0,0,1.01786,0,27.1429)" },
                    React.createElement("path", { d: "M8,1.333L7.714,0L0.286,0L0,1.333L0,6.667L0.286,8L7.714,8L8,6.667L8,1.333Z" })))));
    };
    return SvgList;
}(React.Component));
exports.SvgList = SvgList;


/***/ }),

/***/ "./app/web/src/components/svg/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/components/svg/SvgGrid.tsx"));
__export(__webpack_require__("./app/web/src/components/svg/SvgList.tsx"));


/***/ }),

/***/ "./app/web/src/events/scroll.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var zenscroll = __webpack_require__("./node_modules/zenscroll/zenscroll.js");
// Setup zenscroll
exports.scrollWindow = zenscroll.createScroller((document.scrollingElement || document.body), 500, 64);


/***/ }),

/***/ "./app/web/src/routes/errors/PageForbidden/PageForbidden.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/errors/PageForbidden/PageForbidden.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./PageForbidden.css", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./PageForbidden.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/errors/PageForbidden/PageForbidden.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Form_1 = __webpack_require__("./app/web/src/routes/user/login/Form/index.tsx");
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var Form_2 = __webpack_require__("./app/web/src/routes/user/login/Form/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/routes/errors/PageForbidden/PageForbidden.css");
// Component
var PageForbidden = /** @class */ (function (_super) {
    __extends(PageForbidden, _super);
    function PageForbidden() {
        return _super.call(this) || this;
    }
    PageForbidden.prototype.render = function () {
        return (React.createElement("div", { className: s.pageForbidden },
            React.createElement(Form_2.LoginForm, { headline: this.props.user.isLoggedIn
                    ? 'Page not allowed — login as user with appropriate permissions'
                    : 'Welcome to Spyka CRM — login with your credentials', headlineType: this.props.user.isLoggedIn
                    ? Form_1.HeadlineType.Important
                    : Form_1.HeadlineType.Normal, showBack: this.props.user.isLoggedIn, location: this.props.location, history: this.props.history })));
    };
    PageForbidden = __decorate([
        mobx_react_1.observer
    ], PageForbidden);
    return PageForbidden;
}(React.Component));
exports.PageForbidden = PageForbidden;
exports.default = PageForbidden;


/***/ }),

/***/ "./app/web/src/routes/errors/PageNotFound/PageNotFound.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var s = __webpack_require__("./app/web/src/styles/errors/errors.css");
// Component
var PageNotFound = /** @class */ (function (_super) {
    __extends(PageNotFound, _super);
    function PageNotFound() {
        return _super.call(this) || this;
    }
    PageNotFound.prototype.render = function () {
        return (React.createElement("div", { className: s.pageNotFound },
            React.createElement("h1", { className: s.pageNotFound__inner }, "404 Page not found")));
    };
    PageNotFound = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], PageNotFound);
    return PageNotFound;
}(React.Component));
exports.PageNotFound = PageNotFound;
exports.default = PageNotFound;


/***/ }),

/***/ "./app/web/src/routes/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
// Libraries
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
__webpack_require__("./app/web/src/styles/index.css");
// History
var App_1 = __webpack_require__("./app/web/src/App.tsx");
// Component
var Main = /** @class */ (function (_super) {
    __extends(Main, _super);
    function Main() {
        var _this = _super.call(this) || this;
        App_1.browserHistory.push('sales');
        return _this;
    }
    Main.prototype.render = function () {
        return React.createElement("div", null);
    };
    Main = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], Main);
    return Main;
}(React.Component));
exports.default = Main;


/***/ }),

/***/ "./app/web/src/routes/sales/Dashboard/SalesDashboard.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Dashboard/SalesDashboard.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./SalesDashboard.css", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./SalesDashboard.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Dashboard/SalesDashboard.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__("./app/web/src/routes/sales/Dashboard/index.tsx");
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var provider_1 = __webpack_require__("./app/common/interfaces/provider.ts");
var state_1 = __webpack_require__("./app/common/interfaces/state.ts");
var user_1 = __webpack_require__("./app/common/interfaces/user.ts");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var activity_1 = __webpack_require__("./app/web/src/components/activity/index.tsx");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
var createlead_1 = __webpack_require__("./app/web/src/components/createlead/index.ts");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var layout_1 = __webpack_require__("./app/web/src/components/layout/index.tsx");
var Pagination_1 = __webpack_require__("./app/web/src/components/navigation/Pagination.tsx");
var pricing_1 = __webpack_require__("./app/web/src/components/pricing/index.ts");
var state_2 = __webpack_require__("./app/web/src/components/state/index.tsx");
var sales_1 = __webpack_require__("./app/web/data/sales/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var Leads_1 = __webpack_require__("./app/web/src/stores/Leads.ts");
var zenscroll = __webpack_require__("./node_modules/zenscroll/zenscroll.js");
var PricingRequest_1 = __webpack_require__("./app/web/src/routes/sales/Lead/PricingRequest/index.tsx");
var svg_1 = __webpack_require__("./app/web/src/components/svg/index.ts");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Dashboard/SalesDashboard.css");
var addIcon = __webpack_require__("./app/web/src/assets/plus icon.svg");
var arrowToRightIcon = __webpack_require__("./app/web/src/assets/blue arrow.svg");
// Page
var SalesDashboard = /** @class */ (function (_super) {
    __extends(SalesDashboard, _super);
    function SalesDashboard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.offsetScroll = zenscroll.createScroller((document.scrollingElement || document.body), 0, 140);
        _this.scrollToTop = function () {
            zenscroll.toY(0);
        };
        _this.handleSearchChange = function (value) {
            var leads = _this.props.store.leads;
            _this.scrollToTop();
            if (leads.leadsSearchFilter === Leads_1.LeadsSearchFilter.Notes) {
                leads.notesSearchQuery = value;
            }
            else {
                leads.leadsSearch = value;
            }
        };
        _this.handleSearchFilterChange = function (value) {
            var leads = _this.props.store.leads;
            _this.scrollToTop();
            var currentFilterValue = leads.leadsSearchFilter.slice();
            var nextFilterValue = value;
            // Copy value
            if (currentFilterValue !== nextFilterValue) {
                if (currentFilterValue === Leads_1.LeadsSearchFilter.Notes) {
                    leads.leadsSearch = leads.notesSearchQuery;
                }
                else if (nextFilterValue === Leads_1.LeadsSearchFilter.Notes) {
                    leads.notesSearchQuery = leads.leadsSearch;
                }
            }
            leads.leadsSearchFilter = nextFilterValue
                ? nextFilterValue
                : Leads_1.LeadsSearchFilter.All;
        };
        _this.handleSearchFilterByActivityTypeChange = function (value) {
            _this.scrollToTop();
            _this.props.store.leads.leadsFilterByActivityTypeId = value;
        };
        _this.handleSearchFilterByActivityDateChange = function (value) {
            _this.scrollToTop();
            if (value === 0) {
                _this.props.store.leads.leadsFilterByActivityDate = {
                    from: null,
                    to: null,
                    noActivity: false,
                };
            }
            else if (value === -1) {
                _this.props.store.leads.leadsFilterByActivityDate = {
                    from: null,
                    to: null,
                    noActivity: true,
                };
            }
            else if (typeof value === 'string') {
                var activityDateExploded = value.split('/');
                if (activityDateExploded.length >= 2) {
                    _this.props.store.leads.leadsFilterByActivityDate = {
                        from: activityDateExploded[0],
                        to: activityDateExploded[1],
                        noActivity: false,
                    };
                }
            }
        };
        _this.handleOpenRepsAreasModal = function () {
            _this.props.store.state.modalStatus = state_1.StateModalStatus.OpenOnRepAreasList;
        };
        _this.handleOpenCreateNewLeadModal = function () {
            _this.props.store.leads.modalStatus = provider_1.CreateLeadModalStatus.Opened;
        };
        _this.handlePricingRequestClose = function () {
            _this.props.store.leadPricing.fetchAllItemsWithPricing();
            _this.props.store.pricingRequest.resetSinglePricingRequest();
        };
        _this.handleLeadsPageChange = function (page) {
            _this.props.store.leads.changeLeadsPage(page);
            _this.scrollToTop();
        };
        _this.handleNotesPageChange = function (page) {
            _this.props.store.leads.changeNotesPage(page);
            _this.scrollToTop();
        };
        _this.handleTogglingDashboardView = function (view) { return function (e) {
            if (view !== _this.props.store.leads.leadsDashboardView) {
                _this.props.store.leads.setLeadsDashboardView(view);
                _this.scrollToTop();
            }
        }; };
        return _this;
    }
    Object.defineProperty(SalesDashboard.prototype, "activityTypesDropdownOptions", {
        get: function () {
            return [
                {
                    key: 'all-activities-option',
                    value: 0,
                    label: 'All',
                },
            ].concat(mobx_1.toJS(this.props.store.activities.allActivityTypes.map(function (activityType, i) {
                return {
                    key: typeof activityType.value === 'string'
                        ? activityType.value + i.toString()
                        : JSON.stringify(activityType.value) + i,
                    value: activityType.value,
                    label: activityType.label,
                };
            })));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesDashboard.prototype, "activityDatesDropdownOptions", {
        get: function () {
            return sales_1.activityDatesDropdownOptions();
        },
        enumerable: true,
        configurable: true
    });
    SalesDashboard.prototype.componentDidMount = function () {
        var _a = this.props.store, _b = _a.lead, generateDashboardLeadCardId = _b.generateDashboardLeadCardId, generateDashboardLeadCardNameId = _b.generateDashboardLeadCardNameId, generateDashboardNoteCardId = _b.generateDashboardNoteCardId, generateDashboardNoteCardNameId = _b.generateDashboardNoteCardNameId, _c = _a.leads, lastLeadId = _c.lastLeadId, lastNoteId = _c.lastNoteId, leadsDashboardView = _c.leadsDashboardView;
        // Scroll to last opened lead
        var leadCardId = leadsDashboardView === provider_1.EDashboardView.List
            ? generateDashboardLeadCardNameId(lastLeadId)
            : generateDashboardLeadCardId(lastLeadId);
        var lastLeadCardElem = document.getElementById(leadCardId);
        if (lastLeadCardElem) {
            this.offsetScroll.to(lastLeadCardElem, 0);
        }
        else {
            // Or scroll to last opened note
            var noteCardNameId = leadsDashboardView === provider_1.EDashboardView.List
                ? generateDashboardNoteCardNameId(lastNoteId)
                : generateDashboardNoteCardId(lastNoteId);
            var lastNoteCardElem = document.getElementById(noteCardNameId);
            if (lastNoteCardElem) {
                this.offsetScroll.to(lastNoteCardElem, 0);
            }
            else {
                zenscroll.toY(0);
            }
        }
        // Fetch provider types and dispenser classes
        this.props.store.leads.fetchProviderTypes();
        this.props.store.leads.fetchDispenserClasses();
    };
    SalesDashboard.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f;
        var _g = this.props.store, user = _g.user, leads = _g.leads, activities = _g.activities, pricingRequest = _g.pricingRequest;
        return (React.createElement(layout_1.Layout, null,
            React.createElement("div", { className: s.salesDashboard },
                React.createElement("div", { className: s.leads },
                    React.createElement("div", { className: s.leadsList },
                        React.createElement("div", { className: s.fixedHeader },
                            React.createElement("div", { className: s.leadsSearch },
                                React.createElement(action_1.Search, { id: "leads-search-field", onValueChange: this.handleSearchChange, onOptionChange: this.handleSearchFilterChange, classNameForField: s.searchField, autoFocus: true, label: "Search leads", placeholder: leads.leadsSearchFilter === Leads_1.LeadsSearchFilter.All
                                        ? 'Search leads by name, address or phone number...'
                                        : leads.leadsSearchFilter === Leads_1.LeadsSearchFilter.Phone
                                            ? 'Search leads by phone number...'
                                            : leads.leadsSearchFilter === Leads_1.LeadsSearchFilter.Name
                                                ? 'Search leads by name...'
                                                : leads.leadsSearchFilter === Leads_1.LeadsSearchFilter.Notes
                                                    ? 'Search leads by notes content...'
                                                    : 'Search leads by address...', isValueClearable: true, clearOnlySearchValue: leads.leadsSearchFilter === Leads_1.LeadsSearchFilter.Notes
                                        ? true
                                        : false, value: leads.leadsSearchFilter === Leads_1.LeadsSearchFilter.Notes
                                        ? leads.notesSearchQuery
                                        : leads.leadsSearch, selectedOption: leads.leadsSearchFilter, options: Object.keys(Leads_1.LeadsSearchFilter).map(function (searchFilterLabel) { return ({
                                        key: searchFilterLabel,
                                        value: Leads_1.LeadsSearchFilter[searchFilterLabel],
                                        label: searchFilterLabel,
                                    }); }) }),
                                leads.leadsSearchFilter !== Leads_1.LeadsSearchFilter.Notes && (React.createElement(action_1.Search, { id: "leads-last-activity-type-filter", onOptionChange: this.handleSearchFilterByActivityTypeChange, className: s.lastLeadActivityType, label: "Last Lead's activity type", selectedOption: leads.leadsFilterByActivityTypeId, options: this.activityTypesDropdownOptions.map(function (activity) { return ({
                                        key: activity.key,
                                        value: activity.value,
                                        label: activity.label,
                                    }); }) })),
                                leads.leadsSearchFilter !== Leads_1.LeadsSearchFilter.Notes && (React.createElement(action_1.Search, { id: "leads-last-activity-date-filter", onOptionChange: this.handleSearchFilterByActivityDateChange, className: s.lastLeadActivityDate, label: "Last lead's activity date", selectedOption: leads.leadsFilterByActivityDate !== null &&
                                        leads.leadsFilterByActivityDate.from !== null &&
                                        leads.leadsFilterByActivityDate.to !== null
                                        ? leads.leadsFilterByActivityDate.from +
                                            '/' +
                                            leads.leadsFilterByActivityDate.to
                                        : leads.leadsFilterByActivityDate !== null &&
                                            leads.leadsFilterByActivityDate.noActivity === true
                                            ? -1
                                            : 0, options: this.activityDatesDropdownOptions.map(function (date) { return ({
                                        key: date.key,
                                        value: date.value,
                                        label: date.label,
                                    }); }) })),
                                React.createElement("div", { className: s.viewToggle },
                                    React.createElement("button", { onClick: this.handleTogglingDashboardView(provider_1.EDashboardView.Grid), className: classNames(s.viewToggleButton, (_a = {},
                                            _a[s.active] = leads.leadsDashboardView === provider_1.EDashboardView.Grid,
                                            _a)) },
                                        React.createElement(svg_1.SvgGrid, null)),
                                    React.createElement("button", { onClick: this.handleTogglingDashboardView(provider_1.EDashboardView.List), className: classNames(s.viewToggleButton, (_b = {},
                                            _b[s.active] = leads.leadsDashboardView === provider_1.EDashboardView.List,
                                            _b)) },
                                        React.createElement(svg_1.SvgList, null))))),
                        (leads.leadsSearchFilter !== Leads_1.LeadsSearchFilter.Notes && (React.createElement("div", { className: classNames(s.leadsListResults, (_c = {},
                                _c[s.listIsEmpty] = (leads.leadsToDisplay.firstFetch &&
                                    leads.leadsToDisplay.isLoading) ||
                                    (!leads.leadsToDisplay.firstFetch &&
                                        !leads.leadsToDisplay.isLoading &&
                                        leads.leadsToDisplay.totalLeads <= 0),
                                _c)) },
                            (leads.leadsToDisplay.firstFetch &&
                                leads.leadsToDisplay.isLoading && (React.createElement("div", { className: s.listNoResults },
                                React.createElement("p", null, "Loading leads...")))) ||
                                (leads.leadsToDisplay.firstFetch === false &&
                                    leads.leadsToDisplay.isLoading === false &&
                                    leads.leadsToDisplay.totalLeads <= 0 && (React.createElement("div", { className: s.listNoResults },
                                    React.createElement("p", null, "No leads have been found")))) || (React.createElement("div", { className: s.listWithLeads },
                                React.createElement("div", { className: classNames((_d = {},
                                        _d[s.leadsGrid] = leads.leadsDashboardView === provider_1.EDashboardView.Grid,
                                        _d[s.leadsList] = leads.leadsDashboardView === provider_1.EDashboardView.List,
                                        _d[s.single] = leads.leadsToDisplayDetails.length <= 1,
                                        _d[s.double] = leads.leadsToDisplayDetails.length === 2,
                                        _d)) }, leads.leadsToDisplayDetails.map(function (lead, leadIndex) { return (React.createElement(_1.SalesDashboardLead, { key: lead.databaseId, index: leadIndex, lead: lead })); })))),
                            leads.leadsToDisplay.totalLeads > 0 && (React.createElement(Pagination_1.Pagination, { onPageClick: this.handleLeadsPageChange, isLoading: leads.leadsToDisplay.isLoading, totalEntries: leads.leadsToDisplay.totalLeads, entriesPerPage: leads.LEADS_OR_NOTES_PER_PAGE_LIMIT, showingFromOffset: leads.leadsFetchOffset }))))) || (React.createElement("div", { className: classNames(s.leadsListResults, (_e = {},
                                _e[s.listIsEmpty] = (leads.notesToDisplay.firstFetch &&
                                    leads.notesToDisplay.isLoading) ||
                                    (!leads.notesToDisplay.firstFetch &&
                                        !leads.notesToDisplay.isLoading &&
                                        leads.notesToDisplay.totalNotes <= 0),
                                _e)) },
                            (leads.notesToDisplay.firstFetch &&
                                leads.notesToDisplay.isLoading && (React.createElement("div", { className: s.listNoResults },
                                React.createElement("p", null, "Loading notes...")))) ||
                                (leads.notesToDisplay.firstFetch === false &&
                                    leads.notesToDisplay.isLoading === false &&
                                    leads.notesToDisplay.totalNotes <= 0 && (React.createElement("div", { className: s.listNoResults },
                                    React.createElement("p", null, "No notes have been found")))) || (React.createElement("div", { className: s.listWithLeads },
                                React.createElement("div", { className: classNames((_f = {},
                                        _f[s.leadsGrid] = leads.leadsDashboardView === provider_1.EDashboardView.Grid,
                                        _f[s.leadsList] = leads.leadsDashboardView === provider_1.EDashboardView.List,
                                        _f[s.single] = leads.notesToDisplayDetails.length <= 1,
                                        _f[s.double] = leads.notesToDisplayDetails.length === 2,
                                        _f)) }, leads.notesToDisplayDetails.map(function (note, noteIndex) { return (React.createElement(_1.SalesDashboardNote, { key: note.id, index: noteIndex, note: note })); })))),
                            leads.notesToDisplay.totalNotes > 0 && (React.createElement(Pagination_1.Pagination, { onPageClick: this.handleNotesPageChange, isLoading: leads.notesToDisplay.isLoading, totalEntries: leads.notesToDisplay.totalNotes, entriesPerPage: leads.LEADS_OR_NOTES_PER_PAGE_LIMIT, showingFromOffset: leads.notesFetchOffset })))))),
                React.createElement("div", { className: s.leadsActivities },
                    React.createElement(content_1.SectionHeadline, { className: s.assignRepsHeadline, title: "Create new lead", button: {
                            label: 'Create',
                            icon: addIcon,
                            iconClassName: s.createNewLeadIcon,
                            onClick: this.handleOpenCreateNewLeadModal,
                        } }),
                    user.userType !== null && user.userType === user_1.UserType.SalesManager && (React.createElement(content_1.SectionHeadline, { className: s.assignRepsHeadline, title: "Sales reps areas", button: {
                            label: 'View and assign',
                            icon: arrowToRightIcon,
                            iconClassName: s.assignRepsIcon,
                            onClick: this.handleOpenRepsAreasModal,
                        } })),
                    React.createElement(content_1.SectionHeadline, { title: "Pricing requests" }),
                    (pricingRequest.pricingRequestsLength > 0 && (React.createElement(pricing_1.PendingPricingRequestsList, null))) || (React.createElement("p", { className: s.empty }, "All pending pricing requests have been approved.")),
                    React.createElement(content_1.SectionHeadline, { title: "Activities" }),
                    (activities.activitiesUserLength > 0 && (React.createElement("div", null, this.renderActivitiesListByGroup()))) || (React.createElement("p", { className: s.empty }, "You have finished all of your activities.")),
                    React.createElement(indicator_1.LoadingFullScreen, { className: s.spinner, fitInContainer: true, active: (activities.userActivitiesLoading &&
                            activities.activitiesUserLength <= 0) ||
                            (pricingRequest.loadingPricingRequests &&
                                pricingRequest.pricingRequestsLength <= 0) }))),
            React.createElement(PricingRequest_1.PricingRequestModal, { show: pricingRequest.loadingSinglePricingRequest ||
                    pricingRequest.singlePricingRequest !== null, existingRequest: {
                    data: pricingRequest.singlePricingRequest,
                    status: pricingRequest.statusOfSinglePricingRequestApproval,
                    loading: pricingRequest.loadingSinglePricingRequest,
                }, onModalClose: this.handlePricingRequestClose }),
            React.createElement(state_2.State, null),
            React.createElement(state_2.StateAreaListPicker, null),
            React.createElement(createlead_1.CreateLeadModal, null)));
    };
    SalesDashboard.prototype.renderActivitiesListByGroup = function () {
        return this.props.store.activities.userActivitiesGroups.map(function (group, key) {
            return group.activities.length > 0 ? (React.createElement(activity_1.ActivitiesGroup, { key: group.key, className: "dashboardActivities", title: group.title, allFinished: group.allFinished, activities: group.activities })) : null;
        });
    };
    __decorate([
        mobx_1.computed
    ], SalesDashboard.prototype, "activityTypesDropdownOptions", null);
    __decorate([
        mobx_1.action
    ], SalesDashboard.prototype, "handleOpenRepsAreasModal", void 0);
    __decorate([
        mobx_1.action
    ], SalesDashboard.prototype, "handleOpenCreateNewLeadModal", void 0);
    __decorate([
        mobx_1.action
    ], SalesDashboard.prototype, "handlePricingRequestClose", void 0);
    __decorate([
        mobx_1.action
    ], SalesDashboard.prototype, "handleLeadsPageChange", void 0);
    __decorate([
        mobx_1.action
    ], SalesDashboard.prototype, "handleNotesPageChange", void 0);
    __decorate([
        mobx_1.action
    ], SalesDashboard.prototype, "handleTogglingDashboardView", void 0);
    SalesDashboard = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], SalesDashboard);
    return SalesDashboard;
}(React.Component));
exports.SalesDashboard = SalesDashboard;


/***/ }),

/***/ "./app/web/src/routes/sales/Dashboard/SalesDashboardLead.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __webpack_require__("./node_modules/classnames/index.js");
var provider_1 = __webpack_require__("./app/common/interfaces/provider.ts");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var moment = __webpack_require__("./node_modules/moment/moment.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Dashboard/SalesDashboardLeadOrNoteCard.css");
// Component
var SalesDashboardLead = /** @class */ (function (_super) {
    __extends(SalesDashboardLead, _super);
    function SalesDashboardLead() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleLeadClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.props.store.leads.lastLeadId = _this.props.lead.databaseId;
            _this.props.store.lead.handleLeadSelect(_this.props.lead.databaseId);
        };
        _this.handlePhoneNumberClick = function (e) {
            e.stopPropagation();
        };
        return _this;
    }
    Object.defineProperty(SalesDashboardLead.prototype, "isEvenEntry", {
        get: function () {
            return this.props.index % 2 <= 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesDashboardLead.prototype, "location", {
        get: function () {
            var lead = this.props.lead;
            var location = '';
            location += lead.plCity || '';
            location += lead.plState ? ', ' + lead.plState : '';
            location += lead.plZipcode ? ' ' + lead.plZipcode : '';
            return location;
        },
        enumerable: true,
        configurable: true
    });
    SalesDashboardLead.prototype.render = function () {
        var _a;
        var _b = this.props, lead = _b.lead, leadsDashboardView = _b.store.leads.leadsDashboardView;
        return (React.createElement("div", { id: this.props.store.lead.generateDashboardLeadCardId(lead.databaseId), onClick: this.handleLeadClick, className: classnames_1.default(s.card, s.lead, (_a = {},
                _a[s.inList] = leadsDashboardView === provider_1.EDashboardView.List,
                _a[s.isEven] = this.isEvenEntry,
                _a)) },
            React.createElement("div", { className: s.inner },
                React.createElement("div", { id: this.props.store.lead.generateDashboardLeadCardNameId(lead.databaseId), className: s.idContainer },
                    React.createElement("p", { className: s.id },
                        React.createElement("span", null, "#"),
                        React.createElement("strong", null, lead.providerId || lead.databaseId))),
                React.createElement("a", { className: s.name },
                    (lead.dba || lead.legalBusName) && (React.createElement("strong", null, lead.dba || lead.legalBusName)),
                    lead.dba && lead.legalBusName && React.createElement("span", null, lead.legalBusName)),
                React.createElement("ul", { className: classnames_1.default(s.details, s.lastActivity) }, typeof lead.lastCompletedActivity !== 'undefined' &&
                    lead.lastCompletedActivity !== null && (React.createElement("li", null,
                    "Last completed activity:",
                    ' ',
                    React.createElement("p", null, lead.lastCompletedActivity.activityTypeName +
                        ' on ' +
                        moment(lead.lastCompletedActivity.updatedAt).format('MMM, Do, YYYY - hh:mm A'))))),
                React.createElement("ul", { className: classnames_1.default(s.details, s.contact) },
                    this.location && (React.createElement("li", null,
                        'Location: ',
                        React.createElement("p", null, this.location))),
                    lead.plPhone && (React.createElement("li", null,
                        'Phone: ',
                        React.createElement("p", null,
                            React.createElement("a", { onClick: this.handlePhoneNumberClick, href: "tel:+1 " + lead.plPhone.replace(/ /g, '') }, lead.plPhone))))),
                (typeof lead.lastCompletedActivity === 'undefined' ||
                    lead.lastCompletedActivity === null) &&
                    !this.location &&
                    !lead.plPhone && React.createElement("br", null))));
    };
    __decorate([
        mobx_1.computed
    ], SalesDashboardLead.prototype, "isEvenEntry", null);
    __decorate([
        mobx_1.computed
    ], SalesDashboardLead.prototype, "location", null);
    SalesDashboardLead = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], SalesDashboardLead);
    return SalesDashboardLead;
}(React.Component));
exports.SalesDashboardLead = SalesDashboardLead;


/***/ }),

/***/ "./app/web/src/routes/sales/Dashboard/SalesDashboardLeadOrNoteCard.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Dashboard/SalesDashboardLeadOrNoteCard.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./SalesDashboardLeadOrNoteCard.css", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./SalesDashboardLeadOrNoteCard.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Dashboard/SalesDashboardNote.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __webpack_require__("./node_modules/classnames/index.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var provider_1 = __webpack_require__("./app/common/interfaces/provider.ts");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Dashboard/SalesDashboardLeadOrNoteCard.css");
// Component
var SalesDashboardNote = /** @class */ (function (_super) {
    __extends(SalesDashboardNote, _super);
    function SalesDashboardNote() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleNoteClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.props.store.leads.lastNoteId = _this.props.note.id;
            _this.props.store.lead.handleLeadSelect(_this.props.note.providerDatabaseId);
        };
        return _this;
    }
    Object.defineProperty(SalesDashboardNote.prototype, "isEvenEntry", {
        get: function () {
            return this.props.index % 2 <= 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesDashboardNote.prototype, "noteCommentFormatted", {
        get: function () {
            var _a = this.props, comment = _a.note.comment, notesSearchQuery = _a.store.leads.notesSearchQuery;
            var search = notesSearchQuery.trim();
            if (!comment || comment.trim().length <= 0) {
                return '';
            }
            if (search.length <= 0) {
                return comment;
            }
            var regex = new RegExp(search, 'gi');
            return comment.trim().replace(regex, '<em>$&</em>');
        },
        enumerable: true,
        configurable: true
    });
    SalesDashboardNote.prototype.render = function () {
        var _a;
        var _b = this.props, note = _b.note, leadsDashboardView = _b.store.leads.leadsDashboardView;
        return (React.createElement("div", { id: this.props.store.lead.generateDashboardNoteCardId(note.id), onClick: this.handleNoteClick, className: classnames_1.default(s.card, s.note, (_a = {},
                _a[s.inList] = leadsDashboardView === provider_1.EDashboardView.List,
                _a[s.isEven] = this.isEvenEntry,
                _a)) },
            React.createElement("div", { className: s.inner },
                React.createElement("div", { id: this.props.store.lead.generateDashboardNoteCardNameId(note.id), className: s.idContainer },
                    React.createElement("p", { className: s.id },
                        React.createElement("span", null, "#"),
                        React.createElement("strong", null, note.id))),
                React.createElement("a", { className: s.comment, dangerouslySetInnerHTML: {
                        __html: this.noteCommentFormatted,
                    } }),
                (leadsDashboardView === provider_1.EDashboardView.List &&
                    this.renderNoteCustomerName()) ||
                    this.renderNoteDate(),
                (leadsDashboardView === provider_1.EDashboardView.List &&
                    this.renderNoteDate()) ||
                    this.renderNoteCustomerName())));
    };
    SalesDashboardNote.prototype.renderNoteDate = function () {
        var note = this.props.note;
        return (React.createElement("ul", { className: classnames_1.default(s.details, s.lastActivity, s.noteDate) }, typeof note.updatedAt !== 'undefined' && note.updatedAt !== null && (React.createElement("li", null,
            'Note written on: ',
            React.createElement("p", null, moment(note.updatedAt).format('MMM, Do - hh:mm A'))))));
    };
    SalesDashboardNote.prototype.renderNoteCustomerName = function () {
        var note = this.props.note;
        return (React.createElement("ul", { className: classnames_1.default(s.details, s.contact, s.noteContact) }, note.comment && (note.dba || note.legalBusName) && (React.createElement("li", null, "Lead's DBA and business name: ",
            React.createElement("p", null, note.dba || note.legalBusName),
            (!note.dba || note.dba !== note.legalBusName) && (React.createElement("p", null, note.legalBusName))))));
    };
    __decorate([
        mobx_1.computed
    ], SalesDashboardNote.prototype, "isEvenEntry", null);
    __decorate([
        mobx_1.computed
    ], SalesDashboardNote.prototype, "noteCommentFormatted", null);
    SalesDashboardNote = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], SalesDashboardNote);
    return SalesDashboardNote;
}(React.Component));
exports.SalesDashboardNote = SalesDashboardNote;


/***/ }),

/***/ "./app/web/src/routes/sales/Dashboard/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Dashboard/SalesDashboard.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Dashboard/SalesDashboardLead.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Dashboard/SalesDashboardNote.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Activities/LeadActivities.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Activities/LeadActivities.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadActivities.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadActivities.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Activities/LeadActivities.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var user_1 = __webpack_require__("./app/common/interfaces/user.ts");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var activity_1 = __webpack_require__("./app/web/src/components/activity/index.tsx");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var list_1 = __webpack_require__("./app/web/src/components/list/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Activities/LeadActivities.css");
var cancelIcon = __webpack_require__("./app/web/src/assets/close orange icon.svg");
var addIcon = __webpack_require__("./app/web/src/assets/plus icon.svg");
// Pages
var LeadActivities = /** @class */ (function (_super) {
    __extends(LeadActivities, _super);
    function LeadActivities(props) {
        var _this = _super.call(this, props) || this;
        _this.renderActivitiesListByGroup = function () {
            return _this.props.store.leadActivities.activitiesGroups.map(function (group) {
                return group.activities.length > 0 ? (React.createElement(activity_1.ActivitiesGroup, { key: group.key, title: group.title, allFinished: group.allFinished, activities: group.activities, isOnLeadPage: true })) : null;
            });
        };
        _this.activitiesUserFilterDropdown = null;
        _this.referenceActivitiesUserFilter = function (ref) {
            return (_this.activitiesUserFilterDropdown = ref);
        };
        _this.activitiesFilterDropdown = null;
        _this.referenceActivitiesFilter = function (ref) {
            return (_this.activitiesFilterDropdown = ref);
        };
        _this.handleActivitiesOfUserFilterChange = function (changed) {
            _this.props.store.leadActivities.setLeadActivitiesForSalesPerson(_this.props.store.lead.openLeadId, changed.value, changed.label);
            if (_this.activitiesUserFilterDropdown) {
                _this.activitiesUserFilterDropdown.closeDropdown();
            }
        };
        _this.handleActivitiesFilterChange = function (changed) {
            if (changed.value <= 0) {
                _this.props.store.leadActivities.showCompletedActivities = false;
            }
            else {
                _this.props.store.user.changeMaxActivitiesPreference(changed.value);
                _this.props.store.leadActivities.showCompletedActivities = true;
            }
            if (_this.activitiesFilterDropdown) {
                _this.activitiesFilterDropdown.closeDropdown();
            }
        };
        return _this;
    }
    Object.defineProperty(LeadActivities.prototype, "activitiesOfUserFilterOptions", {
        get: function () {
            var _a = this.props.store, user = _a.user, lead = _a.lead;
            var filterUsers = [];
            filterUsers.push({ value: user.id, label: user.name || user.username });
            if (user.userType === user_1.UserType.SalesManager) {
                lead.openLeadDetails.activitiesAssignedToUsers.forEach(function (assignedToUser) {
                    if (assignedToUser.id !== user.id) {
                        filterUsers.push({
                            value: assignedToUser.id,
                            label: assignedToUser.name || assignedToUser.username,
                        });
                    }
                });
            }
            filterUsers = filterUsers.sort(function (a, b) {
                var aName = a.label ? a.label.toLowerCase() : '';
                var bName = b.label ? b.label.toLowerCase() : '';
                return aName > bName ? 1 : aName < bName ? -1 : 0;
            });
            return filterUsers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadActivities.prototype, "activitiesActionButtonProps", {
        get: function () {
            var _this = this;
            var activitiesCreateOrEdit = this.props.store.activitiesCreateOrEdit;
            return {
                onClick: function () {
                    if (activitiesCreateOrEdit.newActivity !== null) {
                        activitiesCreateOrEdit.resetNewActivity();
                    }
                    else {
                        activitiesCreateOrEdit.initializeNewActivity(_this.props.store.lead.openLeadId);
                    }
                },
                label: activitiesCreateOrEdit.newActivity !== null
                    ? 'Cancel creating'
                    : 'New activity',
                icon: activitiesCreateOrEdit.newActivity !== null ? cancelIcon : addIcon,
                className: s.cancelOrAddButton,
                labelOnRight: true,
                showLabel: true,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadActivities.prototype, "showDefineNewActivityButton", {
        get: function () {
            return (this.props.store.leadActivities.leadActivitiesLoading === false &&
                this.props.store.activitiesCreateOrEdit.newActivity === null);
        },
        enumerable: true,
        configurable: true
    });
    LeadActivities.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props.store, user = _b.user, leadActivities = _b.leadActivities, activitiesCreateOrEdit = _b.activitiesCreateOrEdit;
        return (React.createElement("div", { className: s.leadActivities },
            React.createElement(content_1.SectionHeadline, { className: leadActivities.openLeadAllActivitiesCount <= 0
                    ? s.noActivitiesHeadline
                    : s.activitiesHeadline, title: "Activities", details: leadActivities.openLeadAllActivitiesCount <= 0
                    ? 'No activities assigned.'
                    : undefined, button: this.showDefineNewActivityButton
                    ? {
                        onClick: function () {
                            activitiesCreateOrEdit.initializeNewActivity(_this.props.store.lead.openLeadId);
                        },
                        icon: addIcon,
                        label: 'Define new activity',
                        showLabel: true,
                        labelOnRight: false,
                    }
                    : null }),
            React.createElement("div", { className: classNames(s.activitiesFilters, (_a = {},
                    _a[s.paddingRight] = this.showDefineNewActivityButton,
                    _a)) },
                user.userType === user_1.UserType.SalesManager && (React.createElement(list_1.DropdownContainer, { label: "Activities of", ref: this.referenceActivitiesUserFilter, value: leadActivities.leadActivitiesForSalesPerson.salesPersonName },
                    React.createElement(list_1.OptionsList, { label: "Filter by person", onChange: this.handleActivitiesOfUserFilterChange, value: leadActivities.leadActivitiesForSalesPerson
                            ? leadActivities.leadActivitiesForSalesPerson.salesPersonId
                            : -1, options: [
                            {
                                value: -1,
                                label: 'All',
                            },
                        ].concat(this.activitiesOfUserFilterOptions) }))),
                React.createElement(list_1.DropdownContainer, { label: "Show", ref: this.referenceActivitiesFilter, value: leadActivities.showCompletedActivities
                        ? (user.maxFinishedActivitiesCount > 0 &&
                            user.maxFinishedActivitiesCount <= 100
                            ? user.maxFinishedActivitiesCount
                            : 'all') + ' completed activities'
                        : 'only open activities' },
                    React.createElement(list_1.OptionsList, { label: "Activities filter", onChange: this.handleActivitiesFilterChange, value: leadActivities.showCompletedActivities
                            ? user.maxFinishedActivitiesCount
                            : 0, options: [
                            { value: 0, label: 'Only open activities' },
                            {
                                value: 10,
                                label: 'Last 10 completed activities',
                            },
                            {
                                value: 25,
                                label: 'Last 25 completed activities',
                            },
                            {
                                value: 50,
                                label: 'Last 50 completed activities',
                            },
                            {
                                value: 100,
                                label: 'Last 100 completed activities',
                            },
                            {
                                value: 99999999,
                                label: 'All completed activities',
                            },
                        ] }))),
            leadActivities.openLeadAllActivitiesCount >= 0
                ? this.renderActivitiesListByGroup()
                : null,
            activitiesCreateOrEdit.newActivity !== null && (React.createElement("div", { className: s.leadDefineActivity },
                React.createElement("div", { className: s.title },
                    React.createElement("h4", null, "Define")),
                React.createElement("div", { className: s.create },
                    React.createElement(activity_1.ActivityCreateOrEdit, null)))),
            (leadActivities.openLeadAllActivitiesCount > 0 ||
                activitiesCreateOrEdit.newActivity !== null) && (React.createElement(action_1.IconButton, __assign({}, this.activitiesActionButtonProps))),
            React.createElement(indicator_1.LoadingFullScreen, { active: leadActivities.leadActivitiesLoading, fitInContainer: true })));
    };
    __decorate([
        mobx_1.computed
    ], LeadActivities.prototype, "activitiesOfUserFilterOptions", null);
    __decorate([
        mobx_1.computed
    ], LeadActivities.prototype, "activitiesActionButtonProps", null);
    __decorate([
        mobx_1.computed
    ], LeadActivities.prototype, "showDefineNewActivityButton", null);
    LeadActivities = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], LeadActivities);
    return LeadActivities;
}(React.Component));
exports.LeadActivities = LeadActivities;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Activities/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Export
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Activities/LeadActivities.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/BusinessGroup/BusinessGroupModal.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/BusinessGroup/BusinessGroupModal.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./BusinessGroupModal.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./BusinessGroupModal.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/BusinessGroup/BusinessGroupModal.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var _1 = __webpack_require__("./app/web/src/routes/sales/Lead/BusinessGroup/index.ts");
var provider_1 = __webpack_require__("./app/common/interfaces/provider.ts");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/BusinessGroup/BusinessGroupModal.css");
var backArrow = __webpack_require__("./app/web/src/assets/back icon.svg");
// Component
var BusinessGroupModal = /** @class */ (function (_super) {
    __extends(BusinessGroupModal, _super);
    function BusinessGroupModal(props) {
        var _this = _super.call(this, props) || this;
        _this.renderStatesSearchBar = function () {
            return (React.createElement("input", { className: s.statesSearchBar, type: "text", placeholder: "Search group...", onChange: _this.handleSearchChange, value: _this.props.store.leadGroup.groupListSearch }));
        };
        _this.modalTitle = function () {
            var leadGroup = _this.props.store.leadGroup;
            return leadGroup.modalStatus === provider_1.LeadGroupModalStatus.OpenedOnGroupList
                ? 'Assign lead to group'
                : leadGroup.modalStatus === provider_1.LeadGroupModalStatus.OpenedOnCreateGroup
                    ? 'Create group'
                    : leadGroup.modalStatus === provider_1.LeadGroupModalStatus.OpenedOnSpecificGroup
                        ? 'Assigning...'
                        : '';
        };
        _this.handleSearchChange = function (e) {
            _this.props.store.leadGroup.groupListSearch = e.currentTarget.value;
        };
        _this.handleBackToList = function () {
            _this.props.store.leadGroup.modalStatus =
                provider_1.LeadGroupModalStatus.OpenedOnGroupList;
            _this.props.store.leadGroup.openedGroup = null;
        };
        _this.closeModal = function () {
            _this.props.store.leadGroup.modalStatus = provider_1.LeadGroupModalStatus.Closed;
        };
        return _this;
    }
    BusinessGroupModal.prototype.render = function () {
        var leadGroup = this.props.store.leadGroup;
        return (React.createElement(content_1.Modal, { onModalClose: this.closeModal, show: this.props.show, title: this.modalTitle(), titleBarContent: leadGroup.modalStatus === provider_1.LeadGroupModalStatus.OpenedOnGroupList &&
                leadGroup.leadGroups.length > 0
                ? this.renderStatesSearchBar()
                : null, titleBarIcons: leadGroup.modalStatus !== provider_1.LeadGroupModalStatus.OpenedOnGroupList
                ? [
                    {
                        key: 'back-arrow',
                        label: 'Back to group list',
                        showLabel: true,
                        icon: backArrow,
                        className: s.backArrow,
                        iconClassName: s.backArrowIcon,
                        onClick: this.handleBackToList,
                    },
                ]
                : undefined }, this.props.show && (React.createElement("div", { className: s.state }, leadGroup.modalStatus ===
            provider_1.LeadGroupModalStatus.OpenedOnGroupList ? (React.createElement(_1.GroupList, null)) : leadGroup.modalStatus ===
            provider_1.LeadGroupModalStatus.OpenedOnCreateGroup ? (React.createElement(_1.GroupCreate, null)) : leadGroup.modalStatus ===
            provider_1.LeadGroupModalStatus.OpenedOnSpecificGroup ? (React.createElement(_1.GroupItem, null)) : null))));
    };
    BusinessGroupModal = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], BusinessGroupModal);
    return BusinessGroupModal;
}(React.Component));
exports.BusinessGroupModal = BusinessGroupModal;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/BusinessGroup/GroupCreate.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/BusinessGroup/GroupCreate.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./GroupCreate.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./GroupCreate.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/BusinessGroup/GroupCreate.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/BusinessGroup/GroupCreate.css");
// Component
var GroupCreate = /** @class */ (function (_super) {
    __extends(GroupCreate, _super);
    function GroupCreate(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChangeGroupName = function (e) {
            _this.props.store.leadGroup.createNewGroup = e.currentTarget.value;
        };
        _this.handleCreateGroup = function (e) {
            _this.props.store.leadGroup.createLeadGroup();
        };
        return _this;
    }
    GroupCreate.prototype.render = function () {
        // Destructure
        var createNewGroup = this.props.store.leadGroup.createNewGroup;
        // Render
        return (React.createElement("div", { className: s.createGroup },
            React.createElement("input", { type: "text", placeholder: "Group name...", autoFocus: true, value: createNewGroup, onChange: this.handleChangeGroupName }),
            React.createElement("button", { className: "boxButton", onClick: this.handleCreateGroup }, "Create new group")));
    };
    GroupCreate = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], GroupCreate);
    return GroupCreate;
}(React.Component));
exports.GroupCreate = GroupCreate;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/BusinessGroup/GroupItem.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/BusinessGroup/GroupItem.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./GroupItem.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./GroupItem.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/BusinessGroup/GroupItem.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/BusinessGroup/GroupItem.css");
// Component
var GroupItem = /** @class */ (function (_super) {
    __extends(GroupItem, _super);
    function GroupItem(props) {
        var _this = _super.call(this, props) || this;
        _this.props.store.leadGroup.addLeadToGroup(_this.props.store.leadGroup.openedGroup.id);
        return _this;
    }
    GroupItem.prototype.render = function () {
        var openedGroup = this.props.store.leadGroup.openedGroup;
        return (React.createElement(index_1.SavingIndicator, { align: "center", className: s.saving, labels: {
                saving: "Assigning to group" + (openedGroup.name ? ' "' + openedGroup.name + '"' : '...'),
            }, status: index_1.SavingIndicatorStatus.Saving }));
    };
    GroupItem = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], GroupItem);
    return GroupItem;
}(React.Component));
exports.GroupItem = GroupItem;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/BusinessGroup/GroupList.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/BusinessGroup/GroupList.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./GroupList.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./GroupList.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/BusinessGroup/GroupList.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var provider_1 = __webpack_require__("./app/common/interfaces/provider.ts");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/BusinessGroup/GroupList.css");
var arrow = __webpack_require__("./app/web/src/assets/blue arrow.svg");
var plus = __webpack_require__("./app/web/src/assets/plus icon.svg");
// Component
var GroupList = /** @class */ (function (_super) {
    __extends(GroupList, _super);
    function GroupList(props) {
        var _this = _super.call(this, props) || this;
        _this.renderCreateGroupItem = function (label) {
            if (label === void 0) { label = 'Create new group'; }
            return (React.createElement("div", { className: s.groupListItem },
                React.createElement("button", { className: classNames(s.groupListButton, s.groupListCreateButton), onClick: _this.handleCreateGroupClick },
                    React.createElement("strong", { className: s.groupName }, label),
                    React.createElement("img", { className: s.icon, src: plus, alt: "" }))));
        };
        _this.handleGroupClick = function (groupSearchResult) { return function (e) {
            _this.props.store.leadGroup.openedGroup = groupSearchResult;
            _this.props.store.leadGroup.modalStatus =
                provider_1.LeadGroupModalStatus.OpenedOnSpecificGroup;
        }; };
        _this.handleCreateGroupClick = function (e) {
            _this.props.store.leadGroup.modalStatus =
                provider_1.LeadGroupModalStatus.OpenedOnCreateGroup;
        };
        return _this;
    }
    GroupList.prototype.render = function () {
        var _this = this;
        var leadGroup = this.props.store.leadGroup;
        return (React.createElement("div", { className: s.groupListContainer }, (leadGroup.groupSearchedResults.length > 0 && (React.createElement("div", { className: s.groupList },
            this.renderCreateGroupItem(),
            leadGroup.groupSearchedResults.map(function (groupSearchResult, index) { return (React.createElement("div", { className: s.groupListItem, key: groupSearchResult.id },
                React.createElement("button", { className: s.groupListButton, onClick: _this.handleGroupClick(groupSearchResult) },
                    React.createElement("p", { className: s.groupName }, groupSearchResult.name),
                    React.createElement("img", { className: s.icon, src: arrow, alt: "" })))); })))) || (React.createElement("div", { className: classNames(s.groupList, s.empty) }, this.renderCreateGroupItem(leadGroup.leadGroups.length > 0
            ? 'No groups have been found, create new group'
            : 'Create new group')))));
    };
    __decorate([
        mobx_1.action
    ], GroupList.prototype, "handleGroupClick", void 0);
    __decorate([
        mobx_1.action
    ], GroupList.prototype, "handleCreateGroupClick", void 0);
    GroupList = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], GroupList);
    return GroupList;
}(React.Component));
exports.GroupList = GroupList;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/BusinessGroup/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/BusinessGroup/BusinessGroupModal.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/BusinessGroup/GroupList.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/BusinessGroup/GroupItem.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/BusinessGroup/GroupCreate.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/BusinessPartner/BusinessPartner.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/BusinessPartner/BusinessPartner.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./BusinessPartner.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./BusinessPartner.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/BusinessPartner/BusinessPartner.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/BusinessPartner/BusinessPartner.css");
// Component
var LeadPricingRequest = /** @class */ (function (_super) {
    __extends(LeadPricingRequest, _super);
    function LeadPricingRequest(props) {
        return _super.call(this, props) || this;
    }
    LeadPricingRequest.prototype.render = function () {
        // TODO: Show pending pricing requests with date of request
        // clicking should open modal: for sales rep a read only view, for sales manager edit / approve pricing
        // TODO: Below show button "Approved pricing" with date of last approved pricing
        // Clicking by any user shold open modal with all items in table, no search bar, and current approved prices for the lead
        return React.createElement("div", null);
    };
    LeadPricingRequest = __decorate([
        mobx_react_1.observer
    ], LeadPricingRequest);
    return LeadPricingRequest;
}(React.Component));
exports.LeadPricingRequest = LeadPricingRequest;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/BusinessPartner/Modal/BusinessPartnerContent.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/BusinessPartner/Modal/BusinessPartnerContent.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./BusinessPartnerContent.css", function() {
		var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./BusinessPartnerContent.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/BusinessPartner/Modal/BusinessPartnerContent.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var calendar_1 = __webpack_require__("./app/web/src/components/calendar/index.tsx");
var businessPartner_1 = __webpack_require__("./app/common/interfaces/businessPartner.ts");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
// Enumerables
var BusinessPartnerProperties;
(function (BusinessPartnerProperties) {
    BusinessPartnerProperties["shippingAddress1"] = "shippingAddress1";
    BusinessPartnerProperties["shippingAddress2"] = "shippingAddress2";
    BusinessPartnerProperties["shippingCity"] = "shippingCity";
    BusinessPartnerProperties["shippingState"] = "shippingState";
    BusinessPartnerProperties["shippingZipcode"] = "shippingZipcode";
    BusinessPartnerProperties["licenceNumber"] = "licenceNumber";
    BusinessPartnerProperties["licenceExp"] = "licenceExp";
})(BusinessPartnerProperties = exports.BusinessPartnerProperties || (exports.BusinessPartnerProperties = {}));
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/BusinessPartner/Modal/BusinessPartnerContent.css");
var addIcon = __webpack_require__("./app/web/src/assets/plus icon.svg");
// Component
var BusinessPartnerContent = /** @class */ (function (_super) {
    __extends(BusinessPartnerContent, _super);
    function BusinessPartnerContent(props) {
        var _this = _super.call(this, props) || this;
        _this.handleBusinessPartnerDetailsChange = function (property) { return function (e) {
            if (typeof _this.props.store.businessPartner.newRequest[property] === 'string') {
                // @ts-ignore
                _this.props.store.businessPartner.newRequest[property] =
                    e.currentTarget.value;
            }
        }; };
        _this.handleLicenseNumberChange = function (e) {
            _this.props.store.businessPartner.newRequest.licenceNumber =
                e.currentTarget.value;
        };
        _this.handleLicenseExpirationDateChange = function (date) {
            _this.props.store.businessPartner.changeLicenseExpirationDate(date);
        };
        _this.handleSubmit = function () {
            _this.props.store.businessPartner.createBusinessPartner();
        };
        document.documentElement.style.overflow = 'hidden';
        return _this;
    }
    Object.defineProperty(BusinessPartnerContent, "defaultProps", {
        get: function () {
            return {
                status: businessPartner_1.StatusOfBusinessPartner.None,
            };
        },
        enumerable: true,
        configurable: true
    });
    BusinessPartnerContent.prototype.componentWillUnmount = function () {
        document.documentElement.style.overflow = null;
    };
    BusinessPartnerContent.prototype.render = function () {
        var newRequest = this.props.store.businessPartner.newRequest;
        return (React.createElement("div", null,
            React.createElement("div", { className: s.copyAddress },
                React.createElement(action_1.IconButton, { className: s.copyIcon, onClick: this.props.store.businessPartner.copyShippingAddress, label: "Copy address from lead's details", showLabel: true, labelOnRight: false, icon: addIcon })),
            React.createElement("div", { className: classNames(s.fields, s.address) },
                React.createElement(content_1.SectionHeadline, { title: "Physical / shipping address" }),
                React.createElement("div", { className: s.group },
                    React.createElement("label", null,
                        React.createElement("p", null,
                            React.createElement("span", null, "Address 1")),
                        React.createElement("input", { type: "text", value: newRequest.shippingAddress1, onChange: this.handleBusinessPartnerDetailsChange(BusinessPartnerProperties.shippingAddress1) })),
                    React.createElement("label", null,
                        React.createElement("p", null,
                            React.createElement("span", null, "Address 2")),
                        React.createElement("input", { type: "text", value: newRequest.shippingAddress2, onChange: this.handleBusinessPartnerDetailsChange(BusinessPartnerProperties.shippingAddress2) })),
                    React.createElement("label", null,
                        React.createElement("p", null,
                            React.createElement("span", null, "City")),
                        React.createElement("input", { type: "text", value: newRequest.shippingCity, onChange: this.handleBusinessPartnerDetailsChange(BusinessPartnerProperties.shippingCity) })),
                    React.createElement("label", null,
                        React.createElement("p", null,
                            React.createElement("span", null, "State")),
                        React.createElement("input", { type: "text", value: newRequest.shippingState, onChange: this.handleBusinessPartnerDetailsChange(BusinessPartnerProperties.shippingState) })),
                    React.createElement("label", null,
                        React.createElement("p", null,
                            React.createElement("span", null, "ZIP code")),
                        React.createElement("input", { type: "text", value: newRequest.shippingZipcode, onChange: this.handleBusinessPartnerDetailsChange(BusinessPartnerProperties.shippingZipcode) })))),
            React.createElement("div", { className: classNames(s.fields, s.license) },
                React.createElement(content_1.SectionHeadline, { title: "License" }),
                React.createElement("div", { className: s.group },
                    React.createElement("label", null,
                        React.createElement("p", null,
                            React.createElement("span", null, "License number")),
                        React.createElement("input", { type: "text", value: newRequest.licenceNumber, onChange: this.handleLicenseNumberChange })),
                    React.createElement("div", { className: s.licenseExp },
                        React.createElement(calendar_1.DatePickerDropdown, { onChange: this.handleLicenseExpirationDateChange, value: newRequest.licenceExp.date, label: "License expiration" })))),
            React.createElement("div", { className: s.footer },
                React.createElement(indicator_1.SavingIndicator, { align: "right", labels: {
                        saving: 'Saving...',
                        error: newRequest.status ===
                            businessPartner_1.StatusOfBusinessPartner.ErrorCustomerAlreadyCreated
                            ? 'Lead has already been promoted to business partner, reload lead'
                            : 'Could not submit, try again',
                        success: newRequest.promoted,
                    }, status: newRequest.status === businessPartner_1.StatusOfBusinessPartner.Saving
                        ? indicator_1.SavingIndicatorStatus.Saving
                        : newRequest.status === businessPartner_1.StatusOfBusinessPartner.ErrorTryAgain ||
                            newRequest.status ===
                                businessPartner_1.StatusOfBusinessPartner.ErrorCustomerAlreadyCreated
                            ? indicator_1.SavingIndicatorStatus.Error
                            : newRequest.status === businessPartner_1.StatusOfBusinessPartner.Success
                                ? indicator_1.SavingIndicatorStatus.Success
                                : indicator_1.SavingIndicatorStatus.None }),
                React.createElement("button", { className: "boxButton", onClick: this.handleSubmit }, "Make a business partner"))));
    };
    BusinessPartnerContent = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], BusinessPartnerContent);
    return BusinessPartnerContent;
}(React.Component));
exports.BusinessPartnerContent = BusinessPartnerContent;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/BusinessPartner/Modal/BusinessPartnerSlider.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/BusinessPartner/Modal/BusinessPartnerSlider.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./BusinessPartnerSlider.css", function() {
		var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./BusinessPartnerSlider.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/BusinessPartner/Modal/BusinessPartnerSlider.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var react_transition_group_1 = __webpack_require__("./node_modules/react-transition-group/index.js");
var _1 = __webpack_require__("./app/web/src/routes/sales/Lead/BusinessPartner/Modal/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/BusinessPartner/Modal/BusinessPartnerSlider.css");
// Component
var BusinessPartnerSlider = /** @class */ (function (_super) {
    __extends(BusinessPartnerSlider, _super);
    function BusinessPartnerSlider(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(BusinessPartnerSlider.prototype, "animationTime", {
        get: function () {
            return 500;
        },
        enumerable: true,
        configurable: true
    });
    BusinessPartnerSlider.prototype.render = function () {
        var _a;
        var newRequest = this.props.store.businessPartner.newRequest;
        return (React.createElement(react_transition_group_1.CSSTransitionGroup, { component: "div", className: classNames(s.slider, (_a = {},
                _a[s.show] = this.props.show,
                _a)), transitionName: "slide", transitionAppear: true, transitionEnter: true, transitionLeave: true, transitionAppearTimeout: this.animationTime, transitionEnterTimeout: this.animationTime, transitionLeaveTimeout: this.animationTime }, this.props.show && (React.createElement("div", { className: s.shade, key: "busines-partner" },
            React.createElement("div", { className: s.pane },
                React.createElement(_1.BusinessPartnerContent, { status: newRequest.status }))))));
    };
    BusinessPartnerSlider = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], BusinessPartnerSlider);
    return BusinessPartnerSlider;
}(React.Component));
exports.BusinessPartnerSlider = BusinessPartnerSlider;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/BusinessPartner/Modal/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/BusinessPartner/Modal/BusinessPartnerSlider.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/BusinessPartner/Modal/BusinessPartnerContent.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/BusinessPartner/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/BusinessPartner/BusinessPartner.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/BusinessPartner/Modal/index.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Contacts/Contact/LeadContactEditOrCreate.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Contacts/LeadContacts.css");
// Component
var LeadContactEditOrCreate = /** @class */ (function (_super) {
    __extends(LeadContactEditOrCreate, _super);
    function LeadContactEditOrCreate(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFieldValueChange = function (field) { return function (e) {
            // @ts-ignore
            _this.props.store.leadContacts.editedContacts[_this.editIndex][field] =
                e.currentTarget.value;
            _this.props.store.leadContacts.editedContacts[_this.editIndex].modified = true;
        }; };
        _this.handleDefaultValueChange = function (checked, value) {
            if (_this.props.contact.id !== null) {
                _this.props.store.leadContacts.toggleDefaultContact(_this.props.contact.id, checked);
            }
        };
        return _this;
    }
    Object.defineProperty(LeadContactEditOrCreate.prototype, "isNew", {
        get: function () {
            return this.props.contact.id === null ? true : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadContactEditOrCreate.prototype, "editIndex", {
        get: function () {
            return this.props.store.leadContacts.editedContactsIds.indexOf(this.props.contact.id);
        },
        enumerable: true,
        configurable: true
    });
    LeadContactEditOrCreate.prototype.render = function () {
        var _this = this;
        var contact = this.props.contact;
        return this.editIndex !== -1 ? (React.createElement("div", { className: classNames(s.contact, s.contactBeingEdited) },
            (this.isNew && React.createElement("h5", null, "New contact:")) || (React.createElement("h5", null,
                "Edit contact",
                typeof this.props.order !== 'undefined'
                    ? ' #' + this.props.order
                    : '',
                ":")),
            this.props.textFields.map(function (field) {
                return (React.createElement("label", { key: "field-" + field.name },
                    React.createElement("p", null,
                        React.createElement("span", null, field.label)),
                    React.createElement("input", { type: "text", name: field.name, value: contact[field.name], onChange: _this.handleFieldValueChange(field.name) })));
            }),
            React.createElement("div", null,
                React.createElement("br", null),
                React.createElement(action_1.Checkbox, { className: s.primary, onChange: this.handleDefaultValueChange, checked: contact.default, value: true, valueUnchecked: false, label: "Primary contact" })))) : null;
    };
    __decorate([
        mobx_1.computed
    ], LeadContactEditOrCreate.prototype, "isNew", null);
    __decorate([
        mobx_1.computed
    ], LeadContactEditOrCreate.prototype, "editIndex", null);
    __decorate([
        mobx_1.action
    ], LeadContactEditOrCreate.prototype, "handleFieldValueChange", void 0);
    __decorate([
        mobx_1.action
    ], LeadContactEditOrCreate.prototype, "handleDefaultValueChange", void 0);
    LeadContactEditOrCreate = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], LeadContactEditOrCreate);
    return LeadContactEditOrCreate;
}(React.Component));
exports.LeadContactEditOrCreate = LeadContactEditOrCreate;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Contacts/Contact/LeadContactView.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Contacts/LeadContacts.css");
var iconPrimary = __webpack_require__("./app/web/src/assets/primary icon.svg");
var iconSecondary = __webpack_require__("./app/web/src/assets/contact icon.svg");
// Component
var LeadContactView = /** @class */ (function (_super) {
    __extends(LeadContactView, _super);
    function LeadContactView(props) {
        var _this = _super.call(this, props) || this;
        _this.OFFICE_PHONE_LABEL = 'P.';
        _this.MOBILE_PHONE_LABEL = 'M.';
        _this.FAX_LABEL = 'F.';
        _this.EMAIL_LABEL = 'E.';
        return _this;
    }
    Object.defineProperty(LeadContactView.prototype, "fullName", {
        get: function () {
            var contact = this.props.contact;
            var str = [
                contact.firstName || null,
                contact.middleName || null,
                contact.lastName || null,
            ].join(' ');
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadContactView.prototype, "title", {
        get: function () {
            var contact = this.props.contact;
            return contact.title
                ? contact.title.charAt(0).toUpperCase() + contact.title.slice(1)
                : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadContactView.prototype, "contactMeans", {
        get: function () {
            var contact = this.props.contact;
            var means = [];
            if (contact.officePhone) {
                means.push({
                    key: 'office-phone',
                    label: this.OFFICE_PHONE_LABEL,
                    value: contact.officePhone,
                });
            }
            if (contact.mobilePhone) {
                means.push({
                    key: 'mobile-phone',
                    label: this.MOBILE_PHONE_LABEL,
                    value: contact.mobilePhone,
                });
            }
            if (contact.fax) {
                means.push({
                    key: 'fax-number',
                    label: this.FAX_LABEL,
                    value: contact.fax,
                });
            }
            return means;
        },
        enumerable: true,
        configurable: true
    });
    LeadContactView.prototype.render = function () {
        var _this = this;
        var contact = this.props.contact;
        return (React.createElement("div", { className: s.contact },
            React.createElement("div", { className: s.name },
                React.createElement("h1", null, this.fullName)),
            this.title && (React.createElement("div", { className: s.title },
                React.createElement("h2", null, this.title))),
            (this.contactMeans.length > 0 || contact.emailAddress) && (React.createElement("ul", { className: s.means },
                this.contactMeans.map(function (mean) { return (React.createElement("li", { key: mean.key }, ([_this.MOBILE_PHONE_LABEL, _this.OFFICE_PHONE_LABEL].indexOf(mean.label) === 0 && (React.createElement("a", { href: "tel:+1 " + mean.value.replace(/ /g, '') }, mean.label + " " + mean.value))) || React.createElement("p", null, mean.label + " " + mean.value))); }),
                contact.emailAddress && (React.createElement("li", { key: "email-address" },
                    React.createElement("p", { className: s.contactEmailAddress },
                        React.createElement("a", { title: contact.emailAddress, href: "mailto:" + contact.emailAddress }, this.EMAIL_LABEL + ' ' + contact.emailAddress)))))),
            React.createElement("img", { className: s.icon, src: contact.default ? iconPrimary : iconSecondary })));
    };
    __decorate([
        mobx_1.computed
    ], LeadContactView.prototype, "fullName", null);
    __decorate([
        mobx_1.computed
    ], LeadContactView.prototype, "title", null);
    __decorate([
        mobx_1.computed
    ], LeadContactView.prototype, "contactMeans", null);
    LeadContactView = __decorate([
        mobx_react_1.observer
    ], LeadContactView);
    return LeadContactView;
}(React.Component));
exports.LeadContactView = LeadContactView;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Contacts/Contact/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Contacts/Contact/LeadContactView.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Contacts/Contact/LeadContactEditOrCreate.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Contacts/LeadContacts.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Contacts/LeadContacts.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadContacts.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadContacts.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Contacts/LeadContacts.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var LeadContacts_1 = __webpack_require__("./app/web/src/stores/LeadContacts.ts");
var Contact_1 = __webpack_require__("./app/web/src/routes/sales/Lead/Contacts/Contact/index.tsx");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var scroll_1 = __webpack_require__("./app/web/src/events/scroll.ts");
// Enumerables
var EContactFieldName;
(function (EContactFieldName) {
    EContactFieldName["firstName"] = "firstName";
    EContactFieldName["middleName"] = "middleName";
    EContactFieldName["lastName"] = "lastName";
    EContactFieldName["title"] = "title";
    EContactFieldName["emailAddress"] = "emailAddress";
    EContactFieldName["officePhone"] = "officePhone";
    EContactFieldName["mobilePhone"] = "mobilePhone";
    EContactFieldName["fax"] = "fax";
    EContactFieldName["default"] = "default";
})(EContactFieldName = exports.EContactFieldName || (exports.EContactFieldName = {}));
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Contacts/LeadContacts.css");
var addIcon = __webpack_require__("./app/web/src/assets/plus icon.svg");
var cancelIcon = __webpack_require__("./app/web/src/assets/close orange icon.svg");
// Component
var LeadContacts = /** @class */ (function (_super) {
    __extends(LeadContacts, _super);
    function LeadContacts(props) {
        var _this = _super.call(this, props) || this;
        _this.fields = [
            { name: EContactFieldName.firstName, label: 'First name (required)' },
            { name: EContactFieldName.middleName, label: 'Middle name' },
            { name: EContactFieldName.lastName, label: 'Last name (required)' },
            { name: EContactFieldName.title, label: 'Title' },
            { name: EContactFieldName.emailAddress, label: 'Email address' },
            { name: EContactFieldName.officePhone, label: 'Office phone' },
            { name: EContactFieldName.mobilePhone, label: 'Mobile phone' },
            { name: EContactFieldName.fax, label: 'Fax' },
        ];
        _this.list = null;
        _this.referenceList = function (ref) { return (_this.list = ref); };
        _this.createContactSection = null;
        _this.referenceCreateContactSection = function (ref) {
            return (_this.createContactSection = ref);
        };
        _this.handleStartContactCreating = function () {
            if (_this.createContactSection) {
                scroll_1.scrollWindow.to(_this.createContactSection);
            }
            _this.props.store.leadContacts.startCreatingNewContact();
        };
        _this.handleCreate = function () { return __awaiter(_this, void 0, void 0, function () {
            var create;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.store.leadContacts.saveNewContact()];
                    case 1:
                        create = _a.sent();
                        if (create) {
                            scroll_1.scrollWindow.toY(0);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleSave = function () { return __awaiter(_this, void 0, void 0, function () {
            var complete;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.store.leadContacts.saveEditedContacts()];
                    case 1:
                        complete = _a.sent();
                        if (complete) {
                            scroll_1.scrollWindow.toY(0);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    Object.defineProperty(LeadContacts.prototype, "createButton", {
        get: function () {
            var leadContacts = this.props.store.leadContacts;
            if (leadContacts.creating && leadContacts.createContact !== null) {
                return {
                    onClick: leadContacts.cancelCreatingNewContact,
                    label: 'Cancel creating',
                    icon: cancelIcon,
                };
            }
            else {
                return {
                    onClick: this.handleStartContactCreating,
                    label: 'Create contact',
                    icon: addIcon,
                };
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadContacts.prototype, "creatingOnly", {
        get: function () {
            var leadContacts = this.props.store.leadContacts;
            return leadContacts.creating === true && leadContacts.editing === false;
        },
        enumerable: true,
        configurable: true
    });
    LeadContacts.prototype.render = function () {
        var _this = this;
        var _a = this.props.store.leadContacts, saving = _a.saving, errorSaving = _a.errorSaving, editing = _a.editing, creating = _a.creating, combined = _a.combined, createContact = _a.createContact, editedContacts = _a.editedContacts;
        return (React.createElement("div", { className: s.list, ref: this.referenceList },
            (combined.length > 0 && (React.createElement("div", { className: s.results }, combined.map(function (contact, i) {
                var key = "contact-" + contact.id;
                return editing ? (React.createElement(Contact_1.LeadContactEditOrCreate, { key: key + "-edit", order: i + 1, textFields: _this.fields, contact: editedContacts[i] })) : (React.createElement(Contact_1.LeadContactView, { key: key, contact: contact }));
            })))) || (React.createElement("div", { className: s.none },
                React.createElement("p", null,
                    this.props.store.lead.leadTitle,
                    " has no contacts defined"))),
            editing && (React.createElement("div", { className: s.details },
                React.createElement("div", null,
                    React.createElement("button", { className: classNames('boxButton'), onClick: this.handleSave }, "Save changes")),
                React.createElement("div", null,
                    React.createElement(indicator_1.SavingIndicator, { labels: {
                            saving: 'Saving contacts...',
                            error: errorSaving === LeadContacts_1.EContactSavingError.NoName
                                ? 'Name is required'
                                : 'Could not save, try again',
                        }, status: saving === true && errorSaving === LeadContacts_1.EContactSavingError.None
                            ? indicator_1.SavingIndicatorStatus.Saving
                            : errorSaving !== LeadContacts_1.EContactSavingError.None
                                ? indicator_1.SavingIndicatorStatus.Error
                                : indicator_1.SavingIndicatorStatus.None })))),
            React.createElement("div", { ref: this.referenceCreateContactSection },
                React.createElement(action_1.IconButton, { className: s.createContact, labelClassName: s.createContactLabel, onClick: this.createButton.onClick, labelOnRight: true, label: this.createButton.label, showLabel: true, icon: this.createButton.icon }),
                creating && (React.createElement(Contact_1.LeadContactEditOrCreate, { key: "creating-user", textFields: this.fields, contact: createContact }))),
            creating && (React.createElement("div", { className: s.details },
                React.createElement("div", null,
                    React.createElement("button", { className: classNames('boxButton'), onClick: this.handleCreate }, "Create contact")),
                React.createElement("div", null,
                    React.createElement(indicator_1.SavingIndicator, { labels: {
                            saving: 'Creating contact...',
                            error: errorSaving === LeadContacts_1.EContactSavingError.NoName
                                ? 'Name is required'
                                : 'Could not create, try again',
                        }, status: saving === true && errorSaving === LeadContacts_1.EContactSavingError.None
                            ? indicator_1.SavingIndicatorStatus.Saving
                            : errorSaving !== LeadContacts_1.EContactSavingError.None
                                ? indicator_1.SavingIndicatorStatus.Error
                                : indicator_1.SavingIndicatorStatus.None }))))));
    };
    __decorate([
        mobx_1.computed
    ], LeadContacts.prototype, "createButton", null);
    __decorate([
        mobx_1.computed
    ], LeadContacts.prototype, "creatingOnly", null);
    __decorate([
        mobx_1.action
    ], LeadContacts.prototype, "handleCreate", void 0);
    __decorate([
        mobx_1.action
    ], LeadContacts.prototype, "handleSave", void 0);
    LeadContacts = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], LeadContacts);
    return LeadContacts;
}(React.Component));
exports.LeadContacts = LeadContacts;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Contacts/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Contacts/LeadContacts.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Details/LeadDetailsMaster.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Details/LeadDetailsMaster.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadDetailsMaster.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadDetailsMaster.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Details/LeadDetailsMaster.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var user_1 = __webpack_require__("./app/common/interfaces/user.ts");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var list_1 = __webpack_require__("./app/web/src/components/list/index.tsx");
var scroll_1 = __webpack_require__("./app/web/src/events/scroll.ts");
var toString_1 = __webpack_require__("./node_modules/lodash-es/toString.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var Leads_1 = __webpack_require__("./app/web/src/stores/Leads.ts");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
var provider_1 = __webpack_require__("./app/common/interfaces/provider.ts");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Details/LeadDetailsMaster.css");
var companyIcon = __webpack_require__("./app/web/src/assets/document profile icon.svg");
var businessTypeIcon = __webpack_require__("./app/web/src/assets/briefcase icon.svg");
var licenseTypeIcon = __webpack_require__("./app/web/src/assets/license icon.svg");
var addressIcon = __webpack_require__("./app/web/src/assets/building icon.svg");
var contactIcon = __webpack_require__("./app/web/src/assets/conversation icon.svg");
var groupIcon = __webpack_require__("./app/web/src/assets/documents icon.svg");
var arrowIcon = __webpack_require__("./app/web/src/assets/blue arrow.svg");
var repIcon = __webpack_require__("./app/web/src/assets/contact icon.svg");
var primaryIcon = __webpack_require__("./app/web/src/assets/primary icon.svg");
var idIcon = __webpack_require__("./app/web/src/assets/id icon.svg");
var deleteIcon = __webpack_require__("./app/web/src/assets/close orange icon.svg");
// Component
var LeadDetailsMaster = /** @class */ (function (_super) {
    __extends(LeadDetailsMaster, _super);
    function LeadDetailsMaster(props) {
        var _this = _super.call(this, props) || this;
        // Select lead
        _this.handleLeadSelect = function (id) { return function (e) {
            App_1.browserHistory.push('/sales/lead/' + id);
        }; };
        _this.leadGroupDropdown = null;
        _this.referenceLeadGroupDropdown = function (ref) {
            return (_this.leadGroupDropdown = ref);
        };
        _this.salesRepsDropdown = null;
        _this.referenceSalesRepsDropdown = function (ref) {
            return (_this.salesRepsDropdown = ref);
        };
        _this.providerTypeDropdown = null;
        _this.referenceProviderTypeDropdown = function (ref) {
            return (_this.providerTypeDropdown = ref);
        };
        _this.dispenserClassDropdown = null;
        _this.referenceDispenserClassDropdown = function (ref) {
            return (_this.dispenserClassDropdown = ref);
        };
        _this.licenseTypeDropdown = null;
        _this.referenceLicenseTypeDropdown = function (ref) {
            return (_this.licenseTypeDropdown = ref);
        };
        _this.loadLeadGroups = function () {
            var _a = _this.props.store, leadGroup = _a.leadGroup, lead = _a.lead;
            if (leadGroup.showList) {
                _this.props.store.leadGroup.showList = false;
            }
            else {
                _this.props.store.leadGroup.showList = true;
                leadGroup.fetchLeadGroupDetails(lead.openLeadDetails.providerGroup.id);
            }
        };
        _this.handleAddingSalesRep = function (selection) {
            if (selection.value) {
                var filteredReps = _this.props.store.users.salesReps.filter(function (rep) { return rep.id === selection.value; });
                if (filteredReps.length > 0) {
                    var rep = filteredReps[0];
                    var otherRepsCount = _this.props.store.lead.editedOpenLeadDetails
                        .salesReps.length;
                    _this.props.store.lead.editedOpenLeadDetails.salesReps = [
                        {
                            id: rep.id,
                            email: rep.email,
                            username: rep.username,
                            name: rep.name,
                            slpcode: rep.slpcode,
                            primary: otherRepsCount <= 0 ? 1 : 0,
                            status: true,
                        }
                    ].concat(_this.props.store.lead.editedOpenLeadDetails.salesReps.slice());
                    _this.props.store.lead.editedOpenLeadDetails.modified = true;
                }
            }
            if (_this.salesRepsDropdown) {
                _this.salesRepsDropdown.closeDropdown();
            }
        };
        _this.handleChangingSalesRepHierarchy = function (salesRepId) { return function (checked, value) {
            _this.props.store.lead.editedOpenLeadDetails.salesReps = _this.props.store.lead.editedOpenLeadDetails.salesReps
                .slice()
                .map(function (rep) {
                if (rep.id === salesRepId) {
                    return __assign({}, rep, { primary: checked ? 1 : 0 });
                }
                else {
                    return __assign({}, rep, { primary: checked ? 0 : rep.primary });
                }
            });
            _this.props.store.lead.editedOpenLeadDetails.modified = true;
        }; };
        _this.handleRemovingSalesRep = function (salesRepId) { return function (e) {
            var salesRepIndex = -1;
            _this.props.store.lead.editedOpenLeadDetails.salesReps.some(function (rep, repIndex) {
                if (rep.id === salesRepId) {
                    salesRepIndex = repIndex;
                    return true;
                }
                return false;
            });
            if (salesRepIndex !== -1) {
                _this.props.store.lead.editedOpenLeadDetails.salesReps = _this.props.store.lead.editedOpenLeadDetails.salesReps.slice(0, salesRepIndex).concat(_this.props.store.lead.editedOpenLeadDetails.salesReps.slice(salesRepIndex + 1));
                // If primary rep has been removed, turn first rep into primary rep
                var isAnyRepPrimary = _this.props.store.lead.editedOpenLeadDetails.salesReps.some(function (rep) { return (rep.primary === 1 ? true : false); });
                if (isAnyRepPrimary === false &&
                    _this.props.store.lead.editedOpenLeadDetails.salesReps.length > 0) {
                    _this.props.store.lead.editedOpenLeadDetails.salesReps[0].primary = 1;
                }
                _this.props.store.lead.editedOpenLeadDetails.modified = true;
            }
        }; };
        _this.handleLeadGroupChange = function (changed) {
            if (changed.value === 'assign') {
                _this.props.store.leadGroup.modalStatus =
                    provider_1.LeadGroupModalStatus.OpenedOnGroupList;
                _this.props.store.leadGroup.fetchLeadGroups();
            }
            else if (changed.value === 'remove') {
                _this.props.store.leadGroup.addLeadToGroup(null);
            }
            else if (changed.value === 'name') {
                // ??
            }
            if (_this.leadGroupDropdown) {
                _this.leadGroupDropdown.closeDropdown();
            }
        };
        _this.handleProviderTypeChange = function (changed) {
            var editedOpenLeadDetails = _this.props.store.lead.editedOpenLeadDetails;
            editedOpenLeadDetails.providerTypeCode = changed.value;
            editedOpenLeadDetails.providerTypeName = changed.label;
            editedOpenLeadDetails.modified = true;
            if (_this.providerTypeDropdown) {
                _this.providerTypeDropdown.closeDropdown();
            }
        };
        _this.handleDispenserClassChange = function (changed) {
            var editedOpenLeadDetails = _this.props.store.lead.editedOpenLeadDetails;
            editedOpenLeadDetails.dispenserClassCode = changed.value;
            editedOpenLeadDetails.dispenserClassName = changed.label;
            editedOpenLeadDetails.modified = true;
            if (_this.dispenserClassDropdown) {
                _this.dispenserClassDropdown.closeDropdown();
            }
        };
        _this.handleTypeOfLicenseChange = function (changed) {
            _this.props.store.lead.editedOpenLeadDetails.drugLicenseTypeId =
                changed.value;
            _this.props.store.lead.editedOpenLeadDetails.drugLicenseTypeName =
                changed.label;
            _this.props.store.lead.editedOpenLeadDetails.modified = true;
            if (_this.licenseTypeDropdown) {
                _this.licenseTypeDropdown.closeDropdown();
            }
        };
        _this.handleOpenLeadDetailsChange = function (property) { return function (e) {
            _this.props.store.lead.editedOpenLeadDetails[property] =
                e.currentTarget.value;
            _this.props.store.lead.editedOpenLeadDetails.modified = true;
        }; };
        _this.handleSaveChanges = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.store.lead.saveUpdatedLeadDetails()];
                    case 1:
                        _a.sent();
                        scroll_1.scrollWindow.toY(0);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.npiUrl = function (npi) {
            return "http://www.hipaaspace.com/Medical_Billing/Coding/NPI/Codes/NPI_" + npi + ".aspx";
        };
        _this.props.store.lead.fetchBusinessTypes();
        _this.props.store.lead.fetchDrugLicenseTypes();
        return _this;
    }
    Object.defineProperty(LeadDetailsMaster.prototype, "otherLeadsFromSameBusinessGroup", {
        get: function () {
            var _a = this.props.store, lead = _a.lead, leadGroup = _a.leadGroup;
            return !leadGroup.loading
                ? leadGroup.openedGroup.provider.filter(function (provider) { return provider.databaseId !== lead.openLeadId; })
                : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadDetailsMaster.prototype, "businessGroupName", {
        get: function () {
            var openLeadDetails = this.props.store.lead.openLeadDetails;
            return openLeadDetails !== null &&
                openLeadDetails.providerGroup !== null &&
                typeof openLeadDetails.providerGroup.name !== 'undefined' &&
                openLeadDetails.providerGroup.name !== null
                ? openLeadDetails.providerGroup.name
                : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadDetailsMaster.prototype, "leadSalesReps", {
        get: function () {
            var lead = this.props.store.lead;
            return lead.openLeadEditingDetails && lead.editedOpenLeadDetails !== null
                ? lead.editedOpenLeadDetails.salesReps
                : lead.openLeadDetails.salesReps;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadDetailsMaster.prototype, "leadSalesRepsIds", {
        get: function () {
            return this.leadSalesReps.map(function (rep) { return rep.id; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadDetailsMaster.prototype, "sortedLeadSalesReps", {
        get: function () {
            return this.leadSalesReps.length > 0
                ? this.leadSalesReps.sort(function (repA, repB) {
                    return repA.primary && !repB.primary
                        ? -1
                        : !repA.primary && repB.primary
                            ? 1
                            : 0;
                })
                : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadDetailsMaster.prototype, "commaSeparatedStringOfLeadsSalesReps", {
        get: function () {
            return this.sortedLeadSalesReps
                .map(function (rep) { return rep.name || rep.username; })
                .join(', ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadDetailsMaster.prototype, "salesRepsOptions", {
        get: function () {
            var _this = this;
            var users = this.props.store.users;
            return users.allActiveSalesUsers.length > 0
                ? users.allActiveSalesUsers
                    .filter(function (rep) {
                    if (rep.slpcode === null) {
                        return false;
                    }
                    var foundIndex = _this.leadSalesRepsIds.indexOf(rep.id);
                    if (foundIndex !== -1) {
                        return false;
                    }
                    return true;
                })
                    .map(function (user) { return ({
                    value: user.id,
                    label: user.name,
                }); })
                : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadDetailsMaster.prototype, "providerTypesOptions", {
        get: function () {
            var providerTypes = this.props.store.leads.providerTypes;
            return providerTypes.list.map(function (type) { return ({
                value: type.code,
                label: type.name,
            }); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadDetailsMaster.prototype, "dispenserClassesOptions", {
        get: function () {
            var providerDispenserClasses = this.props.store.leads.providerDispenserClasses;
            return providerDispenserClasses.list.map(function (dispenserClass) { return ({
                value: dispenserClass.code,
                label: dispenserClass.name,
            }); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadDetailsMaster.prototype, "drugLicenseTypeOptions", {
        get: function () {
            var lead = this.props.store.lead;
            return lead.drugLicenseTypesLength
                ? lead.drugLicenseTypes.map(function (type) { return ({
                    value: type.id,
                    label: type.name,
                }); })
                : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadDetailsMaster.prototype, "openLeadProviderType", {
        get: function () {
            var _a = this.props.store, providerTypes = _a.leads.providerTypes, openLeadDetails = _a.lead.openLeadDetails;
            if (openLeadDetails === null ||
                (openLeadDetails && openLeadDetails.type === null)) {
                return null;
            }
            var index = -1;
            providerTypes.list.some(function (type, typeIndex) {
                if (openLeadDetails.type === type.code) {
                    index = typeIndex;
                    return true;
                }
                return false;
            });
            return index !== -1 ? providerTypes.list[index] : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadDetailsMaster.prototype, "openLeadDispenserClass", {
        get: function () {
            var _a = this.props.store, providerDispenserClasses = _a.leads.providerDispenserClasses, openLeadDetails = _a.lead.openLeadDetails;
            if (openLeadDetails === null ||
                (openLeadDetails && openLeadDetails.dispenserClass === null)) {
                return null;
            }
            var index = -1;
            providerDispenserClasses.list.some(function (dispenserClass, dispenserClassIndex) {
                if (openLeadDetails.dispenserClass === dispenserClass.code) {
                    index = dispenserClassIndex;
                    return true;
                }
                return false;
            });
            return index !== -1 ? providerDispenserClasses.list[index] : null;
        },
        enumerable: true,
        configurable: true
    });
    LeadDetailsMaster.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d;
        var _e = this.props.store.lead, openLeadId = _e.openLeadId, openLeadAddress = _e.openLeadAddress, openLeadDetails = _e.openLeadDetails, editedOpenLeadDetails = _e.editedOpenLeadDetails, openLeadEditingDetails = _e.openLeadEditingDetails, openLeadEditingDetailsSaving = _e.openLeadEditingDetailsSaving, openLeadEditingDetailsSavingError = _e.openLeadEditingDetailsSavingError, drugLicenseTypesLength = _e.drugLicenseTypesLength;
        var leadGroup = this.props.store.leadGroup;
        var user = this.props.store.user;
        return openLeadId !== null ? (React.createElement("div", { className: classNames((_a = {}, _a[s.editing] = openLeadEditingDetails, _a)) },
            openLeadDetails !== null &&
                (openLeadDetails.dba ||
                    openLeadDetails.legalBusName ||
                    openLeadDetails.cardcode ||
                    openLeadEditingDetails) && (React.createElement("div", { title: openLeadDetails.dba || openLeadDetails.legalBusName
                    ? 'Name'
                    : undefined, className: s.group },
                React.createElement("img", { className: s.icon, src: companyIcon }),
                openLeadDetails.createdManually && openLeadEditingDetails && (React.createElement("div", null,
                    React.createElement("h5", null, "Name:"),
                    React.createElement("label", { className: s.editSection },
                        React.createElement("p", null,
                            React.createElement("span", null, "Provider ID")),
                        React.createElement("input", { type: "text", value: editedOpenLeadDetails.providerId, onChange: this.handleOpenLeadDetailsChange(Leads_1.LeadEditableProperties.providerId) })))),
                (openLeadDetails.dba && openLeadEditingDetails === false && (React.createElement("h1", { className: s.companyTitle }, openLeadDetails.dba || 'Company name'))) ||
                    (openLeadEditingDetails && (React.createElement("label", { className: s.editSection },
                        React.createElement("p", null,
                            React.createElement("span", null, "DBA")),
                        React.createElement("input", { type: "text", value: editedOpenLeadDetails.dba, onChange: this.handleOpenLeadDetailsChange(Leads_1.LeadEditableProperties.dba) })))),
                (openLeadDetails.legalBusName &&
                    openLeadEditingDetails === false && (React.createElement("h3", { className: s.companyLegalName }, openLeadDetails.legalBusName || 'Legal name'))) ||
                    (openLeadEditingDetails && (React.createElement("label", { className: s.editSection },
                        React.createElement("p", null,
                            React.createElement("span", null, "Legal business name")),
                        React.createElement("input", { type: "text", value: editedOpenLeadDetails.legalBusName, onChange: this.handleOpenLeadDetailsChange(Leads_1.LeadEditableProperties.legalBusName) })))),
                openLeadDetails.cardcode !== null &&
                    toString_1.default(openLeadDetails.cardcode) !== '0' &&
                    openLeadEditingDetails === false && (React.createElement("h4", { className: s.cardcode },
                    React.createElement("span", null, "Card code:"),
                    React.createElement("strong", null, openLeadDetails.cardcode))))),
            openLeadDetails !== null &&
                ((openLeadEditingDetails === false &&
                    openLeadDetails.providerGroup &&
                    openLeadDetails.providerGroup.id) ||
                    openLeadEditingDetails === true) && (React.createElement("div", { className: classNames(s.group, s.leadGroup, (_b = {},
                    _b[s.show] = leadGroup.showList,
                    _b[s.edit] = openLeadEditingDetails === true,
                    _b)) },
                openLeadEditingDetails === false &&
                    openLeadDetails.providerGroup &&
                    openLeadDetails.providerGroup.id && (React.createElement("div", null,
                    React.createElement("h4", { title: "Group" },
                        "Group:",
                        ' ',
                        React.createElement("strong", null, openLeadDetails.providerGroup.name)),
                    React.createElement("img", { className: s.icon, src: groupIcon, width: "16", height: "16" }),
                    leadGroup.openedGroup !== null &&
                        typeof leadGroup.openedGroup.provider !== 'undefined' &&
                        leadGroup.openedGroup.provider.length > 1 && (React.createElement(action_1.IconButton, { onClick: this.loadLeadGroups, icon: arrowIcon, showLabel: false, iconClassName: classNames(s.arrow, (_c = {},
                            _c[s.show] = leadGroup.showList,
                            _c)) })),
                    leadGroup.openedGroup !== null &&
                        typeof leadGroup.openedGroup.provider !== 'undefined' &&
                        leadGroup.openedGroup.provider.length > 1 && (React.createElement("ul", { className: classNames(s.leadGroupList, (_d = {},
                            _d[s.show] = leadGroup.showList,
                            _d)) }, this.otherLeadsFromSameBusinessGroup.map(function (lead, leadIndex) { return (React.createElement("li", { key: lead.databaseId },
                        ((user.userType === user_1.UserType.SalesManager ||
                            user.slpcode === lead.slpcode) && (React.createElement("button", { className: classNames(s.providerInGroup, s.providerInGroupButton), onClick: _this.handleLeadSelect(lead.databaseId) },
                            React.createElement("strong", null, lead.dba),
                            React.createElement("span", null, lead.legalBusName),
                            React.createElement("b", null, "Go to lead")))) || (React.createElement("p", { className: s.providerInGroup },
                            React.createElement("strong", null, lead.dba),
                            React.createElement("span", null, lead.legalBusName),
                            React.createElement("em", null, "Assigned to other sales rep"))),
                        React.createElement("p", { className: s.providerInGroupCounter },
                            "#",
                            leadIndex + 1))); }))))),
                openLeadEditingDetails === true && (React.createElement("div", null,
                    React.createElement("h5", null, "Business group"),
                    React.createElement(list_1.DropdownContainer, { ref: this.referenceLeadGroupDropdown, value: this.businessGroupName || 'No group', label: undefined },
                        React.createElement(list_1.OptionsList, { onChange: this.handleLeadGroupChange, label: "Change business group", value: "Business group", options: leadGroup.groupDropdown })))))),
            openLeadDetails !== null &&
                openLeadEditingDetails === false &&
                openLeadDetails.npiNumber && (React.createElement("div", { className: classNames(s.group, s.npiNumber) },
                React.createElement("img", { className: s.icon, src: idIcon }),
                React.createElement("a", { href: this.npiUrl(openLeadDetails.npiNumber), target: "_blank" },
                    React.createElement("span", null, "NPI: "),
                    React.createElement("strong", null, openLeadDetails.npiNumber),
                    React.createElement("img", { src: arrowIcon, alt: "" })))),
            openLeadDetails !== null &&
                (openLeadEditingDetails === false ||
                    (openLeadEditingDetails === true &&
                        this.props.store.user.userType === user_1.UserType.SalesManager)) && (React.createElement("div", { className: classNames(s.group, s.salesReps) },
                openLeadEditingDetails === false && (React.createElement("img", { className: s.icon, src: repIcon })),
                (openLeadEditingDetails === false && (React.createElement("h4", null,
                    React.createElement("span", null, openLeadDetails.salesReps.length > 1
                        ? 'Reps:'
                        : openLeadDetails.salesReps.length === 1
                            ? 'Rep:'
                            : 'No sales reps assigned'),
                    openLeadDetails.salesReps.length > 0 && (React.createElement("strong", null, this.commaSeparatedStringOfLeadsSalesReps))))) ||
                    (openLeadEditingDetails && (React.createElement("div", null,
                        React.createElement("h5", null, "Assigned sales reps:"),
                        React.createElement(list_1.DropdownContainer, { ref: this.referenceSalesRepsDropdown, value: this.salesRepsOptions.length > 0
                                ? undefined
                                : 'No additional reps available', label: this.salesRepsOptions.length > 0
                                ? 'Add sales rep'
                                : undefined },
                            React.createElement(list_1.OptionsList, { label: "Sales people", value: null, onChange: this.handleAddingSalesRep, options: this.leadSalesReps.length >= 2
                                    ? [
                                        {
                                            value: null,
                                            label: 'Only two sales reps are allowed. ' +
                                                'Unassign other reps first.',
                                        },
                                    ]
                                    : this.salesRepsOptions.length > 0
                                        ? [
                                            {
                                                value: null,
                                                label: 'None',
                                            }
                                        ].concat(this.salesRepsOptions) : [
                                        {
                                            value: null,
                                            label: 'No reps available',
                                        },
                                    ] })),
                        this.leadSalesReps.map(function (rep) { return (React.createElement("div", { key: rep.id, className: s.editRepGroup },
                            React.createElement("div", { className: s.editRepGroupContact },
                                React.createElement("p", null, rep.name || rep.username),
                                React.createElement("img", { src: repIcon, alt: "" })),
                            React.createElement("div", { className: s.editRepGroupActions },
                                React.createElement(action_1.Checkbox, { onChange: _this.handleChangingSalesRepHierarchy(rep.id), checked: rep.primary ? true : false, value: true, valueUnchecked: false, label: rep.primary ? 'Main rep' : 'Secondary rep' }),
                                _this.leadSalesReps.length >= 0 && (React.createElement(action_1.IconButton, { onClick: _this.handleRemovingSalesRep(rep.id), label: "Delete", showLabel: false, icon: deleteIcon, labelOnRight: false, removePadding: true }))))); })))))),
            openLeadDetails !== null && (React.createElement("div", { className: classNames(s.group, s.relationTypeGroup) },
                openLeadEditingDetails === false &&
                    (this.openLeadProviderType !== null ||
                        this.openLeadDispenserClass !== null) && (React.createElement("img", { className: s.icon, src: businessTypeIcon })),
                (openLeadEditingDetails === false &&
                    (this.openLeadProviderType !== null ||
                        this.openLeadDispenserClass !== null) && (React.createElement("div", null,
                    this.openLeadProviderType && (React.createElement("h4", { title: "Business type" }, this.openLeadProviderType.name)),
                    this.openLeadDispenserClass && (React.createElement("h4", { title: "Dispenser class" }, this.openLeadDispenserClass.name))))) ||
                    (openLeadEditingDetails && (React.createElement("div", null,
                        React.createElement("h5", null, "Business type:"),
                        React.createElement(list_1.DropdownContainer, { ref: this.referenceProviderTypeDropdown, value: editedOpenLeadDetails.providerTypeName || undefined, label: editedOpenLeadDetails.providerTypeName
                                ? undefined
                                : 'Select business type' },
                            React.createElement(list_1.OptionsList, { label: "Business types", onChange: this.handleProviderTypeChange, value: editedOpenLeadDetails.providerTypeCode, options: this.providerTypesOptions })),
                        React.createElement("h5", null, "Dispenser class:"),
                        React.createElement(list_1.DropdownContainer, { ref: this.referenceDispenserClassDropdown, value: editedOpenLeadDetails.dispenserClassName || undefined, label: editedOpenLeadDetails.dispenserClassName
                                ? undefined
                                : 'Select dispenser class name' },
                            React.createElement(list_1.OptionsList, { label: "Dispenser classes", onChange: this.handleDispenserClassChange, value: editedOpenLeadDetails.dispenserClassCode, options: this.dispenserClassesOptions }))))))),
            openLeadDetails !== null && this.drugLicenseTypeOptions.length && (React.createElement("div", { className: classNames(s.group, s.drugLicenseTypeGroup) },
                openLeadEditingDetails === false &&
                    openLeadDetails.typeOfDrugLicenseData !== null &&
                    openLeadDetails.typeOfDrugLicenseData.id !== null && (React.createElement("img", { className: s.icon, src: licenseTypeIcon })),
                (openLeadEditingDetails === false &&
                    openLeadDetails.typeOfDrugLicenseData !== null &&
                    openLeadDetails.typeOfDrugLicenseData.id !== null && (React.createElement("h4", { title: "License type" }, openLeadDetails.typeOfDrugLicenseData.name))) ||
                    (openLeadEditingDetails && (React.createElement("div", null,
                        React.createElement("h5", null, "License type:"),
                        drugLicenseTypesLength && (React.createElement(list_1.DropdownContainer, { ref: this.referenceLicenseTypeDropdown, value: editedOpenLeadDetails.drugLicenseTypeName, label: editedOpenLeadDetails.drugLicenseTypeName
                                ? undefined
                                : 'Select license type' },
                            React.createElement(list_1.OptionsList, { label: "License types", onChange: this.handleTypeOfLicenseChange, value: editedOpenLeadDetails.drugLicenseTypeId, options: this.drugLicenseTypeOptions })))))))),
            openLeadDetails !== null &&
                (openLeadAddress || openLeadEditingDetails) && (React.createElement("div", { className: s.group },
                React.createElement("img", { className: s.icon, src: addressIcon }),
                (openLeadEditingDetails && (React.createElement("div", null,
                    React.createElement("h5", null, "Address:"),
                    React.createElement("label", { className: s.editSection },
                        React.createElement("p", null,
                            React.createElement("span", null, "Address 1")),
                        React.createElement("input", { type: "text", value: editedOpenLeadDetails.plAddress1, onChange: this.handleOpenLeadDetailsChange(Leads_1.LeadEditableProperties.plAddress1) })),
                    React.createElement("label", { className: s.editSection },
                        React.createElement("p", null,
                            React.createElement("span", null, "Address 2")),
                        React.createElement("input", { type: "text", value: editedOpenLeadDetails.plAddress2, onChange: this.handleOpenLeadDetailsChange(Leads_1.LeadEditableProperties.plAddress2) })),
                    React.createElement("label", { className: s.editSection },
                        React.createElement("p", null,
                            React.createElement("span", null, "City")),
                        React.createElement("input", { type: "text", value: editedOpenLeadDetails.plCity, onChange: this.handleOpenLeadDetailsChange(Leads_1.LeadEditableProperties.plCity) })),
                    React.createElement("label", { className: s.editSection },
                        React.createElement("p", null,
                            React.createElement("span", null, "State")),
                        React.createElement("input", { type: "text", value: editedOpenLeadDetails.plState, onChange: this.handleOpenLeadDetailsChange(Leads_1.LeadEditableProperties.plState) })),
                    React.createElement("label", { className: s.editSection },
                        React.createElement("p", null,
                            React.createElement("span", null, "ZIP code")),
                        React.createElement("input", { type: "text", value: editedOpenLeadDetails.plZipcode, onChange: this.handleOpenLeadDetailsChange(Leads_1.LeadEditableProperties.plZipcode) }))))) ||
                    (openLeadAddress && (React.createElement("ul", { title: "Location" },
                        React.createElement("li", null,
                            React.createElement("p", null, openLeadAddress))))))),
            openLeadDetails !== null &&
                (openLeadDetails.plPhone ||
                    openLeadDetails.plFax ||
                    openLeadEditingDetails) && (React.createElement("div", { className: s.group },
                React.createElement("img", { className: s.icon, src: contactIcon }),
                (openLeadEditingDetails && (React.createElement("div", null,
                    React.createElement("h5", null, "Contact:"),
                    React.createElement("label", { className: s.editSection },
                        React.createElement("p", null,
                            React.createElement("span", null, "Phone number")),
                        React.createElement("input", { type: "text", value: editedOpenLeadDetails.plPhone, onChange: this.handleOpenLeadDetailsChange(Leads_1.LeadEditableProperties.plPhone) })),
                    React.createElement("label", { className: s.editSection },
                        React.createElement("p", null,
                            React.createElement("span", null, "Phone number extension")),
                        React.createElement("input", { type: "text", value: editedOpenLeadDetails.plExt, onChange: this.handleOpenLeadDetailsChange(Leads_1.LeadEditableProperties.plExt) })),
                    React.createElement("label", { className: s.editSection },
                        React.createElement("p", null,
                            React.createElement("span", null, "Fax number")),
                        React.createElement("input", { type: "text", value: editedOpenLeadDetails.plFax, onChange: this.handleOpenLeadDetailsChange(Leads_1.LeadEditableProperties.plFax) })),
                    React.createElement("label", { className: s.editSection },
                        React.createElement("p", null,
                            React.createElement("span", null, "Email address")),
                        React.createElement("input", { type: "text", value: editedOpenLeadDetails.plEmail, onChange: this.handleOpenLeadDetailsChange(Leads_1.LeadEditableProperties.plEmail) }))))) ||
                    ((openLeadDetails.plPhone ||
                        openLeadDetails.plExt ||
                        openLeadDetails.plFax ||
                        openLeadDetails.plEmail) && (React.createElement("ul", { title: "Contact" },
                        openLeadDetails.plPhone && (React.createElement("li", null,
                            React.createElement("p", null,
                                React.createElement("a", { href: "tel:+1 " + openLeadDetails.plPhone.replace(/ /g, '') }, "P. " + openLeadDetails.plPhone)))),
                        openLeadDetails.plExt && (React.createElement("li", null,
                            React.createElement("p", null,
                                React.createElement("span", null, "Extension: " + openLeadDetails.plExt)))),
                        openLeadDetails.plFax && (React.createElement("li", null,
                            React.createElement("p", null,
                                React.createElement("span", null, "F: " + openLeadDetails.plFax)))),
                        openLeadDetails.plEmail && (React.createElement("li", null,
                            React.createElement("p", null,
                                React.createElement("a", { title: openLeadDetails.plEmail, href: "mailto:" + openLeadDetails.plEmail }, "E. " + openLeadDetails.plEmail))))))))),
            openLeadEditingDetails && (React.createElement("div", { className: s.details },
                React.createElement("div", null,
                    React.createElement("button", { className: "boxButton", onClick: this.handleSaveChanges }, "Save changes")),
                React.createElement("div", null,
                    React.createElement(indicator_1.SavingIndicator, { labels: {
                            saving: 'Saving changes...',
                            error: 'Could not save changes, try again',
                        }, status: openLeadEditingDetailsSavingError
                            ? indicator_1.SavingIndicatorStatus.Error
                            : openLeadEditingDetailsSaving
                                ? indicator_1.SavingIndicatorStatus.Saving
                                : indicator_1.SavingIndicatorStatus.None })))))) : null;
    };
    __decorate([
        mobx_1.computed
    ], LeadDetailsMaster.prototype, "otherLeadsFromSameBusinessGroup", null);
    __decorate([
        mobx_1.computed
    ], LeadDetailsMaster.prototype, "businessGroupName", null);
    __decorate([
        mobx_1.computed
    ], LeadDetailsMaster.prototype, "leadSalesReps", null);
    __decorate([
        mobx_1.computed
    ], LeadDetailsMaster.prototype, "leadSalesRepsIds", null);
    __decorate([
        mobx_1.computed
    ], LeadDetailsMaster.prototype, "sortedLeadSalesReps", null);
    __decorate([
        mobx_1.computed
    ], LeadDetailsMaster.prototype, "commaSeparatedStringOfLeadsSalesReps", null);
    __decorate([
        mobx_1.computed
    ], LeadDetailsMaster.prototype, "salesRepsOptions", null);
    __decorate([
        mobx_1.computed
    ], LeadDetailsMaster.prototype, "providerTypesOptions", null);
    __decorate([
        mobx_1.computed
    ], LeadDetailsMaster.prototype, "dispenserClassesOptions", null);
    __decorate([
        mobx_1.computed
    ], LeadDetailsMaster.prototype, "drugLicenseTypeOptions", null);
    __decorate([
        mobx_1.computed
    ], LeadDetailsMaster.prototype, "openLeadProviderType", null);
    __decorate([
        mobx_1.computed
    ], LeadDetailsMaster.prototype, "openLeadDispenserClass", null);
    __decorate([
        mobx_1.action
    ], LeadDetailsMaster.prototype, "handleLeadSelect", void 0);
    __decorate([
        mobx_1.action
    ], LeadDetailsMaster.prototype, "loadLeadGroups", void 0);
    __decorate([
        mobx_1.action
    ], LeadDetailsMaster.prototype, "handleAddingSalesRep", void 0);
    __decorate([
        mobx_1.action
    ], LeadDetailsMaster.prototype, "handleChangingSalesRepHierarchy", void 0);
    __decorate([
        mobx_1.action
    ], LeadDetailsMaster.prototype, "handleRemovingSalesRep", void 0);
    __decorate([
        mobx_1.action
    ], LeadDetailsMaster.prototype, "handleLeadGroupChange", void 0);
    __decorate([
        mobx_1.action
    ], LeadDetailsMaster.prototype, "handleProviderTypeChange", void 0);
    __decorate([
        mobx_1.action
    ], LeadDetailsMaster.prototype, "handleDispenserClassChange", void 0);
    __decorate([
        mobx_1.action
    ], LeadDetailsMaster.prototype, "handleTypeOfLicenseChange", void 0);
    __decorate([
        mobx_1.action
    ], LeadDetailsMaster.prototype, "handleOpenLeadDetailsChange", void 0);
    LeadDetailsMaster = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], LeadDetailsMaster);
    return LeadDetailsMaster;
}(React.Component));
exports.LeadDetailsMaster = LeadDetailsMaster;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Details/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Details/LeadDetailsMaster.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Disable/LeadDisable.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Disable/LeadDisable.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadDisable.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadDisable.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Disable/LeadDisable.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Disable/LeadDisable.css");
// Component
var LeadDisable = /** @class */ (function (_super) {
    __extends(LeadDisable, _super);
    function LeadDisable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleModalClose = function () {
            _this.props.store.lead.closeDisableLeadModal();
        };
        _this.handleDisableLead = function () {
            _this.props.store.lead.disableLead(_this.props.store.lead.openLeadId);
        };
        return _this;
    }
    Object.defineProperty(LeadDisable.prototype, "leadId", {
        get: function () {
            var lead = this.props.store.lead;
            return lead.openLeadDetails !== null
                ? lead.openLeadDetails.providerId.toString()
                : lead.openLeadId
                    ? lead.openLeadId.toString()
                    : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadDisable.prototype, "leadDba", {
        get: function () {
            var lead = this.props.store.lead;
            return lead.openLeadDetails !== null && lead.openLeadDetails.dba
                ? lead.openLeadDetails.dba.trim()
                : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadDisable.prototype, "leadLegalBusName", {
        get: function () {
            var lead = this.props.store.lead;
            return lead.openLeadDetails !== null && lead.openLeadDetails.legalBusName
                ? lead.openLeadDetails.legalBusName.trim()
                : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadDisable.prototype, "leadName", {
        get: function () {
            return this.leadDba && this.leadLegalBusName
                ? this.leadDba + ', ' + this.leadLegalBusName
                : this.leadDba
                    ? this.leadDba
                    : this.leadLegalBusName
                        ? this.leadLegalBusName
                        : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadDisable.prototype, "modalTitle", {
        get: function () {
            var lead = this.props.store.lead;
            var str = 'Disable lead';
            if (this.leadDba) {
                str += ' ' + this.leadDba;
            }
            else if (this.leadLegalBusName) {
                str += ' ' + this.leadLegalBusName;
            }
            else {
                str += ' #' + lead.openLeadId;
            }
            return str;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadDisable.prototype, "promptTitle", {
        get: function () {
            var str = 'I understand, disable lead';
            str += this.leadId ? ' #' + this.leadId : '';
            str += this.leadDba ? ', ' + this.leadDba : '';
            str += this.leadLegalBusName ? ', ' + this.leadLegalBusName : '';
            return str;
        },
        enumerable: true,
        configurable: true
    });
    LeadDisable.prototype.render = function () {
        var lead = this.props.store.lead;
        return (React.createElement(content_1.Modal, { show: lead.disableOpenLeadShowModal, onModalClose: this.handleModalClose, title: this.modalTitle }, lead.disableOpenLeadShowModal && (React.createElement("div", { className: s.container },
            React.createElement("h3", { className: s.message }, "Disabling lead is permament and irreversible."),
            React.createElement("div", { className: s.buttonWrapper },
                React.createElement("button", { className: classNames(s.button, 'boxButton', 'boxButtonImportant'), onClick: this.handleDisableLead }, this.promptTitle)),
            React.createElement(indicator_1.SavingIndicator, { className: s.saving, align: "center", labels: {
                    saving: 'Disabling lead...',
                }, status: lead.disablingOpenLeadError
                    ? indicator_1.SavingIndicatorStatus.Error
                    : lead.disablingOpenLead
                        ? indicator_1.SavingIndicatorStatus.Saving
                        : indicator_1.SavingIndicatorStatus.None })))));
    };
    __decorate([
        mobx_1.computed
    ], LeadDisable.prototype, "leadId", null);
    __decorate([
        mobx_1.computed
    ], LeadDisable.prototype, "leadDba", null);
    __decorate([
        mobx_1.computed
    ], LeadDisable.prototype, "leadLegalBusName", null);
    __decorate([
        mobx_1.computed
    ], LeadDisable.prototype, "leadName", null);
    __decorate([
        mobx_1.computed
    ], LeadDisable.prototype, "modalTitle", null);
    __decorate([
        mobx_1.computed
    ], LeadDisable.prototype, "promptTitle", null);
    LeadDisable = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], LeadDisable);
    return LeadDisable;
}(React.Component));
exports.LeadDisable = LeadDisable;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Disable/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Disable/LeadDisable.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Notes/LeadNotes.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Notes/LeadNotes.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadNotes.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadNotes.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Notes/LeadNotes.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
var lunr = __webpack_require__("./node_modules/lunr/lunr.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var zenscroll = __webpack_require__("./node_modules/zenscroll/zenscroll.js");
var isNil_1 = __webpack_require__("./node_modules/lodash-es/isNil.js");
var Note_1 = __webpack_require__("./app/web/src/routes/sales/Lead/Notes/Note/index.tsx");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var LeadNotesGroup_1 = __webpack_require__("./app/web/src/routes/sales/Lead/Notes/LeadNotesGroup.tsx");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Notes/LeadNotes.css");
var searchIcon = __webpack_require__("./app/web/src/assets/loupe icon blue.svg");
var addIcon = __webpack_require__("./app/web/src/assets/plus icon.svg");
// Component
var LeadNotes = /** @class */ (function (_super) {
    __extends(LeadNotes, _super);
    function LeadNotes() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notesTop = null;
        _this.windowScroller = zenscroll.createScroller((document.scrollingElement || document.body), 300, 128);
        _this.searchQuery = '';
        _this.isOnAddNoteScreen = true;
        _this.referenceNotesTop = function (ref) { return (_this.notesTop = ref); };
        _this.toggleAddNoteScreen = function () {
            _this.isOnAddNoteScreen = !_this.isOnAddNoteScreen;
            _this.searchQuery = '';
        };
        _this.changeSearchValue = function (value) {
            _this.searchQuery = value;
            if (_this.notesTop) {
                _this.windowScroller.intoView(_this.notesTop);
            }
        };
        return _this;
    }
    Object.defineProperty(LeadNotes.prototype, "searchNotesIndex", {
        get: function () {
            var allLeadNotes = this.props.store.lead.openLeadNotes;
            return lunr(function () {
                var _this = this;
                this._b = 0;
                this._k1 = 0;
                this.field('text');
                this.field('author');
                allLeadNotes.map(function (note) {
                    _this.add({
                        id: note.id,
                        text: note.comment,
                        author: note.createdByUser.name || note.createdByUser.username,
                    });
                });
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNotes.prototype, "filteredNotes", {
        get: function () {
            return this.props.store.lead.openLeadNotes.filter(function (note) { return note.comment; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNotes.prototype, "searchNotes", {
        get: function () {
            var _this = this;
            var query = this.searchQuery.trim();
            if (query === '') {
                return this.filteredNotes;
            }
            var notesIds = this.filteredNotes.map(function (note) { return note.id; });
            var words = query.split(/\s/gm);
            var search = this.searchNotesIndex.search(words.map(function (word) { return word + "~1 " + word + "*"; }).join(' '));
            if (search.length <= 0) {
                return [];
            }
            var searchMatchingIds = search.map(function (result) { return parseInt(result.ref, 10); });
            var results = searchMatchingIds.map(function (id) {
                var index = notesIds.indexOf(id);
                return _this.filteredNotes[index];
            });
            return results;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNotes.prototype, "groupedSearchNotes", {
        get: function () {
            var previousDate = moment('1901-01-01');
            return this.searchNotes.reduce(function (noteGroups, note) {
                var noteDate = null;
                if (!isNil_1.default(note.updatedAt)) {
                    var updatedAtParsed = moment(note.updatedAt);
                    noteDate = updatedAtParsed.isValid() ? updatedAtParsed : null;
                }
                else if (!isNil_1.default(note.createdAt)) {
                    var createdAtParsed = moment(note.createdAt);
                    noteDate = createdAtParsed.isValid() ? createdAtParsed : null;
                }
                if (noteDate.isSame(previousDate, 'day')) {
                    noteGroups[noteGroups.length - 1].notes.push(note);
                }
                else {
                    noteGroups.push({
                        date: noteDate.format('YYYY-MM-DD'),
                        notes: [note],
                    });
                    previousDate = noteDate;
                }
                return noteGroups;
            }, []);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNotes.prototype, "groupedSearchNotesWithIndex", {
        get: function () {
            var index = -1;
            return this.groupedSearchNotes.map(function (group) { return (__assign({}, group, { notes: group.notes.map(function (note) {
                    index++;
                    return __assign({}, note, { index: index });
                }) })); });
        },
        enumerable: true,
        configurable: true
    });
    LeadNotes.prototype.render = function () {
        var lead = this.props.store.lead;
        return (React.createElement("div", { className: s.container },
            React.createElement(content_1.SectionHeadline, { title: "Notes", button: {
                    onClick: this.toggleAddNoteScreen,
                    iconClassName: this.isOnAddNoteScreen ? s.searchIcon : s.addIcon,
                    icon: this.isOnAddNoteScreen ? searchIcon : addIcon,
                    label: this.isOnAddNoteScreen ? 'Search notes' : 'Add new note',
                } }),
            React.createElement("div", { className: s.group },
                React.createElement("div", { className: s.notes, ref: this.referenceNotesTop }, (this.isOnAddNoteScreen && React.createElement(Note_1.LeadNoteNew, null)) || (React.createElement(action_1.Search, { onValueChange: this.changeSearchValue, className: s.notesSearchContainer, classNameForField: s.notesSearchField, label: "Search lead's notes", placeholder: "Note's content", value: this.searchQuery, isValueClearable: true, autoFocus: true }))),
                lead.openLeadDetails !== null &&
                    this.groupedSearchNotesWithIndex.length > 0 && (React.createElement("div", { className: s.notes }, this.groupedSearchNotesWithIndex.map(function (notesGroup) {
                    return (React.createElement(LeadNotesGroup_1.LeadNotesGroup, { key: notesGroup.date, group: notesGroup }));
                }))),
                lead.openLeadDetails !== null &&
                    this.groupedSearchNotesWithIndex.length <= 0 && (React.createElement("p", { className: s.noNotes }, this.searchQuery
                    ? 'No notes match search query.'
                    : 'No notes exist for this lead.')))));
    };
    __decorate([
        mobx_1.observable
    ], LeadNotes.prototype, "searchQuery", void 0);
    __decorate([
        mobx_1.observable
    ], LeadNotes.prototype, "isOnAddNoteScreen", void 0);
    __decorate([
        mobx_1.computed
    ], LeadNotes.prototype, "searchNotesIndex", null);
    __decorate([
        mobx_1.computed
    ], LeadNotes.prototype, "filteredNotes", null);
    __decorate([
        mobx_1.computed
    ], LeadNotes.prototype, "searchNotes", null);
    __decorate([
        mobx_1.computed
    ], LeadNotes.prototype, "groupedSearchNotes", null);
    __decorate([
        mobx_1.computed
    ], LeadNotes.prototype, "groupedSearchNotesWithIndex", null);
    __decorate([
        mobx_1.action
    ], LeadNotes.prototype, "toggleAddNoteScreen", void 0);
    __decorate([
        mobx_1.action
    ], LeadNotes.prototype, "changeSearchValue", void 0);
    LeadNotes = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], LeadNotes);
    return LeadNotes;
}(React.Component));
exports.LeadNotes = LeadNotes;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Notes/LeadNotesGroup.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Notes/LeadNotesGroup.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadNotesGroup.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadNotesGroup.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Notes/LeadNotesGroup.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var Note_1 = __webpack_require__("./app/web/src/routes/sales/Lead/Notes/Note/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Notes/LeadNotesGroup.css");
// Component
var LeadNotesGroup = /** @class */ (function (_super) {
    __extends(LeadNotesGroup, _super);
    function LeadNotesGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LeadNotesGroup.prototype, "date", {
        get: function () {
            return moment(this.props.group.date);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNotesGroup.prototype, "isToday", {
        get: function () {
            return this.date.isSame(this.props.store.utilities.now, 'day');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNotesGroup.prototype, "isYesterday", {
        get: function () {
            return this.date.isSame(this.props.store.utilities.now.subtract(1, 'day'), 'day');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNotesGroup.prototype, "isTwoDaysAgo", {
        get: function () {
            return this.date.isSame(this.props.store.utilities.now.subtract(2, 'day'), 'day');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNotesGroup.prototype, "isThreeDaysAgo", {
        get: function () {
            return this.date.isSame(this.props.store.utilities.now.subtract(3, 'day'), 'day');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNotesGroup.prototype, "dateFormatted", {
        get: function () {
            return this.isToday
                ? 'Today'
                : this.isYesterday
                    ? 'Yesterday'
                    : this.isTwoDaysAgo
                        ? 'Two days ago'
                        : this.isThreeDaysAgo
                            ? 'Three days ago'
                            : this.date.format('MMMM Do, YYYY');
        },
        enumerable: true,
        configurable: true
    });
    LeadNotesGroup.prototype.render = function () {
        var _a = this.props.group, dateIsoString = _a.date, notes = _a.notes;
        return (React.createElement("div", { key: dateIsoString, className: s.notesGroup },
            React.createElement("div", { className: s.notesGroupDate },
                React.createElement("p", null, this.dateFormatted),
                React.createElement("hr", null)),
            React.createElement("div", { className: s.notesGroupList }, notes.map(function (info, i) { return (React.createElement(Note_1.LeadNote, { key: info.id, noteInfo: info, index: info.index })); }))));
    };
    __decorate([
        mobx_1.computed
    ], LeadNotesGroup.prototype, "date", null);
    __decorate([
        mobx_1.computed
    ], LeadNotesGroup.prototype, "isToday", null);
    __decorate([
        mobx_1.computed
    ], LeadNotesGroup.prototype, "isYesterday", null);
    __decorate([
        mobx_1.computed
    ], LeadNotesGroup.prototype, "isTwoDaysAgo", null);
    __decorate([
        mobx_1.computed
    ], LeadNotesGroup.prototype, "isThreeDaysAgo", null);
    __decorate([
        mobx_1.computed
    ], LeadNotesGroup.prototype, "dateFormatted", null);
    LeadNotesGroup = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], LeadNotesGroup);
    return LeadNotesGroup;
}(React.Component));
exports.LeadNotesGroup = LeadNotesGroup;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Notes/Note/LeadNote.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__("./app/web/src/routes/sales/Lead/Notes/Note/index.tsx");
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var provider_1 = __webpack_require__("./app/common/interfaces/provider.ts");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var isNil_1 = __webpack_require__("./node_modules/lodash-es/isNil.js");
var moment = __webpack_require__("./node_modules/moment/moment.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Notes/LeadNotes.css");
// Component
var LeadNote = /** @class */ (function (_super) {
    __extends(LeadNote, _super);
    function LeadNote() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LeadNote.prototype, "isHidden", {
        get: function () {
            return this.props.noteInfo.hidden === provider_1.EVisibility.Hidden;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNote.prototype, "isCreator", {
        get: function () {
            var _a = this.props, noteInfo = _a.noteInfo, store = _a.store;
            return Boolean(store.user.id === noteInfo.createdByUser.id ||
                store.user.id === noteInfo.updatedByUser.id);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNote.prototype, "authorName", {
        get: function () {
            var _a = this.props.noteInfo, updatedByUser = _a.updatedByUser, createdByUser = _a.createdByUser;
            if (!isNil_1.default(updatedByUser) && !isNil_1.default(updatedByUser.name)) {
                return updatedByUser.name;
            }
            else if (!isNil_1.default(createdByUser) && isNil_1.default(createdByUser.name)) {
                return createdByUser.name;
            }
            else {
                return '';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNote.prototype, "lastDate", {
        get: function () {
            var _a = this.props.noteInfo, updatedAt = _a.updatedAt, createdAt = _a.createdAt;
            if (!isNil_1.default(updatedAt)) {
                var updatedAtParsed = moment(updatedAt);
                return updatedAtParsed.isValid() ? updatedAtParsed : null;
            }
            else if (!isNil_1.default(createdAt)) {
                var createdAtParsed = moment(createdAt);
                return createdAtParsed.isValid() ? createdAtParsed : null;
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNote.prototype, "lastTimeFormat", {
        get: function () {
            return this.lastDate !== null ? this.lastDate.format('h:mm A') : '';
        },
        enumerable: true,
        configurable: true
    });
    LeadNote.prototype.render = function () {
        var _a;
        var _b = this.props, noteInfo = _b.noteInfo, index = _b.index;
        return noteInfo.id &&
            (!this.isHidden || (this.isHidden && this.isCreator)) ? (React.createElement("div", { className: classNames(s.note, (_a = {},
                _a[s.hidden] = this.isHidden,
                _a[s.odd] = index % 2 === 0,
                _a[s.even] = index % 2 > 0,
                _a)) },
            React.createElement("div", { className: s.noteSummary },
                this.authorName && React.createElement("p", { className: s.name }, this.authorName),
                this.lastTimeFormat && (React.createElement("p", { className: s.time }, this.lastTimeFormat))),
            React.createElement("div", { className: s.noteContent },
                React.createElement(_1.LeadNoteContent, { noteInfo: noteInfo })),
            React.createElement(_1.LeadNoteDetails, { noteInfo: noteInfo }))) : null;
    };
    __decorate([
        mobx_1.computed
    ], LeadNote.prototype, "isHidden", null);
    __decorate([
        mobx_1.computed
    ], LeadNote.prototype, "isCreator", null);
    __decorate([
        mobx_1.computed
    ], LeadNote.prototype, "authorName", null);
    __decorate([
        mobx_1.computed
    ], LeadNote.prototype, "lastDate", null);
    __decorate([
        mobx_1.computed
    ], LeadNote.prototype, "lastTimeFormat", null);
    LeadNote = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], LeadNote);
    return LeadNote;
}(React.Component));
exports.LeadNote = LeadNote;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Notes/Note/LeadNoteContent.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Notes/LeadNotes.css");
// Component
var LeadNoteContent = /** @class */ (function (_super) {
    __extends(LeadNoteContent, _super);
    function LeadNoteContent(props) {
        var _this = _super.call(this, props) || this;
        _this.handleLeadNoteChange = function (html, text) {
            _this.props.store.lead.leadEditingNote = __assign({}, _this.props.store.lead.leadEditingNote, { html: html,
                text: text });
        };
        return _this;
    }
    Object.defineProperty(LeadNoteContent.prototype, "isContentBeingEdited", {
        get: function () {
            return this.props.store.lead.leadEditingNote.id === this.props.noteInfo.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNoteContent.prototype, "noteHtml", {
        get: function () {
            var _this = this;
            var openLeadNotes = this.props.store.lead.openLeadNotes;
            var index = -1;
            openLeadNotes.some(function (note, noteIndex) {
                if (note.id === _this.props.noteInfo.id) {
                    index = noteIndex;
                    return true;
                }
                return false;
            });
            return index !== -1 ? openLeadNotes[index].comment : '';
        },
        enumerable: true,
        configurable: true
    });
    LeadNoteContent.prototype.render = function () {
        var _a;
        return (React.createElement(content_1.ContentEditable, { classNameForField: classNames(s.content, (_a = {},
                _a[s.contentEditable] = this.isContentBeingEdited,
                _a)), autoFocus: true, contentEditable: this.isContentBeingEdited, onChange: this.handleLeadNoteChange, html: this.noteHtml }));
    };
    __decorate([
        mobx_1.computed
    ], LeadNoteContent.prototype, "isContentBeingEdited", null);
    __decorate([
        mobx_1.computed
    ], LeadNoteContent.prototype, "noteHtml", null);
    __decorate([
        mobx_1.action
    ], LeadNoteContent.prototype, "handleLeadNoteChange", void 0);
    LeadNoteContent = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], LeadNoteContent);
    return LeadNoteContent;
}(React.Component));
exports.LeadNoteContent = LeadNoteContent;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Notes/Note/LeadNoteDetails.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var provider_1 = __webpack_require__("./app/common/interfaces/provider.ts");
var user_1 = __webpack_require__("./app/common/interfaces/user.ts");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Notes/LeadNotes.css");
var editIcon = __webpack_require__("./app/web/src/assets/pen icon.svg");
var visibilityIcon = __webpack_require__("./app/web/src/assets/visibility button.svg");
// Component
var LeadNoteDetails = /** @class */ (function (_super) {
    __extends(LeadNoteDetails, _super);
    function LeadNoteDetails(props) {
        var _this = _super.call(this, props) || this;
        _this.handleLeadNoteHide = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var _a, store, noteInfo, update, leadDetailsIndex, leadsNoteIndex_1, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, store = _a.store, noteInfo = _a.noteInfo;
                        if (!this.isHideable) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        this.props.store.lead.leadHidingNote = {
                            id: noteInfo.id,
                            isSaving: true,
                            error: false,
                        };
                        return [4 /*yield*/, store.lead.updateLeadNote(noteInfo.id, {
                                hidden: noteInfo.hidden === provider_1.EVisibility.Visible
                                    ? provider_1.EVisibility.Hidden
                                    : provider_1.EVisibility.Visible,
                            })];
                    case 2:
                        update = _b.sent();
                        this.props.store.lead.leadHidingNote = {
                            id: null,
                            isSaving: false,
                            error: false,
                        };
                        leadDetailsIndex = store.lead.leadsDetailsIds.indexOf(store.lead.openLeadId);
                        leadsNoteIndex_1 = -1;
                        store.lead.leadsDetails[leadDetailsIndex].notes.some(function (note, noteIndex) {
                            if (note.id === noteInfo.id) {
                                leadsNoteIndex_1 = noteIndex;
                                return true;
                            }
                            return false;
                        });
                        if (leadsNoteIndex_1 !== -1) {
                            store.lead.leadsDetails[leadDetailsIndex].notes[leadsNoteIndex_1].hidden = noteInfo.hidden ? provider_1.EVisibility.Visible : provider_1.EVisibility.Hidden;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _b.sent();
                        this.props.store.lead.leadHidingNote = __assign({}, this.props.store.lead.leadHidingNote, { isSaving: false, error: true });
                        console.error(err_1);
                        throw err_1;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.handleLeadNoteStartEditing = function (e) {
            if (_this.isEditable) {
                _this.props.store.lead.leadEditingNote = {
                    id: _this.props.noteInfo.id,
                    isSaving: false,
                    error: false,
                    html: '',
                    text: '',
                };
            }
        };
        _this.handleEditNoteCancel = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.store.lead.leadEditingNote.id = null;
                this.props.store.lead.leadEditingNote.isSaving = false;
                this.props.store.lead.leadEditingNote.error = false;
                this.props.store.lead.leadEditingNote.html = '';
                this.props.store.lead.leadEditingNote.text = '';
                return [2 /*return*/, true];
            });
        }); };
        _this.handleEditNoteUpdate = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, store, noteInfo, update, leadDetailsIndex, leadsNoteIndex_2, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, store = _a.store, noteInfo = _a.noteInfo;
                        if (!(store.lead.leadEditingNote.text.trim().length <= 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.handleEditNoteCancel()];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        store.lead.leadEditingNote.isSaving = true;
                        return [4 /*yield*/, store.lead.updateLeadNote(noteInfo.id, {
                                comment: store.lead.leadEditingNote.text,
                                providerId: noteInfo.providerId,
                                hidden: provider_1.EVisibility.Visible,
                            })];
                    case 3:
                        update = _b.sent();
                        // Hide edit section
                        store.lead.leadEditingNote = {
                            id: null,
                            isSaving: false,
                            error: false,
                            html: '',
                            text: '',
                        };
                        leadDetailsIndex = store.lead.leadsDetailsIds.indexOf(store.lead.openLeadId);
                        leadsNoteIndex_2 = -1;
                        store.lead.leadsDetails[leadDetailsIndex].notes.some(function (note, noteIndex) {
                            if (note.id === noteInfo.id) {
                                leadsNoteIndex_2 = noteIndex;
                                return true;
                            }
                            return false;
                        });
                        if (leadDetailsIndex !== -1 && leadsNoteIndex_2 !== -1) {
                            store.lead.leadsDetails[leadDetailsIndex].notes[leadsNoteIndex_2].comment = update.comment;
                            store.lead.leadsDetails[leadDetailsIndex].notes[leadsNoteIndex_2].updatedAt = moment().format();
                            store.lead.leadsDetails[leadDetailsIndex].notes[leadsNoteIndex_2].updatedByUser = {
                                id: store.user.id,
                                name: store.user.name,
                                username: store.user.username,
                                email: store.user.email,
                            };
                        }
                        // Return success
                        return [2 /*return*/, true];
                    case 4:
                        err_2 = _b.sent();
                        store.lead.leadEditingNote = __assign({}, store.lead.leadEditingNote, { isSaving: false, error: true });
                        console.error(err_2);
                        throw err_2;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    Object.defineProperty(LeadNoteDetails.prototype, "isContentBeingEdited", {
        get: function () {
            return this.props.store.lead.leadEditingNote.id === this.props.noteInfo.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNoteDetails.prototype, "minutesSince", {
        get: function () {
            var noteInfo = this.props.noteInfo;
            var editMoment = moment(noteInfo.updatedAt || noteInfo.createdAt);
            var millisecondsSince = moment().diff(editMoment);
            var minutesSince = moment.duration(millisecondsSince).asMinutes();
            return minutesSince <= 60;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNoteDetails.prototype, "isAuthor", {
        get: function () {
            var _a = this.props, store = _a.store, noteInfo = _a.noteInfo;
            return (store.user.id === (noteInfo.createdByUser.id || noteInfo.updatedByUser.id));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNoteDetails.prototype, "isAdmin", {
        get: function () {
            return this.props.store.user.userType === user_1.UserType.Admin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNoteDetails.prototype, "isEditable", {
        get: function () {
            return (this.isAuthor && this.minutesSince) || this.isAdmin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNoteDetails.prototype, "isHideable", {
        get: function () {
            return (this.isAuthor && this.minutesSince) || this.isAdmin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNoteDetails.prototype, "isCreatingNote", {
        get: function () {
            var _a = this.props, store = _a.store, noteInfo = _a.noteInfo;
            return store.lead.leadEditingNote.id === noteInfo.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadNoteDetails.prototype, "isHidingNote", {
        get: function () {
            var _a = this.props, store = _a.store, noteInfo = _a.noteInfo;
            return store.lead.leadHidingNote.id === noteInfo.id;
        },
        enumerable: true,
        configurable: true
    });
    LeadNoteDetails.prototype.render = function () {
        var _a, _b, _c;
        var noteInfo = this.props.noteInfo;
        var _d = this.props.store.lead, leadEditingNote = _d.leadEditingNote, leadHidingNote = _d.leadHidingNote;
        return (React.createElement("div", { className: s.noteDetails },
            this.isContentBeingEdited && (React.createElement("div", { className: s.detail },
                React.createElement("div", { className: s.left },
                    React.createElement(indicator_1.SavingIndicator, { align: "left", labels: {
                            saving: 'Saving changes...',
                            error: 'Could not update the note, try again',
                        }, status: leadEditingNote.error
                            ? indicator_1.SavingIndicatorStatus.Error
                            : leadEditingNote.isSaving
                                ? indicator_1.SavingIndicatorStatus.Saving
                                : indicator_1.SavingIndicatorStatus.None })),
                React.createElement("div", { className: classNames(s.right, s.saveButtons, (_a = {},
                        _a[s.saving] = leadEditingNote.isSaving,
                        _a)) },
                    React.createElement("button", { className: classNames('boxButton', 'boxButtonImportant'), onClick: leadEditingNote.isSaving
                            ? undefined
                            : this.handleEditNoteCancel }, "Cancel"),
                    React.createElement("button", { className: classNames('boxButton', s.publish), onClick: leadEditingNote.isSaving
                            ? undefined
                            : this.handleEditNoteUpdate }, "Publish")))),
            this.isContentBeingEdited === false && (React.createElement("div", { className: classNames(s.detail, (_b = {},
                    _b[s.withIconButton] = this.isEditable,
                    _b)) },
                React.createElement("div", { className: s.left },
                    React.createElement(indicator_1.SavingIndicator, { align: "left", labels: {
                            saving: noteInfo.hidden === provider_1.EVisibility.Hidden
                                ? 'Showing...'
                                : 'Hiding...',
                            error: "Could not " + (noteInfo.hidden === provider_1.EVisibility.Hidden ? 'show' : 'hide') + " the note, try again",
                        }, status: this.isHidingNote
                            ? leadHidingNote.error
                                ? indicator_1.SavingIndicatorStatus.Error
                                : leadHidingNote.isSaving
                                    ? indicator_1.SavingIndicatorStatus.Saving
                                    : indicator_1.SavingIndicatorStatus.None
                            : indicator_1.SavingIndicatorStatus.None })),
                React.createElement("div", { className: s.right },
                    this.isHideable && (React.createElement(action_1.IconButton, { className: classNames(s.button, s.iconButton, s.hide, (_c = {},
                            _c[s.hidden] = noteInfo.hidden === 1,
                            _c)), onClick: this.handleLeadNoteHide, removePadding: true, label: noteInfo.hidden === provider_1.EVisibility.Hidden
                            ? 'Recover note'
                            : 'Delete note', icon: visibilityIcon })),
                    this.isEditable && this.isHideable && (React.createElement(action_1.IconButton, { className: classNames(s.button, s.iconButton, s.edit), onClick: this.handleLeadNoteStartEditing, removePadding: true, label: "Edit note", icon: editIcon })))))));
    };
    __decorate([
        mobx_1.computed
    ], LeadNoteDetails.prototype, "isContentBeingEdited", null);
    __decorate([
        mobx_1.computed
    ], LeadNoteDetails.prototype, "minutesSince", null);
    __decorate([
        mobx_1.computed
    ], LeadNoteDetails.prototype, "isAuthor", null);
    __decorate([
        mobx_1.computed
    ], LeadNoteDetails.prototype, "isAdmin", null);
    __decorate([
        mobx_1.computed
    ], LeadNoteDetails.prototype, "isEditable", null);
    __decorate([
        mobx_1.computed
    ], LeadNoteDetails.prototype, "isHideable", null);
    __decorate([
        mobx_1.computed
    ], LeadNoteDetails.prototype, "isCreatingNote", null);
    __decorate([
        mobx_1.computed
    ], LeadNoteDetails.prototype, "isHidingNote", null);
    __decorate([
        mobx_1.action
    ], LeadNoteDetails.prototype, "handleLeadNoteHide", void 0);
    __decorate([
        mobx_1.action
    ], LeadNoteDetails.prototype, "handleLeadNoteStartEditing", void 0);
    __decorate([
        mobx_1.action
    ], LeadNoteDetails.prototype, "handleEditNoteCancel", void 0);
    __decorate([
        mobx_1.action
    ], LeadNoteDetails.prototype, "handleEditNoteUpdate", void 0);
    LeadNoteDetails = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], LeadNoteDetails);
    return LeadNoteDetails;
}(React.Component));
exports.LeadNoteDetails = LeadNoteDetails;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Notes/Note/LeadNoteNew.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Notes/LeadNotes.css");
// Component
var LeadNoteNew = /** @class */ (function (_super) {
    __extends(LeadNoteNew, _super);
    function LeadNoteNew(props) {
        var _this = _super.call(this, props) || this;
        _this.handleNewNoteChange = function (html, text) {
            _this.props.store.lead.newNote.html = html;
            _this.props.store.lead.newNote.text = text;
            _this.props.store.lead.newNote.errorAllFieldsRequired = false;
        };
        _this.handleNewNoteClearContent = function (e) {
            _this.props.store.lead.clearNewLeadNote();
        };
        _this.handleNewNotePublish = function (e) {
            e.preventDefault();
            if (_this.isReady) {
                _this.props.store.lead.addLeadNote();
            }
            else {
                _this.props.store.lead.newNote.errorAllFieldsRequired = true;
            }
        };
        return _this;
    }
    Object.defineProperty(LeadNoteNew.prototype, "isReady", {
        get: function () {
            return this.props.store.lead.newNote.text.trim().length > 0;
        },
        enumerable: true,
        configurable: true
    });
    LeadNoteNew.prototype.render = function () {
        var _a;
        var lead = this.props.store.lead;
        return (React.createElement("div", { className: classNames(s.note, s.new) },
            React.createElement("div", { className: s.noteContent },
                React.createElement(content_1.ContentEditable, { classNameForField: classNames(s.content, s.contentEditable), onChange: this.handleNewNoteChange, autoFocus: true, placeholder: "New note...", html: lead.newNote.html || '', selectTextOnFirstFocus: true, contentEditable: true })),
            React.createElement("div", { className: s.noteDetails },
                React.createElement("div", { className: s.detail },
                    React.createElement("div", { className: s.left },
                        lead.newNote.error && (React.createElement("p", { className: "text textImportant" }, "Could not save the note, try again")),
                        React.createElement(indicator_1.SavingIndicator, { align: "left", labels: {
                                saving: 'Saving note...',
                                error: 'Note text is required',
                            }, status: lead.newNote.errorAllFieldsRequired
                                ? indicator_1.SavingIndicatorStatus.Error
                                : lead.newNote.isSaving
                                    ? indicator_1.SavingIndicatorStatus.Saving
                                    : indicator_1.SavingIndicatorStatus.None })),
                    React.createElement("div", { className: classNames(s.right, s.saveButtons, (_a = {},
                            _a[s.saving] = lead.newNote.isSaving,
                            _a)) },
                        lead.newNote.html.length > 0 && (React.createElement("button", { className: classNames('boxButton', 'boxButtonImportant'), onClick: lead.newNote.isSaving
                                ? undefined
                                : this.handleNewNoteClearContent }, "Clear note text")),
                        React.createElement("button", { className: classNames('boxButton', s.publish), onClick: this.handleNewNotePublish }, "Publish"))))));
    };
    __decorate([
        mobx_1.computed
    ], LeadNoteNew.prototype, "isReady", null);
    __decorate([
        mobx_1.action
    ], LeadNoteNew.prototype, "handleNewNoteChange", void 0);
    LeadNoteNew = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], LeadNoteNew);
    return LeadNoteNew;
}(React.Component));
exports.LeadNoteNew = LeadNoteNew;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Notes/Note/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Notes/Note/LeadNote.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Notes/Note/LeadNoteNew.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Notes/Note/LeadNoteContent.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Notes/Note/LeadNoteDetails.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Notes/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Notes/LeadNotes.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Notes/LeadNotesGroup.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/OtherActivities/OtherActivities.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/OtherActivities/OtherActivities.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./OtherActivities.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./OtherActivities.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/OtherActivities/OtherActivities.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var activity_1 = __webpack_require__("./app/web/src/components/activity/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/OtherActivities/OtherActivities.css");
var OtherActivities = /** @class */ (function (_super) {
    __extends(OtherActivities, _super);
    function OtherActivities(props) {
        return _super.call(this, props) || this;
    }
    OtherActivities.prototype.render = function () {
        var leadActivities = this.props.store.leadActivities;
        return leadActivities.activitiesGroupsOfOtherLeads.length > 0 ? (React.createElement("div", null, leadActivities.activitiesGroupsOfOtherLeads.map(function (group) {
            return (React.createElement(activity_1.ActivitiesGroup, { key: group.key, title: group.title, allFinished: group.allFinished, activities: group.activities, isOnLeadPage: false }));
        }))) : (React.createElement("p", { className: s.empty }, "No activities available for other leads."));
    };
    OtherActivities = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], OtherActivities);
    return OtherActivities;
}(React.Component));
exports.OtherActivities = OtherActivities;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/OtherActivities/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/OtherActivities/OtherActivities.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/PricingRequest/Modal/PricingRequestContent.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/PricingRequest/Modal/PricingRequestContent.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./PricingRequestContent.css", function() {
		var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./PricingRequestContent.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/PricingRequest/Modal/PricingRequestContent.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var accounting_1 = __webpack_require__("./node_modules/accounting/accounting.js");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var pricing_1 = __webpack_require__("./app/common/interfaces/pricing.ts");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/PricingRequest/Modal/PricingRequestContent.css");
var removeIcon = __webpack_require__("./app/web/src/assets/close orange icon.svg");
// Component
var PricingRequestContent = /** @class */ (function (_super) {
    __extends(PricingRequestContent, _super);
    function PricingRequestContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleItemRemoveFromNewRequest = function (itemId) { return function (e) {
            _this.props.onItemRemoveFromPricingRequest(itemId);
        }; };
        _this.handleApprovedPriceChange = function (itemId) { return function (e) {
            _this.props.onItemApprovedPriceChange(itemId, e.currentTarget.value, _this.props.onlyListItems);
        }; };
        _this.handleApprovedPriceChangeFormatting = function (itemId) { return function (e) {
            _this.props.onItemApprovedPriceChange(itemId, accounting_1.toFixed(accounting_1.unformat(e.currentTarget.value), 2), _this.props.onlyListItems);
        }; };
        _this.handleApprovedGroupPriceChange = function (itemId) { return function (e) {
            _this.props.onItemGroupPriceChange(itemId, e.currentTarget.value);
        }; };
        _this.handleApprovedGroupPriceChangeFormatting = function (itemId) { return function (e) {
            _this.props.onItemGroupPriceChange(itemId, accounting_1.toFixed(accounting_1.unformat(e.currentTarget.value), 2));
        }; };
        _this.handleRequestedPriceChange = function (itemId) { return function (e) {
            _this.props.onItemRequestedPriceChange(itemId, e.currentTarget.value);
        }; };
        _this.handleRequestedPriceChangeFormatting = function (itemId) { return function (e) {
            _this.props.onItemRequestedPriceChange(itemId, accounting_1.toFixed(accounting_1.unformat(e.currentTarget.value), 2));
        }; };
        _this.handleRequestedQuantityChange = function (itemId) { return function (e) {
            _this.props.onItemRequestedQuantityChange(itemId, e.currentTarget.value);
        }; };
        _this.handleDescriptionChange = function (html, text) {
            _this.props.onRequestNoteChange(html, text);
        };
        _this.handleSubmit = function () {
            if (_this.props.new) {
                _this.props.onSubmitRequest();
            }
            else if (_this.props.userCanApprovePricing) {
                if (_this.props.onlyListItems) {
                    _this.props.onUpdatePrices();
                }
                else if (_this.notAllItemsHaveApprovedPrice) {
                    _this.props.onSaveRequest();
                }
                else {
                    _this.props.onApproveRequest();
                }
            }
        };
        return _this;
    }
    Object.defineProperty(PricingRequestContent, "defaultProps", {
        get: function () {
            return {
                onItemRemoveFromPricingRequest: null,
                onRequestNoteChange: null,
                onItemRequestedPriceChange: null,
                onItemRequestedQuantityChange: null,
                onItemApprovedPriceChange: null,
                onItemGroupPriceChange: null,
                onSubmitRequest: null,
                onApproveRequest: null,
                onSaveRequest: null,
                onUpdatePrices: null,
                existingRequest: null,
                userCanApprovePricing: false,
                onlyListItems: false,
                new: false,
                items: [],
                groupItems: [],
                noteHtml: '',
                status: pricing_1.StatusOfNewPricingRequest.None,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PricingRequestContent.prototype, "notAllItemsHaveApprovedPrice", {
        get: function () {
            var existingRequest = this.props.existingRequest;
            if (existingRequest !== null && existingRequest.item.length > 0) {
                return existingRequest.item.some(function (item) {
                    return item.approvedPrice === null || item.approvedPrice.trim() === '';
                });
            }
            else {
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PricingRequestContent.prototype, "showGroupPrice", {
        get: function () {
            return (this.props.existingRequest !== null &&
                this.props.existingRequest.providerGroup !== null);
        },
        enumerable: true,
        configurable: true
    });
    PricingRequestContent.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, existingRequest = _b.existingRequest, onlyListItems = _b.onlyListItems, userCanApprovePricing = _b.userCanApprovePricing;
        return (React.createElement("div", { className: s.container },
            this.props.userCanApprovePricing &&
                this.props.new === false &&
                existingRequest !== null && (React.createElement("div", { className: s.details },
                React.createElement("div", { className: s.row },
                    (typeof existingRequest.provider !== 'undefined' &&
                        existingRequest.provider && (React.createElement("h4", { className: s.lead },
                        typeof existingRequest.provider.dba !== 'undefined' &&
                            existingRequest.provider.dba && (React.createElement("strong", null, existingRequest.provider.dba)),
                        typeof existingRequest.provider.legalBusName !==
                            'undefined' &&
                            existingRequest.provider.legalBusName && (React.createElement("em", null, existingRequest.provider.legalBusName))))) || (React.createElement("h4", { className: s.lead },
                        React.createElement("strong", null, existingRequest.providerId))),
                    React.createElement("p", { className: s.author },
                        !onlyListItems &&
                            typeof existingRequest.createdAt !== 'undefined' &&
                            existingRequest.createdAt && (React.createElement("span", null, moment(existingRequest.createdAt).format('MMM Do, YYYY h:mm A'))),
                        !onlyListItems &&
                            (typeof existingRequest.createdByUser !== 'undefined' ||
                                typeof existingRequest.createdByUserId !==
                                    'undefined') && (React.createElement("span", null,
                            "by",
                            ' ',
                            typeof existingRequest.createdByUser !== 'undefined' &&
                                typeof existingRequest.createdByUser.name !==
                                    'undefined'
                                ? existingRequest.createdByUser.name
                                : typeof existingRequest.createdByUserId !==
                                    'undefined'
                                    ? existingRequest.createdByUserId.toString()
                                    : '')))))),
            React.createElement("div", { className: s.header },
                React.createElement("div", { className: s.row },
                    React.createElement("div", null, "Item"),
                    React.createElement("div", null, "List price"),
                    !onlyListItems && React.createElement("div", null, "Approved price"),
                    !onlyListItems && React.createElement("div", null, "Requested price"),
                    !onlyListItems && React.createElement("div", null, "Monthly usage"),
                    onlyListItems && React.createElement("div", null, "Customer price"),
                    this.showGroupPrice && onlyListItems && React.createElement("div", null, "Group price"))),
            this.props.items.length > 0 && (React.createElement("div", { className: s.items }, this.props.items.map(function (item, i) {
                var groupPrice = null;
                _this.props.groupItems.some(function (group) {
                    if (item.itemcode === group.itemcode) {
                        groupPrice =
                            typeof group.price === 'string'
                                ? group.price.trim()
                                : group.price;
                        return true;
                    }
                });
                return (React.createElement("div", { key: item.id, className: s.row },
                    React.createElement("div", null,
                        _this.props.new && (React.createElement(action_1.IconButton, { className: s.removeButton, onClick: _this.handleItemRemoveFromNewRequest(item.id), label: "Remove", icon: removeIcon })),
                        React.createElement("p", null,
                            React.createElement("strong", null, item.itemcode),
                            React.createElement("span", null, item.itemname))),
                    React.createElement("div", null,
                        React.createElement("p", null,
                            React.createElement("span", null, "$"),
                            React.createElement("strong", null, accounting_1.toFixed(item.price, 2)))),
                    ((!onlyListItems ||
                        (onlyListItems && _this.props.userCanApprovePricing)) && (React.createElement("div", null,
                        React.createElement("input", { placeholder: typeof item.approvedPrice !== 'undefined' &&
                                item.approvedPrice === null
                                ? 'None'
                                : 'Price', onChange: _this.handleApprovedPriceChange(item.id), onBlur: _this.handleApprovedPriceChangeFormatting(item.id), value: typeof item.approvedPrice !== 'undefined' &&
                                item.approvedPrice !== null
                                ? typeof item.approvedPrice === 'number'
                                    ? accounting_1.toFixed(item.approvedPrice, 2)
                                    : item.approvedPrice
                                : '' })))) ||
                        ((onlyListItems ||
                            _this.props.new ||
                            (existingRequest !== null && existingRequest.complete) ||
                            _this.props.userCanApprovePricing === false) && (React.createElement("div", null, (typeof item.approvedPrice !== 'undefined' &&
                            item.approvedPrice !== null && (React.createElement("p", null,
                            React.createElement("span", null, "$"),
                            React.createElement("strong", null, accounting_1.toFixed(accounting_1.unformat(item.approvedPrice), 2))))) || (React.createElement("p", null,
                            React.createElement("span", null, "None")))))),
                    (_this.showGroupPrice &&
                        onlyListItems &&
                        userCanApprovePricing && (React.createElement("div", null,
                        React.createElement("input", { placeholder: groupPrice === null ? 'None' : 'Price', onChange: _this.handleApprovedGroupPriceChange(item.id), onBlur: _this.handleApprovedGroupPriceChangeFormatting(item.id), value: groupPrice !== null
                                ? typeof groupPrice === 'number'
                                    ? accounting_1.toFixed(groupPrice, 2)
                                    : groupPrice
                                : '' })))) ||
                        (_this.showGroupPrice && onlyListItems && (React.createElement("div", null, (groupPrice !== null && groupPrice !== '' && (React.createElement("p", null,
                            React.createElement("span", null, "$"),
                            React.createElement("strong", null, typeof groupPrice === 'number'
                                ? accounting_1.toFixed(groupPrice, 2)
                                : groupPrice)))) || (React.createElement("p", null,
                            React.createElement("span", null, "None")))))),
                    !onlyListItems && (React.createElement("div", null, (_this.props.new && (React.createElement("input", { placeholder: "Price", onChange: _this.handleRequestedPriceChange(item.id), onBlur: _this.handleRequestedPriceChangeFormatting(item.id), value: item.expectedPrice !== null
                            ? item.expectedPrice
                            : '' }))) || (React.createElement("p", null,
                        React.createElement("span", null, "$"),
                        React.createElement("strong", null, accounting_1.toFixed(accounting_1.unformat(item.expectedPrice), 2)))))),
                    !onlyListItems && (React.createElement("div", null, (_this.props.new && (React.createElement("input", { placeholder: "Quantity", onChange: _this.handleRequestedQuantityChange(item.id), value: item.volume !== null ? item.volume : '' }))) || (React.createElement("p", null,
                        React.createElement("strong", null, accounting_1.toFixed(accounting_1.unformat(item.volume), 0))))))));
            }))),
            this.props.items.length <= 0 && !onlyListItems && (React.createElement("div", { className: s.empty },
                React.createElement("p", null, "No items added to pricing request. Start by searching for items client has requested."))),
            (((this.props.items.length > 0 && !onlyListItems) ||
                (this.props.userCanApprovePricing &&
                    onlyListItems &&
                    existingRequest !== null)) && (React.createElement("div", { className: s.footer },
                React.createElement("div", { className: s.row },
                    (!onlyListItems && (React.createElement(content_1.ContentEditable, { classNameForField: classNames(s.note, (_a = {},
                            _a[s.nonEditable] = !this.props.new,
                            _a)), contentEditable: this.props.new, autoFocus: false, selectTextOnFirstFocus: false, placeholder: this.props.new
                            ? 'Pricing request notes...'
                            : 'No note attached by request\'s author...', html: this.props.noteHtml, onChange: this.handleDescriptionChange }))) || React.createElement("div", { className: classNames(s.note, s.noteUnavailable) }),
                    ((this.props.new ||
                        this.props.userCanApprovePricing ||
                        (this.props.userCanApprovePricing &&
                            ((existingRequest !== null &&
                                existingRequest.approvedPricesModified) ||
                                (existingRequest !== null &&
                                    existingRequest.groupPricesModified)))) && (React.createElement("div", { className: s.submit },
                        React.createElement("button", { className: "boxButton", onClick: this.handleSubmit }, existingRequest !== null &&
                            this.props.userCanApprovePricing &&
                            onlyListItems
                            ? 'Update prices'
                            : this.props.new
                                ? 'Submit request'
                                : this.notAllItemsHaveApprovedPrice
                                    ? 'Save pricing request'
                                    : 'Approve pricing request'),
                        React.createElement(indicator_1.SavingIndicator, { align: "right", labels: {
                                note: this.notAllItemsHaveApprovedPrice && !onlyListItems
                                    ? 'Not all items have approved price entered. ' +
                                        'To close pricing request you need to provide approved price for all requested items.'
                                    : '',
                                success: 'Saved',
                                saving: 'Saving...',
                                error: this.props.status ===
                                    pricing_1.StatusOfNewPricingRequest.ErrorNotAllItemsHaveQuantityAndPrice
                                    ? this.props.new
                                        ? 'All items need price and volume defined'
                                        : 'All items need approved price defined'
                                    : 'Something went wrong, try again',
                            }, status: this.props.status === pricing_1.StatusOfNewPricingRequest.None
                                ? indicator_1.SavingIndicatorStatus.None
                                : this.props.status === pricing_1.StatusOfNewPricingRequest.Saving
                                    ? indicator_1.SavingIndicatorStatus.Saving
                                    : this.props.status ===
                                        pricing_1.StatusOfNewPricingRequest.Success
                                        ? indicator_1.SavingIndicatorStatus.Success
                                        : indicator_1.SavingIndicatorStatus.Error })))) || (React.createElement("div", { className: s.submit },
                        React.createElement("p", { className: s.statusMessage }, existingRequest !== null && existingRequest.complete
                            ? 'Request approved'
                            : 'Request pending'))))))) ||
                (onlyListItems && (React.createElement("div", null,
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement("br", null))))));
    };
    __decorate([
        mobx_1.computed
    ], PricingRequestContent.prototype, "notAllItemsHaveApprovedPrice", null);
    __decorate([
        mobx_1.computed
    ], PricingRequestContent.prototype, "showGroupPrice", null);
    PricingRequestContent = __decorate([
        mobx_react_1.observer
    ], PricingRequestContent);
    return PricingRequestContent;
}(React.Component));
exports.PricingRequestContent = PricingRequestContent;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/PricingRequest/Modal/PricingRequestModal.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/PricingRequest/Modal/PricingRequestModal.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./PricingRequestModal.css", function() {
		var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./PricingRequestModal.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/PricingRequest/Modal/PricingRequestModal.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var react_transition_group_1 = __webpack_require__("./node_modules/react-transition-group/index.js");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
var _1 = __webpack_require__("./app/web/src/routes/sales/Lead/PricingRequest/Modal/index.tsx");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var accounting_1 = __webpack_require__("./node_modules/accounting/accounting.js");
var user_1 = __webpack_require__("./app/common/interfaces/user.ts");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/PricingRequest/Modal/PricingRequestModal.css");
// Component
var PricingRequestModal = /** @class */ (function (_super) {
    __extends(PricingRequestModal, _super);
    function PricingRequestModal(props) {
        var _this = _super.call(this, props) || this;
        _this.searchField = null;
        _this.referenceSearchField = function (ref) {
            return (_this.searchField = ref);
        };
        _this.searchFieldFocused = false;
        _this.toggleSearchFieldFocus = function (focused, delay) { return function (e) {
            setTimeout(function () {
                _this.searchFieldFocused =
                    typeof focused !== 'undefined' ? focused : !_this.searchFieldFocused;
            }, typeof delay !== 'undefined' ? delay : 0);
        }; };
        _this.handleSearch = function (e) {
            _this.props.store.leadPricing.pricingSearch = e.currentTarget.value;
        };
        _this.handleItemAddToPricingRequest = function (item) { return function (e) {
            _this.props.store.leadPricing.addItemToPriceRequest(item);
            _this.props.store.leadPricing.pricingSearch = '';
        }; };
        _this.handleItemRemoveFromPricingRequest = function (itemId) {
            _this.props.store.leadPricing.removeItemFromPriceRequest(itemId);
        };
        _this.handleItemApprovedPriceChange = function (itemId, price, onlyListItems) {
            if (onlyListItems === void 0) { onlyListItems = false; }
            if (onlyListItems) {
                _this.props.store.leadPricing.changeApprovedPriceOfLeadsItem(itemId, price);
            }
            else {
                _this.props.store.pricingRequest.changeApprovedPriceOfSinglePricingRequest(itemId, price);
            }
        };
        _this.handleItemGroupPriceChange = function (itemId, price) {
            _this.props.store.leadPricing.changeGroupPriceOfLeadsItem(itemId, price);
        };
        _this.handleItemRequestedPriceChange = function (itemId, price) {
            _this.props.store.leadPricing.priceRequestItemChangePrice(itemId, price);
        };
        _this.handleItemRequestedQuantityChange = function (itemId, quantity) {
            _this.props.store.leadPricing.priceRequestItemChangeVolume(itemId, quantity);
        };
        _this.handleRequestNoteChange = function (html, text) {
            _this.props.store.leadPricing.newRequest.descriptionHtml = html;
            _this.props.store.leadPricing.newRequest.descriptionText = text;
        };
        _this.handleRequestSubmit = function () {
            if (_this.props.store.leadPricing.newRequest.isNew) {
                _this.props.store.leadPricing.createPricingRequest();
            }
            else {
                _this.props.store.leadPricing.patchPricingRequest();
            }
        };
        _this.handleApproveRequest = function () {
            var pricingRequest = _this.props.store.pricingRequest;
            if (pricingRequest.singlePricingRequest !== null) {
                _this.props.store.pricingRequest.approveSinglePricingRequest();
            }
        };
        _this.handleSaveRequest = function () {
            var pricingRequest = _this.props.store.pricingRequest;
            if (pricingRequest.singlePricingRequest !== null) {
                _this.props.store.pricingRequest.saveSinglePricingRequestItemApprovedPricesChanges();
            }
        };
        _this.handlePricesUpdate = function () {
            _this.props.store.leadPricing.saveUpdatedProviderAndGroupPrices();
        };
        return _this;
    }
    Object.defineProperty(PricingRequestModal, "defaultProps", {
        get: function () {
            return {
                show: false,
                onModalClose: null,
                existingRequest: null,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PricingRequestModal.prototype, "modalTitle", {
        get: function () {
            var existingRequest = this.props.existingRequest;
            var str = '';
            if (existingRequest !== null) {
                if (typeof existingRequest.onlyItems !== 'undefined' &&
                    existingRequest.onlyItems) {
                    str = 'Pricing';
                }
                else {
                    if (this.props.store.user.userType === user_1.UserType.SalesManager) {
                        str = 'Review pricing request';
                        str +=
                            existingRequest && existingRequest.data
                                ? ' #' + existingRequest.data.id
                                : '';
                    }
                    else {
                        str = 'Pricing request';
                        str +=
                            existingRequest && existingRequest.data
                                ? ' #' + existingRequest.data.id
                                : '';
                    }
                }
            }
            else {
                str = 'Create pricing request';
            }
            return str;
        },
        enumerable: true,
        configurable: true
    });
    PricingRequestModal.prototype.render = function () {
        var existingRequest = this.props.existingRequest;
        var newRequest = this.props.store.leadPricing.newRequest;
        return (React.createElement(content_1.Modal, { show: this.props.show, title: this.modalTitle, titleBarContent: this.props.existingRequest === null
                ? this.renderPricingRequestTitleBarContent()
                : null, onModalClose: this.props.onModalClose }, this.props.show && (React.createElement("div", { className: s.content },
            React.createElement(_1.PricingRequestContent, { onItemRemoveFromPricingRequest: this.handleItemRemoveFromPricingRequest, onItemRequestedQuantityChange: this.handleItemRequestedQuantityChange, onItemRequestedPriceChange: this.handleItemRequestedPriceChange, onItemApprovedPriceChange: this.handleItemApprovedPriceChange, onItemGroupPriceChange: this.handleItemGroupPriceChange, onRequestNoteChange: this.handleRequestNoteChange, onSubmitRequest: this.handleRequestSubmit, onApproveRequest: this.handleApproveRequest, onSaveRequest: this.handleSaveRequest, onUpdatePrices: this.handlePricesUpdate, existingRequest: this.props.existingRequest !== null
                    ? this.props.existingRequest.data
                    : null, userCanApprovePricing: this.props.store.user.userType === user_1.UserType.SalesManager, new: existingRequest === null ? true : false, onlyListItems: existingRequest !== null &&
                    typeof existingRequest.onlyItems !== 'undefined'
                    ? existingRequest.onlyItems
                    : false, items: existingRequest !== null && existingRequest.data !== null
                    ? existingRequest.data.item.map(function (i) {
                        return {
                            id: i.id,
                            isNew: false,
                            itemcode: i.itemcode,
                            itemname: i.itemData !== null && i.itemData.itemname
                                ? i.itemData.itemname
                                : null,
                            price: i.itemData !== null && i.itemData.price !== null
                                ? accounting_1.unformat(i.itemData.price)
                                : 0,
                            expectedPrice: i.expectedPrice,
                            approvedPrice: i.approvedPrice,
                            volume: i.volume,
                        };
                    })
                    : newRequest.items, groupItems: existingRequest !== null && existingRequest.data !== null
                    ? existingRequest.data.groupItems
                    : [], noteHtml: existingRequest !== null &&
                    existingRequest.data !== null &&
                    existingRequest.data.note
                    ? existingRequest.data.note
                    : newRequest.descriptionHtml, status: existingRequest !== null &&
                    existingRequest.data !== null &&
                    existingRequest.status !== null
                    ? existingRequest.status
                    : newRequest.status }),
            React.createElement(indicator_1.LoadingFullScreen, { fitInContainer: true, active: this.props.existingRequest !== null &&
                    typeof this.props.existingRequest.loading !== 'undefined' &&
                    this.props.existingRequest.loading === true })))));
    };
    PricingRequestModal.prototype.renderPricingRequestTitleBarContent = function () {
        var _this = this;
        var _a = this.props.store.leadPricing, allPricingItemListLength = _a.allPricingItemListLength, allPricingItemListLoading = _a.allPricingItemListLoading, newRequestItemsLength = _a.newRequestItemsLength, pricingSearch = _a.pricingSearch, pricingSearchLength = _a.pricingSearchLength, pricingItemSearchResults = _a.pricingItemSearchResults, pricingItemSearchResultsLength = _a.pricingItemSearchResultsLength;
        return (React.createElement("div", { className: s.autocomplete },
            React.createElement("input", { ref: this.referenceSearchField, className: s.field, value: pricingSearch, placeholder: "Search item code or name...", onChange: this.handleSearch, onFocus: this.toggleSearchFieldFocus(true), onBlur: this.toggleSearchFieldFocus(false, 128) }),
            React.createElement(react_transition_group_1.CSSTransitionGroup, { component: "div", className: s.resultsContainer, transitionName: "fade", transitionAppear: true, transitionEnter: true, transitionLeave: true, transitionAppearTimeout: 300, transitionEnterTimeout: 300, transitionLeaveTimeout: 300 },
                allPricingItemListLoading === false && this.searchFieldFocused && (React.createElement("div", { className: s.results }, pricingItemSearchResults.map(function (result, i) { return (React.createElement("button", { key: result.id, className: s.result, onClick: _this.handleItemAddToPricingRequest(result) },
                    React.createElement("strong", null, result.itemcode),
                    React.createElement("span", null, result.itemname))); }))),
                pricingItemSearchResultsLength <= 0 && (React.createElement("div", { key: "no-items", className: s.results },
                    React.createElement("p", { className: s.label }, allPricingItemListLength <= 0
                        ? 'No items pricing found for this lead.'
                        : newRequestItemsLength >= allPricingItemListLength
                            ? 'All items have been added.'
                            : 'No items matching search query.'))),
                allPricingItemListLoading && (React.createElement("div", { key: "loading-items", className: s.results },
                    React.createElement("p", { className: s.label }, "Loading items..."))))));
    };
    __decorate([
        mobx_1.computed
    ], PricingRequestModal.prototype, "modalTitle", null);
    __decorate([
        mobx_1.observable
    ], PricingRequestModal.prototype, "searchFieldFocused", void 0);
    __decorate([
        mobx_1.action
    ], PricingRequestModal.prototype, "toggleSearchFieldFocus", void 0);
    __decorate([
        mobx_1.action
    ], PricingRequestModal.prototype, "handleSearch", void 0);
    PricingRequestModal = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], PricingRequestModal);
    return PricingRequestModal;
}(React.Component));
exports.PricingRequestModal = PricingRequestModal;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/PricingRequest/Modal/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/PricingRequest/Modal/PricingRequestModal.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/PricingRequest/Modal/PricingRequestContent.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/PricingRequest/Sidebar/PricingRequestSidebar.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/PricingRequest/Sidebar/PricingRequestSidebar.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./PricingRequestSidebar.css", function() {
		var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./PricingRequestSidebar.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/PricingRequest/Sidebar/PricingRequestSidebar.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var pricing_1 = __webpack_require__("./app/web/src/components/pricing/index.ts");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/PricingRequest/Sidebar/PricingRequestSidebar.css");
// Component
var PricingRequestSidebar = /** @class */ (function (_super) {
    __extends(PricingRequestSidebar, _super);
    function PricingRequestSidebar(props) {
        var _this = _super.call(this, props) || this;
        _this.handlePendingPricingRequestClick = function (request) {
            _this.props.store.pricingRequest.fetchSinglePricingRequest(request.id);
        };
        return _this;
    }
    PricingRequestSidebar.prototype.render = function () {
        return React.createElement("div", null, this.renderPendingPricingRequests());
    };
    PricingRequestSidebar.prototype.renderPendingPricingRequests = function () {
        var _this = this;
        var _a = this.props.store.leadPricing, pendingPricingRequests = _a.pendingPricingRequests, fetchedPendingPricingRequests = _a.fetchedPendingPricingRequests, loadingPendingPricingRequests = _a.loadingPendingPricingRequests;
        if (pendingPricingRequests.length > 0) {
            return (React.createElement("div", { className: s.pending },
                pendingPricingRequests.map(function (request, i) {
                    return (React.createElement(pricing_1.PricingRequestListItem, { key: request.id, showLeadAndAuthorName: false, className: s.pendingRequest, onClick: _this.handlePendingPricingRequestClick, request: {
                            id: request.id,
                            createdByUser: request.createdByUser,
                            createdByUserId: request.createdByUserId,
                            note: request.note,
                            complete: request.complete ? 1 : 0,
                            createdAt: request.createdAt,
                            updatedAt: request.updatedAt,
                            providerId: request.providerId,
                            provider: {
                                databaseId: request.provider.id,
                                providerId: parseInt(request.provider.providerId, 10),
                                dba: request.provider.dba,
                                legalBusName: request.provider.legalBusName,
                                groupId: typeof request.providerGroup !== 'undefined' &&
                                    request.providerGroup !== null &&
                                    typeof request.providerGroup.id !== 'undefined'
                                    ? request.providerGroup.id
                                    : null,
                                providerGroup: typeof request.providerGroup &&
                                    request.providerGroup !== null
                                    ? request.providerGroup
                                    : null,
                            },
                        } }));
                }),
                ";"));
        }
        else if (loadingPendingPricingRequests) {
            return (React.createElement("div", { className: s.loadingContainer },
                React.createElement(index_1.SavingIndicator, { align: "left", labels: { saving: 'Loading pending requests...' }, status: index_1.SavingIndicatorStatus.Saving })));
        }
        else {
            return (React.createElement("p", { key: "empty-message", className: s.empty }, "No pending pricing requests"));
        }
    };
    PricingRequestSidebar = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], PricingRequestSidebar);
    return PricingRequestSidebar;
}(React.Component));
exports.PricingRequestSidebar = PricingRequestSidebar;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/PricingRequest/Sidebar/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/PricingRequest/Sidebar/PricingRequestSidebar.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/PricingRequest/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/PricingRequest/Modal/index.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/PricingRequest/Sidebar/index.ts"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Questions/LeadQuestions.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Questions/LeadQuestions.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadQuestions.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadQuestions.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Questions/LeadQuestions.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var Question_1 = __webpack_require__("./app/web/src/routes/sales/Lead/Questions/Question/index.tsx");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Questions/LeadQuestions.css");
// Component
var LeadQuestions = /** @class */ (function (_super) {
    __extends(LeadQuestions, _super);
    function LeadQuestions(props) {
        return _super.call(this, props) || this;
    }
    LeadQuestions.prototype.render = function () {
        var store = this.props.store;
        return (React.createElement("div", { className: s.questions },
            store.question.questionWithOptionInfo.map(function (question, i) {
                return question !== null && typeof question.id !== 'undefined' ? (React.createElement(Question_1.Question, { index: i, child: false, key: question.id, questionInfo: question }, typeof question.children !== 'undefined' &&
                    question.children !== null &&
                    question.children.length > 0 && (React.createElement("div", null, question.children.map(function (childQuestion, c) {
                    return childQuestion !== null &&
                        typeof childQuestion.id !== 'undefined' ? (React.createElement(Question_1.Question, { index: c, child: true, key: childQuestion.id, questionInfo: childQuestion })) : null;
                }))))) : null;
            }),
            React.createElement(indicator_1.LoadingFullScreen, { active: store.question.loading || store.answer.loading, fitInContainer: true })));
    };
    LeadQuestions = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], LeadQuestions);
    return LeadQuestions;
}(React.Component));
exports.LeadQuestions = LeadQuestions;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Questions/Options/QuestionOptionCheckbox.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Questions/LeadQuestions.css");
// Component
var QuestionOptionCheckbox = /** @class */ (function (_super) {
    __extends(QuestionOptionCheckbox, _super);
    function QuestionOptionCheckbox(props) {
        var _this = _super.call(this, props) || this;
        _this.handleCheckboxChange = function (checked, value) {
            if (_this.props.onChange) {
                _this.props.onChange({
                    checked: checked,
                    value: value,
                });
            }
        };
        return _this;
    }
    QuestionOptionCheckbox.prototype.render = function () {
        var _this = this;
        return this.props.options !== null && this.props.options.length > 0 ? (React.createElement("div", { className: classNames(s.checkboxesList, 'options_from_' + this.props.optionsTable) }, this.props.options.map(function (option, i) {
            return (React.createElement(action_1.Checkbox, { key: "option-" + i, onChange: _this.handleCheckboxChange, label: option.name, value: option.id, valueUnchecked: option.id, checked: _this.props.value !== null &&
                    typeof _this.props.value.length !== 'undefined'
                    ? _this.props.value.indexOf(option.id) !== -1
                    : false }));
        }))) : null;
    };
    QuestionOptionCheckbox = __decorate([
        mobx_react_1.observer
    ], QuestionOptionCheckbox);
    return QuestionOptionCheckbox;
}(React.Component));
exports.QuestionOptionCheckbox = QuestionOptionCheckbox;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Questions/Options/QuestionOptionRadio.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/styles/sales/sales.css");
// Component
var QuestionOptionRadio = /** @class */ (function (_super) {
    __extends(QuestionOptionRadio, _super);
    function QuestionOptionRadio(props) {
        var _this = _super.call(this, props) || this;
        _this.handleToggleChange = function (value) {
            if (_this.props.onChange) {
                _this.props.onChange(value);
            }
        };
        _this.handleRadioChange = function (checked, value) {
            if (_this.props.onChange) {
                _this.props.onChange({
                    value: value,
                    label: value,
                    type: 'default',
                });
            }
        };
        return _this;
    }
    Object.defineProperty(QuestionOptionRadio.prototype, "options", {
        get: function () {
            return typeof this.props.options !== 'undefined' && this.props.options
                ? typeof this.props.options === 'object'
                    ? typeof this.props.options.length !== 'undefined'
                        ? this.props.options
                        : Object.keys(this.props.options)
                    : null
                : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionOptionRadio.prototype, "optionsLength", {
        get: function () {
            return this.options !== null ? this.options.length : 0;
        },
        enumerable: true,
        configurable: true
    });
    QuestionOptionRadio.prototype.render = function () {
        return this.optionsLength > 0 && this.optionsLength <= 2
            ? this.renderYesOrNoToggle()
            : this.optionsLength > 0
                ? this.renderMoreOptions()
                : null;
    };
    QuestionOptionRadio.prototype.renderYesOrNoToggle = function () {
        return (React.createElement(action_1.Toggle, { onChange: this.handleToggleChange, left: {
                value: 0,
                label: this.props.options[0],
                type: 'default',
            }, right: {
                value: 1,
                label: this.props.options[1],
                type: 'success',
            }, value: this.props.value }));
    };
    QuestionOptionRadio.prototype.renderMoreOptions = function () {
        var _this = this;
        return (React.createElement("div", null, this.options.map(function (option, i) {
            return (React.createElement(action_1.Checkbox, { key: "option-" + i, onChange: _this.handleRadioChange, checked: _this.props.value === option, value: option, valueUnchecked: false, label: option }));
        })));
    };
    __decorate([
        mobx_1.computed
    ], QuestionOptionRadio.prototype, "options", null);
    __decorate([
        mobx_1.computed
    ], QuestionOptionRadio.prototype, "optionsLength", null);
    QuestionOptionRadio = __decorate([
        mobx_react_1.observer
    ], QuestionOptionRadio);
    return QuestionOptionRadio;
}(React.Component));
exports.QuestionOptionRadio = QuestionOptionRadio;
exports.default = QuestionOptionRadio;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Questions/Options/QuestionOptionSelect.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Questions/LeadQuestions.css");
// Component
var QuestionOptionSelect = /** @class */ (function (_super) {
    __extends(QuestionOptionSelect, _super);
    function QuestionOptionSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelectChange = function (e) {
            var optionIndex = -1;
            _this.props.options.some(function (option, i) {
                if (option.id === e.currentTarget.value ||
                    option.id === parseInt(e.currentTarget.value, 10)) {
                    optionIndex = i;
                    return true;
                }
                return false;
            });
            if (optionIndex !== -1 && _this.props.onChange) {
                _this.props.onChange({
                    value: _this.props.options[optionIndex].id,
                    label: _this.props.options[optionIndex].name,
                });
            }
        };
        return _this;
    }
    Object.defineProperty(QuestionOptionSelect.prototype, "value", {
        get: function () {
            return this.props.value !== null
                ? typeof this.props.value === 'number'
                    ? this.props.value.toString()
                    : typeof this.props.value === 'string'
                        ? this.props.value
                        : typeof this.props.value === 'object' &&
                            typeof this.props.value.length !== 'undefined' &&
                            this.props.value.length > 0
                            ? typeof this.props.value[0].id !== 'undefined'
                                ? this.props.value[0].id
                                : this.props.value[0]
                            : null
                : null;
        },
        enumerable: true,
        configurable: true
    });
    QuestionOptionSelect.prototype.render = function () {
        var options = [];
        if (this.props.options === null || this.props.options.length <= 0) {
            options.push(React.createElement("option", { key: "option-undefined", value: "null-undefined" }, "No answers"));
        }
        else if (this.value === null) {
            options.push(React.createElement("option", { key: "option-initial", value: "null-initial" }, "Answer"));
        }
        this.props.options.map(function (option, i) {
            options.push(React.createElement("option", { key: 'option-' + i + '-' + option.id, value: typeof option.id === 'number' ? option.id.toString() : option.id }, option.name));
        });
        return options.length > 0 ? (React.createElement("div", { className: s.selectOptionsContainer },
            React.createElement("select", { onChange: this.handleSelectChange, value: this.value !== null ? this.value : undefined }, options))) : null;
    };
    __decorate([
        mobx_1.computed
    ], QuestionOptionSelect.prototype, "value", null);
    QuestionOptionSelect = __decorate([
        mobx_react_1.observer
    ], QuestionOptionSelect);
    return QuestionOptionSelect;
}(React.Component));
exports.QuestionOptionSelect = QuestionOptionSelect;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Questions/Options/QuestionOptionText.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Questions/LeadQuestions.css");
// Component
var QuestionOptionText = /** @class */ (function (_super) {
    __extends(QuestionOptionText, _super);
    function QuestionOptionText(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(QuestionOptionText, "defaultProps", {
        get: function () {
            return {
                className: null,
                onChange: null,
                value: null,
            };
        },
        enumerable: true,
        configurable: true
    });
    QuestionOptionText.prototype.render = function () {
        return (React.createElement(content_1.ContentEditable, { classNameForField: classNames(s.optionText, this.props.className), onChange: this.props.onChange, placeholder: typeof this.props.placeholder !== 'undefined'
                ? this.props.placeholder
                : undefined, html: this.props.value, contentEditable: true }));
    };
    QuestionOptionText = __decorate([
        mobx_react_1.observer
    ], QuestionOptionText);
    return QuestionOptionText;
}(React.Component));
exports.QuestionOptionText = QuestionOptionText;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Questions/Options/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Questions/Options/QuestionOptionText.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Questions/Options/QuestionOptionSelect.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Questions/Options/QuestionOptionCheckbox.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Questions/Options/QuestionOptionRadio.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Questions/Question/Question.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__("./app/web/src/routes/sales/Lead/Questions/Question/index.tsx");
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var findIndex_1 = __webpack_require__("./node_modules/lodash-es/findIndex.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Questions/LeadQuestions.css");
var whiteTickIcon = __webpack_require__("./app/web/src/assets/tick white.svg");
// Component
var Question = /** @class */ (function (_super) {
    __extends(Question, _super);
    function Question(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(Question.prototype, "answerIndex", {
        get: function () {
            var _this = this;
            return findIndex_1.default(this.props.store.answer.answers, function (answer) { return answer.id === _this.props.questionInfo.id; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "answer", {
        get: function () {
            var answer = this.props.store.answer;
            return this.answerIndex !== -1 ? answer.answers[this.answerIndex] : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "unanswered", {
        get: function () {
            return (this.answer === null ||
                (this.answer.type === 'text' &&
                    (typeof this.answer.note === 'undefined' ||
                        this.answer.note === null ||
                        this.answer.note === '')) ||
                (this.answer.type === 'radio' &&
                    (typeof this.answer.answer === 'undefined' ||
                        this.answer.answer === null ||
                        this.answer.answer.length <= 0)) ||
                (this.answer.type === 'checkbox' &&
                    (typeof this.answer.answer === 'undefined' ||
                        this.answer.answer === null ||
                        this.answer.answer.length <= 0)) ||
                (this.answer.type === 'select' &&
                    (typeof this.answer.answer === 'undefined' ||
                        this.answer.answer === null ||
                        this.answer.answer.length <= 0)));
        },
        enumerable: true,
        configurable: true
    });
    Question.prototype.render = function () {
        var _a = this.props, questionInfo = _a.questionInfo, index = _a.index;
        if (this.props.child) {
            return this.renderQuestion();
        }
        else {
            return (React.createElement("div", { className: s.questionGroup },
                this.renderQuestion(),
                typeof this.props.children !== 'undefined' &&
                    this.props.children &&
                    this.unanswered === false &&
                    this.props.children));
        }
    };
    Question.prototype.renderQuestion = function () {
        var _a;
        var _b = this.props, questionInfo = _b.questionInfo, index = _b.index;
        return (React.createElement("div", { className: s.question },
            React.createElement("h2", { className: s.label }, questionInfo.question),
            React.createElement(_1.QuestionOption, { questionInfo: questionInfo, answerDetails: this.answer, unanswered: this.unanswered }),
            this.props.child === false && React.createElement("p", { className: s.index }, index + 1),
            React.createElement("i", { className: classNames(s.status, (_a = {},
                    _a[s.unanswered] = this.unanswered,
                    _a)) }, this.answer !== null && React.createElement("img", { src: whiteTickIcon }))));
    };
    __decorate([
        mobx_1.computed
    ], Question.prototype, "answerIndex", null);
    __decorate([
        mobx_1.computed
    ], Question.prototype, "answer", null);
    __decorate([
        mobx_1.computed
    ], Question.prototype, "unanswered", null);
    Question = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], Question);
    return Question;
}(React.Component));
exports.Question = Question;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Questions/Question/QuestionOption.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var capitalize_1 = __webpack_require__("./node_modules/lodash-es/capitalize.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var __1 = __webpack_require__("./app/web/src/routes/sales/Lead/Questions/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Questions/LeadQuestions.css");
// Component
var QuestionOption = /** @class */ (function (_super) {
    __extends(QuestionOption, _super);
    function QuestionOption(props) {
        var _this = _super.call(this, props) || this;
        _this.handleTextChange = function (html, text) {
            _this.props.store.answer.changeAnswerNote(_this.props.answerDetails !== null ? _this.props.answerDetails.id : null, _this.props.questionInfo, text.trim(), html);
        };
        _this.handleRadioChange = function (radio) {
            _this.props.store.answer.changeAnswerValue(_this.props.answerDetails !== null ? _this.props.answerDetails.id : null, _this.props.questionInfo, radio.value, radio.label);
        };
        _this.handleCheckboxChange = function (box) {
            _this.props.store.answer.changeAnswerCheckbox(_this.props.answerDetails !== null ? _this.props.answerDetails.id : null, _this.props.questionInfo, box.checked, box.value);
        };
        _this.handleSelectChange = function (selected) {
            _this.props.store.answer.changeAnswerSelect(_this.props.answerDetails !== null ? _this.props.answerDetails.id : null, _this.props.questionInfo, selected.value);
        };
        return _this;
    }
    QuestionOption.prototype.render = function () {
        var _a = this.props, questionInfo = _a.questionInfo, answerDetails = _a.answerDetails;
        var renderOptionFunction = 'render' + capitalize_1.default(questionInfo.type);
        if (typeof this[renderOptionFunction] !== 'undefined') {
            return (React.createElement("div", null,
                this[renderOptionFunction](),
                React.createElement(indicator_1.SavingIndicator, { className: s.questionSavingIndicator, labels: { saving: 'Saving changes' }, status: answerDetails !== null && answerDetails.saving
                        ? indicator_1.SavingIndicatorStatus.Saving
                        : indicator_1.SavingIndicatorStatus.None })));
        }
        else {
            console.error("Question / answer of type " + questionInfo.type + " is not implemented");
            return null;
        }
    };
    QuestionOption.prototype.renderText = function () {
        var answerDetails = this.props.answerDetails;
        return (React.createElement(__1.QuestionOptionText, { onChange: this.handleTextChange, value: answerDetails && answerDetails.note ? answerDetails.note : '', placeholder: "Answer..." }));
    };
    QuestionOption.prototype.renderRadio = function () {
        var answerDetails = this.props.answerDetails;
        return (React.createElement(__1.QuestionOptionRadio, { onChange: this.handleRadioChange, options: this.props.questionInfo.option, value: answerDetails !== null &&
                answerDetails.answer &&
                answerDetails.answer.length > 0
                ? typeof answerDetails.answer[0] === 'object' &&
                    typeof answerDetails.answer[0].id !== 'undefined'
                    ? answerDetails.answer[0].id
                    : answerDetails.answer[0]
                : null }));
    };
    QuestionOption.prototype.renderCheckbox = function () {
        var _a = this.props, questionInfo = _a.questionInfo, answerDetails = _a.answerDetails;
        return (React.createElement("div", null,
            React.createElement(__1.QuestionOptionCheckbox, { onChange: this.handleCheckboxChange, optionsTable: questionInfo.optionTable, options: typeof questionInfo.option !== 'undefined' &&
                    questionInfo.option &&
                    questionInfo.option.length > 0
                    ? questionInfo.option.map(function (option, i) { return ({
                        id: option.id,
                        name: option.name,
                    }); })
                    : null, value: answerDetails !== null &&
                    answerDetails.answer &&
                    answerDetails.answer.length > 0
                    ? typeof answerDetails.answer[0] === 'object' &&
                        typeof answerDetails.answer[0].id !== 'undefined'
                        ? answerDetails.answer.map(function (answer, i) { return answer.id; })
                        : answerDetails.answer
                    : null }),
            questionInfo.note === 1 && (React.createElement(__1.QuestionOptionText, { className: s.checkboxesOtherTextField, onChange: this.handleTextChange, value: answerDetails && answerDetails.note ? answerDetails.note : '', placeholder: "Other..." }))));
    };
    QuestionOption.prototype.renderSelect = function () {
        var _a = this.props, questionInfo = _a.questionInfo, answerDetails = _a.answerDetails, store = _a.store;
        var options = [];
        switch (questionInfo.optionTable) {
            case 'wholesaler':
                options = questionInfo.option.map(function (option, i) { return ({
                    id: option.id,
                    name: option.wholesaler,
                }); });
                break;
            case 'sourcing_program':
                var sourcingPrograms = store.answer.primaryWholesalerSourcingProgramsIds !== null
                    ? questionInfo.option.filter(function (option) {
                        return store.answer.primaryWholesalerSourcingProgramsIds.indexOf(option.id) !== -1;
                    })
                    : questionInfo.option;
                options = sourcingPrograms.map(function (option, i) { return ({
                    id: option.id,
                    name: option.program,
                }); });
                break;
            case 'buying_group':
                options = questionInfo.option.map(function (option, i) { return ({
                    id: option.id,
                    name: option.groupCode + ' - ' + option.groupName,
                }); });
                break;
            default:
                break;
        }
        return (React.createElement("div", null,
            React.createElement(__1.QuestionOptionSelect, { onChange: this.handleSelectChange, optionsTable: questionInfo.optionTable, options: options, value: answerDetails !== null && answerDetails.answer
                    ? answerDetails.answer
                    : null }),
            questionInfo.note === 1 && (React.createElement(__1.QuestionOptionText, { className: s.checkboxesOtherTextField, onChange: this.handleTextChange, value: answerDetails && answerDetails.note ? answerDetails.note : '', placeholder: "Other..." }))));
    };
    QuestionOption = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], QuestionOption);
    return QuestionOption;
}(React.Component));
exports.QuestionOption = QuestionOption;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Questions/Question/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Questions/Question/Question.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Questions/Question/QuestionOption.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Questions/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Questions/LeadQuestions.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Questions/Question/index.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Questions/Options/index.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Relations/LeadRelations.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Relations/LeadRelations.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadRelations.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadRelations.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Relations/LeadRelations.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var padStart_1 = __webpack_require__("./node_modules/lodash-es/padStart.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Relations/LeadRelations.css");
// Component
var LeadRelations = /** @class */ (function (_super) {
    __extends(LeadRelations, _super);
    function LeadRelations() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LeadRelations.prototype.render = function () {
        var openLeadDetails = this.props.store.lead.openLeadDetails;
        if (!openLeadDetails || openLeadDetails.relations.length <= 0) {
            return null;
        }
        return (React.createElement("ol", { className: s.list }, openLeadDetails.relations.map(function (relation, relationIndex) { return (React.createElement("li", { key: relationIndex },
            React.createElement("h4", null,
                React.createElement("span", null, padStart_1.default((relationIndex + 1).toString() + '.', 3, '0')),
                React.createElement("strong", null, relation.name)))); })));
    };
    LeadRelations = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], LeadRelations);
    return LeadRelations;
}(React.Component));
exports.LeadRelations = LeadRelations;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Relations/LeadRelationsModal.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Relations/LeadRelationsModal.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadRelationsModal.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadRelationsModal.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Relations/LeadRelationsModal.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var classnames_1 = __webpack_require__("./node_modules/classnames/index.js");
var location_1 = __webpack_require__("./app/web/data/location/index.ts");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Relations/LeadRelationsModal.css");
// Component
var LeadRelationsModal = /** @class */ (function (_super) {
    __extends(LeadRelationsModal, _super);
    function LeadRelationsModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClosingModal = function () {
            _this.props.store.lead.showRelationsOfOpenLead = false;
        };
        return _this;
    }
    Object.defineProperty(LeadRelationsModal.prototype, "relations", {
        get: function () {
            if (this.props.store.lead.openLeadDetails) {
                var statesKeys_1 = [];
                return this.props.store.lead.openLeadDetails.relations.reduce(function (states, relation) {
                    var index = statesKeys_1.indexOf(relation.state);
                    if (index === -1) {
                        index = statesKeys_1.length;
                        statesKeys_1.push(relation.state);
                        states.push({
                            state: relation.state,
                            relations: [],
                        });
                    }
                    var address = [
                        relation.address1,
                        relation.address2,
                        relation.city,
                        relation.zipcode,
                        relation.state,
                    ].filter(function (addr) { return addr !== null && addr !== ''; });
                    states[index].relations.push({
                        name: relation.name,
                        type: relation.description,
                        address: address.join(', '),
                        phone: relation.phone && typeof relation.phone === 'number'
                            ? relation.phone.toString()
                            : relation.phone || null,
                        // relation.extension && relation.phone
                        //     ? `(${relation.extension}) ${relation.phone}`
                        //     : relation.phone
                        //     ? relation.phone.toString()
                        //     : null,
                        fax: null,
                        // relation.extension && relation.fax
                        //     ? `(${relation.extension}) ${relation.fax}`
                        //     : relation.fax
                        //     ? relation.fax.toString()
                        //     : null,
                        contact: {
                            name: '',
                            // (relation.contactTitle
                            //     ? relation.contactTitle + ' '
                            //     : '') + relation.contactName,
                            email: '',
                        },
                    });
                    return states;
                }, []);
            }
            return [];
        },
        enumerable: true,
        configurable: true
    });
    LeadRelationsModal.prototype.render = function () {
        var _a = this.props.store.lead, leadTitle = _a.leadTitle, openLeadDetails = _a.openLeadDetails;
        return (React.createElement(content_1.Modal, { show: this.props.show, title: leadTitle + " relations", onModalClose: this.handleClosingModal }, this.props.show && (React.createElement("div", { className: s.container },
            React.createElement("div", { className: s.header }, openLeadDetails && (React.createElement("div", { className: s.summary },
                React.createElement("h2", null, openLeadDetails.dba || openLeadDetails.legalBusName),
                openLeadDetails.dba &&
                    openLeadDetails.legalBusName &&
                    openLeadDetails.dba !== openLeadDetails.legalBusName && (React.createElement("h3", null, openLeadDetails.legalBusName))))),
            React.createElement("div", { className: s.items },
                this.relations.length <= 0 && (React.createElement("div", { className: classnames_1.default(s.row, s.empty) },
                    React.createElement("p", null, "No relations are available for this lead."))),
                this.relations.map(function (region, regionIndex) { return (React.createElement("div", { key: region.state },
                    React.createElement("div", { className: classnames_1.default(s.row, s.stateRow) },
                        React.createElement("div", null,
                            React.createElement("p", null, location_1.usaStatesList[region.state] || region.state)),
                        React.createElement("div", null,
                            React.createElement("p", null, region.relations.length +
                                ' relation' +
                                (region.relations.length > 1 ? 's' : '')))),
                    region.relations.map(function (relation, relationIndex) { return (React.createElement("div", { key: region.state + '-' + relationIndex },
                        React.createElement("div", { className: classnames_1.default(s.row, s.subRow, s.relationRow) },
                            React.createElement("div", null,
                                React.createElement("p", null, relation.name)),
                            React.createElement("div", null,
                                React.createElement("p", null, relation.type))),
                        React.createElement("div", { className: classnames_1.default(s.row, s.detailsRow) },
                            React.createElement("div", null,
                                relation.address && React.createElement("p", null, relation.address),
                                (relation.phone || relation.fax) && (React.createElement("p", null,
                                    relation.phone && React.createElement("span", null, 'P. '),
                                    relation.phone && (React.createElement("strong", null, relation.phone)),
                                    relation.fax && React.createElement("span", null, 'F. '),
                                    relation.fax && React.createElement("strong", null, relation.fax),
                                    relation.contact.email && React.createElement("span", null, 'E. '),
                                    relation.contact.email && (React.createElement("strong", null, relation.contact.email)))),
                                relation.contact.name && (React.createElement("p", null, relation.contact.name)))))); }))); }))))));
    };
    __decorate([
        mobx_1.computed
    ], LeadRelationsModal.prototype, "relations", null);
    __decorate([
        mobx_1.action
    ], LeadRelationsModal.prototype, "handleClosingModal", void 0);
    LeadRelationsModal = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], LeadRelationsModal);
    return LeadRelationsModal;
}(React.Component));
exports.LeadRelationsModal = LeadRelationsModal;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Relations/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Relations/LeadRelations.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Relations/LeadRelationsModal.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Resources/LeadResources.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Resources/LeadResources.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadResources.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LeadResources.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Resources/LeadResources.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var resources_1 = __webpack_require__("./app/common/interfaces/resources.ts");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var Resource_1 = __webpack_require__("./app/web/src/routes/sales/Lead/Resources/Resource/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Resources/LeadResources.css");
var addIcon = __webpack_require__("./app/web/src/assets/plus icon.svg");
var cancelIcon = __webpack_require__("./app/web/src/assets/close orange icon.svg");
// Component
var LeadResources = /** @class */ (function (_super) {
    __extends(LeadResources, _super);
    function LeadResources() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LeadResources.prototype.render = function () {
        var leadResources = this.props.store.leadResources;
        return (React.createElement("div", { className: s.resources },
            React.createElement("div", { className: s.list }, (leadResources.all.length > 0) && (React.createElement("div", null, leadResources.all.map(function (resource) { return (React.createElement(Resource_1.Resource, { key: "file-" + resource.id, resource: resource, editing: leadResources.editing, onDelete: leadResources.removeLeadResource })); }))) || (React.createElement("p", { className: s.noResources }, "No resources have been uploaded for this lead yet."))),
            React.createElement("div", { className: s.upload },
                React.createElement(action_1.FileUpload, { onChange: leadResources.handleUploadFilesChange, uploading: leadResources.uploadFiles.status === resources_1.UploadStatus.Saving, files: leadResources.uploadFiles.files, label: "Drag files or click to upload resources", multiple: true })),
            React.createElement(indicator_1.LoadingFullScreen, { active: leadResources.loading, fitInContainer: true })));
    };
    LeadResources = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], LeadResources);
    return LeadResources;
}(React.Component));
exports.LeadResources = LeadResources;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Resources/Resource/Resource.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Resources/Resource/Resource.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Resource.css", function() {
		var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Resource.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Resources/Resource/Resource.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Resources/Resource/Resource.css");
var deleteIcon = __webpack_require__("./app/web/src/assets/close orange icon.svg");
var fileBoxCorner = __webpack_require__("./app/web/src/assets/filetypes/file corner.png");
var docIcon = __webpack_require__("./app/web/src/assets/filetypes/office word icon.svg");
var excelIcon = __webpack_require__("./app/web/src/assets/filetypes/office excel icon.svg");
var powerpointIcon = __webpack_require__("./app/web/src/assets/filetypes/office powerpoint icon.svg");
var pdfIcon = __webpack_require__("./app/web/src/assets/filetypes/acrobat icon.svg");
var imageIcon = __webpack_require__("./app/web/src/assets/filetypes/image icon.svg");
var anyfileIcon = __webpack_require__("./app/web/src/assets/filetypes/other format icon.svg");
// Component
var Resource = /** @class */ (function (_super) {
    __extends(Resource, _super);
    function Resource(props) {
        var _this = _super.call(this, props) || this;
        _this.handleResourceRemoval = function () {
            if (_this.props.onDelete) {
                _this.props.onDelete(_this.props.resource.id);
            }
        };
        return _this;
    }
    Object.defineProperty(Resource, "defaultProps", {
        get: function () {
            return {
                resource: null,
                editing: false,
                onDelete: null,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "icon", {
        get: function () {
            var icon = null;
            switch (this.props.resource.fileType) {
                case 'application/msword':
                case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
                case 'application/vnd.ms-word.document.macroEnabled.12':
                case 'application/vnd.ms-word.template.macroEnabled.12':
                case 'application/rtf':
                    icon = docIcon;
                    break;
                case 'application/vnd.ms-excel':
                case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                case 'application/vnd.openxmlformats-officedocument.spreadsheetml.template':
                case 'application/vnd.ms-excel.sheet.macroEnabled.12':
                case 'application/vnd.ms-excel.template.macroEnabled.12':
                case 'application/vnd.ms-excel.addin.macroEnabled.12':
                case 'application/vnd.ms-excel.sheet.binary.macroEnabled.12':
                case 'text/csv':
                    icon = excelIcon;
                    break;
                case 'application/vnd.ms-powerpoint':
                case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                case 'application/vnd.openxmlformats-officedocument.presentationml.template':
                case 'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
                case 'application/vnd.ms-powerpoint.addin.macroEnabled.12':
                case 'application/vnd.ms-powerpoint.presentation.macroEnabled.12':
                case 'application/vnd.ms-powerpoint.template.macroEnabled.12':
                case 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12':
                    icon = powerpointIcon;
                    break;
                case 'application/pdf':
                    icon = pdfIcon;
                    break;
                case 'image/gif':
                case 'image/x-icon':
                case 'image/jpeg':
                case 'image/jpg':
                case 'image/png':
                case 'image/svg':
                case 'image/svg+xml':
                case 'image/tiff':
                case 'image/webp':
                case 'image/bmp':
                    icon = imageIcon;
                    break;
                default:
                    icon = anyfileIcon;
                    break;
            }
            return icon;
        },
        enumerable: true,
        configurable: true
    });
    Resource.prototype.render = function () {
        var _a = this.props.resource, fileTitle = _a.fileTitle, fileName = _a.fileName, fileLink = _a.fileLink, updatedAt = _a.updatedAt;
        return (React.createElement("div", { className: s.resource },
            React.createElement("a", { href: fileLink, className: s.box },
                React.createElement("img", { className: s.icon, src: this.icon }),
                React.createElement("img", { className: s.corner, src: fileBoxCorner })),
            React.createElement("div", { className: s.description },
                React.createElement("a", { href: fileLink, className: s.name }, fileTitle || fileName),
                React.createElement("p", { className: s.date }, moment(updatedAt).format('M/DD/YYYY'))),
            (this.props.editing) && (React.createElement("div", { className: s.delete },
                React.createElement(action_1.IconButton, { onClick: this.handleResourceRemoval, label: "Delete", showLabel: true, icon: deleteIcon, labelOnRight: false })))));
    };
    __decorate([
        mobx_1.computed
    ], Resource.prototype, "icon", null);
    Resource = __decorate([
        mobx_react_1.observer
    ], Resource);
    return Resource;
}(React.Component));
exports.Resource = Resource;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Resources/Resource/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Resources/Resource/Resource.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Resources/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Resources/LeadResources.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Sales/RepCollectionsModal.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Sales/RepCollectionsModal.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./RepCollectionsModal.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./RepCollectionsModal.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Sales/RepCollectionsModal.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var OrderPadSales_1 = __webpack_require__("./app/web/src/stores/OrderPadSales.ts");
var RepCollectionsPeriod_1 = __webpack_require__("./app/web/src/routes/sales/Lead/Sales/RepCollectionsPeriod.tsx");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Sales/RepCollectionsModal.css");
// Component
var RepCollectionsModal = /** @class */ (function (_super) {
    __extends(RepCollectionsModal, _super);
    function RepCollectionsModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.closeModal = function () {
            _this.props.store.orderPadSales.toggleCollectionsModal(false);
        };
        _this.retryMonthlyCollectionsFetch = function () {
            _this.props.store.orderPadSales.fetchMonthlyCollections();
        };
        return _this;
    }
    Object.defineProperty(RepCollectionsModal, "defaultProps", {
        get: function () {
            return {
                show: false,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RepCollectionsModal.prototype, "isLoading", {
        get: function () {
            return (this.props.store.orderPadSales.collectionsMonthsFetchStatus ===
                OrderPadSales_1.CollectionsFetchStatus.Loading &&
                this.props.store.orderPadSales.collectionsMonthsData.length <= 0);
        },
        enumerable: true,
        configurable: true
    });
    RepCollectionsModal.prototype.componentDidMount = function () {
        if (this.props.show) {
            this.props.store.orderPadSales.fetchMonthlyCollections();
        }
    };
    RepCollectionsModal.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.show !== nextProps.show && nextProps.show) {
            this.props.store.orderPadSales.fetchMonthlyCollections();
        }
    };
    RepCollectionsModal.prototype.render = function () {
        var orderPadSales = this.props.store.orderPadSales;
        return (React.createElement(content_1.Modal, { onModalClose: this.closeModal, show: this.props.show, title: "Monthly collections" }, this.props.show && (React.createElement("div", { className: s.container }, (this.isLoading && (React.createElement("div", { className: s.loading },
            React.createElement(indicator_1.LoadingSpinner, { active: true })))) || (React.createElement("div", { className: s.content },
            React.createElement("div", { className: s.status },
                React.createElement(indicator_1.SavingIndicator, { align: "center", labels: {
                        saving: 'Updating data',
                        error: 'Could not fetch data. ',
                        retry: 'Click here to try again',
                    }, onRetry: this.retryMonthlyCollectionsFetch, status: orderPadSales.collectionsMonthsFetchStatus ===
                        OrderPadSales_1.CollectionsFetchStatus.Loading
                        ? indicator_1.SavingIndicatorStatus.Saving
                        : orderPadSales.collectionsMonthsFetchStatus ===
                            OrderPadSales_1.CollectionsFetchStatus.Error
                            ? indicator_1.SavingIndicatorStatus.Error
                            : indicator_1.SavingIndicatorStatus.None })),
            (orderPadSales.collectionsMonthsData.length && (React.createElement("div", { className: s.table }, orderPadSales.collectionsMonthsData.map(function (period) { return (React.createElement(RepCollectionsPeriod_1.RepCollectionsPeriod, { key: period.key, period: period })); })))) || (React.createElement("div", { className: s.table },
                React.createElement("div", { className: s.empty },
                    React.createElement("p", null, "No sales data available."))))))))));
    };
    __decorate([
        mobx_1.computed
    ], RepCollectionsModal.prototype, "isLoading", null);
    RepCollectionsModal = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], RepCollectionsModal);
    return RepCollectionsModal;
}(React.Component));
exports.RepCollectionsModal = RepCollectionsModal;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Sales/RepCollectionsPeriod.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Sales/RepCollectionsPeriod.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./RepCollectionsPeriod.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./RepCollectionsPeriod.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Sales/RepCollectionsPeriod.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var accounting_1 = __webpack_require__("./node_modules/accounting/accounting.js");
var helpers_1 = __webpack_require__("./app/common/helpers/index.ts");
var action_1 = __webpack_require__("./app/web/src/components/action/index.tsx");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var React = __webpack_require__("./node_modules/react/react.js");
var OrderPadSales_1 = __webpack_require__("./app/web/src/stores/OrderPadSales.ts");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Sales/RepCollectionsPeriod.css");
var expandIcon = __webpack_require__("./app/web/src/assets/dropdown arrow.svg");
var collapseIcon = __webpack_require__("./app/web/src/assets/close blue icon.svg");
// Component
var RepCollectionsPeriod = /** @class */ (function (_super) {
    __extends(RepCollectionsPeriod, _super);
    function RepCollectionsPeriod() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isExpanded = false;
        _this.handleSummaryRowClick = function (e) {
            _this.toggleExpansion();
        };
        _this.handleButtonClick = function (e) {
            e.preventDefault();
        };
        _this.handleFetchRetry = function () {
            _this.props.store.orderPadSales.fetchDetailedCollectionsForMonth(_this.props.period.key);
        };
        _this.toggleExpansion = function () {
            var toExpand = !_this.isExpanded;
            _this.isExpanded = toExpand;
            if (toExpand) {
                _this.props.store.orderPadSales.fetchDetailedCollectionsForMonth(_this.props.period.key);
            }
        };
        return _this;
    }
    Object.defineProperty(RepCollectionsPeriod.prototype, "data", {
        get: function () {
            var _a = this.props.store.orderPadSales, collectionsDetailedData = _a.collectionsDetailedData, collectionsDetailedDataKeys = _a.collectionsDetailedDataKeys;
            var index = collectionsDetailedDataKeys.indexOf(this.props.period.key);
            if (index === -1) {
                return null;
            }
            return collectionsDetailedData[index];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RepCollectionsPeriod.prototype, "isLoading", {
        get: function () {
            return (this.data === null ||
                this.data.fetchStatus === OrderPadSales_1.CollectionsFetchStatus.Loading);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RepCollectionsPeriod.prototype, "isLoadingForTheFirstTime", {
        get: function () {
            return (this.isLoading &&
                (this.data === null || this.data.fetchLastTimestamp === 0));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RepCollectionsPeriod.prototype, "isError", {
        get: function () {
            return (this.data !== null &&
                this.data.fetchStatus === OrderPadSales_1.CollectionsFetchStatus.Error);
        },
        enumerable: true,
        configurable: true
    });
    RepCollectionsPeriod.prototype.render = function () {
        var period = this.props.period;
        return (React.createElement("div", { className: s.period },
            React.createElement("div", { className: s.summary, onClick: this.handleSummaryRowClick },
                React.createElement("p", { className: s.label },
                    React.createElement("strong", null, helpers_1.monthName(period.month)),
                    ' ' + period.year),
                React.createElement(indicator_1.SavingIndicator, { status: this.isLoading && !this.isLoadingForTheFirstTime
                        ? indicator_1.SavingIndicatorStatus.Saving
                        : indicator_1.SavingIndicatorStatus.None, labels: {
                        saving: 'Refreshing',
                    } }),
                React.createElement("div", { className: s.right },
                    React.createElement("p", { className: s.amount }, accounting_1.formatMoney(period.amount)),
                    React.createElement(action_1.IconButton, { onClick: this.handleButtonClick, removePadding: true, iconClassName: this.isExpanded ? s.collapseIcon : s.expandIcon, icon: this.isExpanded ? collapseIcon : expandIcon }))),
            (this.isExpanded && period.amount <= 0 && (React.createElement("div", { className: s.details },
                React.createElement("div", { className: s.noResults },
                    React.createElement("p", null, "No collections available for this month."))))) ||
                (this.isExpanded && (React.createElement("div", { className: s.details },
                    (this.isLoadingForTheFirstTime || this.isError) && (React.createElement("div", { className: s.loading },
                        React.createElement(indicator_1.SavingIndicator, { onRetry: this.handleFetchRetry, align: "right", status: this.isError
                                ? indicator_1.SavingIndicatorStatus.Error
                                : indicator_1.SavingIndicatorStatus.Saving, labels: {
                                saving: 'Loading',
                                error: 'Could not fetch data.',
                                retry: ' Click here to try again.',
                            } }))),
                    this.data && (React.createElement("table", { className: s.data },
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", null, "Pay ID"),
                                React.createElement("th", null, "Date"),
                                React.createElement("th", null, "Card Code"),
                                React.createElement("th", null, "Card Name"),
                                React.createElement("th", null, "Amount"))),
                        React.createElement("tbody", null, this.data.payments.map(function (payment) { return (React.createElement("tr", null,
                            React.createElement("td", null, payment.docnum),
                            React.createElement("td", null, moment(payment.docdate).format('M/DD/YYYY')),
                            React.createElement("td", null, payment.cardcode),
                            React.createElement("td", null, payment.cardname),
                            React.createElement("td", null, accounting_1.formatMoney(payment.doctotal)))); })))))))));
    };
    __decorate([
        mobx_1.observable
    ], RepCollectionsPeriod.prototype, "isExpanded", void 0);
    __decorate([
        mobx_1.computed
    ], RepCollectionsPeriod.prototype, "data", null);
    __decorate([
        mobx_1.computed
    ], RepCollectionsPeriod.prototype, "isLoading", null);
    __decorate([
        mobx_1.computed
    ], RepCollectionsPeriod.prototype, "isLoadingForTheFirstTime", null);
    __decorate([
        mobx_1.computed
    ], RepCollectionsPeriod.prototype, "isError", null);
    __decorate([
        mobx_1.action
    ], RepCollectionsPeriod.prototype, "toggleExpansion", void 0);
    RepCollectionsPeriod = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], RepCollectionsPeriod);
    return RepCollectionsPeriod;
}(React.Component));
exports.RepCollectionsPeriod = RepCollectionsPeriod;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Sales/RepSales.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Sales/RepSales.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./RepSales.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./RepSales.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Sales/RepSales.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var accounting_1 = __webpack_require__("./node_modules/accounting/accounting.js");
var classnames_1 = __webpack_require__("./node_modules/classnames/index.js");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/Sales/RepSales.css");
var briefcaseIcon = __webpack_require__("./app/web/src/assets/briefcase icon.svg");
var iconDropdownArrow = __webpack_require__("./app/web/src/assets/dropdown arrow.svg");
// Component
var RepSales = /** @class */ (function (_super) {
    __extends(RepSales, _super);
    function RepSales(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOpeningCollectionsModal = function () {
            _this.props.store.orderPadSales.toggleCollectionsModal(true);
        };
        _this.handleOpeningOrderPad = function () {
            window.open(_this.props.store.orderPad.orderPadUrl, '_blank');
        };
        _this.props.store.orderPad.fetchOrderPadInfo();
        _this.props.store.orderPadSales.fetchSalesData();
        return _this;
    }
    Object.defineProperty(RepSales.prototype, "isLoading", {
        get: function () {
            var _a = this.props.store, orderPad = _a.orderPad, orderPadSales = _a.orderPadSales;
            return ((orderPad.isOrderPadInfoLoading || orderPadSales.isSalesDataLoading) &&
                (orderPad.orderPadUrl === null || orderPadSales.salesData === null));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RepSales.prototype, "salesColumns", {
        get: function () {
            var salesData = this.props.store.orderPadSales.salesData;
            return [
                {
                    label: 'Sales today',
                    amount: salesData.salesToday,
                },
                {
                    label: 'This week',
                    amount: salesData.salesThisWeek,
                },
                {
                    label: 'This month',
                    amount: salesData.salesThisMonth,
                },
                {
                    label: 'Collections this month',
                    amount: salesData.collectionsThisMonth,
                },
            ];
        },
        enumerable: true,
        configurable: true
    });
    RepSales.prototype.render = function () {
        var _this = this;
        return (React.createElement(content_1.SectionHeadline, { className: s.container, title: "Your sales", button: this.isLoading
                ? undefined
                : {
                    onClick: this.handleOpeningOrderPad,
                    label: 'Place an order',
                    icon: briefcaseIcon,
                    showLabel: true,
                }, placeChildrenInTheMiddle: this.isLoading === false }, (this.isLoading && (React.createElement(indicator_1.SavingIndicator, { align: "right", labels: {
                saving: 'Loading your sales',
            }, status: indicator_1.SavingIndicatorStatus.Saving }))) || (React.createElement("div", { className: s.salesTicker }, this.salesColumns.map(function (col, colIndex) {
            var _a;
            var isLast = colIndex + 1 >= _this.salesColumns.length;
            return (React.createElement("div", { key: col.label, onClick: isLast ? _this.handleOpeningCollectionsModal : undefined, className: classnames_1.default(s.salesTickerCol, (_a = {},
                    _a[s.last] = isLast,
                    _a)) },
                React.createElement("p", { className: s.salesLabel }, col.label),
                React.createElement("p", { className: s.salesAmount }, accounting_1.formatMoney(col.amount)),
                isLast && (React.createElement("img", { className: s.salesDropdown, src: iconDropdownArrow, width: 12, height: 6 }))));
        })))));
    };
    __decorate([
        mobx_1.computed
    ], RepSales.prototype, "isLoading", null);
    __decorate([
        mobx_1.computed
    ], RepSales.prototype, "salesColumns", null);
    RepSales = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], RepSales);
    return RepSales;
}(React.Component));
exports.RepSales = RepSales;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/Sales/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Sales/RepSales.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Sales/RepCollectionsModal.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Sales/RepCollectionsPeriod.tsx"));


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/SalesLead.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/SalesLead.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./SalesLead.css", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./SalesLead.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/sales/Lead/SalesLead.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var provider_1 = __webpack_require__("./app/common/interfaces/provider.ts");
var user_1 = __webpack_require__("./app/common/interfaces/user.ts");
var content_1 = __webpack_require__("./app/web/src/components/content/index.tsx");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
var layout_1 = __webpack_require__("./app/web/src/components/layout/index.tsx");
var scroll_1 = __webpack_require__("./app/web/src/events/scroll.ts");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var zenscroll = __webpack_require__("./node_modules/zenscroll/zenscroll.js");
var BusinessGroup_1 = __webpack_require__("./app/web/src/routes/sales/Lead/BusinessGroup/index.ts");
var BusinessPartner_1 = __webpack_require__("./app/web/src/routes/sales/Lead/BusinessPartner/index.tsx");
var Disable_1 = __webpack_require__("./app/web/src/routes/sales/Lead/Disable/index.ts");
var PricingRequest_1 = __webpack_require__("./app/web/src/routes/sales/Lead/PricingRequest/index.tsx");
var LeadQuestions_1 = __webpack_require__("./app/web/src/routes/sales/Lead/Questions/LeadQuestions.tsx");
var RepCollectionsModal_1 = __webpack_require__("./app/web/src/routes/sales/Lead/Sales/RepCollectionsModal.tsx");
var _1 = __webpack_require__("./app/web/src/routes/sales/Lead/index.tsx");
var LeadRelationsModal_1 = __webpack_require__("./app/web/src/routes/sales/Lead/Relations/LeadRelationsModal.tsx");
var Relations_1 = __webpack_require__("./app/web/src/routes/sales/Lead/Relations/index.ts");
// Styles
var s = __webpack_require__("./app/web/src/routes/sales/Lead/SalesLead.css");
var editIcon = __webpack_require__("./app/web/src/assets/pen icon.svg");
var addIcon = __webpack_require__("./app/web/src/assets/plus icon.svg");
var cancelIcon = __webpack_require__("./app/web/src/assets/close orange icon.svg");
var arrowIcon = __webpack_require__("./app/web/src/assets/blue arrow.svg");
var visibilityIcon = __webpack_require__("./app/web/src/assets/visibility button.svg");
var padlockIcon = __webpack_require__("./app/web/src/assets/padlock-icon.svg");
// Page
var SalesLead = /** @class */ (function (_super) {
    __extends(SalesLead, _super);
    function SalesLead(props) {
        var _this = _super.call(this, props) || this;
        _this.isLoading = true;
        _this.noMatch = false;
        _this.contactsSection = null;
        _this.referenceContactsSection = function (ref) {
            return (_this.contactsSection = ref);
        };
        _this.handleNavigateBack = function () {
            _this.props.history.goBack();
        };
        _this.handleViewLeadRelations = function () {
            _this.props.store.lead.showRelationsOfOpenLead = true;
        };
        _this.handleContactsEditing = function () {
            if (_this.contactsSection) {
                scroll_1.scrollWindow.to(_this.contactsSection);
            }
            _this.props.store.leadContacts.startEditingContacts();
        };
        _this.handleViewLeadPricing = function () {
            _this.props.store.leadPricing.leadItemsPricingModal = true;
        };
        _this.handleCreatePricingRequestClick = function (e) {
            _this.props.store.leadPricing.showCreatePricingRequestModal(true);
        };
        _this.handleDisableLeadClick = function () {
            _this.props.store.lead.openDisableLeadModal();
        };
        _this.handleToggleShowingActivitiesOfOtherLeads = function () {
            _this.props.store.leadActivities.toggleShowingOfActivitiesOfOtherLeads();
        };
        _this.handleTogglingQuestionnaireVisibility = function () {
            _this.props.store.lead.toggleQuestionnaireVisibility();
        };
        _this.loadLead = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Being loading
                        this.isLoading = true;
                        this.noMatch = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, 8, 9]);
                        if (!this.id) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.loadDetails()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.loadContacts()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.loadResources()];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5: throw new Error('Lead page has no lead ID provided in route path');
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        error_1 = _a.sent();
                        // Call error
                        if (typeof error_1 !== 'undefined' &&
                            error_1 &&
                            typeof error_1.code !== 'undefined' &&
                            error_1.code === 404) {
                            this.noMatch = true;
                            console.error('Lead does not exist');
                        }
                        else {
                            setTimeout(function () {
                                _this.loadLead();
                            }, 1024);
                        }
                        return [3 /*break*/, 9];
                    case 8:
                        this.isLoading = false;
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        }); };
        _this.loadDetails = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.store.lead.handleLeadLoad(this.id)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.loadContacts = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.store.leadContacts.fetchLeadContacts(this.id)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.loadResources = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.store.leadResources.fetchLeadResources(this.id)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handlePricingRequestModalClose = function () {
            _this.props.store.leadPricing.clearAll();
            _this.props.store.leadPricing.fetchAllItemsWithPricing();
            _this.props.store.pricingRequest.resetSinglePricingRequest();
        };
        _this.handleItemsPricingModalClose = function () {
            _this.props.store.leadPricing.leadItemsPricingModal = false;
        };
        _this.handleBusinessPartnerRequestClick = function (e) {
            _this.props.store.businessPartner.showBusinessPartnerRequestModal();
        };
        // Load details of lead from current page
        _this.loadLead();
        // Fetch provider types and dispenser classes
        _this.props.store.leads.fetchProviderTypes();
        _this.props.store.leads.fetchDispenserClasses();
        return _this;
    }
    Object.defineProperty(SalesLead.prototype, "id", {
        // Get ID of the lead param
        get: function () {
            var parsedId = parseInt(this.props.match.params.providerId, 10);
            return isNaN(parsedId) ? null : parsedId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesLead.prototype, "hasContacts", {
        get: function () {
            return this.props.store.leadContacts.combined.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesLead.prototype, "contactsEditButton", {
        get: function () {
            var leadContacts = this.props.store.leadContacts;
            if (leadContacts.editing) {
                return {
                    onClick: leadContacts.cancelEditingContacts,
                    label: 'Cancel editing',
                    icon: cancelIcon,
                };
            }
            else if (this.hasContacts) {
                return {
                    onClick: this.handleContactsEditing,
                    label: 'Edit',
                    icon: editIcon,
                };
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesLead.prototype, "hasResources", {
        get: function () {
            return this.props.store.leadResources.all.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesLead.prototype, "resourcesEditButton", {
        get: function () {
            var leadResources = this.props.store.leadResources;
            if (this.hasResources && leadResources.editing) {
                return {
                    onClick: leadResources.stopEditing,
                    label: 'Cancel editing',
                    icon: cancelIcon,
                };
            }
            else if (this.hasResources) {
                return {
                    onClick: leadResources.startEditing,
                    label: 'Edit',
                    icon: editIcon,
                };
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesLead.prototype, "isManager", {
        get: function () {
            var userType = this.props.store.user.userType;
            return userType === user_1.UserType.SalesManager;
        },
        enumerable: true,
        configurable: true
    });
    SalesLead.prototype.componentDidMount = function () {
        zenscroll.toY(0);
    };
    SalesLead.prototype.componentDidUpdate = function (prevProps) {
        var prevProviderId = 0;
        var newProviderId = 0;
        if (typeof prevProps.match.params.providerId !== 'undefined') {
            prevProviderId = parseInt(prevProps.match.params.providerId, 10);
        }
        if (typeof this.props.match.params.providerId !== 'undefined') {
            newProviderId = parseInt(this.props.match.params.providerId, 10);
        }
        if (prevProviderId !== newProviderId) {
            this.loadLead();
        }
    };
    SalesLead.prototype.componentWillUnmount = function () {
        this.props.store.lead.handleOpenLeadDisable();
    };
    SalesLead.prototype.render = function () {
        var _a;
        var _b = this.props.store, lead = _b.lead, leadGroup = _b.leadGroup, leadActivities = _b.leadActivities, leadContacts = _b.leadContacts, leadPricing = _b.leadPricing, pricingRequest = _b.pricingRequest, businessPartner = _b.businessPartner, orderPadSales = _b.orderPadSales, user = _b.user;
        return (React.createElement(layout_1.Layout, null,
            this.noMatch === false && lead.openLeadDetails !== null && (React.createElement("div", { className: s.lead },
                React.createElement("div", { className: classNames(s.details, (_a = {},
                        _a[s.creating] = leadContacts.creating,
                        _a[s.businessPartnerPanelOpen] = businessPartner.newRequest.showModal,
                        _a)) },
                    this.isManager &&
                        lead.openLeadDetails !== null &&
                        !lead.openLeadDetails.customerCreated &&
                        !businessPartner.newRequest.promoted && (React.createElement("div", { className: classNames(s.block, s.createAccount) },
                        React.createElement(content_1.SectionHeadline, { title: businessPartner.newRequest.showModal
                                ? 'Cancel'
                                : 'Create account in SAP', button: businessPartner.newRequest.showModal
                                ? {
                                    icon: cancelIcon,
                                    labelOnRight: false,
                                    onClick: businessPartner.hideBusinessPartnerRequestModal,
                                }
                                : {
                                    icon: addIcon,
                                    labelOnRight: false,
                                    onClick: this.handleBusinessPartnerRequestClick,
                                } }),
                        React.createElement("hr", null))),
                    businessPartner.newRequest.promoted && (React.createElement("div", { className: classNames(s.block, s.createAccount) },
                        React.createElement(content_1.SectionHeadline, { title: businessPartner.newRequest.promoted }),
                        React.createElement("hr", null))),
                    React.createElement("div", { className: classNames(s.block, s.pricing) },
                        React.createElement(content_1.SectionHeadline, { title: lead.leadTitle + " pricing", button: {
                                onClick: this.handleViewLeadPricing,
                                label: this.isManager ? 'View and edit' : 'View',
                                icon: arrowIcon,
                                iconClassName: s.arrow,
                            } }),
                        React.createElement("hr", null)),
                    React.createElement("div", { className: classNames(s.block, s.provider) },
                        React.createElement(content_1.SectionHeadline, { title: lead.leadTitle + " details", button: lead.openLeadEditingDetails
                                ? {
                                    onClick: lead.stopEditingOpenLeadDetails,
                                    label: 'Cancel editing',
                                    icon: cancelIcon,
                                }
                                : {
                                    onClick: lead.startEditingOpenLeadDetails,
                                    label: 'Edit',
                                    icon: editIcon,
                                } }),
                        React.createElement(_1.LeadDetailsMaster, null),
                        React.createElement("hr", null)),
                    lead.openLeadDetails &&
                        lead.openLeadDetails.relations.length > 0 && (React.createElement("div", { className: classNames(s.block, s.relations) },
                        React.createElement(content_1.SectionHeadline, { title: lead.leadTitle + " relations", button: {
                                onClick: this.handleViewLeadRelations,
                                label: 'View relations',
                                icon: arrowIcon,
                                iconClassName: s.arrow,
                            } }),
                        React.createElement(Relations_1.LeadRelations, null),
                        React.createElement("hr", null))),
                    React.createElement("div", { className: classNames(s.block, s.contacts), ref: this.referenceContactsSection },
                        React.createElement(content_1.SectionHeadline, { title: lead.leadTitle + " contacts", button: this.contactsEditButton }),
                        React.createElement(_1.LeadContacts, null),
                        React.createElement("hr", null)),
                    businessPartner.newRequest.showModal === false && (React.createElement("div", { className: classNames(s.block, s.pricingReqest) },
                        React.createElement(content_1.SectionHeadline, { title: "Pricing request" + (leadPricing.pendingPricingRequests.length > 1 ? 's' : ''), button: user.userType === user_1.UserType.SalesRep
                                ? {
                                    icon: addIcon,
                                    labelOnRight: false,
                                    label: 'Create pricing request',
                                    onClick: this.handleCreatePricingRequestClick,
                                }
                                : null }),
                        React.createElement(_1.PricingRequestSidebar, null),
                        React.createElement("hr", null))),
                    businessPartner.newRequest.showModal === false && (React.createElement("div", { className: classNames(s.block, s.disable) },
                        React.createElement(content_1.SectionHeadline, { title: "Disable " + lead.leadTitle, button: {
                                icon: padlockIcon,
                                iconClassName: s.disableIcon,
                                labelOnRight: false,
                                label: 'Disable',
                                onClick: this.handleDisableLeadClick,
                            } }),
                        React.createElement(Disable_1.LeadDisable, null)))),
                React.createElement("div", { className: s.middle },
                    React.createElement("div", { className: s.sales },
                        React.createElement(_1.RepSales, null)),
                    React.createElement("div", { className: s.activities },
                        React.createElement(_1.LeadActivities, null)),
                    React.createElement(_1.LeadNotes, null)),
                React.createElement("div", { className: s.other },
                    React.createElement("div", { className: s.otherLeadsActivities },
                        React.createElement(content_1.SectionHeadline, { title: "Other " + lead.leadTitle + "s' activities", button: {
                                onClick: this.handleToggleShowingActivitiesOfOtherLeads,
                                label: leadActivities.showActivitiesOfOtherLeads
                                    ? 'Hide'
                                    : 'Show',
                                icon: visibilityIcon,
                            } }),
                        leadActivities.showActivitiesOfOtherLeads && (React.createElement(_1.OtherActivities, null))),
                    React.createElement("div", { className: s.questionnaire },
                        React.createElement(content_1.SectionHeadline, { title: "Questionnaire", button: {
                                onClick: this.handleTogglingQuestionnaireVisibility,
                                label: lead.isQuestionnaireVisible ? 'Hide' : 'Show',
                                icon: visibilityIcon,
                            } }),
                        lead.isQuestionnaireVisible && React.createElement(LeadQuestions_1.LeadQuestions, null)),
                    React.createElement("div", { className: s.resources },
                        React.createElement(content_1.SectionHeadline, { title: "Resources", button: this.resourcesEditButton }),
                        React.createElement(_1.LeadResources, null))))),
            React.createElement(LeadRelationsModal_1.LeadRelationsModal, { show: lead.showRelationsOfOpenLead }),
            React.createElement(PricingRequest_1.PricingRequestModal, { show: leadPricing.newRequest.showModal ||
                    pricingRequest.singlePricingRequest !== null, existingRequest: pricingRequest.singlePricingRequest
                    ? {
                        data: pricingRequest.singlePricingRequest,
                        status: pricingRequest.statusOfSinglePricingRequestApproval,
                        loading: pricingRequest.loadingSinglePricingRequest,
                    }
                    : null, onModalClose: this.handlePricingRequestModalClose }),
            React.createElement(PricingRequest_1.PricingRequestModal, { show: leadPricing.leadItemsPricingModal, existingRequest: {
                    data: leadPricing.leadItemsPricingModalData,
                    status: leadPricing.statusOfUpdatingPricesForAllItems,
                    onlyItems: true,
                    loading: false,
                }, onModalClose: this.handleItemsPricingModalClose }),
            React.createElement(BusinessGroup_1.BusinessGroupModal, { show: leadGroup.modalStatus !== provider_1.LeadGroupModalStatus.Closed }),
            React.createElement(BusinessPartner_1.BusinessPartnerSlider, { show: businessPartner.newRequest.showModal }),
            React.createElement(RepCollectionsModal_1.RepCollectionsModal, { show: orderPadSales.showCollectionsModal }),
            this.isLoading === false && this.noMatch === true && (React.createElement(content_1.FullScreenMessage, { label: "No lead of ID " + this.id + " exists", dismiss: {
                    label: 'Go back',
                    onClick: this.handleNavigateBack,
                } })),
            React.createElement(indicator_1.LoadingFullScreen, { active: this.isLoading === true && this.noMatch === false })));
    };
    __decorate([
        mobx_1.computed
    ], SalesLead.prototype, "id", null);
    __decorate([
        mobx_1.observable
    ], SalesLead.prototype, "isLoading", void 0);
    __decorate([
        mobx_1.observable
    ], SalesLead.prototype, "noMatch", void 0);
    __decorate([
        mobx_1.computed
    ], SalesLead.prototype, "hasContacts", null);
    __decorate([
        mobx_1.computed
    ], SalesLead.prototype, "contactsEditButton", null);
    __decorate([
        mobx_1.computed
    ], SalesLead.prototype, "hasResources", null);
    __decorate([
        mobx_1.computed
    ], SalesLead.prototype, "resourcesEditButton", null);
    __decorate([
        mobx_1.computed
    ], SalesLead.prototype, "isManager", null);
    __decorate([
        mobx_1.action
    ], SalesLead.prototype, "handleViewLeadRelations", void 0);
    __decorate([
        mobx_1.action
    ], SalesLead.prototype, "loadLead", void 0);
    SalesLead = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], SalesLead);
    return SalesLead;
}(React.Component));
exports.SalesLead = SalesLead;


/***/ }),

/***/ "./app/web/src/routes/sales/Lead/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/Lead/SalesLead.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Details/index.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Contacts/index.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Sales/index.ts"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Activities/index.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Questions/index.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Notes/index.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Resources/index.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/PricingRequest/index.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Disable/index.ts"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/OtherActivities/index.ts"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/Relations/index.ts"));


/***/ }),

/***/ "./app/web/src/routes/sales/SalesMain.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var layout_1 = __webpack_require__("./app/web/src/components/layout/index.tsx");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
// Component
var SalesMain = /** @class */ (function (_super) {
    __extends(SalesMain, _super);
    function SalesMain(props) {
        return _super.call(this, props) || this;
    }
    SalesMain.prototype.render = function () {
        return React.createElement(layout_1.Layout, null, this.props.children);
    };
    SalesMain = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], SalesMain);
    return SalesMain;
}(React.Component));
exports.SalesMain = SalesMain;
exports.default = SalesMain;


/***/ }),

/***/ "./app/web/src/routes/sales/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/sales/SalesMain.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Dashboard/index.tsx"));
__export(__webpack_require__("./app/web/src/routes/sales/Lead/index.tsx"));


/***/ }),

/***/ "./app/web/src/routes/user/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/user/login/index.tsx"));
__export(__webpack_require__("./app/web/src/routes/user/logout/index.tsx"));


/***/ }),

/***/ "./app/web/src/routes/user/login/Form/LoginForm.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/user/login/Form/LoginForm.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LoginForm.css", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./LoginForm.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/user/login/Form/LoginForm.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var classNames = __webpack_require__("./node_modules/classnames/index.js");
var react_router_dom_1 = __webpack_require__("./node_modules/react-router-dom/es/index.js");
var indicator_1 = __webpack_require__("./app/web/src/components/indicator/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/routes/user/login/Form/LoginForm.css");
var crmLogo = __webpack_require__("./app/web/src/assets/crm-logo.png");
// Enumerables
var LoginStatus;
(function (LoginStatus) {
    LoginStatus[LoginStatus["Default"] = 0] = "Default";
    LoginStatus[LoginStatus["LoggingIn"] = 1] = "LoggingIn";
    LoginStatus[LoginStatus["Success"] = 2] = "Success";
    LoginStatus[LoginStatus["AllFieldsRequired"] = 3] = "AllFieldsRequired";
    LoginStatus[LoginStatus["WrongPasswordOrUsername"] = 4] = "WrongPasswordOrUsername";
})(LoginStatus || (LoginStatus = {}));
var HeadlineType;
(function (HeadlineType) {
    HeadlineType[HeadlineType["Normal"] = 0] = "Normal";
    HeadlineType[HeadlineType["Important"] = 1] = "Important";
})(HeadlineType = exports.HeadlineType || (exports.HeadlineType = {}));
// Component
var LoginForm = /** @class */ (function (_super) {
    __extends(LoginForm, _super);
    function LoginForm(props) {
        var _this = _super.call(this, props) || this;
        _this.status = LoginStatus.Default;
        _this.username = '';
        _this.password = '';
        _this.userField = null;
        _this.referenceUserField = function (ref) {
            return (_this.userField = ref);
        };
        _this.handleGoBack = function (e) {
            _this.props.history.goBack();
        };
        _this.handleFormFieldChange = function (type) { return function (e) {
            if (typeof e !== 'undefined' && typeof e.currentTarget !== 'undefined') {
                _this[type] = e.currentTarget.value;
            }
        }; };
        _this.handleFormSubmit = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.state = LoginStatus.LoggingIn;
            var endUsername = _this.username.trim();
            var endPassword = _this.password.trim();
            if (endUsername === '' || endPassword === '') {
                _this.status = LoginStatus.AllFieldsRequired;
            }
            else {
                _this.status = LoginStatus.LoggingIn;
                _this.handleLogin();
            }
        };
        _this.handleLogin = function () {
            _this.props.store.user
                .login(_this.username, _this.password)
                .then(function () {
                // Indicate success
                _this.status = LoginStatus.Success;
            })
                .catch(function (error) {
                // Clear form and indicate error
                _this.username = '';
                _this.password = '';
                _this.status = LoginStatus.WrongPasswordOrUsername;
                // Focus on username field
                if (_this.userField) {
                    _this.userField.focus();
                }
            });
        };
        return _this;
    }
    Object.defineProperty(LoginForm, "defaultProps", {
        get: function () {
            return {
                headlineType: HeadlineType.Normal,
                showBack: false,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginForm.prototype, "isError", {
        get: function () {
            return (this.status === LoginStatus.AllFieldsRequired ||
                this.status === LoginStatus.WrongPasswordOrUsername);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginForm.prototype, "label", {
        get: function () {
            var label = 'Sign in';
            if (this.isError) {
                label =
                    this.status === LoginStatus.WrongPasswordOrUsername
                        ? 'Wrong password or username, try again'
                        : 'All fields are required, try again';
            }
            else if (this.status === LoginStatus.LoggingIn) {
                label = 'Signing in...';
            }
            else if (this.status === LoginStatus.Success) {
                label = 'Signed in';
            }
            return label;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginForm.prototype, "redirectPath", {
        get: function () {
            // Prepare from route
            var from = '/';
            if (typeof this.props.location !== 'undefined' &&
                typeof this.props.location.state !== 'undefined') {
                if (this.props.location.state !== null &&
                    typeof this.props.location.state.from !== 'undefined') {
                    from = this.props.location.state.from;
                }
            }
            // Return default or from route
            return from === '/' && LoginStatus.Success ? "/sales" : from;
        },
        enumerable: true,
        configurable: true
    });
    LoginForm.prototype.render = function () {
        var _a;
        return (React.createElement("div", { className: s.block },
            React.createElement("div", { className: s.top },
                React.createElement("img", { className: s.logo, src: crmLogo }),
                this.props.showBack && (React.createElement("button", { tabIndex: 4, className: s.goBack, onClick: this.handleGoBack }, "Go back"))),
            this.props.headline &&
                this.props.store.utilities.isConnectedToBackEnd && (React.createElement("h1", { className: classNames((_a = {},
                    _a[s.headline] = true,
                    _a[s.headlineImportant] = this.props.headlineType === HeadlineType.Important,
                    _a)) }, this.props.headline)),
            (this.props.store.utilities.isConnectedToBackEnd && (React.createElement("form", { className: s.form, onSubmit: this.handleFormSubmit },
                React.createElement("input", { ref: this.referenceUserField, tabIndex: 1, type: "text", placeholder: "Username", value: this.username, onChange: this.handleFormFieldChange('username') }),
                React.createElement("input", { tabIndex: 2, type: "password", placeholder: "Password", value: this.password, onChange: this.handleFormFieldChange('password') }),
                React.createElement("button", { tabIndex: 3, className: "boxButton", onClick: this.handleFormSubmit }, this.label)))) || (React.createElement("div", { className: s.offline },
                React.createElement(indicator_1.LoadingSpinner, { active: true }),
                React.createElement("p", null,
                    React.createElement("strong", null, "We could not establish connection"),
                    React.createElement("span", null,
                        "The server might be encountering connectivty problems or the issue might be with your network.",
                        React.createElement("br", null),
                        React.createElement("br", null),
                        "Please wait while we attempt to reconnect.")))),
            this.status === LoginStatus.Success && (React.createElement(react_router_dom_1.Redirect, { to: { pathname: this.redirectPath } }))));
    };
    __decorate([
        mobx_1.observable
    ], LoginForm.prototype, "status", void 0);
    __decorate([
        mobx_1.observable
    ], LoginForm.prototype, "username", void 0);
    __decorate([
        mobx_1.observable
    ], LoginForm.prototype, "password", void 0);
    __decorate([
        mobx_1.computed
    ], LoginForm.prototype, "isError", null);
    __decorate([
        mobx_1.computed
    ], LoginForm.prototype, "label", null);
    __decorate([
        mobx_1.computed
    ], LoginForm.prototype, "redirectPath", null);
    __decorate([
        mobx_1.action
    ], LoginForm.prototype, "handleFormSubmit", void 0);
    __decorate([
        mobx_1.action
    ], LoginForm.prototype, "handleLogin", void 0);
    LoginForm = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], LoginForm);
    return LoginForm;
}(React.Component));
exports.LoginForm = LoginForm;


/***/ }),

/***/ "./app/web/src/routes/user/login/Form/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/user/login/Form/LoginForm.tsx"));


/***/ }),

/***/ "./app/web/src/routes/user/login/Login.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/user/login/Login.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Login.css", function() {
		var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./Login.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/routes/user/login/Login.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__("./node_modules/react/react.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var Form_1 = __webpack_require__("./app/web/src/routes/user/login/Form/index.tsx");
// Styles
var s = __webpack_require__("./app/web/src/routes/user/login/Login.css");
// Component
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login(props) {
        return _super.call(this, props) || this;
    }
    Login.prototype.render = function () {
        return (React.createElement("div", { className: s.container },
            React.createElement(Form_1.LoginForm, { headline: "Welcome to Spyka CRM. Login with your credentials.", location: this.props.location, history: this.props.history })));
    };
    Login = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], Login);
    return Login;
}(React.Component));
exports.Login = Login;


/***/ }),

/***/ "./app/web/src/routes/user/login/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/user/login/Login.tsx"));


/***/ }),

/***/ "./app/web/src/routes/user/logout/Logout.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var mobx_react_1 = __webpack_require__("./node_modules/mobx-react/index.module.js");
var React = __webpack_require__("./node_modules/react/react.js");
var react_router_1 = __webpack_require__("./node_modules/react-router/es/index.js");
// Component
var Logout = /** @class */ (function (_super) {
    __extends(Logout, _super);
    function Logout(props) {
        var _this = _super.call(this, props) || this;
        _this.loggedOut = false;
        _this.logoutError = false;
        _this.props.store.sidebar.closeSidebar();
        if (typeof _this.props.store !== 'undefined') {
            _this.props.store.user
                .logout()
                .then(function (response) {
                _this.loggedOut = true;
            })
                .catch(function (error) {
                setTimeout(function () {
                    _this.logoutError = true;
                }, 1024);
            });
        }
        return _this;
    }
    Logout.prototype.render = function () {
        // Prepare from path
        var from = '/';
        if (typeof this.props.location !== 'undefined' &&
            typeof this.props.location.state !== 'undefined') {
            if (this.props.location.state !== null &&
                typeof this.props.location.state.from !== 'undefined') {
                from = this.props.location.state.from;
            }
        }
        // Render
        if (this.loggedOut) {
            return React.createElement(react_router_1.Redirect, { to: { pathname: '/user/login', state: { from: from } } });
        }
        else if (this.logoutError) {
            return React.createElement(react_router_1.Redirect, { to: { pathname: '/user/logout', state: { from: from } } });
        }
        else {
            return (React.createElement("div", null,
                React.createElement("p", null, "Logging out...")));
        }
    };
    __decorate([
        mobx_1.observable
    ], Logout.prototype, "loggedOut", void 0);
    __decorate([
        mobx_1.observable
    ], Logout.prototype, "logoutError", void 0);
    Logout = __decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], Logout);
    return Logout;
}(React.Component));
exports.Logout = Logout;


/***/ }),

/***/ "./app/web/src/routes/user/logout/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/routes/user/logout/Logout.tsx"));


/***/ }),

/***/ "./app/web/src/stores/Activities.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var methods_1 = __webpack_require__("./app/common/methods/index.ts");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
// Store
var Activities = /** @class */ (function () {
    function Activities(user, modal) {
        var _this = this;
        this.user = user;
        this.modal = modal;
        this.reactToUserChange = mobx_1.reaction(function () { return _this.user.id; }, function (userId) {
            if (userId !== null) {
                _this.fetchActivityTypes();
                _this.fetchUserActivities(userId);
            }
        });
        // Reminders
        this.showRemindersCenter = false;
        // Activity types
        this.loadingAllActivityTypes = false;
        this.allActivityTypes = [];
        // All activities
        this.allActivities = [];
        this.allActivitiesLoading = false;
        this.userActivities = [];
        this.userActivitiesLoading = false;
        // Initialize all activities
        this.initializeAllActivities = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.fetchAllActivities(id)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_1 = _a.sent();
                        console.error(err_1);
                        return [2 /*return*/, err_1];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        // Reminder timeouts
        this.reminderTimeouts = [];
        this.openActivitiesReminders = function () {
            _this.showRemindersCenter = true;
            document.documentElement.style.overflow = 'hidden';
        };
        this.closeActivitiesReminders = function () {
            _this.showRemindersCenter = false;
            document.documentElement.style.overflow = null;
        };
        // Fetch all activities
        this.fetchAllActivities = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var activitiesService, activitiesInfo, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Indicate that activities are loading
                        this.allActivitiesLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        activitiesService = App_1.app.service('activity');
                        return [4 /*yield*/, activitiesService.find({
                                query: __assign({ $limit: 10000 }, id),
                            })];
                    case 2:
                        activitiesInfo = (_a.sent());
                        // Update state
                        this.allActivities = activitiesInfo.data.map(function (activity, i) { return (__assign({}, activity, { savingComplete: false })); });
                        return [2 /*return*/, activitiesInfo.data];
                    case 3:
                        err_2 = _a.sent();
                        console.error(err_2);
                        return [2 /*return*/, err_2];
                    case 4:
                        this.allActivitiesLoading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        // Fetch user activities
        this.fetchUserActivities = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var activitiesService, activitiesInfo, userIndex_1, err_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Indicate that activities are loading
                        this.userActivitiesLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        activitiesService = App_1.app.service('activity');
                        return [4 /*yield*/, activitiesService.find({
                                query: {
                                    $limit: 10000,
                                    $skip: 0,
                                    finished: 0,
                                    assignedToUserId: id,
                                    $sort: {
                                        activityTime: 1,
                                    },
                                },
                            })];
                    case 2:
                        activitiesInfo = (_a.sent());
                        userIndex_1 = null;
                        this.userActivities.some(function (user, i) {
                            if (user.id === _this.user.id) {
                                userIndex_1 = i;
                                return true;
                            }
                        });
                        // Update state
                        if (userIndex_1 !== null) {
                            this.userActivities = this.userActivities
                                .slice(0, userIndex_1)
                                .concat({
                                id: this.user.id,
                                activities: activitiesInfo.data.map(function (activity, i) { return (__assign({}, activity, { saving: false, showReminder: false })); }),
                            })
                                .concat(this.userActivities.slice(userIndex_1 + 1));
                        }
                        else {
                            this.userActivities.push({
                                id: this.user.id,
                                activities: activitiesInfo.data.map(function (activity, i) { return (__assign({}, activity, { saving: false, showReminder: false })); }),
                            });
                        }
                        this.setActivityReminders();
                        // Return activities data
                        return [2 /*return*/, activitiesInfo.data];
                    case 3:
                        err_3 = _a.sent();
                        console.error(err_3);
                        return [2 /*return*/, err_3];
                    case 4:
                        this.userActivitiesLoading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        // Get all activity types
        this.fetchActivityTypes = function () { return __awaiter(_this, void 0, void 0, function () {
            var service, activities, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        this.loadingAllActivityTypes = true;
                        return [4 /*yield*/, App_1.app.service('activity-type')];
                    case 1:
                        service = _a.sent();
                        return [4 /*yield*/, service.find({
                                query: { $limit: 100000 },
                            })];
                    case 2:
                        activities = _a.sent();
                        this.allActivityTypes = activities.data.map(function (activity) { return ({
                            value: activity.id,
                            label: activity.name,
                        }); });
                        this.loadingAllActivityTypes = false;
                        return [2 /*return*/, activities];
                    case 3:
                        err_4 = _a.sent();
                        console.error(err_4);
                        return [2 /*return*/, err_4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // Disable reminder
        this.disableActivityReminder = function (activityId) { return __awaiter(_this, void 0, void 0, function () {
            var service, update, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, App_1.app.service('activity')];
                    case 1:
                        service = _a.sent();
                        update = service.patch(activityId, {
                            remind: false,
                        });
                        this.userActivities.map(function (user) {
                            user.activities.map(function (activity) {
                                if (activity.id === activityId) {
                                    activity.remind = false;
                                }
                            });
                        });
                        return [2 /*return*/, true];
                    case 2:
                        err_5 = _a.sent();
                        console.error(err_5);
                        return [2 /*return*/, err_5];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        // Mark activity as complete
        this.markActivityAsComplete = function (activityId) { return __awaiter(_this, void 0, void 0, function () {
            var service, update, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, App_1.app.service('activity')];
                    case 1:
                        service = _a.sent();
                        update = service.patch(activityId, {
                            finished: true,
                        });
                        this.userActivities.map(function (user) {
                            user.activities.map(function (activity) {
                                if (activity.id === activityId) {
                                    activity.finished = true;
                                }
                            });
                        });
                        return [2 /*return*/, true];
                    case 2:
                        err_6 = _a.sent();
                        console.error(err_6);
                        return [2 /*return*/, err_6];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        // Delay activity reminder by minutes
        this.delayActivityReminder = function (activityId, delayReminderByMinutes) { return __awaiter(_this, void 0, void 0, function () {
            var activity_1, updatedRemindAt, updatedRemindAtString, service, update, err_7;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        activity_1 = null;
                        this.userActivities.some(function (user) {
                            return user.activities.some(function (userActivity) {
                                if (userActivity.id === activityId) {
                                    activity_1 = userActivity;
                                    return true;
                                }
                            });
                        });
                        if (activity_1 === null) {
                            throw new Error('Could not find matching activity to update remind time');
                        }
                        updatedRemindAt = moment().add(delayReminderByMinutes, 'minutes');
                        updatedRemindAtString = updatedRemindAt.format();
                        return [4 /*yield*/, App_1.app.service('activity')];
                    case 1:
                        service = _a.sent();
                        update = service.patch(activityId, {
                            remind: true,
                            remindAt: updatedRemindAtString,
                        });
                        activity_1.remind = true;
                        activity_1.showReminder = false;
                        activity_1.remindAt = updatedRemindAtString;
                        if (delayReminderByMinutes < 60 * 24) {
                            this.reminderTimeouts.push(setTimeout(function () {
                                _this.showActivityReminder(activityId);
                            }, delayReminderByMinutes * 1000 * 60));
                        }
                        return [2 /*return*/, true];
                    case 2:
                        err_7 = _a.sent();
                        console.error(err_7);
                        return [2 /*return*/, err_7];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        // Show reminder to user
        this.showActivityReminder = function (activityId) {
            _this.userActivities.some(function (userActivities) {
                return userActivities.activities.some(function (activity) {
                    if (activity.id === activityId) {
                        if (activity.finished === false) {
                            activity.remind = true;
                            activity.showReminder = true;
                        }
                        return true;
                    }
                });
            });
        };
        // Set reminders for all user activities
        this.setActivityReminders = function () {
            var userActivitesIndex = -1;
            _this.userActivities.some(function (user, i) {
                if (user.id === _this.user.id) {
                    userActivitesIndex = i;
                    return true;
                }
            });
            if (userActivitesIndex !== -1) {
                var now_1 = moment();
                _this.reminderTimeouts.map(function (reminder) {
                    clearTimeout(reminder);
                });
                _this.reminderTimeouts = [];
                _this.userActivities[userActivitesIndex].activities.map(function (activity, i) {
                    if (activity.remind && !activity.finished) {
                        var remindAtDateAndTime = activity.remindAt || activity.activityTime;
                        var difference = moment.duration(moment(remindAtDateAndTime).diff(now_1));
                        var differenceInMinutes = difference.asMinutes();
                        var differenceInMiliseconds = difference.asMilliseconds();
                        var timeoutTimer = differenceInMiliseconds || 0;
                        if (differenceInMinutes < 60 * 24) {
                            _this.reminderTimeouts.push(setTimeout(function () {
                                _this.showActivityReminder(activity.id);
                            }, timeoutTimer));
                        }
                    }
                });
            }
        };
        setInterval(function () {
            _this.setActivityReminders();
        }, 1000 * 60 * 60);
    }
    Object.defineProperty(Activities.prototype, "allActivitiesIds", {
        get: function () {
            return this.allActivities.map(function (activity, i) { return activity.id; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Activities.prototype, "activitiesToRemindAbout", {
        // List activities that need to be reminded about
        get: function () {
            var _this = this;
            var activities = [];
            this.userActivities.map(function (userActivites) {
                userActivites.activities.map(function (activity, i) {
                    if (!activity.finished &&
                        activity.remind &&
                        activity.showReminder &&
                        activity.assignedToUserId === _this.user.id) {
                        activities.push(activity);
                    }
                });
            });
            return activities.sort(function (a, b) {
                var remindDateTimeOfA = a.remindAt || a.activityTime;
                var remindDateTimeOfB = b.remindAt || b.activityTime;
                return remindDateTimeOfA > remindDateTimeOfB
                    ? 1
                    : remindDateTimeOfA < remindDateTimeOfB
                        ? -1
                        : 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Activities.prototype, "activitiesToRemindAboutIds", {
        get: function () {
            return this.activitiesToRemindAbout.map(function (activity) { return activity.id; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Activities.prototype, "reminderLength", {
        get: function () {
            return this.activitiesToRemindAbout;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Activities.prototype, "unfinishedActivitiesLength", {
        get: function () {
            return this.allActivities.filter(function (a) { return a.finished; }).length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Activities.prototype, "activitiesLength", {
        get: function () {
            return this.allActivities.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Activities.prototype, "activitiesUserLength", {
        get: function () {
            if (this.userActivitiesIndex !== -1) {
                return this.userActivities[this.userActivitiesIndex].activities.length;
            }
            else {
                return 0;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Activities.prototype, "activitiesGroups", {
        get: function () {
            return methods_1.ActivitiesMethods.parseActivitiesGroups(this.allActivities);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Activities.prototype, "userActivitiesIndex", {
        get: function () {
            var _this = this;
            var userIndex = -1;
            this.userActivities.some(function (user, i) {
                if (user.id === _this.user.id) {
                    userIndex = i;
                    return true;
                }
            });
            return userIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Activities.prototype, "userActivitiesIds", {
        get: function () {
            if (this.userActivitiesIndex !== -1) {
                return this.userActivities[this.userActivitiesIndex].activities.map(function (activity, i) { return activity.id; });
            }
            else {
                return [];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Activities.prototype, "userActivitiesGroups", {
        get: function () {
            return this.userActivitiesIndex !== -1
                ? methods_1.ActivitiesMethods.parseActivitiesGroups(this.userActivities[this.userActivitiesIndex].activities)
                : [];
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], Activities.prototype, "showRemindersCenter", void 0);
    __decorate([
        mobx_1.observable
    ], Activities.prototype, "loadingAllActivityTypes", void 0);
    __decorate([
        mobx_1.observable
    ], Activities.prototype, "allActivityTypes", void 0);
    __decorate([
        mobx_1.observable
    ], Activities.prototype, "allActivities", void 0);
    __decorate([
        mobx_1.computed
    ], Activities.prototype, "allActivitiesIds", null);
    __decorate([
        mobx_1.observable
    ], Activities.prototype, "allActivitiesLoading", void 0);
    __decorate([
        mobx_1.observable
    ], Activities.prototype, "userActivities", void 0);
    __decorate([
        mobx_1.observable
    ], Activities.prototype, "userActivitiesLoading", void 0);
    __decorate([
        mobx_1.action
    ], Activities.prototype, "initializeAllActivities", void 0);
    __decorate([
        mobx_1.computed
    ], Activities.prototype, "activitiesToRemindAbout", null);
    __decorate([
        mobx_1.computed
    ], Activities.prototype, "activitiesToRemindAboutIds", null);
    __decorate([
        mobx_1.computed
    ], Activities.prototype, "reminderLength", null);
    __decorate([
        mobx_1.computed
    ], Activities.prototype, "unfinishedActivitiesLength", null);
    __decorate([
        mobx_1.computed
    ], Activities.prototype, "activitiesLength", null);
    __decorate([
        mobx_1.computed
    ], Activities.prototype, "activitiesUserLength", null);
    __decorate([
        mobx_1.computed
    ], Activities.prototype, "activitiesGroups", null);
    __decorate([
        mobx_1.computed
    ], Activities.prototype, "userActivitiesIndex", null);
    __decorate([
        mobx_1.computed
    ], Activities.prototype, "userActivitiesIds", null);
    __decorate([
        mobx_1.computed
    ], Activities.prototype, "userActivitiesGroups", null);
    __decorate([
        mobx_1.action
    ], Activities.prototype, "openActivitiesReminders", void 0);
    __decorate([
        mobx_1.action
    ], Activities.prototype, "closeActivitiesReminders", void 0);
    __decorate([
        mobx_1.action
    ], Activities.prototype, "fetchAllActivities", void 0);
    __decorate([
        mobx_1.action
    ], Activities.prototype, "fetchUserActivities", void 0);
    __decorate([
        mobx_1.action
    ], Activities.prototype, "fetchActivityTypes", void 0);
    __decorate([
        mobx_1.action
    ], Activities.prototype, "disableActivityReminder", void 0);
    __decorate([
        mobx_1.action
    ], Activities.prototype, "markActivityAsComplete", void 0);
    __decorate([
        mobx_1.action
    ], Activities.prototype, "delayActivityReminder", void 0);
    __decorate([
        mobx_1.action
    ], Activities.prototype, "showActivityReminder", void 0);
    __decorate([
        mobx_1.action
    ], Activities.prototype, "setActivityReminders", void 0);
    return Activities;
}());
exports.Activities = Activities;


/***/ }),

/***/ "./app/web/src/stores/ActivitiesCreateOrEdit.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
var activity_1 = __webpack_require__("./app/common/interfaces/activity.ts");
var ActivitiesCreateOrEdit = /** @class */ (function () {
    function ActivitiesCreateOrEdit(user, activities, leadActivities) {
        var _this = this;
        this.user = user;
        this.activities = activities;
        this.leadActivities = leadActivities;
        // List of activities that are currently being edited
        this.editingActivities = [];
        // New activity state
        this.newActivity = null;
        // Post new activity to the API
        this.createActivity = function () { return __awaiter(_this, void 0, void 0, function () {
            var activityService, dateTime, remindAtDateTime, createdActivity, createActivity, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.newActivity.status = activity_1.NewActivityStatus.Saving;
                        activityService = App_1.app.service('activity');
                        dateTime = this.newActivity.date
                            ? this.newActivity.date.clone()
                            : null;
                        remindAtDateTime = null;
                        if (dateTime !== null) {
                            dateTime.hours(this.newActivity.time.value.hours);
                            dateTime.minutes(this.newActivity.time.value.minutes);
                            remindAtDateTime = this.prepareReminderDateTime(dateTime, this.newActivity.remindAt !== null &&
                                this.newActivity.remindAt.value !== null
                                ? this.newActivity.remindAt.value
                                : null);
                        }
                        createdActivity = {
                            note: this.newActivity.descriptionText,
                            providerId: this.newActivity.providerId,
                            activityTypeId: this.newActivity.typeId,
                            activityTime: dateTime !== null ? dateTime.format() : null,
                            remind: dateTime !== null && remindAtDateTime !== null ? true : false,
                            remindAt: remindAtDateTime !== null ? remindAtDateTime.format() : null,
                            createdByUserId: this.newActivity.createdByUserId,
                            assignedToUserId: this.newActivity.assignedToUserId,
                        };
                        return [4 /*yield*/, activityService.create(createdActivity)];
                    case 1:
                        createActivity = _a.sent();
                        this.newActivity.status = activity_1.NewActivityStatus.Success;
                        this.leadActivities.fetchLeadActivities(this.newActivity.providerId);
                        this.resetNewActivity();
                        this.activities.fetchUserActivities(this.user.id);
                        return [2 /*return*/, true];
                    case 2:
                        err_1 = _a.sent();
                        this.newActivity.status = activity_1.NewActivityStatus.Error;
                        console.error(err_1);
                        return [2 /*return*/, err_1];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        // Patch existing activity to the API
        this.editActivity = function (activityId) { return __awaiter(_this, void 0, void 0, function () {
            var indexOfActivity, activity, activityService, dateTime, remindAtDateTime, updatedActivity, updateActivity, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        indexOfActivity = this.editingActivitiesIds.indexOf(activityId);
                        activity = indexOfActivity !== -1 ? this.editingActivities[indexOfActivity] : null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        if (!(activity !== null)) return [3 /*break*/, 3];
                        activity.status = activity_1.NewActivityStatus.Saving;
                        activityService = App_1.app.service('activity');
                        dateTime = activity.date ? activity.date.clone() : null;
                        remindAtDateTime = null;
                        if (dateTime !== null) {
                            dateTime.hours(activity.time.value.hours);
                            dateTime.minutes(activity.time.value.minutes);
                            remindAtDateTime = this.prepareReminderDateTime(dateTime, activity.remindAt !== null && activity.remindAt.value !== null
                                ? activity.remindAt.value
                                : null);
                        }
                        updatedActivity = {
                            note: activity.descriptionText,
                            activityTypeId: activity.typeId,
                            activityTime: dateTime ? dateTime.format() : null,
                            remind: dateTime !== null && remindAtDateTime !== null ? true : false,
                            remindAt: remindAtDateTime ? remindAtDateTime.format() : null,
                            assignedToUserId: activity.assignedToUserId,
                        };
                        return [4 /*yield*/, activityService.patch(activityId, updatedActivity)];
                    case 2:
                        updateActivity = _a.sent();
                        activity.status = activity_1.NewActivityStatus.Success;
                        this.leadActivities.fetchLeadActivities(activity.providerId);
                        this.activities.fetchUserActivities(this.user.id);
                        this.editingActivities.splice(indexOfActivity, 1);
                        return [2 /*return*/, updateActivity];
                    case 3: throw new Error('Could not find activity of such ID');
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        err_2 = _a.sent();
                        if (activity !== null) {
                            activity.status = activity_1.NewActivityStatus.Error;
                        }
                        console.error(err_2);
                        return [2 /*return*/, err_2];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        // Start editing new activity
        this.startEditingExistingActivity = function (activityId) {
            var activity = null;
            // Check if activity exists in all activities
            var indexOfActivityInAllActivities = _this.activities.allActivitiesIds.indexOf(activityId);
            if (indexOfActivityInAllActivities !== -1) {
                activity = _this.activities.allActivities[indexOfActivityInAllActivities];
            }
            else {
                var indexOfActivityInLeadActivities = _this.leadActivities.openLeadActivitiesIds.indexOf(activityId);
                if (indexOfActivityInLeadActivities !== -1) {
                    var openLeadActivities = _this.leadActivities.leadActivities[_this.leadActivities.openLeadActivitiesIndex];
                    activity =
                        openLeadActivities.activities[indexOfActivityInLeadActivities];
                }
            }
            // Check if activity has been found and copy it to editing array
            if (activity !== null) {
                var dateTime = activity.activityTime
                    ? moment(activity.activityTime)
                    : null;
                _this.editingActivities.push({
                    activityId: activityId,
                    providerId: activity.providerId,
                    typeId: activity.activityTypeId,
                    typeName: activity.activityType.name,
                    date: dateTime,
                    time: {
                        value: dateTime
                            ? {
                                hours: dateTime.hours(),
                                minutes: dateTime.minutes(),
                                totalMinutes: dateTime.hours() * 60 + dateTime.minutes(),
                            }
                            : null,
                        label: dateTime ? dateTime.format('hh:mm A') : 'No date selected',
                    },
                    remindAt: {
                        value: null,
                        label: 'Do not remind',
                    },
                    assignedToUserId: activity.assignedToUserId,
                    assignedToUserName: activity.assignedToUser.name,
                    createdByUserId: activity.createdByUserId,
                    descriptionHtml: '<p>' + activity.note + '</p>',
                    descriptionText: activity.note,
                    descriptionTooLong: false,
                    status: activity_1.NewActivityStatus.None,
                });
            }
        };
        // Initialize new activity
        this.initializeNewActivity = function (providerId) {
            var now = moment();
            _this.newActivity = {
                providerId: providerId,
                typeId: null,
                typeName: null,
                date: null,
                time: {
                    value: {
                        hours: now.hours(),
                        minutes: now.minutes(),
                        totalMinutes: now.hours() * 60 + now.minutes(),
                    },
                    label: now.format('hh:mm A'),
                },
                remindAt: {
                    value: null,
                    label: 'Do not remind',
                },
                assignedToUserId: _this.user.id,
                assignedToUserName: _this.user.name,
                createdByUserId: _this.user.id,
                descriptionHtml: '',
                descriptionText: '',
                descriptionTooLong: false,
                status: activity_1.NewActivityStatus.None,
            };
        };
        // Reset activity
        this.resetNewActivity = function () {
            _this.newActivity = null;
        };
        // Prepare reminder date time
        this.prepareReminderDateTime = function (activityDateTime, remindAtValue) {
            var remindAtDateTime = null;
            if (remindAtValue !== null) {
                remindAtDateTime = activityDateTime.clone();
                if (typeof remindAtValue === 'string') {
                    remindAtDateTime =
                        remindAtValue === 'dontremind'
                            ? null
                            : remindAtValue === 'atthetime'
                                ? remindAtDateTime
                                : null;
                }
                else if (typeof remindAtValue === 'number') {
                    if (remindAtValue >= 0) {
                        remindAtDateTime.subtract(remindAtValue, 'minutes');
                    }
                    else if (remindAtValue < 0) {
                        remindAtDateTime.add(remindAtValue, 'minutes');
                    }
                }
            }
            return remindAtDateTime;
        };
    }
    Object.defineProperty(ActivitiesCreateOrEdit.prototype, "editingActivitiesIds", {
        // Flat array of IDs of activities currently being edited
        get: function () {
            return this.editingActivities.map(function (activity) { return activity.activityId; });
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], ActivitiesCreateOrEdit.prototype, "editingActivities", void 0);
    __decorate([
        mobx_1.computed
    ], ActivitiesCreateOrEdit.prototype, "editingActivitiesIds", null);
    __decorate([
        mobx_1.observable
    ], ActivitiesCreateOrEdit.prototype, "newActivity", void 0);
    __decorate([
        mobx_1.action
    ], ActivitiesCreateOrEdit.prototype, "createActivity", void 0);
    __decorate([
        mobx_1.action
    ], ActivitiesCreateOrEdit.prototype, "editActivity", void 0);
    __decorate([
        mobx_1.action
    ], ActivitiesCreateOrEdit.prototype, "startEditingExistingActivity", void 0);
    __decorate([
        mobx_1.action
    ], ActivitiesCreateOrEdit.prototype, "initializeNewActivity", void 0);
    __decorate([
        mobx_1.action
    ], ActivitiesCreateOrEdit.prototype, "resetNewActivity", void 0);
    return ActivitiesCreateOrEdit;
}());
exports.ActivitiesCreateOrEdit = ActivitiesCreateOrEdit;


/***/ }),

/***/ "./app/web/src/stores/AllStores.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__("./app/web/src/stores/index.ts");
// Initialize all stores
var user = new _1.User();
var modal = new _1.Modal();
var users = new _1.Users(user);
var leads = new _1.Leads(user);
var lead = new _1.Lead(leads, user);
var activities = new _1.Activities(user, modal);
var leadContacts = new _1.LeadContacts(lead);
var leadGroup = new _1.LeadGroup(user, lead);
var pricingRequest = new _1.PricingRequest(user);
var leadPricing = new _1.LeadPricing(lead, pricingRequest, user);
var leadActivities = new _1.LeadActivities(user, lead, activities);
var leadResources = new _1.LeadResources(lead);
var businessPartner = new _1.BusinessPartner(lead, leadContacts);
var activitiesCreateOrEdit = new _1.ActivitiesCreateOrEdit(user, activities, leadActivities);
var question = new _1.Question(user);
var answer = new _1.Answer(lead, question);
var sidebar = new _1.Sidebar();
var orderPad = new _1.OrderPad();
var orderPadSales = new _1.OrderPadSales();
var state = new _1.State(user);
var utilities = new _1.Utilities(user);
// Initialize the store
var store = {
    user: user,
    users: users,
    leads: leads,
    lead: lead,
    leadContacts: leadContacts,
    leadPricing: leadPricing,
    leadActivities: leadActivities,
    leadGroup: leadGroup,
    leadResources: leadResources,
    businessPartner: businessPartner,
    activities: activities,
    activitiesCreateOrEdit: activitiesCreateOrEdit,
    question: question,
    answer: answer,
    sidebar: sidebar,
    utilities: utilities,
    orderPad: orderPad,
    orderPadSales: orderPadSales,
    modal: modal,
    pricingRequest: pricingRequest,
    state: state,
};
exports.default = store;


/***/ }),

/***/ "./app/web/src/stores/Answer.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var debounce_1 = __webpack_require__("./node_modules/lodash-es/debounce.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
// Store
var Answer = /** @class */ (function () {
    function Answer(lead, question) {
        var _this = this;
        this.lead = lead;
        this.question = question;
        this.fetchNewLead = mobx_1.reaction(function () { return _this.lead.openLeadId; }, function (openLeadId) {
            if (openLeadId !== null) {
                _this.fetchAnswers();
            }
        });
        this.loading = false;
        this.answers = [];
        // Fetch all questions
        this.fetchAnswers = function (hideLoader) { return __awaiter(_this, void 0, void 0, function () {
            var id, questionAnswerService, answerInfo, answerService, initializeAnswer, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, 8, 9]);
                        id = this.lead.openLeadId;
                        if (typeof hideLoader === 'undefined' || hideLoader === false) {
                            this.loading = true;
                        }
                        return [4 /*yield*/, App_1.app.service('question-answer')];
                    case 1:
                        questionAnswerService = _a.sent();
                        return [4 /*yield*/, questionAnswerService.get(id)];
                    case 2:
                        answerInfo = _a.sent();
                        if (!(answerInfo === null)) return [3 /*break*/, 6];
                        return [4 /*yield*/, App_1.app.service('answer')];
                    case 3:
                        answerService = _a.sent();
                        return [4 /*yield*/, answerService.create({
                                providerId: id,
                            })];
                    case 4:
                        initializeAnswer = _a.sent();
                        return [4 /*yield*/, questionAnswerService.get(id)];
                    case 5:
                        answerInfo = _a.sent();
                        _a.label = 6;
                    case 6:
                        this.answers = answerInfo.selectedAnswer.map(function (answer, i) {
                            return __assign({}, answer, { note: typeof answer.note !== 'undefined' && answer.note !== null
                                    ? answer.note
                                    : null, others: typeof answer.others !== 'undefined' && answer.others !== null
                                    ? answer.others
                                    : null, answer: typeof answer.answer !== 'undefined' &&
                                    answer.answer &&
                                    answer.answer.length > 0
                                    ? answer.answer
                                    : [], saving: false });
                        });
                        return [2 /*return*/, answerInfo];
                    case 7:
                        err_1 = _a.sent();
                        this.answers = [];
                        console.error(err_1);
                        return [2 /*return*/, err_1];
                    case 8:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        }); };
        this.changeAnswerNote = function (answerId, question, noteText, noteHtml) {
            var answerIndex = _this.answersQuestionsIds.indexOf(question.id);
            if (answerIndex !== -1) {
                _this.answers[answerIndex].saving = true;
                _this.answers[answerIndex].note = noteText;
                _this.pushAnswers();
            }
        };
        this.changeAnswerValue = function (answerId, question, value, label) {
            var answerIndex = _this.answersQuestionsIds.indexOf(question.id);
            if (answerIndex !== -1) {
                _this.answers[answerIndex].saving = true;
                _this.answers[answerIndex].answer = [
                    {
                        id: value,
                        name: label,
                    },
                ];
                _this.pushAnswers();
            }
        };
        this.changeAnswerCheckbox = function (answerId, question, checked, value) {
            var answerIndex = _this.answersQuestionsIds.indexOf(question.id);
            if (answerIndex !== -1) {
                _this.answers[answerIndex].saving = true;
                var answersArray = _this.answers[answerIndex].answer !== null &&
                    _this.answers[answerIndex].answer.length > 0
                    ? typeof _this.answers[answerIndex].answer[0] === 'object' &&
                        typeof _this.answers[answerIndex].answer[0].id !== 'undefined'
                        ? _this.answers[answerIndex].answer.map(function (answer, i) { return answer.id; })
                        : _this.answers[answerIndex].answer
                    : [];
                var valueIndex = answersArray.indexOf(value);
                if (checked) {
                    if (valueIndex === -1) {
                        answersArray.push(value);
                    }
                }
                else {
                    if (valueIndex !== -1) {
                        answersArray = answersArray
                            .slice(0, valueIndex)
                            .concat(answersArray.slice(valueIndex + 1));
                    }
                }
                _this.answers[answerIndex].answer = answersArray;
                _this.pushAnswers();
            }
        };
        this.changeAnswerSelect = function (answerId, question, value) {
            var answerIndex = _this.answersQuestionsIds.indexOf(question.id);
            if (answerIndex !== -1) {
                _this.answers[answerIndex].saving = true;
                _this.answers[answerIndex].answer = [value];
                _this.pushAnswers();
            }
        };
        this.updateAnswers = function () { return __awaiter(_this, void 0, void 0, function () {
            var questionAnswerService, answers, updated, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        questionAnswerService = App_1.app.service('question-answer');
                        answers = this.answers.map(function (answer, i) {
                            return {
                                questionId: answer.id,
                                others: typeof answer.others !== 'undefined' && answer.others !== null
                                    ? answer.others
                                    : null,
                                note: typeof answer.note !== 'undefined' && answer.note !== null
                                    ? answer.note.trim()
                                    : null,
                                answer: answer.answer !== null && answer.answer.length > 0
                                    ? typeof answer.answer[0] === 'object' &&
                                        typeof answer.answer[0].id !== 'undefined'
                                        ? answer.answer.map(function (ans) { return ans.id; })
                                        : answer.answer
                                    : [],
                            };
                        });
                        return [4 /*yield*/, questionAnswerService.update(this.lead.openLeadId, answers)];
                    case 1:
                        updated = _a.sent();
                        return [2 /*return*/, updated];
                    case 2:
                        err_2 = _a.sent();
                        console.error(err_2);
                        return [2 /*return*/, err_2];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.pushAnswers = function () { return __awaiter(_this, void 0, void 0, function () {
            var err_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!(this.answers.length > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.updateAnswers()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.answers.map(function (answer, i) {
                            _this.answers[i].saving = false;
                        });
                        return [2 /*return*/, true];
                    case 3:
                        err_3 = _a.sent();
                        console.error(err_3);
                        return [2 /*return*/, err_3];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.pushAnswers = debounce_1.default(this.pushAnswers, 2000);
    }
    Object.defineProperty(Answer.prototype, "answersQuestionsIds", {
        get: function () {
            return this.answers.map(function (answer, i) { return answer.id; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Answer.prototype, "isAnswerInfoFetched", {
        get: function () {
            return this.loading === false && this.answers.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Answer.prototype, "primaryWholesalerSourcingProgramsQuestion", {
        // Find ID of the question that contains wholesaler info and their sourcing programs
        get: function () {
            try {
                var foundQuestion_1 = null;
                this.question.questionWithOptionInfo.some(function (question, i) {
                    if (question.optionTable === 'wholesaler') {
                        foundQuestion_1 = question;
                        return true;
                    }
                });
                return foundQuestion_1;
            }
            catch (err) {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Answer.prototype, "primaryWholesalerQuestionAnswer", {
        // Find existing answer, if there is any, for primary wholesaler
        get: function () {
            var _this = this;
            try {
                var foundAnswer_1 = null;
                this.answers.some(function (answer, i) {
                    if (answer.id === _this.primaryWholesalerSourcingProgramsQuestion.id) {
                        foundAnswer_1 = answer;
                        return true;
                    }
                });
                return foundAnswer_1;
            }
            catch (err) {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Answer.prototype, "primaryWholesalerSourcingProgramsIds", {
        // Find sourcing program if primary wholesaler have been picked
        get: function () {
            try {
                var primaryWholesalerId_1 = typeof this.primaryWholesalerQuestionAnswer.answer[0].id !== 'undefined'
                    ? this.primaryWholesalerQuestionAnswer.answer[0].id
                    : this.primaryWholesalerQuestionAnswer.answer[0];
                var sourcingProgramsIds_1 = [];
                this.primaryWholesalerSourcingProgramsQuestion.option.some(function (wholesaler, i) {
                    if (wholesaler.id === primaryWholesalerId_1) {
                        sourcingProgramsIds_1 = wholesaler.sourcingProgramIds;
                        return true;
                    }
                });
                return sourcingProgramsIds_1;
            }
            catch (err) {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], Answer.prototype, "loading", void 0);
    __decorate([
        mobx_1.observable
    ], Answer.prototype, "answers", void 0);
    __decorate([
        mobx_1.computed
    ], Answer.prototype, "answersQuestionsIds", null);
    __decorate([
        mobx_1.computed
    ], Answer.prototype, "isAnswerInfoFetched", null);
    __decorate([
        mobx_1.computed
    ], Answer.prototype, "primaryWholesalerSourcingProgramsQuestion", null);
    __decorate([
        mobx_1.computed
    ], Answer.prototype, "primaryWholesalerQuestionAnswer", null);
    __decorate([
        mobx_1.computed
    ], Answer.prototype, "primaryWholesalerSourcingProgramsIds", null);
    __decorate([
        mobx_1.action
    ], Answer.prototype, "fetchAnswers", void 0);
    __decorate([
        mobx_1.action
    ], Answer.prototype, "changeAnswerNote", void 0);
    __decorate([
        mobx_1.action
    ], Answer.prototype, "changeAnswerValue", void 0);
    __decorate([
        mobx_1.action
    ], Answer.prototype, "changeAnswerCheckbox", void 0);
    __decorate([
        mobx_1.action
    ], Answer.prototype, "changeAnswerSelect", void 0);
    __decorate([
        mobx_1.action
    ], Answer.prototype, "updateAnswers", void 0);
    __decorate([
        mobx_1.action
    ], Answer.prototype, "pushAnswers", void 0);
    return Answer;
}());
exports.Answer = Answer;


/***/ }),

/***/ "./app/web/src/stores/BusinessPartner.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var accounting_1 = __webpack_require__("./node_modules/accounting/accounting.js");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
var businessPartner_1 = __webpack_require__("./app/common/interfaces/businessPartner.ts");
// Store
var BusinessPartner = /** @class */ (function () {
    function BusinessPartner(lead, leadContacts) {
        var _this = this;
        this.lead = lead;
        this.leadContacts = leadContacts;
        this.reactToOpenLeadChange = mobx_1.reaction(function () { return _this.lead.openLeadId; }, function (id) {
            _this.clearAll();
        });
        this.createBusinessPartnerRequestLoading = false;
        this.createBusinessPartnerRequestFetched = false;
        this.newRequest = {
            showModal: false,
            status: businessPartner_1.StatusOfBusinessPartner.None,
            isNew: true,
            promoted: '',
            shippingAddress1: '',
            shippingAddress2: '',
            shippingCity: '',
            shippingState: '',
            shippingZipcode: '',
            licenceNumber: '',
            licenceExp: {
                date: moment(),
                label: moment().format(this.licenseExpDateFormat),
            },
        };
        this.showBusinessPartnerRequestModal = function () {
            _this.clearAll();
            _this.newRequest.showModal = true;
        };
        this.hideBusinessPartnerRequestModal = function () {
            _this.newRequest.showModal = false;
            _this.clearAll();
        };
        this.copyShippingAddress = function () {
            var openLeadDetails = _this.lead.openLeadDetails;
            _this.newRequest.shippingAddress1 = openLeadDetails.plAddress1 || '';
            _this.newRequest.shippingAddress2 = openLeadDetails.plAddress2 || '';
            _this.newRequest.shippingCity = openLeadDetails.plCity || '';
            _this.newRequest.shippingState = openLeadDetails.plState || '';
            _this.newRequest.shippingZipcode = openLeadDetails.plZipcode
                ? openLeadDetails.plZipcode.toString()
                : '';
        };
        // Change date
        this.changeLicenseExpirationDate = function (date) {
            _this.newRequest.licenceExp.date = date;
            _this.newRequest.licenceExp.label = date.format(_this.licenseExpDateFormat);
        };
        // Create pricing request
        this.createBusinessPartner = function () { return __awaiter(_this, void 0, void 0, function () {
            var service, result, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        this.newRequest.status = businessPartner_1.StatusOfBusinessPartner.Saving;
                        return [4 /*yield*/, App_1.app.service('provider-to-customer')];
                    case 1:
                        service = _a.sent();
                        return [4 /*yield*/, service.create({
                                providerId: this.lead.openLeadId,
                                license: accounting_1.unformat(this.newRequest.licenceNumber),
                                licenseExpDate: this.newRequest.licenceExp.date.format('YYYY-MM-DD'),
                                address: [
                                    {
                                        address: 'Shipping',
                                        street: this.newRequest.shippingAddress1,
                                        block: this.newRequest.shippingAddress2,
                                        city: this.newRequest.shippingCity,
                                        state: this.newRequest.shippingState,
                                        zipcode: this.newRequest.shippingZipcode,
                                        country: 'US',
                                        addressType: 'S',
                                    },
                                    {
                                        address: 'Billing',
                                        street: this.lead.openLeadDetails.plAddress1,
                                        block: this.lead.openLeadDetails.plAddress2,
                                        city: this.lead.openLeadDetails.plCity,
                                        state: this.lead.openLeadDetails.plState,
                                        zipcode: this.lead.openLeadDetails.plZipcode,
                                        country: 'US',
                                        addressType: 'B',
                                    },
                                ],
                            })];
                    case 2:
                        result = _a.sent();
                        this.newRequest.status = businessPartner_1.StatusOfBusinessPartner.Success;
                        this.lead.openLeadDetails.cardcode = result.cardcode;
                        this.lead.openLeadDetails.customerCreated = true;
                        setTimeout(function () {
                            _this.hideBusinessPartnerRequestModal();
                        }, 512);
                        this.newRequest.promoted = 'Promoted to business partner';
                        return [2 /*return*/, result];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1 === 'Customer already created for provider') {
                            this.newRequest.status =
                                businessPartner_1.StatusOfBusinessPartner.ErrorCustomerAlreadyCreated;
                            this.lead.fetchLeadDetails(this.lead.openLeadId);
                        }
                        else {
                            this.newRequest.status = businessPartner_1.StatusOfBusinessPartner.ErrorTryAgain;
                        }
                        console.error(err_1);
                        return [2 /*return*/, err_1];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // Fetch item by provider id
        this.clearAll = function () {
            _this.newRequest = {
                showModal: false,
                status: businessPartner_1.StatusOfBusinessPartner.None,
                isNew: true,
                promoted: '',
                shippingAddress1: '',
                shippingAddress2: '',
                shippingCity: '',
                shippingState: '',
                shippingZipcode: '',
                licenceNumber: '',
                licenceExp: {
                    date: moment(),
                    label: moment().format(_this.licenseExpDateFormat),
                },
            };
            _this.createBusinessPartnerRequestLoading = false;
            _this.createBusinessPartnerRequestFetched = false;
        };
    }
    Object.defineProperty(BusinessPartner.prototype, "licenseExpDateFormat", {
        get: function () {
            return 'MMM Do, YYYY';
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], BusinessPartner.prototype, "createBusinessPartnerRequestLoading", void 0);
    __decorate([
        mobx_1.observable
    ], BusinessPartner.prototype, "createBusinessPartnerRequestFetched", void 0);
    __decorate([
        mobx_1.observable
    ], BusinessPartner.prototype, "newRequest", void 0);
    __decorate([
        mobx_1.action
    ], BusinessPartner.prototype, "showBusinessPartnerRequestModal", void 0);
    __decorate([
        mobx_1.action
    ], BusinessPartner.prototype, "hideBusinessPartnerRequestModal", void 0);
    __decorate([
        mobx_1.action
    ], BusinessPartner.prototype, "copyShippingAddress", void 0);
    __decorate([
        mobx_1.action
    ], BusinessPartner.prototype, "changeLicenseExpirationDate", void 0);
    __decorate([
        mobx_1.action
    ], BusinessPartner.prototype, "createBusinessPartner", void 0);
    __decorate([
        mobx_1.action
    ], BusinessPartner.prototype, "clearAll", void 0);
    return BusinessPartner;
}());
exports.BusinessPartner = BusinessPartner;


/***/ }),

/***/ "./app/web/src/stores/Lead.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var has_1 = __webpack_require__("./node_modules/lodash-es/has.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
var localForage = __webpack_require__("./node_modules/localforage/dist/localforage.js");
// Store
var Lead = /** @class */ (function () {
    function Lead(leads, user) {
        var _this = this;
        this.leads = leads;
        this.user = user;
        // React to user logout
        this.reactToUserChange = mobx_1.reaction(function () { return _this.user.id; }, function (id) {
            _this.openLeads = [];
        });
        // React to open lead change
        this.reactToOpenLeadChange = mobx_1.reaction(function () { return _this.openLeadId; }, function (id) {
            _this.openLeadEditingDetails = false;
        });
        // Questionnaire visibility
        this.QUESTIONNAIRE_VISIBLE_STORAGE_KEY = 'questionnaire-visible';
        this.isQuestionnaireVisible = false;
        // Business types
        this.businessTypes = [];
        // Drug license types
        this.drugLicenseTypes = [];
        // Details
        this.openLeadId = null;
        this.showRelationsOfOpenLead = false;
        this.disableOpenLeadShowModal = false;
        this.disablingOpenLead = false;
        this.disablingOpenLeadError = false;
        this.openLeadEditingDetails = false;
        this.openLeadEditingDetailsSaving = false;
        this.openLeadEditingDetailsSavingError = false;
        this.editedOpenLeadDetails = {
            dba: '',
            legalBusName: '',
            providerId: '',
            salesReps: [],
            providerTypeCode: null,
            providerTypeName: null,
            dispenserClassCode: null,
            dispenserClassName: null,
            typeOfBusinessId: 0,
            typeOfBusinessName: '',
            drugLicenseTypeId: 0,
            drugLicenseTypeName: '',
            plAddress1: '',
            plAddress2: '',
            plCity: '',
            plState: '',
            plZipcode: '',
            plPhone: '',
            plExt: '',
            plFax: '',
            plEmail: '',
            modified: false,
        };
        this.openLeads = [];
        this.leadsDetails = [];
        this.newNote = {
            isSaving: false,
            error: false,
            errorAllFieldsRequired: false,
            html: '',
            text: '',
        };
        this.leadEditingNote = {
            id: null,
            isSaving: false,
            error: false,
            html: '',
            text: '',
        };
        this.leadHidingNote = {
            id: null,
            isSaving: false,
            error: false,
        };
        // Fetch single lead
        this.fetchLeadDetails = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var provider, leadDetails, leadDetailsIndex, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, App_1.app.service('provider')];
                    case 1:
                        provider = _a.sent();
                        return [4 /*yield*/, provider.get(id)];
                    case 2:
                        leadDetails = _a.sent();
                        leadDetails.notes = mobx_1.observable.array([]);
                        leadDetailsIndex = this.leadsDetailsIds.indexOf(id);
                        if (leadDetailsIndex !== -1) {
                            this.leadsDetails[leadDetailsIndex] = leadDetails;
                        }
                        else {
                            this.leadsDetails.push(leadDetails);
                        }
                        // Return success
                        return [2 /*return*/, leadDetails];
                    case 3:
                        err_1 = _a.sent();
                        // Display error
                        console.error('Could not fetch lead of ID: ' + id, err_1);
                        return [2 /*return*/, err_1];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // Open single lead
        this.handleLeadLoad = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var lead, leadDetails, leadDetailsIndex, openLeadIndex, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        lead = null;
                        leadDetails = null;
                        leadDetailsIndex = this.leadsDetailsIds.indexOf(id);
                        if (!(leadDetailsIndex === -1)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.fetchLeadDetails(id)];
                    case 1:
                        leadDetails = _a.sent();
                        return [4 /*yield*/, this.fetchLeadNotes(id)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        leadDetails = this.leadsDetails[leadDetailsIndex];
                        _a.label = 4;
                    case 4:
                        // Create lead short object
                        lead = {
                            databaseId: leadDetails.databaseId,
                            providerId: leadDetails.providerId,
                            legalBusName: leadDetails.legalBusName,
                            dba: leadDetails.dba,
                        };
                        openLeadIndex = this.openLeadsIds.indexOf(lead.databaseId);
                        if (openLeadIndex === -1) {
                            this.openLeads.push(lead);
                        }
                        // Mark as currently open lead
                        this.openLeadId = lead.databaseId;
                        return [2 /*return*/, lead];
                    case 5:
                        err_2 = _a.sent();
                        console.error(err_2);
                        return [2 /*return*/, err_2];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        // Disable single lead
        this.handleOpenLeadDisable = function () {
            _this.openLeadId = null;
        };
        // Select lead
        this.handleLeadSelect = function (id) {
            App_1.browserHistory.push('/sales/lead/' + id);
        };
        /* Generate lead card ID */
        this.generateDashboardLeadCardId = function (id) {
            return 'dashboard-lead-card-' + id;
        };
        /* Generate lead card name ID */
        this.generateDashboardLeadCardNameId = function (id) {
            return _this.generateDashboardLeadCardId(id) + '-name';
        };
        /* Generate note card ID */
        this.generateDashboardNoteCardId = function (id) {
            return 'dashboard-note-card-' + id;
        };
        /* Generate note card name ID */
        this.generateDashboardNoteCardNameId = function (id) {
            return _this.generateDashboardNoteCardId(id) + '-name';
        };
        // Close lead
        this.handleLeadClose = function (id) {
            var foundIndex = null;
            _this.openLeads.some(function (openLead, i) {
                if (openLead.databaseId === id) {
                    foundIndex = i;
                    return true;
                }
            });
            if (foundIndex !== null) {
                _this.openLeads = _this.openLeads
                    .slice(0, foundIndex)
                    .concat(_this.openLeads.slice(foundIndex + 1));
            }
            // Navigate to sales dashboard
            if (_this.openLeadId === id) {
                _this.openLeadId = null;
                App_1.browserHistory.push('/sales');
            }
        };
        // Start editing lead details
        this.startEditingOpenLeadDetails = function () {
            var providerType = _this.leads.returnProviderTypeOrDispenserClass(_this.openLeadDetails.type || null, 'type');
            var providerDispenserClass = _this.leads.returnProviderTypeOrDispenserClass(_this.openLeadDetails.dispenserClass || null, 'dispenser');
            _this.openLeadEditingDetails = true;
            _this.openLeadEditingDetailsSaving = false;
            _this.openLeadEditingDetailsSavingError = false;
            _this.editedOpenLeadDetails = {
                dba: _this.openLeadDetails.dba || '',
                providerId: _this.openLeadDetails.providerId || '',
                legalBusName: _this.openLeadDetails.legalBusName || '',
                salesReps: _this.openLeadDetails.salesReps || [],
                providerTypeCode: providerType ? providerType.code : null,
                providerTypeName: providerType ? providerType.name : null,
                dispenserClassCode: providerDispenserClass
                    ? providerDispenserClass.code
                    : null,
                dispenserClassName: providerDispenserClass
                    ? providerDispenserClass.name
                    : null,
                typeOfBusinessId: _this.openLeadDetails.typeOfBusinessData &&
                    _this.openLeadDetails.typeOfBusinessData.id
                    ? _this.openLeadDetails.typeOfBusinessData.id
                    : 0,
                typeOfBusinessName: _this.openLeadDetails.typeOfBusinessData &&
                    _this.openLeadDetails.typeOfBusinessData.name
                    ? _this.openLeadDetails.typeOfBusinessData.name
                    : '',
                drugLicenseTypeId: _this.openLeadDetails.typeOfDrugLicenseData &&
                    _this.openLeadDetails.typeOfDrugLicenseData.id
                    ? _this.openLeadDetails.typeOfDrugLicenseData.id
                    : 0,
                drugLicenseTypeName: _this.openLeadDetails.typeOfDrugLicenseData &&
                    _this.openLeadDetails.typeOfDrugLicenseData.name
                    ? _this.openLeadDetails.typeOfDrugLicenseData.name
                    : '',
                plAddress1: _this.openLeadDetails.plAddress1 || '',
                plAddress2: _this.openLeadDetails.plAddress2 || '',
                plCity: _this.openLeadDetails.plCity || '',
                plState: _this.openLeadDetails.plState || '',
                plZipcode: _this.openLeadDetails.plZipcode
                    ? _this.openLeadDetails.plZipcode.toString()
                    : '',
                plPhone: _this.openLeadDetails.plPhone || '',
                plExt: _this.openLeadDetails.plExt || '',
                plFax: _this.openLeadDetails.plFax || '',
                plEmail: _this.openLeadDetails.plEmail || '',
                modified: false,
            };
        };
        // Stop editing lead details
        this.stopEditingOpenLeadDetails = function () {
            _this.openLeadEditingDetails = false;
            _this.openLeadEditingDetailsSaving = false;
            _this.openLeadEditingDetailsSavingError = false;
            _this.editedOpenLeadDetails = {
                dba: '',
                providerId: '',
                legalBusName: '',
                salesReps: [],
                providerTypeCode: null,
                providerTypeName: null,
                dispenserClassCode: null,
                dispenserClassName: null,
                typeOfBusinessId: 0,
                typeOfBusinessName: '',
                drugLicenseTypeId: 0,
                drugLicenseTypeName: '',
                plAddress1: '',
                plAddress2: '',
                plCity: '',
                plState: '',
                plZipcode: '',
                plPhone: '',
                plExt: '',
                plFax: '',
                plEmail: '',
                modified: false,
            };
        };
        // Save
        this.saveUpdatedLeadDetails = function () { return __awaiter(_this, void 0, void 0, function () {
            var zipcode, provider, patch, providerSalesReps, repsPatch, leadDetailsIndex, result, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 8]);
                        this.openLeadEditingDetails = false;
                        this.openLeadEditingDetailsSaving = true;
                        this.openLeadEditingDetailsSavingError = false;
                        if (!this.editedOpenLeadDetails.modified) return [3 /*break*/, 5];
                        zipcode = parseInt(this.editedOpenLeadDetails.plZipcode.trim(), 10);
                        zipcode = isNaN(zipcode) ? null : zipcode;
                        return [4 /*yield*/, App_1.app.service('provider')];
                    case 1:
                        provider = _a.sent();
                        return [4 /*yield*/, provider.patch(this.openLeadId, {
                                providerId: this.editedOpenLeadDetails.providerId.trim(),
                                dba: this.editedOpenLeadDetails.dba.trim(),
                                legalBusName: this.editedOpenLeadDetails.legalBusName.trim(),
                                type: this.editedOpenLeadDetails.providerTypeCode || null,
                                dispenserClass: this.editedOpenLeadDetails.dispenserClassCode || null,
                                typeOfBusiness: this.editedOpenLeadDetails.typeOfBusinessId || null,
                                drugLicenseType: this.editedOpenLeadDetails.drugLicenseTypeId || null,
                                plCity: this.editedOpenLeadDetails.plCity.trim() || null,
                                plAddress1: this.editedOpenLeadDetails.plAddress1.trim() || null,
                                plAddress2: this.editedOpenLeadDetails.plAddress2.trim() || null,
                                plState: this.editedOpenLeadDetails.plState.trim() || null,
                                plZipcode: zipcode,
                                plPhone: this.editedOpenLeadDetails.plPhone.trim() || null,
                                plExt: this.editedOpenLeadDetails.plExt.trim() || null,
                                plFax: this.editedOpenLeadDetails.plFax.trim() || null,
                                plEmail: this.editedOpenLeadDetails.plEmail.trim() || null,
                            })];
                    case 2:
                        patch = _a.sent();
                        return [4 /*yield*/, App_1.app.service('provider-to-salesrep')];
                    case 3:
                        providerSalesReps = _a.sent();
                        return [4 /*yield*/, providerSalesReps.create({
                                providerId: this.openLeadId,
                                salesReps: this.editedOpenLeadDetails.salesReps.map(function (rep) { return ({
                                    slpcode: rep.slpcode,
                                    primary: rep.primary ? 1 : 0,
                                }); }),
                            })];
                    case 4:
                        repsPatch = _a.sent();
                        leadDetailsIndex = this.leadsDetailsIds.indexOf(this.openLeadId);
                        this.leadsDetails[leadDetailsIndex].salesReps = this.editedOpenLeadDetails.salesReps;
                        this.leadsDetails[leadDetailsIndex].dba = patch.dba;
                        this.leadsDetails[leadDetailsIndex].providerId = patch.providerId;
                        this.leadsDetails[leadDetailsIndex].legalBusName = patch.legalBusName;
                        this.leadsDetails[leadDetailsIndex].type = patch.type;
                        this.leadsDetails[leadDetailsIndex].dispenserClass =
                            patch.dispenserClass;
                        this.leadsDetails[leadDetailsIndex].typeOfBusinessData = patch.typeOfBusinessData
                            ? {
                                id: patch.typeOfBusinessData.id,
                                name: patch.typeOfBusinessData.name,
                            }
                            : null;
                        this.leadsDetails[leadDetailsIndex].typeOfDrugLicenseData = patch.typeOfDrugLicenseData
                            ? {
                                id: patch.typeOfDrugLicenseData.id,
                                name: patch.typeOfDrugLicenseData.name,
                            }
                            : null;
                        this.leadsDetails[leadDetailsIndex].plCity = patch.plCity;
                        this.leadsDetails[leadDetailsIndex].plAddress1 = patch.plAddress1;
                        this.leadsDetails[leadDetailsIndex].plAddress2 = patch.plAddress2;
                        this.leadsDetails[leadDetailsIndex].plState = patch.plState;
                        this.leadsDetails[leadDetailsIndex].plZipcode = patch.plZipcode;
                        this.leadsDetails[leadDetailsIndex].plPhone = patch.plPhone;
                        this.leadsDetails[leadDetailsIndex].plExt = patch.plExt;
                        this.leadsDetails[leadDetailsIndex].plFax = patch.plFax;
                        this.leadsDetails[leadDetailsIndex].plEmail = patch.plEmail;
                        this.openLeadEditingDetails = false;
                        this.openLeadEditingDetailsSaving = false;
                        this.openLeadEditingDetailsSavingError = false;
                        return [3 /*break*/, 6];
                    case 5:
                        this.openLeadEditingDetails = false;
                        this.openLeadEditingDetailsSaving = false;
                        this.openLeadEditingDetailsSavingError = false;
                        _a.label = 6;
                    case 6:
                        result = this.editedOpenLeadDetails;
                        this.editedOpenLeadDetails = {
                            dba: '',
                            providerId: '',
                            legalBusName: '',
                            salesReps: [],
                            providerTypeCode: null,
                            providerTypeName: null,
                            dispenserClassCode: null,
                            dispenserClassName: null,
                            typeOfBusinessId: 0,
                            typeOfBusinessName: '',
                            drugLicenseTypeId: 0,
                            drugLicenseTypeName: '',
                            plAddress1: '',
                            plAddress2: '',
                            plCity: '',
                            plState: '',
                            plZipcode: '',
                            plPhone: '',
                            plExt: '',
                            plFax: '',
                            plEmail: '',
                            modified: false,
                        };
                        return [2 /*return*/, result];
                    case 7:
                        err_3 = _a.sent();
                        this.openLeadEditingDetailsSaving = false;
                        this.openLeadEditingDetailsSavingError = true;
                        console.error(err_3);
                        return [2 /*return*/, err_3];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        // Fetch all notes from lead
        this.fetchLeadNotes = function (leadId) { return __awaiter(_this, void 0, void 0, function () {
            var leadNotesDb, leadNotesInfo, leadDetailsIndex_1, err_4;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        leadNotesDb = App_1.app.service('comment');
                        return [4 /*yield*/, leadNotesDb.find({
                                query: {
                                    providerId: leadId,
                                    $limit: 10000,
                                    $sort: {
                                        updatedAt: -1,
                                    },
                                },
                            })];
                    case 1:
                        leadNotesInfo = (_a.sent());
                        leadDetailsIndex_1 = this.leadsDetailsIds.indexOf(leadId);
                        if (leadDetailsIndex_1 !== -1 &&
                            typeof this.leadsDetails[leadDetailsIndex_1].notes !== 'undefined') {
                            leadNotesInfo.data.map(function (note) {
                                _this.leadsDetails[leadDetailsIndex_1].notes.push(note);
                            });
                        }
                        else if (leadDetailsIndex_1 !== -1 &&
                            typeof this.leadsDetails[leadDetailsIndex_1].notes === 'undefined') {
                            mobx_1.extendObservable(this.leadsDetails[leadDetailsIndex_1], {
                                notes: leadNotesInfo,
                            });
                        }
                        return [2 /*return*/, leadNotesInfo];
                    case 2:
                        err_4 = _a.sent();
                        console.error('Could not fetch lead notes for ID: ' + leadId, err_4);
                        throw err_4;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.addLeadNote = function () { return __awaiter(_this, void 0, void 0, function () {
            var id, note, newNoteCreated, leadNoteCreatedByUser, leadDetailsIndex, notes, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.newNote.text.trim().length <= 0)) return [3 /*break*/, 1];
                        return [2 /*return*/];
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        id = this.openLeadId;
                        // Start saving
                        this.newNote.isSaving = true;
                        this.newNote.error = false;
                        this.newNote.errorAllFieldsRequired = false;
                        note = this.newNote.text.trim();
                        return [4 /*yield*/, this.submitLeadNote({
                                comment: note,
                                providerId: id,
                            })];
                    case 2:
                        newNoteCreated = _a.sent();
                        // Disable editing
                        this.newNote = {
                            isSaving: false,
                            error: false,
                            errorAllFieldsRequired: false,
                            html: '',
                            text: '',
                        };
                        leadNoteCreatedByUser = {
                            id: this.user.id,
                            username: this.user.username,
                            name: this.user.name,
                            email: this.user.email,
                        };
                        leadDetailsIndex = this.leadsDetailsIds.indexOf(id);
                        notes = this.leadsDetails[leadDetailsIndex].notes;
                        this.leadsDetails[leadDetailsIndex].notes.unshift({
                            id: newNoteCreated.id,
                            comment: newNoteCreated.comment,
                            hidden: 0,
                            providerId: newNoteCreated.providerId,
                            createdAt: newNoteCreated.createdAt,
                            createdByUser: leadNoteCreatedByUser,
                            updatedAt: newNoteCreated.updatedAt,
                            updatedByUser: leadNoteCreatedByUser,
                        });
                        // Return boolean true if succesfull
                        return [2 /*return*/, true];
                    case 3:
                        err_5 = _a.sent();
                        this.newNote = __assign({}, this.newNote, { isSaving: false, error: true });
                        console.error(err_5);
                        throw err_5;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.clearNewLeadNote = function () {
            if (_this.newNote.isSaving === false) {
                _this.newNote.error = false;
                _this.newNote.errorAllFieldsRequired = false;
                _this.newNote.html = '';
                _this.newNote.text = '';
            }
        };
        this.submitLeadNote = function (leadNotesSubmitInfo) { return __awaiter(_this, void 0, void 0, function () {
            var leadNotesDb, response, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        leadNotesDb = App_1.app.service('comment');
                        return [4 /*yield*/, leadNotesDb.create(leadNotesSubmitInfo)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        err_6 = _a.sent();
                        console.error(err_6);
                        throw err_6;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.fetchBusinessTypes = function () { return __awaiter(_this, void 0, void 0, function () {
            var service, businessTypes, err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        service = App_1.app.service('type-of-business');
                        return [4 /*yield*/, service.find({
                                query: {
                                    $sort: {
                                        name: 1,
                                    },
                                },
                            })];
                    case 1:
                        businessTypes = (_a.sent());
                        this.businessTypes = businessTypes;
                        return [2 /*return*/, businessTypes];
                    case 2:
                        err_7 = _a.sent();
                        console.error(err_7);
                        return [2 /*return*/, err_7];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.fetchDrugLicenseTypes = function () { return __awaiter(_this, void 0, void 0, function () {
            var service, drugLicenseTypes, err_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        service = App_1.app.service('drug-license-type');
                        return [4 /*yield*/, service.find({
                                query: {
                                    $sort: {
                                        name: 1,
                                    },
                                },
                            })];
                    case 1:
                        drugLicenseTypes = _a.sent();
                        this.drugLicenseTypes = drugLicenseTypes;
                        return [2 /*return*/, drugLicenseTypes];
                    case 2:
                        err_8 = _a.sent();
                        console.error(err_8);
                        return [2 /*return*/, err_8];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.updateLeadNote = function (id, leadNotesUpdateInfo) { return __awaiter(_this, void 0, void 0, function () {
            var leadNotesDb, response, err_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        leadNotesDb = App_1.app.service('comment');
                        return [4 /*yield*/, leadNotesDb.patch(id, leadNotesUpdateInfo)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        err_9 = _a.sent();
                        console.error(err_9);
                        throw err_9;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.toggleQuestionnaireVisibility = function () {
            var willBeVisible = !_this.isQuestionnaireVisible;
            _this.isQuestionnaireVisible = willBeVisible;
            localForage.setItem(_this.QUESTIONNAIRE_VISIBLE_STORAGE_KEY, willBeVisible);
        };
        this.openDisableLeadModal = function () {
            _this.disableOpenLeadShowModal = true;
        };
        this.closeDisableLeadModal = function () {
            _this.disableOpenLeadShowModal = false;
        };
        this.disableLead = function (databaseId) { return __awaiter(_this, void 0, void 0, function () {
            var service, patch, disabledLeadIndex_1, err_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        this.disablingOpenLead = true;
                        this.disablingOpenLeadError = false;
                        return [4 /*yield*/, App_1.app.service('provider')];
                    case 1:
                        service = _a.sent();
                        return [4 /*yield*/, service.patch(databaseId, {
                                active: false,
                            })];
                    case 2:
                        patch = _a.sent();
                        this.disableOpenLeadShowModal = false;
                        disabledLeadIndex_1 = -1;
                        this.openLeads.some(function (lead, leadIndex) {
                            if (lead.databaseId === databaseId) {
                                disabledLeadIndex_1 = leadIndex;
                                return true;
                            }
                        });
                        if (disabledLeadIndex_1 !== -1) {
                            this.openLeads.splice(disabledLeadIndex_1);
                        }
                        App_1.browserHistory.push('/sales');
                        this.leads.allLeads = [];
                        this.leads.leadsToDisplayByQuery.clear();
                        this.leads.leadsSearch = '';
                        this.leads.fetchLeads();
                        return [2 /*return*/, true];
                    case 3:
                        err_10 = _a.sent();
                        this.disablingOpenLeadError = true;
                        console.error(err_10);
                        return [2 /*return*/, false];
                    case 4:
                        this.disablingOpenLead = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.setQuestionnaireVisibility = function () {
            localForage
                .getItem(_this.QUESTIONNAIRE_VISIBLE_STORAGE_KEY)
                .then(function (isVisible) {
                if (isVisible) {
                    _this.isQuestionnaireVisible = isVisible;
                }
            });
        };
        this.setQuestionnaireVisibility();
    }
    Object.defineProperty(Lead.prototype, "businessTypesLength", {
        get: function () {
            return this.businessTypes.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Lead.prototype, "drugLicenseTypesLength", {
        get: function () {
            return this.drugLicenseTypes.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Lead.prototype, "openLeadDetails", {
        get: function () {
            if (this.openLeadId) {
                var leadDetailsIndex = this.leadsDetailsIds.indexOf(this.openLeadId);
                return leadDetailsIndex !== -1
                    ? this.leadsDetails[leadDetailsIndex]
                    : null;
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Lead.prototype, "openLeadGroup", {
        get: function () {
            if (this.openLeadDetails !== null &&
                has_1.default(this.openLeadDetails, 'providerGroup.id') &&
                has_1.default(this.openLeadDetails, 'providerGroup.name')) {
                return {
                    id: this.openLeadDetails.providerGroup.id,
                    name: this.openLeadDetails.providerGroup.name,
                };
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Lead.prototype, "leadTitle", {
        get: function () {
            return this.openLeadDetails !== null &&
                (this.openLeadDetails.customerCreated || this.openLeadDetails.cardcode)
                ? 'Customer'
                : 'Lead';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Lead.prototype, "openLeadAddress", {
        get: function () {
            var addr = '';
            if (this.openLeadDetails !== null) {
                var _a = this.openLeadDetails, plAddress1 = _a.plAddress1, plAddress2 = _a.plAddress2, plCity = _a.plCity, plState = _a.plState, plZipcode = _a.plZipcode;
                addr += plAddress1 ? ' ' + this.openLeadDetails.plAddress1 + ', ' : '';
                addr += plAddress2 ? ' ' + this.openLeadDetails.plAddress2 + ', ' : '';
                addr += plCity ? ' ' + this.openLeadDetails.plCity + ',' : '';
                addr += plState ? ' ' + this.openLeadDetails.plState : '';
                addr += plZipcode ? ' ' + this.openLeadDetails.plZipcode : '';
            }
            return addr.replace(/\s\s+/g, ' ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Lead.prototype, "openLeadsIds", {
        get: function () {
            return this.openLeads.map(function (lead) { return lead.databaseId; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Lead.prototype, "leadsDetailsIds", {
        get: function () {
            return this.leadsDetails.map(function (lead) { return lead.databaseId; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Lead.prototype, "openLeadNotes", {
        // Notes
        get: function () {
            if (this.openLeadId) {
                var leadDetailsIndex = this.leadsDetailsIds.indexOf(this.openLeadId);
                return leadDetailsIndex !== -1
                    ? this.leadsDetails[leadDetailsIndex].notes
                    : null;
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], Lead.prototype, "isQuestionnaireVisible", void 0);
    __decorate([
        mobx_1.observable
    ], Lead.prototype, "businessTypes", void 0);
    __decorate([
        mobx_1.computed
    ], Lead.prototype, "businessTypesLength", null);
    __decorate([
        mobx_1.observable
    ], Lead.prototype, "drugLicenseTypes", void 0);
    __decorate([
        mobx_1.computed
    ], Lead.prototype, "drugLicenseTypesLength", null);
    __decorate([
        mobx_1.observable
    ], Lead.prototype, "openLeadId", void 0);
    __decorate([
        mobx_1.observable
    ], Lead.prototype, "showRelationsOfOpenLead", void 0);
    __decorate([
        mobx_1.computed
    ], Lead.prototype, "openLeadDetails", null);
    __decorate([
        mobx_1.computed
    ], Lead.prototype, "openLeadGroup", null);
    __decorate([
        mobx_1.computed
    ], Lead.prototype, "leadTitle", null);
    __decorate([
        mobx_1.observable
    ], Lead.prototype, "disableOpenLeadShowModal", void 0);
    __decorate([
        mobx_1.observable
    ], Lead.prototype, "disablingOpenLead", void 0);
    __decorate([
        mobx_1.observable
    ], Lead.prototype, "disablingOpenLeadError", void 0);
    __decorate([
        mobx_1.observable
    ], Lead.prototype, "openLeadEditingDetails", void 0);
    __decorate([
        mobx_1.observable
    ], Lead.prototype, "openLeadEditingDetailsSaving", void 0);
    __decorate([
        mobx_1.observable
    ], Lead.prototype, "openLeadEditingDetailsSavingError", void 0);
    __decorate([
        mobx_1.observable
    ], Lead.prototype, "editedOpenLeadDetails", void 0);
    __decorate([
        mobx_1.computed
    ], Lead.prototype, "openLeadAddress", null);
    __decorate([
        mobx_1.observable
    ], Lead.prototype, "openLeads", void 0);
    __decorate([
        mobx_1.computed
    ], Lead.prototype, "openLeadsIds", null);
    __decorate([
        mobx_1.observable
    ], Lead.prototype, "leadsDetails", void 0);
    __decorate([
        mobx_1.computed
    ], Lead.prototype, "leadsDetailsIds", null);
    __decorate([
        mobx_1.computed
    ], Lead.prototype, "openLeadNotes", null);
    __decorate([
        mobx_1.observable
    ], Lead.prototype, "newNote", void 0);
    __decorate([
        mobx_1.observable
    ], Lead.prototype, "leadEditingNote", void 0);
    __decorate([
        mobx_1.observable
    ], Lead.prototype, "leadHidingNote", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "fetchLeadDetails", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "handleLeadLoad", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "handleOpenLeadDisable", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "handleLeadSelect", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "handleLeadClose", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "startEditingOpenLeadDetails", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "stopEditingOpenLeadDetails", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "saveUpdatedLeadDetails", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "fetchLeadNotes", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "addLeadNote", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "clearNewLeadNote", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "submitLeadNote", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "fetchBusinessTypes", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "fetchDrugLicenseTypes", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "updateLeadNote", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "toggleQuestionnaireVisibility", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "openDisableLeadModal", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "closeDisableLeadModal", void 0);
    __decorate([
        mobx_1.action
    ], Lead.prototype, "disableLead", void 0);
    return Lead;
}());
exports.Lead = Lead;


/***/ }),

/***/ "./app/web/src/stores/LeadActivities.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var methods_1 = __webpack_require__("./app/common/methods/index.ts");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
var user_1 = __webpack_require__("./app/common/interfaces/user.ts");
var LeadActivities = /** @class */ (function () {
    function LeadActivities(user, lead, activities) {
        var _this = this;
        this.user = user;
        this.lead = lead;
        this.activities = activities;
        // React to open lead change
        this.openLeadChangeReaction = mobx_1.reaction(function () { return _this.lead.openLeadId; }, function (openLeadId) {
            if (openLeadId !== null) {
                if (_this.leadActivitiesForSalesPerson === null) {
                    _this.setLeadActivitiesForSalesPerson(openLeadId, _this.user.userType === user_1.UserType.SalesManager ? -1 : _this.user.id, _this.user.userType === user_1.UserType.SalesManager
                        ? 'All'
                        : _this.user.name || _this.user.username);
                }
                _this.fetchLeadActivities(openLeadId);
            }
        });
        // React to completed activities change
        this.showCompletedActivitiesReaction = mobx_1.reaction(function () { return _this.showCompletedActivities; }, function (showFinished) {
            if (_this.lead.openLeadId !== null) {
                _this.fetchLeadActivities(_this.lead.openLeadId);
            }
        });
        this.showActivitiesForSalesPerson = [];
        this.showCompletedActivities = false;
        this.leadActivitiesLoading = false;
        this.leadActivities = [];
        this.showActivitiesOfOtherLeads = false;
        this.toggleShowingOfActivitiesOfOtherLeads = function (show) {
            show =
                typeof show !== 'undefined' ? show : !_this.showActivitiesOfOtherLeads;
            _this.showActivitiesOfOtherLeads = show;
        };
        // Fetch lead activities
        this.fetchLeadActivities = function (providerId) { return __awaiter(_this, void 0, void 0, function () {
            var finished, activitiesQuery, activitiesService, activitiesInfo, leadIndex_1, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Indicate that activities are loading
                        this.leadActivitiesLoading = true;
                        finished = this.showCompletedActivities;
                        activitiesQuery = {
                            providerId: providerId,
                            finished: finished ? 1 : 0,
                            $limit: 99999999,
                            $sort: {
                                activityTime: finished ? -1 : 1,
                            },
                            $skip: 0,
                        };
                        if (this.user && this.user.userType !== user_1.UserType.SalesManager) {
                            activitiesQuery.assignedToUserId = this.user.id;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        activitiesService = App_1.app.service('activity');
                        return [4 /*yield*/, activitiesService.find({
                                query: activitiesQuery,
                            })];
                    case 2:
                        activitiesInfo = (_a.sent());
                        leadIndex_1 = -1;
                        this.leadActivities.some(function (lead, i) {
                            if (lead.id === _this.lead.openLeadId) {
                                leadIndex_1 = i;
                                return true;
                            }
                        });
                        // Update state
                        if (leadIndex_1 !== -1) {
                            this.leadActivities = this.leadActivities
                                .slice(0, leadIndex_1)
                                .concat({
                                id: this.lead.openLeadId,
                                activities: activitiesInfo.data.map(function (activity, i) { return (__assign({}, activity, { savingComplete: false })); }),
                            })
                                .concat(this.leadActivities.slice(leadIndex_1 + 1));
                        }
                        else {
                            this.leadActivities.push({
                                id: this.lead.openLeadId,
                                activities: activitiesInfo.data.map(function (activity, i) { return (__assign({}, activity, { savingComplete: false })); }),
                            });
                        }
                        return [2 /*return*/, activitiesInfo.data];
                    case 3:
                        err_1 = _a.sent();
                        console.error(err_1);
                        return [2 /*return*/, err_1];
                    case 4:
                        this.leadActivitiesLoading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
    }
    Object.defineProperty(LeadActivities.prototype, "leadActivitiesForSalesPerson", {
        get: function () {
            var _this = this;
            var id = -1;
            var name = 'All';
            if (typeof this.showActivitiesForSalesPerson !== 'undefined' &&
                this.showActivitiesForSalesPerson) {
                this.showActivitiesForSalesPerson.some(function (activity) {
                    if (_this.lead.openLeadId === activity.leadId) {
                        id = activity.salesPersonId;
                        name = activity.salesPersonName;
                        return true;
                    }
                });
            }
            return { salesPersonId: id, salesPersonName: name };
        },
        enumerable: true,
        configurable: true
    });
    LeadActivities.prototype.setLeadActivitiesForSalesPerson = function (leadId, salesPersonId, salesPersonName) {
        var found = false;
        if (!salesPersonId) {
            return false;
        }
        this.showActivitiesForSalesPerson.some(function (activity) {
            if (activity.leadId === leadId) {
                activity.salesPersonId = salesPersonId;
                activity.salesPersonName = salesPersonName;
                found = true;
                return true;
            }
        });
        if (found === false) {
            this.showActivitiesForSalesPerson.push({
                leadId: leadId,
                salesPersonId: salesPersonId,
                salesPersonName: salesPersonName,
            });
        }
        return true;
    };
    Object.defineProperty(LeadActivities.prototype, "openLeadActivitiesIndex", {
        get: function () {
            var _this = this;
            var leadIndex = -1;
            this.leadActivities.some(function (lead, i) {
                if (lead.id === _this.lead.openLeadId) {
                    leadIndex = i;
                    return true;
                }
            });
            return leadIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadActivities.prototype, "activitiesGroupsOfOtherLeads", {
        get: function () {
            var _this = this;
            var otherLeadsActivities = [];
            if (this.activities.userActivitiesIndex !== -1) {
                this.activities.userActivities[this.activities.userActivitiesIndex].activities.map(function (userActivity) {
                    if (typeof userActivity.providerId !== 'undefined' &&
                        userActivity.providerId !== _this.lead.openLeadId) {
                        otherLeadsActivities.push(userActivity);
                    }
                });
            }
            return methods_1.ActivitiesMethods.parseActivitiesGroups(otherLeadsActivities);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadActivities.prototype, "openLeadActivitiesIds", {
        get: function () {
            if (this.openLeadActivitiesIndex !== -1) {
                return this.leadActivities[this.openLeadActivitiesIndex].activities.map(function (activity, i) { return activity.id; });
            }
            else {
                return [];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadActivities.prototype, "activitiesLeadLength", {
        get: function () {
            return this.openLeadActivitiesIndex !== -1
                ? this.leadActivities[this.openLeadActivitiesIndex].activities.length
                : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadActivities.prototype, "openLeadAllActivities", {
        get: function () {
            var _this = this;
            // Get all activities allowed to be seen by logged in user
            var activities = typeof this.leadActivities[this.openLeadActivitiesIndex] !== 'undefined'
                ? this.leadActivities[this.openLeadActivitiesIndex].activities || []
                : [];
            // Filter activities by user filter
            if (this.leadActivitiesForSalesPerson &&
                this.leadActivitiesForSalesPerson.salesPersonId &&
                this.leadActivitiesForSalesPerson.salesPersonId > 0) {
                activities = activities.filter(function (activity) {
                    return activity.assignedToUserId ===
                        _this.leadActivitiesForSalesPerson.salesPersonId;
                });
            }
            // Filter activities by quantity to show
            if (this.showCompletedActivities && this.user.maxFinishedActivitiesCount) {
                activities = activities.slice(0, this.user.maxFinishedActivitiesCount || 999999999);
            }
            return activities;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadActivities.prototype, "openLeadAllActivitiesCount", {
        get: function () {
            return this.openLeadAllActivities.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadActivities.prototype, "activitiesGroups", {
        get: function () {
            return methods_1.ActivitiesMethods.parseActivitiesGroups(this.openLeadAllActivities);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], LeadActivities.prototype, "showActivitiesForSalesPerson", void 0);
    __decorate([
        mobx_1.computed
    ], LeadActivities.prototype, "leadActivitiesForSalesPerson", null);
    __decorate([
        mobx_1.action
    ], LeadActivities.prototype, "setLeadActivitiesForSalesPerson", null);
    __decorate([
        mobx_1.observable
    ], LeadActivities.prototype, "showCompletedActivities", void 0);
    __decorate([
        mobx_1.observable
    ], LeadActivities.prototype, "leadActivitiesLoading", void 0);
    __decorate([
        mobx_1.observable
    ], LeadActivities.prototype, "leadActivities", void 0);
    __decorate([
        mobx_1.computed
    ], LeadActivities.prototype, "openLeadActivitiesIndex", null);
    __decorate([
        mobx_1.observable
    ], LeadActivities.prototype, "showActivitiesOfOtherLeads", void 0);
    __decorate([
        mobx_1.action
    ], LeadActivities.prototype, "toggleShowingOfActivitiesOfOtherLeads", void 0);
    __decorate([
        mobx_1.computed
    ], LeadActivities.prototype, "activitiesGroupsOfOtherLeads", null);
    __decorate([
        mobx_1.computed
    ], LeadActivities.prototype, "openLeadActivitiesIds", null);
    __decorate([
        mobx_1.computed
    ], LeadActivities.prototype, "activitiesLeadLength", null);
    __decorate([
        mobx_1.computed
    ], LeadActivities.prototype, "openLeadAllActivities", null);
    __decorate([
        mobx_1.computed
    ], LeadActivities.prototype, "openLeadAllActivitiesCount", null);
    __decorate([
        mobx_1.computed
    ], LeadActivities.prototype, "activitiesGroups", null);
    __decorate([
        mobx_1.action
    ], LeadActivities.prototype, "fetchLeadActivities", void 0);
    return LeadActivities;
}());
exports.LeadActivities = LeadActivities;


/***/ }),

/***/ "./app/web/src/stores/LeadContacts.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
var EContactSavingError;
(function (EContactSavingError) {
    EContactSavingError[EContactSavingError["None"] = 0] = "None";
    EContactSavingError[EContactSavingError["NoName"] = 1] = "NoName";
    EContactSavingError[EContactSavingError["Other"] = 2] = "Other";
})(EContactSavingError = exports.EContactSavingError || (exports.EContactSavingError = {}));
var LeadContacts = /** @class */ (function () {
    function LeadContacts(lead) {
        var _this = this;
        this.lead = lead;
        this.loading = false;
        this.errorLoading = false;
        this.providerId = null;
        this.all = [];
        this.creating = false;
        this.editing = false;
        this.saving = false;
        this.errorSaving = EContactSavingError.None;
        this.editedContacts = [];
        this.fetchLeadContacts = function (providerId) { return __awaiter(_this, void 0, void 0, function () {
            var service, contacts, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        this.loading = true;
                        this.errorLoading = false;
                        this.editing = false;
                        this.saving = false;
                        this.errorSaving = EContactSavingError.None;
                        this.providerId = providerId;
                        this.all = [];
                        return [4 /*yield*/, App_1.app.service('provider-contact')];
                    case 1:
                        service = _a.sent();
                        return [4 /*yield*/, service.find({
                                query: {
                                    providerId: providerId,
                                },
                            })];
                    case 2:
                        contacts = _a.sent();
                        this.all = contacts.data.map(function (contact) {
                            return {
                                id: contact.id,
                                providerId: contact.providerId,
                                firstName: contact.firstName || '',
                                middleName: contact.middleName || '',
                                lastName: contact.lastName || '',
                                title: contact.title || '',
                                officePhone: contact.officePhone || '',
                                mobilePhone: contact.mobilePhone || '',
                                fax: contact.fax || '',
                                emailAddress: contact.emailAddress || '',
                                default: contact.default ? true : false,
                                createdAt: contact.createdAt,
                                updatedAt: contact.updatedAt,
                            };
                        });
                        this.loading = false;
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.loading = false;
                        this.errorLoading = true;
                        console.error(err_1);
                        throw err_1;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.startEditingContacts = function () {
            _this.editing = true;
            _this.creating = false;
            _this.saving = false;
            _this.errorSaving = EContactSavingError.None;
            _this.editedContacts = _this.combined.map(function (contact, i) {
                return {
                    id: contact.id,
                    firstName: contact.firstName,
                    middleName: contact.middleName,
                    lastName: contact.lastName,
                    title: contact.title,
                    emailAddress: contact.emailAddress,
                    officePhone: contact.officePhone,
                    mobilePhone: contact.mobilePhone,
                    fax: contact.fax,
                    default: contact.default,
                    modified: false,
                };
            });
        };
        this.startCreatingNewContact = function () {
            _this.creating = true;
            _this.saving = false;
            _this.errorSaving = EContactSavingError.None;
            if (_this.createContact === null) {
                _this.editedContacts.push({
                    id: null,
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    title: '',
                    emailAddress: '',
                    officePhone: '',
                    mobilePhone: '',
                    fax: '',
                    default: _this.all.length > 0 ? false : true,
                    modified: false,
                });
            }
        };
        this.toggleDefaultContact = function (id, checked) {
            var editingIndex = _this.editedContactsIds.indexOf(id);
            if (editingIndex !== -1) {
                if (checked === false) {
                    _this.editedContacts[editingIndex].default = false;
                    _this.editedContacts[editingIndex].modified = true;
                }
                else {
                    _this.editedContacts.map(function (contact, i) {
                        if (editingIndex === i) {
                            if (_this.editedContacts[i].default !== true) {
                                _this.editedContacts[i].default = true;
                                _this.editedContacts[i].modified = true;
                            }
                        }
                        else {
                            if (_this.editedContacts[i].default !== false) {
                                _this.editedContacts[i].default = false;
                                _this.editedContacts[i].modified = true;
                            }
                        }
                    });
                }
            }
        };
        this.cancelEditingContacts = function () {
            _this.creating = false;
            _this.editing = false;
            _this.saving = false;
            _this.errorSaving = EContactSavingError.None;
            _this.editedContacts = [];
        };
        this.cancelCreatingNewContact = function () {
            _this.creating = false;
            if (_this.createContact !== null) {
                var index = _this.editedContactsIds.indexOf(null);
                if (index !== -1) {
                    _this.editedContacts = _this.editedContacts
                        .slice(0, index)
                        .concat(_this.editedContacts.slice(index + 1));
                }
            }
        };
        this.saveEditedContacts = function () { return __awaiter(_this, void 0, void 0, function () {
            var service_1, results, err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        this.saving = true;
                        this.errorSaving = EContactSavingError.None;
                        return [4 /*yield*/, App_1.app.service('provider-contact')];
                    case 1:
                        service_1 = _a.sent();
                        return [4 /*yield*/, this.editedContacts.map(function (contact, i) { return __awaiter(_this, void 0, void 0, function () {
                                var patch, index;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!contact.modified) return [3 /*break*/, 3];
                                            if (!(contact.id !== null && contact.firstName && contact.lastName)) return [3 /*break*/, 2];
                                            return [4 /*yield*/, service_1.patch(contact.id, {
                                                    firstName: contact.firstName.trim(),
                                                    middleName: contact.middleName.trim(),
                                                    lastName: contact.lastName.trim(),
                                                    title: contact.title.trim(),
                                                    officePhone: contact.officePhone.trim(),
                                                    mobilePhone: contact.mobilePhone.trim(),
                                                    fax: contact.fax.trim(),
                                                    emailAddress: contact.emailAddress.trim(),
                                                    default: contact.default,
                                                })];
                                        case 1:
                                            patch = _a.sent();
                                            index = this.allIds.indexOf(contact.id);
                                            if (index !== -1) {
                                                this.all[index].firstName = contact.firstName.trim();
                                                this.all[index].middleName = contact.middleName.trim();
                                                this.all[index].lastName = contact.lastName.trim();
                                                this.all[index].title = contact.title.trim();
                                                this.all[index].officePhone = contact.officePhone.trim();
                                                this.all[index].mobilePhone = contact.mobilePhone.trim();
                                                this.all[index].fax = contact.fax.trim();
                                                this.all[index].emailAddress = contact.emailAddress.trim();
                                                this.all[index].default = contact.default;
                                            }
                                            else {
                                                throw new Error('Contact does not exist');
                                            }
                                            return [2 /*return*/, patch];
                                        case 2:
                                            if (contact.id === null) {
                                                return [2 /*return*/, null];
                                            }
                                            else {
                                                throw new Error('Name is required');
                                            }
                                            _a.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 2:
                        results = _a.sent();
                        this.editing = false;
                        this.creating = false;
                        this.errorSaving = EContactSavingError.None;
                        this.editedContacts = [];
                        return [2 /*return*/, true];
                    case 3:
                        err_2 = _a.sent();
                        this.errorSaving =
                            typeof err_2.message !== 'undefined' && err_2.message === 'Name is required'
                                ? EContactSavingError.NoName
                                : EContactSavingError.Other;
                        console.error(err_2);
                        return [2 /*return*/, false];
                    case 4:
                        this.saving = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.saveNewContact = function () { return __awaiter(_this, void 0, void 0, function () {
            var service, post, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (!(this.providerId !== null &&
                            this.createContact.firstName &&
                            this.createContact.lastName)) return [3 /*break*/, 3];
                        this.saving = true;
                        this.errorSaving = EContactSavingError.None;
                        return [4 /*yield*/, App_1.app.service('provider-contact')];
                    case 1:
                        service = _a.sent();
                        return [4 /*yield*/, service.create({
                                providerId: this.providerId,
                                firstName: this.createContact.firstName.trim(),
                                middleName: this.createContact.middleName.trim(),
                                lastName: this.createContact.lastName.trim(),
                                title: this.createContact.title.trim(),
                                officePhone: this.createContact.officePhone.trim(),
                                mobilePhone: this.createContact.mobilePhone.trim(),
                                fax: this.createContact.fax.trim(),
                                emailAddress: this.createContact.emailAddress.trim(),
                                default: this.createContact.default,
                            })];
                    case 2:
                        post = _a.sent();
                        this.all.push(post);
                        this.saving = false;
                        this.creating = false;
                        this.errorSaving = EContactSavingError.None;
                        return [2 /*return*/, true];
                    case 3: throw new Error('Name is required');
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        err_3 = _a.sent();
                        this.saving = false;
                        this.errorSaving =
                            typeof err_3.message !== 'undefined' && err_3.message === 'Name is required'
                                ? EContactSavingError.NoName
                                : EContactSavingError.Other;
                        console.error(err_3);
                        return [2 /*return*/, err_3];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
    }
    Object.defineProperty(LeadContacts.prototype, "allIds", {
        get: function () {
            return this.all.map(function (contact) { return contact.id; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadContacts.prototype, "primary", {
        get: function () {
            return this.all.filter(function (contact) {
                return contact.default === true;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadContacts.prototype, "secondary", {
        get: function () {
            return this.all.filter(function (contact) {
                return contact.default === false;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadContacts.prototype, "combined", {
        get: function () {
            return this.primary.concat(this.secondary);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadContacts.prototype, "editedContactsIds", {
        get: function () {
            return this.editedContacts.map(function (contact) { return contact.id; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadContacts.prototype, "createContact", {
        get: function () {
            var newContactIndex = null;
            this.editedContacts.some(function (contact, i) {
                if (contact.id === null) {
                    newContactIndex = i;
                    return true;
                }
                return false;
            });
            return newContactIndex !== null
                ? this.editedContacts[newContactIndex]
                : null;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], LeadContacts.prototype, "loading", void 0);
    __decorate([
        mobx_1.observable
    ], LeadContacts.prototype, "errorLoading", void 0);
    __decorate([
        mobx_1.observable
    ], LeadContacts.prototype, "providerId", void 0);
    __decorate([
        mobx_1.observable
    ], LeadContacts.prototype, "all", void 0);
    __decorate([
        mobx_1.computed
    ], LeadContacts.prototype, "allIds", null);
    __decorate([
        mobx_1.computed
    ], LeadContacts.prototype, "primary", null);
    __decorate([
        mobx_1.computed
    ], LeadContacts.prototype, "secondary", null);
    __decorate([
        mobx_1.computed
    ], LeadContacts.prototype, "combined", null);
    __decorate([
        mobx_1.observable
    ], LeadContacts.prototype, "creating", void 0);
    __decorate([
        mobx_1.observable
    ], LeadContacts.prototype, "editing", void 0);
    __decorate([
        mobx_1.observable
    ], LeadContacts.prototype, "saving", void 0);
    __decorate([
        mobx_1.observable
    ], LeadContacts.prototype, "errorSaving", void 0);
    __decorate([
        mobx_1.observable
    ], LeadContacts.prototype, "editedContacts", void 0);
    __decorate([
        mobx_1.computed
    ], LeadContacts.prototype, "editedContactsIds", null);
    __decorate([
        mobx_1.computed
    ], LeadContacts.prototype, "createContact", null);
    __decorate([
        mobx_1.action
    ], LeadContacts.prototype, "fetchLeadContacts", void 0);
    __decorate([
        mobx_1.action
    ], LeadContacts.prototype, "startEditingContacts", void 0);
    __decorate([
        mobx_1.action
    ], LeadContacts.prototype, "startCreatingNewContact", void 0);
    __decorate([
        mobx_1.action
    ], LeadContacts.prototype, "toggleDefaultContact", void 0);
    __decorate([
        mobx_1.action
    ], LeadContacts.prototype, "cancelEditingContacts", void 0);
    __decorate([
        mobx_1.action
    ], LeadContacts.prototype, "cancelCreatingNewContact", void 0);
    __decorate([
        mobx_1.action
    ], LeadContacts.prototype, "saveEditedContacts", void 0);
    __decorate([
        mobx_1.action
    ], LeadContacts.prototype, "saveNewContact", void 0);
    return LeadContacts;
}());
exports.LeadContacts = LeadContacts;


/***/ }),

/***/ "./app/web/src/stores/LeadGroup.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
var provider_1 = __webpack_require__("./app/common/interfaces/provider.ts");
var LeadGroup = /** @class */ (function () {
    function LeadGroup(user, lead) {
        var _this = this;
        this.user = user;
        this.lead = lead;
        this.reactToLeadChange = mobx_1.reaction(function () { return _this.lead.openLeadId; }, function (leadId) {
            if (leadId !== null) {
                _this.fetchLeadGroups();
            }
        });
        this.reactToLeadDetailsChange = mobx_1.reaction(function () { return _this.lead.openLeadDetails; }, function (details) {
            if (details !== null) {
                if (details.providerGroup !== null &&
                    typeof details.providerGroup.id !== 'undefined' &&
                    details.providerGroup.id) {
                    _this.fetchLeadGroupDetails(details.providerGroup.id);
                }
                if (_this.groupDropownForLeadOfId !== details.databaseId) {
                    _this.changeBusinessGroupDropdown(details.databaseId, typeof details.providerGroup !== 'undefined' &&
                        details.providerGroup !== null &&
                        typeof details.providerGroup.name !== 'undefined'
                        ? details.providerGroup.name
                        : null);
                }
            }
        });
        this.openedGroup = null;
        this.modalStatus = provider_1.LeadGroupModalStatus.Closed;
        this.leadGroups = [];
        this.loading = false;
        this.showList = false;
        this.createNewGroup = '';
        this.groupListSearch = '';
        this.groupDropdown = [];
        this.groupDropownForLeadOfId = null;
        this.changeBusinessGroupDropdown = function (leadId, groupName) {
            if (groupName === void 0) { groupName = null; }
            _this.groupDropownForLeadOfId = leadId;
            if (groupName) {
                _this.groupDropdown = [
                    { value: 'remove', label: 'Remove from group "' + groupName + '"' },
                    { value: 'name', label: 'Keep in group "' + groupName + '"' },
                    { value: 'assign', label: 'Assign to different group' },
                ];
            }
            else {
                _this.groupDropdown = [
                    { value: 'name', label: 'No group' },
                    { value: 'assign', label: 'Assign to a group' },
                ];
            }
        };
        this.patchLeadGroup = function () { return __awaiter(_this, void 0, void 0, function () {
            var patchGroup, response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.loading = true;
                        patchGroup = App_1.app.service('provider-group');
                        return [4 /*yield*/, patchGroup.patch(1, {
                                name: 'Name #1',
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        err_1 = _a.sent();
                        console.error(err_1);
                        throw err_1;
                    case 3:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.fetchLeadGroupDetails = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var leadGroupDetails, response, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.loading = true;
                        leadGroupDetails = App_1.app.service('provider-group');
                        return [4 /*yield*/, leadGroupDetails.get(id)];
                    case 1:
                        response = _a.sent();
                        this.openedGroup = response;
                        return [2 /*return*/, response];
                    case 2:
                        err_2 = _a.sent();
                        console.error(err_2);
                        throw err_2;
                    case 3:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.fetchLeadGroups = function () { return __awaiter(_this, void 0, void 0, function () {
            var leadGroups, response, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.loading = true;
                        leadGroups = App_1.app.service('provider-group');
                        return [4 /*yield*/, leadGroups.find()];
                    case 1:
                        response = (_a.sent());
                        this.leadGroups = response.data;
                        return [2 /*return*/, response.data];
                    case 2:
                        err_3 = _a.sent();
                        console.error(err_3);
                        throw err_3;
                    case 3:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.createLeadGroup = function () { return __awaiter(_this, void 0, void 0, function () {
            var leadGroups, response, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        this.loading = true;
                        leadGroups = App_1.app.service('provider-group');
                        return [4 /*yield*/, leadGroups.create({
                                name: this.createNewGroup,
                            })];
                    case 1:
                        response = (_a.sent());
                        this.createNewGroup = '';
                        this.modalStatus = provider_1.LeadGroupModalStatus.OpenedOnGroupList;
                        return [4 /*yield*/, this.addLeadToGroup(response.id)];
                    case 2:
                        _a.sent();
                        this.lead.openLeadDetails.providerGroup = {
                            id: response.id,
                            name: response.name,
                        };
                        return [2 /*return*/, response];
                    case 3:
                        err_4 = _a.sent();
                        console.error(err_4);
                        throw err_4;
                    case 4:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.addLeadToGroup = function (groupId) { return __awaiter(_this, void 0, void 0, function () {
            var leadGroups, response, err_5;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.loading = true;
                        leadGroups = App_1.app.service('provider');
                        return [4 /*yield*/, leadGroups.patch(this.lead.openLeadId, {
                                groupId: groupId,
                            })];
                    case 1:
                        response = (_a.sent());
                        this.createNewGroup = '';
                        this.modalStatus = provider_1.LeadGroupModalStatus.Closed;
                        setTimeout(function () {
                            _this.groupListSearch = '';
                        }, 256);
                        this.lead.openLeadDetails.providerGroup = response.providerGroup
                            ? {
                                id: response.providerGroup.id,
                                name: response.providerGroup.name,
                            }
                            : null;
                        this.changeBusinessGroupDropdown(response.databaseId, response.providerGroup ? response.providerGroup.name : null);
                        return [2 /*return*/, response];
                    case 2:
                        err_5 = _a.sent();
                        console.error(err_5);
                        throw err_5;
                    case 3:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    }
    Object.defineProperty(LeadGroup.prototype, "groupSearchedResults", {
        // States search results
        get: function () {
            var searchQuery = this.groupListSearch.toLowerCase().trim();
            if (searchQuery.length > 0) {
                return this.leadGroups.filter(function (_a) {
                    var name = _a.name;
                    return name.toLowerCase().indexOf(searchQuery) !== -1;
                });
            }
            else {
                return this.leadGroups;
            }
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], LeadGroup.prototype, "openedGroup", void 0);
    __decorate([
        mobx_1.observable
    ], LeadGroup.prototype, "modalStatus", void 0);
    __decorate([
        mobx_1.observable
    ], LeadGroup.prototype, "leadGroups", void 0);
    __decorate([
        mobx_1.observable
    ], LeadGroup.prototype, "loading", void 0);
    __decorate([
        mobx_1.observable
    ], LeadGroup.prototype, "showList", void 0);
    __decorate([
        mobx_1.observable
    ], LeadGroup.prototype, "createNewGroup", void 0);
    __decorate([
        mobx_1.observable
    ], LeadGroup.prototype, "groupListSearch", void 0);
    __decorate([
        mobx_1.observable
    ], LeadGroup.prototype, "groupDropdown", void 0);
    __decorate([
        mobx_1.observable
    ], LeadGroup.prototype, "groupDropownForLeadOfId", void 0);
    __decorate([
        mobx_1.action
    ], LeadGroup.prototype, "changeBusinessGroupDropdown", void 0);
    __decorate([
        mobx_1.computed
    ], LeadGroup.prototype, "groupSearchedResults", null);
    __decorate([
        mobx_1.action
    ], LeadGroup.prototype, "patchLeadGroup", void 0);
    __decorate([
        mobx_1.action
    ], LeadGroup.prototype, "fetchLeadGroupDetails", void 0);
    __decorate([
        mobx_1.action
    ], LeadGroup.prototype, "fetchLeadGroups", void 0);
    __decorate([
        mobx_1.action
    ], LeadGroup.prototype, "createLeadGroup", void 0);
    __decorate([
        mobx_1.action
    ], LeadGroup.prototype, "addLeadToGroup", void 0);
    return LeadGroup;
}());
exports.LeadGroup = LeadGroup;


/***/ }),

/***/ "./app/web/src/stores/LeadPricing.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var pricing_1 = __webpack_require__("./app/common/interfaces/pricing.ts");
var accounting_1 = __webpack_require__("./node_modules/accounting/accounting.js");
// Store
var LeadPricing = /** @class */ (function () {
    function LeadPricing(lead, pricingRequest, user) {
        var _this = this;
        this.lead = lead;
        this.pricingRequest = pricingRequest;
        this.user = user;
        this.reactToOpenLeadIdChange = mobx_1.reaction(function () { return _this.lead.openLeadId; }, function (leadId) {
            if (leadId !== null) {
                _this.fetchAllItemsWithPricing();
                _this.fetchPendingPricingRequests();
            }
        });
        this.reactToOpenLeadGroupChange = mobx_1.reaction(function () { return _this.lead.openLeadGroup; }, function (group) {
            _this.fetchGroupPricing();
        });
        this.pricingItemListFetched = false;
        this.pricingItemListLoading = false;
        this.statusOfUpdatingPricesForAllItems = pricing_1.StatusOfNewPricingRequest.None;
        this.allPricingItemListLoading = false;
        this.allPricingItemList = [];
        this.groupPricingItemListLoading = false;
        this.groupPricingItemList = [];
        this.modifiedAnyItemPricing = false;
        this.modifiedAnyGroupPricing = false;
        this.pricingSearch = '';
        this.leadItemsPricingModal = false;
        this.changeApprovedPriceOfLeadsItem = function (itemId, price) {
            var itemIndex = _this.allPricingItemListIds.indexOf(itemId);
            if (itemIndex !== -1) {
                _this.allPricingItemList[itemIndex].customerPrice = price;
                _this.modifiedAnyItemPricing = true;
            }
        };
        this.changeGroupPriceOfLeadsItem = function (itemId, price) {
            var itemIndex = _this.allPricingItemListIds.indexOf(itemId);
            if (itemIndex !== -1) {
                var itemCode = _this.allPricingItemList[itemIndex].itemcode;
                var itemCodeIndex = _this.groupPricingItemListItemCodes.indexOf(itemCode);
                if (itemCodeIndex !== -1) {
                    _this.groupPricingItemList[itemCodeIndex].price = price;
                }
                else {
                    _this.groupPricingItemList.push({
                        itemcode: itemCode,
                        price: price,
                    });
                }
                _this.modifiedAnyGroupPricing = true;
            }
        };
        this.newRequest = {
            showModal: false,
            status: pricing_1.StatusOfNewPricingRequest.None,
            providerId: null,
            items: [],
            isNew: true,
            id: null,
            descriptionHtml: '',
            descriptionText: '',
        };
        this.itemId = null;
        this.showCreatePricingRequestModal = function (requestIsNew) {
            _this.newRequest.showModal = true;
            _this.pricingSearch = '';
            if (typeof requestIsNew !== 'undefined') {
                _this.newRequest.isNew = requestIsNew;
            }
        };
        this.hideCreatePricingRequestModal = function () {
            _this.newRequest.showModal = false;
            _this.newRequest.status = pricing_1.StatusOfNewPricingRequest.None;
            _this.newRequest.providerId = null;
            _this.newRequest.items = [];
            _this.newRequest.isNew = true;
            _this.newRequest.id = null;
            _this.newRequest.descriptionHtml = '';
            _this.newRequest.descriptionText = '';
        };
        this.addItemToPriceRequest = function (item) {
            var itemInPriceRequest = _this.newRequestItemsIds.indexOf(item.id);
            if (itemInPriceRequest < 0) {
                _this.newRequest.items.push({
                    id: item.id,
                    isNew: true,
                    itemcode: item.itemcode,
                    itemname: item.itemname || '',
                    price: item.price,
                    approvedPrice: typeof item.approvedPrice !== 'undefined' &&
                        item.approvedPrice !== null
                        ? accounting_1.formatNumber(item.approvedPrice, 2)
                        : null,
                    expectedPrice: null,
                    volume: null,
                });
            }
        };
        this.removeItemFromPriceRequest = function (itemId) {
            var itemInPriceRequest = _this.newRequestItemsIds.indexOf(itemId);
            if (itemInPriceRequest !== -1) {
                _this.newRequest.items.splice(itemInPriceRequest, 1);
            }
        };
        this.priceRequestItemChangePrice = function (itemId, price) {
            var itemIndex = _this.newRequestItemsIds.indexOf(itemId);
            if (itemIndex !== -1) {
                _this.newRequest.items[itemIndex].expectedPrice = price;
            }
        };
        this.priceRequestItemChangeVolume = function (itemId, volume) {
            var itemIndex = _this.newRequestItemsIds.indexOf(itemId);
            if (itemIndex !== -1) {
                _this.newRequest.items[itemIndex].volume = volume;
            }
        };
        this.priceRequestItemChangeAprovedPrice = function (itemId, approvedPrice) {
            var itemIndex = _this.newRequestItemsIds.indexOf(itemId);
            if (itemIndex !== -1) {
                _this.newRequest.items[itemIndex].approvedPrice = approvedPrice;
            }
        };
        this.fetchAllItemsWithPricing = function () { return __awaiter(_this, void 0, void 0, function () {
            var query, itemsPricingService, itemsPricing, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, 6, 7]);
                        if (!(this.lead.openLeadId !== null)) return [3 /*break*/, 3];
                        this.allPricingItemListLoading = true;
                        query = {
                            $limit: 999999,
                            $skip: 0,
                        };
                        if (this.lead.openLeadId !== null) {
                            query = __assign({}, query, { providerId: this.lead.openLeadId });
                        }
                        if (this.lead.openLeadDetails !== null &&
                            typeof this.lead.openLeadDetails.cardcode !== 'undefined' &&
                            this.lead.openLeadDetails.cardcode !== null) {
                            query = __assign({}, query, { cardcode: this.lead.openLeadDetails.cardcode });
                        }
                        return [4 /*yield*/, App_1.app.service('item')];
                    case 1:
                        itemsPricingService = _a.sent();
                        return [4 /*yield*/, itemsPricingService.find({ query: query })];
                    case 2:
                        itemsPricing = _a.sent();
                        this.allPricingItemList = itemsPricing.data;
                        return [2 /*return*/, itemsPricing.data];
                    case 3: return [2 /*return*/, this.allPricingItemList];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        err_1 = _a.sent();
                        console.error(err_1);
                        return [2 /*return*/, err_1];
                    case 6:
                        this.allPricingItemListLoading = false;
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        // Fetch group pricing
        this.fetchGroupPricing = function () { return __awaiter(_this, void 0, void 0, function () {
            var groupPricingService, groupPricing, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, 6, 7]);
                        if (!(this.lead.openLeadGroup !== null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, App_1.app.service('group-price')];
                    case 1:
                        groupPricingService = _a.sent();
                        return [4 /*yield*/, groupPricingService.find({
                                query: {
                                    groupId: this.lead.openLeadDetails.providerGroup.id,
                                    $skip: 0,
                                    $limit: 999999,
                                },
                            })];
                    case 2:
                        groupPricing = _a.sent();
                        this.groupPricingItemList = groupPricing.data;
                        return [3 /*break*/, 4];
                    case 3:
                        this.groupPricingItemList = [];
                        _a.label = 4;
                    case 4: return [2 /*return*/, true];
                    case 5:
                        err_2 = _a.sent();
                        console.error(err_2);
                        return [2 /*return*/, err_2];
                    case 6:
                        this.groupPricingItemListLoading = false;
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        // Create pricing request
        this.createPricingRequest = function () { return __awaiter(_this, void 0, void 0, function () {
            var itemErrorsCount_1, items, pricingService, pricingItem, err_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        this.newRequest.status = pricing_1.StatusOfNewPricingRequest.Saving;
                        itemErrorsCount_1 = 0;
                        items = this.newRequest.items.map(function (item) {
                            if (typeof item.expectedPrice === 'undefined' ||
                                item.expectedPrice === null ||
                                typeof item.volume === 'undefined' ||
                                item.volume === null) {
                                itemErrorsCount_1++;
                            }
                            return {
                                itemcode: item.itemcode,
                                volume: accounting_1.unformat(item.volume),
                                expectedPrice: accounting_1.unformat(item.expectedPrice),
                                approvedPrice: accounting_1.unformat(item.approvedPrice),
                            };
                        });
                        if (itemErrorsCount_1 > 0) {
                            this.newRequest.status =
                                pricing_1.StatusOfNewPricingRequest.ErrorNotAllItemsHaveQuantityAndPrice;
                            throw new Error('Not all items have all required information provided by the user');
                        }
                        return [4 /*yield*/, App_1.app.service('pricing-request')];
                    case 1:
                        pricingService = _a.sent();
                        return [4 /*yield*/, pricingService.create({
                                item: items,
                                note: this.newRequest.descriptionText,
                                providerId: this.lead.openLeadId,
                            })];
                    case 2:
                        pricingItem = _a.sent();
                        return [4 /*yield*/, this.fetchPendingPricingRequests()];
                    case 3:
                        _a.sent();
                        this.newRequest.status = pricing_1.StatusOfNewPricingRequest.Success;
                        setTimeout(function () {
                            _this.hideCreatePricingRequestModal();
                        }, 512);
                        this.pricingRequest.fetchAllOpenPricingRequests();
                        return [2 /*return*/, pricingItem];
                    case 4:
                        err_3 = _a.sent();
                        if (this.newRequest.status === pricing_1.StatusOfNewPricingRequest.Saving) {
                            this.newRequest.status = pricing_1.StatusOfNewPricingRequest.ErrorTryAgain;
                        }
                        console.error(err_3);
                        return [2 /*return*/, err_3];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        // Create item by provider id
        this.patchPricingRequest = function () { return __awaiter(_this, void 0, void 0, function () {
            var items, pricingService, pricingItem, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        items = this.newRequest.items.map(function (item) { return ({
                            id: item.isNew ? null : item.id,
                            itemcode: item.itemcode,
                            volume: item.volume,
                            expectedPrice: item.expectedPrice,
                            approvedPrice: item.approvedPrice,
                        }); });
                        pricingService = App_1.app.service('pricing-request');
                        return [4 /*yield*/, pricingService.patch(this.newRequest.id, {
                                item: items,
                                note: this.newRequest.descriptionText,
                                providerId: this.newRequest.providerId,
                            })];
                    case 1:
                        pricingItem = _a.sent();
                        // Return pricing search item data
                        return [2 /*return*/, pricingItem];
                    case 2:
                        err_4 = _a.sent();
                        console.error(err_4);
                        return [2 /*return*/, err_4];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        // Aprove price item
        this.removePriceItem = function (index) {
            try {
                // Remove single id
                var removeItem = void 0;
                if (_this.newRequest.items[index].id) {
                    var pricingService = App_1.app.service("pricing-request-line");
                    removeItem = pricingService.remove(_this.newRequest.items[index].id);
                }
                _this.newRequest.items.splice(index, 1);
                return true;
            }
            catch (err) {
                console.error(err);
                return err;
            }
        };
        // Fetch item by provider id
        this.fetchPriceRequestByProviderId = function () { return __awaiter(_this, void 0, void 0, function () {
            var pricingService, pricingItem, response, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        pricingService = App_1.app.service('pricing-request');
                        return [4 /*yield*/, pricingService.find({
                                query: {
                                    providerId: this.lead.openLeadId,
                                    $limit: 1,
                                    $skip: 0,
                                },
                            })];
                    case 1:
                        pricingItem = _a.sent();
                        response = { item: [] };
                        if (!(pricingItem.data.length > 0)) return [3 /*break*/, 3];
                        this.newRequest.id = pricingItem.data[0].id;
                        this.newRequest.descriptionText = pricingItem.data[0].note;
                        this.newRequest.descriptionHtml = pricingItem.data[0].note;
                        this.newRequest.isNew = false;
                        return [4 /*yield*/, pricingService.get(pricingItem.data[0].id)];
                    case 2:
                        response = _a.sent();
                        _a.label = 3;
                    case 3: 
                    // this.newRequest.items = response.item;
                    return [2 /*return*/, response.item];
                    case 4:
                        err_5 = _a.sent();
                        console.error(err_5);
                        return [2 /*return*/, err_5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        // Fetch item by provider id
        this.clearAll = function () {
            _this.newRequest = {
                showModal: false,
                status: pricing_1.StatusOfNewPricingRequest.None,
                providerId: null,
                isNew: true,
                items: [],
                id: null,
                descriptionHtml: '',
                descriptionText: '',
            };
        };
        // Pending pricing requests
        this.loadingPendingPricingRequests = false;
        this.fetchedPendingPricingRequests = false;
        this.pendingPricingRequests = [];
        // Fetch pending pricing requests
        this.fetchPendingPricingRequests = function () { return __awaiter(_this, void 0, void 0, function () {
            var pricingRequestService, pendingPricingRequests, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        this.loadingPendingPricingRequests = true;
                        return [4 /*yield*/, App_1.app.service('pricing-request')];
                    case 1:
                        pricingRequestService = _a.sent();
                        return [4 /*yield*/, pricingRequestService.find({
                                query: {
                                    providerId: this.lead.openLeadId,
                                    complete: false,
                                    $skip: 0,
                                    $limit: 99999,
                                    $sort: {
                                        updatedAt: -1,
                                    },
                                },
                            })];
                    case 2:
                        pendingPricingRequests = _a.sent();
                        this.fetchedPendingPricingRequests = true;
                        this.pendingPricingRequests = pendingPricingRequests.data;
                        return [2 /*return*/, pendingPricingRequests.data];
                    case 3:
                        err_6 = _a.sent();
                        console.error(err_6);
                        return [2 /*return*/, err_6];
                    case 4:
                        this.loadingPendingPricingRequests = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.saveUpdatedProviderAndGroupPrices = function () { return __awaiter(_this, void 0, void 0, function () {
            var pricingUpdateService, groupItemsPricing, allItems, pricingRequestService, err_7;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 9, , 10]);
                        this.statusOfUpdatingPricesForAllItems = pricing_1.StatusOfNewPricingRequest.Saving;
                        if (!(this.leadItemsPricingModalData !== null)) return [3 /*break*/, 8];
                        return [4 /*yield*/, App_1.app.service('pricing-update')];
                    case 1:
                        pricingUpdateService = _a.sent();
                        if (!(this.leadItemsPricingModalData.groupPricesModified &&
                            this.leadItemsPricingModalData.providerGroup !== null)) return [3 /*break*/, 3];
                        groupItemsPricing = this.allPricingItemList.map(function (item) {
                            var itemGroupIndex = _this.groupPricingItemListItemCodes.indexOf(item.itemcode);
                            var itemGroupPrice = itemGroupIndex !== -1
                                ? _this.groupPricingItemList[itemGroupIndex].price.trim() !== ''
                                    ? accounting_1.unformat(_this.groupPricingItemList[itemGroupIndex].price)
                                    : null
                                : null;
                            return {
                                id: item.id,
                                itemcode: item.itemcode,
                                price: itemGroupPrice !== null ? itemGroupPrice : 0,
                                delete: itemGroupPrice === null,
                            };
                        });
                        return [4 /*yield*/, pricingUpdateService.create({
                                groupId: this.leadItemsPricingModalData.providerGroup.id,
                                item: groupItemsPricing,
                            })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!this.leadItemsPricingModalData.approvedPricesModified) return [3 /*break*/, 8];
                        allItems = this.allPricingItemList.map(function (item) {
                            var itemPrice = item.customerPrice !== null
                                ? typeof item.customerPrice === 'string' &&
                                    item.customerPrice.trim() !== ''
                                    ? accounting_1.unformat(item.customerPrice)
                                    : null
                                : typeof item.customerPrice === 'number'
                                    ? item.customerPrice
                                    : null;
                            return {
                                id: item.id,
                                itemcode: item.itemcode,
                                volume: 1,
                                expectedPrice: itemPrice !== null ? itemPrice : null,
                                approvedPrice: itemPrice !== null ? itemPrice : null,
                                price: itemPrice !== null ? itemPrice : null,
                                delete: itemPrice === null,
                            };
                        });
                        if (!this.leadItemsPricingModalData.cardcode) return [3 /*break*/, 5];
                        return [4 /*yield*/, pricingUpdateService.create({
                                cardcode: this.leadItemsPricingModalData.cardcode,
                                item: allItems,
                            })];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 5:
                        allItems = allItems.filter(function (item) { return item.delete === false; });
                        return [4 /*yield*/, App_1.app.service('pricing-request')];
                    case 6:
                        pricingRequestService = _a.sent();
                        return [4 /*yield*/, pricingRequestService.create({
                                item: allItems,
                                note: null,
                                providerId: this.lead.openLeadId,
                                complete: true,
                            })];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8:
                        this.statusOfUpdatingPricesForAllItems =
                            pricing_1.StatusOfNewPricingRequest.Success;
                        this.fetchAllItemsWithPricing();
                        this.fetchGroupPricing();
                        setTimeout(function () {
                            _this.leadItemsPricingModal = false;
                            _this.statusOfUpdatingPricesForAllItems = pricing_1.StatusOfNewPricingRequest.None;
                        }, 1024);
                        return [2 /*return*/, true];
                    case 9:
                        err_7 = _a.sent();
                        this.statusOfUpdatingPricesForAllItems =
                            pricing_1.StatusOfNewPricingRequest.ErrorTryAgain;
                        console.error(err_7);
                        return [2 /*return*/, err_7];
                    case 10: return [2 /*return*/];
                }
            });
        }); };
    }
    Object.defineProperty(LeadPricing.prototype, "allPricingItemListLength", {
        get: function () {
            return this.allPricingItemList.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadPricing.prototype, "allPricingItemListIds", {
        get: function () {
            return this.allPricingItemList.map(function (item) { return item.id; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadPricing.prototype, "groupPricingItemListLength", {
        get: function () {
            return this.groupPricingItemList.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadPricing.prototype, "groupPricingItemListItemCodes", {
        get: function () {
            return this.groupPricingItemList.map(function (group) { return group.itemcode; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadPricing.prototype, "pricingItemSearchResults", {
        get: function () {
            var _this = this;
            if (this.pricingSearch) {
                var regex_1 = new RegExp(/-|%|,|\.|\/|\s/gi);
                var query_1 = this.pricingSearch.toLowerCase().replace(regex_1, '');
                return this.allPricingItemList.filter(function (item, i) {
                    if (_this.newRequestItemsIds.indexOf(item.id) < 0) {
                        var itemcode = item.itemcode.toLowerCase().replace(regex_1, '');
                        var itemname = item.itemname.toLowerCase().replace(regex_1, '');
                        return (itemcode.indexOf(query_1) !== -1 || itemname.indexOf(query_1) !== -1);
                    }
                    else {
                        return false;
                    }
                });
            }
            else {
                return this.allPricingItemList.filter(function (item, i) {
                    return _this.newRequestItemsIds.indexOf(item.id) < 0;
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadPricing.prototype, "pricingItemSearchResultsLength", {
        get: function () {
            return this.pricingItemSearchResults.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadPricing.prototype, "leadItemsPricingModalData", {
        get: function () {
            var now = moment().format();
            return this.lead.openLeadId !== null && this.lead.openLeadDetails !== null
                ? {
                    id: 0,
                    cardcode: this.lead.openLeadDetails.cardcode,
                    item: this.allPricingItemList.map(function (item) { return ({
                        pricingRequestId: 0,
                        id: item.id,
                        itemcode: item.itemcode,
                        itemData: {
                            itemname: item.itemname,
                            price: accounting_1.formatNumber(item.price, 2),
                        },
                        volume: accounting_1.formatNumber(item.volume, 0),
                        approved: item.approved ? true : false,
                        approvedByUserId: item.approvedByUserId,
                        approvedPrice: typeof item.customerPrice === 'number'
                            ? accounting_1.formatNumber(item.customerPrice, 2)
                            : item.customerPrice,
                        expectedPrice: accounting_1.formatNumber(item.expectedPrice, 2),
                    }); }),
                    groupItems: this.groupPricingItemList,
                    providerGroup: this.lead.openLeadDetails.providerGroup !== null &&
                        typeof this.lead.openLeadDetails.providerGroup.id !== 'undefined' &&
                        this.lead.openLeadDetails.providerGroup.id !== null &&
                        typeof this.lead.openLeadDetails.providerGroup.name !==
                            'undefined' &&
                        this.lead.openLeadDetails.providerGroup.name !== null
                        ? {
                            id: this.lead.openLeadDetails.providerGroup.id,
                            name: this.lead.openLeadDetails.providerGroup.name,
                        }
                        : null,
                    note: null,
                    complete: true,
                    createdAt: now,
                    updatedAt: now,
                    createdByUserId: this.user.id,
                    createdByUser: {
                        id: this.user.id,
                        name: this.user.name,
                        username: this.user.username,
                        email: this.user.email,
                    },
                    providerId: this.lead.openLeadId,
                    provider: {
                        id: this.lead.openLeadId,
                        providerId: this.lead.openLeadDetails.providerId,
                        dba: this.lead.openLeadDetails.dba,
                        legalBusName: this.lead.openLeadDetails.legalBusName,
                    },
                    approvedPricesModified: this.modifiedAnyItemPricing,
                    groupPricesModified: this.modifiedAnyGroupPricing,
                }
                : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadPricing.prototype, "newRequestItemsIds", {
        get: function () {
            return this.newRequest.items.map(function (item) { return item.id; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadPricing.prototype, "newRequestItemsLength", {
        get: function () {
            return this.newRequestItemsIds.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadPricing.prototype, "pricingSearchLength", {
        get: function () {
            return this.pricingSearch.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LeadPricing.prototype, "pricingRequestLength", {
        get: function () {
            return this.pricingSearch.length;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], LeadPricing.prototype, "pricingItemListFetched", void 0);
    __decorate([
        mobx_1.observable
    ], LeadPricing.prototype, "pricingItemListLoading", void 0);
    __decorate([
        mobx_1.observable
    ], LeadPricing.prototype, "statusOfUpdatingPricesForAllItems", void 0);
    __decorate([
        mobx_1.observable
    ], LeadPricing.prototype, "allPricingItemListLoading", void 0);
    __decorate([
        mobx_1.observable
    ], LeadPricing.prototype, "allPricingItemList", void 0);
    __decorate([
        mobx_1.computed
    ], LeadPricing.prototype, "allPricingItemListLength", null);
    __decorate([
        mobx_1.computed
    ], LeadPricing.prototype, "allPricingItemListIds", null);
    __decorate([
        mobx_1.observable
    ], LeadPricing.prototype, "groupPricingItemListLoading", void 0);
    __decorate([
        mobx_1.observable
    ], LeadPricing.prototype, "groupPricingItemList", void 0);
    __decorate([
        mobx_1.computed
    ], LeadPricing.prototype, "groupPricingItemListLength", null);
    __decorate([
        mobx_1.computed
    ], LeadPricing.prototype, "groupPricingItemListItemCodes", null);
    __decorate([
        mobx_1.observable
    ], LeadPricing.prototype, "modifiedAnyItemPricing", void 0);
    __decorate([
        mobx_1.observable
    ], LeadPricing.prototype, "modifiedAnyGroupPricing", void 0);
    __decorate([
        mobx_1.observable
    ], LeadPricing.prototype, "pricingSearch", void 0);
    __decorate([
        mobx_1.computed
    ], LeadPricing.prototype, "pricingItemSearchResults", null);
    __decorate([
        mobx_1.computed
    ], LeadPricing.prototype, "pricingItemSearchResultsLength", null);
    __decorate([
        mobx_1.observable
    ], LeadPricing.prototype, "leadItemsPricingModal", void 0);
    __decorate([
        mobx_1.computed
    ], LeadPricing.prototype, "leadItemsPricingModalData", null);
    __decorate([
        mobx_1.action
    ], LeadPricing.prototype, "changeApprovedPriceOfLeadsItem", void 0);
    __decorate([
        mobx_1.action
    ], LeadPricing.prototype, "changeGroupPriceOfLeadsItem", void 0);
    __decorate([
        mobx_1.observable
    ], LeadPricing.prototype, "newRequest", void 0);
    __decorate([
        mobx_1.computed
    ], LeadPricing.prototype, "newRequestItemsIds", null);
    __decorate([
        mobx_1.computed
    ], LeadPricing.prototype, "newRequestItemsLength", null);
    __decorate([
        mobx_1.observable
    ], LeadPricing.prototype, "itemId", void 0);
    __decorate([
        mobx_1.computed
    ], LeadPricing.prototype, "pricingSearchLength", null);
    __decorate([
        mobx_1.computed
    ], LeadPricing.prototype, "pricingRequestLength", null);
    __decorate([
        mobx_1.action
    ], LeadPricing.prototype, "showCreatePricingRequestModal", void 0);
    __decorate([
        mobx_1.action
    ], LeadPricing.prototype, "hideCreatePricingRequestModal", void 0);
    __decorate([
        mobx_1.action
    ], LeadPricing.prototype, "addItemToPriceRequest", void 0);
    __decorate([
        mobx_1.action
    ], LeadPricing.prototype, "removeItemFromPriceRequest", void 0);
    __decorate([
        mobx_1.action
    ], LeadPricing.prototype, "priceRequestItemChangePrice", void 0);
    __decorate([
        mobx_1.action
    ], LeadPricing.prototype, "priceRequestItemChangeVolume", void 0);
    __decorate([
        mobx_1.action
    ], LeadPricing.prototype, "priceRequestItemChangeAprovedPrice", void 0);
    __decorate([
        mobx_1.action
    ], LeadPricing.prototype, "fetchAllItemsWithPricing", void 0);
    __decorate([
        mobx_1.action
    ], LeadPricing.prototype, "fetchGroupPricing", void 0);
    __decorate([
        mobx_1.action
    ], LeadPricing.prototype, "createPricingRequest", void 0);
    __decorate([
        mobx_1.action
    ], LeadPricing.prototype, "patchPricingRequest", void 0);
    __decorate([
        mobx_1.action
    ], LeadPricing.prototype, "removePriceItem", void 0);
    __decorate([
        mobx_1.action
    ], LeadPricing.prototype, "fetchPriceRequestByProviderId", void 0);
    __decorate([
        mobx_1.action
    ], LeadPricing.prototype, "clearAll", void 0);
    __decorate([
        mobx_1.observable
    ], LeadPricing.prototype, "loadingPendingPricingRequests", void 0);
    __decorate([
        mobx_1.observable
    ], LeadPricing.prototype, "fetchedPendingPricingRequests", void 0);
    __decorate([
        mobx_1.observable
    ], LeadPricing.prototype, "pendingPricingRequests", void 0);
    __decorate([
        mobx_1.action
    ], LeadPricing.prototype, "fetchPendingPricingRequests", void 0);
    __decorate([
        mobx_1.action
    ], LeadPricing.prototype, "saveUpdatedProviderAndGroupPrices", void 0);
    return LeadPricing;
}());
exports.LeadPricing = LeadPricing;


/***/ }),

/***/ "./app/web/src/stores/LeadResources.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
var resources_1 = __webpack_require__("./app/common/interfaces/resources.ts");
// Store
var LeadResources = /** @class */ (function () {
    function LeadResources(lead) {
        var _this = this;
        this.lead = lead;
        this.loading = false;
        this.all = [];
        this.editing = false;
        this.uploadFiles = {
            files: null,
            status: resources_1.UploadStatus.None,
        };
        this.startEditing = function () {
            _this.editing = true;
        };
        this.stopEditing = function () {
            _this.editing = false;
        };
        this.fetchLeadResources = function (providerId) { return __awaiter(_this, void 0, void 0, function () {
            var service, files, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.loading = true;
                        service = App_1.app.service('provider-file');
                        return [4 /*yield*/, service.find({
                                query: {
                                    providerId: typeof providerId !== 'undefined'
                                        ? providerId
                                        : this.lead.openLeadId,
                                    $sort: {
                                        updatedAt: 1,
                                    },
                                },
                            })];
                    case 1:
                        files = _a.sent();
                        this.all = files.data;
                        return [2 /*return*/, files];
                    case 2:
                        err_1 = _a.sent();
                        this.all = [];
                        console.error(err_1);
                        return [2 /*return*/, err_1];
                    case 3:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.uploadLeadResources = function () { return __awaiter(_this, void 0, void 0, function () {
            var service_1, files_1, filesCount_1, parsedFiles_1, parsedFilesCount_1, reader_1, resolve_1, err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, App_1.app.service('provider-file-upload')];
                    case 1:
                        service_1 = _a.sent();
                        this.uploadFiles.status = resources_1.UploadStatus.Saving;
                        files_1 = this.uploadFiles.files;
                        filesCount_1 = files_1.length;
                        parsedFiles_1 = [];
                        parsedFilesCount_1 = 0;
                        reader_1 = new FileReader();
                        resolve_1 = function () { return __awaiter(_this, void 0, void 0, function () {
                            var i, upload;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        i = 0;
                                        _a.label = 1;
                                    case 1:
                                        if (!(i < parsedFilesCount_1)) return [3 /*break*/, 4];
                                        return [4 /*yield*/, service_1.create({
                                                uri: parsedFiles_1[i].data,
                                                providerId: this.lead.openLeadId,
                                                fileName: parsedFiles_1[i].name,
                                            })];
                                    case 2:
                                        upload = _a.sent();
                                        _a.label = 3;
                                    case 3:
                                        i++;
                                        return [3 /*break*/, 1];
                                    case 4:
                                        this.uploadFiles.status = resources_1.UploadStatus.None;
                                        this.uploadFiles.files = null;
                                        this.fetchLeadResources();
                                        return [2 /*return*/, true];
                                }
                            });
                        }); };
                        reader_1.onloadend = function () {
                            parsedFiles_1.push({
                                data: reader_1.result,
                                name: files_1[parsedFilesCount_1].name,
                            });
                            parsedFilesCount_1++;
                            if (parsedFilesCount_1 < filesCount_1) {
                                reader_1.readAsDataURL(files_1[parsedFilesCount_1]);
                            }
                            else {
                                resolve_1();
                            }
                        };
                        reader_1.readAsDataURL(files_1[0]);
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        this.uploadFiles.status = resources_1.UploadStatus.Error;
                        this.uploadFiles.files = null;
                        console.error(err_2);
                        return [2 /*return*/, err_2];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.handleUploadFilesChange = function (files) {
            _this.uploadFiles.files = files;
            _this.uploadLeadResources();
        };
        this.removeLeadResource = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var service, removal, indexOfResource, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        service = App_1.app.service('provider-file');
                        return [4 /*yield*/, service.remove(id)];
                    case 1:
                        removal = _a.sent();
                        if (this.all.length <= 1) {
                            this.all = [];
                            this.editing = false;
                        }
                        else {
                            indexOfResource = this.allIds.indexOf(id);
                            if (indexOfResource !== -1) {
                                this.all = this.all
                                    .slice(0, indexOfResource)
                                    .concat(this.all.slice(indexOfResource + 1));
                            }
                        }
                        return [2 /*return*/, removal];
                    case 2:
                        err_3 = _a.sent();
                        console.error(err_3);
                        return [2 /*return*/, err_3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    }
    Object.defineProperty(LeadResources.prototype, "allIds", {
        get: function () {
            return this.all.map(function (resource) { return resource.id; });
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], LeadResources.prototype, "loading", void 0);
    __decorate([
        mobx_1.observable
    ], LeadResources.prototype, "all", void 0);
    __decorate([
        mobx_1.computed
    ], LeadResources.prototype, "allIds", null);
    __decorate([
        mobx_1.observable
    ], LeadResources.prototype, "editing", void 0);
    __decorate([
        mobx_1.observable
    ], LeadResources.prototype, "uploadFiles", void 0);
    __decorate([
        mobx_1.action
    ], LeadResources.prototype, "startEditing", void 0);
    __decorate([
        mobx_1.action
    ], LeadResources.prototype, "stopEditing", void 0);
    __decorate([
        mobx_1.action
    ], LeadResources.prototype, "fetchLeadResources", void 0);
    __decorate([
        mobx_1.action
    ], LeadResources.prototype, "uploadLeadResources", void 0);
    __decorate([
        mobx_1.action
    ], LeadResources.prototype, "handleUploadFilesChange", void 0);
    __decorate([
        mobx_1.action
    ], LeadResources.prototype, "removeLeadResource", void 0);
    return LeadResources;
}());
exports.LeadResources = LeadResources;


/***/ }),

/***/ "./app/web/src/stores/Leads.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var debounce_1 = __webpack_require__("./node_modules/lodash-es/debounce.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var user_1 = __webpack_require__("./app/common/interfaces/user.ts");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
// Interfaces
var provider_1 = __webpack_require__("./app/common/interfaces/provider.ts");
// Enumerables
var LeadEditableProperties;
(function (LeadEditableProperties) {
    LeadEditableProperties["dba"] = "dba";
    LeadEditableProperties["legalBusName"] = "legalBusName";
    LeadEditableProperties["providerId"] = "providerId";
    LeadEditableProperties["plAddress1"] = "plAddress1";
    LeadEditableProperties["plAddress2"] = "plAddress2";
    LeadEditableProperties["plCity"] = "plCity";
    LeadEditableProperties["plState"] = "plState";
    LeadEditableProperties["plZipcode"] = "plZipcode";
    LeadEditableProperties["plPhone"] = "plPhone";
    LeadEditableProperties["plExt"] = "plExt";
    LeadEditableProperties["plFax"] = "plFax";
    LeadEditableProperties["plEmail"] = "plEmail";
})(LeadEditableProperties = exports.LeadEditableProperties || (exports.LeadEditableProperties = {}));
var CreateLeadProperties;
(function (CreateLeadProperties) {
    CreateLeadProperties["providerId"] = "providerId";
    CreateLeadProperties["legalBusName"] = "legalBusName";
    CreateLeadProperties["dba"] = "dba";
})(CreateLeadProperties = exports.CreateLeadProperties || (exports.CreateLeadProperties = {}));
var LeadsSearchFilter;
(function (LeadsSearchFilter) {
    LeadsSearchFilter["All"] = "";
    LeadsSearchFilter["Name"] = "name";
    LeadsSearchFilter["Phone"] = "phone";
    LeadsSearchFilter["State"] = "state";
    LeadsSearchFilter["Area"] = "areacode";
    LeadsSearchFilter["City"] = "city";
    LeadsSearchFilter["Notes"] = "notes";
})(LeadsSearchFilter = exports.LeadsSearchFilter || (exports.LeadsSearchFilter = {}));
// Store
var Leads = /** @class */ (function () {
    function Leads(user) {
        var _this = this;
        this.user = user;
        // Reset search and load initial bunch of leads when user changes
        this.reactToLoggedUserChange = mobx_1.reaction(function () { return _this.user.id; }, function (id) {
            if (id !== null) {
                _this.leadsToDisplayByQuery.clear();
                _this.allLeads = [];
                _this.leadsSearch = '';
                _this.fetchLeads();
                _this.setLeadsDashboardView();
            }
        });
        // Static values
        this.LEADS_OR_NOTES_PER_PAGE_LIMIT = 99;
        // Limit and offset / skip
        this.leadsFetchLimit = this
            .LEADS_OR_NOTES_PER_PAGE_LIMIT;
        this.leadsFetchOffset = 0;
        // Leads dashboard view
        this.leadsDashboardView = provider_1.EDashboardView.Grid;
        // All leads
        this.modalStatus = provider_1.CreateLeadModalStatus.Closed;
        this.allLeads = [];
        this.leadsToDisplayByQuery = mobx_1.observable.map();
        // Providers search
        this.loadedDueToSearch = -1;
        this.leadsSearch = '';
        this.leadsSearchFilter = LeadsSearchFilter.All;
        this.leadsFilterByActivityTypeId = null;
        this.leadsFilterByActivityDate = {
            from: null,
            to: null,
            noActivity: false,
        };
        this.lastLeadId = 0;
        this.lastNoteId = 0;
        // Notes search
        this.notesFetchLimit = this
            .LEADS_OR_NOTES_PER_PAGE_LIMIT;
        this.notesFetchOffset = 0;
        this.notesSearchQuery = '';
        this.allNotes = [];
        this.notesToDisplayByQuery = mobx_1.observable.map();
        // Provider types and dispenser classes
        this.providerTypes = {
            lastFetchTimestamp: 0,
            list: [],
        };
        this.providerDispenserClasses = {
            lastFetchTimestamp: 0,
            list: [],
        };
        this.newLead = {
            status: provider_1.CreateNewLeadStatus.None,
            providerId: '',
            legalBusName: '',
            dba: '',
        };
        this.reactToSearchQueryChange = mobx_1.reaction(function () { return _this.leadsSearch; }, function (query) {
            _this.leadsFetchOffset = 0;
            _this.fetchLeadsDebounced();
        });
        this.reactToNotesSearchQueryChange = mobx_1.reaction(function () { return _this.notesSearchQuery; }, function (query) {
            _this.notesFetchOffset = 0;
            _this.fetchNotesDebounced();
        });
        this.reactToSearchFilterChange = mobx_1.reaction(function () { return _this.leadsSearchFilter; }, function (filter) {
            _this.leadsFetchOffset = 0;
            _this.notesFetchOffset = 0;
            if (filter === LeadsSearchFilter.Notes) {
                _this.fetchNotes();
            }
            else {
                _this.fetchLeads();
            }
        });
        this.reactToSearchFilterByActivityTypeChange = mobx_1.reaction(function () { return _this.leadsFilterByActivityTypeId; }, function (id) {
            _this.leadsFetchOffset = 0;
            _this.fetchLeadsDebounced();
        });
        this.reactToSearchFilterByActivityDateChange = mobx_1.reaction(function () { return _this.leadsFilterByActivityDate; }, function (date) {
            _this.leadsFetchOffset = 0;
            _this.fetchLeadsDebounced();
        });
        this.fetchLeadsDebounced = function () {
            _this.fetchLeads();
        };
        this.fetchNotesDebounced = function () {
            _this.fetchNotes();
        };
        // Fetch all leads based on search query
        this.fetchLeads = function () { return __awaiter(_this, void 0, void 0, function () {
            var key, data, leadsService, leadsInfo, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = this.leadsQueryKey.slice();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        // Create query key and indicate loading
                        if (!this.leadsToDisplayByQuery.has(key)) {
                            this.leadsToDisplayByQuery.set(key, {
                                lastFetchTimestamp: 0,
                                firstFetch: true,
                                isLoading: true,
                                leadsIds: [],
                                totalLeads: 0,
                            });
                        }
                        else {
                            data = this.leadsToDisplayByQuery.get(key);
                            if (data.lastFetchTimestamp > Date.now() - 60 * 1000 * 5) {
                                return [2 /*return*/, this.leadsToDisplayDetails];
                            }
                            this.leadsToDisplayByQuery.set(key, __assign({}, data, { isLoading: true }));
                        }
                        leadsService = App_1.app.service('provider');
                        return [4 /*yield*/, leadsService.find({
                                query: this.leadsInfoFetchApiQuery,
                            })];
                    case 2:
                        leadsInfo = _a.sent();
                        // Update all leads state
                        leadsInfo.data.forEach(function (lead) {
                            var index = _this.allLeadsIds.indexOf(lead.databaseId);
                            if (index !== -1) {
                                _this.allLeads[index] = lead;
                            }
                            else {
                                _this.allLeads.push(lead);
                            }
                        });
                        // Update state
                        this.leadsToDisplayByQuery.set(key, {
                            lastFetchTimestamp: Date.now(),
                            isLoading: false,
                            firstFetch: false,
                            totalLeads: leadsInfo.total,
                            leadsIds: leadsInfo.data.map(function (lead) { return lead.databaseId; }),
                        });
                        // Return leads data
                        return [2 /*return*/, leadsInfo.data];
                    case 3:
                        err_1 = _a.sent();
                        if (this.leadsToDisplayByQuery.has(key)) {
                            this.leadsToDisplayByQuery.set(key, __assign({}, this.leadsToDisplayByQuery.get(key), { isLoading: false }));
                        }
                        console.error(err_1);
                        return [2 /*return*/, err_1];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // Search across all notes
        this.fetchNotes = function () { return __awaiter(_this, void 0, void 0, function () {
            var key, data, notesSearchService, notesSearchResults, err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = this.notesQueryKey.slice();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        // Create notes key and indicate loading
                        if (!this.notesToDisplayByQuery.has(key)) {
                            this.notesToDisplayByQuery.set(key, {
                                lastFetchTimestamp: 0,
                                firstFetch: true,
                                isLoading: true,
                                notesIds: [],
                                totalNotes: 0,
                            });
                        }
                        else {
                            data = this.notesToDisplayByQuery.get(key);
                            if (data.lastFetchTimestamp > Date.now() - 60 * 1000 * 5) {
                                return [2 /*return*/, this.notesToDisplayDetails];
                            }
                            this.notesToDisplayByQuery.set(key, __assign({}, data, { isLoading: true }));
                        }
                        notesSearchService = App_1.app.service('comment-search');
                        return [4 /*yield*/, notesSearchService.find({
                                query: this.notesFetchApiQuery,
                            })];
                    case 2:
                        notesSearchResults = _a.sent();
                        // Update all leads state
                        notesSearchResults.data.forEach(function (note) {
                            var index = _this.allNotesIds.indexOf(note.id);
                            if (index !== -1) {
                                _this.allNotes[index] = note;
                            }
                            else {
                                _this.allNotes.push(note);
                            }
                        });
                        // Update state
                        this.notesToDisplayByQuery.set(key, {
                            isLoading: false,
                            firstFetch: false,
                            lastFetchTimestamp: Date.now(),
                            totalNotes: notesSearchResults.total,
                            notesIds: notesSearchResults.data.map(function (note) { return note.id; }),
                        });
                        // Return leads data
                        return [2 /*return*/, notesSearchResults.data];
                    case 3:
                        err_2 = _a.sent();
                        if (this.notesToDisplayByQuery.has(key)) {
                            this.notesToDisplayByQuery.set(key, __assign({}, this.notesToDisplayByQuery.get(key), { isLoading: false }));
                        }
                        console.error(err_2);
                        return [2 /*return*/, err_2];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // Load more leads as user scrolls
        this.createNewLead = function () { return __awaiter(_this, void 0, void 0, function () {
            var errorProviderIdRequired, errorLegalBusNameRequired, _a, providerId, legalBusName, dba, createLead, newLead_1, err_3;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        errorProviderIdRequired = 'Provider ID is required';
                        errorLegalBusNameRequired = 'Legal bussiness name is required';
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        this.newLead.status = provider_1.CreateNewLeadStatus.Saving;
                        _a = this.newLead, providerId = _a.providerId, legalBusName = _a.legalBusName, dba = _a.dba;
                        if (providerId.trim().length <= 0) {
                            this.newLead.status = provider_1.CreateNewLeadStatus.ProviderIdRequired;
                            throw new Error(errorProviderIdRequired);
                        }
                        if (legalBusName.trim().length <= 0) {
                            this.newLead.status = provider_1.CreateNewLeadStatus.LegalBusNameRequired;
                            throw new Error(errorLegalBusNameRequired);
                        }
                        createLead = App_1.app.service('provider');
                        return [4 /*yield*/, createLead.create({
                                providerId: providerId.trim(),
                                legalBusName: legalBusName.trim(),
                                dba: dba.trim().length > 0 ? dba.trim() : null,
                                slpcode: this.user.userType === user_1.UserType.SalesRep && this.user.slpcode !== null
                                    ? this.user.slpcode
                                    : null,
                                createdManually: true,
                            })];
                    case 2:
                        newLead_1 = _b.sent();
                        this.newLead.status = provider_1.CreateNewLeadStatus.Success;
                        setTimeout(function () {
                            _this.modalStatus = provider_1.CreateLeadModalStatus.Closed;
                        }, 128);
                        setTimeout(function () {
                            _this.newLead.providerId = '';
                            _this.newLead.legalBusName = '';
                            _this.newLead.dba = '';
                            _this.newLead.status = provider_1.CreateNewLeadStatus.None;
                            // Redirect to lead only if user will have permissions to access newly created lead
                            if (_this.user.userType !== user_1.UserType.SalesManager ||
                                _this.user.slpcode !== null) {
                                App_1.browserHistory.push('/sales/lead/' + newLead_1.databaseId);
                            }
                        }, 512);
                        return [2 /*return*/, true];
                    case 3:
                        err_3 = _b.sent();
                        if (this.newLead.status === provider_1.CreateNewLeadStatus.Saving) {
                            this.newLead.status = provider_1.CreateNewLeadStatus.ServerSideError;
                        }
                        console.error(err_3);
                        return [2 /*return*/, err_3];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.changeLeadsPage = function (page) {
            _this.leadsFetchOffset =
                page * _this.LEADS_OR_NOTES_PER_PAGE_LIMIT -
                    _this.LEADS_OR_NOTES_PER_PAGE_LIMIT;
            _this.fetchLeads();
        };
        this.changeNotesPage = function (page) {
            _this.notesFetchOffset =
                page * _this.LEADS_OR_NOTES_PER_PAGE_LIMIT -
                    _this.LEADS_OR_NOTES_PER_PAGE_LIMIT;
            _this.fetchNotes();
        };
        this.fetchProviderTypes = function () { return __awaiter(_this, void 0, void 0, function () {
            var now, service, response, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        now = Date.now();
                        if (this.providerTypes.lastFetchTimestamp > now - 1000 * 60 * 30) {
                            return [2 /*return*/, true];
                        }
                        return [4 /*yield*/, App_1.app.service('provider-type')];
                    case 1:
                        service = _a.sent();
                        return [4 /*yield*/, service.find({
                                query: {
                                    $limit: 999999,
                                },
                            })];
                    case 2:
                        response = (_a.sent());
                        this.providerTypes.lastFetchTimestamp = now;
                        this.providerTypes.list = response.data;
                        return [2 /*return*/, true];
                    case 3:
                        error_1 = _a.sent();
                        setTimeout(function () {
                            _this.fetchProviderTypes();
                        }, 512);
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.fetchDispenserClasses = function () { return __awaiter(_this, void 0, void 0, function () {
            var now, service, response, error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        now = Date.now();
                        if (this.providerDispenserClasses.lastFetchTimestamp >
                            now - 1000 * 60 * 30) {
                            return [2 /*return*/, true];
                        }
                        return [4 /*yield*/, App_1.app.service('provider-dispenser')];
                    case 1:
                        service = _a.sent();
                        return [4 /*yield*/, service.find({
                                query: {
                                    $limit: 999999,
                                },
                            })];
                    case 2:
                        response = (_a.sent());
                        this.providerDispenserClasses.lastFetchTimestamp = now;
                        this.providerDispenserClasses.list = response.data;
                        return [2 /*return*/, true];
                    case 3:
                        error_2 = _a.sent();
                        setTimeout(function () {
                            _this.fetchDispenserClasses();
                        }, 512);
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.returnProviderTypeOrDispenserClass = function (code, select) {
            if (typeof select === 'undefined' || code === null) {
                return null;
            }
            var index = -1;
            if (select === 'dispenser') {
                _this.providerDispenserClasses.list.some(function (dispenserClass, dispenserClassIndex) {
                    if (dispenserClass.code === code) {
                        index = dispenserClassIndex;
                        return true;
                    }
                    return false;
                });
            }
            else if (select === 'type') {
                _this.providerTypes.list.some(function (type, typeIndex) {
                    if (type.code === code) {
                        index = typeIndex;
                        return true;
                    }
                    return false;
                });
            }
            if (index === -1) {
                return null;
            }
            return select === 'dispenser'
                ? _this.providerDispenserClasses.list[index]
                : select === 'type'
                    ? _this.providerTypes.list[index]
                    : null;
        };
        this.setLeadsDashboardView = function (view) {
            var viewKey = 'LeadsDashboardView';
            if (view) {
                view = _this.verifyLeadsDashboardViewAccuracy(view);
            }
            else {
                var local = localStorage.getItem('LeadsDashboardView') || provider_1.EDashboardView.Grid;
                local = _this.verifyLeadsDashboardViewAccuracy(local);
                view = local;
            }
            localStorage.setItem(viewKey, view);
            _this.leadsDashboardView = view;
        };
        this.verifyLeadsDashboardViewAccuracy = function (view) {
            var isAccurate = false;
            Object.keys(provider_1.EDashboardView).some(function (key) {
                if (provider_1.EDashboardView[key] === view) {
                    isAccurate = true;
                    return true;
                }
                return false;
            });
            if (!isAccurate) {
                view = provider_1.EDashboardView.Grid;
            }
            return view;
        };
        this.fetchLeadsDebounced = debounce_1.default(this.fetchLeadsDebounced, 300);
        this.fetchNotesDebounced = debounce_1.default(this.fetchNotesDebounced, 300);
    }
    Object.defineProperty(Leads.prototype, "allLeadsIds", {
        get: function () {
            return this.allLeads.map(function (lead) { return lead.databaseId; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Leads.prototype, "leadsToDisplay", {
        get: function () {
            var key = this.leadsQueryKey;
            if (!key || !this.leadsToDisplayByQuery.has(key)) {
                return {
                    totalLeads: 0,
                    lastFetchTimestamp: 0,
                    firstFetch: true,
                    isLoading: true,
                    leadsIds: [],
                };
            }
            return this.leadsToDisplayByQuery.get(key);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Leads.prototype, "leadsToDisplayIds", {
        get: function () {
            return this.leadsToDisplay.leadsIds;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Leads.prototype, "leadsToDisplayCount", {
        get: function () {
            return this.leadsToDisplayIds.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Leads.prototype, "leadsToDisplayDetails", {
        get: function () {
            var _this = this;
            return this.leadsToDisplayIds.reduce(function (leads, leadId) {
                var index = _this.allLeadsIds.indexOf(leadId);
                if (index !== -1) {
                    leads.push(_this.allLeads[index]);
                }
                return leads;
            }, []);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Leads.prototype, "notesToDisplayIds", {
        get: function () {
            return this.notesToDisplay.notesIds;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Leads.prototype, "notesToDisplayCount", {
        get: function () {
            return this.notesToDisplayIds.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Leads.prototype, "notesToDisplayDetails", {
        get: function () {
            var _this = this;
            return this.notesToDisplayIds.reduce(function (notes, noteId) {
                var index = _this.allNotesIds.indexOf(noteId);
                if (index !== -1) {
                    notes.push(_this.allNotes[index]);
                }
                return notes;
            }, []);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Leads.prototype, "allNotesIds", {
        get: function () {
            return this.allNotes.map(function (note) { return note.id; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Leads.prototype, "notesToDisplay", {
        get: function () {
            var key = this.notesQueryKey;
            if (!key || !this.notesToDisplayByQuery.has(key)) {
                return {
                    totalNotes: 0,
                    lastFetchTimestamp: 0,
                    firstFetch: true,
                    isLoading: true,
                    notesIds: [],
                };
            }
            return this.notesToDisplayByQuery.get(key);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Leads.prototype, "leadsInfoFetchApiQuery", {
        get: function () {
            var query = {
                $limit: this.leadsFetchLimit,
                $skip: this.leadsFetchOffset,
            };
            if (this.leadsSearch.trim().length > 0) {
                query = __assign({}, query, { search: this.leadsSearch });
            }
            if (this.leadsSearchFilter !== LeadsSearchFilter.All &&
                this.leadsSearchFilter !== LeadsSearchFilter.Notes) {
                query = __assign({}, query, { searchType: this.leadsSearchFilter });
            }
            if (this.leadsFilterByActivityTypeId !== null) {
                query = __assign({}, query, { lastCompletedActivityTypeId: this.leadsFilterByActivityTypeId });
            }
            if (this.leadsFilterByActivityDate !== null &&
                this.leadsFilterByActivityDate.from !== null) {
                query = __assign({}, query, { fromDate: this.leadsFilterByActivityDate.from });
            }
            if (this.leadsFilterByActivityDate !== null &&
                this.leadsFilterByActivityDate.to !== null) {
                query = __assign({}, query, { toDate: this.leadsFilterByActivityDate.to });
            }
            if (this.leadsFilterByActivityDate !== null &&
                this.leadsFilterByActivityDate.noActivity === true) {
                query = __assign({}, query, { noActivity: true });
            }
            return query;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Leads.prototype, "leadsQueryKey", {
        get: function () {
            var query = '?limit=' +
                this.leadsInfoFetchApiQuery.$limit +
                '&offset=' +
                this.leadsInfoFetchApiQuery.$skip +
                '&search=' +
                (this.leadsInfoFetchApiQuery.search
                    ? this.leadsInfoFetchApiQuery.search
                    : '') +
                '&searchType=' +
                (this.leadsInfoFetchApiQuery.searchType || '') +
                '&lastActivityTypeId=' +
                (this.leadsInfoFetchApiQuery.lastCompletedActivityTypeId
                    ? this.leadsInfoFetchApiQuery.lastCompletedActivityTypeId
                    : '') +
                '&noActivity=' +
                (this.leadsInfoFetchApiQuery.noActivity ? '1' : '0') +
                '&fromDate=' +
                (this.leadsInfoFetchApiQuery.fromDate
                    ? this.leadsInfoFetchApiQuery.fromDate
                    : '') +
                '&toDate=' +
                (this.leadsInfoFetchApiQuery.toDate
                    ? this.leadsInfoFetchApiQuery.toDate
                    : '');
            return query;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Leads.prototype, "notesFetchApiQuery", {
        get: function () {
            var query = {
                $limit: this.notesFetchLimit,
                $skip: this.notesFetchOffset,
                search: '',
            };
            if (this.leadsSearchFilter === LeadsSearchFilter.Notes) {
                query = __assign({}, query, { search: this.notesSearchQuery });
            }
            return query;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Leads.prototype, "notesQueryKey", {
        get: function () {
            return ('?limit=' +
                this.notesFetchApiQuery.$limit +
                '&offset=' +
                this.notesFetchApiQuery.$skip +
                '&search=' +
                (this.notesFetchApiQuery.search || ''));
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "leadsFetchLimit", void 0);
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "leadsFetchOffset", void 0);
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "leadsDashboardView", void 0);
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "modalStatus", void 0);
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "allLeads", void 0);
    __decorate([
        mobx_1.computed
    ], Leads.prototype, "allLeadsIds", null);
    __decorate([
        mobx_1.computed
    ], Leads.prototype, "leadsToDisplay", null);
    __decorate([
        mobx_1.computed
    ], Leads.prototype, "leadsToDisplayIds", null);
    __decorate([
        mobx_1.computed
    ], Leads.prototype, "leadsToDisplayCount", null);
    __decorate([
        mobx_1.computed
    ], Leads.prototype, "leadsToDisplayDetails", null);
    __decorate([
        mobx_1.computed
    ], Leads.prototype, "notesToDisplayIds", null);
    __decorate([
        mobx_1.computed
    ], Leads.prototype, "notesToDisplayCount", null);
    __decorate([
        mobx_1.computed
    ], Leads.prototype, "notesToDisplayDetails", null);
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "loadedDueToSearch", void 0);
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "leadsSearch", void 0);
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "leadsSearchFilter", void 0);
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "leadsFilterByActivityTypeId", void 0);
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "leadsFilterByActivityDate", void 0);
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "lastLeadId", void 0);
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "lastNoteId", void 0);
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "notesFetchLimit", void 0);
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "notesFetchOffset", void 0);
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "notesSearchQuery", void 0);
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "allNotes", void 0);
    __decorate([
        mobx_1.computed
    ], Leads.prototype, "allNotesIds", null);
    __decorate([
        mobx_1.computed
    ], Leads.prototype, "notesToDisplay", null);
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "providerTypes", void 0);
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "providerDispenserClasses", void 0);
    __decorate([
        mobx_1.computed
    ], Leads.prototype, "leadsInfoFetchApiQuery", null);
    __decorate([
        mobx_1.computed
    ], Leads.prototype, "leadsQueryKey", null);
    __decorate([
        mobx_1.computed
    ], Leads.prototype, "notesFetchApiQuery", null);
    __decorate([
        mobx_1.computed
    ], Leads.prototype, "notesQueryKey", null);
    __decorate([
        mobx_1.observable
    ], Leads.prototype, "newLead", void 0);
    __decorate([
        mobx_1.action
    ], Leads.prototype, "fetchLeads", void 0);
    __decorate([
        mobx_1.action
    ], Leads.prototype, "fetchNotes", void 0);
    __decorate([
        mobx_1.action
    ], Leads.prototype, "createNewLead", void 0);
    __decorate([
        mobx_1.action
    ], Leads.prototype, "changeLeadsPage", void 0);
    __decorate([
        mobx_1.action
    ], Leads.prototype, "changeNotesPage", void 0);
    __decorate([
        mobx_1.action
    ], Leads.prototype, "fetchProviderTypes", void 0);
    __decorate([
        mobx_1.action
    ], Leads.prototype, "fetchDispenserClasses", void 0);
    __decorate([
        mobx_1.action
    ], Leads.prototype, "setLeadsDashboardView", void 0);
    return Leads;
}());
exports.Leads = Leads;


/***/ }),

/***/ "./app/web/src/stores/Modal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
// Store
var Modal = /** @class */ (function () {
    function Modal() {
        var _this = this;
        this.modal = false;
        this.openModal = function () {
            _this.modal = true;
        };
        this.closeModal = function () {
            _this.modal = false;
        };
    }
    __decorate([
        mobx_1.observable
    ], Modal.prototype, "modal", void 0);
    __decorate([
        mobx_1.action
    ], Modal.prototype, "openModal", void 0);
    __decorate([
        mobx_1.action
    ], Modal.prototype, "closeModal", void 0);
    return Modal;
}());
exports.Modal = Modal;


/***/ }),

/***/ "./app/web/src/stores/OrderPad.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
var OrderPad = /** @class */ (function () {
    function OrderPad() {
        var _this = this;
        this.isOrderPadInfoLoading = false;
        this.orderPadUrl = null;
        this.fetchOrderPadInfo = function () { return __awaiter(_this, void 0, void 0, function () {
            var service, orderPadInfo, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (this.orderPadUrl !== null) {
                            return [2 /*return*/, true];
                        }
                        this.isOrderPadInfoLoading = true;
                        service = App_1.app.service('order-pad');
                        return [4 /*yield*/, service.find()];
                    case 1:
                        orderPadInfo = _a.sent();
                        this.orderPadUrl = orderPadInfo.url;
                        this.isOrderPadInfoLoading = false;
                        return [2 /*return*/, true];
                    case 2:
                        error_1 = _a.sent();
                        setTimeout(function () {
                            _this.fetchOrderPadInfo();
                        }, 1000);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    }
    __decorate([
        mobx_1.observable
    ], OrderPad.prototype, "isOrderPadInfoLoading", void 0);
    __decorate([
        mobx_1.observable
    ], OrderPad.prototype, "orderPadUrl", void 0);
    __decorate([
        mobx_1.action
    ], OrderPad.prototype, "fetchOrderPadInfo", void 0);
    return OrderPad;
}());
exports.OrderPad = OrderPad;


/***/ }),

/***/ "./app/web/src/stores/OrderPadSales.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var accounting_1 = __webpack_require__("./node_modules/accounting/accounting.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
var CollectionsFetchStatus;
(function (CollectionsFetchStatus) {
    CollectionsFetchStatus[CollectionsFetchStatus["None"] = 0] = "None";
    CollectionsFetchStatus[CollectionsFetchStatus["Loading"] = 1] = "Loading";
    CollectionsFetchStatus[CollectionsFetchStatus["Error"] = 2] = "Error";
})(CollectionsFetchStatus = exports.CollectionsFetchStatus || (exports.CollectionsFetchStatus = {}));
var OrderPadSales = /** @class */ (function () {
    function OrderPadSales() {
        var _this = this;
        this.MS_TO_INVALIDATE = 1000 * 60 * 30;
        this.isSalesDataLoading = false;
        this.lastSalesDataFetchTimestamp = 0;
        this.salesData = null;
        this.showCollectionsModal = false;
        this.collectionsMonthsFetchStatus = CollectionsFetchStatus.None;
        this.collectionsMonthsData = [];
        this.collectionsDetailedData = [];
        this.toggleCollectionsModal = function (show) {
            _this.showCollectionsModal =
                typeof show === 'boolean' ? show : !_this.showCollectionsModal;
        };
        this.fetchSalesData = function () { return __awaiter(_this, void 0, void 0, function () {
            var service, repSales, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (this.salesData !== null &&
                            this.lastSalesDataFetchTimestamp < Date.now() - this.MS_TO_INVALIDATE) {
                            return [2 /*return*/, true];
                        }
                        this.isSalesDataLoading = true;
                        service = App_1.app.service('rep-sales');
                        return [4 /*yield*/, service.find()];
                    case 1:
                        repSales = _a.sent();
                        this.salesData = {
                            salesToday: repSales.Today ? accounting_1.unformat(repSales.Today) : 0,
                            salesThisWeek: repSales.ThisWeek ? accounting_1.unformat(repSales.ThisWeek) : 0,
                            salesThisMonth: repSales.ThisMonth ? accounting_1.unformat(repSales.ThisMonth) : 0,
                            collectionsThisMonth: repSales.ReceiptAmt
                                ? accounting_1.unformat(repSales.ReceiptAmt)
                                : 0,
                        };
                        this.lastSalesDataFetchTimestamp = Date.now();
                        this.isSalesDataLoading = false;
                        return [2 /*return*/, true];
                    case 2:
                        error_1 = _a.sent();
                        setTimeout(function () {
                            _this.fetchSalesData();
                        }, 1000);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.fetchMonthlyCollections = function () { return __awaiter(_this, void 0, void 0, function () {
            var repCollections;
            return __generator(this, function (_a) {
                try {
                    this.collectionsMonthsFetchStatus = CollectionsFetchStatus.Loading;
                    repCollections = [];
                    this.collectionsMonthsData = repCollections.map(function (collection) { return ({
                        key: collection.year + '-' + collection.month,
                        year: collection.year,
                        month: collection.month,
                        amount: collection.total,
                    }); });
                    this.collectionsMonthsFetchStatus = CollectionsFetchStatus.None;
                    return [2 /*return*/, true];
                }
                catch (error) {
                    if (this.collectionsMonthsData.length > 0) {
                        this.collectionsMonthsFetchStatus = CollectionsFetchStatus.None;
                        return [2 /*return*/, true];
                    }
                    this.collectionsMonthsFetchStatus = CollectionsFetchStatus.Error;
                    throw error;
                }
                return [2 /*return*/];
            });
        }); };
        this.fetchDetailedCollectionsForMonth = function (key) { return __awaiter(_this, void 0, void 0, function () {
            var index_1, payments, index_2;
            return __generator(this, function (_a) {
                try {
                    index_1 = -1;
                    this.collectionsDetailedDataKeys.some(function (dataKey, dataIndex) {
                        if (dataKey === key) {
                            index_1 = dataIndex;
                            return true;
                        }
                        return false;
                    });
                    if (index_1 === -1) {
                        this.collectionsDetailedData.push({
                            key: key,
                            fetchLastTimestamp: 0,
                            fetchStatus: CollectionsFetchStatus.None,
                            payments: [],
                        });
                        index_1 = this.collectionsDetailedData.length - 1;
                    }
                    this.collectionsDetailedData[index_1].fetchStatus =
                        CollectionsFetchStatus.Loading;
                    payments = [];
                    this.collectionsDetailedData[index_1].fetchStatus =
                        CollectionsFetchStatus.None;
                    this.collectionsDetailedData[index_1].fetchLastTimestamp = Date.now();
                    this.collectionsDetailedData[index_1].payments = payments;
                    return [2 /*return*/, true];
                }
                catch (error) {
                    index_2 = -1;
                    this.collectionsDetailedDataKeys.some(function (dataKey, dataIndex) {
                        if (dataKey === key) {
                            index_2 = dataIndex;
                            return true;
                        }
                        return false;
                    });
                    if (index_2 !== -1) {
                        if (this.collectionsDetailedData[index_2].payments.length > 0) {
                            this.collectionsDetailedData[index_2].fetchStatus =
                                CollectionsFetchStatus.None;
                            return [2 /*return*/, true];
                        }
                        this.collectionsDetailedData[index_2].fetchStatus =
                            CollectionsFetchStatus.Error;
                    }
                    throw error;
                }
                return [2 /*return*/];
            });
        }); };
    }
    Object.defineProperty(OrderPadSales.prototype, "collectionsDetailedDataKeys", {
        get: function () {
            return this.collectionsDetailedData.map(function (data) { return data.key; });
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], OrderPadSales.prototype, "isSalesDataLoading", void 0);
    __decorate([
        mobx_1.observable
    ], OrderPadSales.prototype, "lastSalesDataFetchTimestamp", void 0);
    __decorate([
        mobx_1.observable
    ], OrderPadSales.prototype, "salesData", void 0);
    __decorate([
        mobx_1.observable
    ], OrderPadSales.prototype, "showCollectionsModal", void 0);
    __decorate([
        mobx_1.observable
    ], OrderPadSales.prototype, "collectionsMonthsFetchStatus", void 0);
    __decorate([
        mobx_1.observable
    ], OrderPadSales.prototype, "collectionsMonthsData", void 0);
    __decorate([
        mobx_1.observable
    ], OrderPadSales.prototype, "collectionsDetailedData", void 0);
    __decorate([
        mobx_1.computed
    ], OrderPadSales.prototype, "collectionsDetailedDataKeys", null);
    __decorate([
        mobx_1.action
    ], OrderPadSales.prototype, "toggleCollectionsModal", void 0);
    __decorate([
        mobx_1.action
    ], OrderPadSales.prototype, "fetchSalesData", void 0);
    __decorate([
        mobx_1.action
    ], OrderPadSales.prototype, "fetchMonthlyCollections", void 0);
    __decorate([
        mobx_1.action
    ], OrderPadSales.prototype, "fetchDetailedCollectionsForMonth", void 0);
    return OrderPadSales;
}());
exports.OrderPadSales = OrderPadSales;


/***/ }),

/***/ "./app/web/src/stores/PricingRequest.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var accounting_1 = __webpack_require__("./node_modules/accounting/accounting.js");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
var pricing_1 = __webpack_require__("./app/common/interfaces/pricing.ts");
var PricingRequest = /** @class */ (function () {
    function PricingRequest(user) {
        var _this = this;
        this.user = user;
        // React to user change
        this.reactToUserChange = mobx_1.reaction(function () { return _this.user.id; }, function (id) {
            if (id !== null) {
                _this.fetchAllOpenPricingRequests();
            }
        });
        // Pricing requests
        this.loadingPricingRequests = false;
        this.pricingRequests = [];
        // Fetch all open pricing requests
        this.fetchAllOpenPricingRequests = function () { return __awaiter(_this, void 0, void 0, function () {
            var pricingRequestApi, pricingRequestFind, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        this.loadingPricingRequests = true;
                        return [4 /*yield*/, App_1.app.service('pricing-request')];
                    case 1:
                        pricingRequestApi = _a.sent();
                        return [4 /*yield*/, pricingRequestApi.find({
                                query: {
                                    $limit: 999999,
                                    $skip: 0,
                                    complete: 0,
                                    $sort: {
                                        createdAt: 1,
                                    },
                                },
                            })];
                    case 2:
                        pricingRequestFind = _a.sent();
                        this.pricingRequests = pricingRequestFind.data;
                        return [2 /*return*/, pricingRequestFind.data];
                    case 3:
                        err_1 = _a.sent();
                        console.error(err_1);
                        return [2 /*return*/, err_1];
                    case 4:
                        this.loadingPricingRequests = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        // Single pricing request
        this.loadingSinglePricingRequest = false;
        this.statusOfSinglePricingRequestApproval = pricing_1.StatusOfNewPricingRequest.None;
        this.singlePricingRequest = null;
        // Fetch details of single pricing request
        this.fetchSinglePricingRequest = function (requestId) { return __awaiter(_this, void 0, void 0, function () {
            var pricingRequestApi, pricingRequest, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        this.loadingSinglePricingRequest = true;
                        return [4 /*yield*/, App_1.app.service('pricing-request')];
                    case 1:
                        pricingRequestApi = _a.sent();
                        return [4 /*yield*/, pricingRequestApi.get(requestId)];
                    case 2:
                        pricingRequest = _a.sent();
                        this.singlePricingRequest = __assign({}, pricingRequest, { groupItems: [], providerGroup: null, approvedPricesModified: false, groupPricesModified: false });
                        return [2 /*return*/, pricingRequest];
                    case 3:
                        err_2 = _a.sent();
                        console.error(err_2);
                        return [2 /*return*/, err_2];
                    case 4:
                        this.loadingSinglePricingRequest = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        // Change approved price of single loaded pricing request
        this.changeApprovedPriceOfSinglePricingRequest = function (itemId, price) {
            var itemsIds = _this.singlePricingRequest !== null &&
                _this.singlePricingRequest.item !== null
                ? _this.singlePricingRequest.item.map(function (i) { return i.id; })
                : [];
            var itemIndex = itemsIds.indexOf(itemId);
            if (itemIndex !== -1) {
                _this.singlePricingRequest.item[itemIndex].approvedPrice = price;
            }
            if (_this.singlePricingRequest) {
                _this.singlePricingRequest.approvedPricesModified = true;
            }
        };
        // Reset details of single pricing request
        this.resetSinglePricingRequest = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    this.loadingSinglePricingRequest = false;
                    this.singlePricingRequest = null;
                    return [2 /*return*/, true];
                }
                catch (err) {
                    console.error(err);
                    return [2 /*return*/, false];
                }
                return [2 /*return*/];
            });
        }); };
        // Save changes to approve prices of items in single request
        this.saveSinglePricingRequestItemApprovedPricesChanges = function () { return __awaiter(_this, void 0, void 0, function () {
            var pricingRequestItemService_1, allApprovedPricesUpdated, err_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        this.statusOfSinglePricingRequestApproval =
                            pricing_1.StatusOfNewPricingRequest.Saving;
                        return [4 /*yield*/, App_1.app.service('pricing-request-line')];
                    case 1:
                        pricingRequestItemService_1 = _a.sent();
                        return [4 /*yield*/, this.singlePricingRequest.item.map(function (item, i) { return __awaiter(_this, void 0, void 0, function () {
                                var itemApprovedPrice;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            itemApprovedPrice = accounting_1.unformat(item.approvedPrice);
                                            if (!(item.approvedPrice.trim() !== '' &&
                                                typeof itemApprovedPrice === 'number')) return [3 /*break*/, 2];
                                            return [4 /*yield*/, pricingRequestItemService_1.patch(item.id, {
                                                    approvedPrice: itemApprovedPrice,
                                                })];
                                        case 1:
                                            _a.sent();
                                            _a.label = 2;
                                        case 2: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 2:
                        allApprovedPricesUpdated = _a.sent();
                        // Show success message
                        this.statusOfSinglePricingRequestApproval =
                            pricing_1.StatusOfNewPricingRequest.Success;
                        // Close modal after short delay
                        setTimeout(function () {
                            _this.resetSinglePricingRequest();
                        }, 512);
                        return [2 /*return*/, true];
                    case 3:
                        err_3 = _a.sent();
                        this.statusOfSinglePricingRequestApproval =
                            pricing_1.StatusOfNewPricingRequest.ErrorTryAgain;
                        console.error(err_3);
                        return [2 /*return*/, err_3];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // Approve pricing request
        this.approveSinglePricingRequest = function () { return __awaiter(_this, void 0, void 0, function () {
            var pricingRequestItemService_2, allApprovedPricesUpdated, pricingRequestService, approvedPricingRequest, err_4;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        this.statusOfSinglePricingRequestApproval =
                            pricing_1.StatusOfNewPricingRequest.Saving;
                        return [4 /*yield*/, App_1.app.service('pricing-request-line')];
                    case 1:
                        pricingRequestItemService_2 = _a.sent();
                        return [4 /*yield*/, this.singlePricingRequest.item.map(function (item, i) { return __awaiter(_this, void 0, void 0, function () {
                                var itemApprovedPrice;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            itemApprovedPrice = accounting_1.unformat(item.approvedPrice);
                                            if (!(item.approvedPrice.trim() !== '' &&
                                                typeof itemApprovedPrice === 'number')) return [3 /*break*/, 2];
                                            return [4 /*yield*/, pricingRequestItemService_2.patch(item.id, {
                                                    approvedPrice: itemApprovedPrice,
                                                })];
                                        case 1:
                                            _a.sent();
                                            _a.label = 2;
                                        case 2: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 2:
                        allApprovedPricesUpdated = _a.sent();
                        return [4 /*yield*/, App_1.app.service('pricing-request')];
                    case 3:
                        pricingRequestService = _a.sent();
                        return [4 /*yield*/, pricingRequestService.patch(this.singlePricingRequest.id, {
                                complete: true,
                            })];
                    case 4:
                        approvedPricingRequest = _a.sent();
                        // Show success message
                        this.statusOfSinglePricingRequestApproval =
                            pricing_1.StatusOfNewPricingRequest.Success;
                        // Refresh pricing requests
                        this.fetchAllOpenPricingRequests();
                        // Close modal after short delay
                        setTimeout(function () {
                            _this.resetSinglePricingRequest();
                        }, 512);
                        return [2 /*return*/, true];
                    case 5:
                        err_4 = _a.sent();
                        if (this.statusOfSinglePricingRequestApproval ===
                            pricing_1.StatusOfNewPricingRequest.Saving) {
                            this.statusOfSinglePricingRequestApproval =
                                pricing_1.StatusOfNewPricingRequest.ErrorTryAgain;
                        }
                        console.error(err_4);
                        return [2 /*return*/, err_4];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
    }
    Object.defineProperty(PricingRequest.prototype, "pricingRequestsLength", {
        get: function () {
            return this.pricingRequests.length;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], PricingRequest.prototype, "loadingPricingRequests", void 0);
    __decorate([
        mobx_1.observable
    ], PricingRequest.prototype, "pricingRequests", void 0);
    __decorate([
        mobx_1.computed
    ], PricingRequest.prototype, "pricingRequestsLength", null);
    __decorate([
        mobx_1.action
    ], PricingRequest.prototype, "fetchAllOpenPricingRequests", void 0);
    __decorate([
        mobx_1.observable
    ], PricingRequest.prototype, "loadingSinglePricingRequest", void 0);
    __decorate([
        mobx_1.observable
    ], PricingRequest.prototype, "statusOfSinglePricingRequestApproval", void 0);
    __decorate([
        mobx_1.observable
    ], PricingRequest.prototype, "singlePricingRequest", void 0);
    __decorate([
        mobx_1.action
    ], PricingRequest.prototype, "fetchSinglePricingRequest", void 0);
    __decorate([
        mobx_1.action
    ], PricingRequest.prototype, "changeApprovedPriceOfSinglePricingRequest", void 0);
    __decorate([
        mobx_1.action
    ], PricingRequest.prototype, "resetSinglePricingRequest", void 0);
    __decorate([
        mobx_1.action
    ], PricingRequest.prototype, "saveSinglePricingRequestItemApprovedPricesChanges", void 0);
    __decorate([
        mobx_1.action
    ], PricingRequest.prototype, "approveSinglePricingRequest", void 0);
    return PricingRequest;
}());
exports.PricingRequest = PricingRequest;


/***/ }),

/***/ "./app/web/src/stores/Question.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// Libraries
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
// Store
var Question = /** @class */ (function () {
    function Question(user) {
        var _this = this;
        this.user = user;
        this.reactToUserLogin = mobx_1.reaction(function () { return _this.user.id; }, function (id) {
            if (id !== null) {
                _this.fetchAllQuestionWithOptions();
            }
        });
        this.loading = false;
        this.questionWithOptionInfo = [];
        // Fetch all questions
        this.fetchAllQuestionWithOptions = function () { return __awaiter(_this, void 0, void 0, function () {
            var service, questionWithOptionInfo, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        this.loading = true;
                        this.questionWithOptionInfo = [];
                        return [4 /*yield*/, App_1.app.service('question-with-option')];
                    case 1:
                        service = _a.sent();
                        return [4 /*yield*/, service.find()];
                    case 2:
                        questionWithOptionInfo = _a.sent();
                        this.questionWithOptionInfo = questionWithOptionInfo;
                        return [2 /*return*/, questionWithOptionInfo];
                    case 3:
                        err_1 = _a.sent();
                        console.error(err_1);
                        return [2 /*return*/, err_1];
                    case 4:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
    }
    __decorate([
        mobx_1.observable
    ], Question.prototype, "loading", void 0);
    __decorate([
        mobx_1.observable
    ], Question.prototype, "questionWithOptionInfo", void 0);
    __decorate([
        mobx_1.action
    ], Question.prototype, "fetchAllQuestionWithOptions", void 0);
    return Question;
}());
exports.Question = Question;


/***/ }),

/***/ "./app/web/src/stores/Sidebar.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var SidebarType;
(function (SidebarType) {
    SidebarType[SidebarType["Closed"] = 0] = "Closed";
    SidebarType[SidebarType["Leads"] = 1] = "Leads";
    SidebarType[SidebarType["Activities"] = 2] = "Activities";
    SidebarType[SidebarType["Profile"] = 3] = "Profile";
})(SidebarType = exports.SidebarType || (exports.SidebarType = {}));
var Sidebar = /** @class */ (function () {
    function Sidebar() {
        var _this = this;
        // Properties
        this.open = SidebarType.Closed;
        this.width = 420;
        // Open sidebar
        this.openSidebar = function (type, newWidth) { return __awaiter(_this, void 0, void 0, function () {
            var closed;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (newWidth) {
                            this.width = newWidth;
                        }
                        return [4 /*yield*/, this.closeSidebar()];
                    case 1:
                        closed = _a.sent();
                        this.open = type;
                        return [4 /*yield*/, setTimeout(function () {
                                return true;
                            }, 600)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, false];
                }
            });
        }); };
        // Close sidebar
        this.closeSidebar = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.open = SidebarType.Closed;
                        if (!(this.open !== SidebarType.Closed)) return [3 /*break*/, 2];
                        return [4 /*yield*/, setTimeout(function () {
                                return true;
                            }, 600)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, false];
                    case 2: return [2 /*return*/, true];
                }
            });
        }); };
    }
    __decorate([
        mobx_1.observable
    ], Sidebar.prototype, "open", void 0);
    __decorate([
        mobx_1.observable
    ], Sidebar.prototype, "width", void 0);
    __decorate([
        mobx_1.action
    ], Sidebar.prototype, "openSidebar", void 0);
    __decorate([
        mobx_1.action
    ], Sidebar.prototype, "closeSidebar", void 0);
    return Sidebar;
}());
exports.Sidebar = Sidebar;


/***/ }),

/***/ "./app/web/src/stores/State.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var location_1 = __webpack_require__("./app/web/data/location/index.ts");
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
// Interfaces
var state_1 = __webpack_require__("./app/common/interfaces/state.ts");
// Store
var State = /** @class */ (function () {
    function State(user) {
        var _this = this;
        this.user = user;
        // Check if modal should show up
        this.modalStatus = state_1.StateModalStatus.Closed;
        // Fetch states when modal status changes
        this.reactToModalStatusChange = mobx_1.reaction(function () { return _this.modalStatus; }, function (status) {
            if (status === state_1.StateModalStatus.OpenOnRepAreasList) {
                _this.fetchRepAreasList();
            }
            else if (status === state_1.StateModalStatus.OpenOnSpecificRepArea &&
                _this.selectedRep !== null) {
                _this.fetchRepAssignedAreas(_this.selectedRep);
            }
            else if (status === state_1.StateModalStatus.OpenOnStatesList) {
                _this.fetchStatesList();
            }
            else if (status === state_1.StateModalStatus.OpenOnSpecificArea &&
                _this.selectedState !== null) {
                _this.fetchStateAreasList();
            }
        });
        // Reps areas
        this.repsAreas = [];
        this.repsSearch = '';
        this.selectedRep = null;
        this.repAssignedAreasDetails = [];
        // Selected state in modal
        this.selectedState = null;
        this.selectedStateIsLoading = false;
        // Search strings
        this.statesListSearch = '';
        this.stateAreasSearch = state_1.AreasFilterType.All;
        // All USA states
        this.usaStates = Object.keys(location_1.usaStatesList).map(function (state, i) {
            return {
                id: state,
                name: location_1.usaStatesList[state],
                leadsCount: null,
            };
        });
        // All areas of selected state
        this.selectedStateAreas = [];
        // Status of assigning user to checked areas
        this.assignUser = {
            isBeingAssigned: true,
            status: state_1.AssignUserStatus.None,
        };
        // Set user to area
        this.assignUserToCheckedAreas = function (userId, slpCode, userName, isPrimary) { return __awaiter(_this, void 0, void 0, function () {
            var assignLeadToRep, assignLeadToRepData, assignment, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        this.assignUser.status = state_1.AssignUserStatus.Saving;
                        this.assignUser.isBeingAssigned = true;
                        return [4 /*yield*/, App_1.app.service('provider-assign-to-rep')];
                    case 1:
                        assignLeadToRep = _a.sent();
                        assignLeadToRepData = {
                            slpcode: slpCode,
                            isPrimary: isPrimary,
                            state: this.selectedState.id,
                            areasCodes: this.checkedAreasSearchedResults.map(function (area) { return area.areaCode; }),
                        };
                        return [4 /*yield*/, assignLeadToRep.create(assignLeadToRepData)];
                    case 2:
                        assignment = _a.sent();
                        this.checkedAreasSearchedResults.map(function (area, i) {
                            // Filter out any reps for selected role
                            area.assignedTo = area.assignedTo.filter(function (rep) {
                                return isPrimary ? rep.primary === 0 : rep.primary === 1;
                            });
                            if (slpCode > 0) {
                                area.assignedTo.push({
                                    userId: userId,
                                    slpcode: slpCode,
                                    name: userName,
                                    primary: isPrimary ? 1 : 0,
                                });
                            }
                        });
                        this.assignUser.status = state_1.AssignUserStatus.Success;
                        setTimeout(function () {
                            if (_this.assignUser.status === state_1.AssignUserStatus.Success) {
                                _this.assignUser.status = state_1.AssignUserStatus.None;
                            }
                        }, 2048);
                        return [2 /*return*/, true];
                    case 3:
                        err_1 = _a.sent();
                        this.assignUser.status = state_1.AssignUserStatus.Error;
                        console.error(err_1);
                        throw err_1;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // Remove user from area
        this.unassignUserFromCheckedAreas = function (userType) { return __awaiter(_this, void 0, void 0, function () {
            var assignLeadToRep, response, err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        this.assignUser.status = state_1.AssignUserStatus.Saving;
                        this.assignUser.isBeingAssigned = false;
                        return [4 /*yield*/, App_1.app.service('provider-assign-to-rep')];
                    case 1:
                        assignLeadToRep = _a.sent();
                        return [4 /*yield*/, assignLeadToRep.create({
                                slpcode: null,
                                type: userType,
                                state: this.selectedState.id,
                                areaCode: this.checkedAreasSearchedResults.map(function (area) { return area.areaCode; }),
                            })];
                    case 2:
                        response = _a.sent();
                        this.checkedAreasSearchedResults.map(function (area, i) {
                            area.assignedTo = area.assignedTo.filter(function (rep) {
                                return userType === 'primary' ? rep.primary === 0 : rep.primary === 1;
                            });
                        });
                        this.toggleAllAreaCheckboxes(false);
                        this.assignUser[userType].status = state_1.AssignUserStatus.Success;
                        setTimeout(function () {
                            if (_this.assignUser[userType].status === state_1.AssignUserStatus.Success) {
                                _this.assignUser[userType].status = state_1.AssignUserStatus.None;
                            }
                        }, 2048);
                        return [2 /*return*/, true];
                    case 3:
                        err_2 = _a.sent();
                        this.assignUser[userType].status = state_1.AssignUserStatus.Error;
                        console.error(err_2);
                        return [2 /*return*/, err_2];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // Check or uncheck or areas in the state
        this.toggleAllAreaCheckboxes = function (check) {
            _this.areasSearchedResults.map(function (area, i) {
                area.checked = check;
            });
        };
        // Check or uncheck single area
        this.toggleAreaCheckbox = function (areaCode, check) {
            var areaIndex = -1;
            _this.selectedStateAreas.some(function (area, i) {
                if (area.areaCode === areaCode) {
                    areaIndex = i;
                    return true;
                }
            });
            if (areaIndex !== -1) {
                _this.selectedStateAreas[areaIndex].checked =
                    typeof check !== 'undefined' && check !== null
                        ? check
                        : !_this.selectedStateAreas[areaIndex].checked;
            }
        };
        // Get rep areas list
        this.fetchRepAreasList = function () { return __awaiter(_this, void 0, void 0, function () {
            var service, repsList, err_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, App_1.app.service('reps-assigned')];
                    case 1:
                        service = _a.sent();
                        return [4 /*yield*/, service.find()];
                    case 2:
                        repsList = _a.sent();
                        this.repsAreas = repsList;
                        return [2 /*return*/, true];
                    case 3:
                        err_3 = _a.sent();
                        console.error(err_3);
                        setTimeout(function () {
                            _this.fetchRepAreasList();
                        }, 512);
                        throw err_3;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // Get rep assigned areas
        this.fetchRepAssignedAreas = function (rep) { return __awaiter(_this, void 0, void 0, function () {
            var service, areas, stateCodesIds_1, states, index, err_4;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (rep === null) {
                            return [2 /*return*/, true];
                        }
                        return [4 /*yield*/, App_1.app.service('reps-assigned')];
                    case 1:
                        service = _a.sent();
                        return [4 /*yield*/, service.get(rep.slpcode)];
                    case 2:
                        areas = _a.sent();
                        if (areas.length <= 0) {
                            return [2 /*return*/, true];
                        }
                        stateCodesIds_1 = [];
                        states = areas.reduce(function (combined, area) {
                            var stateIndex = stateCodesIds_1.indexOf(area.state);
                            if (stateIndex === -1) {
                                stateCodesIds_1.push(area.state);
                                combined.push({
                                    stateCode: area.state,
                                    stateLeadsCount: 0,
                                    areas: [],
                                });
                                stateIndex = combined.length - 1;
                            }
                            combined[stateIndex].stateLeadsCount += area.providersCount;
                            combined[stateIndex].areas.push({
                                areaCode: area.areaCode,
                                areaLeadsCount: area.providersCount,
                            });
                            return combined;
                        }, []);
                        index = this.repAssignedAreasDetailsSlpCodes.indexOf(rep.slpcode);
                        if (index !== -1) {
                            this.repAssignedAreasDetails[index].states = states;
                        }
                        else {
                            this.repAssignedAreasDetails.push({
                                userId: rep.id,
                                name: rep.name || rep.username,
                                slpcode: rep.slpcode,
                                states: states,
                            });
                        }
                        return [2 /*return*/, true];
                    case 3:
                        err_4 = _a.sent();
                        console.error(err_4);
                        setTimeout(function () {
                            _this.fetchRepAssignedAreas(rep);
                        }, 512);
                        throw err_4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // Get state list
        this.fetchStatesList = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, service, statesList, otherStates_1, err_5;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, App_1.app.service('provider-state-list')];
                    case 1:
                        service = _b.sent();
                        return [4 /*yield*/, service.find()];
                    case 2:
                        statesList = _b.sent();
                        otherStates_1 = [];
                        statesList.map(function (stateDetails, i) {
                            var usaStateIndex = -1;
                            var foundState = _this.usaStates.some(function (state, y) {
                                if (stateDetails.plState === state.id) {
                                    usaStateIndex = y;
                                    return true;
                                }
                            });
                            if (usaStateIndex !== -1) {
                                _this.usaStates[usaStateIndex].leadsCount = stateDetails.providerCount;
                            }
                            else {
                                otherStates_1.push({
                                    id: stateDetails.plState,
                                    name: 'Other',
                                    leadsCount: stateDetails.providerCount,
                                });
                            }
                        });
                        if (otherStates_1.length > 0) {
                            (_a = this.usaStates).push.apply(_a, otherStates_1);
                        }
                        return [2 /*return*/, statesList];
                    case 3:
                        err_5 = _b.sent();
                        console.error(err_5);
                        return [2 /*return*/, err_5];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // Get areas list
        this.fetchStateAreasList = function () { return __awaiter(_this, void 0, void 0, function () {
            var service, stateAreasList, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        this.selectedStateAreas = [];
                        this.selectedStateIsLoading = true;
                        return [4 /*yield*/, App_1.app.service('provider-state-list')];
                    case 1:
                        service = _a.sent();
                        return [4 /*yield*/, service.get(this.selectedState.id)];
                    case 2:
                        stateAreasList = _a.sent();
                        this.selectedStateAreas = stateAreasList.map(function (area, i) {
                            var assignedTo = [];
                            if (area.primarySlpcode && area.primaryUserId) {
                                assignedTo.push({
                                    userId: area.primaryUserId,
                                    name: area.primaryUserName,
                                    slpcode: area.primarySlpcode,
                                    primary: 1,
                                });
                            }
                            if (area.secondarySlpcode && area.secondaryUserId) {
                                assignedTo.push({
                                    userId: area.secondaryUserId,
                                    name: area.secondaryUserName,
                                    slpcode: area.secondarySlpcode,
                                    primary: 0,
                                });
                            }
                            return {
                                areaCode: area.areaCode,
                                providersInAreaCode: area.providersInAreaCode,
                                assignedTo: assignedTo,
                                checked: false,
                                modified: false,
                            };
                        });
                        this.selectedStateIsLoading = false;
                        return [2 /*return*/, stateAreasList];
                    case 3:
                        err_6 = _a.sent();
                        this.selectedStateIsLoading = false;
                        console.error(err_6);
                        throw err_6;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    }
    Object.defineProperty(State.prototype, "repAssignedAreasDetailsSlpCodes", {
        get: function () {
            return this.repAssignedAreasDetails.map(function (area) { return area.slpcode; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(State.prototype, "selectedRepAssignedAreasDetails", {
        get: function () {
            if (!this.selectedRep) {
                return null;
            }
            var index = this.repAssignedAreasDetailsSlpCodes.indexOf(this.selectedRep.slpcode);
            if (index === -1) {
                return null;
            }
            return this.repAssignedAreasDetails[index];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(State.prototype, "statesSearchedResults", {
        // States search results
        get: function () {
            var searchQuery = this.statesListSearch.toLowerCase().trim();
            if (searchQuery.length > 0) {
                return this.usaStates.filter(function (state, i) {
                    var stateId = state.id ? state.id.toLowerCase() : '';
                    var stateName = state.name ? state.name.toLowerCase() : '';
                    return (stateId.indexOf(searchQuery) !== -1 ||
                        stateName.indexOf(searchQuery) !== -1);
                });
            }
            else {
                return this.usaStates;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(State.prototype, "areasSearchedResults", {
        // Areas of selected state filter results
        get: function () {
            var _this = this;
            return this.stateAreasSearch === state_1.AreasFilterType.All
                ? this.selectedStateAreas
                : this.selectedStateAreas.filter(function (area, i) {
                    var isAssigned = typeof area.assignedTo !== 'undefined' &&
                        area.assignedTo &&
                        area.assignedTo.length > 0;
                    return _this.stateAreasSearch === state_1.AreasFilterType.OnlyAssigned
                        ? isAssigned
                        : _this.stateAreasSearch === state_1.AreasFilterType.OnlyUnassigned
                            ? !isAssigned
                            : false;
                });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(State.prototype, "checkedAreasSearchedResults", {
        // Areas of selected state that have been modified
        get: function () {
            return this.areasSearchedResults.filter(function (area, i) { return area.checked; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(State.prototype, "checkedAreasSearchedResultsLength", {
        get: function () {
            return this.checkedAreasSearchedResults.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(State.prototype, "checkedAreasSearchedResultsHasAnySalesReps", {
        // Check if any of selected areas has sales rep assigned
        get: function () {
            return this.areasSearchedResults.some(function (area) {
                return area.assignedTo && area.assignedTo.length > 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], State.prototype, "modalStatus", void 0);
    __decorate([
        mobx_1.observable
    ], State.prototype, "repsAreas", void 0);
    __decorate([
        mobx_1.observable
    ], State.prototype, "repsSearch", void 0);
    __decorate([
        mobx_1.observable
    ], State.prototype, "selectedRep", void 0);
    __decorate([
        mobx_1.observable
    ], State.prototype, "repAssignedAreasDetails", void 0);
    __decorate([
        mobx_1.computed
    ], State.prototype, "repAssignedAreasDetailsSlpCodes", null);
    __decorate([
        mobx_1.computed
    ], State.prototype, "selectedRepAssignedAreasDetails", null);
    __decorate([
        mobx_1.observable
    ], State.prototype, "selectedState", void 0);
    __decorate([
        mobx_1.observable
    ], State.prototype, "selectedStateIsLoading", void 0);
    __decorate([
        mobx_1.observable
    ], State.prototype, "statesListSearch", void 0);
    __decorate([
        mobx_1.observable
    ], State.prototype, "stateAreasSearch", void 0);
    __decorate([
        mobx_1.observable
    ], State.prototype, "usaStates", void 0);
    __decorate([
        mobx_1.computed
    ], State.prototype, "statesSearchedResults", null);
    __decorate([
        mobx_1.observable
    ], State.prototype, "selectedStateAreas", void 0);
    __decorate([
        mobx_1.computed
    ], State.prototype, "areasSearchedResults", null);
    __decorate([
        mobx_1.computed
    ], State.prototype, "checkedAreasSearchedResults", null);
    __decorate([
        mobx_1.computed
    ], State.prototype, "checkedAreasSearchedResultsLength", null);
    __decorate([
        mobx_1.computed
    ], State.prototype, "checkedAreasSearchedResultsHasAnySalesReps", null);
    __decorate([
        mobx_1.observable
    ], State.prototype, "assignUser", void 0);
    __decorate([
        mobx_1.action
    ], State.prototype, "assignUserToCheckedAreas", void 0);
    __decorate([
        mobx_1.action
    ], State.prototype, "unassignUserFromCheckedAreas", void 0);
    __decorate([
        mobx_1.action
    ], State.prototype, "toggleAllAreaCheckboxes", void 0);
    __decorate([
        mobx_1.action
    ], State.prototype, "toggleAreaCheckbox", void 0);
    __decorate([
        mobx_1.action
    ], State.prototype, "fetchRepAreasList", void 0);
    __decorate([
        mobx_1.action
    ], State.prototype, "fetchRepAssignedAreas", void 0);
    __decorate([
        mobx_1.action
    ], State.prototype, "fetchStatesList", void 0);
    __decorate([
        mobx_1.action
    ], State.prototype, "fetchStateAreasList", void 0);
    return State;
}());
exports.State = State;


/***/ }),

/***/ "./app/web/src/stores/User.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// Libraries
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
// Enumerables
var UserEditableProperties;
(function (UserEditableProperties) {
    UserEditableProperties["name"] = "name";
    UserEditableProperties["email"] = "email";
    UserEditableProperties["currentPassword"] = "currentPassword";
    UserEditableProperties["newPassword"] = "newPassword";
    UserEditableProperties["confirmPassword"] = "confirmPassword";
})(UserEditableProperties = exports.UserEditableProperties || (exports.UserEditableProperties = {}));
// Store
var User = /** @class */ (function () {
    function User() {
        var _this = this;
        // User info
        this.id = null;
        this.username = null;
        this.name = null;
        this.email = null;
        this.maxFinishedActivitiesCount = null;
        this.userType = null;
        this.slpcode = null;
        // Edit user
        this.userEdit = false;
        this.userEditSaving = false;
        this.userEditSavingError = false;
        this.editedUser = {
            name: '',
            email: '',
            modified: false,
        };
        // Edit user password
        this.userChangePassword = false;
        this.userChangePasswordSaving = false;
        this.userChangePasswordSavingError = false;
        this.userChangePasswordSavingSuccess = false;
        this.changeUserPassword = {
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
            modified: false,
        };
        // Start editing user info
        this.startEditingUser = function () {
            _this.userEdit = true;
            _this.userEditSaving = false;
            _this.userEditSavingError = false;
            _this.editedUser = {
                name: _this.name || '',
                email: _this.email || '',
                modified: false,
            };
        };
        // Stop editing user info
        this.stopEditingUser = function () {
            _this.userEdit = false;
            _this.userEditSaving = false;
            _this.userEditSavingError = false;
            _this.editedUser = {
                name: '',
                email: '',
                modified: false,
            };
        };
        // Start change user password
        this.startEditingUserPassword = function () {
            _this.resetEditingUserPassword(true);
        };
        // Stop change user password
        this.stopEditingUserPassword = function () {
            _this.resetEditingUserPassword(false);
        };
        this.resetEditingUserPassword = function (openPasswordEditForm) {
            _this.userChangePassword = openPasswordEditForm;
            _this.userChangePasswordSaving = false;
            _this.userChangePasswordSavingError = false;
            _this.userChangePasswordSavingSuccess = false;
            _this.changeUserPassword = {
                currentPassword: '',
                newPassword: '',
                confirmPassword: '',
                modified: false,
            };
        };
        this.updateUserPassword = function () { return __awaiter(_this, void 0, void 0, function () {
            var service, patch, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, 7, 8]);
                        this.userChangePasswordSaving = true;
                        this.userChangePasswordSavingError = false;
                        this.userChangePasswordSavingSuccess = false;
                        if (!this.changeUserPassword.modified) return [3 /*break*/, 4];
                        if (!(this.changeUserPassword.currentPassword &&
                            this.changeUserPassword.newPassword &&
                            this.changeUserPassword.confirmPassword)) return [3 /*break*/, 2];
                        service = App_1.app.service('users');
                        return [4 /*yield*/, service.patch(this.id, {
                                currentPassword: this.changeUserPassword.currentPassword,
                                newPassword: this.changeUserPassword.newPassword,
                                confirmPassword: this.changeUserPassword.confirmPassword,
                            })];
                    case 1:
                        patch = _a.sent();
                        this.userChangePasswordSavingSuccess = true;
                        this.changeUserPassword = {
                            currentPassword: '',
                            newPassword: '',
                            confirmPassword: '',
                            modified: false,
                        };
                        return [3 /*break*/, 3];
                    case 2: throw new Error('All password fields are required');
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        this.resetEditingUserPassword(false);
                        _a.label = 5;
                    case 5: return [2 /*return*/, true];
                    case 6:
                        err_1 = _a.sent();
                        this.userChangePasswordSavingError = true;
                        console.error(err_1);
                        return [2 /*return*/, err_1];
                    case 7:
                        this.userChangePasswordSaving = false;
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        this.saveUpdatedUser = function () { return __awaiter(_this, void 0, void 0, function () {
            var service, patch, result, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        this.userEdit = false;
                        this.userEditSaving = true;
                        this.userEditSavingError = false;
                        if (!this.editedUser.modified) return [3 /*break*/, 2];
                        service = App_1.app.service('users');
                        return [4 /*yield*/, service.patch(this.id, {
                                name: this.editedUser.name.trim(),
                                email: this.editedUser.email.trim(),
                            })];
                    case 1:
                        patch = _a.sent();
                        this.name = patch.name;
                        this.email = patch.email;
                        _a.label = 2;
                    case 2:
                        this.userEdit = false;
                        this.userEditSaving = false;
                        this.userEditSavingError = false;
                        result = this.editedUser;
                        this.editedUser = {
                            name: '',
                            email: '',
                            modified: false,
                        };
                        return [2 /*return*/, result];
                    case 3:
                        err_2 = _a.sent();
                        this.userEditSaving = false;
                        this.userEditSavingError = true;
                        console.error(err_2);
                        return [2 /*return*/, err_2];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // Change max activities preference
        this.changeMaxActivitiesPreference = function (maxActivities) { return __awaiter(_this, void 0, void 0, function () {
            var userService, user, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.maxFinishedActivitiesCount = maxActivities;
                        userService = App_1.app.service('users');
                        return [4 /*yield*/, userService.patch(this.id, {
                                maxActivity: maxActivities,
                            })];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, maxActivities];
                    case 2:
                        err_3 = _a.sent();
                        console.error(err_3);
                        return [2 /*return*/, err_3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        // Relogin via local token
        this.relogin = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, App_1.app.passport
                            .getJWT()
                            .then(function (token) {
                            if (token) {
                                return App_1.app.passport.authenticate({
                                    type: 'local',
                                    accessToken: token,
                                });
                            }
                            else {
                                var err = new Error('No valid token stored');
                                throw err.stack;
                            }
                        })
                            .then(function (payload) {
                            if (typeof payload !== 'undefined' &&
                                payload !== null &&
                                typeof payload.user.id !== 'undefined' &&
                                payload.user.id) {
                                var srv = App_1.app.service('users');
                                return App_1.app.service('users').get(payload.user.id);
                            }
                            else {
                                var err = new Error('Token is invalid');
                                throw err.stack;
                            }
                        })
                            .then(function (user) {
                            if (typeof user !== 'undefined') {
                                App_1.app.set('user', user);
                                _this.id = user.id;
                                _this.username = user.username;
                                _this.name = user.name;
                                _this.email = user.email;
                                _this.userType = user.type;
                                _this.slpcode = user.slpcode;
                                _this.maxFinishedActivitiesCount = user.maxActivity || 10;
                                return user;
                            }
                            else {
                                var err = new Error('User does not exist');
                                throw err.stack;
                            }
                        })
                            .catch(function (error) {
                            console.error(error);
                            return error;
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        // Login
        this.login = function (username, password) {
            if (username === void 0) { username = ''; }
            if (password === void 0) { password = ''; }
            return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, App_1.app
                                .authenticate({
                                type: 'local',
                                strategy: 'local',
                                username: username.trim(),
                                password: password.trim(),
                            })
                                .then(function (response) {
                                if (typeof response.accessToken !== 'undefined' &&
                                    response.accessToken) {
                                    return App_1.app.passport.verifyJWT(response.accessToken);
                                }
                                else {
                                    var err = new Error('No access token returned');
                                    throw err.stack;
                                }
                            })
                                .then(function (payload) {
                                if (typeof payload !== 'undefined' &&
                                    payload !== null &&
                                    typeof payload.userId !== 'undefined' &&
                                    payload.userId) {
                                    return App_1.app.service('users').get(payload.userId);
                                }
                                else {
                                    var err = new Error('Token is invalid');
                                    throw err.stack;
                                }
                            })
                                .then(function (user) {
                                if (typeof user !== 'undefined') {
                                    App_1.app.set('user', user);
                                    _this.id = user.id;
                                    _this.username = user.username;
                                    _this.name = user.name;
                                    _this.email = user.email;
                                    _this.userType = user.type;
                                    _this.slpcode = user.slpcode;
                                    _this.maxFinishedActivitiesCount = user.maxActivity || 10;
                                    return user;
                                }
                                else {
                                    var err = new Error('User does not exist');
                                    throw err.stack;
                                }
                            })
                                .catch(function (error) {
                                console.error(error);
                                throw error;
                            })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        // Logout
        this.logout = function () { return __awaiter(_this, void 0, void 0, function () {
            var err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, App_1.app.logout()];
                    case 1:
                        _a.sent();
                        this.id = null;
                        this.username = null;
                        this.userType = null;
                        return [2 /*return*/, true];
                    case 2:
                        err_4 = _a.sent();
                        console.error(err_4);
                        return [2 /*return*/, err_4];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    }
    Object.defineProperty(User.prototype, "isLoggedIn", {
        // @observable public userType: string | null = null;
        get: function () {
            return this.id && this.username ? true : false;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], User.prototype, "id", void 0);
    __decorate([
        mobx_1.observable
    ], User.prototype, "username", void 0);
    __decorate([
        mobx_1.observable
    ], User.prototype, "name", void 0);
    __decorate([
        mobx_1.observable
    ], User.prototype, "email", void 0);
    __decorate([
        mobx_1.observable
    ], User.prototype, "maxFinishedActivitiesCount", void 0);
    __decorate([
        mobx_1.observable
    ], User.prototype, "userType", void 0);
    __decorate([
        mobx_1.observable
    ], User.prototype, "slpcode", void 0);
    __decorate([
        mobx_1.observable
    ], User.prototype, "userEdit", void 0);
    __decorate([
        mobx_1.observable
    ], User.prototype, "userEditSaving", void 0);
    __decorate([
        mobx_1.observable
    ], User.prototype, "userEditSavingError", void 0);
    __decorate([
        mobx_1.observable
    ], User.prototype, "editedUser", void 0);
    __decorate([
        mobx_1.observable
    ], User.prototype, "userChangePassword", void 0);
    __decorate([
        mobx_1.observable
    ], User.prototype, "userChangePasswordSaving", void 0);
    __decorate([
        mobx_1.observable
    ], User.prototype, "userChangePasswordSavingError", void 0);
    __decorate([
        mobx_1.observable
    ], User.prototype, "userChangePasswordSavingSuccess", void 0);
    __decorate([
        mobx_1.observable
    ], User.prototype, "changeUserPassword", void 0);
    __decorate([
        mobx_1.action
    ], User.prototype, "startEditingUser", void 0);
    __decorate([
        mobx_1.action
    ], User.prototype, "stopEditingUser", void 0);
    __decorate([
        mobx_1.action
    ], User.prototype, "startEditingUserPassword", void 0);
    __decorate([
        mobx_1.action
    ], User.prototype, "stopEditingUserPassword", void 0);
    __decorate([
        mobx_1.action
    ], User.prototype, "resetEditingUserPassword", void 0);
    __decorate([
        mobx_1.action
    ], User.prototype, "updateUserPassword", void 0);
    __decorate([
        mobx_1.action
    ], User.prototype, "saveUpdatedUser", void 0);
    __decorate([
        mobx_1.computed
    ], User.prototype, "isLoggedIn", null);
    __decorate([
        mobx_1.action
    ], User.prototype, "changeMaxActivitiesPreference", void 0);
    __decorate([
        mobx_1.action
    ], User.prototype, "relogin", void 0);
    __decorate([
        mobx_1.action
    ], User.prototype, "login", void 0);
    __decorate([
        mobx_1.action
    ], User.prototype, "logout", void 0);
    return User;
}());
exports.User = User;


/***/ }),

/***/ "./app/web/src/stores/Users.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var App_1 = __webpack_require__("./app/web/src/App.tsx");
var user_1 = __webpack_require__("./app/common/interfaces/user.ts");
// Store
var Users = /** @class */ (function () {
    function Users(user) {
        var _this = this;
        this.user = user;
        // React to user login change
        this.reactToUserLogin = mobx_1.reaction(function () { return _this.user.isLoggedIn; }, function (loggedIn) {
            if (loggedIn) {
                _this.fetchAllUsers(true);
            }
        });
        // All users
        this.loadingAll = false;
        this.all = [];
        // Fetch all users
        this.fetchAllUsers = function (activeOnly) { return __awaiter(_this, void 0, void 0, function () {
            var query, usersDb, users, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        activeOnly = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.loadingAll = true;
                        query = {
                            $limit: 999999,
                            $skip: 0,
                            $sort: {
                                name: 1,
                            },
                        };
                        if (activeOnly) {
                            query = __assign({}, query, { status: true });
                        }
                        usersDb = App_1.app.service('users');
                        return [4 /*yield*/, usersDb.find({ query: query })];
                    case 2:
                        users = _a.sent();
                        this.all = users.data;
                        this.loadingAll = false;
                        return [2 /*return*/, users];
                    case 3:
                        err_1 = _a.sent();
                        this.loadingAll = false;
                        console.error(err_1);
                        return [2 /*return*/, err_1];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // Create user
        this.createUser = function (nextUser) { return __awaiter(_this, void 0, void 0, function () {
            var usersDb, newUsers, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        usersDb = App_1.app.service('users');
                        return [4 /*yield*/, usersDb.create(nextUser)];
                    case 1:
                        newUsers = _a.sent();
                        return [2 /*return*/, newUsers];
                    case 2:
                        err_2 = _a.sent();
                        console.error(err_2);
                        return [2 /*return*/, err_2];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        // Fetch single user
        this.fetchSingleUser = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var userDb, user, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        userDb = App_1.app.service('users');
                        return [4 /*yield*/, userDb.get(id)];
                    case 1:
                        user = (_a.sent());
                        return [2 /*return*/, user];
                    case 2:
                        err_3 = _a.sent();
                        console.error(err_3);
                        return [2 /*return*/, err_3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    }
    Object.defineProperty(Users.prototype, "allUsersSorted", {
        // All users sorted
        get: function () {
            return this.all.sort(function (a, b) {
                var aName = a.name ? a.name.toLowerCase() : '0';
                var bName = b.name ? b.name.toLowerCase() : '0';
                return aName > bName ? 1 : aName < bName ? -1 : 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Users.prototype, "salesReps", {
        // Sales reps
        get: function () {
            return this.allUsersSorted.filter(function (user) { return user.type === user_1.UserType.SalesRep; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Users.prototype, "activeSalesReps", {
        // Active sales reps
        get: function () {
            return this.salesReps.filter(function (user) { return user.status; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Users.prototype, "salesManagers", {
        // Sales managers
        get: function () {
            return this.allUsersSorted.filter(function (user) { return user.type === user_1.UserType.SalesManager; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Users.prototype, "activeSalesManagers", {
        // Active sales managers
        get: function () {
            return this.salesManagers.filter(function (user) { return user.status; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Users.prototype, "allActiveSalesUsers", {
        // Active sales users
        get: function () {
            return this.activeSalesReps.concat(this.activeSalesManagers).sort(function (a, b) {
                var aName = a.name ? a.name.toLowerCase() : '0';
                var bName = b.name ? b.name.toLowerCase() : '0';
                return aName > bName ? 1 : aName < bName ? -1 : 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], Users.prototype, "loadingAll", void 0);
    __decorate([
        mobx_1.observable
    ], Users.prototype, "all", void 0);
    __decorate([
        mobx_1.computed
    ], Users.prototype, "allUsersSorted", null);
    __decorate([
        mobx_1.computed
    ], Users.prototype, "salesReps", null);
    __decorate([
        mobx_1.computed
    ], Users.prototype, "activeSalesReps", null);
    __decorate([
        mobx_1.computed
    ], Users.prototype, "salesManagers", null);
    __decorate([
        mobx_1.computed
    ], Users.prototype, "activeSalesManagers", null);
    __decorate([
        mobx_1.computed
    ], Users.prototype, "allActiveSalesUsers", null);
    __decorate([
        mobx_1.action
    ], Users.prototype, "fetchAllUsers", void 0);
    __decorate([
        mobx_1.action
    ], Users.prototype, "createUser", void 0);
    __decorate([
        mobx_1.action
    ], Users.prototype, "fetchSingleUser", void 0);
    return Users;
}());
exports.Users = Users;


/***/ }),

/***/ "./app/web/src/stores/Utilities.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
var moment = __webpack_require__("./node_modules/moment/moment.js");
var Utilities = /** @class */ (function () {
    function Utilities(user) {
        var _this = this;
        this.user = user;
        // Dates
        this.now = moment();
        // Web sockets connectivity
        this.connectionsCount = 0;
        this.isConnectedToBackEnd = false;
        // Change web socket connection status
        this.changeConnectionStatus = function (connected) {
            connected =
                typeof connected !== 'undefined' ? connected : !_this.isConnectedToBackEnd;
            if (connected) {
                _this.isConnectedToBackEnd = true;
                _this.connectionsCount++;
            }
            else {
                _this.isConnectedToBackEnd = false;
            }
        };
    }
    Object.defineProperty(Utilities.prototype, "currentYear", {
        get: function () {
            return this.now.year();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Utilities.prototype, "showOfflineArea", {
        // Show offline area
        get: function () {
            return (!this.isConnectedToBackEnd &&
                this.connectionsCount <= 0 &&
                this.user.isLoggedIn);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], Utilities.prototype, "now", void 0);
    __decorate([
        mobx_1.computed
    ], Utilities.prototype, "currentYear", null);
    __decorate([
        mobx_1.observable
    ], Utilities.prototype, "connectionsCount", void 0);
    __decorate([
        mobx_1.observable
    ], Utilities.prototype, "isConnectedToBackEnd", void 0);
    __decorate([
        mobx_1.computed
    ], Utilities.prototype, "showOfflineArea", null);
    __decorate([
        mobx_1.action
    ], Utilities.prototype, "changeConnectionStatus", void 0);
    return Utilities;
}());
exports.Utilities = Utilities;


/***/ }),

/***/ "./app/web/src/stores/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Exports
__export(__webpack_require__("./app/web/src/stores/User.ts"));
__export(__webpack_require__("./app/web/src/stores/Users.ts"));
__export(__webpack_require__("./app/web/src/stores/Leads.ts"));
__export(__webpack_require__("./app/web/src/stores/Lead.ts"));
__export(__webpack_require__("./app/web/src/stores/LeadContacts.ts"));
__export(__webpack_require__("./app/web/src/stores/LeadPricing.ts"));
__export(__webpack_require__("./app/web/src/stores/LeadActivities.ts"));
__export(__webpack_require__("./app/web/src/stores/LeadResources.ts"));
__export(__webpack_require__("./app/web/src/stores/LeadGroup.ts"));
__export(__webpack_require__("./app/web/src/stores/BusinessPartner.ts"));
__export(__webpack_require__("./app/web/src/stores/Activities.ts"));
__export(__webpack_require__("./app/web/src/stores/ActivitiesCreateOrEdit.ts"));
__export(__webpack_require__("./app/web/src/stores/Question.ts"));
__export(__webpack_require__("./app/web/src/stores/Answer.ts"));
__export(__webpack_require__("./app/web/src/stores/Sidebar.ts"));
__export(__webpack_require__("./app/web/src/stores/State.ts"));
__export(__webpack_require__("./app/web/src/stores/PricingRequest.ts"));
__export(__webpack_require__("./app/web/src/stores/OrderPad.ts"));
__export(__webpack_require__("./app/web/src/stores/OrderPadSales.ts"));
__export(__webpack_require__("./app/web/src/stores/Utilities.ts"));
__export(__webpack_require__("./app/web/src/stores/Modal.ts"));
__export(__webpack_require__("./app/web/src/stores/AllStores.ts"));


/***/ }),

/***/ "./app/web/src/styles/errors/errors.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/styles/errors/errors.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./errors.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./errors.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/styles/index.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/styles/index.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./index.css", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./index.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./app/web/src/styles/sales/sales.css":
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__("./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/styles/sales/sales.css");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__("./node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./sales.css", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--3-2!./sales.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/esm/extends.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js":
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),

/***/ "./node_modules/accounting/accounting.js":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * accounting.js v0.4.1
 * Copyright 2014 Open Exchange Rates
 *
 * Freely distributable under the MIT license.
 * Portions of accounting.js are inspired or borrowed from underscore.js
 *
 * Full details and documentation:
 * http://openexchangerates.github.io/accounting.js/
 */

(function(root, undefined) {

	/* --- Setup --- */

	// Create the local library object, to be exported or referenced globally later
	var lib = {};

	// Current version
	lib.version = '0.4.1';


	/* --- Exposed settings --- */

	// The library's settings configuration object. Contains default parameters for
	// currency and number formatting
	lib.settings = {
		currency: {
			symbol : "$",		// default currency symbol is '$'
			format : "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
			decimal : ".",		// decimal point separator
			thousand : ",",		// thousands separator
			precision : 2,		// decimal places
			grouping : 3		// digit grouping (not implemented yet)
		},
		number: {
			precision : 0,		// default precision on numbers is 0
			grouping : 3,		// digit grouping (not implemented yet)
			thousand : ",",
			decimal : "."
		}
	};


	/* --- Internal Helper Methods --- */

	// Store reference to possibly-available ECMAScript 5 methods for later
	var nativeMap = Array.prototype.map,
		nativeIsArray = Array.isArray,
		toString = Object.prototype.toString;

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js
	 */
	function isString(obj) {
		return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
	}

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js, delegates to ECMA5's native Array.isArray
	 */
	function isArray(obj) {
		return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
	}

	/**
	 * Tests whether supplied parameter is a true object
	 */
	function isObject(obj) {
		return obj && toString.call(obj) === '[object Object]';
	}

	/**
	 * Extends an object with a defaults object, similar to underscore's _.defaults
	 *
	 * Used for abstracting parameter handling from API methods
	 */
	function defaults(object, defs) {
		var key;
		object = object || {};
		defs = defs || {};
		// Iterate over object non-prototype properties:
		for (key in defs) {
			if (defs.hasOwnProperty(key)) {
				// Replace values with defaults only if undefined (allow empty/zero values):
				if (object[key] == null) object[key] = defs[key];
			}
		}
		return object;
	}

	/**
	 * Implementation of `Array.map()` for iteration loops
	 *
	 * Returns a new Array as a result of calling `iterator` on each array value.
	 * Defers to native Array.map if available
	 */
	function map(obj, iterator, context) {
		var results = [], i, j;

		if (!obj) return results;

		// Use native .map method if it exists:
		if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);

		// Fallback for native .map:
		for (i = 0, j = obj.length; i < j; i++ ) {
			results[i] = iterator.call(context, obj[i], i, obj);
		}
		return results;
	}

	/**
	 * Check and normalise the value of precision (must be positive integer)
	 */
	function checkPrecision(val, base) {
		val = Math.round(Math.abs(val));
		return isNaN(val)? base : val;
	}


	/**
	 * Parses a format string or object and returns format obj for use in rendering
	 *
	 * `format` is either a string with the default (positive) format, or object
	 * containing `pos` (required), `neg` and `zero` values (or a function returning
	 * either a string or object)
	 *
	 * Either string or format.pos must contain "%v" (value) to be valid
	 */
	function checkCurrencyFormat(format) {
		var defaults = lib.settings.currency.format;

		// Allow function as format parameter (should return string or object):
		if ( typeof format === "function" ) format = format();

		// Format can be a string, in which case `value` ("%v") must be present:
		if ( isString( format ) && format.match("%v") ) {

			// Create and return positive, negative and zero formats:
			return {
				pos : format,
				neg : format.replace("-", "").replace("%v", "-%v"),
				zero : format
			};

		// If no format, or object is missing valid positive value, use defaults:
		} else if ( !format || !format.pos || !format.pos.match("%v") ) {

			// If defaults is a string, casts it to an object for faster checking next time:
			return ( !isString( defaults ) ) ? defaults : lib.settings.currency.format = {
				pos : defaults,
				neg : defaults.replace("%v", "-%v"),
				zero : defaults
			};

		}
		// Otherwise, assume format was fine:
		return format;
	}


	/* --- API Methods --- */

	/**
	 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
	 * Alias: `accounting.parse(string)`
	 *
	 * Decimal must be included in the regular expression to match floats (defaults to
	 * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
	 * separator, provide it as the second argument.
	 *
	 * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
	 *
	 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
	 */
	var unformat = lib.unformat = lib.parse = function(value, decimal) {
		// Recursively unformat arrays:
		if (isArray(value)) {
			return map(value, function(val) {
				return unformat(val, decimal);
			});
		}

		// Fails silently (need decent errors):
		value = value || 0;

		// Return the value as-is if it's already a number:
		if (typeof value === "number") return value;

		// Default decimal point comes from settings, but could be set to eg. "," in opts:
		decimal = decimal || lib.settings.number.decimal;

		 // Build regex to strip out everything except digits, decimal point and minus sign:
		var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
			unformatted = parseFloat(
				("" + value)
				.replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
				.replace(regex, '')         // strip out any cruft
				.replace(decimal, '.')      // make sure decimal point is standard
			);

		// This will fail silently which may cause trouble, let's wait and see:
		return !isNaN(unformatted) ? unformatted : 0;
	};


	/**
	 * Implementation of toFixed() that treats floats more like decimals
	 *
	 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
	 * problems for accounting- and finance-related software.
	 */
	var toFixed = lib.toFixed = function(value, precision) {
		precision = checkPrecision(precision, lib.settings.number.precision);
		var power = Math.pow(10, precision);

		// Multiply up by precision, round accurately, then divide and use native toFixed():
		return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
	};


	/**
	 * Format a number, with comma-separated thousands and custom precision/decimal places
	 * Alias: `accounting.format()`
	 *
	 * Localise by overriding the precision and thousand / decimal separators
	 * 2nd parameter `precision` can be an object matching `settings.number`
	 */
	var formatNumber = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val) {
				return formatNumber(val, precision, thousand, decimal);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(precision) ? precision : {
					precision : precision,
					thousand : thousand,
					decimal : decimal
				}),
				lib.settings.number
			),

			// Clean up precision
			usePrecision = checkPrecision(opts.precision),

			// Do some calc:
			negative = number < 0 ? "-" : "",
			base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
			mod = base.length > 3 ? base.length % 3 : 0;

		// Format the number:
		return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
	};


	/**
	 * Format a number into currency
	 *
	 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
	 * defaults: (0, "$", 2, ",", ".", "%s%v")
	 *
	 * Localise by overriding the symbol, precision, thousand / decimal separators and format
	 * Second param can be an object matching `settings.currency` which is the easiest way.
	 *
	 * To do: tidy up the parameters
	 */
	var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val){
				return formatMoney(val, symbol, precision, thousand, decimal, format);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero):
			formats = checkCurrencyFormat(opts.format),

			// Choose which format to use for this value:
			useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;

		// Return with currency symbol added:
		return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
	};


	/**
	 * Format a list of numbers into an accounting column, padding with whitespace
	 * to line up currency symbols, thousand separators and decimals places
	 *
	 * List should be an array of numbers
	 * Second parameter can be an object containing keys that match the params
	 *
	 * Returns array of accouting-formatted number strings of same length
	 *
	 * NB: `white-space:pre` CSS rule is required on the list container to prevent
	 * browsers from collapsing the whitespace in the output strings.
	 */
	lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
		if (!list) return [];

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero), only need pos for now:
			formats = checkCurrencyFormat(opts.format),

			// Whether to pad at start of string or after currency symbol:
			padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,

			// Store value for the length of the longest string in the column:
			maxLength = 0,

			// Format the list according to options, store the length of the longest string:
			formatted = map(list, function(val, i) {
				if (isArray(val)) {
					// Recursively format columns if list is a multi-dimensional array:
					return lib.formatColumn(val, opts);
				} else {
					// Clean up the value
					val = unformat(val);

					// Choose which format to use for this value (pos, neg or zero):
					var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,

						// Format this value, push into formatted list and save the length:
						fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));

					if (fVal.length > maxLength) maxLength = fVal.length;
					return fVal;
				}
			});

		// Pad each number in the list and send back the column of numbers:
		return map(formatted, function(val, i) {
			// Only if this is a string (not a nested array, which would have already been padded):
			if (isString(val) && val.length < maxLength) {
				// Depending on symbol position, pad after symbol or at index 0:
				return padAfterSymbol ? val.replace(opts.symbol, opts.symbol+(new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
			}
			return val;
		});
	};


	/* --- Module Definition --- */

	// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
	// Otherwise, just add `accounting` to the global object
	if (true) {
		if (typeof module !== 'undefined' && module.exports) {
			exports = module.exports = lib;
		}
		exports.accounting = lib;
	} else if (typeof define === 'function' && define.amd) {
		// Return the library as an AMD module:
		define([], function() {
			return lib;
		});
	} else {
		// Use accounting.noConflict to restore `accounting` back to its original value.
		// Returns a reference to the library's `accounting` object;
		// e.g. `var numbers = accounting.noConflict();`
		lib.noConflict = (function(oldAccounting) {
			return function() {
				// Reset the value of the root's `accounting` variable:
				root.accounting = oldAccounting;
				// Delete the noConflict method:
				lib.noConflict = undefined;
				// Return reference to the library to re-assign it:
				return lib;
			};
		})(root.accounting);

		// Declare `fx` on the root (global/window) object:
		root['accounting'] = lib;
	}

	// Root will be `window` in browser or `global` on the server:
}(this));


/***/ }),

/***/ "./node_modules/after/index.js":
/***/ (function(module, exports) {

module.exports = after

function after(count, callback, err_cb) {
    var bail = false
    err_cb = err_cb || noop
    proxy.count = count

    return (count === 0) ? callback() : proxy

    function proxy(err, result) {
        if (proxy.count <= 0) {
            throw new Error('after called too many times')
        }
        --proxy.count

        // after first error, rest are passed to err_cb
        if (err) {
            bail = true
            callback(err)
            // future error callbacks will go to error handler
            callback = err_cb
        } else if (proxy.count === 0 && !bail) {
            callback(null, result)
        }
    }
}

function noop() {}


/***/ }),

/***/ "./node_modules/arraybuffer.slice/index.js":
/***/ (function(module, exports) {

/**
 * An abstraction for slicing an arraybuffer even when
 * ArrayBuffer.prototype.slice is not supported
 *
 * @api public
 */

module.exports = function(arraybuffer, start, end) {
  var bytes = arraybuffer.byteLength;
  start = start || 0;
  end = end || bytes;

  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }

  if (start < 0) { start += bytes; }
  if (end < 0) { end += bytes; }
  if (end > bytes) { end = bytes; }

  if (start >= bytes || start >= end || bytes === 0) {
    return new ArrayBuffer(0);
  }

  var abv = new Uint8Array(arraybuffer);
  var result = new Uint8Array(end - start);
  for (var i = start, ii = 0; i < end; i++, ii++) {
    result[ii] = abv[i];
  }
  return result.buffer;
};


/***/ }),

/***/ "./node_modules/babel-runtime/core-js/array/from.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/array/from.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/assign.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/keys.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/keys.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/backo2/index.js":
/***/ (function(module, exports) {


/**
 * Expose `Backoff`.
 */

module.exports = Backoff;

/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */

function Backoff(opts) {
  opts = opts || {};
  this.ms = opts.min || 100;
  this.max = opts.max || 10000;
  this.factor = opts.factor || 2;
  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
  this.attempts = 0;
}

/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */

Backoff.prototype.duration = function(){
  var ms = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var rand =  Math.random();
    var deviation = Math.floor(rand * this.jitter * ms);
    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
  }
  return Math.min(ms, this.max) | 0;
};

/**
 * Reset the number of attempts.
 *
 * @api public
 */

Backoff.prototype.reset = function(){
  this.attempts = 0;
};

/**
 * Set the minimum duration
 *
 * @api public
 */

Backoff.prototype.setMin = function(min){
  this.ms = min;
};

/**
 * Set the maximum duration
 *
 * @api public
 */

Backoff.prototype.setMax = function(max){
  this.max = max;
};

/**
 * Set the jitter
 *
 * @api public
 */

Backoff.prototype.setJitter = function(jitter){
  this.jitter = jitter;
};



/***/ }),

/***/ "./node_modules/base64-arraybuffer/lib/base64-arraybuffer.js":
/***/ (function(module, exports) {

/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */
(function(){
  "use strict";

  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

  // Use a lookup table to find the index.
  var lookup = new Uint8Array(256);
  for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
  }

  exports.encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer),
    i, len = bytes.length, base64 = "";

    for (i = 0; i < len; i+=3) {
      base64 += chars[bytes[i] >> 2];
      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
      base64 += chars[bytes[i + 2] & 63];
    }

    if ((len % 3) === 2) {
      base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
      base64 = base64.substring(0, base64.length - 2) + "==";
    }

    return base64;
  };

  exports.decode =  function(base64) {
    var bufferLength = base64.length * 0.75,
    len = base64.length, i, p = 0,
    encoded1, encoded2, encoded3, encoded4;

    if (base64[base64.length - 1] === "=") {
      bufferLength--;
      if (base64[base64.length - 2] === "=") {
        bufferLength--;
      }
    }

    var arraybuffer = new ArrayBuffer(bufferLength),
    bytes = new Uint8Array(arraybuffer);

    for (i = 0; i < len; i+=4) {
      encoded1 = lookup[base64.charCodeAt(i)];
      encoded2 = lookup[base64.charCodeAt(i+1)];
      encoded3 = lookup[base64.charCodeAt(i+2)];
      encoded4 = lookup[base64.charCodeAt(i+3)];

      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }

    return arraybuffer;
  };
})();


/***/ }),

/***/ "./node_modules/base64-js/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return (b64.length * 3 / 4) - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr((len * 3 / 4) - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0; i < l; i += 4) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),

/***/ "./node_modules/blob/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Create a blob builder even when vendor prefixes exist
 */

var BlobBuilder = global.BlobBuilder
  || global.WebKitBlobBuilder
  || global.MSBlobBuilder
  || global.MozBlobBuilder;

/**
 * Check if Blob constructor is supported
 */

var blobSupported = (function() {
  try {
    var a = new Blob(['hi']);
    return a.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */

var blobSupportsArrayBufferView = blobSupported && (function() {
  try {
    var b = new Blob([new Uint8Array([1,2])]);
    return b.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if BlobBuilder is supported
 */

var blobBuilderSupported = BlobBuilder
  && BlobBuilder.prototype.append
  && BlobBuilder.prototype.getBlob;

/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */

function mapArrayBufferViews(ary) {
  for (var i = 0; i < ary.length; i++) {
    var chunk = ary[i];
    if (chunk.buffer instanceof ArrayBuffer) {
      var buf = chunk.buffer;

      // if this is a subarray, make a copy so we only
      // include the subarray region from the underlying buffer
      if (chunk.byteLength !== buf.byteLength) {
        var copy = new Uint8Array(chunk.byteLength);
        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
        buf = copy.buffer;
      }

      ary[i] = buf;
    }
  }
}

function BlobBuilderConstructor(ary, options) {
  options = options || {};

  var bb = new BlobBuilder();
  mapArrayBufferViews(ary);

  for (var i = 0; i < ary.length; i++) {
    bb.append(ary[i]);
  }

  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
};

function BlobConstructor(ary, options) {
  mapArrayBufferViews(ary);
  return new Blob(ary, options || {});
};

module.exports = (function() {
  if (blobSupported) {
    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
  } else if (blobBuilderSupported) {
    return BlobBuilderConstructor;
  } else {
    return undefined;
  }
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/chain-function/index.js":
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),

/***/ "./node_modules/classnames/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ "./node_modules/component-bind/index.js":
/***/ (function(module, exports) {

/**
 * Slice reference.
 */

var slice = [].slice;

/**
 * Bind `obj` to `fn`.
 *
 * @param {Object} obj
 * @param {Function|String} fn or string
 * @return {Function}
 * @api public
 */

module.exports = function(obj, fn){
  if ('string' == typeof fn) fn = obj[fn];
  if ('function' != typeof fn) throw new Error('bind() requires a function');
  var args = slice.call(arguments, 2);
  return function(){
    return fn.apply(obj, args.concat(slice.call(arguments)));
  }
};


/***/ }),

/***/ "./node_modules/component-emitter/index.js":
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),

/***/ "./node_modules/component-inherit/index.js":
/***/ (function(module, exports) {


module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};

/***/ }),

/***/ "./node_modules/core-js/library/fn/array/from.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("./node_modules/core-js/library/modules/es6.array.from.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Array.from;


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.assign.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.assign;


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/keys.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.keys.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.keys;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_a-function.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var toLength = __webpack_require__("./node_modules/core-js/library/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/library/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_classof.js":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("./node_modules/core-js/library/modules/_cof.js");
var TAG = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_cof.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_core.js":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/core-js/library/modules/_create-property.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_defined.js":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var document = __webpack_require__("./node_modules/core-js/library/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "./node_modules/core-js/library/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_fails.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_global.js":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/core-js/library/modules/_has.js":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_html.js":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("./node_modules/core-js/library/modules/_global.js").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") && !__webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("./node_modules/core-js/library/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("./node_modules/core-js/library/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_is-array-iter.js":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_is-object.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iter-call.js":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iter-create.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("./node_modules/core-js/library/modules/_object-create.js");
var descriptor = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("./node_modules/core-js/library/modules/_hide.js")(IteratorPrototype, __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iter-define.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("./node_modules/core-js/library/modules/_library.js");
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var redefine = __webpack_require__("./node_modules/core-js/library/modules/_redefine.js");
var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
var $iterCreate = __webpack_require__("./node_modules/core-js/library/modules/_iter-create.js");
var setToStringTag = __webpack_require__("./node_modules/core-js/library/modules/_set-to-string-tag.js");
var getPrototypeOf = __webpack_require__("./node_modules/core-js/library/modules/_object-gpo.js");
var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iter-detect.js":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iterators.js":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_library.js":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-assign.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js");
var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
var gOPS = __webpack_require__("./node_modules/core-js/library/modules/_object-gops.js");
var pIE = __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js");
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var IObject = __webpack_require__("./node_modules/core-js/library/modules/_iobject.js");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var dPs = __webpack_require__("./node_modules/core-js/library/modules/_object-dps.js");
var enumBugKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-bug-keys.js");
var IE_PROTO = __webpack_require__("./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("./node_modules/core-js/library/modules/_dom-create.js")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("./node_modules/core-js/library/modules/_html.js").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("./node_modules/core-js/library/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/library/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-dps.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");

module.exports = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-gops.js":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-gpo.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var IE_PROTO = __webpack_require__("./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("./node_modules/core-js/library/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-bug-keys.js");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-pie.js":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-sap.js":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var fails = __webpack_require__("./node_modules/core-js/library/modules/_fails.js");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_property-desc.js":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");


/***/ }),

/***/ "./node_modules/core-js/library/modules/_set-to-string-tag.js":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f;
var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var TAG = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("./node_modules/core-js/library/modules/_shared.js")('keys');
var uid = __webpack_require__("./node_modules/core-js/library/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("./node_modules/core-js/library/modules/_library.js") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/_string-at.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("./node_modules/core-js/library/modules/_to-integer.js");
var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("./node_modules/core-js/library/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-integer.js":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("./node_modules/core-js/library/modules/_iobject.js");
var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("./node_modules/core-js/library/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_uid.js":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_wks.js":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("./node_modules/core-js/library/modules/_shared.js")('wks');
var uid = __webpack_require__("./node_modules/core-js/library/modules/_uid.js");
var Symbol = __webpack_require__("./node_modules/core-js/library/modules/_global.js").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "./node_modules/core-js/library/modules/core.get-iterator-method.js":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("./node_modules/core-js/library/modules/_classof.js");
var ITERATOR = __webpack_require__("./node_modules/core-js/library/modules/_wks.js")('iterator');
var Iterators = __webpack_require__("./node_modules/core-js/library/modules/_iterators.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.array.from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var call = __webpack_require__("./node_modules/core-js/library/modules/_iter-call.js");
var isArrayIter = __webpack_require__("./node_modules/core-js/library/modules/_is-array-iter.js");
var toLength = __webpack_require__("./node_modules/core-js/library/modules/_to-length.js");
var createProperty = __webpack_require__("./node_modules/core-js/library/modules/_create-property.js");
var getIterFn = __webpack_require__("./node_modules/core-js/library/modules/core.get-iterator-method.js");

$export($export.S + $export.F * !__webpack_require__("./node_modules/core-js/library/modules/_iter-detect.js")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("./node_modules/core-js/library/modules/_object-assign.js") });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");

__webpack_require__("./node_modules/core-js/library/modules/_object-sap.js")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.string.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("./node_modules/core-js/library/modules/_string-at.js")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("./node_modules/core-js/library/modules/_iter-define.js")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "./node_modules/create-react-class/factory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("./node_modules/object-assign/index.js");

var emptyObject = __webpack_require__("./node_modules/fbjs/lib/emptyObject.js");
var _invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/action/Button.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".button_from_Button-css_3cT {\r\n\r\n}\r\n\r\n.box_from_Button-css_FQo {\r\n  width: 100%;\r\n  padding: 24px;\r\n  display: table-cell;\r\n}\r\n\r\n.action_from_Button-css_24G {\r\n\r\n}\r\n\r\n.icon_from_Button-css_2AF {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin: 0 4px 0 4px;\r\n}\r\n\r\n.children_from_Button-css_2Oo {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin: 0 4px 0 4px;\r\n}\r\n\r\n.important_from_Button-css_3Uo {\r\n\r\n}\r\n", ""]);

// exports
exports.locals = {
	"button": "button_from_Button-css_3cT",
	"box": "box_from_Button-css_FQo",
	"action": "action_from_Button-css_24G",
	"icon": "icon_from_Button-css_2AF",
	"children": "children_from_Button-css_2Oo",
	"important": "important_from_Button-css_3Uo"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/action/CardButton.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".button_from_CardButton-css_fDA {\r\n    position: relative;\r\n    padding: 16px;\r\n    background: #FFFFFF;\r\n    border: 1px solid #FFFFFF;\r\n    border-radius: 3px;\r\n    -webkit-box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);\r\n            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);\r\n    -webkit-transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.button_from_CardButton-css_fDA:hover:not(.disabled_from_CardButton-css_iTb) {\r\n    border-color: #496DF4\r\n}\r\n\r\n.button_from_CardButton-css_fDA:hover:not(.disabled_from_CardButton-css_iTb) .arrow_from_CardButton-css_3WJ {\r\n    -webkit-transform: translateX(3px);\r\n            transform: translateX(3px);\r\n}\r\n\r\n.button_from_CardButton-css_fDA.disabled_from_CardButton-css_iTb .arrow_from_CardButton-css_3WJ {\r\n    display: none;\r\n}\r\n\r\n.arrow_from_CardButton-css_3WJ {\r\n    position: absolute;\r\n    bottom: 16px;\r\n    right: 16px;\r\n    width: 11px;\r\n    height: 7px;\r\n    -webkit-transform: translateX(0px);\r\n            transform: translateX(0px);\r\n    -webkit-transition: 300ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 300ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 300ms transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 300ms transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000), 300ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"button": "button_from_CardButton-css_fDA",
	"disabled": "disabled_from_CardButton-css_iTb",
	"arrow": "arrow_from_CardButton-css_3WJ"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/action/Checkbox.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".checkbox_from_Checkbox-css_Dv2 {\r\n    position: relative;\r\n    width: 100%;\r\n    min-width: 20px;\r\n    min-height: 20px;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center\r\n}\n.checkbox_from_Checkbox-css_Dv2 > input,\r\n    .checkbox_from_Checkbox-css_Dv2 > input[type='checkbox'] {\r\n    width: 18px;\r\n    height: 18px;\r\n    opacity: 0;\r\n    margin: 0;\r\n    margin-left: 0;\r\n    margin-right: 6px;\r\n}\n.checkbox_from_Checkbox-css_Dv2 p {\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1 0;\r\n            flex: 1 0;\r\n    font-size: 0.825em;\r\n    font-weight: 600;\r\n    color: #2B2C2F;\r\n    -webkit-transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\n.checkbox_from_Checkbox-css_Dv2 p::before {\r\n    content: '';\r\n    position: absolute;\r\n    display: block;\r\n    z-index: 1;\r\n    width: 18px;\r\n    height: 18px;\r\n    top: 0;\r\n    left: 0;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    background: #FFFFFF;\r\n    border: 1px solid #DCDEDE;\r\n    border-radius: 1px;\r\n    -webkit-transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\n.checkbox_from_Checkbox-css_Dv2 .icon_from_Checkbox-css_30e {\r\n    outline: none;\r\n    position: absolute;\r\n    display: block;\r\n    width: 18px;\r\n    height: 18px;\r\n    z-index: 2;\r\n    top: 0;\r\n    left: 0;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box\r\n}\n.checkbox_from_Checkbox-css_Dv2 .icon_from_Checkbox-css_30e img {\r\n    width: 20px;\r\n    height: 20px;\r\n    position: relative;\r\n    left: 1px;\r\n    top: 0;\r\n}\n.checkbox_from_Checkbox-css_Dv2 .icon_from_Checkbox-css_30e:focus,\r\n        .checkbox_from_Checkbox-css_Dv2 .icon_from_Checkbox-css_30e:active {\r\n    border: 1px dashed #6F7583;\r\n    border-radius: 1px;\r\n}\n.checkbox_from_Checkbox-css_Dv2:hover p {\r\n    color: #496DF4\r\n}\n.checkbox_from_Checkbox-css_Dv2:hover p::before {\r\n    background: #E9EBEB;\r\n}\n.checkbox_from_Checkbox-css_Dv2.checked_from_Checkbox-css_1nb p::before {\r\n    background: #25AC7F;\r\n    border-color: #18A073;\r\n}\n.checkbox_from_Checkbox-css_Dv2.checked_from_Checkbox-css_1nb .icon_from_Checkbox-css_30e:focus,\r\n            .checkbox_from_Checkbox-css_Dv2.checked_from_Checkbox-css_1nb .icon_from_Checkbox-css_30e:active {\r\n    border-color: #FFFFFF;\r\n}\n.checkbox_from_Checkbox-css_Dv2.checked_from_Checkbox-css_1nb:hover p::before {\r\n    background: #18A073;\r\n}\n.checkbox_from_Checkbox-css_Dv2.disabled_from_Checkbox-css_349 {\r\n    cursor: not-allowed;\r\n}\n.checkbox_from_Checkbox-css_Dv2.labelOnLeft_from_Checkbox-css_1tK {\r\n    -webkit-box-pack: end;\r\n        -ms-flex-pack: end;\r\n            justify-content: flex-end;\r\n    text-align: right\r\n}\n.checkbox_from_Checkbox-css_Dv2.labelOnLeft_from_Checkbox-css_1tK > input,\r\n        .checkbox_from_Checkbox-css_Dv2.labelOnLeft_from_Checkbox-css_1tK > input[type='checkbox'] {\r\n    margin: 0;\r\n    margin-left: 6px;\r\n    margin-right: 0;\r\n}\n.checkbox_from_Checkbox-css_Dv2.labelOnLeft_from_Checkbox-css_1tK p::before {\r\n    left: auto;\r\n    right: 0;\r\n}\n.checkbox_from_Checkbox-css_Dv2.labelOnLeft_from_Checkbox-css_1tK .icon_from_Checkbox-css_30e {\r\n    left: auto;\r\n    right: 0;\r\n}\n.checkbox_from_Checkbox-css_Dv2.alignLeft_from_Checkbox-css_gJN {\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n}\n.checkbox_from_Checkbox-css_Dv2.alignCenter_from_Checkbox-css_2TU {\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n}\n.checkbox_from_Checkbox-css_Dv2.alignRight_from_Checkbox-css_-eJ {\r\n    -webkit-box-pack: end;\r\n        -ms-flex-pack: end;\r\n            justify-content: flex-end;\r\n    text-align: right\r\n}\n.checkbox_from_Checkbox-css_Dv2.alignRight_from_Checkbox-css_-eJ > input,\r\n        .checkbox_from_Checkbox-css_Dv2.alignRight_from_Checkbox-css_-eJ > input[type='checkbox'] {\r\n    margin: 0;\r\n    margin-left: 6px;\r\n    margin-right: 0;\r\n}\n.checkbox_from_Checkbox-css_Dv2.alignRight_from_Checkbox-css_-eJ p::before {\r\n    left: auto;\r\n    right: 0;\r\n}\n.checkbox_from_Checkbox-css_Dv2.alignRight_from_Checkbox-css_-eJ .icon_from_Checkbox-css_30e {\r\n    left: auto;\r\n    right: 0;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"checkbox": "checkbox_from_Checkbox-css_Dv2",
	"icon": "icon_from_Checkbox-css_30e",
	"checked": "checked_from_Checkbox-css_1nb",
	"disabled": "disabled_from_Checkbox-css_349",
	"labelOnLeft": "labelOnLeft_from_Checkbox-css_1tK",
	"alignLeft": "alignLeft_from_Checkbox-css_gJN",
	"alignCenter": "alignCenter_from_Checkbox-css_2TU",
	"alignRight": "alignRight_from_Checkbox-css_-eJ"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/action/FileUpload.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".fileUploadForm_from_FileUpload-css_39_ {\r\n  position: relative\r\n}\n.fileUploadForm_from_FileUpload-css_39_ .container_from_FileUpload-css_29J {\r\n  background: transparent;\r\n  -webkit-transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\n.fileUploadForm_from_FileUpload-css_39_ .uploadGroup_from_FileUpload-css_3jP {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  position: relative;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  border: 3px dashed #E9EBEB;\r\n  -webkit-transition: 500ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 500ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\n.fileUploadForm_from_FileUpload-css_39_ .uploadGroup_from_FileUpload-css_3jP p {\r\n  padding: 32px 12px;\r\n  text-align: center;\r\n  display: block;\r\n  width: 100%;\r\n  font-size: 0.825em;\r\n  font-weight: 600;\r\n  color: #496DF4;\r\n  left: 0;\r\n  position: relative;\r\n  z-index: 1;\r\n}\n.fileUploadForm_from_FileUpload-css_39_ .uploadGroup_from_FileUpload-css_3jP input {\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 0;\r\n  margin: 0;\r\n  position: absolute;\r\n  opacity: 0;\r\n  z-index: 2;\r\n}\n.fileUploadForm_from_FileUpload-css_39_.disabled_from_FileUpload-css_Trh .container_from_FileUpload-css_29J {\r\n  background: #E9EBEB;\r\n}\n.fileUploadForm_from_FileUpload-css_39_.disabled_from_FileUpload-css_Trh .uploadGroup_from_FileUpload-css_3jP {\r\n  border-color: #FFFFFF\r\n}\n.fileUploadForm_from_FileUpload-css_39_.disabled_from_FileUpload-css_Trh .uploadGroup_from_FileUpload-css_3jP p {\r\n  opacity: 0.2;\r\n}\n.fileUploadForm_from_FileUpload-css_39_.disabled_from_FileUpload-css_Trh .uploadGroup_from_FileUpload-css_3jP input {\r\n  background: transparent;\r\n  cursor: no-drop;\r\n}\n.fileUploadForm_from_FileUpload-css_39_.active_from_FileUpload-css_324 .uploadGroup_from_FileUpload-css_3jP {\r\n  border-color: #2E3D73;\r\n  border-width: 1px\r\n}\n.fileUploadForm_from_FileUpload-css_39_.active_from_FileUpload-css_324 .uploadGroup_from_FileUpload-css_3jP p {\r\n  color: #2E3D73;\r\n  text-transform: none;\r\n}\n.fileUploadForm_from_FileUpload-css_39_.dragging .container_from_FileUpload-css_29J, .fileUploadForm_from_FileUpload-css_39_:hover .container_from_FileUpload-css_29J {\r\n  background: #FFFFFF;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"fileUploadForm": "fileUploadForm_from_FileUpload-css_39_",
	"container": "container_from_FileUpload-css_29J",
	"uploadGroup": "uploadGroup_from_FileUpload-css_3jP",
	"disabled": "disabled_from_FileUpload-css_Trh",
	"active": "active_from_FileUpload-css_324"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/action/IconButton.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".button_from_IconButton-css_1cK {\r\n    position: relative;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    outline: none;\r\n    z-index: 2;\r\n    padding: 0 16px\r\n}\r\n\r\n.button_from_IconButton-css_1cK.noPadding_from_IconButton-css_VZz {\r\n    padding: 0\r\n}\r\n\r\n.button_from_IconButton-css_1cK.noPadding_from_IconButton-css_VZz .label_from_IconButton-css_kYE {\r\n    top: 0;\r\n    right: 24px;\r\n}\r\n\r\n.button_from_IconButton-css_1cK:active .label_from_IconButton-css_kYE, .button_from_IconButton-css_1cK:focus .label_from_IconButton-css_kYE, .button_from_IconButton-css_1cK:hover .label_from_IconButton-css_kYE {\r\n    opacity: 1;\r\n    width: auto;\r\n    color: #496DF4;\r\n    -webkit-transform: translateX(0px);\r\n            transform: translateX(0px);\r\n}\r\n\r\n.button_from_IconButton-css_1cK:active .icon_from_IconButton-css_20W, .button_from_IconButton-css_1cK:focus .icon_from_IconButton-css_20W, .button_from_IconButton-css_1cK:hover .icon_from_IconButton-css_20W {\r\n    border-color: #496DF4;\r\n}\r\n\r\n.button_from_IconButton-css_1cK:active.labelOnRight_from_IconButton-css_tMf .label_from_IconButton-css_kYE, .button_from_IconButton-css_1cK:focus.labelOnRight_from_IconButton-css_tMf .label_from_IconButton-css_kYE, .button_from_IconButton-css_1cK:hover.labelOnRight_from_IconButton-css_tMf .label_from_IconButton-css_kYE {\r\n    -webkit-transform: translateX(0px);\r\n            transform: translateX(0px);\r\n}\r\n\r\n.button_from_IconButton-css_1cK.alwaysVisible_from_IconButton-css_2VJ .label_from_IconButton-css_kYE {\r\n    position: relative;\r\n    top: 0;\r\n    right: auto;\r\n    left: 0;\r\n    opacity: 1;\r\n    width: auto;\r\n    color: #496DF4;\r\n    -webkit-transform: translateX(0px);\r\n            transform: translateX(0px);\r\n}\r\n\r\n.button_from_IconButton-css_1cK.labelOnRight_from_IconButton-css_tMf {\r\n    -webkit-box-pack: end;\r\n        -ms-flex-pack: end;\r\n            justify-content: flex-end\r\n}\r\n\r\n.button_from_IconButton-css_1cK.labelOnRight_from_IconButton-css_tMf .label_from_IconButton-css_kYE {\r\n    left: 40px;\r\n    right: auto;\r\n    -webkit-transform: translateX(-6px);\r\n            transform: translateX(-6px);\r\n}\r\n\r\n.button_from_IconButton-css_1cK.labelOnRight_from_IconButton-css_tMf.alwaysVisible_from_IconButton-css_2VJ .label_from_IconButton-css_kYE {\r\n    left: auto;\r\n    right: 0;\r\n    -webkit-transform: translateX(0px);\r\n            transform: translateX(0px);\r\n}\r\n\r\n.label_from_IconButton-css_kYE {\r\n    position: absolute;\r\n    display: inline-block;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    z-index: 1;\r\n    width: 0;\r\n    height: 24px;\r\n    padding: 6px;\r\n    background: #F8FCFD;\r\n    right: 40px;\r\n    top: 0;\r\n    font-size: 0.9em;\r\n    color: #2B2C2F;\r\n    opacity: 0;\r\n    -webkit-transform: translateX(6px);\r\n            transform: translateX(6px);\r\n    -webkit-transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        300ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        300ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        300ms transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        300ms transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000),\r\n        300ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n}\r\n\r\n.icon_from_IconButton-css_20W {\r\n    position: relative;\r\n    z-index: 2;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    width: 24px;\r\n    height: 24px;\r\n    border: 1px solid #E9EBEB;\r\n    border-radius: 1px;\r\n    -webkit-transition: 250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.icon_from_IconButton-css_20W img {\r\n    width: 18px;\r\n    height: 18px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"button": "button_from_IconButton-css_1cK",
	"noPadding": "noPadding_from_IconButton-css_VZz",
	"label": "label_from_IconButton-css_kYE",
	"icon": "icon_from_IconButton-css_20W",
	"labelOnRight": "labelOnRight_from_IconButton-css_tMf",
	"alwaysVisible": "alwaysVisible_from_IconButton-css_2VJ"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/action/Search.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".container_from_Search-css_oZp {\r\n    display: inline-block;\r\n}\r\n\r\n.wrapper_from_Search-css_25B {\r\n    width: 100%;\r\n    position: relative;\r\n    display: -webkit-inline-box;\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: reverse;\r\n        -ms-flex-direction: row-reverse;\r\n            flex-direction: row-reverse;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: end;\r\n        align-content: flex-end;\r\n    -webkit-box-align: end;\r\n        -ms-flex-align: end;\r\n            align-items: flex-end;\r\n}\r\n\r\n.label_from_Search-css_3rF {\r\n    position: absolute;\r\n    bottom: 28px;\r\n    left: 12px;\r\n    font-size: 0.625em;\r\n    font-weight: 400;\r\n    color: #6F7583;\r\n    padding: 3px 6px;\r\n    background: none\r\n}\r\n\r\n.label_from_Search-css_3rF > span {\r\n    position: relative;\r\n    color: inherit;\r\n    z-index: 3;\r\n}\r\n\r\n.label_from_Search-css_3rF::after {\r\n    content: '';\r\n    display: block;\r\n    position: absolute;\r\n    z-index: 2;\r\n    top: 9px;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 1px;\r\n    background: #FFFFFF;\r\n}\r\n\r\n.field_from_Search-css_3iN {\r\n    text-align: left;\r\n    -webkit-box-ordinal-group: 3;\r\n        -ms-flex-order: 2;\r\n            order: 2;\r\n}\r\n\r\n.options_from_Search-css_2jb {\r\n    -webkit-box-ordinal-group: 4;\r\n        -ms-flex-order: 3;\r\n            order: 3;\r\n}\r\n\r\n.clearButton_from_Search-css_2Ur {\r\n    -webkit-box-ordinal-group: 2;\r\n        -ms-flex-order: 1;\r\n            order: 1;\r\n    cursor: default;\r\n    pointer-events: none;\r\n    padding: 0;\r\n    opacity: 0;\r\n    width: 0px;\r\n    -webkit-transition: 250ms width 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 250ms width 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.clearButton_from_Search-css_2Ur.visible_from_Search-css_2Vz {\r\n    cursor: pointer;\r\n    pointer-events: all;\r\n    width: 38px;\r\n    opacity: 1;\r\n}\r\n\r\n.clearButton_from_Search-css_2Ur .clearIcon_from_Search-css_18H {\r\n    width: 38px;\r\n    height: 38px;\r\n}\r\n\r\n.clearButton_from_Search-css_2Ur .clearLabel_from_Search-css_1L_ {\r\n    height: 28px;\r\n    top: 7px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "container_from_Search-css_oZp",
	"wrapper": "wrapper_from_Search-css_25B",
	"label": "label_from_Search-css_3rF",
	"field": "field_from_Search-css_3iN",
	"options": "options_from_Search-css_2jb",
	"clearButton": "clearButton_from_Search-css_2Ur",
	"visible": "visible_from_Search-css_2Vz",
	"clearIcon": "clearIcon_from_Search-css_18H",
	"clearLabel": "clearLabel_from_Search-css_1L_"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/action/Toggle.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".toggle_from_Toggle-css_2m1 {\r\n  position: relative;\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -webkit-box-pack: justify;\r\n      -ms-flex-pack: justify;\r\n          justify-content: space-between;\r\n  -ms-flex-line-pack: stretch;\r\n      align-content: stretch;\r\n  -webkit-box-align: stretch;\r\n      -ms-flex-align: stretch;\r\n          align-items: stretch;\r\n  outline: none;\r\n  cursor: pointer;\r\n  background: #FFFFFF;\r\n  border: 1px solid #E9EBEB;\r\n  border-radius: 1px;\r\n  -webkit-transition: 250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\n.toggle_from_Toggle-css_2m1:hover,\r\n  .toggle_from_Toggle-css_2m1:focus,\r\n  .toggle_from_Toggle-css_2m1:active {\r\n  border-color: #DCDEDE\r\n}\n.toggle_from_Toggle-css_2m1:hover .slider_from_Toggle-css_34r, .toggle_from_Toggle-css_2m1:focus .slider_from_Toggle-css_34r, .toggle_from_Toggle-css_2m1:active .slider_from_Toggle-css_34r {\r\n  border-color: #FFFFFF;\r\n  color: #496DF4\r\n}\n.toggle_from_Toggle-css_2m1:hover .slider_from_Toggle-css_34r .ridge_from_Toggle-css_2Mu, .toggle_from_Toggle-css_2m1:focus .slider_from_Toggle-css_34r .ridge_from_Toggle-css_2Mu, .toggle_from_Toggle-css_2m1:active .slider_from_Toggle-css_34r .ridge_from_Toggle-css_2Mu {\r\n  background: #496DF4;\r\n}\n.toggle_from_Toggle-css_2m1 > p {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  text-align: center;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  font-size: 0.825em;\r\n  font-weight: 700;\r\n  color: #2B2C2F;\r\n  min-width: 64px;\r\n  width: auto;\r\n  height: 38px\r\n}\n.toggle_from_Toggle-css_2m1 > p.important_from_Toggle-css_3mm {\r\n  color: #EC7B65;\r\n}\n.toggle_from_Toggle-css_2m1 > p.success_from_Toggle-css_28l {\r\n  color: #25AC7F;\r\n}\n.toggle_from_Toggle-css_2m1 > p span {\r\n  font-size: inherit;\r\n  font-weight: inherit;\r\n  color: inherit;\r\n}\n.toggle_from_Toggle-css_2m1 .slider_from_Toggle-css_34r {\r\n  cursor: pointer;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  text-align: center;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  position: absolute;\r\n  font-size: 0.825em;\r\n  font-weight: 600;\r\n  font-style: normal;\r\n  color: #2B2C2F;\r\n  top: 0;\r\n  left: 0;\r\n  width: 0px;\r\n  height: 100%;\r\n  border: 1px solid #E9EBEB;\r\n  background: #E9EBEB;\r\n  -webkit-box-shadow: 0px 0px 16px rgba(43, 44, 47, 0.05);\r\n          box-shadow: 0px 0px 16px rgba(43, 44, 47, 0.05);\r\n  -webkit-transition: 300ms width 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000),\r\n                300ms left 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000),\r\n                300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                300ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 300ms width 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000),\r\n                300ms left 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000),\r\n                300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                300ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\n.toggle_from_Toggle-css_2m1 .slider_from_Toggle-css_34r p {\r\n  -webkit-transition: 300ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 300ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  color: inherit;\r\n}\n.toggle_from_Toggle-css_2m1 .slider_from_Toggle-css_34r .ridge_from_Toggle-css_2Mu {\r\n  position: absolute;\r\n  top: 35%;\r\n  height: 30%;\r\n  left: 50%;\r\n  width: 1px;\r\n  background: #A0A3A3;\r\n  margin-left: 0px;\r\n  -webkit-transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\n.toggle_from_Toggle-css_2m1 .slider_from_Toggle-css_34r .ridge_from_Toggle-css_2Mu.hidden_from_Toggle-css_2Kd {\r\n  display: none;\r\n}\n.toggle_from_Toggle-css_2m1 .slider_from_Toggle-css_34r .ridge_from_Toggle-css_2Mu.ridgeLeft_from_Toggle-css_i1K {\r\n  margin-left: -3px;\r\n}\n.toggle_from_Toggle-css_2m1 .slider_from_Toggle-css_34r .ridge_from_Toggle-css_2Mu.ridgeRight_from_Toggle-css_Lqq {\r\n  margin-left: 3px;\r\n}\n.toggle_from_Toggle-css_2m1.isUnknown_from_Toggle-css_WU- .slider_from_Toggle-css_34r {\r\n  background: #FFFFFF;\r\n  border-color: #FFFFFF\r\n}\n.toggle_from_Toggle-css_2m1.isUnknown_from_Toggle-css_WU- .slider_from_Toggle-css_34r:hover {\r\n  background: #E9EBEB;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"toggle": "toggle_from_Toggle-css_2m1",
	"slider": "slider_from_Toggle-css_34r",
	"ridge": "ridge_from_Toggle-css_2Mu",
	"important": "important_from_Toggle-css_3mm",
	"success": "success_from_Toggle-css_28l",
	"hidden": "hidden_from_Toggle-css_2Kd",
	"ridgeLeft": "ridgeLeft_from_Toggle-css_i1K",
	"ridgeRight": "ridgeRight_from_Toggle-css_Lqq",
	"isUnknown": "isUnknown_from_Toggle-css_WU-"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/activity/Activities.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".activityGroup_from_Activities-css_3Tq {\r\n    width: 100%;\r\n    height: auto;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-flex: 0;\r\n        -ms-flex: none;\r\n            flex: none;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    -ms-flex-wrap: nowrap;\r\n        flex-wrap: nowrap;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: start;\r\n        align-content: flex-start;\r\n    -webkit-box-align: start;\r\n        -ms-flex-align: start;\r\n            align-items: flex-start\r\n}\r\n\r\n.activityGroup_from_Activities-css_3Tq:last-child {\r\n    border: none;\r\n}\r\n\r\n.activityGroup_from_Activities-css_3Tq:first-child {\r\n    border-top: 1px solid #E9EBEB;\r\n}\r\n\r\n.activityGroup_from_Activities-css_3Tq .groupTitle_from_Activities-css_2F3 {\r\n    display: block;\r\n    background: rgb(250, 254, 255);\r\n    border-bottom: 1px dashed #E9EBEB;\r\n    padding: 24px 32px;\r\n    height: auto;\r\n    width: 100%;\r\n    font-weight: 600;\r\n    font-size: 1.1em;\r\n    color: #EC7B65;\r\n}\r\n\r\n.activityGroup_from_Activities-css_3Tq .groupList_from_Activities-css_1Zk {\r\n    display: block;\r\n    width: 100%\r\n}\r\n\r\n.activityGroup_from_Activities-css_3Tq .groupList_from_Activities-css_1Zk > div {\r\n    border-bottom: 1px solid #E9EBEB;\r\n    padding: 16px 32px;\r\n}\r\n\r\n.activityGroup_from_Activities-css_3Tq.activityGroupWide_from_Activities-css_frX {\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -ms-flex-wrap: nowrap;\r\n        flex-wrap: nowrap;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -ms-flex-line-pack: stretch;\r\n        align-content: stretch;\r\n    -webkit-box-align: stretch;\r\n        -ms-flex-align: stretch;\r\n            align-items: stretch\r\n}\r\n\r\n.activityGroup_from_Activities-css_3Tq.activityGroupWide_from_Activities-css_frX .groupTitle_from_Activities-css_2F3 {\r\n    height: auto;\r\n    width: 30%;\r\n    background: none;\r\n    border-bottom: 1px solid #E9EBEB;\r\n}\r\n\r\n.activityGroup_from_Activities-css_3Tq.activityGroupWide_from_Activities-css_frX .groupList_from_Activities-css_1Zk {\r\n    height: auto;\r\n    width: 70%;\r\n    border-left: 1px solid #E9EBEB;\r\n}\r\n\r\n.activityGroup_from_Activities-css_3Tq.activitiesAllFinished_from_Activities-css_2xY .groupTitle_from_Activities-css_2F3 {\r\n    color: #18A073;\r\n}\r\n\r\n.activityGroup_from_Activities-css_3Tq.dashboardActivities {\r\n    -webkit-box-flex: 0;\r\n        -ms-flex: 0 1 auto;\r\n            flex: 0 1 auto\r\n}\r\n\r\n.activityGroup_from_Activities-css_3Tq.dashboardActivities .groupTitle_from_Activities-css_2F3 {\r\n    background: none;\r\n}\r\n\r\n.activityGroup_from_Activities-css_3Tq.dashboardActivities .activity_from_Activities-css_sTG {\r\n    background: #F2F2F2\r\n}\r\n\r\n.activityGroup_from_Activities-css_3Tq.dashboardActivities .activity_from_Activities-css_sTG:hover {\r\n    background: #F7FDFF;\r\n}\r\n\r\n.activity_from_Activities-css_sTG {\r\n    cursor: pointer;\r\n    position: relative;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: start;\r\n        -ms-flex-align: start;\r\n            align-items: flex-start;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    width: 100%;\r\n    background: #F7FDFF;\r\n    -webkit-transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.activity_from_Activities-css_sTG:hover {\r\n    background: #F2F2F2;\r\n}\r\n\r\n.activity_from_Activities-css_sTG .activityTime_from_Activities-css_z8F {\r\n    color: #6F7583;\r\n    font-weight: 400;\r\n    font-size: 0.675em\r\n}\r\n\r\n.activity_from_Activities-css_sTG .activityTime_from_Activities-css_z8F strong {\r\n    font-weight: 600;\r\n}\r\n\r\n.activity_from_Activities-css_sTG .activityTime_from_Activities-css_z8F span {\r\n    margin-left: 3px;\r\n    font-weight: 400;\r\n}\r\n\r\n.activity_from_Activities-css_sTG .activityTitle_from_Activities-css_1F9 {\r\n    color: #2A5798;\r\n    font-weight: 400;\r\n    font-size: 1.275em;\r\n    margin-top: 3px;\r\n}\r\n\r\n.activity_from_Activities-css_sTG .activityNote_from_Activities-css_1i- {\r\n    font-weight: 600;\r\n    font-size: 0.875em;\r\n    line-height: 1.125;\r\n    color: #2B2C2F;\r\n    margin-top: 6px;\r\n}\r\n\r\n.activity_from_Activities-css_sTG .activityAuthorAndLead_from_Activities-css_2Pw {\r\n    color: #6F7583;\r\n    font-weight: 400;\r\n    font-size: 0.725em;\r\n    margin-top: 6px;\r\n}\r\n\r\n.activity_from_Activities-css_sTG.activityWide_from_Activities-css_X0W {\r\n    padding: 16px 24px;\r\n    background: none;\r\n    cursor: default;\r\n}\r\n\r\n.activity_from_Activities-css_sTG .editActivity_from_Activities-css_3qE {\r\n    position: absolute;\r\n    right: 12px;\r\n    top: 12px;\r\n}\r\n\r\n.activity_from_Activities-css_sTG .markAsComplete_from_Activities-css_3WX {\r\n    position: absolute;\r\n    right: 12px;\r\n    bottom: 12px\r\n}\r\n\r\n.activity_from_Activities-css_sTG .markAsComplete_from_Activities-css_3WX .markAsCompleteIcon_from_Activities-css_Jat img {\r\n    width: 15px;\r\n    height: 15px;\r\n    position: relative;\r\n    top: 2px;\r\n    left: 2px;\r\n}\r\n\r\n.activity_from_Activities-css_sTG .markingAsComplete_from_Activities-css_es_ {\r\n    z-index: 2;\r\n    position: absolute;\r\n    right: 24px;\r\n    top: 16px;\r\n}\r\n\r\n.activity_from_Activities-css_sTG.finished_from_Activities-css_2ut .activityTime_from_Activities-css_z8F {\r\n    color: #A0A3A3;\r\n}\r\n\r\n.activity_from_Activities-css_sTG.finished_from_Activities-css_2ut .activityTitle_from_Activities-css_1F9 {\r\n    color: #6F7583;\r\n    font-weight: 400;\r\n}\r\n\r\n.activity_from_Activities-css_sTG.finished_from_Activities-css_2ut .activityNote_from_Activities-css_1i- {\r\n    color: #6F7583;\r\n    font-weight: 400;\r\n}\r\n\r\n.activity_from_Activities-css_sTG.finished_from_Activities-css_2ut .markAsComplete_from_Activities-css_3WX .markAsCompleteIcon_from_Activities-css_Jat img {\r\n    width: 17px;\r\n    height: 17px;\r\n    position: relative;\r\n    top: 1px;\r\n    left: 1px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"activityGroup": "activityGroup_from_Activities-css_3Tq",
	"groupTitle": "groupTitle_from_Activities-css_2F3",
	"groupList": "groupList_from_Activities-css_1Zk",
	"activityGroupWide": "activityGroupWide_from_Activities-css_frX",
	"activitiesAllFinished": "activitiesAllFinished_from_Activities-css_2xY",
	"activity": "activity_from_Activities-css_sTG",
	"activityTime": "activityTime_from_Activities-css_z8F",
	"activityTitle": "activityTitle_from_Activities-css_1F9",
	"activityNote": "activityNote_from_Activities-css_1i-",
	"activityAuthorAndLead": "activityAuthorAndLead_from_Activities-css_2Pw",
	"activityWide": "activityWide_from_Activities-css_X0W",
	"editActivity": "editActivity_from_Activities-css_3qE",
	"markAsComplete": "markAsComplete_from_Activities-css_3WX",
	"markAsCompleteIcon": "markAsCompleteIcon_from_Activities-css_Jat",
	"markingAsComplete": "markingAsComplete_from_Activities-css_es_",
	"finished": "finished_from_Activities-css_2ut"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/activity/ActivityCreateOrEdit.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".define_from_ActivityCreateOrEdit-css_HIB {\r\n    position: relative;\r\n    padding: 24px;\r\n}\r\n\r\n.row_from_ActivityCreateOrEdit-css_1D1 {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: start;\r\n        align-content: flex-start;\r\n    -webkit-box-align: start;\r\n        -ms-flex-align: start;\r\n            align-items: flex-start\r\n}\r\n\r\n.row_from_ActivityCreateOrEdit-css_1D1 > .col_from_ActivityCreateOrEdit-css_D9W {\r\n    -webkit-box-flex: 0;\r\n        -ms-flex: 0 1 auto;\r\n            flex: 0 1 auto;\r\n    padding-right: 32px;\r\n}\r\n\r\n.row_from_ActivityCreateOrEdit-css_1D1 > .col_from_ActivityCreateOrEdit-css_D9W > .comp-dropdown-label_from_ActivityCreateOrEdit-css_3GX p span {\r\n    white-space: nowrap;\r\n}\r\n\r\n.row_from_ActivityCreateOrEdit-css_1D1 > .col_from_ActivityCreateOrEdit-css_D9W:last-child {\r\n    padding-right: 0;\r\n}\r\n\r\n.row_from_ActivityCreateOrEdit-css_1D1 > .col_from_ActivityCreateOrEdit-css_D9W > p {\r\n    font-size: 0.725em;\r\n    font-weight: 400;\r\n    color: #6F7583;\r\n    padding-bottom: 12px;\r\n}\r\n\r\n.details_from_ActivityCreateOrEdit-css_2e6 {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n            justify-content: space-between;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: start;\r\n        align-content: flex-start;\r\n    margin-top: 12px;\r\n    width: 100%\r\n}\r\n\r\n.details_from_ActivityCreateOrEdit-css_2e6 .descriptionContainer_from_ActivityCreateOrEdit-css_2Tj {\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1 0;\r\n            flex: 1 0;\r\n}\r\n\r\n.details_from_ActivityCreateOrEdit-css_2e6 .description_from_ActivityCreateOrEdit-css_39r {\r\n    min-height: 58px;\r\n    background: #FFFFFF;\r\n    border: 1px solid #E9EBEB;\r\n    border-radius: 1px;\r\n    outline: none;\r\n    padding: 12px 16px;\r\n    font-size: 0.825em;\r\n    color: #2B2C2F;\r\n    -webkit-transition: 250ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 250ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.details_from_ActivityCreateOrEdit-css_2e6 .description_from_ActivityCreateOrEdit-css_39r:hover,\r\n        .details_from_ActivityCreateOrEdit-css_2e6 .description_from_ActivityCreateOrEdit-css_39r:focus,\r\n        .details_from_ActivityCreateOrEdit-css_2e6 .description_from_ActivityCreateOrEdit-css_39r:active {\r\n    background: #E9EBEB;\r\n}\r\n\r\n.details_from_ActivityCreateOrEdit-css_2e6 .description_from_ActivityCreateOrEdit-css_39r:focus,\r\n        .details_from_ActivityCreateOrEdit-css_2e6 .description_from_ActivityCreateOrEdit-css_39r:active {\r\n    background: #FFFFFF;\r\n    border-color: #DCDEDE;\r\n}\r\n\r\n.details_from_ActivityCreateOrEdit-css_2e6 .saveButton_from_ActivityCreateOrEdit-css_1DM {\r\n    -webkit-box-flex: 0;\r\n        -ms-flex: 0 1 auto;\r\n            flex: 0 1 auto;\r\n}\r\n\r\n.savingIndicator_from_ActivityCreateOrEdit-css_Lec {\r\n    position: absolute;\r\n    right: 16px;\r\n    top: 16px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"define": "define_from_ActivityCreateOrEdit-css_HIB",
	"row": "row_from_ActivityCreateOrEdit-css_1D1",
	"col": "col_from_ActivityCreateOrEdit-css_D9W",
	"comp-dropdown-label": "comp-dropdown-label_from_ActivityCreateOrEdit-css_3GX",
	"details": "details_from_ActivityCreateOrEdit-css_2e6",
	"descriptionContainer": "descriptionContainer_from_ActivityCreateOrEdit-css_2Tj",
	"description": "description_from_ActivityCreateOrEdit-css_39r",
	"saveButton": "saveButton_from_ActivityCreateOrEdit-css_1DM",
	"savingIndicator": "savingIndicator_from_ActivityCreateOrEdit-css_Lec"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/calendar/DatePickerCalendar.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".calendar_from_DatePickerCalendar-css_e4a {\r\n  width: 100%;\r\n  max-width: 318px;\r\n  background: #F5F7F7;\r\n}\r\n\r\n.row_from_DatePickerCalendar-css_Tqb {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-wrap: nowrap;\r\n      flex-wrap: nowrap;\r\n  -webkit-box-pack: justify;\r\n      -ms-flex-pack: justify;\r\n          justify-content: space-between;\r\n  -ms-flex-line-pack: justify;\r\n      align-content: space-between;\r\n  margin-left: -16px;\r\n  margin-right: -16px\r\n}\r\n\r\n.row_from_DatePickerCalendar-css_Tqb.noGutter_from_DatePickerCalendar-css_cZL {\r\n  margin-left: 0;\r\n  margin-right: 0;\r\n}\r\n\r\n.row_from_DatePickerCalendar-css_Tqb > .col_from_DatePickerCalendar-css_E_8 {\r\n  padding: 0 16px;\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 0 auto;\r\n          flex: 1 0 auto;\r\n}\r\n\r\n.row_from_DatePickerCalendar-css_Tqb > .col_from_DatePickerCalendar-css_E_8.noGutter_from_DatePickerCalendar-css_cZL {\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n}\r\n\r\n.row_from_DatePickerCalendar-css_Tqb.navigation_from_DatePickerCalendar-css_3nn {\r\n  background: #E9EBEB;\r\n  border-bottom: 1px solid #DCDEDE;\r\n  margin-left: 0;\r\n  margin-right: 0;\r\n  -ms-flex-line-pack: stretch;\r\n      align-content: stretch;\r\n  -webkit-box-align: stretch;\r\n      -ms-flex-align: stretch;\r\n          align-items: stretch\r\n}\r\n\r\n.row_from_DatePickerCalendar-css_Tqb.navigation_from_DatePickerCalendar-css_3nn > .col_from_DatePickerCalendar-css_E_8 {\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n  text-align: center;\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 0 auto;\r\n          flex: 1 0 auto;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: justify;\r\n      -ms-flex-pack: justify;\r\n          justify-content: space-between;\r\n  -ms-flex-line-pack: stretch;\r\n      align-content: stretch;\r\n  -webkit-box-align: stretch;\r\n      -ms-flex-align: stretch;\r\n          align-items: stretch;\r\n}\r\n\r\n.row_from_DatePickerCalendar-css_Tqb.navigation_from_DatePickerCalendar-css_3nn > .col_from_DatePickerCalendar-css_E_8:first-child,\r\n    .row_from_DatePickerCalendar-css_Tqb.navigation_from_DatePickerCalendar-css_3nn > .col_from_DatePickerCalendar-css_E_8:last-child {\r\n  -webkit-box-flex: 0;\r\n      -ms-flex: 0 1 auto;\r\n          flex: 0 1 auto;\r\n}\r\n\r\n.row_from_DatePickerCalendar-css_Tqb.navigation_from_DatePickerCalendar-css_3nn > .col_from_DatePickerCalendar-css_E_8:first-child button, .row_from_DatePickerCalendar-css_Tqb.navigation_from_DatePickerCalendar-css_3nn > .col_from_DatePickerCalendar-css_E_8:last-child button {\r\n  padding: 0 24px;\r\n  border-bottom: 1px solid transparent;\r\n  -webkit-transition: 250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.row_from_DatePickerCalendar-css_Tqb.navigation_from_DatePickerCalendar-css_3nn > .col_from_DatePickerCalendar-css_E_8:first-child button:hover, .row_from_DatePickerCalendar-css_Tqb.navigation_from_DatePickerCalendar-css_3nn > .col_from_DatePickerCalendar-css_E_8:last-child button:hover {\r\n  border-bottom-color: #496DF4;\r\n}\r\n\r\n.row_from_DatePickerCalendar-css_Tqb.navigation_from_DatePickerCalendar-css_3nn > .col_from_DatePickerCalendar-css_E_8:first-child img, .row_from_DatePickerCalendar-css_Tqb.navigation_from_DatePickerCalendar-css_3nn > .col_from_DatePickerCalendar-css_E_8:last-child img {\r\n  max-width: none;\r\n  width: 17px;\r\n  height: 14px;\r\n}\r\n\r\n.row_from_DatePickerCalendar-css_Tqb.navigation_from_DatePickerCalendar-css_3nn > .col_from_DatePickerCalendar-css_E_8 .daysMonthsToggle_from_DatePickerCalendar-css_3gg {\r\n  margin: 0 auto;\r\n  padding: 16px 0;\r\n  text-transform: uppercase;\r\n  font-size: 0.925em;\r\n  font-weight: 600;\r\n  color: #2E3D73;\r\n  border-bottom: 1px solid transparent;\r\n  -webkit-transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                  250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                  250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.row_from_DatePickerCalendar-css_Tqb.navigation_from_DatePickerCalendar-css_3nn > .col_from_DatePickerCalendar-css_E_8 .daysMonthsToggle_from_DatePickerCalendar-css_3gg:hover {\r\n  color: #496DF4;\r\n  border-bottom-color: #496DF4;\r\n}\r\n\r\n.row_from_DatePickerCalendar-css_Tqb.weekDays_from_DatePickerCalendar-css_2Cy {\r\n  padding: 0;\r\n  margin-left: 0;\r\n  margin-right: 0;\r\n  -ms-flex-pack: distribute;\r\n      justify-content: space-around;\r\n  border-bottom: 1px solid #E9EBEB\r\n}\r\n\r\n.row_from_DatePickerCalendar-css_Tqb.weekDays_from_DatePickerCalendar-css_2Cy > .col_from_DatePickerCalendar-css_E_8 {\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 0 auto;\r\n          flex: 1 0 auto;\r\n  padding: 0;\r\n  background: rgb(226, 228, 228);\r\n  border-left: 1px solid rgb(212, 216, 216);\r\n  border-bottom: 4px solid rgb(212, 216, 216);\r\n}\r\n\r\n.row_from_DatePickerCalendar-css_Tqb.weekDays_from_DatePickerCalendar-css_2Cy > .col_from_DatePickerCalendar-css_E_8:first-child {\r\n  border-left: none;\r\n}\r\n\r\n.row_from_DatePickerCalendar-css_Tqb.weekDays_from_DatePickerCalendar-css_2Cy > .col_from_DatePickerCalendar-css_E_8:first-child > p {\r\n  padding-left: 12px;\r\n}\r\n\r\n.row_from_DatePickerCalendar-css_Tqb.weekDays_from_DatePickerCalendar-css_2Cy > .col_from_DatePickerCalendar-css_E_8:last-child > p {\r\n  padding-right: 12px;\r\n}\r\n\r\n.row_from_DatePickerCalendar-css_Tqb.weekDays_from_DatePickerCalendar-css_2Cy > .col_from_DatePickerCalendar-css_E_8 > p {\r\n  border-bottom: 1px solid #E9EBEB;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  display: block;\r\n  width: 100%;\r\n  padding: 6px 0;\r\n  text-align: center;\r\n  text-transform: uppercase;\r\n  font-size: 0.725em;\r\n  font-weight: 600;\r\n  color: #444956;\r\n}\r\n\r\n.days_from_DatePickerCalendar-css_26m {\r\n  padding: 12px 0\r\n}\r\n\r\n.days_from_DatePickerCalendar-css_26m > .row_from_DatePickerCalendar-css_Tqb {\r\n  margin-left: 0;\r\n  margin-right: 0;\r\n  padding: 6px 24px;\r\n  -webkit-box-pack: justify;\r\n      -ms-flex-pack: justify;\r\n          justify-content: space-between;\r\n}\r\n\r\n.days_from_DatePickerCalendar-css_26m > .row_from_DatePickerCalendar-css_Tqb > .col_from_DatePickerCalendar-css_E_8 {\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 0 auto;\r\n          flex: 1 0 auto;\r\n  padding: 0;\r\n}\r\n\r\n.days_from_DatePickerCalendar-css_26m > .row_from_DatePickerCalendar-css_Tqb > .col_from_DatePickerCalendar-css_E_8 > button {\r\n  cursor: pointer;\r\n  display: block;\r\n  text-align: center;\r\n  line-height: 38px;\r\n  height: 36px;\r\n  width: 36px;\r\n  padding: 0;\r\n  border: none;\r\n  color: #2E3D73;\r\n  font-size: 0.875em;\r\n  font-weight: 600;\r\n  border-radius: 50%;\r\n  background: transparent;\r\n  -webkit-transition: 300ms background 0ms cubic-bezier(0.455, 0.03, 0.515, 0.955),\r\n                    300ms color 0ms cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  transition: 300ms background 0ms cubic-bezier(0.455, 0.03, 0.515, 0.955),\r\n                    300ms color 0ms cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n}\r\n\r\n.days_from_DatePickerCalendar-css_26m > .row_from_DatePickerCalendar-css_Tqb > .col_from_DatePickerCalendar-css_E_8 > button:hover {\r\n  background: rgb(220, 224, 224);\r\n  color: #496DF4;\r\n}\r\n\r\n.days_from_DatePickerCalendar-css_26m > .row_from_DatePickerCalendar-css_Tqb > .col_from_DatePickerCalendar-css_E_8 > button.daySelected_from_DatePickerCalendar-css_12L {\r\n  background: rgb(226, 228, 228);\r\n  color: #496DF4;\r\n  cursor: default;\r\n}\r\n\r\n.days_from_DatePickerCalendar-css_26m > .row_from_DatePickerCalendar-css_Tqb > .col_from_DatePickerCalendar-css_E_8 > button.dayNotCurrentMonth_from_DatePickerCalendar-css_3vw {\r\n  background: transparent;\r\n  color: #A0A3A3;\r\n}\r\n\r\n.days_from_DatePickerCalendar-css_26m > .row_from_DatePickerCalendar-css_Tqb > .col_from_DatePickerCalendar-css_E_8 > button.dayNotCurrentMonth_from_DatePickerCalendar-css_3vw:hover {\r\n  background: rgb(220, 224, 224);\r\n  color: #496DF4;\r\n}\r\n\r\n.days_from_DatePickerCalendar-css_26m > .row_from_DatePickerCalendar-css_Tqb > .col_from_DatePickerCalendar-css_E_8 > button.dayToday_from_DatePickerCalendar-css_3IN {\r\n  position: relative;\r\n}\r\n\r\n.days_from_DatePickerCalendar-css_26m > .row_from_DatePickerCalendar-css_Tqb > .col_from_DatePickerCalendar-css_E_8 > button.dayToday_from_DatePickerCalendar-css_3IN::after {\r\n  content: \"\";\r\n  display: block;\r\n  position: absolute;\r\n  top: -6px;\r\n  left: 50%;\r\n  margin-left: -2px;\r\n  width: 4px;\r\n  height: 4px;\r\n  background: #496DF4;\r\n}\r\n\r\n.months_from_DatePickerCalendar-css_65H {\r\n  padding: 48px 0\r\n}\r\n\r\n.months_from_DatePickerCalendar-css_65H > .row_from_DatePickerCalendar-css_Tqb {\r\n  margin-left: 0;\r\n  margin-right: 0;\r\n  padding: 8px 24px;\r\n  -webkit-box-pack: justify;\r\n      -ms-flex-pack: justify;\r\n          justify-content: space-between;\r\n}\r\n\r\n.months_from_DatePickerCalendar-css_65H > .row_from_DatePickerCalendar-css_Tqb > .col_from_DatePickerCalendar-css_E_8 {\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 0 50%;\r\n          flex: 1 0 50%;\r\n  padding: 0;\r\n}\r\n\r\n.months_from_DatePickerCalendar-css_65H > .row_from_DatePickerCalendar-css_Tqb > .col_from_DatePickerCalendar-css_E_8 > button {\r\n  cursor: pointer;\r\n  display: block;\r\n  text-align: center;\r\n  padding: 0;\r\n  margin: 0 auto;\r\n  border: none;\r\n  color: #496DF4;\r\n  font-size: 1.0em;\r\n  font-weight: 400;\r\n  background: transparent;\r\n  border-bottom: 1px solid transparent;\r\n  -webkit-transition: 250ms border 0ms cubic-bezier(0.420, 0.000, 0.580, 1.000);\r\n  transition: 250ms border 0ms cubic-bezier(0.420, 0.000, 0.580, 1.000);\r\n}\r\n\r\n.months_from_DatePickerCalendar-css_65H > .row_from_DatePickerCalendar-css_Tqb > .col_from_DatePickerCalendar-css_E_8 > button:hover {\r\n  border-bottom-color: #496DF4;\r\n}\r\n\r\n.months_from_DatePickerCalendar-css_65H > .row_from_DatePickerCalendar-css_Tqb > .col_from_DatePickerCalendar-css_E_8 > button.monthSelected_from_DatePickerCalendar-css_3jH {\r\n  color: #A0A3A3;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"calendar": "calendar_from_DatePickerCalendar-css_e4a",
	"row": "row_from_DatePickerCalendar-css_Tqb",
	"noGutter": "noGutter_from_DatePickerCalendar-css_cZL",
	"col": "col_from_DatePickerCalendar-css_E_8",
	"navigation": "navigation_from_DatePickerCalendar-css_3nn",
	"daysMonthsToggle": "daysMonthsToggle_from_DatePickerCalendar-css_3gg",
	"weekDays": "weekDays_from_DatePickerCalendar-css_2Cy",
	"days": "days_from_DatePickerCalendar-css_26m",
	"daySelected": "daySelected_from_DatePickerCalendar-css_12L",
	"dayNotCurrentMonth": "dayNotCurrentMonth_from_DatePickerCalendar-css_3vw",
	"dayToday": "dayToday_from_DatePickerCalendar-css_3IN",
	"months": "months_from_DatePickerCalendar-css_65H",
	"monthSelected": "monthSelected_from_DatePickerCalendar-css_3jH"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/calendar/DatePickerDropdown.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".summary_from_DatePickerDropdown-css_3wi {\r\n    position: relative;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    width: 100%;\r\n    height: 40px;\r\n    text-align: center;\r\n    background: rgb(249, 250, 250);\r\n    border-top: 1px solid #E9EBEB\r\n}\n.summary_from_DatePickerDropdown-css_3wi > div {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    height: 100%;\r\n    padding: 0 6px;\r\n    border-left: 1px solid #E9EBEB\r\n}\n.summary_from_DatePickerDropdown-css_3wi > div:first-child {\r\n    border-left: none;\r\n}\n.summary_from_DatePickerDropdown-css_3wi button {\r\n    display: -webkit-inline-box;\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    font-weight: 600;\r\n    font-size: 0.775em;\r\n    color: #EC7B65\r\n}\n.summary_from_DatePickerDropdown-css_3wi button span {\r\n    font-weight: inherit;\r\n    color: inherit;\r\n}\n.summary_from_DatePickerDropdown-css_3wi button i {\r\n    display: none;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    margin-left: 6px;\r\n    overflow: hidden;\r\n    border-radius: 50%;\r\n    width: 24px;\r\n    height: 24px;\r\n    background: #6F7583;\r\n    -webkit-transform: none;\r\n            transform: none;\r\n}\n.summary_from_DatePickerDropdown-css_3wi button img {\r\n    width: 24px;\r\n    height: 24px;\r\n    position: relative;\r\n    top: 1px;\r\n    left: 1px;\r\n}\n.summary_from_DatePickerDropdown-css_3wi.approve_from_DatePickerDropdown-css_1LY button {\r\n    color: #2B2C2F\r\n}\n.summary_from_DatePickerDropdown-css_3wi.approve_from_DatePickerDropdown-css_1LY button i {\r\n    display: -webkit-inline-box;\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex;\r\n    background: #18A073;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"summary": "summary_from_DatePickerDropdown-css_3wi",
	"approve": "approve_from_DatePickerDropdown-css_1LY"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/calendar/SelectTime.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "\r\n", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/content/ContentEditable.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".container_from_ContentEditable-css_2Zl {\r\n}\r\n\r\n.field_from_ContentEditable-css_2yH {\r\n    outline: none;\r\n    min-height: 42px;\r\n    color: #2B2C2F\r\n}\r\n\r\n.field_from_ContentEditable-css_2yH p,\r\n    .field_from_ContentEditable-css_2yH span,\r\n    .field_from_ContentEditable-css_2yH li {\r\n    color: inherit;\r\n}\r\n\r\n.field_from_ContentEditable-css_2yH p.contentEditablePlaceholderParagraph {\r\n    opacity: 0.5;\r\n}\r\n\r\n.error_from_ContentEditable-css_1jE {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    height: 0px;\r\n    overflow: hidden;\r\n    -webkit-transition: 300ms height 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms height 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.error_from_ContentEditable-css_1jE.show_from_ContentEditable-css_J6Z {\r\n    height: 18px;\r\n}\r\n\r\n.error_from_ContentEditable-css_1jE p {\r\n    font-size: 0.725em;\r\n    font-weight: 600;\r\n    color: #EC7B65;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "container_from_ContentEditable-css_2Zl",
	"field": "field_from_ContentEditable-css_2yH",
	"error": "error_from_ContentEditable-css_1jE",
	"show": "show_from_ContentEditable-css_J6Z"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/content/FullScreenMessage.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".container_from_FullScreenMessage-css_1cW {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  position: fixed;\r\n  opacity: 0.9;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 7;\r\n  background: rgba(248, 252, 253, 0.96);\r\n}\r\n\r\n.message_from_FullScreenMessage-css_3a2 {\r\n  font-size: 1.7em;\r\n  line-height: 1.3;\r\n  font-weight: 300;\r\n  display: block;\r\n  text-align: center;\r\n  margin: 0 auto;\r\n  width: 75%;\r\n  max-width: 640px;\r\n  color: #2B2C2F;\r\n}\r\n\r\n.dismiss_from_FullScreenMessage-css_1f9 {\r\n  position: relative;\r\n  margin-top: 16px;\r\n  font-size: 0.8em;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.2em;\r\n  color: #EC7B65\r\n}\r\n\r\n.dismiss_from_FullScreenMessage-css_1f9 hr {\r\n  position: absolute;\r\n  bottom: -6px;\r\n  width: 70%;\r\n  left: 15%;\r\n  height: 1px;\r\n  margin: 0;\r\n  background: none;\r\n  border: none;\r\n  border-bottom: 10px solid rgba(236, 123, 101, 0);\r\n  -webkit-transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                300ms margin 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                300ms margin 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.dismiss_from_FullScreenMessage-css_1f9:hover hr {\r\n  border-bottom: 1px solid #EC7B65;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "container_from_FullScreenMessage-css_1cW",
	"message": "message_from_FullScreenMessage-css_3a2",
	"dismiss": "dismiss_from_FullScreenMessage-css_1f9"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/content/Modal.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".background_from_Modal-css_1_H {\r\n    position: fixed;\r\n    z-index: 99999;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(242, 242, 242, 0.88)\r\n}\r\n\r\n.background_from_Modal-css_1_H .container_from_Modal-css_3N0 {\r\n    -webkit-transform: translateY(0px);\r\n            transform: translateY(0px);\r\n    opacity: 1;\r\n}\r\n\r\n.background_from_Modal-css_1_H.modal-enter,\r\n    .background_from_Modal-css_1_H.modal-appear {\r\n    background: rgba(242, 242, 242, 0);\r\n    -webkit-transition: 500ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 500ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.background_from_Modal-css_1_H.modal-enter .container_from_Modal-css_3N0, .background_from_Modal-css_1_H.modal-appear .container_from_Modal-css_3N0 {\r\n    -webkit-transform: translateY(32px);\r\n            transform: translateY(32px);\r\n    opacity: 0;\r\n    -webkit-transition: 500ms opacity 200ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                700ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 500ms opacity 200ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                700ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 500ms opacity 200ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                700ms transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 500ms opacity 200ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                700ms transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000),\r\n                700ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n}\r\n\r\n.background_from_Modal-css_1_H.modal-enter-active,\r\n    .background_from_Modal-css_1_H.modal-appear-active {\r\n    background: rgba(242, 242, 242, 0.88)\r\n}\r\n\r\n.background_from_Modal-css_1_H.modal-enter-active .container_from_Modal-css_3N0, .background_from_Modal-css_1_H.modal-appear-active .container_from_Modal-css_3N0 {\r\n    -webkit-transform: translateY(0px);\r\n            transform: translateY(0px);\r\n    opacity: 1;\r\n}\r\n\r\n.background_from_Modal-css_1_H.modal-leave {\r\n    background: rgba(242, 242, 242, 0.88);\r\n    -webkit-transition: 500ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 500ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.background_from_Modal-css_1_H.modal-leave .container_from_Modal-css_3N0 {\r\n    -webkit-transform: translateY(0px);\r\n            transform: translateY(0px);\r\n    opacity: 1;\r\n    -webkit-transition: 300ms opacity 200ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                500ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 300ms opacity 200ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                500ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 300ms opacity 200ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                500ms transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 300ms opacity 200ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                500ms transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000),\r\n                500ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n}\r\n\r\n.background_from_Modal-css_1_H.modal-leave-active {\r\n    background: rgba(242, 242, 242, 0)\r\n}\r\n\r\n.background_from_Modal-css_1_H.modal-leave-active .container_from_Modal-css_3N0 {\r\n    -webkit-transform: translateY(-24px);\r\n            transform: translateY(-24px);\r\n    opacity: 0;\r\n}\r\n\r\n.wrapper_from_Modal-css_1Bg {\r\n    position: absolute;\r\n    overflow: auto;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -ms-flex-line-pack: start;\r\n        align-content: flex-start;\r\n    -webkit-box-align: start;\r\n        -ms-flex-align: start;\r\n            align-items: flex-start;\r\n    -webkit-perspective: 480px;\r\n            perspective: 480px;\r\n    -webkit-perspective-origin: center;\r\n            perspective-origin: center;\r\n}\r\n\r\n.container_from_Modal-css_3N0 {\r\n    position: relative;\r\n    height: auto;\r\n    width: 100%;\r\n    margin: 64px auto;\r\n    max-width: 960px;\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1 0 auto;\r\n            flex: 1 0 auto;\r\n    border-radius: 3px;\r\n    background: #F8FCFD;\r\n    -webkit-box-shadow: 0px 16px 32px rgba(0, 0, 0, 0.06);\r\n            box-shadow: 0px 16px 32px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.titleBar_from_Modal-css_3Ud {\r\n    position: relative;\r\n    background: #F0F4F5;\r\n    width: 100%;\r\n    height: auto;\r\n    min-height: 60px;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -ms-flex-wrap: nowrap;\r\n        flex-wrap: nowrap;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -ms-flex-line-pack: stretch;\r\n        align-content: stretch;\r\n    -webkit-box-align: stretch;\r\n        -ms-flex-align: stretch;\r\n            align-items: stretch\r\n}\r\n\r\n.titleBar_from_Modal-css_3Ud .titleBarHeadline_from_Modal-css_2Fq {\r\n    position: absolute;\r\n    top: 19px;\r\n    left: 64px;\r\n    font-size: 1.1em;\r\n    font-weight: 600;\r\n    color: #2E3D73;\r\n    text-align: center;\r\n}\r\n\r\n.titleBar_from_Modal-css_3Ud .titleBarContent_from_Modal-css_1Vm {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n}\r\n\r\n.titleBar_from_Modal-css_3Ud .titleBarIcons_from_Modal-css_2V0 {\r\n    position: absolute;\r\n    top: 18px;\r\n    right: 48px;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -ms-flex-wrap: nowrap;\r\n        flex-wrap: nowrap;\r\n    -webkit-box-pack: end;\r\n        -ms-flex-pack: end;\r\n            justify-content: flex-end;\r\n    -webkit-box-align: start;\r\n        -ms-flex-align: start;\r\n            align-items: flex-start\r\n}\r\n\r\n.titleBar_from_Modal-css_3Ud .titleBarIcons_from_Modal-css_2V0 > button {\r\n    margin-left: 12px;\r\n}\r\n\r\n.content_from_Modal-css_3jd {\r\n}\r\n", ""]);

// exports
exports.locals = {
	"background": "background_from_Modal-css_1_H",
	"container": "container_from_Modal-css_3N0",
	"wrapper": "wrapper_from_Modal-css_1Bg",
	"titleBar": "titleBar_from_Modal-css_3Ud",
	"titleBarHeadline": "titleBarHeadline_from_Modal-css_2Fq",
	"titleBarContent": "titleBarContent_from_Modal-css_1Vm",
	"titleBarIcons": "titleBarIcons_from_Modal-css_2V0",
	"content": "content_from_Modal-css_3jd"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/content/ModalBottomBar.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".container_from_ModalBottomBar-css_3o_ {\r\n    position: fixed;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: auto;\r\n    overflow: visible;\r\n    text-align: center;\r\n    z-index: 999999\r\n}\r\n\r\n.container_from_ModalBottomBar-css_3o_.show_from_ModalBottomBar-css_3z7 .wrapper_from_ModalBottomBar-css_jo9 {\r\n    opacity: 1;\r\n    -webkit-transform: translateY(0%);\r\n            transform: translateY(0%);\r\n}\r\n\r\n.wrapper_from_ModalBottomBar-css_jo9 {\r\n    text-align: left;\r\n    margin: 0 auto;\r\n    width: 100%;\r\n    background: #FFFFFF;\r\n    -webkit-box-shadow: 0px -8px 24px rgba(0, 0, 0, 0.08);\r\n            box-shadow: 0px -8px 24px rgba(0, 0, 0, 0.08);\r\n    opacity: 0;\r\n    -webkit-transform: translateY(100%);\r\n            transform: translateY(100%);\r\n    -webkit-transition: 600ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        500ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 600ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        500ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 500ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000),\r\n        600ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 500ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000),\r\n        600ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        500ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n}\r\n\r\n.content_from_ModalBottomBar-css_3v- {\r\n    margin: 0 auto;\r\n    max-width: 960px;\r\n    text-align: left;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "container_from_ModalBottomBar-css_3o_",
	"show": "show_from_ModalBottomBar-css_3z7",
	"wrapper": "wrapper_from_ModalBottomBar-css_jo9",
	"content": "content_from_ModalBottomBar-css_3v-"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/content/SectionHeadline.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".container_from_SectionHeadline-css_sk1 {\r\n    margin: 0;\r\n    padding: 32px;\r\n    padding-bottom: 24px;\r\n    position: relative;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n            justify-content: space-between;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n}\r\n\r\n.headline_from_SectionHeadline-css_3OO {\r\n    display: block\r\n}\r\n\r\n.headline_from_SectionHeadline-css_3OO > span {\r\n    position: relative;\r\n    z-index: 1;\r\n    display: inline;\r\n    text-transform: uppercase;\r\n    text-align: left;\r\n    font-size: 0.7em;\r\n    font-weight: 700;\r\n    color: #A0A3A3;\r\n    letter-spacing: 0.2em;\r\n}\r\n\r\n.headline_from_SectionHeadline-css_3OO > em {\r\n    position: relative;\r\n    z-index: 1;\r\n    display: inline;\r\n    text-transform: none;\r\n    text-align: left;\r\n    margin-left: 12px;\r\n    font-size: 0.675em;\r\n    font-weight: 400;\r\n    font-style: normal;\r\n    color: #A0A3A3;\r\n    letter-spacing: normal;\r\n}\r\n\r\n.middle_from_SectionHeadline-css_11I {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n}\r\n\r\n.right_from_SectionHeadline-css_1yi {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -webkit-box-pack: end;\r\n        -ms-flex-pack: end;\r\n            justify-content: flex-end;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n}\r\n\r\n.iconButton_from_SectionHeadline-css_3Yf {\r\n    z-index: 2;\r\n    padding-right: 0;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "container_from_SectionHeadline-css_sk1",
	"headline": "headline_from_SectionHeadline-css_3OO",
	"middle": "middle_from_SectionHeadline-css_11I",
	"right": "right_from_SectionHeadline-css_1yi",
	"iconButton": "iconButton_from_SectionHeadline-css_3Yf"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/createlead/CreateLeadForm.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".container_from_CreateLeadForm-css_6nf {\r\n  padding: 32px 64px;\r\n}\r\n\r\n.form_from_CreateLeadForm-css_2q2 {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-pack: distribute;\r\n      justify-content: space-around;\r\n  -ms-flex-line-pack: start;\r\n      align-content: flex-start;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: row;\r\n          flex-direction: row;\r\n  -ms-flex-wrap: wrap;\r\n      flex-wrap: wrap;\r\n  position: relative;\r\n}\r\n\r\n.saving_from_CreateLeadForm-css_2Lb {\r\n  padding-top: 12px;\r\n  text-align: right;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "container_from_CreateLeadForm-css_6nf",
	"form": "form_from_CreateLeadForm-css_2q2",
	"saving": "saving_from_CreateLeadForm-css_2Lb"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/createlead/CreateLeadModal.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".createLeadContainer_from_CreateLeadModal-css_2DA {\r\n\r\n}\r\n", ""]);

// exports
exports.locals = {
	"createLeadContainer": "createLeadContainer_from_CreateLeadModal-css_2DA"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/indicator/LoadingFullScreen.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".comp-loading-pane-container {\r\n  position: static\r\n}\r\n\r\n.comp-loading-pane-container.fade-appear,\r\n  .comp-loading-pane-container.fade-enter {\r\n  opacity: 0;\r\n  -webkit-transition: 300ms opacity 0ms cubic-bezier(0.550, 0.055, 0.675, 0.190);\r\n  transition: 300ms opacity 0ms cubic-bezier(0.550, 0.055, 0.675, 0.190);\r\n}\r\n\r\n.comp-loading-pane-container.fade-appear-active,\r\n  .comp-loading-pane-container.fade-enter-active {\r\n  opacity: 1;\r\n}\r\n\r\n.comp-loading-pane {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  position: fixed;\r\n  opacity: 0.9;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 7;\r\n  background: rgba(248, 252, 253, 0.96);\r\n}\r\n\r\n.comp-loading-pane.comp-loading-pane-fit {\r\n  position: absolute;\r\n}\r\n", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/indicator/LoadingSpinner.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".comp-spinner-wrapper {\r\n  margin: 0 auto;\r\n  color: #2A5798;\r\n  width: 64px;\r\n}\r\n\r\n.comp-spinner-container {\r\n  overflow: hidden;\r\n  text-align: center;\r\n  height: auto;\r\n  opacity: 1\r\n}\r\n\r\n.comp-spinner-container.spin-appear,\r\n  .comp-spinner-container.spin-enter {\r\n  opacity: 0;\r\n  -webkit-transition: 200ms opacity 0ms cubic-bezier(0.550, 0.055, 0.675, 0.190);\r\n  transition: 200ms opacity 0ms cubic-bezier(0.550, 0.055, 0.675, 0.190);\r\n}\r\n\r\n.comp-spinner-container.spin-appear-active,\r\n  .comp-spinner-container.spin-enter-active {\r\n  opacity: 1;\r\n}\r\n\r\n.comp-spinner {\r\n  margin: 0 auto;\r\n  -webkit-transform: rotateZ(0deg);\r\n          transform: rotateZ(0deg);\r\n  -webkit-transform-origin: 50% 50%;\r\n          transform-origin: 50% 50%;\r\n  -webkit-animation-delay: 0ms;\r\n          animation-delay: 0ms;\r\n  -webkit-animation-duration: 800ms;\r\n          animation-duration: 800ms;\r\n  -webkit-animation-timing-function: linear;\r\n          animation-timing-function: linear;\r\n  -webkit-animation-iteration-count: infinite;\r\n          animation-iteration-count: infinite;\r\n  -webkit-animation-name: rotate_from_LoadingSpinner-css_hN-;\r\n          animation-name: rotate_from_LoadingSpinner-css_hN-;\r\n}\r\n\r\n@-webkit-keyframes rotate_from_LoadingSpinner-css_hN- {\r\n  to {\r\n    -webkit-transform: rotateZ(360deg);\r\n            transform: rotateZ(360deg);\r\n  }\r\n}\r\n\r\n@keyframes rotate_from_LoadingSpinner-css_hN- {\r\n  to {\r\n    -webkit-transform: rotateZ(360deg);\r\n            transform: rotateZ(360deg);\r\n  }\r\n}\r\n", ""]);

// exports
exports.locals = {
	"rotate": "rotate_from_LoadingSpinner-css_hN-"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/indicator/SavingIndicator.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".container_from_SavingIndicator-css_1vb {\r\n  display: inline-block;\r\n  text-align: right;\r\n  margin-left: auto;\r\n  margin-right: 0\r\n}\r\n\r\n.container_from_SavingIndicator-css_1vb.alignLeft_from_SavingIndicator-css_UKx {\r\n  margin-left: 0;\r\n  margin-right: auto;\r\n}\r\n\r\n.container_from_SavingIndicator-css_1vb.alignCenter_from_SavingIndicator-css_mmj {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.container_from_SavingIndicator-css_1vb.alignRight_from_SavingIndicator-css_RNm {\r\n  margin-left: auto;\r\n  margin-right: 0;\r\n}\r\n\r\n.indicator_from_SavingIndicator-css_iGn {\r\n  opacity: 1;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: end;\r\n      -ms-flex-pack: end;\r\n          justify-content: flex-end;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center\r\n}\r\n\r\n.indicator_from_SavingIndicator-css_iGn.fade-appear,\r\n  .indicator_from_SavingIndicator-css_iGn.fade-enter {\r\n  opacity: 0;\r\n}\r\n\r\n.indicator_from_SavingIndicator-css_iGn.fade-appear-active,\r\n  .indicator_from_SavingIndicator-css_iGn.fade-enter-active {\r\n  opacity: 1;\r\n  -webkit-transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.indicator_from_SavingIndicator-css_iGn.fade-leave {\r\n  opacity: 1;\r\n}\r\n\r\n.indicator_from_SavingIndicator-css_iGn.fade-leave-active {\r\n  opacity: 0;\r\n  -webkit-transition: 1000ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 1000ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.label_from_SavingIndicator-css_4oQ {\r\n  padding-left: 6px;\r\n  font-size: 0.775em;\r\n  font-weight: 600;\r\n  color: #2B2C2F\r\n}\r\n\r\n.label_from_SavingIndicator-css_4oQ span,\r\n  .label_from_SavingIndicator-css_4oQ button {\r\n  color: inherit;\r\n  font-size: inherit;\r\n  font-weight: inherit;\r\n}\r\n\r\n.label_from_SavingIndicator-css_4oQ:first-child {\r\n  padding-left: 0;\r\n}\r\n\r\n.successMsg_from_SavingIndicator-css_4dR {\r\n  color: #18A073;\r\n}\r\n\r\n.errorMsg_from_SavingIndicator-css_36e {\r\n  color: #EC7B65;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "container_from_SavingIndicator-css_1vb",
	"alignLeft": "alignLeft_from_SavingIndicator-css_UKx",
	"alignCenter": "alignCenter_from_SavingIndicator-css_mmj",
	"alignRight": "alignRight_from_SavingIndicator-css_RNm",
	"indicator": "indicator_from_SavingIndicator-css_iGn",
	"label": "label_from_SavingIndicator-css_4oQ",
	"successMsg": "successMsg_from_SavingIndicator-css_4dR",
	"errorMsg": "errorMsg_from_SavingIndicator-css_36e"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/Layout.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".layout_from_Layout-css_1Ab {\r\n  position: static;\r\n}\r\n\r\n.page_from_Layout-css_1Dm {\r\n  padding-top: 64px\r\n}\r\n\r\n.page_from_Layout-css_1Dm.paddedBottom_from_Layout-css_ki3 {\r\n  padding-bottom: 48px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"layout": "layout_from_Layout-css_1Ab",
	"page": "page_from_Layout-css_1Dm",
	"paddedBottom": "paddedBottom_from_Layout-css_ki3"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/Offline/OfflineArea.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".offlineArea_from_OfflineArea-css_2TP {\r\n  position: fixed;\r\n  z-index: 98;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.offlineBar_from_OfflineArea-css_1ty {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: auto;\r\n  padding: 0 32px;\r\n  text-align: center;\r\n  background: rgba(242, 242, 242, 0.92);\r\n  -webkit-box-shadow: 0px -8px 16px rgba(0, 0, 0, 0.03);\r\n          box-shadow: 0px -8px 16px rgba(0, 0, 0, 0.03);\r\n  -webkit-transform: translateY(0%);\r\n          transform: translateY(0%)\r\n}\r\n\r\n.offlineBar_from_OfflineArea-css_1ty p {\r\n  display: block;\r\n  font-size: 0.675em;\r\n  padding: 12px 0;\r\n}\r\n\r\n.offlineBar_from_OfflineArea-css_1ty p strong {\r\n  font-weight: 600;\r\n  color: #EC7B65;\r\n  margin-right: 6px;\r\n}\r\n\r\n.offlineBar_from_OfflineArea-css_1ty p strong:last-child {\r\n  margin-right: 0;\r\n}\r\n\r\n.offlineBar_from_OfflineArea-css_1ty p span {\r\n  font-weight: 400;\r\n  color: #6F7583;\r\n  padding-top: 6px;\r\n  padding-bottom: 12px;\r\n}\r\n\r\n.offlineBar_from_OfflineArea-css_1ty.slide-appear,\r\n  .offlineBar_from_OfflineArea-css_1ty.slide-enter {\r\n  -webkit-transform: translateY(100%);\r\n          transform: translateY(100%);\r\n  -webkit-transition: 500ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n  transition: 500ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n  transition: 500ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n  transition: 500ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000), 500ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n}\r\n\r\n.offlineBar_from_OfflineArea-css_1ty.slide-appear-active,\r\n  .offlineBar_from_OfflineArea-css_1ty.slide-enter-active {\r\n  -webkit-transform: translateY(0%);\r\n          transform: translateY(0%);\r\n}\r\n\r\n.offlineBar_from_OfflineArea-css_1ty.slide-leave {\r\n  -webkit-transform: translateY(0%);\r\n          transform: translateY(0%);\r\n  opacity: 1;\r\n  -webkit-transition: 500ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                500ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n  transition: 500ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                500ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n  transition: 500ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000),\r\n                500ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 500ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000),\r\n                500ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                500ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n}\r\n\r\n.offlineBar_from_OfflineArea-css_1ty.slide-leave-active {\r\n  opacity: 0;\r\n  -webkit-transform: translateY(100%);\r\n          transform: translateY(100%);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"offlineArea": "offlineArea_from_OfflineArea-css_2TP",
	"offlineBar": "offlineBar_from_OfflineArea-css_1ty"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/Sidebar/Activities/ActivitiesSidebar.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".activitiesSidebar_from_ActivitiesSidebar-css_20k {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  width: 100%;\r\n  min-height: calc(100% - 64px);\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  -webkit-box-pack: start;\r\n      -ms-flex-pack: start;\r\n          justify-content: flex-start;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n}\r\n\r\n.spinner_from_ActivitiesSidebar-css_3Vc {\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n}\r\n\r\n.activity_from_ActivitiesSidebar-css_1De {\r\n  padding: 0 32px;\r\n\r\n  .activity-time_from_ActivitiesSidebar-css_1n7 {\r\n    color: red;\r\n  }\r\n}\r\n\r\n.activity_from_ActivitiesSidebar-css_1De > .inner_from_ActivitiesSidebar-css_YVH {\r\n  border-left: 1px solid #E9EBEB;\r\n  padding-left: 24px;\r\n  padding-bottom: 32px;\r\n  position: relative;\r\n  cursor: pointer;\r\n}\r\n\r\n.activity_from_ActivitiesSidebar-css_1De > .inner_from_ActivitiesSidebar-css_YVH:hover .link_from_ActivitiesSidebar-css_3cy::after {\r\n  margin-left: -35%;\r\n  width: 70%;\r\n}\r\n\r\n.activity_from_ActivitiesSidebar-css_1De .leadRow_from_ActivitiesSidebar-css_2Ib {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: start;\r\n      -ms-flex-pack: start;\r\n          justify-content: flex-start;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n}\r\n\r\n.activity_from_ActivitiesSidebar-css_1De .leadRow_from_ActivitiesSidebar-css_2Ib > .leadCol_from_ActivitiesSidebar-css_2TG {\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 0 auto;\r\n          flex: 1 0 auto;\r\n}\r\n\r\n.activity_from_ActivitiesSidebar-css_1De .leadRow_from_ActivitiesSidebar-css_2Ib > .leadCol_from_ActivitiesSidebar-css_2TG:last-child {\r\n  text-align: right;\r\n}\r\n\r\n.activity_from_ActivitiesSidebar-css_1De .id_from_ActivitiesSidebar-css_1Kp {\r\n  padding-top: 4px;\r\n  font-weight: 400;\r\n  font-size: 0.85em;\r\n  color: #444956;\r\n}\r\n\r\n.activity_from_ActivitiesSidebar-css_1De .id_from_ActivitiesSidebar-css_1Kp::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: -12px;\r\n  top: 0;\r\n  width: 24px;\r\n  height: 24px;\r\n  border-radius: 1px;\r\n  background: #F7FDFF;\r\n  border: 1px solid #DCDEDE;\r\n}\r\n\r\n.activity_from_ActivitiesSidebar-css_1De .name_from_ActivitiesSidebar-css_1lx {\r\n  text-align: left;\r\n  padding-bottom: 0px;\r\n  -webkit-transition: 300ms padding 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 300ms padding 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.activity_from_ActivitiesSidebar-css_1De .name_from_ActivitiesSidebar-css_1lx > strong {\r\n  display: block;\r\n  font-size: 1.3em;\r\n  font-weight: 400;\r\n  color: #2E3D73;\r\n  margin-top: 6px;\r\n}\r\n\r\n.activity_from_ActivitiesSidebar-css_1De .name_from_ActivitiesSidebar-css_1lx > span {\r\n  display: block;\r\n  font-size: 0.8em;\r\n  font-weight: 700;\r\n  margin-top: 1px;\r\n  color: #2B2C2F;\r\n  border-bottom: 6px solid transparent;\r\n  -webkit-transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.activity_from_ActivitiesSidebar-css_1De .details_from_ActivitiesSidebar-css_Jft {\r\n  margin-left: -12px;\r\n}\r\n\r\n.activity_from_ActivitiesSidebar-css_1De .details_from_ActivitiesSidebar-css_Jft li {\r\n  display: inline-block;\r\n  margin: 6px 12px;\r\n  font-weight: 300;\r\n  font-size: 0.7em;\r\n  color: #444956;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.activity_from_ActivitiesSidebar-css_1De .details_from_ActivitiesSidebar-css_Jft li p {\r\n  color: #2B2C2F;\r\n  font-weight: 400;\r\n  font-size: 1.1em;\r\n}\r\n\r\n.activity_from_ActivitiesSidebar-css_1De .link_from_ActivitiesSidebar-css_3cy {\r\n  position: relative;\r\n  color: #496DF4;\r\n  padding: 6px;\r\n  margin-left: auto;\r\n  margin-right: 0;\r\n  outline: none;\r\n}\r\n\r\n.activity_from_ActivitiesSidebar-css_1De .link_from_ActivitiesSidebar-css_3cy::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  display: block;\r\n  bottom: 0;\r\n  left: 50%;\r\n  margin-left: 0%;\r\n  width: 0%;\r\n  height: 1px;\r\n  background: #496DF4;\r\n  -webkit-transition: 250ms margin 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                  300ms width 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 250ms margin 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                  300ms width 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.activity_from_ActivitiesSidebar-css_1De .link_from_ActivitiesSidebar-css_3cy:active::after, .activity_from_ActivitiesSidebar-css_1De .link_from_ActivitiesSidebar-css_3cy:focus::after, .activity_from_ActivitiesSidebar-css_1De .link_from_ActivitiesSidebar-css_3cy:hover::after {\r\n  margin-left: -35%;\r\n  width: 70%;\r\n}\r\n\r\n.leadsActivities_from_ActivitiesSidebar-css_15K {\r\n  -webkit-box-flex: 0;\r\n      -ms-flex: 0 1 435px;\r\n          flex: 0 1 435px;\r\n  max-width: 435px;\r\n  z-index: 2;\r\n  background: #F2F2F2;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"activitiesSidebar": "activitiesSidebar_from_ActivitiesSidebar-css_20k",
	"spinner": "spinner_from_ActivitiesSidebar-css_3Vc",
	"activity": "activity_from_ActivitiesSidebar-css_1De",
	"activity-time": "activity-time_from_ActivitiesSidebar-css_1n7",
	"inner": "inner_from_ActivitiesSidebar-css_YVH",
	"link": "link_from_ActivitiesSidebar-css_3cy",
	"leadRow": "leadRow_from_ActivitiesSidebar-css_2Ib",
	"leadCol": "leadCol_from_ActivitiesSidebar-css_2TG",
	"id": "id_from_ActivitiesSidebar-css_1Kp",
	"name": "name_from_ActivitiesSidebar-css_1lx",
	"details": "details_from_ActivitiesSidebar-css_Jft",
	"leadsActivities": "leadsActivities_from_ActivitiesSidebar-css_15K"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/Sidebar/Profile/ProfileSidebar.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".profileSidebar_from_ProfileSidebar-css_Tt3 {\r\n  width: 100%;\r\n}\r\n\r\n.profileSidebarInner_from_ProfileSidebar-css_2ie {\r\n  padding-bottom: 96px;\r\n}\r\n\r\n.logout_from_ProfileSidebar-css_3VJ {\r\n  position: fixed;\r\n  z-index: 10;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  outline: none;\r\n  bottom: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  height: 64px;\r\n  background: #EC7B65;\r\n  -webkit-transition: 250ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 250ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.logout_from_ProfileSidebar-css_3VJ span {\r\n  position: relative;\r\n  top: 1px;\r\n  font-size: 1.0em;\r\n  font-weight: 400;\r\n  color: #FFFFFF;\r\n  -webkit-transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.logout_from_ProfileSidebar-css_3VJ img {\r\n  margin-left: 6px;\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n\r\n.logout_from_ProfileSidebar-css_3VJ:hover {\r\n  background: #F2F2F2;\r\n}\r\n\r\n.logout_from_ProfileSidebar-css_3VJ:hover span {\r\n  color: #EC7B65;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"profileSidebar": "profileSidebar_from_ProfileSidebar-css_Tt3",
	"profileSidebarInner": "profileSidebarInner_from_ProfileSidebar-css_2ie",
	"logout": "logout_from_ProfileSidebar-css_3VJ"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/Sidebar/Profile/UserProfile.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".group_from_UserProfile-css_33b {\r\n  position: relative;\r\n  padding: 0;\r\n  padding-left: 24px;\r\n  margin: 0 32px;\r\n  margin-top: 32px;\r\n  color: #2E3D73;\r\n  line-height: 1.5\r\n}\r\n\r\n.group_from_UserProfile-css_33b:first-child {\r\n  margin-top: 0\r\n}\r\n\r\n.group_from_UserProfile-css_33b:first-child .icon_from_UserProfile-css_WQJ {\r\n  top: 0;\r\n}\r\n\r\n.group_from_UserProfile-css_33b:last-child {\r\n  padding-bottom: 32px;\r\n  border-bottom: 1px solid #E9EBEB;\r\n}\r\n\r\n.group_from_UserProfile-css_33b .icon_from_UserProfile-css_WQJ {\r\n  position: absolute;\r\n  top: 1px;\r\n  left: 0;\r\n}\r\n\r\n.group_from_UserProfile-css_33b h1 {\r\n  font-size: 1.175em;\r\n  font-weight: 700;\r\n  line-height: 1.2;\r\n  position: relative;\r\n  top: -3px;\r\n}\r\n\r\n.group_from_UserProfile-css_33b h3 {\r\n  font-size: 0.875em;\r\n  font-weight: 400;\r\n  line-height: 1.1;\r\n  position: relative;\r\n  margin-top: -4px;\r\n}\r\n\r\n.group_from_UserProfile-css_33b h4 {\r\n  font-size: 0.825em;\r\n  font-weight: 400;\r\n  line-height: 1.1;\r\n  position: relative;\r\n}\r\n\r\n.group_from_UserProfile-css_33b p {\r\n  font-size: 0.825em;\r\n  font-weight: 400\r\n}\r\n\r\n.group_from_UserProfile-css_33b p.email_from_UserProfile-css_3MS {\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.group_from_UserProfile-css_33b a {\r\n  color: inherit;\r\n  text-decoration: none;\r\n  border-bottom: 1px solid transparent;\r\n  -webkit-transition: 250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.group_from_UserProfile-css_33b a:hover,\r\n    .group_from_UserProfile-css_33b a:active,\r\n    .group_from_UserProfile-css_33b a:focus {\r\n  border-bottom: 1px solid #496DF4;\r\n}\r\n\r\n.details_from_UserProfile-css_1g0 {\r\n  text-align: right;\r\n  margin: 0 32px;\r\n  margin-top: 6px;\r\n  padding-bottom: 12px;\r\n  border-bottom: 1px solid #E9EBEB\r\n}\r\n\r\n.details_from_UserProfile-css_1g0 > div {\r\n  padding-top: 6px;\r\n}\r\n\r\n.details_from_UserProfile-css_1g0 button {\r\n  margin-left: auto;\r\n  margin-right: 0;\r\n}\r\n\r\n.editing_from_UserProfile-css_34G .group_from_UserProfile-css_33b {\r\n  padding-left: 0;\r\n  margin-top: 6px\r\n}\r\n\r\n.editing_from_UserProfile-css_34G .group_from_UserProfile-css_33b:first-child {\r\n  margin-top: 0\r\n}\r\n\r\n.editing_from_UserProfile-css_34G .group_from_UserProfile-css_33b:first-child h5 {\r\n  padding-top: 0;\r\n}\r\n\r\n.editing_from_UserProfile-css_34G .group_from_UserProfile-css_33b h5 {\r\n  font-size: 0.825em;\r\n  font-weight: 600;\r\n  color: #444956;\r\n  display: block;\r\n  padding-top: 6px;\r\n  border-bottom: 1px solid #E9EBEB;\r\n}\r\n\r\n.editing_from_UserProfile-css_34G .group_from_UserProfile-css_33b input {\r\n  width: 100%;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  margin-top: 6px;\r\n}\r\n\r\n.editing_from_UserProfile-css_34G .group_from_UserProfile-css_33b .icon_from_UserProfile-css_WQJ {\r\n  display: none;\r\n}\r\n\r\n.editing_from_UserProfile-css_34G label {\r\n  display: block;\r\n  position: relative;\r\n  margin-top: 12px\r\n}\r\n\r\n.editing_from_UserProfile-css_34G label > p {\r\n  position: absolute;\r\n  z-index: 3;\r\n  top: -3px;\r\n  left: 12px;\r\n  font-size: 0.625em;\r\n  font-weight: 400;\r\n  color:#6F7583;\r\n  padding: 3px 6px;\r\n  background: none\r\n}\r\n\r\n.editing_from_UserProfile-css_34G label > p > span {\r\n  position: relative;\r\n  z-index: 3;\r\n  color: inherit;\r\n}\r\n\r\n.editing_from_UserProfile-css_34G label > p::after {\r\n  content: \"\";\r\n  display: block;\r\n  position: absolute;\r\n  z-index: 2;\r\n  top: 9px;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 1px;\r\n  background: #FFFFFF;\r\n}\r\n\r\n.userProfile_from_UserProfile-css_2ej {}\r\n", ""]);

// exports
exports.locals = {
	"group": "group_from_UserProfile-css_33b",
	"icon": "icon_from_UserProfile-css_WQJ",
	"email": "email_from_UserProfile-css_3MS",
	"details": "details_from_UserProfile-css_1g0",
	"editing": "editing_from_UserProfile-css_34G",
	"userProfile": "userProfile_from_UserProfile-css_2ej"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/Sidebar/Sidebar.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".sidebar_from_Sidebar-css_cDh {\r\n  position: fixed;\r\n  z-index: 99;\r\n  top: 0;\r\n  right: 0;\r\n  width: 0%;\r\n  height: 100%;\r\n  opacity: 0;\r\n  overflow: hidden;\r\n  background: rgba(248, 252, 253, 0.88);\r\n  -webkit-transition: 400ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 400ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.sidebar_from_Sidebar-css_cDh.open_from_Sidebar-css_3pE {\r\n  opacity: 1;\r\n  width: 100%;\r\n}\r\n\r\n.inner_from_Sidebar-css_Mix {\r\n  position: fixed;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  -webkit-box-pack: start;\r\n      -ms-flex-pack: start;\r\n          justify-content: flex-start;\r\n  -ms-flex-line-pack: stretch;\r\n      align-content: stretch;\r\n  -webkit-box-align: stretch;\r\n      -ms-flex-align: stretch;\r\n          align-items: stretch;\r\n  top: 0;\r\n  right: 0;\r\n  width: 0px;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  background: #F7FDFF;\r\n  -webkit-box-shadow: 0px 0px 32px rgba(43, 44, 47, 0.06);\r\n          box-shadow: 0px 0px 32px rgba(43, 44, 47, 0.06);\r\n  -webkit-transition: 400ms width 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n  transition: 400ms width 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n}\r\n\r\n.transitionGroup_from_Sidebar-css_3el {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 0 100%;\r\n          flex: 1 0 100%;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  -webkit-box-pack: start;\r\n      -ms-flex-pack: start;\r\n          justify-content: flex-start;\r\n  -ms-flex-line-pack: stretch;\r\n      align-content: stretch;\r\n  -webkit-box-align: stretch;\r\n      -ms-flex-align: stretch;\r\n          align-items: stretch;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"sidebar": "sidebar_from_Sidebar-css_cDh",
	"open": "open_from_Sidebar-css_3pE",
	"inner": "inner_from_Sidebar-css_Mix",
	"transitionGroup": "transitionGroup_from_Sidebar-css_3el"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/Sidebar/SidebarContent.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".container_from_SidebarContent-css_3mn {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 0 100%;\r\n          flex: 1 0 100%;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  -webkit-box-pack: start;\r\n      -ms-flex-pack: start;\r\n          justify-content: flex-start;\r\n  -ms-flex-line-pack: stretch;\r\n      align-content: stretch;\r\n  -webkit-box-align: stretch;\r\n      -ms-flex-align: stretch;\r\n          align-items: stretch;\r\n}\r\n\r\n.top_from_SidebarContent-css_PXr {\r\n  -webkit-box-flex: 0;\r\n      -ms-flex: 0 1 auto;\r\n          flex: 0 1 auto;\r\n  height: 64px;\r\n  z-index: 3;\r\n  top: 0;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: start;\r\n      -ms-flex-pack: start;\r\n          justify-content: flex-start;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  width: 100%;\r\n  background: #2E3D73;\r\n  position: fixed\r\n}\r\n\r\n.top_from_SidebarContent-css_PXr .title_from_SidebarContent-css_1vO {\r\n  font-size: 0.9em;\r\n  font-weight: 300;\r\n  color: #C2CFFF;\r\n  padding-left: 32px;\r\n}\r\n\r\n.top_from_SidebarContent-css_PXr .close_from_SidebarContent-css_3kK {\r\n  position: absolute;\r\n  right: 16px;\r\n  top: 16px;\r\n  padding: 6px;\r\n  border-radius: 50%;\r\n  outline: none;\r\n  background: #101834;\r\n  -webkit-transition: 250ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 250ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.top_from_SidebarContent-css_PXr .close_from_SidebarContent-css_3kK img {\r\n  display: block;\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n\r\n.top_from_SidebarContent-css_PXr .close_from_SidebarContent-css_3kK:hover {\r\n  background: #EC7B65;\r\n}\r\n\r\n.main_from_SidebarContent-css_2zR {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: columns;\r\n          flex-direction: columns;\r\n  -webkit-box-pack: start;\r\n      -ms-flex-pack: start;\r\n          justify-content: flex-start;\r\n  -ms-flex-line-pack: stretch;\r\n      align-content: stretch;\r\n  -webkit-box-align: stretch;\r\n      -ms-flex-align: stretch;\r\n          align-items: stretch;\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1;\r\n          flex: 1;\r\n  margin-top: 64px;\r\n  position: relative;\r\n  z-index: 1;\r\n  overflow-y: auto;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "container_from_SidebarContent-css_3mn",
	"top": "top_from_SidebarContent-css_PXr",
	"title": "title_from_SidebarContent-css_1vO",
	"close": "close_from_SidebarContent-css_3kK",
	"main": "main_from_SidebarContent-css_2zR"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/layout/Topbar/Topbar.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".topbar_from_Topbar-css_qwF {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    position: fixed;\r\n    z-index: 9;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 64px;\r\n    background: #2E3D73;\r\n}\r\n\r\n.logo_from_Topbar-css_3mG {\r\n    cursor: pointer;\r\n    display: -webkit-inline-box;\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex;\r\n    height: 100%;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    background: rgb(54, 76, 155);\r\n    -webkit-transition: 250ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 250ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.logo_from_Topbar-css_3mG img {\r\n    height: 24px;\r\n    padding-left: 32px;\r\n    padding-right: 32px;\r\n}\r\n\r\n.logo_from_Topbar-css_3mG:hover {\r\n    background: rgb(58, 82, 166);\r\n}\r\n\r\n.navigation_from_Topbar-css_mqT > li {\r\n    padding-left: 60px;\r\n    padding-right: 61px;\r\n    border-left: 1px solid #101834;\r\n}\r\n\r\n.navigation_from_Topbar-css_mqT > li:first-child {\r\n    border-left: none;\r\n}\r\n\r\n.navigation_from_Topbar-css_mqT.navigationLeads_from_Topbar-css_2HV > li {\r\n    padding-left: 23px;\r\n    padding-right: 24px;\r\n}\r\n\r\n.navigation_from_Topbar-css_mqT.navigationLeads_from_Topbar-css_2HV > li:first-child {\r\n    border-left: 1px solid #101834;\r\n}\r\n\r\n.navigation_from_Topbar-css_mqT .navLink_from_Topbar-css_2ML {\r\n    padding: 3px 0;\r\n    color: #C2CFFF;\r\n    outline: none;\r\n    font-weight: 300;\r\n    font-size: 0.8em;\r\n    text-decoration: none;\r\n    border-bottom: 1px solid #2E3D73;\r\n    -webkit-transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            300ms border 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            300ms border 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n}\r\n\r\n.navigation_from_Topbar-css_mqT .navLink_from_Topbar-css_2ML strong {\r\n    font-size: inherit;\r\n    font-weight: 600;\r\n    color: inherit;\r\n}\r\n\r\n.navigation_from_Topbar-css_mqT .navLink_from_Topbar-css_2ML em {\r\n    font-style: normal;\r\n    font-size: inherit;\r\n    font-weight: 300;\r\n    color: inherit;\r\n}\r\n\r\n.navigation_from_Topbar-css_mqT .navLink_from_Topbar-css_2ML:hover {\r\n    color: #FFFFFF;\r\n}\r\n\r\n.navigation_from_Topbar-css_mqT .navLink_from_Topbar-css_2ML:focus,\r\n        .navigation_from_Topbar-css_mqT .navLink_from_Topbar-css_2ML:active {\r\n    border-bottom-color: rgb(149, 171, 249);\r\n}\r\n\r\n.navigation_from_Topbar-css_mqT .navLink_from_Topbar-css_2ML.navLinkActive_from_Topbar-css_2Jk {\r\n    color: #E8EDFF;\r\n    border-bottom-color: #496DF4;\r\n}\r\n\r\n.navigation_from_Topbar-css_mqT .navLink_from_Topbar-css_2ML.navLinkActive_from_Topbar-css_2Jk:focus {\r\n    border-bottom-color: rgb(149, 171, 249);\r\n}\r\n\r\n.navigationLeads_from_Topbar-css_2HV > li {\r\n    display: -webkit-inline-box;\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n}\r\n\r\n.navigationLeads_from_Topbar-css_2HV button.closeLead_from_Topbar-css_1Dy {\r\n    display: block;\r\n    position: relative;\r\n    margin-left: 6px;\r\n    width: 16px;\r\n    height: 16px;\r\n    border-radius: 50%;\r\n    outline: none;\r\n    background: #101834;\r\n    -webkit-transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.navigationLeads_from_Topbar-css_2HV button.closeLead_from_Topbar-css_1Dy span {\r\n    position: absolute;\r\n    display: inline-block;\r\n    padding: 6px 16px;\r\n    width: 64px;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    top: -18px;\r\n    text-align: center;\r\n    font-size: 0.6em;\r\n    font-weight: 600;\r\n    letter-spacing: 0.1em;\r\n    text-transform: uppercase;\r\n    left: 50%;\r\n    opacity: 0;\r\n    margin-left: -32px;\r\n    color: #E8EDFF;\r\n    -webkit-transform: translateY(6px);\r\n            transform: translateY(6px);\r\n    -webkit-transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                    300ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                    300ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                    300ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                    300ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000),\r\n                    300ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n}\r\n\r\n.navigationLeads_from_Topbar-css_2HV button.closeLead_from_Topbar-css_1Dy img {\r\n    position: relative;\r\n    margin: 0 auto;\r\n}\r\n\r\n.navigationLeads_from_Topbar-css_2HV button.closeLead_from_Topbar-css_1Dy:hover,\r\n            .navigationLeads_from_Topbar-css_2HV button.closeLead_from_Topbar-css_1Dy:active,\r\n            .navigationLeads_from_Topbar-css_2HV button.closeLead_from_Topbar-css_1Dy:focus {\r\n    background: #EC7B65;\r\n}\r\n\r\n.navigationLeads_from_Topbar-css_2HV button.closeLead_from_Topbar-css_1Dy:hover span, .navigationLeads_from_Topbar-css_2HV button.closeLead_from_Topbar-css_1Dy:active span, .navigationLeads_from_Topbar-css_2HV button.closeLead_from_Topbar-css_1Dy:focus span {\r\n    opacity: 1;\r\n    -webkit-transform: translateY(0px);\r\n            transform: translateY(0px);\r\n}\r\n\r\n.actions_from_Topbar-css_1lY {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: end;\r\n        -ms-flex-pack: end;\r\n            justify-content: flex-end;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    margin-left: auto;\r\n    margin-right: 0\r\n}\r\n\r\n.actions_from_Topbar-css_1lY > li {\r\n    display: block;\r\n    padding: 0 32px;\r\n    padding-left: 31px;\r\n    border-left: 1px solid #101834;\r\n}\r\n\r\n.actions_from_Topbar-css_1lY > li:first-child {\r\n    border-left: none;\r\n}\r\n\r\n.actions_from_Topbar-css_1lY > li:last-child button {\r\n    color: #EC7B65;\r\n}\r\n\r\n.actions_from_Topbar-css_1lY button {\r\n    outline: none;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    font-size: 0.7em;\r\n    color: #E8EDFF;\r\n}\r\n\r\n.actions_from_Topbar-css_1lY button strong {\r\n    font-size: inherit;\r\n    font-weight: 600;\r\n    color: inherit;\r\n    border-top: 6px solid transparent;\r\n    border-bottom: 6px solid rgba(73, 109, 244, 0);\r\n    -webkit-transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.actions_from_Topbar-css_1lY button img {\r\n    margin-left: 12px;\r\n    height: 18px;\r\n    width: auto;\r\n}\r\n\r\n.actions_from_Topbar-css_1lY button:focus strong, .actions_from_Topbar-css_1lY button:active strong {\r\n    border-top: 1px solid transparent;\r\n    border-bottom: 1px solid rgb(149, 171, 249);\r\n}\r\n\r\n.actions_from_Topbar-css_1lY button:hover strong {\r\n    border-top: 1px solid transparent;\r\n    border-bottom: 1px solid #496DF4;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"topbar": "topbar_from_Topbar-css_qwF",
	"logo": "logo_from_Topbar-css_3mG",
	"navigation": "navigation_from_Topbar-css_mqT",
	"navigationLeads": "navigationLeads_from_Topbar-css_2HV",
	"navLink": "navLink_from_Topbar-css_2ML",
	"navLinkActive": "navLinkActive_from_Topbar-css_2Jk",
	"closeLead": "closeLead_from_Topbar-css_1Dy",
	"actions": "actions_from_Topbar-css_1lY"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/list/DropdownContainer.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".comp-dropdown-container {\r\n  position: relative\r\n}\r\n\r\n.comp-dropdown-container.left {\r\n  text-align: left\r\n}\r\n\r\n.comp-dropdown-container.left .comp-dropdown-label {\r\n  margin-left: 0;\r\n  margin-right: auto;\r\n  -webkit-box-pack: start;\r\n      -ms-flex-pack: start;\r\n          justify-content: flex-start;\r\n}\r\n\r\n.comp-dropdown-container.center {\r\n  text-align: center\r\n}\r\n\r\n.comp-dropdown-container.center .comp-dropdown-label {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n}\r\n\r\n.comp-dropdown-container.right {\r\n  text-align: right\r\n}\r\n\r\n.comp-dropdown-container.right .comp-dropdown-label {\r\n  margin-left: auto;\r\n  margin-right: 0;\r\n  -webkit-box-pack: end;\r\n      -ms-flex-pack: end;\r\n          justify-content: flex-end;\r\n}\r\n\r\n.comp-dropdown-label {\r\n  position: relative;\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -webkit-box-pack: end;\r\n      -ms-flex-pack: end;\r\n          justify-content: flex-end;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  text-align: right;\r\n  color: #2B2C2F;\r\n  font-size: 0.825em;\r\n  cursor: pointer\r\n}\r\n\r\n.comp-dropdown-label p {\r\n  display: inline\r\n}\r\n\r\n.comp-dropdown-label p span {\r\n  color: inherit;\r\n  padding-right: 6px;\r\n}\r\n\r\n.comp-dropdown-label p strong {\r\n  padding-right: 6px;\r\n  color: #2E3D73;\r\n  font-weight: 700;\r\n  -webkit-transition: 300ms color 0ms cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  transition: 300ms color 0ms cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n}\r\n\r\n.comp-dropdown-label i {\r\n  position: static;\r\n  display: inline-block;\r\n  -webkit-transform: rotateZ(0deg);\r\n          transform: rotateZ(0deg);\r\n  -webkit-transform-origin: 50% 38%;\r\n          transform-origin: 50% 38%;\r\n  -webkit-transition: 500ms -webkit-transform 0ms cubic-bezier(1, 0, 0, 1);\r\n  transition: 500ms -webkit-transform 0ms cubic-bezier(1, 0, 0, 1);\r\n  transition: 500ms transform 0ms cubic-bezier(1, 0, 0, 1);\r\n  transition: 500ms transform 0ms cubic-bezier(1, 0, 0, 1), 500ms -webkit-transform 0ms cubic-bezier(1, 0, 0, 1);\r\n}\r\n\r\n.comp-dropdown-label:hover p strong {\r\n  color: #496DF4;\r\n}\r\n\r\n.comp-dropdown-group {\r\n  z-index: 999;\r\n  position: absolute;\r\n  width: 100%;\r\n  min-width: 192px;\r\n  left: 0;\r\n  top: 0;\r\n  margin: 0px;\r\n  background: #FFFFFF;\r\n  -webkit-box-shadow: 0px 8px 16px rgba(43, 44, 47, 0.05);\r\n          box-shadow: 0px 8px 16px rgba(43, 44, 47, 0.05);\r\n  border: 1px solid #E9EBEB;\r\n  border-radius: 1px;\r\n  -webkit-transform-origin: top;\r\n          transform-origin: top;\r\n  -webkit-transform: scale(0);\r\n          transform: scale(0);\r\n  overflow: auto;\r\n  opacity: 0;\r\n  -webkit-transition: 500ms margin 0ms cubic-bezier(1, 0, 0, 1),\r\n              300ms opacity 0ms cubic-bezier(0.86, 0, 0.07, 1),\r\n              500ms -webkit-transform 0ms cubic-bezier(1, 0, 0, 1);\r\n  transition: 500ms margin 0ms cubic-bezier(1, 0, 0, 1),\r\n              300ms opacity 0ms cubic-bezier(0.86, 0, 0.07, 1),\r\n              500ms -webkit-transform 0ms cubic-bezier(1, 0, 0, 1);\r\n  transition: 500ms transform 0ms cubic-bezier(1, 0, 0, 1),\r\n              500ms margin 0ms cubic-bezier(1, 0, 0, 1),\r\n              300ms opacity 0ms cubic-bezier(0.86, 0, 0.07, 1);\r\n  transition: 500ms transform 0ms cubic-bezier(1, 0, 0, 1),\r\n              500ms margin 0ms cubic-bezier(1, 0, 0, 1),\r\n              300ms opacity 0ms cubic-bezier(0.86, 0, 0.07, 1),\r\n              500ms -webkit-transform 0ms cubic-bezier(1, 0, 0, 1);\r\n}\r\n\r\n.comp-dropdown-open .comp-dropdown-group {\r\n  opacity: 1;\r\n  -webkit-transform: scale(1);\r\n          transform: scale(1);\r\n  -webkit-transition: 600ms margin 0ms cubic-bezier(1, 0, 0, 1),\r\n                500ms opacity 0ms cubic-bezier(0.86, 0, 0.07, 1),\r\n                400ms -webkit-transform 0ms cubic-bezier(1, 0, 0, 1);\r\n  transition: 600ms margin 0ms cubic-bezier(1, 0, 0, 1),\r\n                500ms opacity 0ms cubic-bezier(0.86, 0, 0.07, 1),\r\n                400ms -webkit-transform 0ms cubic-bezier(1, 0, 0, 1);\r\n  transition: 400ms transform 0ms cubic-bezier(1, 0, 0, 1),\r\n                600ms margin 0ms cubic-bezier(1, 0, 0, 1),\r\n                500ms opacity 0ms cubic-bezier(0.86, 0, 0.07, 1);\r\n  transition: 400ms transform 0ms cubic-bezier(1, 0, 0, 1),\r\n                600ms margin 0ms cubic-bezier(1, 0, 0, 1),\r\n                500ms opacity 0ms cubic-bezier(0.86, 0, 0.07, 1),\r\n                400ms -webkit-transform 0ms cubic-bezier(1, 0, 0, 1)\r\n}\r\n\r\n.comp-dropdown-open .comp-dropdown-group.top {\r\n  top: auto;\r\n  bottom: 0;\r\n  -webkit-transform-origin: bottom;\r\n          transform-origin: bottom;\r\n}\r\n\r\n.comp-dropdown-open i {\r\n  -webkit-transform: rotateZ(-180deg);\r\n          transform: rotateZ(-180deg);\r\n}\r\n", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/list/OptionsList.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".comp-options-list-container {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.comp-options-list-search {\r\n  margin: 8px;\r\n}\r\n\r\n.comp-options-list-results {\r\n  height: 100%;\r\n  background: transparent;\r\n  border: 1px solid #E9EBEB;\r\n  border-top-color: transparent\r\n}\r\n\r\n.comp-options-list-results > .comp-options-list-results-label {\r\n  display: block;\r\n  background: transparent;\r\n  border-bottom: 1px solid #E9EBEB;\r\n  padding: 6px 16px;\r\n  font-size: 0.85em;\r\n  font-weight: 600;\r\n  line-height: 1.3;\r\n  border-bottom: 1px solid #DCDEDE;\r\n}\r\n\r\n.comp-options-list-results > .comp-options-list-results-label.comp-options-list-results-empty-label {\r\n  color: #EC7B65;\r\n}\r\n\r\n.comp-options-list-results > ul {\r\n  position: relative;\r\n  padding: 0;\r\n  margin: 0;\r\n  overflow: auto;\r\n}\r\n\r\n.comp-options-list-results > ul > li {\r\n  display: block;\r\n  padding: 0;\r\n  margin: 0;\r\n  text-align: left;\r\n}\r\n\r\n.comp-options-list-results > ul > li > p,\r\n      .comp-options-list-results > ul > li > button {\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  display: block;\r\n  width: 100%;\r\n  border: none;\r\n  padding: 12px 16px;\r\n  text-align: inherit;\r\n}\r\n\r\n.comp-options-list-results > ul > li > p {\r\n  color: #2B2C2F;\r\n  font-size: 0.8em;\r\n  font-weight: 600;\r\n  cursor: default;\r\n}\r\n\r\n.comp-options-list-results > ul > li > button {\r\n  font-size: 0.775em;\r\n  font-weight: 400;\r\n  cursor: pointer;\r\n  color: #2B2C2F;\r\n  background: transparent;\r\n  -webkit-transition: 250ms background 0ms cubic-bezier(0.455, 0.03, 0.515, 0.955),\r\n                    300ms color 0ms cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n  transition: 250ms background 0ms cubic-bezier(0.455, 0.03, 0.515, 0.955),\r\n                    300ms color 0ms cubic-bezier(0.455, 0.03, 0.515, 0.955);\r\n}\r\n\r\n.comp-options-list-results > ul > li > button:hover {\r\n  background: #E9EBEB;\r\n  color: #496DF4;\r\n}\r\n\r\n.comp-options-list-results > ul > li.comp-options-list-result-active button {\r\n  font-weight: 700;\r\n  color: #496DF4;\r\n}\r\n\r\n.comp-options-list-results > ul > li.comp-options-list-result-active button:hover {\r\n  background: #E9EBEB;\r\n}\r\n\r\n.comp-options-list-results > ul > li.comp-options-list-result-highlight button {\r\n  background: #E9EBEB;\r\n  color: #2B2C2F;\r\n}\r\n\r\n.comp-options-list-results > ul.comp-options-list-align-left > li {\r\n  text-align: left;\r\n}\r\n\r\n.comp-options-list-results > ul.comp-options-list-align-center > li {\r\n  text-align: center;\r\n}\r\n\r\n.comp-options-list-results > ul.comp-options-list-align-right > li {\r\n  text-align: right;\r\n}\r\n", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/navigation/Pagination.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".pagination_from_Pagination-css_37I {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n            justify-content: space-between;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    width: 100%;\r\n    height: auto;\r\n    background: #F8FCFD;\r\n    border: 1px solid #DCDEDE;\r\n    border-radius: 3px;\r\n    -webkit-box-shadow: 0px 16px 32px rgba(0, 0, 0, 0.02);\r\n            box-shadow: 0px 16px 32px rgba(0, 0, 0, 0.02);\r\n}\r\n\r\n.goto_from_Pagination-css_3tg {\r\n    padding: 6px 24px;\r\n    opacity: 1;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.goto_from_Pagination-css_3tg.hidden_from_Pagination-css_1Ot {\r\n    opacity: 0;\r\n}\r\n\r\n.goto_from_Pagination-css_3tg p {\r\n    font-size: 12.8px;\r\n    font-size: 0.8rem;\r\n    font-weight: 400;\r\n    color: #A0A3A3;\r\n}\r\n\r\n.goto_from_Pagination-css_3tg input {\r\n    width: 64px;\r\n    margin: 0 12px;\r\n    text-align: center;\r\n}\r\n\r\n.goto_from_Pagination-css_3tg button {\r\n    font-size: 12.8px;\r\n    font-size: 0.8rem;\r\n    font-weight: 600;\r\n    color: #496DF4;\r\n}\r\n\r\n.pages_from_Pagination-css_3z5 {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -webkit-box-pack: end;\r\n        -ms-flex-pack: end;\r\n            justify-content: flex-end;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    padding: 6px 24px;\r\n    padding-left: 0\r\n}\r\n\r\n.pages_from_Pagination-css_3z5 li {\r\n    margin-left: 6px;\r\n}\r\n\r\n.pages_from_Pagination-css_3z5 li:first-child {\r\n    margin-left: 0;\r\n}\r\n\r\n.pages_from_Pagination-css_3z5 li button * {\r\n    font-style: normal;\r\n    font-size: 14.4px;\r\n    font-size: 0.9rem;\r\n    font-weight: 600;\r\n    display: inline-block;\r\n    border: 1px solid #FFFFFF;\r\n    border-radius: 3px;\r\n    background: #FFFFFF;\r\n    padding: 6px;\r\n    -webkit-transition: 300ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                    300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                    300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.pages_from_Pagination-css_3z5 li button *:hover {\r\n    background: #496DF4;\r\n    color: #E9EBEB;\r\n}\r\n\r\n.pages_from_Pagination-css_3z5 li button strong {\r\n    background: #FFFFFF;\r\n    color: #496DF4;\r\n    font-weight: 400;\r\n    border-bottom: 1px solid #496DF4;\r\n}\r\n\r\n.pages_from_Pagination-css_3z5 li button em {\r\n    color: #2E3D73;\r\n}\r\n\r\n.pages_from_Pagination-css_3z5 li button span {\r\n    color: #A0A3A3;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"pagination": "pagination_from_Pagination-css_37I",
	"goto": "goto_from_Pagination-css_3tg",
	"hidden": "hidden_from_Pagination-css_1Ot",
	"pages": "pages_from_Pagination-css_3z5"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/pricing/PendingPricingRequestsList.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".list_from_PendingPricingRequestsList-css_2AZ {\r\n  padding-bottom: 32px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"list": "list_from_PendingPricingRequestsList-css_2AZ"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/pricing/PricingRequestListItem.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".request_from_PricingRequestListItem-css_U_N {\r\n  cursor: pointer;\r\n  position: relative;\r\n  background: #F2F2F2;\r\n  padding: 24px 32px;\r\n  -webkit-transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.request_from_PricingRequestListItem-css_U_N::after {\r\n  content: \"\";\r\n  display: block;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 32px;\r\n  height: 1px;\r\n  width: calc(100% - 64px);\r\n  background: #E9EBEB;\r\n}\r\n\r\n.request_from_PricingRequestListItem-css_U_N:first-child::after {\r\n  display: none;\r\n}\r\n\r\n.request_from_PricingRequestListItem-css_U_N:hover {\r\n  background: #F7FDFF\r\n}\r\n\r\n.request_from_PricingRequestListItem-css_U_N:hover .id_from_PricingRequestListItem-css_3ms {\r\n  color: #496DF4\r\n}\r\n\r\n.request_from_PricingRequestListItem-css_U_N:hover .id_from_PricingRequestListItem-css_3ms strong {\r\n  color: #496DF4;\r\n}\r\n\r\n.request_from_PricingRequestListItem-css_U_N:hover .arrow_from_PricingRequestListItem-css_3ZA {\r\n  -webkit-transform: translateX(3px);\r\n          transform: translateX(3px);\r\n}\r\n\r\n.id_from_PricingRequestListItem-css_3ms {\r\n  font-size: 0.725em;\r\n  font-weight: 400;\r\n  color: #6F7583;\r\n  -webkit-transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.id_from_PricingRequestListItem-css_3ms strong {\r\n  font-weight: 600;\r\n  color: #2B2C2F;\r\n  -webkit-transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.lead_from_PricingRequestListItem-css_1qy {\r\n  margin-top: 6px\r\n}\r\n\r\n.lead_from_PricingRequestListItem-css_1qy > strong {\r\n  font-size: 0.975em;\r\n  font-weight: 700;\r\n  color: #2E3D73;\r\n}\r\n\r\n.lead_from_PricingRequestListItem-css_1qy > em {\r\n  display: block;\r\n  margin-top: 1px;\r\n  font-size: 0.825em;\r\n  font-weight: 600;\r\n  font-style: normal;\r\n  color: #2E3D73;\r\n}\r\n\r\n.note_from_PricingRequestListItem-css_3ZS {\r\n  margin-top: 12px;\r\n  font-size: 0.825em;\r\n  font-weight: 400;\r\n  line-height: 1.3;\r\n  color: #2B2C2F\r\n}\r\n\r\n.note_from_PricingRequestListItem-css_3ZS:first-child {\r\n  margin-top: 0;\r\n}\r\n\r\n.author_from_PricingRequestListItem-css_DLL {\r\n  margin-top: 12px;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex\r\n}\r\n\r\n.author_from_PricingRequestListItem-css_DLL:first-child {\r\n  margin-top: 0;\r\n}\r\n\r\n.author_from_PricingRequestListItem-css_DLL > span {\r\n  font-size: 0.775em;\r\n  font-weight: 600;\r\n  color: #6F7583\r\n}\r\n\r\n.author_from_PricingRequestListItem-css_DLL > span:first-child {\r\n  padding-left: 0;\r\n}\r\n\r\n.author_from_PricingRequestListItem-css_DLL > span:last-child {\r\n  padding-right: 0;\r\n}\r\n\r\n.author_from_PricingRequestListItem-css_DLL > img {\r\n  padding: 0 6px;\r\n}\r\n\r\n.arrow_from_PricingRequestListItem-css_3ZA {\r\n  width: 11px;\r\n  height: 7px;\r\n  position: absolute;\r\n  top: 28px;\r\n  right: 38px;\r\n  -webkit-transform: translateX(0px);\r\n          transform: translateX(0px);\r\n  -webkit-transition: 250ms -webkit-transform 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 250ms -webkit-transform 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 250ms transform 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 250ms transform 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000), 250ms -webkit-transform 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"request": "request_from_PricingRequestListItem-css_U_N",
	"id": "id_from_PricingRequestListItem-css_3ms",
	"arrow": "arrow_from_PricingRequestListItem-css_3ZA",
	"lead": "lead_from_PricingRequestListItem-css_1qy",
	"note": "note_from_PricingRequestListItem-css_3ZS",
	"author": "author_from_PricingRequestListItem-css_DLL"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/reminder/ReminderContent.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".reminder_from_ReminderContent-css_3n_ {\r\n    display: block;\r\n    position: relative;\r\n    text-align: left;\r\n    height: auto;\r\n    width: 411px;\r\n    margin-bottom: 24px;\r\n    -webkit-transform-origin: bottom right;\r\n            transform-origin: bottom right;\r\n    -webkit-transform: translateX(411px) scaleY(0);\r\n            transform: translateX(411px) scaleY(0);\r\n    -webkit-transition: 800ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 800ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 800ms transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 800ms transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000), 800ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000)\r\n}\r\n\r\n.reminder_from_ReminderContent-css_3n_:last-child {\r\n    margin-top: 24px;\r\n}\r\n\r\n.reminder_from_ReminderContent-css_3n_.show_from_ReminderContent-css_2W1 {\r\n    -webkit-transform: translateX(0px) scaleY(1);\r\n            transform: translateX(0px) scaleY(1);\r\n}\r\n\r\n.reminder_from_ReminderContent-css_3n_ .content_from_ReminderContent-css_3sa {\r\n    width: 411px;\r\n    height: auto;\r\n    background: #FFFFFF;\r\n    border: 1px solid #F2F2F2;\r\n    -webkit-box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08);\r\n            box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.activity_from_ReminderContent-css_3z- {\r\n    padding: 24px 32px;\r\n}\r\n\r\n.time_from_ReminderContent-css_1ab {\r\n    color: #6F7583;\r\n    font-weight: 400;\r\n    font-size: 0.675em\r\n}\r\n\r\n.time_from_ReminderContent-css_1ab strong {\r\n    font-weight: 600;\r\n}\r\n\r\n.time_from_ReminderContent-css_1ab span {\r\n    margin-left: 3px;\r\n    font-weight: 400;\r\n}\r\n\r\n.title_from_ReminderContent-css_1fo {\r\n    color: #2A5798;\r\n    font-weight: 400;\r\n    font-size: 1.275em;\r\n    margin-top: 16px;\r\n}\r\n\r\n.note_from_ReminderContent-css_3Js {\r\n    font-weight: 600;\r\n    font-size: 0.775em;\r\n    line-height: 1.125;\r\n    color: #2B2C2F;\r\n    margin-top: 3px;\r\n}\r\n\r\n.lead_from_ReminderContent-css_3QT {\r\n    color: #6F7583;\r\n    font-weight: 400;\r\n    font-size: 0.725em;\r\n    margin-top: 12px\r\n}\r\n\r\n.lead_from_ReminderContent-css_3QT strong {\r\n    font-weight: 600;\r\n    font-size: 1.1em;\r\n}\r\n\r\n.lead_from_ReminderContent-css_3QT em {\r\n    display: block;\r\n    font-weight: 400;\r\n    font-style: normal;\r\n}\r\n\r\n.lead_from_ReminderContent-css_3QT button {\r\n    display: inline-block;\r\n    font-weight: 600;\r\n    font-size: 1.025em;\r\n    margin-top: 6px;\r\n    color: #496DF4;\r\n    border-bottom: 1px solid transparent;\r\n    -webkit-transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.lead_from_ReminderContent-css_3QT button:hover,\r\n        .lead_from_ReminderContent-css_3QT button:focus,\r\n        .lead_from_ReminderContent-css_3QT button:active {\r\n    border-bottom-color: #496DF4;\r\n}\r\n\r\n.actions_from_ReminderContent-css_ugJ {\r\n    padding: 0 32px;\r\n    padding-bottom: 24px\r\n}\r\n\r\n.actions_from_ReminderContent-css_ugJ .quickActions_from_ReminderContent-css_2cT {\r\n    width: 100%;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n            justify-content: space-between\r\n}\r\n\r\n.actions_from_ReminderContent-css_ugJ .quickActions_from_ReminderContent-css_2cT > button {\r\n    text-align: center;\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1 0 50%;\r\n            flex: 1 0 50%;\r\n}\r\n\r\n.actions_from_ReminderContent-css_ugJ .snoozeActions_from_ReminderContent-css_1gx {\r\n    display: none;\r\n    height: 34px\r\n}\r\n\r\n.actions_from_ReminderContent-css_ugJ .snoozeActions_from_ReminderContent-css_1gx.show_from_ReminderContent-css_2W1 {\r\n    display: block;\r\n}\r\n\r\n.actions_from_ReminderContent-css_ugJ .snoozeActions_from_ReminderContent-css_1gx .comp-dropdown-container .comp-dropdown-label {\r\n    font-weight: 600;\r\n}\r\n\r\n.dismiss_from_ReminderContent-css_1Y6 {\r\n    position: absolute;\r\n    padding: 0;\r\n    right: 32px;\r\n    top: 19px;\r\n}\r\n\r\n.dismissConfirmation_from_ReminderContent-css_uwm {\r\n    position: absolute;\r\n    z-index: 3;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    background: rgba(245, 247, 247, 0.92);\r\n    -webkit-transform-origin: top;\r\n            transform-origin: top\r\n}\r\n\r\n.dismissConfirmation_from_ReminderContent-css_uwm.dismissal-transition-appear,\r\n    .dismissConfirmation_from_ReminderContent-css_uwm.dismissal-transition-enter {\r\n    -webkit-transform: scale(0.7) translateY(-32px);\r\n            transform: scale(0.7) translateY(-32px);\r\n    opacity: 0;\r\n    -webkit-transition: 500ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            500ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 500ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            500ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 500ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            500ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 500ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            500ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000),\r\n            500ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n}\r\n\r\n.dismissConfirmation_from_ReminderContent-css_uwm.dismissal-transition-appear-active,\r\n    .dismissConfirmation_from_ReminderContent-css_uwm.dismissal-transition-enter-active {\r\n    opacity: 1;\r\n    -webkit-transform: scale(1) translateY(0px);\r\n            transform: scale(1) translateY(0px);\r\n}\r\n\r\n.dismissConfirmation_from_ReminderContent-css_uwm.dismissal-transition-leave {\r\n    opacity: 1;\r\n    -webkit-transform: scale(1) translateY(0px);\r\n            transform: scale(1) translateY(0px);\r\n    -webkit-transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            500ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            500ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            500ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            500ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000),\r\n            500ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n}\r\n\r\n.dismissConfirmation_from_ReminderContent-css_uwm.dismissal-transition-leave-active {\r\n    opacity: 0;\r\n    -webkit-transform: scale(1.1) translateY(32px);\r\n            transform: scale(1.1) translateY(32px);\r\n}\r\n\r\n.dismissConfirmation_from_ReminderContent-css_uwm .dismissLabel_from_ReminderContent-css_1Sr {\r\n    position: absolute;\r\n    top: 24px;\r\n    left: 32px;\r\n    color: #6F7583;\r\n    font-weight: 600;\r\n    font-size: 0.675em;\r\n}\r\n\r\n.dismissConfirmation_from_ReminderContent-css_uwm .dismissContent_from_ReminderContent-css_3L8 {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center\r\n}\r\n\r\n.dismissConfirmation_from_ReminderContent-css_uwm .dismissContent_from_ReminderContent-css_3L8 > p {\r\n    font-size: 0.95em;\r\n    font-weight: 400;\r\n    color: #EC7B65;\r\n}\r\n\r\n.dismissConfirmation_from_ReminderContent-css_uwm .dismissContent_from_ReminderContent-css_3L8 > button {\r\n    margin-top: 6px\r\n}\r\n\r\n.dismissConfirmation_from_ReminderContent-css_uwm .dismissContent_from_ReminderContent-css_3L8 > button.dismissCancelButton_from_ReminderContent-css_CVS {\r\n    margin-top: 24px;\r\n    display: inline-block;\r\n    font-size: 0.8em;\r\n    font-weight: 600;\r\n    color: #496DF4;\r\n    border-bottom: 1px solid transparent;\r\n    -webkit-transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.dismissConfirmation_from_ReminderContent-css_uwm .dismissContent_from_ReminderContent-css_3L8 > button.dismissCancelButton_from_ReminderContent-css_CVS:hover,\r\n                .dismissConfirmation_from_ReminderContent-css_uwm .dismissContent_from_ReminderContent-css_3L8 > button.dismissCancelButton_from_ReminderContent-css_CVS:focus,\r\n                .dismissConfirmation_from_ReminderContent-css_uwm .dismissContent_from_ReminderContent-css_3L8 > button.dismissCancelButton_from_ReminderContent-css_CVS:active {\r\n    border-bottom-color: #496DF4;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"reminder": "reminder_from_ReminderContent-css_3n_",
	"show": "show_from_ReminderContent-css_2W1",
	"content": "content_from_ReminderContent-css_3sa",
	"activity": "activity_from_ReminderContent-css_3z-",
	"time": "time_from_ReminderContent-css_1ab",
	"title": "title_from_ReminderContent-css_1fo",
	"note": "note_from_ReminderContent-css_3Js",
	"lead": "lead_from_ReminderContent-css_3QT",
	"actions": "actions_from_ReminderContent-css_ugJ",
	"quickActions": "quickActions_from_ReminderContent-css_2cT",
	"snoozeActions": "snoozeActions_from_ReminderContent-css_1gx",
	"dismiss": "dismiss_from_ReminderContent-css_1Y6",
	"dismissConfirmation": "dismissConfirmation_from_ReminderContent-css_uwm",
	"dismissLabel": "dismissLabel_from_ReminderContent-css_1Sr",
	"dismissContent": "dismissContent_from_ReminderContent-css_3L8",
	"dismissCancelButton": "dismissCancelButton_from_ReminderContent-css_CVS"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/reminder/RemindersAlert.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".container_from_RemindersAlert-css_10G {\r\n    position: fixed;\r\n    z-index: 8;\r\n    bottom: 0;\r\n    right: 0;\r\n}\r\n\r\n.alert_from_RemindersAlert-css_avA {\r\n    position: relative;\r\n    outline: none;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    margin: 32px;\r\n    width: 64px;\r\n    height: 64px;\r\n    border-radius: 50%;\r\n    background: #F5F7F7;\r\n    border: 2px solid #F5F7F7;\r\n    -webkit-box-shadow: 0px 12px 36px rgba(16, 24, 52, 0.16);\r\n            box-shadow: 0px 12px 36px rgba(16, 24, 52, 0.16);\r\n    -webkit-transform-origin: center;\r\n            transform-origin: center;\r\n    -webkit-transition: 500ms all 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 500ms all 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.alert_from_RemindersAlert-css_avA:hover {\r\n    background: #FFFFFF;\r\n    border-color: #DCDEDE;\r\n    -webkit-box-shadow: 0px 8px 24px rgba(43, 44, 47, 0.2);\r\n            box-shadow: 0px 8px 24px rgba(43, 44, 47, 0.2);\r\n}\r\n\r\n.alert_from_RemindersAlert-css_avA .noteIcon_from_RemindersAlert-css_jYQ {\r\n    display: inline-block;\r\n}\r\n\r\n.alert_from_RemindersAlert-css_avA .closeIcon_from_RemindersAlert-css_302 {\r\n    display: none;\r\n}\r\n\r\n.alert_from_RemindersAlert-css_avA.isOpen_from_RemindersAlert-css_2es .noteIcon_from_RemindersAlert-css_jYQ {\r\n    display: none;\r\n}\r\n\r\n.alert_from_RemindersAlert-css_avA.isOpen_from_RemindersAlert-css_2es .closeIcon_from_RemindersAlert-css_302 {\r\n    display: inline-block;\r\n}\r\n\r\n.alert_from_RemindersAlert-css_avA > p {\r\n    z-index: 2;\r\n    position: absolute;\r\n    bottom: 2px;\r\n    right: 2px;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    font-size: 0.825em;\r\n    font-weight: 600;\r\n    width: 21px;\r\n    height: 21px;\r\n    border-radius: 50%;\r\n    background: #EC7B65;\r\n    color: #E9EBEB;\r\n}\r\n\r\n.alert_from_RemindersAlert-css_avA > img {\r\n    width: 30px;\r\n    height: auto;\r\n}\r\n\r\n.alert_from_RemindersAlert-css_avA > img.closeIcon_from_RemindersAlert-css_302 {\r\n    width: 21px;\r\n    height: auto;\r\n}\r\n\r\n.alert_from_RemindersAlert-css_avA.show-appear,\r\n    .alert_from_RemindersAlert-css_avA.show-enter {\r\n    opacity: 0;\r\n    -webkit-transform: scale(0) translateY(8px);\r\n            transform: scale(0) translateY(8px);\r\n    -webkit-transition: 500ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            500ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 500ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            500ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 500ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            500ms transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 500ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            500ms transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000),\r\n            500ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n}\r\n\r\n.alert_from_RemindersAlert-css_avA.show-appear > img, .alert_from_RemindersAlert-css_avA.show-enter > img {\r\n    opacity: 0;\r\n    -webkit-transform: translateY(-24px);\r\n            transform: translateY(-24px);\r\n    -webkit-transition: 500ms opacity 300ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                500ms -webkit-transform 300ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 500ms opacity 300ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                500ms -webkit-transform 300ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 500ms opacity 300ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                500ms transform 300ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 500ms opacity 300ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                500ms transform 300ms cubic-bezier(0.860, 0.000, 0.070, 1.000),\r\n                500ms -webkit-transform 300ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n}\r\n\r\n.alert_from_RemindersAlert-css_avA.show-appear-active,\r\n    .alert_from_RemindersAlert-css_avA.show-enter-active {\r\n    opacity: 1;\r\n    -webkit-transform: scale(1) translateY(0px);\r\n            transform: scale(1) translateY(0px);\r\n}\r\n\r\n.alert_from_RemindersAlert-css_avA.show-appear-active > img, .alert_from_RemindersAlert-css_avA.show-enter-active > img {\r\n    opacity: 1;\r\n    -webkit-transform: translateY(0px);\r\n            transform: translateY(0px);\r\n}\r\n\r\n.alert_from_RemindersAlert-css_avA.show-leave {\r\n    opacity: 1;\r\n    -webkit-transform: scale(1);\r\n            transform: scale(1);\r\n    -webkit-transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            300ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            300ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            300ms transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n    transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            300ms transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000),\r\n            300ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n}\r\n\r\n.alert_from_RemindersAlert-css_avA.show-leave-active {\r\n    opacity: 0;\r\n    -webkit-transform: scale(0);\r\n            transform: scale(0);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "container_from_RemindersAlert-css_10G",
	"alert": "alert_from_RemindersAlert-css_avA",
	"noteIcon": "noteIcon_from_RemindersAlert-css_jYQ",
	"closeIcon": "closeIcon_from_RemindersAlert-css_302",
	"isOpen": "isOpen_from_RemindersAlert-css_2es"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/reminder/RemindersCenter.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".container_from_RemindersCenter-css_1dr {\r\n    pointer-events: none;\r\n    position: fixed;\r\n    display: block;\r\n    text-align: right;\r\n    z-index: 7;\r\n    bottom: 0;\r\n    right: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    height: calc(100% - 64px);\r\n    opacity: 0;\r\n    overflow: scroll;\r\n    overflow-x: hidden;\r\n    background: rgba(242, 242, 242, 0.88);\r\n    -webkit-transition: 400ms opacity 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 400ms opacity 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000)\r\n}\r\n\r\n.container_from_RemindersCenter-css_1dr.show_from_RemindersCenter-css_1ok {\r\n    pointer-events: all;\r\n    opacity: 1\r\n}\r\n\r\n.container_from_RemindersCenter-css_1dr.show_from_RemindersCenter-css_1ok .center_from_RemindersCenter-css_1Tc {\r\n    -webkit-transform: translateX(0px) scaleX(1);\r\n            transform: translateX(0px) scaleX(1);\r\n    -webkit-transition: 500ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 500ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 500ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 500ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000), 500ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n}\r\n\r\n.center_from_RemindersCenter-css_1Tc {\r\n    background: rgba(247, 253, 255, 0.3);\r\n    -webkit-box-shadow: 0px 0px 128px rgba(0, 0, 0, 0.06);\r\n            box-shadow: 0px 0px 128px rgba(0, 0, 0, 0.06);\r\n    width: 667px;\r\n    padding-left: 128px;\r\n    margin-left: auto;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    height: auto;\r\n    min-height: 100%;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: reverse;\r\n        -ms-flex-direction: column-reverse;\r\n            flex-direction: column-reverse;\r\n    -ms-flex-wrap: nowrap;\r\n        flex-wrap: nowrap;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: start;\r\n        align-content: flex-start;\r\n    -webkit-box-align: start;\r\n        -ms-flex-align: start;\r\n            align-items: flex-start;\r\n    -webkit-transform-origin: bottom right;\r\n            transform-origin: bottom right;\r\n    -webkit-transform: translateX(64px) scaleX(0.8);\r\n            transform: translateX(64px) scaleX(0.8);\r\n    -webkit-transition: 300ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 300ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 300ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 300ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000), 300ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n}\r\n\r\n.noReminders_from_RemindersCenter-css_1PE {\r\n    display: block;\r\n    position: relative;\r\n    text-align: left;\r\n    height: auto;\r\n    width: 411px;\r\n    margin-bottom: 24px;\r\n    background: #FFFFFF;\r\n    border: 1px solid #F2F2F2;\r\n    -webkit-box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08);\r\n            box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08);\r\n    padding: 32px 32px;\r\n    color: #6F7583;\r\n    font-weight: 600;\r\n    font-size: 0.75em;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "container_from_RemindersCenter-css_1dr",
	"show": "show_from_RemindersCenter-css_1ok",
	"center": "center_from_RemindersCenter-css_1Tc",
	"noReminders": "noReminders_from_RemindersCenter-css_1PE"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/state/State.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".state_from_State-css_1aq {\r\n}\r\n\r\n.repsSearchField_from_State-css_1YR {\r\n    width: 320px;\r\n}\r\n\r\n.statesSearchField_from_State-css_2Mb {\r\n    width: 320px;\r\n}\r\n\r\n.backArrow_from_State-css_c5x .backArrowIcon_from_State-css_14- > img {\r\n    width: 12px;\r\n    height: 9px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"state": "state_from_State-css_1aq",
	"repsSearchField": "repsSearchField_from_State-css_1YR",
	"statesSearchField": "statesSearchField_from_State-css_2Mb",
	"backArrow": "backArrow_from_State-css_c5x",
	"backArrowIcon": "backArrowIcon_from_State-css_14-"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/state/StateArea.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".stateArea_from_StateArea-css_20v > div p {\n    color: #2E3D73;\n    font-weight: 600;\n    font-size: 0.875em;\n}\n.stateArea_from_StateArea-css_20v > div p strong {\n    font-weight: 700;\n}\n.stateArea_from_StateArea-css_20v > div p span {\n    font-weight: 400;\n}\n.stateArea_from_StateArea-css_20v > div p em {\n    font-weight: 400;\n    font-style: normal;\n    color: #A0A3A3;\n}\r\n", ""]);

// exports
exports.locals = {
	"stateArea": "stateArea_from_StateArea-css_20v"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/state/StateAreaList.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".row_from_StateAreaList-css_ZkR {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -ms-flex-wrap: nowrap;\r\n        flex-wrap: nowrap;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center\r\n}\r\n\r\n.row_from_StateAreaList-css_ZkR > div {\r\n    -webkit-box-flex: 0;\r\n        -ms-flex: 0 1 auto;\r\n            flex: 0 1 auto;\r\n    width: 192px;\r\n    text-align: left;\r\n    padding: 12px 6px\r\n}\r\n\r\n.row_from_StateAreaList-css_ZkR > div:last-child {\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1;\r\n            flex: 1;\r\n    width: auto;\r\n    text-align: right\r\n}\r\n\r\n.row_from_StateAreaList-css_ZkR > div:last-child > label {\r\n    margin-left: auto;\r\n    margin-right: 0;\r\n}\r\n\r\n.stateName_from_StateAreaList-css_eUz {\r\n    display: block;\r\n    font-size: 1.25em;\r\n    font-weight: 600;\r\n    color: #2E3D73;\r\n    padding: 24px 64px;\r\n    padding-bottom: 0;\r\n    background: #F5F9FA;\r\n}\r\n\r\n.header_from_StateAreaList-css_1gs {\r\n    padding: 12px 58px;\r\n    padding-top: 0;\r\n    background: #F5F9FA\r\n}\r\n\r\n.header_from_StateAreaList-css_1gs:first-child {\r\n    padding-top: 24px;\r\n}\r\n\r\n.header_from_StateAreaList-css_1gs > .row_from_StateAreaList-css_ZkR {\r\n    padding-top: 0;\r\n    padding-bottom: 0\r\n}\r\n\r\n.header_from_StateAreaList-css_1gs > .row_from_StateAreaList-css_ZkR > div {\r\n    font-size: 0.725em;\r\n    font-weight: 600;\r\n    color: #6F7583;\r\n}\r\n\r\n.header_from_StateAreaList-css_1gs .selectCol_from_StateAreaList-css_3rJ {\r\n    min-width: 110px;\r\n}\r\n\r\n.header_from_StateAreaList-css_1gs .selectAll_from_StateAreaList-css_3Xy > p {\r\n    font-size: 1.175em;\r\n    color: #496DF4;\r\n}\r\n\r\n.loading_from_StateAreaList-css_yNE {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    padding: 12px 58px;\r\n    padding-bottom: 32px;\r\n}\r\n\r\n.items_from_StateAreaList-css_1yl {\r\n    padding: 12px 58px;\r\n    padding-bottom: 32px\r\n}\r\n\r\n.items_from_StateAreaList-css_1yl .row_from_StateAreaList-css_ZkR > div {\r\n    position: relative;\r\n}\r\n\r\n.empty_from_StateAreaList-css_17d {\r\n    padding: 32px 64px;\r\n    padding-bottom: 48px\r\n}\r\n\r\n.empty_from_StateAreaList-css_17d p {\r\n    text-align: center;\r\n    font-size: 0.725em;\r\n    font-weight: 400;\r\n    color: #6F7583;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"row": "row_from_StateAreaList-css_ZkR",
	"stateName": "stateName_from_StateAreaList-css_eUz",
	"header": "header_from_StateAreaList-css_1gs",
	"selectCol": "selectCol_from_StateAreaList-css_3rJ",
	"selectAll": "selectAll_from_StateAreaList-css_3Xy",
	"loading": "loading_from_StateAreaList-css_yNE",
	"items": "items_from_StateAreaList-css_1yl",
	"empty": "empty_from_StateAreaList-css_17d"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/state/StateAreaListPicker.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".container_from_StateAreaListPicker-css_2l1 {\r\n    text-align: left;\r\n    display: grid;\r\n    grid-template: auto / 1fr 1fr 1fr;\r\n    gap: 12px;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n            justify-content: space-between;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    padding: 12px 64px\r\n}\n.container_from_StateAreaListPicker-css_2l1 > div {\r\n    width: 100%;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n}\n.container_from_StateAreaListPicker-css_2l1 select {\r\n    width: 100%;\r\n}\n.container_from_StateAreaListPicker-css_2l1 .status_from_StateAreaListPicker-css_13c {\r\n    text-align: left\r\n}\n.container_from_StateAreaListPicker-css_2l1 .status_from_StateAreaListPicker-css_13c .error_from_StateAreaListPicker-css_19y {\r\n    font-size: 0.875em;\r\n    font-weight: 400;\r\n    color: #EC7B65;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "container_from_StateAreaListPicker-css_2l1",
	"status": "status_from_StateAreaListPicker-css_13c",
	"error": "error_from_StateAreaListPicker-css_19y"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/state/StateItem.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".stateListItem_from_StateItem-css_3TY {\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1 0 25%;\r\n            flex: 1 0 25%;\r\n    display: block;\r\n    padding: 12px;\r\n}\r\n\r\n.stateListButton_from_StateItem-css_3uc {\r\n    width: 100%;\r\n    min-height: 72px;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: start;\r\n        align-content: flex-start;\r\n    -webkit-box-align: start;\r\n        -ms-flex-align: start;\r\n            align-items: flex-start\r\n}\r\n\r\n.stateListButton_from_StateItem-css_3uc .stateName_from_StateItem-css_1PK {\r\n    text-align: left;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    padding-right: 16px;\r\n}\r\n\r\n.stateListButton_from_StateItem-css_3uc .stateName_from_StateItem-css_1PK strong {\r\n    display: block;\r\n    font-size: 1.3em;\r\n    font-weight: 700;\r\n    color: #496DF4;\r\n}\r\n\r\n.stateListButton_from_StateItem-css_3uc .stateName_from_StateItem-css_1PK span {\r\n    display: block;\r\n    font-size: 0.825em;\r\n    font-weight: 400;\r\n    color: #2E3D73;\r\n    margin-top: 12px;\r\n}\r\n\r\n.stateListButton_from_StateItem-css_3uc .stateName_from_StateItem-css_1PK span:first-child {\r\n    margin-top: 0;\r\n}\r\n\r\n.stateListButton_from_StateItem-css_3uc .stateLeadsCount_from_StateItem-css_2-D {\r\n    position: absolute;\r\n    top: 16px;\r\n    right: 16px;\r\n    text-align: right;\r\n    color: #2B2C2F;\r\n}\r\n\r\n.stateListButton_from_StateItem-css_3uc .stateLeadsCount_from_StateItem-css_2-D strong {\r\n    font-weight: 600;\r\n    color: inherit;\r\n}\r\n\r\n.stateListButton_from_StateItem-css_3uc .stateLeadsCount_from_StateItem-css_2-D em {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    color: inherit;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"stateListItem": "stateListItem_from_StateItem-css_3TY",
	"stateListButton": "stateListButton_from_StateItem-css_3uc",
	"stateName": "stateName_from_StateItem-css_1PK",
	"stateLeadsCount": "stateLeadsCount_from_StateItem-css_2-D"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/state/StateList.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".stateList_from_StateList-css_19z {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -ms-flex-line-pack: start;\r\n      align-content: flex-start;\r\n  -webkit-box-align: start;\r\n      -ms-flex-align: start;\r\n          align-items: flex-start;\r\n  padding: 32px 40px;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: row;\r\n          flex-direction: row;\r\n  -ms-flex-wrap: wrap;\r\n      flex-wrap: wrap;\r\n}\r\n\r\n.empty_from_StateList-css_35Z {\r\n  padding: 32px 64px;\r\n  padding-bottom: 48px\r\n}\r\n\r\n.empty_from_StateList-css_35Z p {\r\n  text-align: center;\r\n  font-size: 0.725em;\r\n  font-weight: 400;\r\n  color: #6F7583;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"stateList": "stateList_from_StateList-css_19z",
	"empty": "empty_from_StateList-css_35Z"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/state/StateRepAssignedAreas.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".row_from_StateRepAssignedAreas-css_1BR {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -ms-flex-wrap: nowrap;\r\n        flex-wrap: nowrap;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center\r\n}\r\n\r\n.row_from_StateRepAssignedAreas-css_1BR > div {\r\n    -webkit-box-flex: 0;\r\n        -ms-flex: 0 1 auto;\r\n            flex: 0 1 auto;\r\n    width: 192px;\r\n    text-align: left;\r\n    padding: 12px 6px\r\n}\r\n\r\n.row_from_StateRepAssignedAreas-css_1BR > div:last-child {\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1;\r\n            flex: 1;\r\n    width: auto;\r\n    text-align: right;\r\n}\r\n\r\n.header_from_StateRepAssignedAreas-css_2bV {\r\n    padding: 12px 64px;\r\n    padding-top: 0;\r\n    background: #F5F9FA\r\n}\r\n\r\n.header_from_StateRepAssignedAreas-css_2bV:first-child {\r\n    padding-top: 24px;\r\n}\r\n\r\n.header_from_StateRepAssignedAreas-css_2bV > .row_from_StateRepAssignedAreas-css_1BR {\r\n    padding-top: 0;\r\n    padding-bottom: 0\r\n}\r\n\r\n.header_from_StateRepAssignedAreas-css_2bV > .row_from_StateRepAssignedAreas-css_1BR > div {\r\n    font-size: 0.725em;\r\n    font-weight: 600;\r\n    color: #6F7583;\r\n}\r\n\r\n.items_from_StateRepAssignedAreas-css_15b {\r\n    padding: 12px 64px;\r\n    padding-bottom: 32px\r\n}\r\n\r\n.items_from_StateRepAssignedAreas-css_15b > div:first-child .row_from_StateRepAssignedAreas-css_1BR:not(.subRow_from_StateRepAssignedAreas-css_2SN) {\r\n    margin-top: 0;\r\n    border-top: none;\r\n}\r\n\r\n.items_from_StateRepAssignedAreas-css_15b .row_from_StateRepAssignedAreas-css_1BR {\r\n    margin-top: 12px;\r\n    padding-top: 12px;\r\n    border-top: 1px solid #6F7583\r\n}\r\n\r\n.items_from_StateRepAssignedAreas-css_15b .row_from_StateRepAssignedAreas-css_1BR > div {\r\n    position: relative;\r\n}\r\n\r\n.items_from_StateRepAssignedAreas-css_15b .row_from_StateRepAssignedAreas-css_1BR.subRow_from_StateRepAssignedAreas-css_2SN {\r\n    margin-top: 0;\r\n    padding-top: 0;\r\n    border-top: 1px dashed #E9EBEB;\r\n    background: #F8FCFD;\r\n    -webkit-transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.items_from_StateRepAssignedAreas-css_15b .row_from_StateRepAssignedAreas-css_1BR.subRow_from_StateRepAssignedAreas-css_2SN:hover {\r\n    background: #FFFFFF;\r\n}\r\n\r\n.items_from_StateRepAssignedAreas-css_15b .row_from_StateRepAssignedAreas-css_1BR.subRow_from_StateRepAssignedAreas-css_2SN > div {\r\n    padding-top: 6px;\r\n    padding-bottom: 6px\r\n}\r\n\r\n.items_from_StateRepAssignedAreas-css_15b .row_from_StateRepAssignedAreas-css_1BR.subRow_from_StateRepAssignedAreas-css_2SN > div:first-child {\r\n    padding-left: 32px\r\n}\r\n\r\n.items_from_StateRepAssignedAreas-css_15b .row_from_StateRepAssignedAreas-css_1BR.subRow_from_StateRepAssignedAreas-css_2SN > div:first-child p {\r\n    position: relative\r\n}\r\n\r\n.items_from_StateRepAssignedAreas-css_15b .row_from_StateRepAssignedAreas-css_1BR.subRow_from_StateRepAssignedAreas-css_2SN > div:first-child p::after {\r\n    content: '';\r\n    display: block;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: -24px;\r\n    width: 16px;\r\n    height: 1px;\r\n    margin-top: -1px;\r\n    background: rgba(160, 163, 163, 0.3);\r\n}\r\n\r\n.items_from_StateRepAssignedAreas-css_15b .row_from_StateRepAssignedAreas-css_1BR.subRow_from_StateRepAssignedAreas-css_2SN > div p {\r\n    font-size: 0.85em;\r\n}\r\n\r\n.headline_from_StateRepAssignedAreas-css_1Yj {\r\n    display: block;\r\n    font-size: 1.025em;\r\n    font-weight: 600;\r\n    color: #2E3D73;\r\n    padding: 24px 70px;\r\n    padding-bottom: 0;\r\n    background: #F5F9FA;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"row": "row_from_StateRepAssignedAreas-css_1BR",
	"header": "header_from_StateRepAssignedAreas-css_2bV",
	"items": "items_from_StateRepAssignedAreas-css_15b",
	"subRow": "subRow_from_StateRepAssignedAreas-css_2SN",
	"headline": "headline_from_StateRepAssignedAreas-css_1Yj"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/state/StateRepsList.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".container_from_StateRepsList-css_3jK {\r\n}\r\n\r\n.header_from_StateRepsList-css_bz3 {\r\n    padding: 12px 64px;\r\n    padding-top: 24px;\r\n    background: #F5F9FA;\r\n}\r\n\r\n.headline_from_StateRepsList-css_nKl {\r\n    padding: 0;\r\n}\r\n\r\n.assignIcon_from_StateRepsList-css_3ro img {\r\n    width: 14px;\r\n    height: auto;\r\n}\r\n\r\n.repsList_from_StateRepsList-css_2hJ {\r\n    display: grid;\r\n    grid-template: auto / 1fr 1fr 1fr 1fr;\r\n    gap: 24px;\r\n    padding: 32px 64px\r\n}\r\n\r\n.repsList_from_StateRepsList-css_2hJ.oneResult_from_StateRepsList-css_363 {\r\n    grid-template: auto / 1fr;\r\n}\r\n\r\n.repsList_from_StateRepsList-css_2hJ.twoResults_from_StateRepsList-css_3VN {\r\n    grid-template: auto / 1fr 1fr;\r\n}\r\n\r\n.repsList_from_StateRepsList-css_2hJ.threeResults_from_StateRepsList-css_3pW {\r\n    grid-template: auto / 1fr 1fr 1fr;\r\n}\r\n\r\n.empty_from_StateRepsList-css_2wj {\r\n    display: block;\r\n    padding: 32px 64px;\r\n    padding-bottom: 48px\r\n}\r\n\r\n.empty_from_StateRepsList-css_2wj p {\r\n    text-align: center;\r\n    font-size: 0.725em;\r\n    font-weight: 400;\r\n    color: #6F7583;\r\n}\r\n\r\n.repButton_from_StateRepsList-css_wep {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -webkit-box-align: start;\r\n        -ms-flex-align: start;\r\n            align-items: flex-start;\r\n    text-align: left;\r\n}\r\n\r\n.repName_from_StateRepsList-css_3vs {\r\n    display: block;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    padding-right: 16px;\r\n    font-size: 1.25em;\r\n    font-weight: 400;\r\n    color: #496DF4;\r\n}\r\n\r\n.repAreasCount_from_StateRepsList-css_18x {\r\n    margin-top: 6px;\r\n    font-weight: 400;\r\n    font-size: 0.95em;\r\n    font-style: normal;\r\n    color: #2B2C2F\r\n}\r\n\r\n.repAreasCount_from_StateRepsList-css_18x strong {\r\n    font-weight: 400;\r\n    color: inherit;\r\n}\r\n\r\n.repAreasCount_from_StateRepsList-css_18x span {\r\n    margin-left: 6px;\r\n    color: #444956;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "container_from_StateRepsList-css_3jK",
	"header": "header_from_StateRepsList-css_bz3",
	"headline": "headline_from_StateRepsList-css_nKl",
	"assignIcon": "assignIcon_from_StateRepsList-css_3ro",
	"repsList": "repsList_from_StateRepsList-css_2hJ",
	"oneResult": "oneResult_from_StateRepsList-css_363",
	"twoResults": "twoResults_from_StateRepsList-css_3VN",
	"threeResults": "threeResults_from_StateRepsList-css_3pW",
	"empty": "empty_from_StateRepsList-css_2wj",
	"repButton": "repButton_from_StateRepsList-css_wep",
	"repName": "repName_from_StateRepsList-css_3vs",
	"repAreasCount": "repAreasCount_from_StateRepsList-css_18x"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/errors/PageForbidden/PageForbidden.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".pageForbidden_from_PageForbidden-css_9lm {\r\n  position: fixed;\r\n  overflow: auto;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"pageForbidden": "pageForbidden_from_PageForbidden-css_9lm"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Dashboard/SalesDashboard.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".salesDashboard_from_SalesDashboard-css_PL0 {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    width: 100%;\r\n    min-height: calc(100% - 64px);\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: stretch;\r\n        align-content: stretch;\r\n    -webkit-box-align: stretch;\r\n        -ms-flex-align: stretch;\r\n            align-items: stretch;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -ms-flex-wrap: nowrap;\r\n        flex-wrap: nowrap\r\n}\r\n\r\n.salesDashboard_from_SalesDashboard-css_PL0 > div {\r\n    position: relative;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: stretch;\r\n        align-content: stretch;\r\n    -webkit-box-align: stretch;\r\n        -ms-flex-align: stretch;\r\n            align-items: stretch\r\n}\r\n\r\n.salesDashboard_from_SalesDashboard-css_PL0 > div.leads_from_SalesDashboard-css_2wb {\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1 0;\r\n            flex: 1 0;\r\n    z-index: 3;\r\n    position: relative;\r\n    background: #F8FCFD;\r\n    -webkit-box-shadow: 0px 10px 25px rgba(43, 44, 47, 0.08);\r\n            box-shadow: 0px 10px 25px rgba(43, 44, 47, 0.08);\r\n}\r\n\r\n.viewToggle_from_SalesDashboard-css_3Il {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    width: auto;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -webkit-box-align: stretch;\r\n        -ms-flex-align: stretch;\r\n            align-items: stretch;\r\n    -ms-flex-line-pack: stretch;\r\n        align-content: stretch;\r\n    -ms-flex-wrap: nowrap;\r\n        flex-wrap: nowrap;\r\n    margin-left: 12px;\r\n}\r\n\r\n.viewToggleButton_from_SalesDashboard-css_3G8 {\r\n    z-index: 1;\r\n    position: relative;\r\n    display: -webkit-inline-box;\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    width: 38px;\r\n    height: 38px;\r\n    background: #FFFFFF;\r\n    border: 1px solid #E9EBEB;\r\n    -webkit-transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        300ms -webkit-box-shadow 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        300ms -webkit-box-shadow 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        300ms box-shadow 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n    transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        300ms box-shadow 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000),\r\n        300ms -webkit-box-shadow 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000)\r\n}\r\n\r\n.viewToggleButton_from_SalesDashboard-css_3G8:not(:first-child) {\r\n    border-left: none;\r\n}\r\n\r\n.viewToggleButton_from_SalesDashboard-css_3G8:first-child {\r\n    border-top-left-radius: 3px;\r\n    border-bottom-left-radius: 3px;\r\n}\r\n\r\n.viewToggleButton_from_SalesDashboard-css_3G8:last-child {\r\n    border-top-right-radius: 3px;\r\n    border-bottom-right-radius: 3px;\r\n}\r\n\r\n.viewToggleButton_from_SalesDashboard-css_3G8:hover {\r\n    z-index: 2;\r\n    background: #F5F7F7;\r\n    -webkit-box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.24);\r\n            box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.24);\r\n}\r\n\r\n.viewToggleButton_from_SalesDashboard-css_3G8 > svg {\r\n    width: 14px;\r\n    height: 14px\r\n}\r\n\r\n.viewToggleButton_from_SalesDashboard-css_3G8 > svg > g g {\r\n    fill: #444956;\r\n}\r\n\r\n.viewToggleButton_from_SalesDashboard-css_3G8.active_from_SalesDashboard-css_OnM > svg > g g {\r\n    fill: #496DF4;\r\n}\r\n\r\n.leadsList_from_SalesDashboard-css_3G9 {\r\n    display: grid;\r\n    grid-template: auto / auto auto auto auto;\r\n    width: 100%;\r\n    margin: 0 auto\r\n}\r\n\r\n.leadsList_from_SalesDashboard-css_3G9 .headline_from_SalesDashboard-css_1jJ {\r\n    padding: 0;\r\n    padding-right: 12px;\r\n}\r\n\r\n.leadsList_from_SalesDashboard-css_3G9 .leadsSearch_from_SalesDashboard-css_3N- {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    width: auto;\r\n    padding-top: 16px;\r\n    padding-bottom: 16px\r\n}\r\n\r\n.leadsList_from_SalesDashboard-css_3G9 .leadsSearch_from_SalesDashboard-css_3N- .searchField_from_SalesDashboard-css_1jN {\r\n    width: 384px;\r\n}\r\n\r\n.leadsList_from_SalesDashboard-css_3G9 .leadsSearch_from_SalesDashboard-css_3N- .lastLeadActivityType_from_SalesDashboard-css_3Z5,\r\n        .leadsList_from_SalesDashboard-css_3G9 .leadsSearch_from_SalesDashboard-css_3N- .lastLeadActivityDate_from_SalesDashboard-css_2DW {\r\n    margin-left: 16px;\r\n}\r\n\r\n.leadsList_from_SalesDashboard-css_3G9 > .leadsListResults_from_SalesDashboard-css_1Cv {\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1;\r\n            flex: 1;\r\n    padding: 64px;\r\n    padding-top: 128px\r\n}\r\n\r\n.leadsList_from_SalesDashboard-css_3G9 > .leadsListResults_from_SalesDashboard-css_1Cv.listIsEmpty_from_SalesDashboard-css_hrX {\r\n    grid-column: 1 / span 4;\r\n}\r\n\r\n.leadsList_from_SalesDashboard-css_3G9 > .leadsListResults_from_SalesDashboard-css_1Cv .listNoResults_from_SalesDashboard-css_2e2 p {\r\n    text-align: center;\r\n    padding: 16px 32px;\r\n    font-size: 0.8em;\r\n    font-weight: 600;\r\n    color: #444956;\r\n}\r\n\r\n.leadsGrid_from_SalesDashboard-css_NXW {\r\n    padding: 0;\r\n    padding-bottom: 48px;\r\n    display: grid;\r\n    grid-template: auto / 1fr 1fr 1fr;\r\n    gap: 32px\r\n}\r\n\r\n.leadsGrid_from_SalesDashboard-css_NXW.single_from_SalesDashboard-css_3ks > div:nth-child(1) {\r\n    grid-column: 2;\r\n}\r\n\r\n.leadsGrid_from_SalesDashboard-css_NXW.double_from_SalesDashboard-css_1hh {\r\n    grid-template: auto / 1fr 2fr 2fr 1fr\r\n}\r\n\r\n.leadsGrid_from_SalesDashboard-css_NXW.double_from_SalesDashboard-css_1hh > div:nth-child(1) {\r\n    grid-column: 2;\r\n}\r\n\r\n.leadsGrid_from_SalesDashboard-css_NXW.double_from_SalesDashboard-css_1hh > div:nth-child(2) {\r\n    grid-column: 3;\r\n}\r\n\r\n@media screen and (max-width: 1366px) {\r\n\r\n    .leadsGrid_from_SalesDashboard-css_NXW {\r\n        grid-template: auto / 1fr 1fr\r\n    }\r\n\r\n    .leadsGrid_from_SalesDashboard-css_NXW.single_from_SalesDashboard-css_3ks > div:nth-child(1) {\r\n        grid-column: 1 / span 2;\r\n    }\r\n\r\n    .leadsGrid_from_SalesDashboard-css_NXW.double_from_SalesDashboard-css_1hh {\r\n        grid-template: auto / 1fr 1fr\r\n    }\r\n\r\n    .leadsGrid_from_SalesDashboard-css_NXW.double_from_SalesDashboard-css_1hh > div:nth-child(1) {\r\n        grid-column: 1;\r\n    }\r\n\r\n    .leadsGrid_from_SalesDashboard-css_NXW.double_from_SalesDashboard-css_1hh > div:nth-child(2) {\r\n        grid-column: 2;\r\n    }\r\n}\r\n\r\n.createNewLeadIcon_from_SalesDashboard-css_Iu3 img {\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n\r\n.assignRepsIcon_from_SalesDashboard-css_1-9 img {\r\n    width: 14px;\r\n    height: auto;\r\n}\r\n\r\n.leadsActivities_from_SalesDashboard-css_1-t {\r\n    position: relative;\r\n    -webkit-box-flex: 0;\r\n        -ms-flex: 0 1 435px;\r\n            flex: 0 1 435px;\r\n    max-width: 435px;\r\n    background: #F2F2F2;\r\n    padding-bottom: 128px;\r\n    z-index: 2\r\n}\r\n\r\n.leadsActivities_from_SalesDashboard-css_1-t > h2 {\r\n    border-top: 1px solid #E9EBEB\r\n}\r\n\r\n.leadsActivities_from_SalesDashboard-css_1-t > h2:first-child {\r\n    border-top: none;\r\n}\r\n\r\n.leadsActivities_from_SalesDashboard-css_1-t .assignRepsHeadline_from_SalesDashboard-css_uuP {\r\n    padding-top: 26px;\r\n    padding-bottom: 26px;\r\n}\r\n\r\n.leadsActivities_from_SalesDashboard-css_1-t .empty_from_SalesDashboard-css_2Wu {\r\n    display: block;\r\n    font-size: 0.725em;\r\n    font-weight: 400;\r\n    color: #A0A3A3;\r\n    padding: 0 32px;\r\n    padding-bottom: 24px;\r\n}\r\n\r\n.fixedHeader_from_SalesDashboard-css_2fm {\r\n    position: fixed;\r\n    width: 100%;\r\n    left: 0;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1;\r\n            flex: 1;\r\n    max-width: calc(100% - 435px);\r\n    background: #F8FCFD;\r\n    z-index: 1;\r\n    -webkit-box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.06);\r\n            box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.06);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"salesDashboard": "salesDashboard_from_SalesDashboard-css_PL0",
	"leads": "leads_from_SalesDashboard-css_2wb",
	"viewToggle": "viewToggle_from_SalesDashboard-css_3Il",
	"viewToggleButton": "viewToggleButton_from_SalesDashboard-css_3G8",
	"active": "active_from_SalesDashboard-css_OnM",
	"leadsList": "leadsList_from_SalesDashboard-css_3G9",
	"headline": "headline_from_SalesDashboard-css_1jJ",
	"leadsSearch": "leadsSearch_from_SalesDashboard-css_3N-",
	"searchField": "searchField_from_SalesDashboard-css_1jN",
	"lastLeadActivityType": "lastLeadActivityType_from_SalesDashboard-css_3Z5",
	"lastLeadActivityDate": "lastLeadActivityDate_from_SalesDashboard-css_2DW",
	"leadsListResults": "leadsListResults_from_SalesDashboard-css_1Cv",
	"listIsEmpty": "listIsEmpty_from_SalesDashboard-css_hrX",
	"listNoResults": "listNoResults_from_SalesDashboard-css_2e2",
	"leadsGrid": "leadsGrid_from_SalesDashboard-css_NXW",
	"single": "single_from_SalesDashboard-css_3ks",
	"double": "double_from_SalesDashboard-css_1hh",
	"createNewLeadIcon": "createNewLeadIcon_from_SalesDashboard-css_Iu3",
	"assignRepsIcon": "assignRepsIcon_from_SalesDashboard-css_1-9",
	"leadsActivities": "leadsActivities_from_SalesDashboard-css_1-t",
	"assignRepsHeadline": "assignRepsHeadline_from_SalesDashboard-css_uuP",
	"empty": "empty_from_SalesDashboard-css_2Wu",
	"fixedHeader": "fixedHeader_from_SalesDashboard-css_2fm"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Dashboard/SalesDashboardLeadOrNoteCard.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".card_from_SalesDashboardLeadOrNoteCard-css_1W_ {\r\n    position: relative;\r\n    cursor: pointer;\r\n    background: #F8FCFD;\r\n    border: 1px solid #DCDEDE;\r\n    border-radius: 3px;\r\n    -webkit-box-shadow: 0px 16px 32px rgba(0, 0, 0, 0.02);\r\n            box-shadow: 0px 16px 32px rgba(0, 0, 0, 0.02);\r\n    -webkit-transition: 400ms -webkit-box-shadow 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 400ms -webkit-box-shadow 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 400ms box-shadow 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 400ms box-shadow 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000), 400ms -webkit-box-shadow 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.card_from_SalesDashboardLeadOrNoteCard-css_1W_:hover {\r\n    -webkit-box-shadow: 0px 16px 32px rgba(0, 0, 0, 0.06);\r\n            box-shadow: 0px 16px 32px rgba(0, 0, 0, 0.06)\r\n}\r\n\r\n.card_from_SalesDashboardLeadOrNoteCard-css_1W_:hover .comment_from_SalesDashboardLeadOrNoteCard-css_C35 {\r\n    margin-bottom: 6px;\r\n    border-bottom: 1px solid #496DF4;\r\n}\r\n\r\n.card_from_SalesDashboardLeadOrNoteCard-css_1W_:hover .name_from_SalesDashboardLeadOrNoteCard-css_lwa > strong {\r\n    color: #496DF4;\r\n}\r\n\r\n.card_from_SalesDashboardLeadOrNoteCard-css_1W_:hover .name_from_SalesDashboardLeadOrNoteCard-css_lwa > span {\r\n    margin-bottom: 6px;\r\n    border-bottom: 1px solid #496DF4;\r\n}\r\n\r\n.card_from_SalesDashboardLeadOrNoteCard-css_1W_.inList_from_SalesDashboardLeadOrNoteCard-css_1Ut {\r\n    display: contents;\r\n    border: none;\r\n    background: none\r\n}\r\n\r\n.card_from_SalesDashboardLeadOrNoteCard-css_1W_.inList_from_SalesDashboardLeadOrNoteCard-css_1Ut:not(:first-child) {\r\n    margin-top: 12px\r\n}\r\n\r\n.card_from_SalesDashboardLeadOrNoteCard-css_1W_.inList_from_SalesDashboardLeadOrNoteCard-css_1Ut:not(:first-child) .inner_from_SalesDashboardLeadOrNoteCard-css_2N6 > * {\r\n    border-top: 1px solid #DCDEDE;\r\n}\r\n\r\n.card_from_SalesDashboardLeadOrNoteCard-css_1W_.inList_from_SalesDashboardLeadOrNoteCard-css_1Ut.isEven_from_SalesDashboardLeadOrNoteCard-css_2Pb .inner_from_SalesDashboardLeadOrNoteCard-css_2N6 > * {\r\n    background: #F7FDFF;\r\n}\r\n\r\n.card_from_SalesDashboardLeadOrNoteCard-css_1W_.inList_from_SalesDashboardLeadOrNoteCard-css_1Ut .inner_from_SalesDashboardLeadOrNoteCard-css_2N6 {\r\n    display: contents\r\n}\r\n\r\n.card_from_SalesDashboardLeadOrNoteCard-css_1W_.inList_from_SalesDashboardLeadOrNoteCard-css_1Ut .inner_from_SalesDashboardLeadOrNoteCard-css_2N6 > * {\r\n    background: #FFFFFF;\r\n}\r\n\r\n.card_from_SalesDashboardLeadOrNoteCard-css_1W_.inList_from_SalesDashboardLeadOrNoteCard-css_1Ut .inner_from_SalesDashboardLeadOrNoteCard-css_2N6 > br {\r\n    display: none;\r\n}\r\n\r\n.card_from_SalesDashboardLeadOrNoteCard-css_1W_.inList_from_SalesDashboardLeadOrNoteCard-css_1Ut .idContainer_from_SalesDashboardLeadOrNoteCard-css_W3G {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    padding: 12px;\r\n    border: none;\r\n}\r\n\r\n.card_from_SalesDashboardLeadOrNoteCard-css_1W_.inList_from_SalesDashboardLeadOrNoteCard-css_1Ut .name_from_SalesDashboardLeadOrNoteCard-css_lwa {\r\n    padding: 12px;\r\n}\r\n\r\n.card_from_SalesDashboardLeadOrNoteCard-css_1W_.inList_from_SalesDashboardLeadOrNoteCard-css_1Ut .comment_from_SalesDashboardLeadOrNoteCard-css_C35 {\r\n    margin-top: 0;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.card_from_SalesDashboardLeadOrNoteCard-css_1W_.inList_from_SalesDashboardLeadOrNoteCard-css_1Ut .details_from_SalesDashboardLeadOrNoteCard-css_VYm {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -ms-flex-wrap: nowrap;\r\n        flex-wrap: nowrap;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    padding: 12px 0;\r\n    padding-left: 12px\r\n}\r\n\r\n.card_from_SalesDashboardLeadOrNoteCard-css_1W_.inList_from_SalesDashboardLeadOrNoteCard-css_1Ut .details_from_SalesDashboardLeadOrNoteCard-css_VYm.contact_from_SalesDashboardLeadOrNoteCard-css_sfH {\r\n    -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n            justify-content: space-between;\r\n}\r\n\r\n.card_from_SalesDashboardLeadOrNoteCard-css_1W_.inList_from_SalesDashboardLeadOrNoteCard-css_1Ut .details_from_SalesDashboardLeadOrNoteCard-css_VYm.noteDate_from_SalesDashboardLeadOrNoteCard-css_3oK {\r\n    -webkit-box-pack: end;\r\n        -ms-flex-pack: end;\r\n            justify-content: flex-end;\r\n    text-align: right;\r\n}\r\n\r\n.inner_from_SalesDashboardLeadOrNoteCard-css_2N6 {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n            justify-content: space-between;\r\n    -webkit-box-align: start;\r\n        -ms-flex-align: start;\r\n            align-items: flex-start;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.idContainer_from_SalesDashboardLeadOrNoteCard-css_W3G {\r\n    width: 100%;\r\n    position: relative;\r\n    padding: 12px 24px;\r\n    border-bottom: 1px solid #E9EBEB;\r\n}\r\n\r\n.id_from_SalesDashboardLeadOrNoteCard-css_y84 {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    font-weight: 400;\r\n    font-size: 0.85em;\r\n    color: #444956\r\n}\r\n\r\n.id_from_SalesDashboardLeadOrNoteCard-css_y84 span {\r\n    display: -webkit-inline-box;\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    width: 24px;\r\n    height: 24px;\r\n    border-radius: 1px;\r\n    background: #F7FDFF;\r\n    border: 1px solid #DCDEDE;\r\n}\r\n\r\n.id_from_SalesDashboardLeadOrNoteCard-css_y84 strong {\r\n    margin-left: 6px;\r\n    font-weight: inherit;\r\n}\r\n\r\n.name_from_SalesDashboardLeadOrNoteCard-css_lwa {\r\n    text-align: left;\r\n    padding: 12px 24px;\r\n    padding-top: 24px\r\n}\r\n\r\n.name_from_SalesDashboardLeadOrNoteCard-css_lwa > strong {\r\n    display: block;\r\n    font-size: 1.3em;\r\n    font-weight: 400;\r\n    color: #2E3D73;\r\n    margin-top: 6px;\r\n    -webkit-transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.name_from_SalesDashboardLeadOrNoteCard-css_lwa > span {\r\n    display: inline-block;\r\n    font-size: 0.8em;\r\n    font-weight: 700;\r\n    color: #2B2C2F;\r\n    margin-top: 1px;\r\n    margin-bottom: 1px;\r\n    border-bottom: 6px solid transparent;\r\n    -webkit-transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            300ms margin 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n            300ms margin 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.name_from_SalesDashboardLeadOrNoteCard-css_lwa:hover > strong, .name_from_SalesDashboardLeadOrNoteCard-css_lwa:focus > strong, .name_from_SalesDashboardLeadOrNoteCard-css_lwa:active > strong {\r\n    color: #496DF4;\r\n}\r\n\r\n.name_from_SalesDashboardLeadOrNoteCard-css_lwa:hover > span, .name_from_SalesDashboardLeadOrNoteCard-css_lwa:focus > span, .name_from_SalesDashboardLeadOrNoteCard-css_lwa:active > span {\r\n    margin-bottom: 6px;\r\n    border-bottom: 1px solid #496DF4;\r\n}\r\n\r\n.comment_from_SalesDashboardLeadOrNoteCard-css_C35 {\r\n    text-align: left;\r\n    padding: 12px 24px;\r\n    padding-top: 24px;\r\n    display: block;\r\n    width: 100%;\r\n    line-height: 1.3;\r\n    font-size: 0.9em;\r\n    font-weight: 600;\r\n    color: #2B2C2F;\r\n    margin-top: 1px;\r\n    margin-bottom: 1px;\r\n    border-bottom: 6px solid transparent;\r\n    -webkit-transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        300ms margin 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        300ms margin 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.comment_from_SalesDashboardLeadOrNoteCard-css_C35 em {\r\n    font-style: inherit;\r\n    font-weight: inherit;\r\n    background: rgb(223, 226, 226);\r\n    color: #2A5798;\r\n}\r\n\r\n.comment_from_SalesDashboardLeadOrNoteCard-css_C35:hover > span, .comment_from_SalesDashboardLeadOrNoteCard-css_C35:focus > span, .comment_from_SalesDashboardLeadOrNoteCard-css_C35:active > span {\r\n    margin-bottom: 6px;\r\n    border-bottom: 1px solid #496DF4;\r\n}\r\n\r\n.details_from_SalesDashboardLeadOrNoteCard-css_VYm {\r\n    padding: 12px 24px\r\n}\r\n\r\n.details_from_SalesDashboardLeadOrNoteCard-css_VYm.lastActivity_from_SalesDashboardLeadOrNoteCard-css_ZTb {\r\n    padding-bottom: 0\r\n}\r\n\r\n.details_from_SalesDashboardLeadOrNoteCard-css_VYm.lastActivity_from_SalesDashboardLeadOrNoteCard-css_ZTb span {\r\n    display: block;\r\n    padding-top: 4px;\r\n    font-weight: 400;\r\n    font-size: 0.85em;\r\n    color: #444956;\r\n}\r\n\r\n.details_from_SalesDashboardLeadOrNoteCard-css_VYm.lastActivity_from_SalesDashboardLeadOrNoteCard-css_ZTb strong {\r\n    display: block;\r\n    font-size: 1.1em;\r\n    font-weight: 400;\r\n    margin-top: 6px;\r\n    color: #2E3D73;\r\n}\r\n\r\n.details_from_SalesDashboardLeadOrNoteCard-css_VYm li {\r\n    display: inline-block;\r\n    margin-left: 24px;\r\n    font-weight: 300;\r\n    font-size: 0.7em;\r\n    color: #444956;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.05em\r\n}\r\n\r\n.details_from_SalesDashboardLeadOrNoteCard-css_VYm li:first-child {\r\n    margin-left: 0;\r\n}\r\n\r\n.details_from_SalesDashboardLeadOrNoteCard-css_VYm li p {\r\n    color: #2B2C2F;\r\n    font-weight: 400;\r\n    font-size: 1.1em;\r\n}\r\n\r\n.details_from_SalesDashboardLeadOrNoteCard-css_VYm li a {\r\n    display: inline;\r\n    color: inherit;\r\n    text-decoration: none;\r\n    border: none;\r\n    border-bottom: 1px solid #A0A3A3;\r\n    -webkit-transition: 300ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.details_from_SalesDashboardLeadOrNoteCard-css_VYm li a:hover {\r\n    color: #496DF4;\r\n    border-bottom-color: #496DF4;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"card": "card_from_SalesDashboardLeadOrNoteCard-css_1W_",
	"comment": "comment_from_SalesDashboardLeadOrNoteCard-css_C35",
	"name": "name_from_SalesDashboardLeadOrNoteCard-css_lwa",
	"inList": "inList_from_SalesDashboardLeadOrNoteCard-css_1Ut",
	"inner": "inner_from_SalesDashboardLeadOrNoteCard-css_2N6",
	"isEven": "isEven_from_SalesDashboardLeadOrNoteCard-css_2Pb",
	"idContainer": "idContainer_from_SalesDashboardLeadOrNoteCard-css_W3G",
	"details": "details_from_SalesDashboardLeadOrNoteCard-css_VYm",
	"contact": "contact_from_SalesDashboardLeadOrNoteCard-css_sfH",
	"noteDate": "noteDate_from_SalesDashboardLeadOrNoteCard-css_3oK",
	"id": "id_from_SalesDashboardLeadOrNoteCard-css_y84",
	"lastActivity": "lastActivity_from_SalesDashboardLeadOrNoteCard-css_ZTb"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Activities/LeadActivities.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".leadActivities_from_LeadActivities-css_3xo {\r\n    position: relative;\r\n    background: #F7FDFF;\r\n    -webkit-box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.03);\r\n            box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.03);\r\n}\r\n\r\n.activitiesFilters_from_LeadActivities-css_2r5 {\r\n    position: absolute;\r\n    top: 32px;\r\n    right: 32px;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: end;\r\n        -ms-flex-pack: end;\r\n            justify-content: flex-end;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -ms-flex-wrap: nowrap;\r\n        flex-wrap: nowrap\r\n}\r\n\r\n.activitiesFilters_from_LeadActivities-css_2r5.paddingRight_from_LeadActivities-css_deM {\r\n    right: 180px;\r\n}\r\n\r\n.activitiesFilters_from_LeadActivities-css_2r5 > div {\r\n    margin-left: 24px;\r\n}\r\n\r\n.activitiesFilters_from_LeadActivities-css_2r5 > div:first-child {\r\n    margin-left: 0;\r\n}\r\n\r\n.activitiesFilters_from_LeadActivities-css_2r5 .comp-dropdown-label p {\r\n    font-size: 0.9em;\r\n}\r\n\r\n.activitiesFilters_from_LeadActivities-css_2r5 .comp-dropdown-label p span {\r\n    padding-right: 3px;\r\n}\r\n\r\n.activitiesHeadline_from_LeadActivities-css_3rZ,\r\n.noActivitiesHeadline_from_LeadActivities-css_2Nf {\r\n    border-bottom: 1px solid #F2F2F2;\r\n}\r\n\r\n.noActivitiesHeadline_from_LeadActivities-css_2Nf {\r\n    padding-bottom: 32px;\r\n}\r\n\r\n.leadDefineActivity_from_LeadActivities-css_152 {\r\n    width: 100%;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: stretch;\r\n        align-content: stretch;\r\n    -webkit-box-align: start;\r\n        -ms-flex-align: start;\r\n            align-items: flex-start;\r\n    border-bottom: 1px solid #F2F2F2\r\n}\r\n\r\n.leadDefineActivity_from_LeadActivities-css_152 .title_from_LeadActivities-css_2XZ {\r\n    -webkit-box-flex: 0;\r\n        -ms-flex: 0 1 30%;\r\n            flex: 0 1 30%;\r\n    position: relative;\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n    font-size: 1rem;\r\n    color: #6F7583;\r\n    height: 100%;\r\n    -webkit-box-align: start;\r\n        -ms-flex-align: start;\r\n            align-items: flex-start;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n}\r\n\r\n.leadDefineActivity_from_LeadActivities-css_152 .title_from_LeadActivities-css_2XZ h4 {\r\n    margin: 24px 32px;\r\n    font-size: 1em;\r\n    font-weight: 600;\r\n    color: #6F7583;\r\n}\r\n\r\n.leadDefineActivity_from_LeadActivities-css_152 .create_from_LeadActivities-css_2ii {\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1 0 70%;\r\n            flex: 1 0 70%;\r\n    border-left: 1px solid #F2F2F2;\r\n}\r\n\r\n.cancelOrAddButton_from_LeadActivities-css_3NX {\r\n    position: absolute;\r\n    bottom: 12px;\r\n    left: 16px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"leadActivities": "leadActivities_from_LeadActivities-css_3xo",
	"activitiesFilters": "activitiesFilters_from_LeadActivities-css_2r5",
	"paddingRight": "paddingRight_from_LeadActivities-css_deM",
	"activitiesHeadline": "activitiesHeadline_from_LeadActivities-css_3rZ",
	"noActivitiesHeadline": "noActivitiesHeadline_from_LeadActivities-css_2Nf",
	"leadDefineActivity": "leadDefineActivity_from_LeadActivities-css_152",
	"title": "title_from_LeadActivities-css_2XZ",
	"create": "create_from_LeadActivities-css_2ii",
	"cancelOrAddButton": "cancelOrAddButton_from_LeadActivities-css_3NX"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/BusinessGroup/BusinessGroupModal.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".state_from_BusinessGroupModal-css_1qk {\r\n\r\n}\r\n\r\n.statesSearchBar_from_BusinessGroupModal-css_1EJ {\r\n  width: 320px;\r\n}\r\n\r\n.backArrow_from_BusinessGroupModal-css_5hD .backArrowIcon_from_BusinessGroupModal-css_2rV > img {\r\n  width: 12px;\r\n  height: 9px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"state": "state_from_BusinessGroupModal-css_1qk",
	"statesSearchBar": "statesSearchBar_from_BusinessGroupModal-css_1EJ",
	"backArrow": "backArrow_from_BusinessGroupModal-css_5hD",
	"backArrowIcon": "backArrowIcon_from_BusinessGroupModal-css_2rV"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/BusinessGroup/GroupCreate.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".createGroup_from_GroupCreate-css_3WJ {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  padding: 20px\r\n}\n.createGroup_from_GroupCreate-css_3WJ > input {\r\n  margin-right: 10px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"createGroup": "createGroup_from_GroupCreate-css_3WJ"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/BusinessGroup/GroupItem.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".saving_from_GroupItem-css_qU0 {\r\n  padding: 32px;\r\n  margin: 0 auto;\r\n  text-align: center;\r\n  font-size: 0.975em;\r\n  font-weight: 600;\r\n  color: #6F7583;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"saving": "saving_from_GroupItem-css_qU0"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/BusinessGroup/GroupList.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".groupList_from_GroupList-css_YnB {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -ms-flex-line-pack: start;\r\n      align-content: flex-start;\r\n  -webkit-box-align: start;\r\n      -ms-flex-align: start;\r\n          align-items: flex-start;\r\n  padding: 32px 40px;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: row;\r\n          flex-direction: row;\r\n  -ms-flex-wrap: wrap;\r\n      flex-wrap: wrap;\r\n}\r\n\r\n.empty_from_GroupList-css_3iq {\r\n  padding: 32px 64px;\r\n  padding-bottom: 48px\r\n}\r\n\r\n.empty_from_GroupList-css_3iq p {\r\n  text-align: center;\r\n  font-size: 0.725em;\r\n  font-weight: 400;\r\n  color: #6F7583;\r\n}\r\n\r\n.groupListItem_from_GroupList-css_2f6 {\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 0 25%;\r\n          flex: 1 0 25%;\r\n  display: block;\r\n  padding: 12px;\r\n}\r\n\r\n.groupListButton_from_GroupList-css_2Xg {\r\n  width: 100%;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  position: relative;\r\n  -webkit-box-pack: justify;\r\n      -ms-flex-pack: justify;\r\n          justify-content: space-between;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  padding: 16px;\r\n  background: #FFFFFF;\r\n  border: 1px solid #FFFFFF;\r\n  border-radius: 3px;\r\n  -webkit-box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);\r\n          box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);\r\n  -webkit-transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.groupListButton_from_GroupList-css_2Xg .groupName_from_GroupList-css_dhs {\r\n  text-align: left;\r\n  padding-right: 16px;\r\n}\r\n\r\n.groupListButton_from_GroupList-css_2Xg strong {\r\n  display: block;\r\n  font-size: 1.0em;\r\n  font-weight: 600;\r\n  color: #496DF4;\r\n}\r\n\r\n.groupListButton_from_GroupList-css_2Xg p {\r\n  display: block;\r\n  font-size: 1.0em;\r\n  font-weight: 400;\r\n  color: #496DF4;\r\n}\r\n\r\n.groupListButton_from_GroupList-css_2Xg .icon_from_GroupList-css_1J5 {\r\n  width: 20px;\r\n  height: 10px;\r\n  -webkit-transform: translateX(0px);\r\n          transform: translateX(0px);\r\n  -webkit-transition: 300ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n  transition: 300ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n  transition: 300ms transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n  transition: 300ms transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000), 300ms -webkit-transform 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n}\r\n\r\n.groupListButton_from_GroupList-css_2Xg.groupListCreateButton_from_GroupList-css_3s2 .icon_from_GroupList-css_1J5 {\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n\r\n.groupListButton_from_GroupList-css_2Xg:hover {\r\n  border-color: #496DF4;\r\n}\r\n\r\n.groupListButton_from_GroupList-css_2Xg:hover .icon_from_GroupList-css_1J5 {\r\n  -webkit-transform: translateX(3px);\r\n          transform: translateX(3px);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"groupList": "groupList_from_GroupList-css_YnB",
	"empty": "empty_from_GroupList-css_3iq",
	"groupListItem": "groupListItem_from_GroupList-css_2f6",
	"groupListButton": "groupListButton_from_GroupList-css_2Xg",
	"groupName": "groupName_from_GroupList-css_dhs",
	"icon": "icon_from_GroupList-css_1J5",
	"groupListCreateButton": "groupListCreateButton_from_GroupList-css_3s2"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/BusinessPartner/BusinessPartner.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/BusinessPartner/Modal/BusinessPartnerContent.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".copyAddress_from_BusinessPartnerContent-css_3A3 {\r\n  padding: 32px;\r\n  padding-bottom: 24px;\r\n  position: relative;\r\n  height: 75px\r\n}\r\n\r\n.copyAddress_from_BusinessPartnerContent-css_3A3 .copyIcon_from_BusinessPartnerContent-css_1PS {\r\n  position: absolute;\r\n  top: 16px;\r\n  right: 16px;\r\n}\r\n\r\n.fields_from_BusinessPartnerContent-css_fBL > .group_from_BusinessPartnerContent-css_AQI {\r\n  margin: 0 32px;\r\n  margin-top: 0;\r\n}\r\n\r\n.fields_from_BusinessPartnerContent-css_fBL label {\r\n  display: block;\r\n  position: relative;\r\n  margin-top: 12px\r\n}\r\n\r\n.fields_from_BusinessPartnerContent-css_fBL label:first-child {\r\n  margin-top: 0;\r\n}\r\n\r\n.fields_from_BusinessPartnerContent-css_fBL label > p {\r\n  position: absolute;\r\n  z-index: 3;\r\n  top: -8px;\r\n  left: 12px;\r\n  font-size: 0.625em;\r\n  font-weight: 400;\r\n  color:#6F7583;\r\n  padding: 3px 6px;\r\n  background: none\r\n}\r\n\r\n.fields_from_BusinessPartnerContent-css_fBL label > p > span {\r\n  position: relative;\r\n  z-index: 3;\r\n  color: inherit;\r\n}\r\n\r\n.fields_from_BusinessPartnerContent-css_fBL label > p::after {\r\n  content: \"\";\r\n  display: block;\r\n  position: absolute;\r\n  z-index: 2;\r\n  top: 8px;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 1px;\r\n  background: #FFFFFF;\r\n}\r\n\r\n.fields_from_BusinessPartnerContent-css_fBL label input {\r\n  width: 100%;\r\n}\r\n\r\n.fields_from_BusinessPartnerContent-css_fBL .licenseExp_from_BusinessPartnerContent-css_1Qd {\r\n  margin-top: 12px\r\n}\r\n\r\n.fields_from_BusinessPartnerContent-css_fBL .licenseExp_from_BusinessPartnerContent-css_1Qd > .comp-dropdown-container {\r\n  width: 100%;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  padding: 9px 16px;\r\n  border: 1px solid #E9EBEB;\r\n  background: #FFFFFF;\r\n  font-size: 0.95em\r\n}\r\n\r\n.fields_from_BusinessPartnerContent-css_fBL .licenseExp_from_BusinessPartnerContent-css_1Qd > .comp-dropdown-container:hover {\r\n  background: #F5F7F7;\r\n  border-color: #DCDEDE;\r\n}\r\n\r\n.footer_from_BusinessPartnerContent-css__Pa {\r\n  padding: 24px 32px;\r\n  width: 100%;\r\n  display: block;\r\n  text-align: right\r\n}\r\n\r\n.footer_from_BusinessPartnerContent-css__Pa > button {\r\n  margin-right: 0;\r\n  margin-left: auto;\r\n  margin-top: 6px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"copyAddress": "copyAddress_from_BusinessPartnerContent-css_3A3",
	"copyIcon": "copyIcon_from_BusinessPartnerContent-css_1PS",
	"fields": "fields_from_BusinessPartnerContent-css_fBL",
	"group": "group_from_BusinessPartnerContent-css_AQI",
	"licenseExp": "licenseExp_from_BusinessPartnerContent-css_1Qd",
	"footer": "footer_from_BusinessPartnerContent-css__Pa"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/BusinessPartner/Modal/BusinessPartnerSlider.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".slider_from_BusinessPartnerSlider-css_hlA {\r\n  position: fixed;\r\n  top: 64px;\r\n  left: 384px;\r\n  width: 0px;\r\n  height: calc(100% - 64px);\r\n  z-index: 5;\r\n  overflow: visible;\r\n  -webkit-transition: 500ms width 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000);\r\n  transition: 500ms width 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000)\r\n}\r\n\r\n.slider_from_BusinessPartnerSlider-css_hlA.show_from_BusinessPartnerSlider-css_1ml {\r\n  width: calc(100% - 384px);\r\n}\r\n\r\n.slider_from_BusinessPartnerSlider-css_hlA .shade_from_BusinessPartnerSlider-css_1o7 {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  opacity: 1;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  background: rgba(255, 255, 255, 0.92)\r\n}\r\n\r\n.slider_from_BusinessPartnerSlider-css_hlA .shade_from_BusinessPartnerSlider-css_1o7 .pane_from_BusinessPartnerSlider-css_1Hk {\r\n  position: absolute;\r\n  overflow: auto;\r\n  top: 0;\r\n  left: 0;\r\n  width: 384px;\r\n  height: 100%;\r\n  background: #F7FDFF;\r\n  border-left: 1px solid #E9EBEB;\r\n  border-right: 1px solid #DCDEDE;\r\n  -webkit-box-shadow: 64px 0px 128px rgba(0, 0, 0, 0.06);\r\n          box-shadow: 64px 0px 128px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.slider_from_BusinessPartnerSlider-css_hlA .shade_from_BusinessPartnerSlider-css_1o7.slide-enter,\r\n    .slider_from_BusinessPartnerSlider-css_hlA .shade_from_BusinessPartnerSlider-css_1o7.slide-enter-active,\r\n    .slider_from_BusinessPartnerSlider-css_hlA .shade_from_BusinessPartnerSlider-css_1o7.slide-appear,\r\n    .slider_from_BusinessPartnerSlider-css_hlA .shade_from_BusinessPartnerSlider-css_1o7.slide-appear-active {\r\n  width: 0%;\r\n  opacity: 0;\r\n  -webkit-transition: 500ms width 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000),\r\n                  500ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 500ms width 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000),\r\n                  500ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.slider_from_BusinessPartnerSlider-css_hlA .shade_from_BusinessPartnerSlider-css_1o7.slide-enter-active,\r\n    .slider_from_BusinessPartnerSlider-css_hlA .shade_from_BusinessPartnerSlider-css_1o7.slide-appear-active {\r\n  opacity: 1;\r\n  width: 100%;\r\n}\r\n\r\n.slider_from_BusinessPartnerSlider-css_hlA .shade_from_BusinessPartnerSlider-css_1o7.slide-leave,\r\n    .slider_from_BusinessPartnerSlider-css_hlA .shade_from_BusinessPartnerSlider-css_1o7.slide-leave-active {\r\n  opacity: 1;\r\n  width: 100%;\r\n  -webkit-transition: 500ms width 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000),\r\n      500ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 500ms width 0ms cubic-bezier(0.860, 0.000, 0.070, 1.000),\r\n      500ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.slider_from_BusinessPartnerSlider-css_hlA .shade_from_BusinessPartnerSlider-css_1o7.slide-leave-active {\r\n  opacity: 0;\r\n  width: 0%;\r\n}\r\n\r\n.close_from_BusinessPartnerSlider-css_37H {\r\n  position: absolute;\r\n  top: 16px;\r\n  right: 16px;\r\n  z-index: 2;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"slider": "slider_from_BusinessPartnerSlider-css_hlA",
	"show": "show_from_BusinessPartnerSlider-css_1ml",
	"shade": "shade_from_BusinessPartnerSlider-css_1o7",
	"pane": "pane_from_BusinessPartnerSlider-css_1Hk",
	"close": "close_from_BusinessPartnerSlider-css_37H"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Contacts/LeadContacts.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".list_from_LeadContacts-css_3qH .results_from_LeadContacts-css_Pni {}\r\n\r\n.list_from_LeadContacts-css_3qH .none_from_LeadContacts-css_2cN p {\r\n  font-size: 0.725em;\r\n  font-weight: 400;\r\n  color: #6F7583;\r\n  padding: 0 32px;\r\n}\r\n\r\n.contact_from_LeadContacts-css_f3B {\r\n  position: relative;\r\n  margin-top: 24px\r\n}\r\n\r\n.contact_from_LeadContacts-css_f3B:first-child {\r\n  margin-top: 0;\r\n}\r\n\r\n.contact_from_LeadContacts-css_f3B .icon_from_LeadContacts-css_1MR {\r\n  position: absolute;\r\n  left: 32px;\r\n  top: 0;\r\n}\r\n\r\n.contact_from_LeadContacts-css_f3B .name_from_LeadContacts-css_3Zh {\r\n  margin: 0 32px;\r\n  padding-left: 24px;\r\n  line-height: 1.3;\r\n}\r\n\r\n.contact_from_LeadContacts-css_f3B .name_from_LeadContacts-css_3Zh h1 {\r\n  font-size: 0.925em;\r\n  font-weight: 700;\r\n  color: #2E3D73;\r\n}\r\n\r\n.contact_from_LeadContacts-css_f3B .title_from_LeadContacts-css_dGt {\r\n  margin: 0 32px;\r\n  padding-left: 24px;\r\n}\r\n\r\n.contact_from_LeadContacts-css_f3B .title_from_LeadContacts-css_dGt h2 {\r\n  font-size: 0.775em;\r\n  font-weight: 400;\r\n  text-transform: uppercase;\r\n  color: #2E3D73;\r\n}\r\n\r\n.contact_from_LeadContacts-css_f3B .means_from_LeadContacts-css_18P {\r\n  padding: 0 32px;\r\n}\r\n\r\n.contact_from_LeadContacts-css_f3B .means_from_LeadContacts-css_18P > li {\r\n  padding-top: 6px;\r\n  padding-left: 24px;\r\n  color: #2E3D73;\r\n  font-size: 0.825em;\r\n  font-weight: 400;\r\n}\r\n\r\n.contact_from_LeadContacts-css_f3B .means_from_LeadContacts-css_18P > li:first-child {\r\n  padding-top: 12px;\r\n}\r\n\r\n.contact_from_LeadContacts-css_f3B .means_from_LeadContacts-css_18P > li .contactEmailAddress_from_LeadContacts-css_lvu {\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  padding-bottom: 1px;\r\n}\r\n\r\n.contact_from_LeadContacts-css_f3B .means_from_LeadContacts-css_18P > li a {\r\n  color: inherit;\r\n  text-decoration: none;\r\n  border-bottom: 1px solid transparent;\r\n  -webkit-transition: 250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.contact_from_LeadContacts-css_f3B .means_from_LeadContacts-css_18P > li a:hover,\r\n        .contact_from_LeadContacts-css_f3B .means_from_LeadContacts-css_18P > li a:active,\r\n        .contact_from_LeadContacts-css_f3B .means_from_LeadContacts-css_18P > li a:focus {\r\n  border-bottom: 1px solid #496DF4;\r\n}\r\n\r\n.contactBeingEdited_from_LeadContacts-css_3MH {\r\n  margin-left: 32px;\r\n  margin-right: 32px\r\n}\r\n\r\n.contactBeingEdited_from_LeadContacts-css_3MH h5 {\r\n  font-size: 0.825em;\r\n  font-weight: 600;\r\n  color: #444956;\r\n  display: block;\r\n  border-bottom: 1px solid #E9EBEB;\r\n}\r\n\r\n.contactBeingEdited_from_LeadContacts-css_3MH > label {\r\n  display: block;\r\n  position: relative;\r\n  margin-top: 12px;\r\n}\r\n\r\n.contactBeingEdited_from_LeadContacts-css_3MH > label p {\r\n  position: absolute;\r\n  z-index: 3;\r\n  top: -8px;\r\n  left: 12px;\r\n  font-size: 0.625em;\r\n  font-weight: 400;\r\n  color: #6F7583;\r\n  padding: 3px 6px;\r\n  background: none;\r\n}\r\n\r\n.contactBeingEdited_from_LeadContacts-css_3MH > label p span {\r\n  position: relative;\r\n  z-index: 3;\r\n  color: inherit;\r\n}\r\n\r\n.contactBeingEdited_from_LeadContacts-css_3MH > label p::after {\r\n  content: \"\";\r\n  display: block;\r\n  position: absolute;\r\n  z-index: 2;\r\n  top: 8px;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 1px;\r\n  background: #FFFFFF;\r\n}\r\n\r\n.contactBeingEdited_from_LeadContacts-css_3MH > label input {\r\n  position: relative;\r\n  z-index: 1;\r\n  width: 100%;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n}\r\n\r\n.contactBeingEdited_from_LeadContacts-css_3MH .primary_from_LeadContacts-css_1Re {\r\n  margin-top: 6px;\r\n}\r\n\r\n.createContact_from_LeadContacts-css_1DD {\r\n  margin-top: 6px;\r\n  margin-right: auto;\r\n  margin-bottom: 0;\r\n  margin-left: 12px\r\n}\r\n\r\n.createContact_from_LeadContacts-css_1DD .createContactLabel_from_LeadContacts-css_1eZ {\r\n  left: 38px;\r\n}\r\n\r\n.details_from_LeadContacts-css_1kV {\r\n  text-align: right;\r\n  margin: 0 32px;\r\n  margin-top: 6px;\r\n  padding-bottom: 12px;\r\n  border-bottom: 1px solid #E9EBEB\r\n}\r\n\r\n.details_from_LeadContacts-css_1kV > div {\r\n  padding-top: 6px;\r\n}\r\n\r\n.details_from_LeadContacts-css_1kV button {\r\n  margin-left: auto;\r\n  margin-right: 0;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"list": "list_from_LeadContacts-css_3qH",
	"results": "results_from_LeadContacts-css_Pni",
	"none": "none_from_LeadContacts-css_2cN",
	"contact": "contact_from_LeadContacts-css_f3B",
	"icon": "icon_from_LeadContacts-css_1MR",
	"name": "name_from_LeadContacts-css_3Zh",
	"title": "title_from_LeadContacts-css_dGt",
	"means": "means_from_LeadContacts-css_18P",
	"contactEmailAddress": "contactEmailAddress_from_LeadContacts-css_lvu",
	"contactBeingEdited": "contactBeingEdited_from_LeadContacts-css_3MH",
	"primary": "primary_from_LeadContacts-css_1Re",
	"createContact": "createContact_from_LeadContacts-css_1DD",
	"createContactLabel": "createContactLabel_from_LeadContacts-css_1eZ",
	"details": "details_from_LeadContacts-css_1kV"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Details/LeadDetailsMaster.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".editing_from_LeadDetailsMaster-css_24m .group_from_LeadDetailsMaster-css_3ks {\r\n    padding-left: 0;\r\n    margin-top: 6px;\r\n}\r\n\r\n.editing_from_LeadDetailsMaster-css_24m .group_from_LeadDetailsMaster-css_3ks:first-child {\r\n    margin-top: 0;\r\n}\r\n\r\n.editing_from_LeadDetailsMaster-css_24m .group_from_LeadDetailsMaster-css_3ks:first-child h5 {\r\n    padding-top: 0;\r\n}\r\n\r\n.editing_from_LeadDetailsMaster-css_24m .group_from_LeadDetailsMaster-css_3ks h5 {\r\n    font-size: 0.825em;\r\n    font-weight: 600;\r\n    color: #444956;\r\n    display: block;\r\n    padding-top: 6px;\r\n    border-bottom: 1px solid #E9EBEB;\r\n}\r\n\r\n.editing_from_LeadDetailsMaster-css_24m .group_from_LeadDetailsMaster-css_3ks .icon_from_LeadDetailsMaster-css_3SU {\r\n    display: none;\r\n}\r\n\r\n.editing_from_LeadDetailsMaster-css_24m .group_from_LeadDetailsMaster-css_3ks > div {}\r\n\r\n.editSection_from_LeadDetailsMaster-css_3Bd {\r\n    display: block;\r\n    position: relative;\r\n    margin-top: 12px\r\n}\r\n\r\n.editSection_from_LeadDetailsMaster-css_3Bd input {\r\n    width: 100%;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    margin-top: 6px;\r\n}\r\n\r\n.editSection_from_LeadDetailsMaster-css_3Bd > p {\r\n    position: absolute;\r\n    z-index: 3;\r\n    top: -3px;\r\n    left: 12px;\r\n    font-size: 0.625em;\r\n    font-weight: 400;\r\n    color: #6F7583;\r\n    padding: 3px 6px;\r\n    background: none;\r\n}\r\n\r\n.editSection_from_LeadDetailsMaster-css_3Bd > p > span {\r\n    position: relative;\r\n    z-index: 3;\r\n    color: inherit;\r\n}\r\n\r\n.editSection_from_LeadDetailsMaster-css_3Bd > p::after {\r\n    content: '';\r\n    display: block;\r\n    position: absolute;\r\n    z-index: 2;\r\n    top: 9px;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 1px;\r\n    background: #FFFFFF;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks {\r\n    position: relative;\r\n    padding-left: 24px;\r\n    margin: 0 32px;\r\n    margin-top: 24px;\r\n    line-height: 1.5;\r\n    color: #2E3D73\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks:first-child {\r\n    margin-top: 0;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks:first-child .icon_from_LeadDetailsMaster-css_3SU {\r\n    top: 0;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks:last-child {\r\n    padding-bottom: 24px;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks.npiNumber_from_LeadDetailsMaster-css_1QS .icon_from_LeadDetailsMaster-css_3SU {\r\n    top: 3px !important;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks.npiNumber_from_LeadDetailsMaster-css_1QS .icon_from_LeadDetailsMaster-css_3SU, .group_from_LeadDetailsMaster-css_3ks.salesReps_from_LeadDetailsMaster-css_3VY .icon_from_LeadDetailsMaster-css_3SU, .group_from_LeadDetailsMaster-css_3ks.relationTypeGroup_from_LeadDetailsMaster-css_T4e .icon_from_LeadDetailsMaster-css_3SU, .group_from_LeadDetailsMaster-css_3ks.leadGroup_from_LeadDetailsMaster-css_37D .icon_from_LeadDetailsMaster-css_3SU, .group_from_LeadDetailsMaster-css_3ks.drugLicenseTypeGroup_from_LeadDetailsMaster-css_2hu .icon_from_LeadDetailsMaster-css_3SU {\r\n    top: -2px;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks.npiNumber_from_LeadDetailsMaster-css_1QS .comp-dropdown-container, .group_from_LeadDetailsMaster-css_3ks.salesReps_from_LeadDetailsMaster-css_3VY .comp-dropdown-container, .group_from_LeadDetailsMaster-css_3ks.relationTypeGroup_from_LeadDetailsMaster-css_T4e .comp-dropdown-container, .group_from_LeadDetailsMaster-css_3ks.leadGroup_from_LeadDetailsMaster-css_37D .comp-dropdown-container, .group_from_LeadDetailsMaster-css_3ks.drugLicenseTypeGroup_from_LeadDetailsMaster-css_2hu .comp-dropdown-container {\r\n    margin-top: 12px;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks.npiNumber_from_LeadDetailsMaster-css_1QS .comp-dropdown-label, .group_from_LeadDetailsMaster-css_3ks.salesReps_from_LeadDetailsMaster-css_3VY .comp-dropdown-label, .group_from_LeadDetailsMaster-css_3ks.relationTypeGroup_from_LeadDetailsMaster-css_T4e .comp-dropdown-label, .group_from_LeadDetailsMaster-css_3ks.leadGroup_from_LeadDetailsMaster-css_37D .comp-dropdown-label, .group_from_LeadDetailsMaster-css_3ks.drugLicenseTypeGroup_from_LeadDetailsMaster-css_2hu .comp-dropdown-label {\r\n    width: 100%;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    padding: 9px 16px;\r\n    border: 1px solid #E9EBEB;\r\n    background: #FFFFFF;\r\n    font-size: 0.95em;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks.npiNumber_from_LeadDetailsMaster-css_1QS .comp-dropdown-label:hover, .group_from_LeadDetailsMaster-css_3ks.salesReps_from_LeadDetailsMaster-css_3VY .comp-dropdown-label:hover, .group_from_LeadDetailsMaster-css_3ks.relationTypeGroup_from_LeadDetailsMaster-css_T4e .comp-dropdown-label:hover, .group_from_LeadDetailsMaster-css_3ks.leadGroup_from_LeadDetailsMaster-css_37D .comp-dropdown-label:hover, .group_from_LeadDetailsMaster-css_3ks.drugLicenseTypeGroup_from_LeadDetailsMaster-css_2hu .comp-dropdown-label:hover {\r\n    background: #F5F7F7;\r\n    border-color: #DCDEDE;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks .icon_from_LeadDetailsMaster-css_3SU {\r\n    position: absolute;\r\n    top: 1px;\r\n    left: 0;\r\n    width: 16px;\r\n    height: auto;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks h1 {\r\n    font-size: 1.175em;\r\n    font-weight: 700;\r\n    line-height: 1.2;\r\n    position: relative;\r\n    top: -3px;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks h3 {\r\n    font-size: 0.875em;\r\n    font-weight: 400;\r\n    line-height: 1.1;\r\n    position: relative;\r\n    margin-top: -4px;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks h4 {\r\n    font-size: 0.825em;\r\n    font-weight: 400;\r\n    line-height: 1.1;\r\n    position: relative;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks h4 strong {\r\n    margin-left: 3px;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks h4 strong:first-child {\r\n    margin-left: 0;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks .cardcode_from_LeadDetailsMaster-css_2WH {\r\n    margin-top: 6px;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks p {\r\n    font-size: 0.825em;\r\n    font-weight: 400;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks p.email_from_LeadDetailsMaster-css_326 {\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks a {\r\n    display: block;\r\n    position: relative;\r\n    color: inherit;\r\n    text-decoration: none;\r\n    border-bottom: 1px solid transparent;\r\n    -webkit-transition: 250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks a img {\r\n    position: absolute;\r\n    top: 50%;\r\n    height: 10px;\r\n    margin-top: -5px;\r\n    width: auto;\r\n    right: 0;\r\n}\r\n\r\n.group_from_LeadDetailsMaster-css_3ks a:hover,\r\n        .group_from_LeadDetailsMaster-css_3ks a:active,\r\n        .group_from_LeadDetailsMaster-css_3ks a:focus {\r\n    border-bottom: 1px solid #496DF4;\r\n}\r\n\r\n.details_from_LeadDetailsMaster-css_2LX {\r\n    text-align: right;\r\n    margin: 0 32px;\r\n    margin-top: 6px;\r\n    padding-bottom: 12px;\r\n    border-bottom: 1px solid #E9EBEB\r\n}\r\n\r\n.details_from_LeadDetailsMaster-css_2LX > div {\r\n    padding-top: 6px;\r\n}\r\n\r\n.details_from_LeadDetailsMaster-css_2LX button {\r\n    margin-left: auto;\r\n    margin-right: 0;\r\n}\r\n\r\n.arrow_from_LeadDetailsMaster-css_s0x img {\r\n    width: 13px !important;\r\n    height: 9px !important;\r\n    -webkit-transform: rotate(90deg);\r\n            transform: rotate(90deg);\r\n    -webkit-transition: 0.5s all cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 0.5s all cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.arrow_from_LeadDetailsMaster-css_s0x.show_from_LeadDetailsMaster-css_1bJ img {\r\n    -webkit-transform: rotate(-90deg);\r\n            transform: rotate(-90deg);\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D {\r\n    margin: 0;\r\n    padding: 24px 32px;\r\n    padding-bottom: 0;\r\n    -webkit-transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D.show_from_LeadDetailsMaster-css_1bJ {\r\n    background: #F5F7F7;\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D.edit_from_LeadDetailsMaster-css_1uI {\r\n    padding: 0;\r\n    margin: 0 32px;\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D.edit_from_LeadDetailsMaster-css_1uI > div {\r\n    padding: 0;\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D > div {\r\n    position: relative;\r\n    padding: 0 24px;\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D > div > button {\r\n    padding: 0;\r\n    position: absolute;\r\n    right: 0;\r\n    top: -5px;\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D .leadGroupList_from_LeadDetailsMaster-css_H1j {\r\n    display: none;\r\n    -webkit-box-align: start;\r\n        -ms-flex-align: start;\r\n            align-items: flex-start;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    -ms-flex-wrap: wrap;\r\n        flex-wrap: wrap;\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D .leadGroupList_from_LeadDetailsMaster-css_H1j.show_from_LeadDetailsMaster-css_1bJ {\r\n    display: block;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D .leadGroupList_from_LeadDetailsMaster-css_H1j li {\r\n    padding: 6px 0px;\r\n    margin: 0px;\r\n    position: relative;\r\n    display: block;\r\n    text-align: left;\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D .leadGroupList_from_LeadDetailsMaster-css_H1j li:first-child {\r\n    margin-top: 12px;\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D .leadGroupList_from_LeadDetailsMaster-css_H1j li:last-child {\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D .leadGroupList_from_LeadDetailsMaster-css_H1j li .providerInGroup_from_LeadDetailsMaster-css_1YZ {\r\n    width: 100%;\r\n    display: block;\r\n    text-align: left;\r\n    line-height: 1;\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D .leadGroupList_from_LeadDetailsMaster-css_H1j li .providerInGroup_from_LeadDetailsMaster-css_1YZ strong {\r\n    display: block;\r\n    font-size: 14px;\r\n    font-size: 0.875rem;\r\n    font-weight: 700;\r\n    color: #2B2C2F;\r\n    -webkit-transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D .leadGroupList_from_LeadDetailsMaster-css_H1j li .providerInGroup_from_LeadDetailsMaster-css_1YZ b {\r\n    display: block;\r\n    font-size: 0.675em;\r\n    font-weight: 600;\r\n    color: #2E3D73;\r\n    margin-top: 3px;\r\n    -webkit-transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D .leadGroupList_from_LeadDetailsMaster-css_H1j li .providerInGroup_from_LeadDetailsMaster-css_1YZ span {\r\n    display: block;\r\n    font-size: 11.6px;\r\n    font-size: 0.725rem;\r\n    font-weight: 400;\r\n    color: #2B2C2F;\r\n    margin-top: 3px;\r\n    -webkit-transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D .leadGroupList_from_LeadDetailsMaster-css_H1j li .providerInGroup_from_LeadDetailsMaster-css_1YZ em {\r\n    display: block;\r\n    font-size: 10.8px;\r\n    font-size: 0.675rem;\r\n    font-weight: 400;\r\n    color: #444956;\r\n    margin-top: 3px;\r\n    -webkit-transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D .leadGroupList_from_LeadDetailsMaster-css_H1j li .providerInGroup_from_LeadDetailsMaster-css_1YZ.providerInGroupButton_from_LeadDetailsMaster-css_3Fd {\r\n    cursor: pointer;\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D .leadGroupList_from_LeadDetailsMaster-css_H1j li .providerInGroup_from_LeadDetailsMaster-css_1YZ.providerInGroupButton_from_LeadDetailsMaster-css_3Fd strong {\r\n    color: #496DF4;\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D .leadGroupList_from_LeadDetailsMaster-css_H1j li .providerInGroup_from_LeadDetailsMaster-css_1YZ.providerInGroupButton_from_LeadDetailsMaster-css_3Fd:hover strong {\r\n    color: #496DF4;\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D .leadGroupList_from_LeadDetailsMaster-css_H1j li .providerInGroup_from_LeadDetailsMaster-css_1YZ.providerInGroupButton_from_LeadDetailsMaster-css_3Fd:hover span {\r\n    color: #496DF4;\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D .leadGroupList_from_LeadDetailsMaster-css_H1j li .providerInGroup_from_LeadDetailsMaster-css_1YZ.providerInGroupButton_from_LeadDetailsMaster-css_3Fd:hover em {\r\n    color: #496DF4;\r\n}\r\n\r\n.leadGroup_from_LeadDetailsMaster-css_37D .leadGroupList_from_LeadDetailsMaster-css_H1j li .providerInGroupCounter_from_LeadDetailsMaster-css_qXO {\r\n    position: absolute;\r\n    top: 6px;\r\n    left: -24px;\r\n    font-size: 0.775em;\r\n    font-weight: 600;\r\n    color: #A0A3A3;\r\n}\r\n\r\n.editRepGroup_from_LeadDetailsMaster-css_2Ua {\r\n    padding-top: 12px\r\n}\r\n\r\n.editRepGroup_from_LeadDetailsMaster-css_2Ua > div {\r\n    padding-left: 12px;\r\n}\r\n\r\n.editRepGroup_from_LeadDetailsMaster-css_2Ua .editRepGroupContact_from_LeadDetailsMaster-css_2tP {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: reverse;\r\n        -ms-flex-direction: row-reverse;\r\n            flex-direction: row-reverse;\r\n    -webkit-box-pack: end;\r\n        -ms-flex-pack: end;\r\n            justify-content: flex-end;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n}\r\n\r\n.editRepGroup_from_LeadDetailsMaster-css_2Ua .editRepGroupContact_from_LeadDetailsMaster-css_2tP img {\r\n    margin-right: 6px;\r\n}\r\n\r\n.editRepGroup_from_LeadDetailsMaster-css_2Ua .editRepGroupActions_from_LeadDetailsMaster-css_3F5 {\r\n    margin-top: 6px;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n            justify-content: space-between;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"editing": "editing_from_LeadDetailsMaster-css_24m",
	"group": "group_from_LeadDetailsMaster-css_3ks",
	"icon": "icon_from_LeadDetailsMaster-css_3SU",
	"editSection": "editSection_from_LeadDetailsMaster-css_3Bd",
	"npiNumber": "npiNumber_from_LeadDetailsMaster-css_1QS",
	"salesReps": "salesReps_from_LeadDetailsMaster-css_3VY",
	"relationTypeGroup": "relationTypeGroup_from_LeadDetailsMaster-css_T4e",
	"leadGroup": "leadGroup_from_LeadDetailsMaster-css_37D",
	"drugLicenseTypeGroup": "drugLicenseTypeGroup_from_LeadDetailsMaster-css_2hu",
	"cardcode": "cardcode_from_LeadDetailsMaster-css_2WH",
	"email": "email_from_LeadDetailsMaster-css_326",
	"details": "details_from_LeadDetailsMaster-css_2LX",
	"arrow": "arrow_from_LeadDetailsMaster-css_s0x",
	"show": "show_from_LeadDetailsMaster-css_1bJ",
	"edit": "edit_from_LeadDetailsMaster-css_1uI",
	"leadGroupList": "leadGroupList_from_LeadDetailsMaster-css_H1j",
	"providerInGroup": "providerInGroup_from_LeadDetailsMaster-css_1YZ",
	"providerInGroupButton": "providerInGroupButton_from_LeadDetailsMaster-css_3Fd",
	"providerInGroupCounter": "providerInGroupCounter_from_LeadDetailsMaster-css_qXO",
	"editRepGroup": "editRepGroup_from_LeadDetailsMaster-css_2Ua",
	"editRepGroupContact": "editRepGroupContact_from_LeadDetailsMaster-css_2tP",
	"editRepGroupActions": "editRepGroupActions_from_LeadDetailsMaster-css_3F5"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Disable/LeadDisable.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".container_from_LeadDisable-css_2dX {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    text-align: center;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    -ms-flex-wrap: nowrap;\r\n        flex-wrap: nowrap;\r\n    padding: 64px 32px;\r\n}\r\n\r\n.message_from_LeadDisable-css_Afi {\r\n    font-size: 1.275em;\r\n    font-weight: 600;\r\n    color: #EC7B65;\r\n}\r\n\r\n.buttonWrapper_from_LeadDisable-css_U05 {\r\n    margin-top: 24px;\r\n    .button_from_LeadDisable-css_3SS {\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n.saving_from_LeadDisable-css_25O {\r\n    margin: 0 auto;\r\n    margin-top: 6px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "container_from_LeadDisable-css_2dX",
	"message": "message_from_LeadDisable-css_Afi",
	"buttonWrapper": "buttonWrapper_from_LeadDisable-css_U05",
	"button": "button_from_LeadDisable-css_3SS",
	"saving": "saving_from_LeadDisable-css_25O"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Notes/LeadNotes.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".container_from_LeadNotes-css_3Hy {\r\n    background: #F8FCFD;\r\n}\r\n\r\n.searchIcon_from_LeadNotes-css_3Oj img {\r\n    width: 12px;\r\n    height: 12px;\r\n}\r\n\r\n.notesSearchContainer_from_LeadNotes-css_1SI {\r\n    width: 100%;\r\n    padding-bottom: 50px;\r\n}\r\n\r\n.notesSearchField_from_LeadNotes-css_3G2 {\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1 0;\r\n            flex: 1 0;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB {\r\n    position: relative;\r\n    margin: 0 32px;\r\n    line-height: 1.5;\r\n    color: #2E3D73\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .icon_from_LeadNotes-css_1w7 {\r\n    position: absolute;\r\n    top: 1px;\r\n    left: 0;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .noNotes_from_LeadNotes-css_wR5 {\r\n    padding-bottom: 32px;\r\n    font-size: 0.7em;\r\n    font-weight: 400;\r\n    color: #6F7583;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX {\r\n    display: grid;\r\n    grid-template: auto auto / -webkit-max-content 1fr;\r\n    grid-template: auto auto / max-content 1fr;\r\n    -webkit-column-gap: 32px;\r\n       -moz-column-gap: 32px;\r\n            column-gap: 32px;\r\n    row-gap: 6px;\r\n    -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n            justify-content: space-between;\r\n    margin-top: 12px;\r\n    overflow: visible;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX.new_from_LeadNotes-css_1aP {\r\n    grid-template: auto auto / 100% !important;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX.new_from_LeadNotes-css_1aP .noteContent_from_LeadNotes-css_OVY {\r\n    grid-column: 1;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX.new_from_LeadNotes-css_1aP .noteDetails_from_LeadNotes-css_27q {\r\n    grid-column: 1;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX.hidden_from_LeadNotes-css_291 {\r\n    opacity: 0.5;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX:first-child {\r\n    margin-top: 0;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX.odd_from_LeadNotes-css_2SX .content_from_LeadNotes-css_32w::after {\r\n    left: -12px;\r\n    right: auto;\r\n    border-left: 6px solid transparent;\r\n    border-right: 6px solid #E9EBEB;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX.odd_from_LeadNotes-css_2SX .content_from_LeadNotes-css_32w.contentEditable_from_LeadNotes-css_2AL:hover::after, .group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX.odd_from_LeadNotes-css_2SX .content_from_LeadNotes-css_32w.contentEditable_from_LeadNotes-css_2AL:focus::after, .group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX.odd_from_LeadNotes-css_2SX .content_from_LeadNotes-css_32w.contentEditable_from_LeadNotes-css_2AL:active::after {\r\n    border-left: 6px solid transparent;\r\n    border-right: 6px solid #A0A3A3;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX.even_from_LeadNotes-css_1-F {\r\n    grid-template: auto auto / 1fr -webkit-max-content;\r\n    grid-template: auto auto / 1fr max-content;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX.even_from_LeadNotes-css_1-F .content_from_LeadNotes-css_32w::after {\r\n    left: auto;\r\n    right: -12px;\r\n    border-left: 6px solid #E9EBEB;\r\n    border-right: 6px solid transparent;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX.even_from_LeadNotes-css_1-F .content_from_LeadNotes-css_32w.contentEditable_from_LeadNotes-css_2AL:hover::after, .group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX.even_from_LeadNotes-css_1-F .content_from_LeadNotes-css_32w.contentEditable_from_LeadNotes-css_2AL:focus::after, .group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX.even_from_LeadNotes-css_1-F .content_from_LeadNotes-css_32w.contentEditable_from_LeadNotes-css_2AL:active::after {\r\n    border-left: 6px solid #A0A3A3;\r\n    border-right: 6px solid transparent;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX.even_from_LeadNotes-css_1-F .noteSummary_from_LeadNotes-css_2O1 {\r\n    grid-column: 2;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX.even_from_LeadNotes-css_1-F .noteContent_from_LeadNotes-css_OVY {\r\n    grid-column: 1;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX.even_from_LeadNotes-css_1-F .noteDetails_from_LeadNotes-css_27q {\r\n    grid-column: 1;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .content_from_LeadNotes-css_32w {\r\n    position: relative;\r\n    z-index: 3;\r\n    font-size: 0.825em;\r\n    font-weight: 400;\r\n    line-height: 1.3;\r\n    padding: 16px 24px;\r\n    border: 1px solid #E9EBEB;\r\n    background: #E9EBEB;\r\n    color: #2B2C2F;\r\n    outline: none;\r\n    word-break: break-all;\r\n    -webkit-transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .content_from_LeadNotes-css_32w::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: -1px;\r\n    right: 0;\r\n    width: 0;\r\n    height: 0;\r\n    border-top: 6px solid #E9EBEB;\r\n    border-right: 6px solid transparent;\r\n    border-bottom: 6px solid transparent;\r\n    -webkit-transition: 250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .content_from_LeadNotes-css_32w.contentEditable_from_LeadNotes-css_2AL:hover,\r\n                .group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .content_from_LeadNotes-css_32w.contentEditable_from_LeadNotes-css_2AL:focus,\r\n                .group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .content_from_LeadNotes-css_32w.contentEditable_from_LeadNotes-css_2AL:active {\r\n    border-color: #A0A3A3;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .content_from_LeadNotes-css_32w.contentEditable_from_LeadNotes-css_2AL:focus,\r\n                .group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .content_from_LeadNotes-css_32w.contentEditable_from_LeadNotes-css_2AL:active {\r\n    background: #FFFFFF;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .detail_from_LeadNotes-css_2r2 {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n            justify-content: space-between;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    position: relative;\r\n    color: #6F7583;\r\n    font-size: 0.825em;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .detail_from_LeadNotes-css_2r2 .right_from_LeadNotes-css_3z6 {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: end;\r\n        -ms-flex-pack: end;\r\n            justify-content: flex-end;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    text-align: right;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .detail_from_LeadNotes-css_2r2 .right_from_LeadNotes-css_3z6 .boxButton {\r\n    margin-left: 6px;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .detail_from_LeadNotes-css_2r2 .right_from_LeadNotes-css_3z6 .iconButton_from_LeadNotes-css_1fI {\r\n    margin-left: 16px;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .detail_from_LeadNotes-css_2r2 .saveButtons_from_LeadNotes-css_5Q5 {\r\n    opacity: 1;\r\n    -webkit-transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .detail_from_LeadNotes-css_2r2 .saveButtons_from_LeadNotes-css_5Q5.saving_from_LeadNotes-css_2XC {\r\n    opacity: 0.2;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .detail_from_LeadNotes-css_2r2 .edit_from_LeadNotes-css_3Gk {\r\n    z-index: 2;\r\n    position: relative;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .detail_from_LeadNotes-css_2r2 .hide_from_LeadNotes-css_2lF {\r\n    z-index: 1;\r\n    position: relative;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .detail_from_LeadNotes-css_2r2 .hide_from_LeadNotes-css_2lF.hidden_from_LeadNotes-css_291 {}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .detail_from_LeadNotes-css_2r2 > .button_from_LeadNotes-css_387 {\r\n    outline: none;\r\n    z-index: 2;\r\n    top: 3px;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .detail_from_LeadNotes-css_2r2 > .button_from_LeadNotes-css_387 .icon_from_LeadNotes-css_1w7 {\r\n    position: relative;\r\n    z-index: 2;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    width: 24px;\r\n    height: 24px;\r\n    border: 1px solid #E9EBEB;\r\n    border-radius: 1px;\r\n    -webkit-transition: 250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .detail_from_LeadNotes-css_2r2 > .button_from_LeadNotes-css_387 .icon_from_LeadNotes-css_1w7 img {\r\n    width: 18px;\r\n    height: 18px;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .detail_from_LeadNotes-css_2r2 > .button_from_LeadNotes-css_387:active .icon_from_LeadNotes-css_1w7, .group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .detail_from_LeadNotes-css_2r2 > .button_from_LeadNotes-css_387:focus .icon_from_LeadNotes-css_1w7, .group_from_LeadNotes-css_1QB .note_from_LeadNotes-css_1tX .detail_from_LeadNotes-css_2r2 > .button_from_LeadNotes-css_387:hover .icon_from_LeadNotes-css_1w7 {\r\n    border-color: #496DF4;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .noteSummary_from_LeadNotes-css_2O1 {\r\n    grid-row: 1;\r\n    grid-column: 1;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    text-align: left;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .noteSummary_from_LeadNotes-css_2O1 p {\r\n    display: block;\r\n    font-size: 0.85em;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .noteSummary_from_LeadNotes-css_2O1 .name_from_LeadNotes-css_273 {\r\n    font-weight: 600;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .noteSummary_from_LeadNotes-css_2O1 .time_from_LeadNotes-css_1jL {\r\n    font-weight: 400;\r\n    color: #6F7583;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .noteContent_from_LeadNotes-css_OVY {\r\n    grid-row: 1;\r\n    grid-column: 2;\r\n    min-width: 320px;\r\n}\r\n\r\n.group_from_LeadNotes-css_1QB .noteDetails_from_LeadNotes-css_27q {\r\n    grid-row: 2;\r\n    grid-column: 2;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "container_from_LeadNotes-css_3Hy",
	"searchIcon": "searchIcon_from_LeadNotes-css_3Oj",
	"notesSearchContainer": "notesSearchContainer_from_LeadNotes-css_1SI",
	"notesSearchField": "notesSearchField_from_LeadNotes-css_3G2",
	"group": "group_from_LeadNotes-css_1QB",
	"icon": "icon_from_LeadNotes-css_1w7",
	"noNotes": "noNotes_from_LeadNotes-css_wR5",
	"note": "note_from_LeadNotes-css_1tX",
	"new": "new_from_LeadNotes-css_1aP",
	"noteContent": "noteContent_from_LeadNotes-css_OVY",
	"noteDetails": "noteDetails_from_LeadNotes-css_27q",
	"hidden": "hidden_from_LeadNotes-css_291",
	"odd": "odd_from_LeadNotes-css_2SX",
	"content": "content_from_LeadNotes-css_32w",
	"contentEditable": "contentEditable_from_LeadNotes-css_2AL",
	"even": "even_from_LeadNotes-css_1-F",
	"noteSummary": "noteSummary_from_LeadNotes-css_2O1",
	"detail": "detail_from_LeadNotes-css_2r2",
	"right": "right_from_LeadNotes-css_3z6",
	"iconButton": "iconButton_from_LeadNotes-css_1fI",
	"saveButtons": "saveButtons_from_LeadNotes-css_5Q5",
	"saving": "saving_from_LeadNotes-css_2XC",
	"edit": "edit_from_LeadNotes-css_3Gk",
	"hide": "hide_from_LeadNotes-css_2lF",
	"button": "button_from_LeadNotes-css_387",
	"name": "name_from_LeadNotes-css_273",
	"time": "time_from_LeadNotes-css_1jL"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Notes/LeadNotesGroup.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".notesGroup_from_LeadNotesGroup-css_ATZ:first-child .notesGroupDate_from_LeadNotesGroup-css_1gm {\r\n    margin-top: 0;\r\n}\r\n\r\n.notesGroupDate_from_LeadNotesGroup-css_1gm {\r\n    display: block;\r\n    position: relative;\r\n    text-align: center;\r\n    margin: 16px -32px;\r\n    margin-top: 32px\r\n}\r\n\r\n.notesGroupDate_from_LeadNotesGroup-css_1gm p {\r\n    display: inline-block;\r\n    position: relative;\r\n    z-index: 2;\r\n    font-size: 0.85em;\r\n    font-weight: 600;\r\n    color: #2A5798;\r\n    padding: 0 12px;\r\n    background: #F8FCFD;\r\n}\r\n\r\n.notesGroupDate_from_LeadNotesGroup-css_1gm hr {\r\n    position: absolute;\r\n    margin: 0;\r\n    top: 50%;\r\n    left: 0;\r\n    display: block;\r\n    width: 100%;\r\n    height: 1px;\r\n    border: none;\r\n    background: #E9EBEB;\r\n}\r\n\r\n.notesGroupDate_from_LeadNotesGroup-css_1gm::after {\r\n    content: '';\r\n    display: block;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 0;\r\n    width: 0;\r\n    height: 0;\r\n    border: none;\r\n    margin-top: -6px;\r\n    border-top: 6px solid transparent;\r\n    border-bottom: 6px solid transparent;\r\n    border-left: 9px solid #C2CFFF;\r\n}\r\n\r\n.notesGroupList_from_LeadNotesGroup-css_20o {\r\n    margin: 0 auto;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"notesGroup": "notesGroup_from_LeadNotesGroup-css_ATZ",
	"notesGroupDate": "notesGroupDate_from_LeadNotesGroup-css_1gm",
	"notesGroupList": "notesGroupList_from_LeadNotesGroup-css_20o"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/OtherActivities/OtherActivities.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".empty_from_OtherActivities-css_19J {\r\n  font-weight: 400;\r\n  font-size: 0.775em;\r\n  color: #A0A3A3;\r\n  padding: 24px 32px;\r\n  padding-top: 0;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"empty": "empty_from_OtherActivities-css_19J"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/PricingRequest/Modal/PricingRequestContent.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".row_from_PricingRequestContent-css_zyp {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -ms-flex-wrap: nowrap;\r\n        flex-wrap: nowrap;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center\r\n}\r\n\r\n.row_from_PricingRequestContent-css_zyp > div {\r\n    -webkit-box-flex: 0;\r\n        -ms-flex: 0 1 auto;\r\n            flex: 0 1 auto;\r\n    width: 128px;\r\n    text-align: right;\r\n    padding: 12px 6px\r\n}\r\n\r\n.row_from_PricingRequestContent-css_zyp > div:first-child {\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1;\r\n            flex: 1;\r\n    width: auto;\r\n    text-align: left;\r\n}\r\n\r\n.details_from_PricingRequestContent-css_1p6 {\r\n    padding: 0 64px;\r\n    padding-top: 24px;\r\n    background: #F5F9FA\r\n}\r\n\r\n.details_from_PricingRequestContent-css_1p6 > .row_from_PricingRequestContent-css_zyp {\r\n    -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n            justify-content: space-between;\r\n    -ms-flex-line-pack: start;\r\n        align-content: flex-start;\r\n    -webkit-box-align: start;\r\n        -ms-flex-align: start;\r\n            align-items: flex-start;\r\n}\r\n\r\n.details_from_PricingRequestContent-css_1p6 .lead_from_PricingRequestContent-css_RmD {\r\n    padding-left: 6px\r\n}\r\n\r\n.details_from_PricingRequestContent-css_1p6 .lead_from_PricingRequestContent-css_RmD > strong {\r\n    font-size: 0.975em;\r\n    font-weight: 700;\r\n    color: #2E3D73;\r\n    -webkit-transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.details_from_PricingRequestContent-css_1p6 .lead_from_PricingRequestContent-css_RmD > em {\r\n    display: block;\r\n    margin-top: 1px;\r\n    font-size: 0.825em;\r\n    font-weight: 600;\r\n    font-style: normal;\r\n    color: #2E3D73;\r\n}\r\n\r\n.details_from_PricingRequestContent-css_1p6 .author_from_PricingRequestContent-css_3UK {\r\n    padding-right: 6px\r\n}\r\n\r\n.details_from_PricingRequestContent-css_1p6 .author_from_PricingRequestContent-css_3UK span {\r\n    display: block;\r\n    text-align: right;\r\n    font-size: 0.775em;\r\n    font-weight: 600;\r\n    color: #6F7583;\r\n}\r\n\r\n.header_from_PricingRequestContent-css_5r_ {\r\n    padding: 24px 64px;\r\n    padding-top: 0;\r\n    padding-bottom: 12px;\r\n    background: #F5F9FA\r\n}\r\n\r\n.header_from_PricingRequestContent-css_5r_:first-child {\r\n    padding-top: 24px;\r\n}\r\n\r\n.header_from_PricingRequestContent-css_5r_ > .row_from_PricingRequestContent-css_zyp {\r\n    padding-top: 0;\r\n    padding-bottom: 0\r\n}\r\n\r\n.header_from_PricingRequestContent-css_5r_ > .row_from_PricingRequestContent-css_zyp > div {\r\n    font-size: 0.725em;\r\n    font-weight: 600;\r\n    color: #6F7583;\r\n}\r\n\r\n.items_from_PricingRequestContent-css_3GP {\r\n    padding: 12px 64px\r\n}\r\n\r\n.items_from_PricingRequestContent-css_3GP .row_from_PricingRequestContent-css_zyp > div {\r\n    position: relative\r\n}\r\n\r\n.items_from_PricingRequestContent-css_3GP .row_from_PricingRequestContent-css_zyp > div p {\r\n    color: #2E3D73;\r\n    font-size: 0.875em\r\n}\r\n\r\n.items_from_PricingRequestContent-css_3GP .row_from_PricingRequestContent-css_zyp > div p span {\r\n    font-weight: 400;\r\n}\r\n\r\n.items_from_PricingRequestContent-css_3GP .row_from_PricingRequestContent-css_zyp > div p strong {\r\n    font-weight: 600;\r\n}\r\n\r\n.items_from_PricingRequestContent-css_3GP .row_from_PricingRequestContent-css_zyp > div:first-child .removeButton_from_PricingRequestContent-css_1ey {\r\n    position: absolute;\r\n    top: 11px;\r\n    left: -12px;\r\n}\r\n\r\n.items_from_PricingRequestContent-css_3GP .row_from_PricingRequestContent-css_zyp > div:first-child p {\r\n    color: #2E3D73\r\n}\r\n\r\n.items_from_PricingRequestContent-css_3GP .row_from_PricingRequestContent-css_zyp > div:first-child p:first-child strong {\r\n    margin-left: 0;\r\n}\r\n\r\n.items_from_PricingRequestContent-css_3GP .row_from_PricingRequestContent-css_zyp > div:first-child p strong {\r\n    display: inline-block;\r\n    color: inherit;\r\n    font-size: 1em;\r\n    font-weight: 700;\r\n    margin-top: 4px;\r\n    margin-left: 32px;\r\n}\r\n\r\n.items_from_PricingRequestContent-css_3GP .row_from_PricingRequestContent-css_zyp > div:first-child p span {\r\n    display: block;\r\n    margin-top: 6px;\r\n    color: inherit;\r\n    font-size: 0.775em;\r\n    font-weight: 400;\r\n}\r\n\r\n.items_from_PricingRequestContent-css_3GP .row_from_PricingRequestContent-css_zyp input {\r\n    width: 92px;\r\n    text-align: right;\r\n}\r\n\r\n.empty_from_PricingRequestContent-css_2B0 {\r\n    padding: 32px 64px;\r\n    padding-bottom: 48px\r\n}\r\n\r\n.empty_from_PricingRequestContent-css_2B0 p {\r\n    text-align: center;\r\n    font-size: 0.725em;\r\n    font-weight: 400;\r\n    color: #6F7583;\r\n}\r\n\r\n.footer_from_PricingRequestContent-css_3f7 {\r\n    padding: 12px 64px;\r\n    padding-bottom: 32px\r\n}\r\n\r\n.footer_from_PricingRequestContent-css_3f7 > .row_from_PricingRequestContent-css_zyp {\r\n    -ms-flex-line-pack: start;\r\n        align-content: flex-start;\r\n    -webkit-box-align: start;\r\n        -ms-flex-align: start;\r\n            align-items: flex-start\r\n}\r\n\r\n.footer_from_PricingRequestContent-css_3f7 > .row_from_PricingRequestContent-css_zyp > div.note_from_PricingRequestContent-css_2kv {\r\n    -webkit-box-flex: 2;\r\n        -ms-flex: 2;\r\n            flex: 2;\r\n    min-width: 256px;\r\n    background: #FFFFFF;\r\n    border: 1px solid #E9EBEB;\r\n    border-radius: 1px;\r\n    outline: none;\r\n    padding: 12px 16px;\r\n    font-size: 0.825em;\r\n    color: #2B2C2F;\r\n    -webkit-transition: 250ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                    250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 250ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                    250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.footer_from_PricingRequestContent-css_3f7 > .row_from_PricingRequestContent-css_zyp > div.note_from_PricingRequestContent-css_2kv:hover,\r\n                .footer_from_PricingRequestContent-css_3f7 > .row_from_PricingRequestContent-css_zyp > div.note_from_PricingRequestContent-css_2kv:focus,\r\n                .footer_from_PricingRequestContent-css_3f7 > .row_from_PricingRequestContent-css_zyp > div.note_from_PricingRequestContent-css_2kv:active {\r\n    background: #E9EBEB;\r\n}\r\n\r\n.footer_from_PricingRequestContent-css_3f7 > .row_from_PricingRequestContent-css_zyp > div.note_from_PricingRequestContent-css_2kv:focus,\r\n                .footer_from_PricingRequestContent-css_3f7 > .row_from_PricingRequestContent-css_zyp > div.note_from_PricingRequestContent-css_2kv:active {\r\n    background: #FFFFFF;\r\n    border-color: #DCDEDE;\r\n}\r\n\r\n.footer_from_PricingRequestContent-css_3f7 > .row_from_PricingRequestContent-css_zyp > div.note_from_PricingRequestContent-css_2kv.nonEditable_from_PricingRequestContent-css_x6y {\r\n    padding: 6px 0;\r\n    line-height: 1.3;\r\n    background: none;\r\n    border: none;\r\n}\r\n\r\n.footer_from_PricingRequestContent-css_3f7 > .row_from_PricingRequestContent-css_zyp > div.note_from_PricingRequestContent-css_2kv.noteUnavailable_from_PricingRequestContent-css_2E3 {\r\n    background: none;\r\n    border: none;\r\n    padding: 0;\r\n    min-height: 32px;\r\n}\r\n\r\n.footer_from_PricingRequestContent-css_3f7 > .row_from_PricingRequestContent-css_zyp > div.submit_from_PricingRequestContent-css_1xE {\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1;\r\n            flex: 1;\r\n    padding-left: 16px;\r\n    padding-top: 0;\r\n    padding-bottom: 0\r\n}\r\n\r\n.footer_from_PricingRequestContent-css_3f7 > .row_from_PricingRequestContent-css_zyp > div.submit_from_PricingRequestContent-css_1xE > .statusMessage_from_PricingRequestContent-css_2jX {\r\n    font-size: 0.875em;\r\n    font-weight: 600;\r\n    color: #2E3D73;\r\n}\r\n\r\n.footer_from_PricingRequestContent-css_3f7 > .row_from_PricingRequestContent-css_zyp > div.submit_from_PricingRequestContent-css_1xE > button {\r\n    margin-bottom: 6px;\r\n}\r\n\r\n.footer_from_PricingRequestContent-css_3f7 > .row_from_PricingRequestContent-css_zyp > div.submit_from_PricingRequestContent-css_1xE > div {\r\n    display: block;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"row": "row_from_PricingRequestContent-css_zyp",
	"details": "details_from_PricingRequestContent-css_1p6",
	"lead": "lead_from_PricingRequestContent-css_RmD",
	"author": "author_from_PricingRequestContent-css_3UK",
	"header": "header_from_PricingRequestContent-css_5r_",
	"items": "items_from_PricingRequestContent-css_3GP",
	"removeButton": "removeButton_from_PricingRequestContent-css_1ey",
	"empty": "empty_from_PricingRequestContent-css_2B0",
	"footer": "footer_from_PricingRequestContent-css_3f7",
	"note": "note_from_PricingRequestContent-css_2kv",
	"nonEditable": "nonEditable_from_PricingRequestContent-css_x6y",
	"noteUnavailable": "noteUnavailable_from_PricingRequestContent-css_2E3",
	"submit": "submit_from_PricingRequestContent-css_1xE",
	"statusMessage": "statusMessage_from_PricingRequestContent-css_2jX"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/PricingRequest/Modal/PricingRequestModal.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".content_from_PricingRequestModal-css_HTK {\r\n  position: relative;\r\n  min-height: 128px;\r\n}\r\n\r\n.autocomplete_from_PricingRequestModal-css_1Bx {\r\n  position: relative;\r\n  width: 256px;\r\n  height: 38px;\r\n}\r\n\r\n.field_from_PricingRequestModal-css_2GY {\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.resultsContainer_from_PricingRequestModal-css_1eJ {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 38px;\r\n  width: 100%;\r\n  z-index: 2;\r\n  background: none;\r\n}\r\n\r\n.results_from_PricingRequestModal-css_25N {\r\n  position: relative;\r\n  width: 100%;\r\n  height: auto;\r\n  overflow: auto;\r\n  max-height: 320px;\r\n  -webkit-box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04);\r\n          box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04);\r\n  -webkit-transform: translateY(0px) scaleY(1) scaleX(1);\r\n          transform: translateY(0px) scaleY(1) scaleX(1);\r\n  -webkit-transform-origin: top;\r\n          transform-origin: top\r\n}\r\n\r\n.results_from_PricingRequestModal-css_25N.fade-appear,\r\n  .results_from_PricingRequestModal-css_25N.fade-enter {\r\n  -webkit-transform: translateY(6px) scaleY(0) scaleX(0.9);\r\n          transform: translateY(6px) scaleY(0) scaleX(0.9);\r\n  -webkit-transition: 300ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n  transition: 300ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n  transition: 300ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n  transition: 300ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000), 300ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n}\r\n\r\n.results_from_PricingRequestModal-css_25N.fade-appear-active,\r\n  .results_from_PricingRequestModal-css_25N.fade-enter-active {\r\n  -webkit-transform: translateY(0px) scaleY(1) scaleX(1);\r\n          transform: translateY(0px) scaleY(1) scaleX(1);\r\n}\r\n\r\n.results_from_PricingRequestModal-css_25N.fade-leave {\r\n  -webkit-transform: translateY(6px) scaleY(0) scaleX(0.9);\r\n          transform: translateY(6px) scaleY(0) scaleX(0.9);\r\n  opacity: 1;\r\n  -webkit-transition: 400ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                300ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n  transition: 400ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                300ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n  transition: 300ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000),\r\n                400ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 300ms transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000),\r\n                400ms opacity 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                300ms -webkit-transform 0ms cubic-bezier(1.000, 0.000, 0.000, 1.000);\r\n}\r\n\r\n.results_from_PricingRequestModal-css_25N.fade-leave-active {\r\n  -webkit-transform: translateY(0px) scaleY(0) scaleX(1);\r\n          transform: translateY(0px) scaleY(0) scaleX(1);\r\n  opacity: 0;\r\n}\r\n\r\n.results_from_PricingRequestModal-css_25N .label_from_PricingRequestModal-css_2Ui {\r\n  text-align: center;\r\n}\r\n\r\n.results_from_PricingRequestModal-css_25N .label_from_PricingRequestModal-css_2Ui,\r\n  .results_from_PricingRequestModal-css_25N .result_from_PricingRequestModal-css_2wF {\r\n  width: 100%;\r\n  display: block;\r\n  background: #FFFFFF;\r\n  padding: 12px 16px;\r\n  text-align: left;\r\n}\r\n\r\n.results_from_PricingRequestModal-css_25N .label_from_PricingRequestModal-css_2Ui strong, .results_from_PricingRequestModal-css_25N .result_from_PricingRequestModal-css_2wF strong {\r\n  display: block;\r\n  font-size: 0.9em;\r\n  font-weight: 600;\r\n  color: #2E3D73;\r\n}\r\n\r\n.results_from_PricingRequestModal-css_25N .label_from_PricingRequestModal-css_2Ui span, .results_from_PricingRequestModal-css_25N .result_from_PricingRequestModal-css_2wF span {\r\n  display: block;\r\n  font-size: 0.725em;\r\n  font-weight: 400;\r\n  color: #2B2C2F;\r\n}\r\n\r\n.results_from_PricingRequestModal-css_25N .result_from_PricingRequestModal-css_2wF {\r\n  -webkit-transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.results_from_PricingRequestModal-css_25N .result_from_PricingRequestModal-css_2wF:hover,\r\n    .results_from_PricingRequestModal-css_25N .result_from_PricingRequestModal-css_2wF:focus,\r\n    .results_from_PricingRequestModal-css_25N .result_from_PricingRequestModal-css_2wF:active {\r\n  background: #E9EBEB;\r\n}\r\n\r\n.results_from_PricingRequestModal-css_25N .label_from_PricingRequestModal-css_2Ui {\r\n  font-size: 0.775em;\r\n  font-weight: 400;\r\n  color: #6F7583;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"content": "content_from_PricingRequestModal-css_HTK",
	"autocomplete": "autocomplete_from_PricingRequestModal-css_1Bx",
	"field": "field_from_PricingRequestModal-css_2GY",
	"resultsContainer": "resultsContainer_from_PricingRequestModal-css_1eJ",
	"results": "results_from_PricingRequestModal-css_25N",
	"label": "label_from_PricingRequestModal-css_2Ui",
	"result": "result_from_PricingRequestModal-css_2wF"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/PricingRequest/Sidebar/PricingRequestSidebar.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".itemsPricingButton_from_PricingRequestSidebar-css_zvK {\r\n  position: relative;\r\n  display: block;\r\n  width: 100%;\r\n  outline: none;\r\n  text-align: left;\r\n  font-size: 0.825em;\r\n  font-weight: 600;\r\n  color: #2E3D73;\r\n  padding: 0 32px;\r\n  padding-bottom: 24px;\r\n  -webkit-transition: 300ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 300ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.itemsPricingButton_from_PricingRequestSidebar-css_zvK strong {\r\n  font-weight: inherit;\r\n  color: inherit;\r\n  border-bottom: 1px solid transparent;\r\n  -webkit-transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.itemsPricingButton_from_PricingRequestSidebar-css_zvK img {\r\n  position: absolute;\r\n  width: 11px;\r\n  height: 7px;\r\n  top: 5px;\r\n  right: 38px;\r\n  -webkit-transform: translateX(0px);\r\n          transform: translateX(0px);\r\n  -webkit-transition: 200ms -webkit-transform 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 200ms -webkit-transform 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 200ms transform 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 200ms transform 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000), 200ms -webkit-transform 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.itemsPricingButton_from_PricingRequestSidebar-css_zvK:hover,\r\n  .itemsPricingButton_from_PricingRequestSidebar-css_zvK:active,\r\n  .itemsPricingButton_from_PricingRequestSidebar-css_zvK:focus {\r\n  color: #496DF4\r\n}\r\n\r\n.itemsPricingButton_from_PricingRequestSidebar-css_zvK:hover img, .itemsPricingButton_from_PricingRequestSidebar-css_zvK:active img, .itemsPricingButton_from_PricingRequestSidebar-css_zvK:focus img {\r\n  -webkit-transform: translateX(3px);\r\n          transform: translateX(3px);\r\n}\r\n\r\n.itemsPricingButton_from_PricingRequestSidebar-css_zvK:focus strong {\r\n  border-bottom: 1px solid #496DF4;\r\n}\r\n\r\n.pending_from_PricingRequestSidebar-css_2gD > p {\r\n  font-size: 0.725em;\r\n  font-weight: 400;\r\n  color: #A0A3A3;\r\n  margin: 0 32px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.pendingRequest_from_PricingRequestSidebar-css_oRN {\r\n  background: #F8FCFD !important\r\n}\r\n\r\n.pendingRequest_from_PricingRequestSidebar-css_oRN::after {\r\n  width: 128px;\r\n}\r\n\r\n.pendingRequest_from_PricingRequestSidebar-css_oRN:first-child {\r\n  padding-top: 0;\r\n}\r\n\r\n.pendingRequest_from_PricingRequestSidebar-css_oRN:last-child {\r\n  padding-bottom: 0;\r\n}\r\n\r\n.loadingContainer_from_PricingRequestSidebar-css_3jQ {\r\n  margin: 12px 32px;\r\n  margin-top: 0;\r\n}\r\n\r\n.empty_from_PricingRequestSidebar-css_23l {\r\n  font-size: 0.725em;\r\n  font-weight: 400;\r\n  color: #A0A3A3;\r\n  margin: 0 32px;\r\n  margin-bottom: 24px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"itemsPricingButton": "itemsPricingButton_from_PricingRequestSidebar-css_zvK",
	"pending": "pending_from_PricingRequestSidebar-css_2gD",
	"pendingRequest": "pendingRequest_from_PricingRequestSidebar-css_oRN",
	"loadingContainer": "loadingContainer_from_PricingRequestSidebar-css_3jQ",
	"empty": "empty_from_PricingRequestSidebar-css_23l"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Questions/LeadQuestions.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".questions_from_LeadQuestions-css_3zC {\r\n}\r\n\r\n.questionGroup_from_LeadQuestions-css_3Oc {\r\n    position: relative;\r\n}\r\n\r\n.question_from_LeadQuestions-css_Hmn {\r\n    position: relative;\r\n    padding: 24px 32px;\r\n    width: 100%;\r\n    margin: 0\r\n}\r\n\r\n.question_from_LeadQuestions-css_Hmn::after {\r\n    content: '';\r\n    position: absolute;\r\n    display: block;\r\n    left: 42px;\r\n    top: 0;\r\n    width: 1px;\r\n    height: 100%;\r\n    background: #DCDEDE;\r\n}\r\n\r\n.question_from_LeadQuestions-css_Hmn > .label_from_LeadQuestions-css_2AA {\r\n    font-size: 0.875em;\r\n    font-weight: 600;\r\n    color: #2E3D73;\r\n    padding-left: 32px;\r\n}\r\n\r\n.question_from_LeadQuestions-css_Hmn > .index_from_LeadQuestions-css_3Fq {\r\n    position: absolute;\r\n    right: 32px;\r\n    top: 24px;\r\n    color: #A0A3A3;\r\n    font-weight: 700;\r\n    font-size: 0.725em;\r\n}\r\n\r\n.question_from_LeadQuestions-css_Hmn > .index_from_LeadQuestions-css_3Fq::before {\r\n    content: '#';\r\n}\r\n\r\n.question_from_LeadQuestions-css_Hmn > .status_from_LeadQuestions-css_wLd {\r\n    z-index: 2;\r\n    position: absolute;\r\n    left: 28px;\r\n    top: 17px;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-sizing: content-box;\r\n            box-sizing: content-box;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    width: 21px;\r\n    height: 21px;\r\n    padding: 0;\r\n    margin: 0;\r\n    background: #18A073;\r\n    border-radius: 1px;\r\n    border: 4px solid #F8FCFD;\r\n}\r\n\r\n.question_from_LeadQuestions-css_Hmn > .status_from_LeadQuestions-css_wLd::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 21px;\r\n    height: 21px;\r\n    border-radius: 1px;\r\n    border: 1px solid #25AC7F;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n}\r\n\r\n.question_from_LeadQuestions-css_Hmn > .status_from_LeadQuestions-css_wLd.unanswered_from_LeadQuestions-css_qrA {\r\n    background: #FFFFFF;\r\n}\r\n\r\n.question_from_LeadQuestions-css_Hmn > .status_from_LeadQuestions-css_wLd.unanswered_from_LeadQuestions-css_qrA::after {\r\n    border: 1px solid #DCDEDE;\r\n}\r\n\r\n.question_from_LeadQuestions-css_Hmn > .status_from_LeadQuestions-css_wLd img {\r\n    position: relative;\r\n    width: 27px;\r\n    height: 27px;\r\n    top: 2px;\r\n    left: 2px;\r\n    -webkit-transform: scale(1.25);\r\n            transform: scale(1.25);\r\n}\r\n\r\n.question_from_LeadQuestions-css_Hmn > div {\r\n    margin-top: 16px;\r\n    padding-left: 32px;\r\n}\r\n\r\n.question_from_LeadQuestions-css_Hmn .questionSavingIndicator_from_LeadQuestions-css_2dm {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 32px;\r\n}\r\n\r\n.optionText_from_LeadQuestions-css_1cB {\r\n    display: block;\r\n    background: #FFFFFF;\r\n    border: 1px solid #E9EBEB;\r\n    border-radius: 1px;\r\n    padding: 12px 16px;\r\n    outline: none;\r\n    line-height: 1.2;\r\n    font-size: 0.825em;\r\n    color: #2B2C2F;\r\n    -webkit-transition: 250ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 250ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.optionText_from_LeadQuestions-css_1cB:hover,\r\n    .optionText_from_LeadQuestions-css_1cB:focus,\r\n    .optionText_from_LeadQuestions-css_1cB:active {\r\n    background: #E9EBEB;\r\n}\r\n\r\n.optionText_from_LeadQuestions-css_1cB:focus,\r\n    .optionText_from_LeadQuestions-css_1cB:active {\r\n    background: #FFFFFF;\r\n    border-color: #DCDEDE;\r\n}\r\n\r\n.checkboxesList_from_LeadQuestions-css_3Cr {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    position: relative;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: start;\r\n        align-content: flex-start;\r\n    align-content: flex-start;\r\n    max-width: 768px;\r\n    margin-top: -6px;\r\n    margin-left: -12px;\r\n    margin-bottom: -6px\r\n}\r\n\r\n.checkboxesList_from_LeadQuestions-css_3Cr.options_from_item,\r\n    .checkboxesList_from_LeadQuestions-css_3Cr.options_from_redi_item {\r\n    max-width: none;\r\n}\r\n\r\n.checkboxesList_from_LeadQuestions-css_3Cr.options_from_item > label, .checkboxesList_from_LeadQuestions-css_3Cr.options_from_redi_item > label {\r\n    width: 100%;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n}\r\n\r\n.checkboxesList_from_LeadQuestions-css_3Cr > label {\r\n    margin: 6px 12px;\r\n}\r\n\r\n.checkboxesOtherTextField_from_LeadQuestions-css_doU {\r\n    margin-top: 12px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"questions": "questions_from_LeadQuestions-css_3zC",
	"questionGroup": "questionGroup_from_LeadQuestions-css_3Oc",
	"question": "question_from_LeadQuestions-css_Hmn",
	"label": "label_from_LeadQuestions-css_2AA",
	"index": "index_from_LeadQuestions-css_3Fq",
	"status": "status_from_LeadQuestions-css_wLd",
	"unanswered": "unanswered_from_LeadQuestions-css_qrA",
	"questionSavingIndicator": "questionSavingIndicator_from_LeadQuestions-css_2dm",
	"optionText": "optionText_from_LeadQuestions-css_1cB",
	"checkboxesList": "checkboxesList_from_LeadQuestions-css_3Cr",
	"checkboxesOtherTextField": "checkboxesOtherTextField_from_LeadQuestions-css_doU"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Relations/LeadRelations.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".list_from_LeadRelations-css_3xs {\r\n    position: relative;\r\n    margin: 0 32px;\r\n    padding-bottom: 24px;\r\n    color: #2E3D73;\r\n    list-style: none\r\n}\n.list_from_LeadRelations-css_3xs li {\r\n    margin-top: 6px;\r\n}\n.list_from_LeadRelations-css_3xs h4 {\r\n    font-size: 0.825em;\r\n    font-weight: 400;\r\n    line-height: 1.2;\r\n    position: relative\r\n}\n.list_from_LeadRelations-css_3xs h4 span {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n}\n.list_from_LeadRelations-css_3xs h4 strong {\r\n    font-weight: 700;\r\n    margin-left: 24px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"list": "list_from_LeadRelations-css_3xs"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Relations/LeadRelationsModal.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".row_from_LeadRelationsModal-css_2BP {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -ms-flex-wrap: nowrap;\r\n        flex-wrap: nowrap;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center\r\n}\r\n\r\n.row_from_LeadRelationsModal-css_2BP > div {\r\n    -webkit-box-flex: 0;\r\n        -ms-flex: 0 1 auto;\r\n            flex: 0 1 auto;\r\n    text-align: left;\r\n    padding: 12px 6px\r\n}\r\n\r\n.row_from_LeadRelationsModal-css_2BP > div:first-child {\r\n    padding-left: 0;\r\n}\r\n\r\n.row_from_LeadRelationsModal-css_2BP > div:last-child {\r\n    padding-right: 0;\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1;\r\n            flex: 1;\r\n    width: auto;\r\n    text-align: right;\r\n}\r\n\r\n.header_from_LeadRelationsModal-css_1jV {\r\n    padding: 12px 64px;\r\n    background: #F5F9FA\r\n}\r\n\r\n.header_from_LeadRelationsModal-css_1jV > .summary_from_LeadRelationsModal-css_2Ki {\r\n    text-align: left;\r\n    line-height: 1.5\r\n}\r\n\r\n.header_from_LeadRelationsModal-css_1jV > .summary_from_LeadRelationsModal-css_2Ki h2 {\r\n    font-size: 1.025em;\r\n    font-weight: 600;\r\n    color: #2E3D73;\r\n}\r\n\r\n.header_from_LeadRelationsModal-css_1jV > .summary_from_LeadRelationsModal-css_2Ki h3 {\r\n    font-size: 0.9em;\r\n    font-weight: 400;\r\n    color: #2E3D73;\r\n}\r\n\r\n.header_from_LeadRelationsModal-css_1jV > .row_from_LeadRelationsModal-css_2BP {\r\n    padding-top: 0;\r\n    padding-bottom: 0\r\n}\r\n\r\n.header_from_LeadRelationsModal-css_1jV > .row_from_LeadRelationsModal-css_2BP > div {\r\n    font-size: 0.725em;\r\n    font-weight: 600;\r\n    color: #6F7583;\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU {\r\n    padding: 12px 64px;\r\n    padding-bottom: 32px\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU > div:not(:first-child) > .stateRow_from_LeadRelationsModal-css_3JW {\r\n    border-top: 1px solid #6F7583;\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU > div:first-child > .stateRow_from_LeadRelationsModal-css_3JW {\r\n    margin-top: 0;\r\n    padding-top: 0;\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU .row_from_LeadRelationsModal-css_2BP {\r\n    margin-top: 12px;\r\n    padding-top: 12px\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU .row_from_LeadRelationsModal-css_2BP > div {\r\n    position: relative;\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU .row_from_LeadRelationsModal-css_2BP.stateRow_from_LeadRelationsModal-css_3JW {}\r\n\r\n.items_from_LeadRelationsModal-css_3uU .row_from_LeadRelationsModal-css_2BP.subRow_from_LeadRelationsModal-css_1Jq {\r\n    margin-top: 0;\r\n    padding-top: 0;\r\n    border-top: 1px dashed #E9EBEB;\r\n    background: #F8FCFD;\r\n    -webkit-transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU .row_from_LeadRelationsModal-css_2BP.subRow_from_LeadRelationsModal-css_1Jq:hover {\r\n    background: #FFFFFF;\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU .row_from_LeadRelationsModal-css_2BP.subRow_from_LeadRelationsModal-css_1Jq > div {\r\n    padding-top: 6px;\r\n    padding-bottom: 6px\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU .row_from_LeadRelationsModal-css_2BP.subRow_from_LeadRelationsModal-css_1Jq > div:first-child {\r\n    padding-left: 32px\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU .row_from_LeadRelationsModal-css_2BP.subRow_from_LeadRelationsModal-css_1Jq > div:first-child p {\r\n    position: relative\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU .row_from_LeadRelationsModal-css_2BP.subRow_from_LeadRelationsModal-css_1Jq > div:first-child p::after {\r\n    content: '';\r\n    display: block;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: -24px;\r\n    width: 16px;\r\n    height: 1px;\r\n    margin-top: -1px;\r\n    background: rgba(160, 163, 163, 0.3);\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU .row_from_LeadRelationsModal-css_2BP.subRow_from_LeadRelationsModal-css_1Jq > div p {\r\n    font-size: 0.85em;\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU .row_from_LeadRelationsModal-css_2BP.relationRow_from_LeadRelationsModal-css_304 {\r\n    padding-top: 16px;\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU .row_from_LeadRelationsModal-css_2BP.detailsRow_from_LeadRelationsModal-css_2Dl {\r\n    padding-top: 0;\r\n    margin-top: 0\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU .row_from_LeadRelationsModal-css_2BP.detailsRow_from_LeadRelationsModal-css_2Dl > div {\r\n    padding-top: 0;\r\n    padding-left: 32px;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    text-align: left\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU .row_from_LeadRelationsModal-css_2BP.detailsRow_from_LeadRelationsModal-css_2Dl > div p {\r\n    font-size: 0.75em;\r\n    margin-top: 3px\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU .row_from_LeadRelationsModal-css_2BP.detailsRow_from_LeadRelationsModal-css_2Dl > div p:first-child {\r\n    margin-top: 0;\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU .row_from_LeadRelationsModal-css_2BP.detailsRow_from_LeadRelationsModal-css_2Dl > div p span {\r\n    margin-left: 6px\r\n}\r\n\r\n.items_from_LeadRelationsModal-css_3uU .row_from_LeadRelationsModal-css_2BP.detailsRow_from_LeadRelationsModal-css_2Dl > div p span:first-child {\r\n    margin-left: 0;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"row": "row_from_LeadRelationsModal-css_2BP",
	"header": "header_from_LeadRelationsModal-css_1jV",
	"summary": "summary_from_LeadRelationsModal-css_2Ki",
	"items": "items_from_LeadRelationsModal-css_3uU",
	"stateRow": "stateRow_from_LeadRelationsModal-css_3JW",
	"subRow": "subRow_from_LeadRelationsModal-css_1Jq",
	"relationRow": "relationRow_from_LeadRelationsModal-css_304",
	"detailsRow": "detailsRow_from_LeadRelationsModal-css_2Dl"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Resources/LeadResources.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".resources_from_LeadResources-css_Gyu {\r\n  position: relative;\r\n}\r\n\r\n.list_from_LeadResources-css_3v8 {\r\n  margin: 0 32px\r\n}\r\n\r\n.list_from_LeadResources-css_3v8 .noResources_from_LeadResources-css_17E {\r\n  font-size: 0.7em;\r\n  font-weight: 400;\r\n  color: #6F7583;\r\n}\r\n\r\n.upload_from_LeadResources-css_1Bq {\r\n  position: relative;\r\n  margin: 0 32px;\r\n  margin-top: 24px;\r\n  margin-bottom: 32px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"resources": "resources_from_LeadResources-css_Gyu",
	"list": "list_from_LeadResources-css_3v8",
	"noResources": "noResources_from_LeadResources-css_17E",
	"upload": "upload_from_LeadResources-css_1Bq"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Resources/Resource/Resource.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".resource_from_Resource-css_1fZ {\r\n  position: relative;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: start;\r\n      -ms-flex-pack: start;\r\n          justify-content: flex-start;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  margin-top: 12px\r\n}\n.resource_from_Resource-css_1fZ:first-child {\r\n  margin-top: 0;\r\n}\n.resource_from_Resource-css_1fZ .box_from_Resource-css_1Ok {\r\n  position: relative;\r\n  cursor: pointer;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  width: 48px;\r\n  height: 48px;\r\n  background: #E9EBEB;\r\n  border: 1px solid #DCDEDE;\r\n  border-radius: 3px;\r\n  -webkit-transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\n.resource_from_Resource-css_1fZ .box_from_Resource-css_1Ok img.icon_from_Resource-css_4z0 {\r\n  width: 21px;\r\n  height: 21px;\r\n}\n.resource_from_Resource-css_1fZ .box_from_Resource-css_1Ok img.corner_from_Resource-css_2A3 {\r\n  position: absolute;\r\n  bottom: 2px;\r\n  left: 2px;\r\n  width: 8px;\r\n  height: 8px;\r\n}\n.resource_from_Resource-css_1fZ .box_from_Resource-css_1Ok:hover {\r\n  border-color: #496DF4;\r\n}\n.resource_from_Resource-css_1fZ .description_from_Resource-css_B2r {\r\n  padding-left: 12px;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -ms-flex-line-pack: start;\r\n      align-content: flex-start;\r\n  -webkit-box-align: start;\r\n      -ms-flex-align: start;\r\n          align-items: flex-start\r\n}\n.resource_from_Resource-css_1fZ .description_from_Resource-css_B2r .name_from_Resource-css_3PG {\r\n  text-decoration: none;\r\n  font-size: 0.825em;\r\n  font-weight: 400;\r\n  line-height: 1.3;\r\n  color: #2B2C2F;\r\n  border: 1px solid transparent;\r\n  -webkit-transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                  250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 300ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n                  250ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\n.resource_from_Resource-css_1fZ .description_from_Resource-css_B2r .name_from_Resource-css_3PG:hover {\r\n  border-bottom-color: #496DF4;\r\n  color: #496DF4;\r\n}\n.resource_from_Resource-css_1fZ .description_from_Resource-css_B2r .date_from_Resource-css_29v {\r\n  font-size: 0.725em;\r\n  font-weight: 400;\r\n  color: #A0A3A3;\r\n  margin-top: 2px;\r\n}\n.resource_from_Resource-css_1fZ .delete_from_Resource-css_LXr {\r\n  -webkit-box-flex: 0;\r\n      -ms-flex: 0 1 auto;\r\n          flex: 0 1 auto;\r\n  margin-left: auto;\r\n  margin-right: 0\r\n}\n.resource_from_Resource-css_1fZ .delete_from_Resource-css_LXr > button {\r\n  position: relative;\r\n  left: 16px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"resource": "resource_from_Resource-css_1fZ",
	"box": "box_from_Resource-css_1Ok",
	"icon": "icon_from_Resource-css_4z0",
	"corner": "corner_from_Resource-css_2A3",
	"description": "description_from_Resource-css_B2r",
	"name": "name_from_Resource-css_3PG",
	"date": "date_from_Resource-css_29v",
	"delete": "delete_from_Resource-css_LXr"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Sales/RepCollectionsModal.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".container_from_RepCollectionsModal-css_1fw {\r\n}\r\n\r\n.loading_from_RepCollectionsModal-css_1Ll {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    text-align: center;\r\n    padding: 32px 0;\r\n}\r\n\r\n.status_from_RepCollectionsModal-css_3W7 {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n}\r\n\r\n.content_from_RepCollectionsModal-css_3tX {\r\n    padding: 24px 64px;\r\n}\r\n\r\n.table_from_RepCollectionsModal-css_2qW {\r\n    border-top: 1px solid #F0F4F5;\r\n    padding-bottom: 24px;\r\n}\r\n\r\n.empty_from_RepCollectionsModal-css_2VF {\r\n    padding-top: 24px\r\n}\r\n\r\n.empty_from_RepCollectionsModal-css_2VF p {\r\n    font-size: 16px;\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    color: #6F7583;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "container_from_RepCollectionsModal-css_1fw",
	"loading": "loading_from_RepCollectionsModal-css_1Ll",
	"status": "status_from_RepCollectionsModal-css_3W7",
	"content": "content_from_RepCollectionsModal-css_3tX",
	"table": "table_from_RepCollectionsModal-css_2qW",
	"empty": "empty_from_RepCollectionsModal-css_2VF"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Sales/RepCollectionsPeriod.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".period_from_RepCollectionsPeriod-css_aVm {\r\n    margin: 0 -16px;\r\n    margin-top: 6px\r\n}\n.period_from_RepCollectionsPeriod-css_aVm .summary_from_RepCollectionsPeriod-css_3Uz {\r\n    cursor: pointer;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    background: #F8FCFD;\r\n    margin: 0;\r\n    padding: 16px;\r\n    -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n            justify-content: space-between;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\n.period_from_RepCollectionsPeriod-css_aVm .summary_from_RepCollectionsPeriod-css_3Uz p {\r\n    font-size: 0.85em;\r\n}\n.period_from_RepCollectionsPeriod-css_aVm .summary_from_RepCollectionsPeriod-css_3Uz:hover {\r\n    background: rgb(243, 243, 243);\r\n}\n.period_from_RepCollectionsPeriod-css_aVm:nth-child(2n) .summary_from_RepCollectionsPeriod-css_3Uz {\r\n    background: #F0F4F5\r\n}\n.period_from_RepCollectionsPeriod-css_aVm:nth-child(2n) .summary_from_RepCollectionsPeriod-css_3Uz:hover {\r\n    background: rgb(234, 239, 241);\r\n}\n.period_from_RepCollectionsPeriod-css_aVm:nth-child(2n) .details_from_RepCollectionsPeriod-css_2mQ {\r\n    background: #F0F4F5;\r\n}\n.period_from_RepCollectionsPeriod-css_aVm .right_from_RepCollectionsPeriod-css_1oA {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: end;\r\n        -ms-flex-pack: end;\r\n            justify-content: flex-end;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center\r\n}\n.period_from_RepCollectionsPeriod-css_aVm .right_from_RepCollectionsPeriod-css_1oA .amount_from_RepCollectionsPeriod-css_3N5 {\r\n    margin-right: 6px;\r\n}\n.period_from_RepCollectionsPeriod-css_aVm .right_from_RepCollectionsPeriod-css_1oA .collapseIcon_from_RepCollectionsPeriod-css_3p6 img {\r\n    width: 12px;\r\n    height: 12px;\r\n}\n.period_from_RepCollectionsPeriod-css_aVm .right_from_RepCollectionsPeriod-css_1oA .expandIcon_from_RepCollectionsPeriod-css_3HQ img {\r\n    width: 12px;\r\n    height: 9px;\r\n}\n.period_from_RepCollectionsPeriod-css_aVm .details_from_RepCollectionsPeriod-css_2mQ {\r\n    border-top: 1px solid #E9EBEB;\r\n    padding: 12px 16px\r\n}\n.period_from_RepCollectionsPeriod-css_aVm .details_from_RepCollectionsPeriod-css_2mQ .noResults_from_RepCollectionsPeriod-css_2KA {\r\n    text-align: left\r\n}\n.period_from_RepCollectionsPeriod-css_aVm .details_from_RepCollectionsPeriod-css_2mQ .noResults_from_RepCollectionsPeriod-css_2KA p {\r\n    font-size: 0.8em;\r\n    color: #6F7583;\r\n}\n.period_from_RepCollectionsPeriod-css_aVm .details_from_RepCollectionsPeriod-css_2mQ .loading_from_RepCollectionsPeriod-css_1OW {\r\n    text-align: right;\r\n}\n.period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z {\r\n    width: 100%\r\n}\n.period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z thead th,\r\n            .period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z thead td,\r\n            .period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z tbody th,\r\n            .period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z tbody td {\r\n    border-bottom: 1px dashed #E9EBEB;\r\n    padding: 6px 6px;\r\n    text-align: left\r\n}\n.period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z thead th:first-child, .period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z thead td:first-child, .period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z tbody th:first-child, .period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z tbody td:first-child {\r\n    padding-left: 0;\r\n}\n.period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z thead th:nth-child(2n), .period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z thead td:nth-child(2n), .period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z tbody th:nth-child(2n), .period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z tbody td:nth-child(2n) {\r\n    text-align: right;\r\n    padding-right: 16px;\r\n}\n.period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z thead th:nth-child(5n), .period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z thead td:nth-child(5n), .period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z tbody th:nth-child(5n), .period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z tbody td:nth-child(5n) {\r\n    text-align: right;\r\n}\n.period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z thead th:last-child, .period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z thead td:last-child, .period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z tbody th:last-child, .period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z tbody td:last-child {\r\n    padding-right: 0;\r\n}\n.period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z thead th, .period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z tbody th {\r\n    font-size: 1em;\r\n    font-weight: 400;\r\n    color: #2A5798;\r\n    border-bottom-color: #444956;\r\n}\n.period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z thead tr, .period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z tbody tr {\r\n    font-size: 0.85em;\r\n    font-weight: 400\r\n}\n.period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z thead tr:last-child td, .period_from_RepCollectionsPeriod-css_aVm table.data_from_RepCollectionsPeriod-css_22z tbody tr:last-child td {\r\n    border-bottom: none;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"period": "period_from_RepCollectionsPeriod-css_aVm",
	"summary": "summary_from_RepCollectionsPeriod-css_3Uz",
	"details": "details_from_RepCollectionsPeriod-css_2mQ",
	"right": "right_from_RepCollectionsPeriod-css_1oA",
	"amount": "amount_from_RepCollectionsPeriod-css_3N5",
	"collapseIcon": "collapseIcon_from_RepCollectionsPeriod-css_3p6",
	"expandIcon": "expandIcon_from_RepCollectionsPeriod-css_3HQ",
	"noResults": "noResults_from_RepCollectionsPeriod-css_2KA",
	"loading": "loading_from_RepCollectionsPeriod-css_1OW",
	"data": "data_from_RepCollectionsPeriod-css_22z"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Sales/RepSales.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".container_from_RepSales-css_37c {\r\n    z-index: 2;\r\n    padding-bottom: 0;\r\n}\r\n\r\n.salesTicker_from_RepSales-css_3_5 {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -webkit-box-align: stretch;\r\n        -ms-flex-align: stretch;\r\n            align-items: stretch;\r\n    border: 1px solid #E9EBEB;\r\n    background: #F8FCFD;\r\n    padding: 12px 6px;\r\n    -webkit-box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.06);\r\n            box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.salesTickerCol_from_RepSales-css_gOP {\r\n    position: relative;\r\n    text-align: center;\r\n    padding: 0 12px;\r\n    border-left: 1px solid #DCDEDE\r\n}\r\n\r\n.salesTickerCol_from_RepSales-css_gOP:first-child {\r\n    border-left: none;\r\n}\r\n\r\n.salesTickerCol_from_RepSales-css_gOP.last_from_RepSales-css_2E3 {\r\n    padding-right: 32px;\r\n    cursor: pointer;\r\n}\r\n\r\n.salesTickerCol_from_RepSales-css_gOP.last_from_RepSales-css_2E3 p {\r\n    -webkit-transition: 300ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.salesTickerCol_from_RepSales-css_gOP.last_from_RepSales-css_2E3:hover .salesLabel_from_RepSales-css_3KR {\r\n    color: #2B2C2F;\r\n}\r\n\r\n.salesTickerCol_from_RepSales-css_gOP.last_from_RepSales-css_2E3:hover .salesAmount_from_RepSales-css_1XC {\r\n    color: #496DF4;\r\n}\r\n\r\n.salesLabel_from_RepSales-css_3KR {\r\n    text-transform: uppercase;\r\n    font-size: 0.7em;\r\n    font-weight: 400;\r\n    color: #A0A3A3;\r\n}\r\n\r\n.salesAmount_from_RepSales-css_1XC {\r\n    margin-top: 3px;\r\n    font-size: 0.85em;\r\n    font-weight: 600;\r\n    color: #2B2C2F;\r\n}\r\n\r\n.salesDropdown_from_RepSales-css_1BB {\r\n    position: absolute;\r\n    top: 3px;\r\n    right: 12px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "container_from_RepSales-css_37c",
	"salesTicker": "salesTicker_from_RepSales-css_3_5",
	"salesTickerCol": "salesTickerCol_from_RepSales-css_gOP",
	"last": "last_from_RepSales-css_2E3",
	"salesLabel": "salesLabel_from_RepSales-css_3KR",
	"salesAmount": "salesAmount_from_RepSales-css_1XC",
	"salesDropdown": "salesDropdown_from_RepSales-css_1BB"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/SalesLead.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".lead_from_SalesLead-css_F99 {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    width: 100%;\r\n    min-height: calc(100% - 64px);\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: stretch;\r\n        align-content: stretch;\r\n    -webkit-box-align: stretch;\r\n        -ms-flex-align: stretch;\r\n            align-items: stretch;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n            flex-direction: row;\r\n    -ms-flex-wrap: nowrap;\r\n        flex-wrap: nowrap;\r\n    min-height: 900px\r\n}\r\n\r\n.lead_from_SalesLead-css_F99 > div {\r\n    position: relative;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: flex-start;\r\n    -ms-flex-line-pack: stretch;\r\n        align-content: stretch;\r\n    -webkit-box-align: stretch;\r\n        -ms-flex-align: stretch;\r\n            align-items: stretch;\r\n}\r\n\r\n.details_from_SalesLead-css_3PL {\r\n    -webkit-box-flex: 0;\r\n        -ms-flex: 0 1 auto;\r\n            flex: 0 1 auto;\r\n    width: 320px;\r\n    z-index: 4;\r\n    overflow: hidden;\r\n    background: #F8FCFD;\r\n    -webkit-transition: 300ms width 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 300ms width 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.details_from_SalesLead-css_3PL.businessPartnerPanelOpen_from_SalesLead-css_3EO {\r\n    position: fixed;\r\n    z-index: 5;\r\n    top: 64px;\r\n    left: 0;\r\n    height: calc(100% - 64px);\r\n    width: 384px;\r\n    overflow: auto;\r\n    overflow-x: hidden;\r\n}\r\n\r\n.details_from_SalesLead-css_3PL .block_from_SalesLead-css_rNp > hr {\r\n    position: relative;\r\n    display: block;\r\n    width: calc(100% - 64px);\r\n    height: 1px;\r\n    border: none;\r\n    top: 4px;\r\n    margin: 0 32px;\r\n    background: #E9EBEB;\r\n}\r\n\r\n.details_from_SalesLead-css_3PL .provider_from_SalesLead-css_2hP {}\r\n\r\n.details_from_SalesLead-css_3PL .contacts_from_SalesLead-css_12g {}\r\n\r\n.details_from_SalesLead-css_3PL .pricing_from_SalesLead-css_2iG {}\r\n\r\n.details_from_SalesLead-css_3PL .disable_from_SalesLead-css_3Dn .disableIcon_from_SalesLead-css_14j img {\r\n    width: 13px;\r\n    height: 13px;\r\n}\r\n\r\n.arrow_from_SalesLead-css_1ae img {\r\n    width: 13px !important;\r\n    height: 9px !important;\r\n}\r\n\r\n.middle_from_SalesLead-css_1Zx {\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1;\r\n            flex: 1;\r\n    z-index: 3;\r\n    background: #F8FCFD;\r\n    border-left: 1px solid #E9EBEB;\r\n    -webkit-box-shadow: 0px 10px 25px rgba(43, 44, 47, 0.08);\r\n            box-shadow: 0px 10px 25px rgba(43, 44, 47, 0.08)\r\n}\r\n\r\n.middle_from_SalesLead-css_1Zx .activites_from_SalesLead-css_18o {\r\n    background: #F7FDFF;\r\n    -webkit-box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.03);\r\n            box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.03);\r\n}\r\n\r\n.other_from_SalesLead-css_2dc {\r\n    -webkit-box-flex: 0;\r\n        -ms-flex: 0 1 435px;\r\n            flex: 0 1 435px;\r\n    z-index: 2;\r\n    background: #F2F2F2;\r\n    padding-bottom: 128px\r\n}\r\n\r\n.other_from_SalesLead-css_2dc .questionnaire_from_SalesLead-css_11c {\r\n    background: #F5F7F7;\r\n}\r\n\r\n.other_from_SalesLead-css_2dc .resources_from_SalesLead-css_2ji {}\r\n", ""]);

// exports
exports.locals = {
	"lead": "lead_from_SalesLead-css_F99",
	"details": "details_from_SalesLead-css_3PL",
	"businessPartnerPanelOpen": "businessPartnerPanelOpen_from_SalesLead-css_3EO",
	"block": "block_from_SalesLead-css_rNp",
	"provider": "provider_from_SalesLead-css_2hP",
	"contacts": "contacts_from_SalesLead-css_12g",
	"pricing": "pricing_from_SalesLead-css_2iG",
	"disable": "disable_from_SalesLead-css_3Dn",
	"disableIcon": "disableIcon_from_SalesLead-css_14j",
	"arrow": "arrow_from_SalesLead-css_1ae",
	"middle": "middle_from_SalesLead-css_1Zx",
	"activites": "activites_from_SalesLead-css_18o",
	"other": "other_from_SalesLead-css_2dc",
	"questionnaire": "questionnaire_from_SalesLead-css_11c",
	"resources": "resources_from_SalesLead-css_2ji"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/user/login/Form/LoginForm.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".block_from_LoginForm-css_2qp {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  -webkit-box-pack: stretch;\r\n      -ms-flex-pack: stretch;\r\n          justify-content: stretch;\r\n  text-align: left;\r\n  max-width: 448px;\r\n  background: #FFFFFF;\r\n  -webkit-box-shadow: 0px 8px 16px rgba(43, 44, 47, 0.02);\r\n          box-shadow: 0px 8px 16px rgba(43, 44, 47, 0.02);\r\n}\r\n\r\n.top_from_LoginForm-css_r16 {\r\n  position: relative;\r\n  display: block;\r\n  margin: 48px;\r\n  margin-bottom: 96px\r\n}\r\n\r\n.top_from_LoginForm-css_r16 .logo_from_LoginForm-css_S8B {\r\n  padding-right: 12px;\r\n  max-width: 192px;\r\n  height: auto;\r\n}\r\n\r\n.top_from_LoginForm-css_r16 .goBack_from_LoginForm-css_3w8 {\r\n  position: absolute;\r\n  top: -8px;\r\n  right: 0;\r\n  margin: 0;\r\n  padding: 12px;\r\n  font-size: 0.725em;\r\n  font-weight: 700;\r\n  color: #EC7B65;\r\n  border-bottom: 10px solid rgba(236, 123, 101, 0);\r\n  -webkit-transition: 250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n  transition: 250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n}\r\n\r\n.top_from_LoginForm-css_r16 .goBack_from_LoginForm-css_3w8:hover,\r\n    .top_from_LoginForm-css_r16 .goBack_from_LoginForm-css_3w8:focus,\r\n    .top_from_LoginForm-css_r16 .goBack_from_LoginForm-css_3w8:active {\r\n  border-bottom: 1px solid #EC7B65;\r\n}\r\n\r\n.headline_from_LoginForm-css_3hu {\r\n  font-size: 1.3em;\r\n  font-family: 600;\r\n  color: #444956;\r\n  padding: 0 96px;\r\n  padding-bottom: 32px\r\n}\r\n\r\n.headline_from_LoginForm-css_3hu.headlineImportant_from_LoginForm-css_1l8 {\r\n  color: #EC7B65;\r\n}\r\n\r\n.form_from_LoginForm-css_2Fw {\r\n  position: relative;\r\n  overflow: hidden;\r\n  padding: 0 96px;\r\n  padding-bottom: 144px\r\n}\r\n\r\n.form_from_LoginForm-css_2Fw input {\r\n  width: 100%;\r\n  margin-top: 12px;\r\n}\r\n\r\n.form_from_LoginForm-css_2Fw button {\r\n  margin-top: 44px;\r\n  float: right;\r\n}\r\n\r\n.form_from_LoginForm-css_2Fw button::after {\r\n  content: '';\r\n  display: table;\r\n  clear: both;\r\n}\r\n\r\n.offline_from_LoginForm-css_Vr_ {\r\n  width: 100%;\r\n  height: 100%;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  padding: 0 96px;\r\n  padding-bottom: 144px;\r\n  background: #FFFFFF;\r\n  z-index: 2;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n  -ms-flex-wrap: nowrap;\r\n      flex-wrap: nowrap;\r\n  text-align: center;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center\r\n}\r\n\r\n.offline_from_LoginForm-css_Vr_ > p {\r\n  margin-top: 24px;\r\n}\r\n\r\n.offline_from_LoginForm-css_Vr_ strong {\r\n  display: block;\r\n  font-size: 1.025em;\r\n  font-weight: 600;\r\n  color: #EC7B65;\r\n}\r\n\r\n.offline_from_LoginForm-css_Vr_ span {\r\n  display: block;\r\n  margin-top: 12px;\r\n  font-size: 0.825em;\r\n  line-height: 1.3;\r\n  color: #2B2C2F;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"block": "block_from_LoginForm-css_2qp",
	"top": "top_from_LoginForm-css_r16",
	"logo": "logo_from_LoginForm-css_S8B",
	"goBack": "goBack_from_LoginForm-css_3w8",
	"headline": "headline_from_LoginForm-css_3hu",
	"headlineImportant": "headlineImportant_from_LoginForm-css_1l8",
	"form": "form_from_LoginForm-css_2Fw",
	"offline": "offline_from_LoginForm-css_Vr_"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/user/login/Login.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".container_from_Login-css_26v {\r\n  position: fixed;\r\n  overflow: auto;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "container_from_Login-css_26v"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/styles/errors/errors.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".pageForbidden_from_errors-css_34x {\r\n  position: relative;\r\n  height: 100vh;\r\n}\r\n\r\n.pageForbidden__inner_from_errors-css_xIJ {\r\n  position: absolute;\r\n  width: 320px;\r\n  left: 50%;\r\n  top: 50%;\r\n  -webkit-transform: translate(-50%, -50%);\r\n          transform: translate(-50%, -50%);\r\n}\r\n\r\n.pageForbidden__option_from_errors-css_3q7 {\r\n  color: black;\r\n  padding: 4px 0;\r\n}\r\n\r\n.pageNotFound_from_errors-css_iTp {\r\n  position: relative;\r\n  height: 100vh;\r\n}\r\n\r\n.pageNotFound__inner_from_errors-css_3tc {\r\n  position: absolute;\r\n  width: 320px;\r\n  left: 50%;\r\n  top: 50%;\r\n  -webkit-transform: translate(-50%, -50%);\r\n          transform: translate(-50%, -50%);\r\n}\r\n\r\n.errors_from_errors-css_3hO {}\r\n", ""]);

// exports
exports.locals = {
	"pageForbidden": "pageForbidden_from_errors-css_34x",
	"pageForbidden__inner": "pageForbidden__inner_from_errors-css_xIJ",
	"pageForbidden__option": "pageForbidden__option_from_errors-css_3q7",
	"pageNotFound": "pageNotFound_from_errors-css_iTp",
	"pageNotFound__inner": "pageNotFound__inner_from_errors-css_3tc",
	"errors": "errors_from_errors-css_3hO"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/styles/index.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "/*\r\n\tHTML5 Reset :: style.css\r\n\t----------------------------------------------------------\r\n\tWe have learned much from/been inspired by/taken code where offered from:\r\n\r\n\tEric Meyer\t\t\t\t\t:: http://meyerweb.com\r\n\tHTML5 Doctor\t\t\t\t:: http://html5doctor.com\r\n\tand the HTML5 Boilerplate\t:: http://html5boilerplate.com\r\n\r\n-------------------------------------------------------------------------------*/\r\n\r\n/* Let's default this puppy out\r\n-------------------------------------------------------------------------------*/\r\n\r\nhtml, body, body div, span, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, abbr, address, cite, code, del, dfn, em, img, ins, kbd, q, samp, small, strong, sub, sup, var, b, i, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, figure, footer, header, menu, nav, section, time, mark, audio, video, details, summary {\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tborder: 0;\r\n\tfont-size: 100%;\r\n\tfont-weight: normal;\r\n\tvertical-align: baseline;\r\n\tbackground: transparent;\r\n}\r\n\r\narticle, aside, figure, footer, header, nav, section, details, summary {display: block;}\r\n\r\n/* Handle box-sizing while better addressing child elements:\r\n   http://css-tricks.com/inheriting-box-sizing-probably-slightly-better-best-practice/ */\r\n\r\nhtml {\r\n\t-webkit-box-sizing: border-box;\r\n\t        box-sizing: border-box;\r\n}\r\n\r\n*,\r\n*:before,\r\n*:after {\r\n\t-webkit-box-sizing: inherit;\r\n\t        box-sizing: inherit;\r\n}\r\n\r\n/* consider resetting the default cursor: https://gist.github.com/murtaugh/5247154 */\r\n\r\n/* Responsive images and other embedded objects */\r\n\r\n/* if you don't have full control over `img` tags (if you have to overcome attributes), consider adding height: auto */\r\n\r\nimg,\r\nobject,\r\nembed {max-width: 100%;}\r\n\r\n/*\r\n   Note: keeping IMG here will cause problems if you're using foreground images as sprites.\r\n\tIn fact, it *will* cause problems with Google Maps' controls at small size.\r\n\tIf this is the case for you, try uncommenting the following:\r\n\r\n#map img {\r\n\t\tmax-width: none;\r\n}\r\n*/\r\n\r\n/* force a vertical scrollbar to prevent a jumpy page */\r\n\r\nhtml {overflow-y: scroll;}\r\n\r\n/* we use a lot of ULs that aren't bulleted.\r\n\tyou'll have to restore the bullets within content,\r\n\twhich is fine because they're probably customized anyway */\r\n\r\nul {list-style: none;}\r\n\r\nblockquote, q {quotes: none;}\r\n\r\nblockquote:before,\r\nblockquote:after,\r\nq:before,\r\nq:after {content: ''; content: none;}\r\n\r\na {margin: 0; padding: 0; font-size: 100%; vertical-align: baseline; background: transparent;}\r\n\r\ndel {text-decoration: line-through;}\r\n\r\nabbr[title], dfn[title] {border-bottom: 1px dotted #000; cursor: help;}\r\n\r\n/* tables still need cellspacing=\"0\" in the markup */\r\n\r\ntable {border-collapse: collapse; border-spacing: 0;}\r\n\r\nth {font-weight: bold; vertical-align: bottom;}\r\n\r\ntd {font-weight: normal; vertical-align: top;}\r\n\r\nhr {display: block; height: 1px; border: 0; border-top: 1px solid #ccc; margin: 1em 0; padding: 0;}\r\n\r\ninput, select {vertical-align: middle;}\r\n\r\npre {\r\n    white-space: pre; /* CSS2 */\r\n    white-space: pre-wrap; /* CSS 2.1 */\r\n    white-space: pre-line; /* CSS 3 (and 2.1 as well, actually) */\r\n    word-wrap: break-word; /* IE */\r\n}\r\n\r\ninput[type=\"radio\"] {vertical-align: text-bottom;}\r\n\r\ninput[type=\"checkbox\"] {vertical-align: bottom;}\r\n\r\n.ie7_from_index-css_T_l input[type=\"checkbox\"] {vertical-align: baseline;}\r\n\r\n.ie6_from_index-css_3n- input {vertical-align: text-bottom;}\r\n\r\nselect, input, textarea {font: 99% sans-serif;}\r\n\r\ntable {font-size: inherit; font: 100%;}\r\n\r\nsmall {font-size: 85%;}\r\n\r\nstrong {font-weight: bold;}\r\n\r\ntd, td img {vertical-align: top;}\r\n\r\n/* Make sure sup and sub don't mess with your line-heights http://gist.github.com/413930 */\r\n\r\nsub, sup {font-size: 75%; line-height: 0; position: relative;}\r\n\r\nsup {top: -0.5em;}\r\n\r\nsub {bottom: -0.25em;}\r\n\r\n/* standardize any monospaced elements */\r\n\r\npre, code, kbd, samp {font-family: monospace, sans-serif;}\r\n\r\n/* hand cursor on clickable elements */\r\n\r\n.clickable_from_index-css_22L,\r\nlabel,\r\ninput[type=button],\r\ninput[type=submit],\r\ninput[type=file],\r\nbutton {cursor: pointer;}\r\n\r\n/* Webkit browsers add a 2px margin outside the chrome of form elements */\r\n\r\nbutton, input, select, textarea {margin: 0;}\r\n\r\n/* make buttons play nice in IE */\r\n\r\nbutton,\r\ninput[type=button] {width: auto; overflow: visible;}\r\n\r\nbutton {\r\n  margin: 0;\r\n  padding: 0;\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n}\r\n\r\n/* scale images in IE7 more attractively */\r\n\r\n.ie7_from_index-css_T_l img {-ms-interpolation-mode: bicubic;}\r\n\r\n/* prevent BG image flicker upon hover\r\n   (commented out as usage is rare, and the filter syntax messes with some pre-processors)\r\n.ie6 html {filter: expression(document.execCommand(\"BackgroundImageCache\", false, true));}\r\n*/\r\n\r\n/* let's clear some floats */\r\n\r\n.clearfix_from_index-css_1iP:before, .clearfix_from_index-css_1iP:after { content: \" \"; display: block; height: 0; overflow: hidden; }\r\n\r\n.clearfix_from_index-css_1iP:after { clear: both; }\r\n\r\n.clearfix_from_index-css_1iP { zoom: 1; }\r\n\r\n.ReactVirtualized__Collection {\r\n}\r\n\r\n.ReactVirtualized__Collection__innerScrollContainer {\r\n}\r\n\r\n.ReactVirtualized__Grid {\r\n  outline: none;\r\n}\r\n\r\n.ReactVirtualized__Grid__innerScrollContainer {\r\n  outline: none;\r\n}\r\n\r\n.ReactVirtualized__Table {\r\n}\r\n\r\n.ReactVirtualized__Table__Grid {\r\n}\r\n\r\n.ReactVirtualized__Table__headerRow {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: row;\r\n          flex-direction: row;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  font-weight: 600;\r\n  font-size: 0.8em;\r\n  color: #444956;\r\n  background: none;\r\n  padding: 0 32px;\r\n  border-bottom: 1px solid #E9EBEB;\r\n}\r\n\r\n.ReactVirtualized__Table__row {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: row;\r\n          flex-direction: row;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  padding: 32px;\r\n  margin-top: 12px;\r\n  background: #F7FDFF;\r\n  border-radius: 3px;\r\n  border: 1px solid #F2F2F2;\r\n  -webkit-box-shadow: 1px 8px 16px rgba(43, 44, 47, 0.03);\r\n          box-shadow: 1px 8px 16px rgba(43, 44, 47, 0.03);\r\n}\r\n\r\n.ReactVirtualized__Table__headerTruncatedText {\r\n  display: inline-block;\r\n  max-width: 100%;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n}\r\n\r\n.ReactVirtualized__Table__headerColumn,\r\n.ReactVirtualized__Table__rowColumn {\r\n  margin-right: 12px;\r\n  min-width: 0px\r\n}\r\n\r\n.ReactVirtualized__Table__headerColumn:last-child, .ReactVirtualized__Table__rowColumn:last-child {\r\n\ttext-align: right;\r\n\tmargin-right: 0;\r\n}\r\n\r\n.ReactVirtualized__Table__rowColumn {\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.ReactVirtualized__Table__headerColumn:first-of-type,\r\n.ReactVirtualized__Table__rowColumn:first-of-type {\r\n  margin-left: 10px;\r\n}\r\n\r\n.ReactVirtualized__Table__sortableHeaderColumn {\r\n  cursor: pointer;\r\n}\r\n\r\n.ReactVirtualized__Table__sortableHeaderIconContainer {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n}\r\n\r\n.ReactVirtualized__Table__sortableHeaderIcon {\r\n  -webkit-box-flex: 0;\r\n      -ms-flex: 0 0 24px;\r\n          flex: 0 0 24px;\r\n  height: 1em;\r\n  width: 1em;\r\n  fill: currentColor;\r\n}\r\n\r\n.ReactVirtualized__List {\r\n}\r\n\r\nhtml {\r\n    min-height: 100%;\r\n    background: transparent;\r\n}\r\n\r\nbody {\r\n    background: #F8FCFD;\r\n    font-family: Roboto, 'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans',\r\n        'Helvetica Neue', sans-serif;\r\n    scroll-behavior: smooth;\r\n}\r\n\r\n.smooth-container {\r\n    scroll-behavior: smooth;\r\n}\r\n\r\ninput,\r\ntextarea,\r\nselect {\r\n    outline: none;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    padding: 12px 16px;\r\n    border: 1px solid #E9EBEB;\r\n    background: #FFFFFF;\r\n    height: 38px;\r\n    outline: none;\r\n    color: #2B2C2F;\r\n    font-size: 0.8em;\r\n    font-weight: 600;\r\n    border-radius: 1px;\r\n    -webkit-transition: 250ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 250ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        250ms border 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\ninput:hover,\r\n    input:focus,\r\n    textarea:hover,\r\n    textarea:focus,\r\n    select:hover,\r\n    select:focus {\r\n\tbackground: #F5F7F7;\r\n\tborder-color: #DCDEDE;\r\n}\r\n\r\ninput:focus,\r\n    input:active,\r\n    textarea:focus,\r\n    textarea:active,\r\n    select:focus,\r\n    select:active {\r\n\tbackground: #FFFFFF;\r\n\tborder-color: rgba(42, 87, 152, 0.3);\r\n}\r\n\r\ninput:hover,\r\n    input:focus,\r\n    input:active,\r\n    textarea:hover,\r\n    textarea:focus,\r\n    textarea:active,\r\n    select:hover,\r\n    select:focus,\r\n    select:active {\r\n\tcolor: #496DF4;\r\n}\r\n\r\nselect {\r\n    padding-top: 0;\r\n    padding-bottom: 0;\r\n}\r\n\r\nlabel.checkboxGroup {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n}\r\n\r\n.text {\r\n    font-size: 0.8em;\r\n    font-weight: 600;\r\n    line-height: 1.3;\r\n    color: #2B2C2F\r\n}\r\n\r\n.text.textImportant {\r\n\tcolor: #EC7B65;\r\n}\r\n\r\n.boxButton {\r\n    text-decoration: none;\r\n    background: #496DF4;\r\n    border: 1px solid #2E3D73;\r\n    text-transform: uppercase;\r\n    color: #F5F7F7;\r\n    font-size: 0.725em;\r\n    font-weight: 600;\r\n    margin: 0;\r\n    outline: none;\r\n    padding: 9px 16px;\r\n    border-radius: 1px;\r\n    -webkit-transition: 250ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        300ms border 150ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        300ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000);\r\n    transition: 250ms background 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        300ms border 150ms cubic-bezier(0.645, 0.045, 0.355, 1.000),\r\n        300ms color 0ms cubic-bezier(0.645, 0.045, 0.355, 1.000)\r\n}\r\n\r\n.boxButton.boxButtonImportant {\r\n\tbackground: #EC7B65;\r\n\tborder-color: rgb(234, 108, 83);\r\n\tcolor: #FFFFFF;\r\n}\r\n\r\n.boxButton.boxButtonImportant:hover,\r\n        .boxButton.boxButtonImportant:focus,\r\n        .boxButton.boxButtonImportant:active {\r\n\tbackground: #FFFFFF;\r\n\tborder-color: #EC7B65;\r\n\tcolor: #EC7B65;\r\n}\r\n\r\n.boxButton.boxButtonImportant:active {\r\n\tborder-color: rgba(236, 123, 101, 0.2);\r\n}\r\n\r\n.boxButton.boxButtonWhite {\r\n\tbackground: #FFFFFF;\r\n\tborder-color: #E9EBEB;\r\n\tcolor: #496DF4;\r\n}\r\n\r\n.boxButton.boxButtonWhite:hover,\r\n        .boxButton.boxButtonWhite:focus,\r\n        .boxButton.boxButtonWhite:active {\r\n\tbackground: #FFFFFF;\r\n\tborder-color: #496DF4;\r\n\tcolor: #496DF4;\r\n}\r\n\r\n.boxButton.boxButtonWhite:active {\r\n\tborder-color: #E9EBEB;\r\n}\r\n\r\n.boxButton.boxButtonWhiteSuccess {\r\n\tbackground: #FFFFFF;\r\n\tborder-color: #E9EBEB;\r\n\tcolor: #18A073;\r\n}\r\n\r\n.boxButton.boxButtonWhiteSuccess:hover,\r\n        .boxButton.boxButtonWhiteSuccess:focus,\r\n        .boxButton.boxButtonWhiteSuccess:active {\r\n\tbackground: #FFFFFF;\r\n\tborder-color: #18A073;\r\n\tcolor: #18A073;\r\n}\r\n\r\n.boxButton.boxButtonWhiteSuccess:active {\r\n\tborder-color: #E9EBEB;\r\n}\r\n\r\n.boxButton:hover,\r\n    .boxButton:focus,\r\n    .boxButton:active {\r\n\tbackground: #FFFFFF;\r\n\tborder-color: #496DF4;\r\n\tcolor: #496DF4;\r\n}\r\n\r\n.boxButton.active_from_index-css_IBE {\r\n\tborder-color: rgba(73, 109, 244, 0.2);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"ie7": "ie7_from_index-css_T_l",
	"ie6": "ie6_from_index-css_3n-",
	"clickable": "clickable_from_index-css_22L",
	"clearfix": "clearfix_from_index-css_1iP",
	"active": "active_from_index-css_IBE"
};

/***/ }),

/***/ "./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/styles/sales/sales.css":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".leadsSearchInput_from_sales-css_1W6 {\r\n}\r\n.leadsSearchInput__input_from_sales-css_WGP {\r\n  width: calc(100% - 18px);\r\n  background: #FFFFFF;\r\n  padding: 24px;\r\n  margin: 12px;\r\n  font-weight: 900;\r\n}\r\n.leadsSearchAutocomplete_from_sales-css_30j {\r\n  position: relative;\r\n}\r\n.leadsSearchAutocomplete__inner_from_sales-css_Cks {\r\n  position: absolute;\r\n  background: #FFFFFF;\r\n  border-radius: 4px;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n.leadsSearchAutocompleteRow_from_sales-css_1q0 {\r\n  background: rgba(0, 0, 0, .66);\r\n  color: #FFFFFF;\r\n  padding: 6px;\r\n}\r\n.leadsSearchAutocompleteRow_from_sales-css_1q0:hover {\r\n  opacity: 0.66;\r\n  cursor: pointer;\r\n}\r\n.leadsSearch_from_sales-css_1d3 {\r\n  background: #FFFFFF;\r\n  border-radius: 4px;\r\n}\r\n.tableRow_from_sales-css_2tm {\r\n  cursor: pointer;\r\n}\r\n.tableRowSelected_from_sales-css_1Se {\r\n}\r\n.tableColumn_from_sales-css_t7E {\r\n\r\n}\r\n.questions_from_sales-css_3E9 {\r\n  background: #FFFFFF;\r\n  border-radius: 4px;\r\n}\r\n.question_from_sales-css_16j {\r\n  width: calc(100% - 18px);\r\n  background: #FFFFFF;\r\n  padding: 24px;\r\n  margin: 12px;\r\n  font-weight: 900;\r\n}\r\n.salesRepresentativePanel__button_from_sales-css_3Sf {\r\n  width: calc(100% - 18px);\r\n  text-align: center;\r\n}\r\n.salesRepresentativePanel__buttonInner_from_sales-css_23H {\r\n  display: inline-block;\r\n  background: #FFFFFF;\r\n  margin: 12px;\r\n  font-weight: 900;\r\n}\r\n.salesRepresentativePanel__buttonInner--disabled_from_sales-css_YsD {\r\n  display: inline-block;\r\n  background: #EEEEEE;\r\n  margin: 12px;\r\n  opacity: 0.5\r\n}\r\n.question__number_from_sales-css_3PX {\r\n  padding-right: 24px;\r\n  font-weight: 900;\r\n  -webkit-transform: scale(1.8);\r\n          transform: scale(1.8);\r\n}\r\n.questionOption_from_sales-css_3cc {\r\n  width: calc(100% - 12px);\r\n  padding: 24px;\r\n  font-weight: 900;\r\n}\r\n.questionOptionText_from_sales-css_1Xi {\r\n  width: calc(100% - 12px);\r\n  margin: 10px 0;\r\n  padding: 24px;\r\n}\r\n.questionOptionRadio__item_from_sales-css_28I {\r\n  margin: 10px 0;\r\n}\r\n.questionOptionRadio__input_from_sales-css_3B7 {\r\n  margin: 0 10px;\r\n}\r\n.questionOptionCheckbox__item_from_sales-css_3ZO {\r\n  margin: 10px 0;\r\n}\r\n.questionOptionCheckbox__input_from_sales-css_CCN {\r\n  margin: 0 10px;\r\n}\r\n.salesRepresentativePanel_from_sales-css_2eH {\r\n  padding: 48px;\r\n  width: 100%;\r\n}\r\n.salesRepresentativePanel__item_from_sales-css_vZC {\r\n  margin-bottom: 48px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"leadsSearchInput": "leadsSearchInput_from_sales-css_1W6",
	"leadsSearchInput__input": "leadsSearchInput__input_from_sales-css_WGP",
	"leadsSearchAutocomplete": "leadsSearchAutocomplete_from_sales-css_30j",
	"leadsSearchAutocomplete__inner": "leadsSearchAutocomplete__inner_from_sales-css_Cks",
	"leadsSearchAutocompleteRow": "leadsSearchAutocompleteRow_from_sales-css_1q0",
	"leadsSearch": "leadsSearch_from_sales-css_1d3",
	"tableRow": "tableRow_from_sales-css_2tm",
	"tableRowSelected": "tableRowSelected_from_sales-css_1Se",
	"tableColumn": "tableColumn_from_sales-css_t7E",
	"questions": "questions_from_sales-css_3E9",
	"question": "question_from_sales-css_16j",
	"salesRepresentativePanel__button": "salesRepresentativePanel__button_from_sales-css_3Sf",
	"salesRepresentativePanel__buttonInner": "salesRepresentativePanel__buttonInner_from_sales-css_23H",
	"salesRepresentativePanel__buttonInner--disabled": "salesRepresentativePanel__buttonInner--disabled_from_sales-css_YsD",
	"question__number": "question__number_from_sales-css_3PX",
	"questionOption": "questionOption_from_sales-css_3cc",
	"questionOptionText": "questionOptionText_from_sales-css_1Xi",
	"questionOptionRadio__item": "questionOptionRadio__item_from_sales-css_28I",
	"questionOptionRadio__input": "questionOptionRadio__input_from_sales-css_3B7",
	"questionOptionCheckbox__item": "questionOptionCheckbox__item_from_sales-css_3ZO",
	"questionOptionCheckbox__input": "questionOptionCheckbox__input_from_sales-css_CCN",
	"salesRepresentativePanel": "salesRepresentativePanel_from_sales-css_2eH",
	"salesRepresentativePanel__item": "salesRepresentativePanel__item_from_sales-css_vZC"
};

/***/ }),

/***/ "./node_modules/css-loader/lib/css-base.js":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "./node_modules/debug/src/browser.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__("./node_modules/debug/src/debug.js");
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/debug/src/debug.js":
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__("./node_modules/ms/index.js");

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ "./node_modules/dom-helpers/class/addClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__("./node_modules/dom-helpers/class/hasClass.js"));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/dom-helpers/class/hasClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/dom-helpers/class/removeClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),

/***/ "./node_modules/dom-helpers/transition/properties.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__("./node_modules/dom-helpers/util/inDOM.js"));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),

/***/ "./node_modules/dom-helpers/util/inDOM.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/dom-helpers/util/requestAnimationFrame.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__("./node_modules/dom-helpers/util/inDOM.js"));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/engine.io-client/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {


module.exports = __webpack_require__("./node_modules/engine.io-client/lib/socket.js");

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = __webpack_require__("./node_modules/engine.io-parser/lib/browser.js");


/***/ }),

/***/ "./node_modules/engine.io-client/lib/socket.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var transports = __webpack_require__("./node_modules/engine.io-client/lib/transports/index.js");
var Emitter = __webpack_require__("./node_modules/component-emitter/index.js");
var debug = __webpack_require__("./node_modules/debug/src/browser.js")('engine.io-client:socket');
var index = __webpack_require__("./node_modules/indexof/index.js");
var parser = __webpack_require__("./node_modules/engine.io-parser/lib/browser.js");
var parseuri = __webpack_require__("./node_modules/parseuri/index.js");
var parseqs = __webpack_require__("./node_modules/parseqs/index.js");

/**
 * Module exports.
 */

module.exports = Socket;

/**
 * Socket constructor.
 *
 * @param {String|Object} uri or options
 * @param {Object} options
 * @api public
 */

function Socket (uri, opts) {
  if (!(this instanceof Socket)) return new Socket(uri, opts);

  opts = opts || {};

  if (uri && 'object' === typeof uri) {
    opts = uri;
    uri = null;
  }

  if (uri) {
    uri = parseuri(uri);
    opts.hostname = uri.host;
    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
    opts.port = uri.port;
    if (uri.query) opts.query = uri.query;
  } else if (opts.host) {
    opts.hostname = parseuri(opts.host).host;
  }

  this.secure = null != opts.secure ? opts.secure
    : (typeof location !== 'undefined' && 'https:' === location.protocol);

  if (opts.hostname && !opts.port) {
    // if no port is specified manually, use the protocol default
    opts.port = this.secure ? '443' : '80';
  }

  this.agent = opts.agent || false;
  this.hostname = opts.hostname ||
    (typeof location !== 'undefined' ? location.hostname : 'localhost');
  this.port = opts.port || (typeof location !== 'undefined' && location.port
      ? location.port
      : (this.secure ? 443 : 80));
  this.query = opts.query || {};
  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
  this.upgrade = false !== opts.upgrade;
  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
  this.forceJSONP = !!opts.forceJSONP;
  this.jsonp = false !== opts.jsonp;
  this.forceBase64 = !!opts.forceBase64;
  this.enablesXDR = !!opts.enablesXDR;
  this.timestampParam = opts.timestampParam || 't';
  this.timestampRequests = opts.timestampRequests;
  this.transports = opts.transports || ['polling', 'websocket'];
  this.transportOptions = opts.transportOptions || {};
  this.readyState = '';
  this.writeBuffer = [];
  this.prevBufferLen = 0;
  this.policyPort = opts.policyPort || 843;
  this.rememberUpgrade = opts.rememberUpgrade || false;
  this.binaryType = null;
  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;

  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
    this.perMessageDeflate.threshold = 1024;
  }

  // SSL options for Node.js client
  this.pfx = opts.pfx || null;
  this.key = opts.key || null;
  this.passphrase = opts.passphrase || null;
  this.cert = opts.cert || null;
  this.ca = opts.ca || null;
  this.ciphers = opts.ciphers || null;
  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? true : opts.rejectUnauthorized;
  this.forceNode = !!opts.forceNode;

  // detect ReactNative environment
  this.isReactNative = (typeof navigator !== 'undefined' && typeof navigator.product === 'string' && navigator.product.toLowerCase() === 'reactnative');

  // other options for Node.js or ReactNative client
  if (typeof self === 'undefined' || this.isReactNative) {
    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
      this.extraHeaders = opts.extraHeaders;
    }

    if (opts.localAddress) {
      this.localAddress = opts.localAddress;
    }
  }

  // set on handshake
  this.id = null;
  this.upgrades = null;
  this.pingInterval = null;
  this.pingTimeout = null;

  // set on heartbeat
  this.pingIntervalTimer = null;
  this.pingTimeoutTimer = null;

  this.open();
}

Socket.priorWebsocketSuccess = false;

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Protocol version.
 *
 * @api public
 */

Socket.protocol = parser.protocol; // this is an int

/**
 * Expose deps for legacy compatibility
 * and standalone browser access.
 */

Socket.Socket = Socket;
Socket.Transport = __webpack_require__("./node_modules/engine.io-client/lib/transport.js");
Socket.transports = __webpack_require__("./node_modules/engine.io-client/lib/transports/index.js");
Socket.parser = __webpack_require__("./node_modules/engine.io-parser/lib/browser.js");

/**
 * Creates transport of the given type.
 *
 * @param {String} transport name
 * @return {Transport}
 * @api private
 */

Socket.prototype.createTransport = function (name) {
  debug('creating transport "%s"', name);
  var query = clone(this.query);

  // append engine.io protocol identifier
  query.EIO = parser.protocol;

  // transport name
  query.transport = name;

  // per-transport options
  var options = this.transportOptions[name] || {};

  // session id if we already have one
  if (this.id) query.sid = this.id;

  var transport = new transports[name]({
    query: query,
    socket: this,
    agent: options.agent || this.agent,
    hostname: options.hostname || this.hostname,
    port: options.port || this.port,
    secure: options.secure || this.secure,
    path: options.path || this.path,
    forceJSONP: options.forceJSONP || this.forceJSONP,
    jsonp: options.jsonp || this.jsonp,
    forceBase64: options.forceBase64 || this.forceBase64,
    enablesXDR: options.enablesXDR || this.enablesXDR,
    timestampRequests: options.timestampRequests || this.timestampRequests,
    timestampParam: options.timestampParam || this.timestampParam,
    policyPort: options.policyPort || this.policyPort,
    pfx: options.pfx || this.pfx,
    key: options.key || this.key,
    passphrase: options.passphrase || this.passphrase,
    cert: options.cert || this.cert,
    ca: options.ca || this.ca,
    ciphers: options.ciphers || this.ciphers,
    rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
    perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
    extraHeaders: options.extraHeaders || this.extraHeaders,
    forceNode: options.forceNode || this.forceNode,
    localAddress: options.localAddress || this.localAddress,
    requestTimeout: options.requestTimeout || this.requestTimeout,
    protocols: options.protocols || void (0),
    isReactNative: this.isReactNative
  });

  return transport;
};

function clone (obj) {
  var o = {};
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      o[i] = obj[i];
    }
  }
  return o;
}

/**
 * Initializes transport to use and starts probe.
 *
 * @api private
 */
Socket.prototype.open = function () {
  var transport;
  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
    transport = 'websocket';
  } else if (0 === this.transports.length) {
    // Emit error on next tick so it can be listened to
    var self = this;
    setTimeout(function () {
      self.emit('error', 'No transports available');
    }, 0);
    return;
  } else {
    transport = this.transports[0];
  }
  this.readyState = 'opening';

  // Retry with the next transport if the transport is disabled (jsonp: false)
  try {
    transport = this.createTransport(transport);
  } catch (e) {
    this.transports.shift();
    this.open();
    return;
  }

  transport.open();
  this.setTransport(transport);
};

/**
 * Sets the current transport. Disables the existing one (if any).
 *
 * @api private
 */

Socket.prototype.setTransport = function (transport) {
  debug('setting transport %s', transport.name);
  var self = this;

  if (this.transport) {
    debug('clearing existing transport %s', this.transport.name);
    this.transport.removeAllListeners();
  }

  // set up transport
  this.transport = transport;

  // set up transport listeners
  transport
  .on('drain', function () {
    self.onDrain();
  })
  .on('packet', function (packet) {
    self.onPacket(packet);
  })
  .on('error', function (e) {
    self.onError(e);
  })
  .on('close', function () {
    self.onClose('transport close');
  });
};

/**
 * Probes a transport.
 *
 * @param {String} transport name
 * @api private
 */

Socket.prototype.probe = function (name) {
  debug('probing transport "%s"', name);
  var transport = this.createTransport(name, { probe: 1 });
  var failed = false;
  var self = this;

  Socket.priorWebsocketSuccess = false;

  function onTransportOpen () {
    if (self.onlyBinaryUpgrades) {
      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
      failed = failed || upgradeLosesBinary;
    }
    if (failed) return;

    debug('probe transport "%s" opened', name);
    transport.send([{ type: 'ping', data: 'probe' }]);
    transport.once('packet', function (msg) {
      if (failed) return;
      if ('pong' === msg.type && 'probe' === msg.data) {
        debug('probe transport "%s" pong', name);
        self.upgrading = true;
        self.emit('upgrading', transport);
        if (!transport) return;
        Socket.priorWebsocketSuccess = 'websocket' === transport.name;

        debug('pausing current transport "%s"', self.transport.name);
        self.transport.pause(function () {
          if (failed) return;
          if ('closed' === self.readyState) return;
          debug('changing transport and sending upgrade packet');

          cleanup();

          self.setTransport(transport);
          transport.send([{ type: 'upgrade' }]);
          self.emit('upgrade', transport);
          transport = null;
          self.upgrading = false;
          self.flush();
        });
      } else {
        debug('probe transport "%s" failed', name);
        var err = new Error('probe error');
        err.transport = transport.name;
        self.emit('upgradeError', err);
      }
    });
  }

  function freezeTransport () {
    if (failed) return;

    // Any callback called by transport should be ignored since now
    failed = true;

    cleanup();

    transport.close();
    transport = null;
  }

  // Handle any error that happens while probing
  function onerror (err) {
    var error = new Error('probe error: ' + err);
    error.transport = transport.name;

    freezeTransport();

    debug('probe transport "%s" failed because of error: %s', name, err);

    self.emit('upgradeError', error);
  }

  function onTransportClose () {
    onerror('transport closed');
  }

  // When the socket is closed while we're probing
  function onclose () {
    onerror('socket closed');
  }

  // When the socket is upgraded while we're probing
  function onupgrade (to) {
    if (transport && to.name !== transport.name) {
      debug('"%s" works - aborting "%s"', to.name, transport.name);
      freezeTransport();
    }
  }

  // Remove all listeners on the transport and on self
  function cleanup () {
    transport.removeListener('open', onTransportOpen);
    transport.removeListener('error', onerror);
    transport.removeListener('close', onTransportClose);
    self.removeListener('close', onclose);
    self.removeListener('upgrading', onupgrade);
  }

  transport.once('open', onTransportOpen);
  transport.once('error', onerror);
  transport.once('close', onTransportClose);

  this.once('close', onclose);
  this.once('upgrading', onupgrade);

  transport.open();
};

/**
 * Called when connection is deemed open.
 *
 * @api public
 */

Socket.prototype.onOpen = function () {
  debug('socket open');
  this.readyState = 'open';
  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
  this.emit('open');
  this.flush();

  // we check for `readyState` in case an `open`
  // listener already closed the socket
  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
    debug('starting upgrade probes');
    for (var i = 0, l = this.upgrades.length; i < l; i++) {
      this.probe(this.upgrades[i]);
    }
  }
};

/**
 * Handles a packet.
 *
 * @api private
 */

Socket.prototype.onPacket = function (packet) {
  if ('opening' === this.readyState || 'open' === this.readyState ||
      'closing' === this.readyState) {
    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);

    this.emit('packet', packet);

    // Socket is live - any packet counts
    this.emit('heartbeat');

    switch (packet.type) {
      case 'open':
        this.onHandshake(JSON.parse(packet.data));
        break;

      case 'pong':
        this.setPing();
        this.emit('pong');
        break;

      case 'error':
        var err = new Error('server error');
        err.code = packet.data;
        this.onError(err);
        break;

      case 'message':
        this.emit('data', packet.data);
        this.emit('message', packet.data);
        break;
    }
  } else {
    debug('packet received with socket readyState "%s"', this.readyState);
  }
};

/**
 * Called upon handshake completion.
 *
 * @param {Object} handshake obj
 * @api private
 */

Socket.prototype.onHandshake = function (data) {
  this.emit('handshake', data);
  this.id = data.sid;
  this.transport.query.sid = data.sid;
  this.upgrades = this.filterUpgrades(data.upgrades);
  this.pingInterval = data.pingInterval;
  this.pingTimeout = data.pingTimeout;
  this.onOpen();
  // In case open handler closes socket
  if ('closed' === this.readyState) return;
  this.setPing();

  // Prolong liveness of socket on heartbeat
  this.removeListener('heartbeat', this.onHeartbeat);
  this.on('heartbeat', this.onHeartbeat);
};

/**
 * Resets ping timeout.
 *
 * @api private
 */

Socket.prototype.onHeartbeat = function (timeout) {
  clearTimeout(this.pingTimeoutTimer);
  var self = this;
  self.pingTimeoutTimer = setTimeout(function () {
    if ('closed' === self.readyState) return;
    self.onClose('ping timeout');
  }, timeout || (self.pingInterval + self.pingTimeout));
};

/**
 * Pings server every `this.pingInterval` and expects response
 * within `this.pingTimeout` or closes connection.
 *
 * @api private
 */

Socket.prototype.setPing = function () {
  var self = this;
  clearTimeout(self.pingIntervalTimer);
  self.pingIntervalTimer = setTimeout(function () {
    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
    self.ping();
    self.onHeartbeat(self.pingTimeout);
  }, self.pingInterval);
};

/**
* Sends a ping packet.
*
* @api private
*/

Socket.prototype.ping = function () {
  var self = this;
  this.sendPacket('ping', function () {
    self.emit('ping');
  });
};

/**
 * Called on `drain` event
 *
 * @api private
 */

Socket.prototype.onDrain = function () {
  this.writeBuffer.splice(0, this.prevBufferLen);

  // setting prevBufferLen = 0 is very important
  // for example, when upgrading, upgrade packet is sent over,
  // and a nonzero prevBufferLen could cause problems on `drain`
  this.prevBufferLen = 0;

  if (0 === this.writeBuffer.length) {
    this.emit('drain');
  } else {
    this.flush();
  }
};

/**
 * Flush write buffers.
 *
 * @api private
 */

Socket.prototype.flush = function () {
  if ('closed' !== this.readyState && this.transport.writable &&
    !this.upgrading && this.writeBuffer.length) {
    debug('flushing %d packets in socket', this.writeBuffer.length);
    this.transport.send(this.writeBuffer);
    // keep track of current length of writeBuffer
    // splice writeBuffer and callbackBuffer on `drain`
    this.prevBufferLen = this.writeBuffer.length;
    this.emit('flush');
  }
};

/**
 * Sends a message.
 *
 * @param {String} message.
 * @param {Function} callback function.
 * @param {Object} options.
 * @return {Socket} for chaining.
 * @api public
 */

Socket.prototype.write =
Socket.prototype.send = function (msg, options, fn) {
  this.sendPacket('message', msg, options, fn);
  return this;
};

/**
 * Sends a packet.
 *
 * @param {String} packet type.
 * @param {String} data.
 * @param {Object} options.
 * @param {Function} callback function.
 * @api private
 */

Socket.prototype.sendPacket = function (type, data, options, fn) {
  if ('function' === typeof data) {
    fn = data;
    data = undefined;
  }

  if ('function' === typeof options) {
    fn = options;
    options = null;
  }

  if ('closing' === this.readyState || 'closed' === this.readyState) {
    return;
  }

  options = options || {};
  options.compress = false !== options.compress;

  var packet = {
    type: type,
    data: data,
    options: options
  };
  this.emit('packetCreate', packet);
  this.writeBuffer.push(packet);
  if (fn) this.once('flush', fn);
  this.flush();
};

/**
 * Closes the connection.
 *
 * @api private
 */

Socket.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.readyState = 'closing';

    var self = this;

    if (this.writeBuffer.length) {
      this.once('drain', function () {
        if (this.upgrading) {
          waitForUpgrade();
        } else {
          close();
        }
      });
    } else if (this.upgrading) {
      waitForUpgrade();
    } else {
      close();
    }
  }

  function close () {
    self.onClose('forced close');
    debug('socket closing - telling transport to close');
    self.transport.close();
  }

  function cleanupAndClose () {
    self.removeListener('upgrade', cleanupAndClose);
    self.removeListener('upgradeError', cleanupAndClose);
    close();
  }

  function waitForUpgrade () {
    // wait for upgrade to finish since we can't send packets while pausing a transport
    self.once('upgrade', cleanupAndClose);
    self.once('upgradeError', cleanupAndClose);
  }

  return this;
};

/**
 * Called upon transport error
 *
 * @api private
 */

Socket.prototype.onError = function (err) {
  debug('socket error %j', err);
  Socket.priorWebsocketSuccess = false;
  this.emit('error', err);
  this.onClose('transport error', err);
};

/**
 * Called upon transport close.
 *
 * @api private
 */

Socket.prototype.onClose = function (reason, desc) {
  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
    debug('socket close with reason: "%s"', reason);
    var self = this;

    // clear timers
    clearTimeout(this.pingIntervalTimer);
    clearTimeout(this.pingTimeoutTimer);

    // stop event from firing again for transport
    this.transport.removeAllListeners('close');

    // ensure transport won't stay open
    this.transport.close();

    // ignore further transport communication
    this.transport.removeAllListeners();

    // set ready state
    this.readyState = 'closed';

    // clear session id
    this.id = null;

    // emit close event
    this.emit('close', reason, desc);

    // clean buffers after, so users can still
    // grab the buffers on `close` event
    self.writeBuffer = [];
    self.prevBufferLen = 0;
  }
};

/**
 * Filters upgrades, returning only those matching client transports.
 *
 * @param {Array} server upgrades
 * @api private
 *
 */

Socket.prototype.filterUpgrades = function (upgrades) {
  var filteredUpgrades = [];
  for (var i = 0, j = upgrades.length; i < j; i++) {
    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
  }
  return filteredUpgrades;
};


/***/ }),

/***/ "./node_modules/engine.io-client/lib/transport.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var parser = __webpack_require__("./node_modules/engine.io-parser/lib/browser.js");
var Emitter = __webpack_require__("./node_modules/component-emitter/index.js");

/**
 * Module exports.
 */

module.exports = Transport;

/**
 * Transport abstract constructor.
 *
 * @param {Object} options.
 * @api private
 */

function Transport (opts) {
  this.path = opts.path;
  this.hostname = opts.hostname;
  this.port = opts.port;
  this.secure = opts.secure;
  this.query = opts.query;
  this.timestampParam = opts.timestampParam;
  this.timestampRequests = opts.timestampRequests;
  this.readyState = '';
  this.agent = opts.agent || false;
  this.socket = opts.socket;
  this.enablesXDR = opts.enablesXDR;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;
  this.forceNode = opts.forceNode;

  // results of ReactNative environment detection
  this.isReactNative = opts.isReactNative;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;
  this.localAddress = opts.localAddress;
}

/**
 * Mix in `Emitter`.
 */

Emitter(Transport.prototype);

/**
 * Emits an error.
 *
 * @param {String} str
 * @return {Transport} for chaining
 * @api public
 */

Transport.prototype.onError = function (msg, desc) {
  var err = new Error(msg);
  err.type = 'TransportError';
  err.description = desc;
  this.emit('error', err);
  return this;
};

/**
 * Opens the transport.
 *
 * @api public
 */

Transport.prototype.open = function () {
  if ('closed' === this.readyState || '' === this.readyState) {
    this.readyState = 'opening';
    this.doOpen();
  }

  return this;
};

/**
 * Closes the transport.
 *
 * @api private
 */

Transport.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.doClose();
    this.onClose();
  }

  return this;
};

/**
 * Sends multiple packets.
 *
 * @param {Array} packets
 * @api private
 */

Transport.prototype.send = function (packets) {
  if ('open' === this.readyState) {
    this.write(packets);
  } else {
    throw new Error('Transport not open');
  }
};

/**
 * Called upon open
 *
 * @api private
 */

Transport.prototype.onOpen = function () {
  this.readyState = 'open';
  this.writable = true;
  this.emit('open');
};

/**
 * Called with data.
 *
 * @param {String} data
 * @api private
 */

Transport.prototype.onData = function (data) {
  var packet = parser.decodePacket(data, this.socket.binaryType);
  this.onPacket(packet);
};

/**
 * Called with a decoded packet.
 */

Transport.prototype.onPacket = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon close.
 *
 * @api private
 */

Transport.prototype.onClose = function () {
  this.readyState = 'closed';
  this.emit('close');
};


/***/ }),

/***/ "./node_modules/engine.io-client/lib/transports/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var XMLHttpRequest = __webpack_require__("./node_modules/engine.io-client/lib/xmlhttprequest.js");
var XHR = __webpack_require__("./node_modules/engine.io-client/lib/transports/polling-xhr.js");
var JSONP = __webpack_require__("./node_modules/engine.io-client/lib/transports/polling-jsonp.js");
var websocket = __webpack_require__("./node_modules/engine.io-client/lib/transports/websocket.js");

/**
 * Export transports.
 */

exports.polling = polling;
exports.websocket = websocket;

/**
 * Polling transport polymorphic constructor.
 * Decides on xhr vs jsonp based on feature detection.
 *
 * @api private
 */

function polling (opts) {
  var xhr;
  var xd = false;
  var xs = false;
  var jsonp = false !== opts.jsonp;

  if (typeof location !== 'undefined') {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    xd = opts.hostname !== location.hostname || port !== opts.port;
    xs = opts.secure !== isSSL;
  }

  opts.xdomain = xd;
  opts.xscheme = xs;
  xhr = new XMLHttpRequest(opts);

  if ('open' in xhr && !opts.forceJSONP) {
    return new XHR(opts);
  } else {
    if (!jsonp) throw new Error('JSONP disabled');
    return new JSONP(opts);
  }
}


/***/ }),

/***/ "./node_modules/engine.io-client/lib/transports/polling-jsonp.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module requirements.
 */

var Polling = __webpack_require__("./node_modules/engine.io-client/lib/transports/polling.js");
var inherit = __webpack_require__("./node_modules/component-inherit/index.js");

/**
 * Module exports.
 */

module.exports = JSONPPolling;

/**
 * Cached regular expressions.
 */

var rNewline = /\n/g;
var rEscapedNewline = /\\n/g;

/**
 * Global JSONP callbacks.
 */

var callbacks;

/**
 * Noop.
 */

function empty () { }

/**
 * Until https://github.com/tc39/proposal-global is shipped.
 */
function glob () {
  return typeof self !== 'undefined' ? self
      : typeof window !== 'undefined' ? window
      : typeof global !== 'undefined' ? global : {};
}

/**
 * JSONP Polling constructor.
 *
 * @param {Object} opts.
 * @api public
 */

function JSONPPolling (opts) {
  Polling.call(this, opts);

  this.query = this.query || {};

  // define global callbacks array if not present
  // we do this here (lazily) to avoid unneeded global pollution
  if (!callbacks) {
    // we need to consider multiple engines in the same page
    var global = glob();
    callbacks = global.___eio = (global.___eio || []);
  }

  // callback identifier
  this.index = callbacks.length;

  // add callback to jsonp global
  var self = this;
  callbacks.push(function (msg) {
    self.onData(msg);
  });

  // append to query string
  this.query.j = this.index;

  // prevent spurious errors from being emitted when the window is unloaded
  if (typeof addEventListener === 'function') {
    addEventListener('beforeunload', function () {
      if (self.script) self.script.onerror = empty;
    }, false);
  }
}

/**
 * Inherits from Polling.
 */

inherit(JSONPPolling, Polling);

/*
 * JSONP only supports binary as base64 encoded strings
 */

JSONPPolling.prototype.supportsBinary = false;

/**
 * Closes the socket.
 *
 * @api private
 */

JSONPPolling.prototype.doClose = function () {
  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  if (this.form) {
    this.form.parentNode.removeChild(this.form);
    this.form = null;
    this.iframe = null;
  }

  Polling.prototype.doClose.call(this);
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

JSONPPolling.prototype.doPoll = function () {
  var self = this;
  var script = document.createElement('script');

  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  script.async = true;
  script.src = this.uri();
  script.onerror = function (e) {
    self.onError('jsonp poll error', e);
  };

  var insertAt = document.getElementsByTagName('script')[0];
  if (insertAt) {
    insertAt.parentNode.insertBefore(script, insertAt);
  } else {
    (document.head || document.body).appendChild(script);
  }
  this.script = script;

  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);

  if (isUAgecko) {
    setTimeout(function () {
      var iframe = document.createElement('iframe');
      document.body.appendChild(iframe);
      document.body.removeChild(iframe);
    }, 100);
  }
};

/**
 * Writes with a hidden iframe.
 *
 * @param {String} data to send
 * @param {Function} called upon flush.
 * @api private
 */

JSONPPolling.prototype.doWrite = function (data, fn) {
  var self = this;

  if (!this.form) {
    var form = document.createElement('form');
    var area = document.createElement('textarea');
    var id = this.iframeId = 'eio_iframe_' + this.index;
    var iframe;

    form.className = 'socketio';
    form.style.position = 'absolute';
    form.style.top = '-1000px';
    form.style.left = '-1000px';
    form.target = id;
    form.method = 'POST';
    form.setAttribute('accept-charset', 'utf-8');
    area.name = 'd';
    form.appendChild(area);
    document.body.appendChild(form);

    this.form = form;
    this.area = area;
  }

  this.form.action = this.uri();

  function complete () {
    initIframe();
    fn();
  }

  function initIframe () {
    if (self.iframe) {
      try {
        self.form.removeChild(self.iframe);
      } catch (e) {
        self.onError('jsonp polling iframe removal error', e);
      }
    }

    try {
      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
      iframe = document.createElement(html);
    } catch (e) {
      iframe = document.createElement('iframe');
      iframe.name = self.iframeId;
      iframe.src = 'javascript:0';
    }

    iframe.id = self.iframeId;

    self.form.appendChild(iframe);
    self.iframe = iframe;
  }

  initIframe();

  // escape \n to prevent it from being converted into \r\n by some UAs
  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
  data = data.replace(rEscapedNewline, '\\\n');
  this.area.value = data.replace(rNewline, '\\n');

  try {
    this.form.submit();
  } catch (e) {}

  if (this.iframe.attachEvent) {
    this.iframe.onreadystatechange = function () {
      if (self.iframe.readyState === 'complete') {
        complete();
      }
    };
  } else {
    this.iframe.onload = complete;
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/engine.io-client/lib/transports/polling-xhr.js":
/***/ (function(module, exports, __webpack_require__) {

/* global attachEvent */

/**
 * Module requirements.
 */

var XMLHttpRequest = __webpack_require__("./node_modules/engine.io-client/lib/xmlhttprequest.js");
var Polling = __webpack_require__("./node_modules/engine.io-client/lib/transports/polling.js");
var Emitter = __webpack_require__("./node_modules/component-emitter/index.js");
var inherit = __webpack_require__("./node_modules/component-inherit/index.js");
var debug = __webpack_require__("./node_modules/debug/src/browser.js")('engine.io-client:polling-xhr');

/**
 * Module exports.
 */

module.exports = XHR;
module.exports.Request = Request;

/**
 * Empty function
 */

function empty () {}

/**
 * XHR Polling constructor.
 *
 * @param {Object} opts
 * @api public
 */

function XHR (opts) {
  Polling.call(this, opts);
  this.requestTimeout = opts.requestTimeout;
  this.extraHeaders = opts.extraHeaders;

  if (typeof location !== 'undefined') {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    this.xd = (typeof location !== 'undefined' && opts.hostname !== location.hostname) ||
      port !== opts.port;
    this.xs = opts.secure !== isSSL;
  }
}

/**
 * Inherits from Polling.
 */

inherit(XHR, Polling);

/**
 * XHR supports binary
 */

XHR.prototype.supportsBinary = true;

/**
 * Creates a request.
 *
 * @param {String} method
 * @api private
 */

XHR.prototype.request = function (opts) {
  opts = opts || {};
  opts.uri = this.uri();
  opts.xd = this.xd;
  opts.xs = this.xs;
  opts.agent = this.agent || false;
  opts.supportsBinary = this.supportsBinary;
  opts.enablesXDR = this.enablesXDR;

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  opts.requestTimeout = this.requestTimeout;

  // other options for Node.js client
  opts.extraHeaders = this.extraHeaders;

  return new Request(opts);
};

/**
 * Sends data.
 *
 * @param {String} data to send.
 * @param {Function} called upon flush.
 * @api private
 */

XHR.prototype.doWrite = function (data, fn) {
  var isBinary = typeof data !== 'string' && data !== undefined;
  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
  var self = this;
  req.on('success', fn);
  req.on('error', function (err) {
    self.onError('xhr post error', err);
  });
  this.sendXhr = req;
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

XHR.prototype.doPoll = function () {
  debug('xhr poll');
  var req = this.request();
  var self = this;
  req.on('data', function (data) {
    self.onData(data);
  });
  req.on('error', function (err) {
    self.onError('xhr poll error', err);
  });
  this.pollXhr = req;
};

/**
 * Request constructor
 *
 * @param {Object} options
 * @api public
 */

function Request (opts) {
  this.method = opts.method || 'GET';
  this.uri = opts.uri;
  this.xd = !!opts.xd;
  this.xs = !!opts.xs;
  this.async = false !== opts.async;
  this.data = undefined !== opts.data ? opts.data : null;
  this.agent = opts.agent;
  this.isBinary = opts.isBinary;
  this.supportsBinary = opts.supportsBinary;
  this.enablesXDR = opts.enablesXDR;
  this.requestTimeout = opts.requestTimeout;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;

  this.create();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Request.prototype);

/**
 * Creates the XHR object and sends the request.
 *
 * @api private
 */

Request.prototype.create = function () {
  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;

  var xhr = this.xhr = new XMLHttpRequest(opts);
  var self = this;

  try {
    debug('xhr open %s: %s', this.method, this.uri);
    xhr.open(this.method, this.uri, this.async);
    try {
      if (this.extraHeaders) {
        xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
        for (var i in this.extraHeaders) {
          if (this.extraHeaders.hasOwnProperty(i)) {
            xhr.setRequestHeader(i, this.extraHeaders[i]);
          }
        }
      }
    } catch (e) {}

    if ('POST' === this.method) {
      try {
        if (this.isBinary) {
          xhr.setRequestHeader('Content-type', 'application/octet-stream');
        } else {
          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
        }
      } catch (e) {}
    }

    try {
      xhr.setRequestHeader('Accept', '*/*');
    } catch (e) {}

    // ie6 check
    if ('withCredentials' in xhr) {
      xhr.withCredentials = true;
    }

    if (this.requestTimeout) {
      xhr.timeout = this.requestTimeout;
    }

    if (this.hasXDR()) {
      xhr.onload = function () {
        self.onLoad();
      };
      xhr.onerror = function () {
        self.onError(xhr.responseText);
      };
    } else {
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 2) {
          try {
            var contentType = xhr.getResponseHeader('Content-Type');
            if (self.supportsBinary && contentType === 'application/octet-stream') {
              xhr.responseType = 'arraybuffer';
            }
          } catch (e) {}
        }
        if (4 !== xhr.readyState) return;
        if (200 === xhr.status || 1223 === xhr.status) {
          self.onLoad();
        } else {
          // make sure the `error` event handler that's user-set
          // does not throw in the same tick and gets caught here
          setTimeout(function () {
            self.onError(xhr.status);
          }, 0);
        }
      };
    }

    debug('xhr data %s', this.data);
    xhr.send(this.data);
  } catch (e) {
    // Need to defer since .create() is called directly fhrom the constructor
    // and thus the 'error' event can only be only bound *after* this exception
    // occurs.  Therefore, also, we cannot throw here at all.
    setTimeout(function () {
      self.onError(e);
    }, 0);
    return;
  }

  if (typeof document !== 'undefined') {
    this.index = Request.requestsCount++;
    Request.requests[this.index] = this;
  }
};

/**
 * Called upon successful response.
 *
 * @api private
 */

Request.prototype.onSuccess = function () {
  this.emit('success');
  this.cleanup();
};

/**
 * Called if we have data.
 *
 * @api private
 */

Request.prototype.onData = function (data) {
  this.emit('data', data);
  this.onSuccess();
};

/**
 * Called upon error.
 *
 * @api private
 */

Request.prototype.onError = function (err) {
  this.emit('error', err);
  this.cleanup(true);
};

/**
 * Cleans up house.
 *
 * @api private
 */

Request.prototype.cleanup = function (fromError) {
  if ('undefined' === typeof this.xhr || null === this.xhr) {
    return;
  }
  // xmlhttprequest
  if (this.hasXDR()) {
    this.xhr.onload = this.xhr.onerror = empty;
  } else {
    this.xhr.onreadystatechange = empty;
  }

  if (fromError) {
    try {
      this.xhr.abort();
    } catch (e) {}
  }

  if (typeof document !== 'undefined') {
    delete Request.requests[this.index];
  }

  this.xhr = null;
};

/**
 * Called upon load.
 *
 * @api private
 */

Request.prototype.onLoad = function () {
  var data;
  try {
    var contentType;
    try {
      contentType = this.xhr.getResponseHeader('Content-Type');
    } catch (e) {}
    if (contentType === 'application/octet-stream') {
      data = this.xhr.response || this.xhr.responseText;
    } else {
      data = this.xhr.responseText;
    }
  } catch (e) {
    this.onError(e);
  }
  if (null != data) {
    this.onData(data);
  }
};

/**
 * Check if it has XDomainRequest.
 *
 * @api private
 */

Request.prototype.hasXDR = function () {
  return typeof XDomainRequest !== 'undefined' && !this.xs && this.enablesXDR;
};

/**
 * Aborts the request.
 *
 * @api public
 */

Request.prototype.abort = function () {
  this.cleanup();
};

/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */

Request.requestsCount = 0;
Request.requests = {};

if (typeof document !== 'undefined') {
  if (typeof attachEvent === 'function') {
    attachEvent('onunload', unloadHandler);
  } else if (typeof addEventListener === 'function') {
    var terminationEvent = 'onpagehide' in self ? 'pagehide' : 'unload';
    addEventListener(terminationEvent, unloadHandler, false);
  }
}

function unloadHandler () {
  for (var i in Request.requests) {
    if (Request.requests.hasOwnProperty(i)) {
      Request.requests[i].abort();
    }
  }
}


/***/ }),

/***/ "./node_modules/engine.io-client/lib/transports/polling.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var Transport = __webpack_require__("./node_modules/engine.io-client/lib/transport.js");
var parseqs = __webpack_require__("./node_modules/parseqs/index.js");
var parser = __webpack_require__("./node_modules/engine.io-parser/lib/browser.js");
var inherit = __webpack_require__("./node_modules/component-inherit/index.js");
var yeast = __webpack_require__("./node_modules/yeast/index.js");
var debug = __webpack_require__("./node_modules/debug/src/browser.js")('engine.io-client:polling');

/**
 * Module exports.
 */

module.exports = Polling;

/**
 * Is XHR2 supported?
 */

var hasXHR2 = (function () {
  var XMLHttpRequest = __webpack_require__("./node_modules/engine.io-client/lib/xmlhttprequest.js");
  var xhr = new XMLHttpRequest({ xdomain: false });
  return null != xhr.responseType;
})();

/**
 * Polling interface.
 *
 * @param {Object} opts
 * @api private
 */

function Polling (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (!hasXHR2 || forceBase64) {
    this.supportsBinary = false;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(Polling, Transport);

/**
 * Transport name.
 */

Polling.prototype.name = 'polling';

/**
 * Opens the socket (triggers polling). We write a PING message to determine
 * when the transport is open.
 *
 * @api private
 */

Polling.prototype.doOpen = function () {
  this.poll();
};

/**
 * Pauses polling.
 *
 * @param {Function} callback upon buffers are flushed and transport is paused
 * @api private
 */

Polling.prototype.pause = function (onPause) {
  var self = this;

  this.readyState = 'pausing';

  function pause () {
    debug('paused');
    self.readyState = 'paused';
    onPause();
  }

  if (this.polling || !this.writable) {
    var total = 0;

    if (this.polling) {
      debug('we are currently polling - waiting to pause');
      total++;
      this.once('pollComplete', function () {
        debug('pre-pause polling complete');
        --total || pause();
      });
    }

    if (!this.writable) {
      debug('we are currently writing - waiting to pause');
      total++;
      this.once('drain', function () {
        debug('pre-pause writing complete');
        --total || pause();
      });
    }
  } else {
    pause();
  }
};

/**
 * Starts polling cycle.
 *
 * @api public
 */

Polling.prototype.poll = function () {
  debug('polling');
  this.polling = true;
  this.doPoll();
  this.emit('poll');
};

/**
 * Overloads onData to detect payloads.
 *
 * @api private
 */

Polling.prototype.onData = function (data) {
  var self = this;
  debug('polling got data %s', data);
  var callback = function (packet, index, total) {
    // if its the first message we consider the transport open
    if ('opening' === self.readyState) {
      self.onOpen();
    }

    // if its a close packet, we close the ongoing requests
    if ('close' === packet.type) {
      self.onClose();
      return false;
    }

    // otherwise bypass onData and handle the message
    self.onPacket(packet);
  };

  // decode payload
  parser.decodePayload(data, this.socket.binaryType, callback);

  // if an event did not trigger closing
  if ('closed' !== this.readyState) {
    // if we got data we're not polling
    this.polling = false;
    this.emit('pollComplete');

    if ('open' === this.readyState) {
      this.poll();
    } else {
      debug('ignoring poll - transport state "%s"', this.readyState);
    }
  }
};

/**
 * For polling, send a close packet.
 *
 * @api private
 */

Polling.prototype.doClose = function () {
  var self = this;

  function close () {
    debug('writing close packet');
    self.write([{ type: 'close' }]);
  }

  if ('open' === this.readyState) {
    debug('transport open - closing');
    close();
  } else {
    // in case we're trying to close while
    // handshaking is in progress (GH-164)
    debug('transport not open - deferring close');
    this.once('open', close);
  }
};

/**
 * Writes a packets payload.
 *
 * @param {Array} data packets
 * @param {Function} drain callback
 * @api private
 */

Polling.prototype.write = function (packets) {
  var self = this;
  this.writable = false;
  var callbackfn = function () {
    self.writable = true;
    self.emit('drain');
  };

  parser.encodePayload(packets, this.supportsBinary, function (data) {
    self.doWrite(data, callbackfn);
  });
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

Polling.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'https' : 'http';
  var port = '';

  // cache busting is forced
  if (false !== this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  if (!this.supportsBinary && !query.sid) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // avoid port if default for schema
  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
     ('http' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};


/***/ }),

/***/ "./node_modules/engine.io-client/lib/transports/websocket.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/**
 * Module dependencies.
 */

var Transport = __webpack_require__("./node_modules/engine.io-client/lib/transport.js");
var parser = __webpack_require__("./node_modules/engine.io-parser/lib/browser.js");
var parseqs = __webpack_require__("./node_modules/parseqs/index.js");
var inherit = __webpack_require__("./node_modules/component-inherit/index.js");
var yeast = __webpack_require__("./node_modules/yeast/index.js");
var debug = __webpack_require__("./node_modules/debug/src/browser.js")('engine.io-client:websocket');

var BrowserWebSocket, NodeWebSocket;

if (typeof WebSocket !== 'undefined') {
  BrowserWebSocket = WebSocket;
} else if (typeof self !== 'undefined') {
  BrowserWebSocket = self.WebSocket || self.MozWebSocket;
} else {
  try {
    NodeWebSocket = __webpack_require__(1);
  } catch (e) { }
}

/**
 * Get either the `WebSocket` or `MozWebSocket` globals
 * in the browser or try to resolve WebSocket-compatible
 * interface exposed by `ws` for Node-like environment.
 */

var WebSocketImpl = BrowserWebSocket || NodeWebSocket;

/**
 * Module exports.
 */

module.exports = WS;

/**
 * WebSocket transport constructor.
 *
 * @api {Object} connection options
 * @api public
 */

function WS (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (forceBase64) {
    this.supportsBinary = false;
  }
  this.perMessageDeflate = opts.perMessageDeflate;
  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
  this.protocols = opts.protocols;
  if (!this.usingBrowserWebSocket) {
    WebSocketImpl = NodeWebSocket;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(WS, Transport);

/**
 * Transport name.
 *
 * @api public
 */

WS.prototype.name = 'websocket';

/*
 * WebSockets support binary
 */

WS.prototype.supportsBinary = true;

/**
 * Opens socket.
 *
 * @api private
 */

WS.prototype.doOpen = function () {
  if (!this.check()) {
    // let probe timeout
    return;
  }

  var uri = this.uri();
  var protocols = this.protocols;
  var opts = {
    agent: this.agent,
    perMessageDeflate: this.perMessageDeflate
  };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  if (this.extraHeaders) {
    opts.headers = this.extraHeaders;
  }
  if (this.localAddress) {
    opts.localAddress = this.localAddress;
  }

  try {
    this.ws =
      this.usingBrowserWebSocket && !this.isReactNative
        ? protocols
          ? new WebSocketImpl(uri, protocols)
          : new WebSocketImpl(uri)
        : new WebSocketImpl(uri, protocols, opts);
  } catch (err) {
    return this.emit('error', err);
  }

  if (this.ws.binaryType === undefined) {
    this.supportsBinary = false;
  }

  if (this.ws.supports && this.ws.supports.binary) {
    this.supportsBinary = true;
    this.ws.binaryType = 'nodebuffer';
  } else {
    this.ws.binaryType = 'arraybuffer';
  }

  this.addEventListeners();
};

/**
 * Adds event listeners to the socket
 *
 * @api private
 */

WS.prototype.addEventListeners = function () {
  var self = this;

  this.ws.onopen = function () {
    self.onOpen();
  };
  this.ws.onclose = function () {
    self.onClose();
  };
  this.ws.onmessage = function (ev) {
    self.onData(ev.data);
  };
  this.ws.onerror = function (e) {
    self.onError('websocket error', e);
  };
};

/**
 * Writes data to socket.
 *
 * @param {Array} array of packets.
 * @api private
 */

WS.prototype.write = function (packets) {
  var self = this;
  this.writable = false;

  // encodePacket efficient as it uses WS framing
  // no need for encodePayload
  var total = packets.length;
  for (var i = 0, l = total; i < l; i++) {
    (function (packet) {
      parser.encodePacket(packet, self.supportsBinary, function (data) {
        if (!self.usingBrowserWebSocket) {
          // always create a new object (GH-437)
          var opts = {};
          if (packet.options) {
            opts.compress = packet.options.compress;
          }

          if (self.perMessageDeflate) {
            var len = 'string' === typeof data ? Buffer.byteLength(data) : data.length;
            if (len < self.perMessageDeflate.threshold) {
              opts.compress = false;
            }
          }
        }

        // Sometimes the websocket has already been closed but the browser didn't
        // have a chance of informing us about it yet, in that case send will
        // throw an error
        try {
          if (self.usingBrowserWebSocket) {
            // TypeError is thrown when passing the second argument on Safari
            self.ws.send(data);
          } else {
            self.ws.send(data, opts);
          }
        } catch (e) {
          debug('websocket closed before onclose event');
        }

        --total || done();
      });
    })(packets[i]);
  }

  function done () {
    self.emit('flush');

    // fake drain
    // defer to next tick to allow Socket to clear writeBuffer
    setTimeout(function () {
      self.writable = true;
      self.emit('drain');
    }, 0);
  }
};

/**
 * Called upon close
 *
 * @api private
 */

WS.prototype.onClose = function () {
  Transport.prototype.onClose.call(this);
};

/**
 * Closes socket.
 *
 * @api private
 */

WS.prototype.doClose = function () {
  if (typeof this.ws !== 'undefined') {
    this.ws.close();
  }
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

WS.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'wss' : 'ws';
  var port = '';

  // avoid port if default for schema
  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
    ('ws' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // append timestamp to URI
  if (this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  // communicate binary support capabilities
  if (!this.supportsBinary) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};

/**
 * Feature detection for WebSocket.
 *
 * @return {Boolean} whether this transport is available.
 * @api public
 */

WS.prototype.check = function () {
  return !!WebSocketImpl && !('__initialize' in WebSocketImpl && this.name === WS.prototype.name);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/engine.io-client/lib/xmlhttprequest.js":
/***/ (function(module, exports, __webpack_require__) {

// browser shim for xmlhttprequest module

var hasCORS = __webpack_require__("./node_modules/has-cors/index.js");

module.exports = function (opts) {
  var xdomain = opts.xdomain;

  // scheme must be same when usign XDomainRequest
  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
  var xscheme = opts.xscheme;

  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
  // https://github.com/Automattic/engine.io-client/pull/217
  var enablesXDR = opts.enablesXDR;

  // XMLHttpRequest can be disabled on IE
  try {
    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
      return new XMLHttpRequest();
    }
  } catch (e) { }

  // Use XDomainRequest for IE8 if enablesXDR is true
  // because loading bar keeps flashing when using jsonp-polling
  // https://github.com/yujiosaka/socke.io-ie8-loading-example
  try {
    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
      return new XDomainRequest();
    }
  } catch (e) { }

  if (!xdomain) {
    try {
      return new self[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
    } catch (e) { }
  }
};


/***/ }),

/***/ "./node_modules/engine.io-parser/lib/browser.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module dependencies.
 */

var keys = __webpack_require__("./node_modules/engine.io-parser/lib/keys.js");
var hasBinary = __webpack_require__("./node_modules/has-binary2/index.js");
var sliceBuffer = __webpack_require__("./node_modules/arraybuffer.slice/index.js");
var after = __webpack_require__("./node_modules/after/index.js");
var utf8 = __webpack_require__("./node_modules/engine.io-parser/lib/utf8.js");

var base64encoder;
if (global && global.ArrayBuffer) {
  base64encoder = __webpack_require__("./node_modules/base64-arraybuffer/lib/base64-arraybuffer.js");
}

/**
 * Check if we are running an android browser. That requires us to use
 * ArrayBuffer with polling transports...
 *
 * http://ghinda.net/jpeg-blob-ajax-android/
 */

var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);

/**
 * Check if we are running in PhantomJS.
 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
 * https://github.com/ariya/phantomjs/issues/11395
 * @type boolean
 */
var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);

/**
 * When true, avoids using Blobs to encode payloads.
 * @type boolean
 */
var dontSendBlobs = isAndroid || isPhantomJS;

/**
 * Current protocol version.
 */

exports.protocol = 3;

/**
 * Packet types.
 */

var packets = exports.packets = {
    open:     0    // non-ws
  , close:    1    // non-ws
  , ping:     2
  , pong:     3
  , message:  4
  , upgrade:  5
  , noop:     6
};

var packetslist = keys(packets);

/**
 * Premade error packet.
 */

var err = { type: 'error', data: 'parser error' };

/**
 * Create a blob api even for blob builder when vendor prefixes exist
 */

var Blob = __webpack_require__("./node_modules/blob/index.js");

/**
 * Encodes a packet.
 *
 *     <packet type id> [ <data> ]
 *
 * Example:
 *
 *     5hello world
 *     3
 *     4
 *
 * Binary is encoded in an identical principle
 *
 * @api private
 */

exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
  if (typeof supportsBinary === 'function') {
    callback = supportsBinary;
    supportsBinary = false;
  }

  if (typeof utf8encode === 'function') {
    callback = utf8encode;
    utf8encode = null;
  }

  var data = (packet.data === undefined)
    ? undefined
    : packet.data.buffer || packet.data;

  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
    return encodeArrayBuffer(packet, supportsBinary, callback);
  } else if (Blob && data instanceof global.Blob) {
    return encodeBlob(packet, supportsBinary, callback);
  }

  // might be an object with { base64: true, data: dataAsBase64String }
  if (data && data.base64) {
    return encodeBase64Object(packet, callback);
  }

  // Sending data as a utf-8 string
  var encoded = packets[packet.type];

  // data fragment is optional
  if (undefined !== packet.data) {
    encoded += utf8encode ? utf8.encode(String(packet.data), { strict: false }) : String(packet.data);
  }

  return callback('' + encoded);

};

function encodeBase64Object(packet, callback) {
  // packet data is an object { base64: true, data: dataAsBase64String }
  var message = 'b' + exports.packets[packet.type] + packet.data.data;
  return callback(message);
}

/**
 * Encode packet helpers for binary types
 */

function encodeArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var data = packet.data;
  var contentArray = new Uint8Array(data);
  var resultBuffer = new Uint8Array(1 + data.byteLength);

  resultBuffer[0] = packets[packet.type];
  for (var i = 0; i < contentArray.length; i++) {
    resultBuffer[i+1] = contentArray[i];
  }

  return callback(resultBuffer.buffer);
}

function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var fr = new FileReader();
  fr.onload = function() {
    packet.data = fr.result;
    exports.encodePacket(packet, supportsBinary, true, callback);
  };
  return fr.readAsArrayBuffer(packet.data);
}

function encodeBlob(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  if (dontSendBlobs) {
    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
  }

  var length = new Uint8Array(1);
  length[0] = packets[packet.type];
  var blob = new Blob([length.buffer, packet.data]);

  return callback(blob);
}

/**
 * Encodes a packet with binary data in a base64 string
 *
 * @param {Object} packet, has `type` and `data`
 * @return {String} base64 encoded message
 */

exports.encodeBase64Packet = function(packet, callback) {
  var message = 'b' + exports.packets[packet.type];
  if (Blob && packet.data instanceof global.Blob) {
    var fr = new FileReader();
    fr.onload = function() {
      var b64 = fr.result.split(',')[1];
      callback(message + b64);
    };
    return fr.readAsDataURL(packet.data);
  }

  var b64data;
  try {
    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
  } catch (e) {
    // iPhone Safari doesn't let you apply with typed arrays
    var typed = new Uint8Array(packet.data);
    var basic = new Array(typed.length);
    for (var i = 0; i < typed.length; i++) {
      basic[i] = typed[i];
    }
    b64data = String.fromCharCode.apply(null, basic);
  }
  message += global.btoa(b64data);
  return callback(message);
};

/**
 * Decodes a packet. Changes format to Blob if requested.
 *
 * @return {Object} with `type` and `data` (if any)
 * @api private
 */

exports.decodePacket = function (data, binaryType, utf8decode) {
  if (data === undefined) {
    return err;
  }
  // String data
  if (typeof data === 'string') {
    if (data.charAt(0) === 'b') {
      return exports.decodeBase64Packet(data.substr(1), binaryType);
    }

    if (utf8decode) {
      data = tryDecode(data);
      if (data === false) {
        return err;
      }
    }
    var type = data.charAt(0);

    if (Number(type) != type || !packetslist[type]) {
      return err;
    }

    if (data.length > 1) {
      return { type: packetslist[type], data: data.substring(1) };
    } else {
      return { type: packetslist[type] };
    }
  }

  var asArray = new Uint8Array(data);
  var type = asArray[0];
  var rest = sliceBuffer(data, 1);
  if (Blob && binaryType === 'blob') {
    rest = new Blob([rest]);
  }
  return { type: packetslist[type], data: rest };
};

function tryDecode(data) {
  try {
    data = utf8.decode(data, { strict: false });
  } catch (e) {
    return false;
  }
  return data;
}

/**
 * Decodes a packet encoded in a base64 string
 *
 * @param {String} base64 encoded message
 * @return {Object} with `type` and `data` (if any)
 */

exports.decodeBase64Packet = function(msg, binaryType) {
  var type = packetslist[msg.charAt(0)];
  if (!base64encoder) {
    return { type: type, data: { base64: true, data: msg.substr(1) } };
  }

  var data = base64encoder.decode(msg.substr(1));

  if (binaryType === 'blob' && Blob) {
    data = new Blob([data]);
  }

  return { type: type, data: data };
};

/**
 * Encodes multiple messages (payload).
 *
 *     <length>:data
 *
 * Example:
 *
 *     11:hello world2:hi
 *
 * If any contents are binary, they will be encoded as base64 strings. Base64
 * encoded strings are marked with a b before the length specifier
 *
 * @param {Array} packets
 * @api private
 */

exports.encodePayload = function (packets, supportsBinary, callback) {
  if (typeof supportsBinary === 'function') {
    callback = supportsBinary;
    supportsBinary = null;
  }

  var isBinary = hasBinary(packets);

  if (supportsBinary && isBinary) {
    if (Blob && !dontSendBlobs) {
      return exports.encodePayloadAsBlob(packets, callback);
    }

    return exports.encodePayloadAsArrayBuffer(packets, callback);
  }

  if (!packets.length) {
    return callback('0:');
  }

  function setLengthHeader(message) {
    return message.length + ':' + message;
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, !isBinary ? false : supportsBinary, false, function(message) {
      doneCallback(null, setLengthHeader(message));
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(results.join(''));
  });
};

/**
 * Async array map using after
 */

function map(ary, each, done) {
  var result = new Array(ary.length);
  var next = after(ary.length, done);

  var eachWithIndex = function(i, el, cb) {
    each(el, function(error, msg) {
      result[i] = msg;
      cb(error, result);
    });
  };

  for (var i = 0; i < ary.length; i++) {
    eachWithIndex(i, ary[i], next);
  }
}

/*
 * Decodes data when a payload is maybe expected. Possible binary contents are
 * decoded from their base64 representation
 *
 * @param {String} data, callback method
 * @api public
 */

exports.decodePayload = function (data, binaryType, callback) {
  if (typeof data !== 'string') {
    return exports.decodePayloadAsBinary(data, binaryType, callback);
  }

  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var packet;
  if (data === '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

  var length = '', n, msg;

  for (var i = 0, l = data.length; i < l; i++) {
    var chr = data.charAt(i);

    if (chr !== ':') {
      length += chr;
      continue;
    }

    if (length === '' || (length != (n = Number(length)))) {
      // parser error - ignoring payload
      return callback(err, 0, 1);
    }

    msg = data.substr(i + 1, n);

    if (length != msg.length) {
      // parser error - ignoring payload
      return callback(err, 0, 1);
    }

    if (msg.length) {
      packet = exports.decodePacket(msg, binaryType, false);

      if (err.type === packet.type && err.data === packet.data) {
        // parser error in individual packet - ignoring payload
        return callback(err, 0, 1);
      }

      var ret = callback(packet, i + n, l);
      if (false === ret) return;
    }

    // advance cursor
    i += n;
    length = '';
  }

  if (length !== '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

};

/**
 * Encodes multiple messages (payload) as binary.
 *
 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
 * 255><data>
 *
 * Example:
 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
 *
 * @param {Array} packets
 * @return {ArrayBuffer} encoded payload
 * @api private
 */

exports.encodePayloadAsArrayBuffer = function(packets, callback) {
  if (!packets.length) {
    return callback(new ArrayBuffer(0));
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(data) {
      return doneCallback(null, data);
    });
  }

  map(packets, encodeOne, function(err, encodedPackets) {
    var totalLength = encodedPackets.reduce(function(acc, p) {
      var len;
      if (typeof p === 'string'){
        len = p.length;
      } else {
        len = p.byteLength;
      }
      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
    }, 0);

    var resultArray = new Uint8Array(totalLength);

    var bufferIndex = 0;
    encodedPackets.forEach(function(p) {
      var isString = typeof p === 'string';
      var ab = p;
      if (isString) {
        var view = new Uint8Array(p.length);
        for (var i = 0; i < p.length; i++) {
          view[i] = p.charCodeAt(i);
        }
        ab = view.buffer;
      }

      if (isString) { // not true binary
        resultArray[bufferIndex++] = 0;
      } else { // true binary
        resultArray[bufferIndex++] = 1;
      }

      var lenStr = ab.byteLength.toString();
      for (var i = 0; i < lenStr.length; i++) {
        resultArray[bufferIndex++] = parseInt(lenStr[i]);
      }
      resultArray[bufferIndex++] = 255;

      var view = new Uint8Array(ab);
      for (var i = 0; i < view.length; i++) {
        resultArray[bufferIndex++] = view[i];
      }
    });

    return callback(resultArray.buffer);
  });
};

/**
 * Encode as Blob
 */

exports.encodePayloadAsBlob = function(packets, callback) {
  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(encoded) {
      var binaryIdentifier = new Uint8Array(1);
      binaryIdentifier[0] = 1;
      if (typeof encoded === 'string') {
        var view = new Uint8Array(encoded.length);
        for (var i = 0; i < encoded.length; i++) {
          view[i] = encoded.charCodeAt(i);
        }
        encoded = view.buffer;
        binaryIdentifier[0] = 0;
      }

      var len = (encoded instanceof ArrayBuffer)
        ? encoded.byteLength
        : encoded.size;

      var lenStr = len.toString();
      var lengthAry = new Uint8Array(lenStr.length + 1);
      for (var i = 0; i < lenStr.length; i++) {
        lengthAry[i] = parseInt(lenStr[i]);
      }
      lengthAry[lenStr.length] = 255;

      if (Blob) {
        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
        doneCallback(null, blob);
      }
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(new Blob(results));
  });
};

/*
 * Decodes data when a payload is maybe expected. Strings are decoded by
 * interpreting each byte as a key code for entries marked to start with 0. See
 * description of encodePayloadAsBinary
 *
 * @param {ArrayBuffer} data, callback method
 * @api public
 */

exports.decodePayloadAsBinary = function (data, binaryType, callback) {
  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var bufferTail = data;
  var buffers = [];

  while (bufferTail.byteLength > 0) {
    var tailArray = new Uint8Array(bufferTail);
    var isString = tailArray[0] === 0;
    var msgLength = '';

    for (var i = 1; ; i++) {
      if (tailArray[i] === 255) break;

      // 310 = char length of Number.MAX_VALUE
      if (msgLength.length > 310) {
        return callback(err, 0, 1);
      }

      msgLength += tailArray[i];
    }

    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
    msgLength = parseInt(msgLength);

    var msg = sliceBuffer(bufferTail, 0, msgLength);
    if (isString) {
      try {
        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
      } catch (e) {
        // iPhone Safari doesn't let you apply to typed arrays
        var typed = new Uint8Array(msg);
        msg = '';
        for (var i = 0; i < typed.length; i++) {
          msg += String.fromCharCode(typed[i]);
        }
      }
    }

    buffers.push(msg);
    bufferTail = sliceBuffer(bufferTail, msgLength);
  }

  var total = buffers.length;
  buffers.forEach(function(buffer, i) {
    callback(exports.decodePacket(buffer, binaryType, true), i, total);
  });
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/engine.io-parser/lib/keys.js":
/***/ (function(module, exports) {


/**
 * Gets the keys for an object.
 *
 * @return {Array} keys
 * @api private
 */

module.exports = Object.keys || function keys (obj){
  var arr = [];
  var has = Object.prototype.hasOwnProperty;

  for (var i in obj) {
    if (has.call(obj, i)) {
      arr.push(i);
    }
  }
  return arr;
};


/***/ }),

/***/ "./node_modules/engine.io-parser/lib/utf8.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/utf8js v2.1.2 by @mathias */
;(function(root) {

	// Detect free variables `exports`
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code,
	// and use it as `root`
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var stringFromCharCode = String.fromCharCode;

	// Taken from https://mths.be/punycode
	function ucs2decode(string) {
		var output = [];
		var counter = 0;
		var length = string.length;
		var value;
		var extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	// Taken from https://mths.be/punycode
	function ucs2encode(array) {
		var length = array.length;
		var index = -1;
		var value;
		var output = '';
		while (++index < length) {
			value = array[index];
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
		}
		return output;
	}

	function checkScalarValue(codePoint, strict) {
		if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
			if (strict) {
				throw Error(
					'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
					' is not a scalar value'
				);
			}
			return false;
		}
		return true;
	}
	/*--------------------------------------------------------------------------*/

	function createByte(codePoint, shift) {
		return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	}

	function encodeCodePoint(codePoint, strict) {
		if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
			return stringFromCharCode(codePoint);
		}
		var symbol = '';
		if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
			symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
		}
		else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
			if (!checkScalarValue(codePoint, strict)) {
				codePoint = 0xFFFD;
			}
			symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
			symbol += createByte(codePoint, 6);
		}
		else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
			symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
			symbol += createByte(codePoint, 12);
			symbol += createByte(codePoint, 6);
		}
		symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
		return symbol;
	}

	function utf8encode(string, opts) {
		opts = opts || {};
		var strict = false !== opts.strict;

		var codePoints = ucs2decode(string);
		var length = codePoints.length;
		var index = -1;
		var codePoint;
		var byteString = '';
		while (++index < length) {
			codePoint = codePoints[index];
			byteString += encodeCodePoint(codePoint, strict);
		}
		return byteString;
	}

	/*--------------------------------------------------------------------------*/

	function readContinuationByte() {
		if (byteIndex >= byteCount) {
			throw Error('Invalid byte index');
		}

		var continuationByte = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		if ((continuationByte & 0xC0) == 0x80) {
			return continuationByte & 0x3F;
		}

		// If we end up here, it’s not a continuation byte
		throw Error('Invalid continuation byte');
	}

	function decodeSymbol(strict) {
		var byte1;
		var byte2;
		var byte3;
		var byte4;
		var codePoint;

		if (byteIndex > byteCount) {
			throw Error('Invalid byte index');
		}

		if (byteIndex == byteCount) {
			return false;
		}

		// Read first byte
		byte1 = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		// 1-byte sequence (no continuation bytes)
		if ((byte1 & 0x80) == 0) {
			return byte1;
		}

		// 2-byte sequence
		if ((byte1 & 0xE0) == 0xC0) {
			byte2 = readContinuationByte();
			codePoint = ((byte1 & 0x1F) << 6) | byte2;
			if (codePoint >= 0x80) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 3-byte sequence (may include unpaired surrogates)
		if ((byte1 & 0xF0) == 0xE0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
			if (codePoint >= 0x0800) {
				return checkScalarValue(codePoint, strict) ? codePoint : 0xFFFD;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 4-byte sequence
		if ((byte1 & 0xF8) == 0xF0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			byte4 = readContinuationByte();
			codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
				(byte3 << 0x06) | byte4;
			if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
				return codePoint;
			}
		}

		throw Error('Invalid UTF-8 detected');
	}

	var byteArray;
	var byteCount;
	var byteIndex;
	function utf8decode(byteString, opts) {
		opts = opts || {};
		var strict = false !== opts.strict;

		byteArray = ucs2decode(byteString);
		byteCount = byteArray.length;
		byteIndex = 0;
		var codePoints = [];
		var tmp;
		while ((tmp = decodeSymbol(strict)) !== false) {
			codePoints.push(tmp);
		}
		return ucs2encode(codePoints);
	}

	/*--------------------------------------------------------------------------*/

	var utf8 = {
		'version': '2.1.2',
		'encode': utf8encode,
		'decode': utf8decode
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return utf8;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = utf8;
		} else { // in Narwhal or RingoJS v0.7.0-
			var object = {};
			var hasOwnProperty = object.hasOwnProperty;
			for (var key in utf8) {
				hasOwnProperty.call(utf8, key) && (freeExports[key] = utf8[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.utf8 = utf8;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module), __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/events/events.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = $getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  var args = [];
  for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    ReflectApply(this.listener, this.target, args);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),

/***/ "./node_modules/fbjs/lib/EventListener.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),

/***/ "./node_modules/fbjs/lib/ExecutionEnvironment.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),

/***/ "./node_modules/fbjs/lib/camelize.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),

/***/ "./node_modules/fbjs/lib/camelizeStyleName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__("./node_modules/fbjs/lib/camelize.js");

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),

/***/ "./node_modules/fbjs/lib/containsNode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__("./node_modules/fbjs/lib/isTextNode.js");

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),

/***/ "./node_modules/fbjs/lib/createArrayFromMixed.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),

/***/ "./node_modules/fbjs/lib/createNodesFromMarkup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__("./node_modules/fbjs/lib/ExecutionEnvironment.js");

var createArrayFromMixed = __webpack_require__("./node_modules/fbjs/lib/createArrayFromMixed.js");
var getMarkupWrap = __webpack_require__("./node_modules/fbjs/lib/getMarkupWrap.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),

/***/ "./node_modules/fbjs/lib/emptyFunction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),

/***/ "./node_modules/fbjs/lib/emptyObject.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),

/***/ "./node_modules/fbjs/lib/focusNode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),

/***/ "./node_modules/fbjs/lib/getActiveElement.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),

/***/ "./node_modules/fbjs/lib/getMarkupWrap.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__("./node_modules/fbjs/lib/ExecutionEnvironment.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),

/***/ "./node_modules/fbjs/lib/getUnboundedScrollPosition.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),

/***/ "./node_modules/fbjs/lib/hyphenate.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),

/***/ "./node_modules/fbjs/lib/hyphenateStyleName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__("./node_modules/fbjs/lib/hyphenate.js");

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),

/***/ "./node_modules/fbjs/lib/invariant.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ "./node_modules/fbjs/lib/isNode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),

/***/ "./node_modules/fbjs/lib/isTextNode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__("./node_modules/fbjs/lib/isNode.js");

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),

/***/ "./node_modules/fbjs/lib/memoizeStringOnly.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),

/***/ "./node_modules/fbjs/lib/shallowEqual.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),

/***/ "./node_modules/fbjs/lib/warning.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),

/***/ "./node_modules/feathers-authentication-client/lib/hooks/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _populateHeader = __webpack_require__("./node_modules/feathers-authentication-client/lib/hooks/populate-header.js");

var _populateHeader2 = _interopRequireDefault(_populateHeader);

var _populateAccessToken = __webpack_require__("./node_modules/feathers-authentication-client/lib/hooks/populate-access-token.js");

var _populateAccessToken2 = _interopRequireDefault(_populateAccessToken);

var _populateEntity = __webpack_require__("./node_modules/feathers-authentication-client/lib/hooks/populate-entity.js");

var _populateEntity2 = _interopRequireDefault(_populateEntity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hooks = {
  populateHeader: _populateHeader2.default,
  populateAccessToken: _populateAccessToken2.default,
  populateEntity: _populateEntity2.default
};

exports.default = hooks;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers-authentication-client/lib/hooks/populate-access-token.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = populateAccessToken;
/*
 * Exposes the access token to the client side hooks
 * under hook.params.accessToken.
 */

function populateAccessToken() {
  return function (hook) {
    var app = hook.app;

    if (hook.type !== 'before') {
      return Promise.reject(new Error('The \'populateAccessToken\' hook should only be used as a \'before\' hook.'));
    }

    Object.assign(hook.params, { accessToken: app.get('accessToken') });

    return Promise.resolve(hook);
  };
}
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers-authentication-client/lib/hooks/populate-entity.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = populateEntity;
/*
 * Fetch and populate an entity by id encoded in the
 * access token payload. Useful for easily getting the
 * current user after authentication, or any other entity.
 */

function populateEntity() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!options.service) {
    throw new Error('You need to pass \'options.service\' to the populateEntity() hook.');
  }

  if (!options.field) {
    throw new Error('You need to pass \'options.field\' to the populateEntity() hook.');
  }

  if (!options.entity) {
    throw new Error('You need to pass \'options.entity\' to the populateEntity() hook.');
  }

  return function (hook) {
    var app = hook.app;

    if (hook.type !== 'after') {
      return Promise.reject(new Error('The \'populateEntity\' hook should only be used as an \'after\' hook.'));
    }

    return app.passport.verifyJWT(hook.result.accessToken).then(function (payload) {
      var id = payload[options.field];

      if (!id) {
        return Promise.reject(new Error('Access token payload is missing the \'' + options.field + '\' field.'));
      }

      return app.service(options.service).get(id);
    }).then(function (entity) {
      hook.result[options.entity] = entity;
      app.set(options.entity, entity);

      return Promise.resolve(hook);
    });
  };
}
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers-authentication-client/lib/hooks/populate-header.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = populateHeader;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Sets the access token in the authorization header
 * under hook.params.header so that it can be picked
 * up by the client side REST libraries.
 */

function populateHeader() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!options.header) {
    throw new Error('You need to pass \'options.header\' to the populateHeader() hook.');
  }

  return function (hook) {
    if (hook.type !== 'before') {
      return Promise.reject(new Error('The \'populateHeader\' hook should only be used as a \'before\' hook.'));
    }

    if (hook.params.accessToken) {
      hook.params.headers = Object.assign({}, _defineProperty({}, options.header, options.prefix ? options.prefix + ' ' + hook.params.accessToken : hook.params.accessToken), hook.params.headers);
    }

    return Promise.resolve(hook);
  };
}
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers-authentication-client/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _index = __webpack_require__("./node_modules/feathers-authentication-client/lib/hooks/index.js");

var _index2 = _interopRequireDefault(_index);

var _passport = __webpack_require__("./node_modules/feathers-authentication-client/lib/passport.js");

var _passport2 = _interopRequireDefault(_passport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
  header: 'Authorization',
  cookie: 'feathers-jwt',
  storageKey: 'feathers-jwt',
  jwtStrategy: 'jwt',
  path: '/authentication',
  entity: 'user',
  service: 'users',
  timeout: 5000
};

function init() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var options = Object.assign({}, defaults, config);

  return function () {
    var app = this;

    app.passport = new _passport2.default(app, options);
    app.authenticate = app.passport.authenticate.bind(app.passport);
    app.logout = app.passport.logout.bind(app.passport);

    // Set up hook that adds token and user to params so that
    // it they can be accessed by client side hooks and services
    app.mixins.push(function (service) {
      // if (typeof service.hooks !== 'function') {
      if (typeof service.before !== 'function' || typeof service.after !== 'function') {
        throw new Error('It looks like feathers-hooks isn\'t configured. It is required before running feathers-authentication.');
      }

      service.before(_index2.default.populateAccessToken(options));
    });

    // Set up hook that adds authorization header for REST provider
    if (app.rest) {
      app.mixins.push(function (service) {
        service.before(_index2.default.populateHeader(options));
      });
    }
  };
}

init.defaults = defaults;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers-authentication-client/lib/passport.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _feathersErrors = __webpack_require__("./node_modules/feathers-errors/lib/index.js");

var _feathersErrors2 = _interopRequireDefault(_feathersErrors);

var _jwtDecode = __webpack_require__("./node_modules/jwt-decode/lib/index.js");

var _jwtDecode2 = _interopRequireDefault(_jwtDecode);

var _debug = __webpack_require__("./node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _utils = __webpack_require__("./node_modules/feathers-authentication-client/lib/utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = (0, _debug2.default)('feathers-authentication-client');

var Passport = function () {
  function Passport(app, options) {
    _classCallCheck(this, Passport);

    if (app.passport) {
      throw new Error('You have already registered authentication on this client app instance. You only need to do it once.');
    }

    Object.assign(this, {
      options: options,
      app: app,
      payloadIsValid: _utils.payloadIsValid,
      getCookie: _utils.getCookie,
      clearCookie: _utils.clearCookie,
      storage: app.get('storage') || this.getStorage(options.storage)
    });

    this.setJWT = this.setJWT.bind(this);

    app.set('storage', this.storage);
    this.getJWT().then(this.setJWT);

    this.setupSocketListeners();
  }

  _createClass(Passport, [{
    key: 'setupSocketListeners',
    value: function setupSocketListeners() {
      var _this = this;

      var app = this.app;
      var socket = app.io || app.primus;
      var emit = app.io ? 'emit' : 'send';
      var reconnected = app.io ? 'reconnect' : 'reconnected';

      if (!socket) {
        return;
      }

      socket.on(reconnected, function () {
        debug('Socket reconnected');

        // If socket was already authenticated then re-authenticate
        // it with the server automatically.
        if (socket.authenticated) {
          var data = {
            strategy: _this.options.jwtStrategy,
            accessToken: app.get('accessToken')
          };
          _this.authenticateSocket(data, socket, emit).then(_this.setJWT).catch(function (error) {
            debug('Error re-authenticating after socket reconnect', error);
            socket.authenticated = false;
            app.emit('reauthentication-error', error);
          });
        }
      });

      var socketUpgradeHandler = function socketUpgradeHandler() {
        socket.io.engine.on('upgrade', function () {
          debug('Socket upgrading');

          // If socket was already authenticated then re-authenticate
          // it with the server automatically.
          if (socket.authenticated) {
            var data = {
              strategy: _this.options.jwtStrategy,
              accessToken: app.get('accessToken')
            };

            _this.authenticateSocket(data, socket, emit).then(_this.setJWT).catch(function (error) {
              debug('Error re-authenticating after socket upgrade', error);
              socket.authenticated = false;
              app.emit('reauthentication-error', error);
            });
          }
        });
      };

      if (socket.io && socket.io.engine) {
        socketUpgradeHandler();
      } else {
        socket.on('connect', socketUpgradeHandler);
      }
    }
  }, {
    key: 'connected',
    value: function connected() {
      var _this2 = this;

      var app = this.app;

      if (app.rest) {
        return Promise.resolve();
      }

      var socket = app.io || app.primus;

      if (!socket) {
        return Promise.reject(new Error('It looks like your client connection has not been configured.'));
      }

      if (app.io && socket.connected || app.primus && socket.readyState === 3) {
        debug('Socket already connected');
        return Promise.resolve(socket);
      }

      return new Promise(function (resolve, reject) {
        var connected = app.primus ? 'open' : 'connect';
        var disconnect = app.io ? 'disconnect' : 'end';
        var timeout = setTimeout(function () {
          debug('Socket connection timed out');
          reject(new Error('Socket connection timed out'));
        }, _this2.options.timeout);

        debug('Waiting for socket connection');

        var handleDisconnect = function handleDisconnect() {
          debug('Socket disconnected before it could connect');
          socket.authenticated = false;
        };

        // If disconnect happens before `connect` the promise will be rejected.
        socket.once(disconnect, handleDisconnect);
        socket.once(connected, function () {
          debug('Socket connected');
          debug('Removing ' + disconnect + ' listener');
          socket.removeListener(disconnect, handleDisconnect);
          clearTimeout(timeout);
          resolve(socket);
        });
      });
    }
  }, {
    key: 'authenticate',
    value: function authenticate() {
      var _this3 = this;

      var credentials = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var app = this.app;
      var getCredentials = Promise.resolve(credentials);

      // If no strategy was given let's try to authenticate with a stored JWT
      if (!credentials.strategy) {
        if (credentials.accessToken) {
          credentials.strategy = this.options.jwtStrategy;
        } else {
          getCredentials = this.getJWT().then(function (accessToken) {
            if (!accessToken) {
              return Promise.reject(new _feathersErrors2.default.NotAuthenticated('Could not find stored JWT and no authentication strategy was given'));
            }
            return { strategy: _this3.options.jwtStrategy, accessToken: accessToken };
          });
        }
      }

      return getCredentials.then(function (credentials) {
        return _this3.connected(app).then(function (socket) {
          if (app.rest) {
            return app.service(_this3.options.path).create(credentials).then(_this3.setJWT);
          }

          var emit = app.io ? 'emit' : 'send';
          return _this3.authenticateSocket(credentials, socket, emit).then(_this3.setJWT);
        });
      }).then(function (payload) {
        app.emit('authenticated', payload);
        return payload;
      });
    }

    // Returns a promise that authenticates a socket

  }, {
    key: 'authenticateSocket',
    value: function authenticateSocket(credentials, socket, emit) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        var timeout = setTimeout(function () {
          debug('authenticateSocket timed out');
          reject(new Error('Authentication timed out'));
        }, _this4.options.timeout);

        debug('Attempting to authenticate socket');
        socket[emit]('authenticate', credentials, function (error, data) {
          if (error) {
            return reject(error);
          }

          clearTimeout(timeout);
          socket.authenticated = true;
          debug('Socket authenticated!');

          resolve(data);
        });
      });
    }
  }, {
    key: 'logoutSocket',
    value: function logoutSocket(socket, emit) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        var timeout = setTimeout(function () {
          debug('logoutSocket timed out');
          reject(new Error('Logout timed out'));
        }, _this5.options.timeout);

        socket[emit]('logout', function (error) {
          clearTimeout(timeout);
          socket.authenticated = false;

          if (error) {
            return reject(error);
          }

          resolve();
        });
      });
    }
  }, {
    key: 'logout',
    value: function logout() {
      var _this6 = this;

      var app = this.app;

      app.set('accessToken', null);
      this.clearCookie(this.options.cookie);

      // remove the accessToken from localStorage
      return Promise.resolve(app.get('storage').removeItem(this.options.storageKey)).then(function () {
        // If using sockets de-authenticate the socket
        if (app.io || app.primus) {
          var method = app.io ? 'emit' : 'send';
          var socket = app.io ? app.io : app.primus;

          return _this6.logoutSocket(socket, method);
        }
      }).then(function (result) {
        app.emit('logout', result);

        return result;
      });
    }
  }, {
    key: 'setJWT',
    value: function setJWT(data) {
      var accessToken = data && data.accessToken ? data.accessToken : data;

      if (accessToken) {
        this.app.set('accessToken', accessToken);
        this.app.get('storage').setItem(this.options.storageKey, accessToken);
      }

      return Promise.resolve(data);
    }
  }, {
    key: 'getJWT',
    value: function getJWT() {
      var _this7 = this;

      var app = this.app;
      return new Promise(function (resolve, reject) {
        var accessToken = app.get('accessToken');

        if (accessToken) {
          return resolve(accessToken);
        }

        return Promise.resolve(_this7.storage.getItem(_this7.options.storageKey)).then(function (jwt) {
          var token = jwt || _this7.getCookie(_this7.options.cookie);

          if (token && token !== 'null' && !_this7.payloadIsValid((0, _jwtDecode2.default)(token))) {
            token = undefined;
          }

          return resolve(token);
        }).catch(reject);
      });
    }

    // Pass a jwt token, get back a payload if it's valid.

  }, {
    key: 'verifyJWT',
    value: function verifyJWT(token) {
      if (typeof token !== 'string') {
        return Promise.reject(new Error('Token provided to verifyJWT is missing or not a string'));
      }

      try {
        var payload = (0, _jwtDecode2.default)(token);

        if (this.payloadIsValid(payload)) {
          return Promise.resolve(payload);
        }

        return Promise.reject(new Error('Invalid token: expired'));
      } catch (error) {
        return Promise.reject(new Error('Cannot decode malformed token.'));
      }
    }

    // Returns a storage implementation

  }, {
    key: 'getStorage',
    value: function getStorage(storage) {
      if (storage) {
        return storage;
      }

      return new _utils.Storage();
    }
  }]);

  return Passport;
}();

exports.default = Passport;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers-authentication-client/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.payloadIsValid = payloadIsValid;
exports.getCookie = getCookie;
exports.clearCookie = clearCookie;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Storage = exports.Storage = function () {
  function Storage() {
    _classCallCheck(this, Storage);

    this.store = {};
  }

  _createClass(Storage, [{
    key: 'getItem',
    value: function getItem(key) {
      return this.store[key];
    }
  }, {
    key: 'setItem',
    value: function setItem(key, value) {
      return this.store[key] = value;
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key) {
      delete this.store[key];
      return this;
    }
  }]);

  return Storage;
}();

// Pass a decoded payload and it will return a boolean based on if it hasn't expired.


function payloadIsValid(payload) {
  return payload && (!payload.exp || payload.exp * 1000 > new Date().getTime());
}

function getCookie(name) {
  if (typeof document !== 'undefined') {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');

    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
  }

  return null;
}

function clearCookie(name) {
  if (typeof document !== 'undefined') {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  return null;
}

/***/ }),

/***/ "./node_modules/feathers-commons/lib/arguments.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getArguments;

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

var noop = exports.noop = function noop() {};
var getCallback = function getCallback(args) {
  var last = args[args.length - 1];
  return typeof last === 'function' ? last : noop;
};
var getParams = function getParams(args, position) {
  return _typeof(args[position]) === 'object' ? args[position] : {};
};

var updateOrPatch = function updateOrPatch(name) {
  return function (args) {
    var id = args[0];
    var data = args[1];
    var callback = getCallback(args);
    var params = getParams(args, 2);

    if (typeof id === 'function') {
      throw new Error('First parameter for \'' + name + '\' can not be a function');
    }

    if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') {
      throw new Error('No data provided for \'' + name + '\'');
    }

    if (args.length > 4) {
      throw new Error('Too many arguments for \'' + name + '\' service method');
    }

    return [id, data, params, callback];
  };
};

var getOrRemove = function getOrRemove(name) {
  return function (args) {
    var id = args[0];
    var params = getParams(args, 1);
    var callback = getCallback(args);

    if (args.length > 3) {
      throw new Error('Too many arguments for \'' + name + '\' service method');
    }

    if (typeof id === 'function') {
      throw new Error('First parameter for \'' + name + '\' can not be a function');
    }

    return [id, params, callback];
  };
};

var converters = exports.converters = {
  find: function find(args) {
    var callback = getCallback(args);
    var params = getParams(args, 0);

    if (args.length > 2) {
      throw new Error('Too many arguments for \'find\' service method');
    }

    return [params, callback];
  },
  create: function create(args) {
    var data = args[0];
    var params = getParams(args, 1);
    var callback = getCallback(args);

    if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') {
      throw new Error('First parameter for \'create\' must be an object');
    }

    if (args.length > 3) {
      throw new Error('Too many arguments for \'create\' service method');
    }

    return [data, params, callback];
  },

  update: updateOrPatch('update'),

  patch: updateOrPatch('patch'),

  get: getOrRemove('get'),

  remove: getOrRemove('remove')
};

function getArguments(method, args) {
  return converters[method](args);
}

/***/ }),

/***/ "./node_modules/feathers-commons/lib/commons.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _arguments = __webpack_require__("./node_modules/feathers-commons/lib/arguments.js");

var _arguments2 = _interopRequireDefault(_arguments);

var _utils = __webpack_require__("./node_modules/feathers-commons/lib/utils.js");

var _hooks = __webpack_require__("./node_modules/feathers-commons/lib/hooks.js");

var _hooks2 = _interopRequireDefault(_hooks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  _: _utils._,
  getArguments: _arguments2.default,
  stripSlashes: _utils.stripSlashes,
  hooks: _hooks2.default,
  matcher: _utils.matcher,
  sorter: _utils.sorter,
  select: _utils.select,
  makeUrl: _utils.makeUrl,
  // lodash functions
  each: _utils.each,
  some: _utils.some,
  every: _utils.every,
  keys: _utils.keys,
  values: _utils.values,
  isMatch: _utils.isMatch,
  isEmpty: _utils.isEmpty,
  isObject: _utils.isObject,
  extend: _utils.extend,
  omit: _utils.omit,
  pick: _utils.pick,
  merge: _utils.merge
};
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers-commons/lib/hooks.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__("./node_modules/feathers-commons/lib/utils.js");

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

function getOrRemove(args) {
  return {
    id: args[0],
    params: args[1],
    callback: args[2]
  };
}

function updateOrPatch(args) {
  return {
    id: args[0],
    data: args[1],
    params: args[2],
    callback: args[3]
  };
}

var converters = {
  find: function find(args) {
    return {
      params: args[0],
      callback: args[1]
    };
  },
  create: function create(args) {
    return {
      data: args[0],
      params: args[1],
      callback: args[2]
    };
  },
  get: getOrRemove,
  remove: getOrRemove,
  update: updateOrPatch,
  patch: updateOrPatch
};

function hookObject(method, type, args) {
  var app = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];

  var hook = converters[method](args);

  hook.method = method;
  hook.type = type;

  if (typeof app === 'function') {
    hook.app = app;
  } else {
    _extends(hook, app);
  }

  return hook;
}

function defaultMakeArguments(hook) {
  var result = [];
  if (typeof hook.id !== 'undefined') {
    result.push(hook.id);
  }

  if (hook.data) {
    result.push(hook.data);
  }

  result.push(hook.params || {});
  result.push(hook.callback);

  return result;
}

function makeArguments(hook) {
  if (hook.method === 'find') {
    return [hook.params, hook.callback];
  }

  if (hook.method === 'get' || hook.method === 'remove') {
    return [hook.id, hook.params, hook.callback];
  }

  if (hook.method === 'update' || hook.method === 'patch') {
    return [hook.id, hook.data, hook.params, hook.callback];
  }

  if (hook.method === 'create') {
    return [hook.data, hook.params, hook.callback];
  }

  return defaultMakeArguments(hook);
}

function convertHookData(obj) {
  var hook = {};

  if (Array.isArray(obj)) {
    hook = { all: obj };
  } else if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    hook = { all: [obj] };
  } else {
    (0, _utils.each)(obj, function (value, key) {
      hook[key] = !Array.isArray(value) ? [value] : value;
    });
  }

  return hook;
}

exports.default = {
  hookObject: hookObject,
  hook: hookObject,
  converters: converters,
  defaultMakeArguments: defaultMakeArguments,
  makeArguments: makeArguments,
  convertHookData: convertHookData
};
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers-commons/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stripSlashes = stripSlashes;
exports.each = each;
exports.some = some;
exports.every = every;
exports.keys = keys;
exports.values = values;
exports.isMatch = isMatch;
exports.isEmpty = isEmpty;
exports.isObject = isObject;
exports.extend = extend;
exports.omit = omit;
exports.pick = pick;
exports.merge = merge;
exports.select = select;
exports.matcher = matcher;
exports.sorter = sorter;
exports.makeUrl = makeUrl;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function stripSlashes(name) {
  return name.replace(/^(\/*)|(\/*)$/g, '');
}

function each(obj, callback) {
  if (obj && typeof obj.forEach === 'function') {
    obj.forEach(callback);
  } else if (isObject(obj)) {
    Object.keys(obj).forEach(function (key) {
      return callback(obj[key], key);
    });
  }
}

function some(value, callback) {
  return Object.keys(value).map(function (key) {
    return [value[key], key];
  }).some(function (current) {
    return callback.apply(undefined, _toConsumableArray(current));
  });
}

function every(value, callback) {
  return Object.keys(value).map(function (key) {
    return [value[key], key];
  }).every(function (current) {
    return callback.apply(undefined, _toConsumableArray(current));
  });
}

function keys(obj) {
  return Object.keys(obj);
}

function values(obj) {
  return _.keys(obj).map(function (key) {
    return obj[key];
  });
}

function isMatch(obj, item) {
  return _.keys(item).every(function (key) {
    return obj[key] === item[key];
  });
}

function isEmpty(obj) {
  return _.keys(obj).length === 0;
}

function isObject(item) {
  return (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && !Array.isArray(item) && item !== null;
}

function extend() {
  return _extends.apply(undefined, arguments);
}

function omit(obj) {
  var result = _.extend({}, obj);

  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  keys.forEach(function (key) {
    return delete result[key];
  });
  return result;
}

function pick(source) {
  var result = {};

  for (var _len2 = arguments.length, keys = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    keys[_key2 - 1] = arguments[_key2];
  }

  keys.forEach(function (key) {
    result[key] = source[key];
  });
  return result;
}

function merge(target, source) {
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(function (key) {
      if (isObject(source[key])) {
        if (!target[key]) _extends(target, _defineProperty({}, key, {}));
        merge(target[key], source[key]);
      } else {
        _extends(target, _defineProperty({}, key, source[key]));
      }
    });
  }
  return target;
}

var _ = exports._ = {
  each: each,
  some: some,
  every: every,
  keys: keys,
  values: values,
  isMatch: isMatch,
  isEmpty: isEmpty,
  isObject: isObject,
  extend: extend,
  omit: omit,
  pick: pick,
  merge: merge
};

var specialFilters = exports.specialFilters = {
  $in: function $in(key, ins) {
    return function (current) {
      return ins.indexOf(current[key]) !== -1;
    };
  },
  $nin: function $nin(key, nins) {
    return function (current) {
      return nins.indexOf(current[key]) === -1;
    };
  },
  $lt: function $lt(key, value) {
    return function (current) {
      return current[key] < value;
    };
  },
  $lte: function $lte(key, value) {
    return function (current) {
      return current[key] <= value;
    };
  },
  $gt: function $gt(key, value) {
    return function (current) {
      return current[key] > value;
    };
  },
  $gte: function $gte(key, value) {
    return function (current) {
      return current[key] >= value;
    };
  },
  $ne: function $ne(key, value) {
    return function (current) {
      return current[key] !== value;
    };
  }
};

function select(params) {
  var fields = params && params.query && params.query.$select;

  for (var _len3 = arguments.length, otherFields = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    otherFields[_key3 - 1] = arguments[_key3];
  }

  if (Array.isArray(fields) && otherFields.length) {
    fields.push.apply(fields, otherFields);
  }

  var convert = function convert(result) {
    if (!Array.isArray(fields)) {
      return result;
    }

    return _.pick.apply(_, [result].concat(_toConsumableArray(fields)));
  };

  return function (result) {
    if (Array.isArray(result)) {
      return result.map(convert);
    }

    return convert(result);
  };
}

function matcher(originalQuery) {
  var query = _.omit(originalQuery, '$limit', '$skip', '$sort', '$select');

  return function (item) {
    if (query.$or && _.some(query.$or, function (or) {
      return matcher(or)(item);
    })) {
      return true;
    }

    return _.every(query, function (value, key) {
      if (value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        return _.every(value, function (target, filterType) {
          if (specialFilters[filterType]) {
            var filter = specialFilters[filterType](key, target);
            return filter(item);
          }

          return false;
        });
      } else if (typeof item[key] !== 'undefined') {
        return item[key] === query[key];
      }

      return false;
    });
  };
}

function sorter($sort) {
  return function (first, second) {
    var comparator = 0;
    each($sort, function (modifier, key) {
      modifier = parseInt(modifier, 10);

      if (first[key] < second[key]) {
        comparator -= 1 * modifier;
      }

      if (first[key] > second[key]) {
        comparator += 1 * modifier;
      }
    });
    return comparator;
  };
}

function makeUrl(path) {
  var app = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var get = typeof app.get === 'function' ? app.get.bind(app) : function () {};
  var env = get('env') || "production";
  var host = get('host') || process.env.HOST_NAME || 'localhost';
  var protocol = env === 'development' || env === 'test' || env === undefined ? 'http' : 'https';
  var PORT = get('port') || process.env.PORT || 3030;
  var port = env === 'development' || env === 'test' || env === undefined ? ':' + PORT : '';

  path = path || '';

  return protocol + '://' + host + port + '/' + stripSlashes(path);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/feathers-errors/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var debug = __webpack_require__("./node_modules/debug/src/browser.js")('feathers-errors');

function FeathersError(msg, name, code, className, data) {
  msg = msg || 'Error';

  var errors = void 0;
  var message = void 0;
  var newData = void 0;

  if (msg instanceof Error) {
    message = msg.message || 'Error';

    // NOTE (EK): This is typically to handle validation errors
    if (msg.errors) {
      errors = msg.errors;
    }
  } else if ((typeof msg === 'undefined' ? 'undefined' : _typeof(msg)) === 'object') {
    // Support plain old objects
    message = msg.message || 'Error';
    data = msg;
  } else {
    // message is just a string
    message = msg;
  }

  if (data) {
    // NOTE(EK): To make sure that we are not messing
    // with immutable data, just make a copy.
    // https://github.com/feathersjs/feathers-errors/issues/19
    newData = JSON.parse(JSON.stringify(data));

    if (newData.errors) {
      errors = newData.errors;
      delete newData.errors;
    } else if (data.errors) {
      // The errors property from data could be
      // stripped away while cloning resulting newData not to have it
      // For example: when cloning arrays this property
      errors = JSON.parse(JSON.stringify(data.errors));
    }
  }

  // NOTE (EK): Babel doesn't support this so
  // we have to pass in the class name manually.
  // this.name = this.constructor.name;
  this.type = 'FeathersError';
  this.name = name;
  this.message = message;
  this.code = code;
  this.className = className;
  this.data = newData;
  this.errors = errors || {};

  debug(this.name + '(' + this.code + '): ' + this.message);
  debug(this.errors);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, FeathersError);
  } else {
    this.stack = new Error().stack;
  }
}

FeathersError.prototype = Object.create(Error.prototype);

// NOTE (EK): A little hack to get around `message` not
// being included in the default toJSON call.
Object.defineProperty(FeathersError.prototype, 'toJSON', {
  value: function value() {
    return {
      name: this.name,
      message: this.message,
      code: this.code,
      className: this.className,
      data: this.data,
      errors: this.errors
    };
  }
});

// 400 - Bad Request
function BadRequest(message, data) {
  FeathersError.call(this, message, 'BadRequest', 400, 'bad-request', data);
}

BadRequest.prototype = FeathersError.prototype;

// 401 - Not Authenticated
function NotAuthenticated(message, data) {
  FeathersError.call(this, message, 'NotAuthenticated', 401, 'not-authenticated', data);
}

NotAuthenticated.prototype = FeathersError.prototype;

// 402 - Payment Error
function PaymentError(message, data) {
  FeathersError.call(this, message, 'PaymentError', 402, 'payment-error', data);
}

PaymentError.prototype = FeathersError.prototype;

// 403 - Forbidden
function Forbidden(message, data) {
  FeathersError.call(this, message, 'Forbidden', 403, 'forbidden', data);
}

Forbidden.prototype = FeathersError.prototype;

// 404 - Not Found
function NotFound(message, data) {
  FeathersError.call(this, message, 'NotFound', 404, 'not-found', data);
}

NotFound.prototype = FeathersError.prototype;

// 405 - Method Not Allowed
function MethodNotAllowed(message, data) {
  FeathersError.call(this, message, 'MethodNotAllowed', 405, 'method-not-allowed', data);
}

MethodNotAllowed.prototype = FeathersError.prototype;

// 406 - Not Acceptable
function NotAcceptable(message, data) {
  FeathersError.call(this, message, 'NotAcceptable', 406, 'not-acceptable', data);
}

NotAcceptable.prototype = FeathersError.prototype;

// 408 - Timeout
function Timeout(message, data) {
  FeathersError.call(this, message, 'Timeout', 408, 'timeout', data);
}

Timeout.prototype = FeathersError.prototype;

// 409 - Conflict
function Conflict(message, data) {
  FeathersError.call(this, message, 'Conflict', 409, 'conflict', data);
}

Conflict.prototype = FeathersError.prototype;

// 411 - Length Required
function LengthRequired(message, data) {
  FeathersError.call(this, message, 'LengthRequired', 411, 'length-required', data);
}

LengthRequired.prototype = FeathersError.prototype;

// 422 Unprocessable
function Unprocessable(message, data) {
  FeathersError.call(this, message, 'Unprocessable', 422, 'unprocessable', data);
}

Unprocessable.prototype = FeathersError.prototype;

// 429 Too Many Requests
function TooManyRequests(message, data) {
  FeathersError.call(this, message, 'TooManyRequests', 429, 'too-many-requests', data);
}

TooManyRequests.prototype = FeathersError.prototype;

// 500 - General Error
function GeneralError(message, data) {
  FeathersError.call(this, message, 'GeneralError', 500, 'general-error', data);
}

GeneralError.prototype = FeathersError.prototype;

// 501 - Not Implemented
function NotImplemented(message, data) {
  FeathersError.call(this, message, 'NotImplemented', 501, 'not-implemented', data);
}

NotImplemented.prototype = FeathersError.prototype;

// 502 - Bad Gateway
function BadGateway(message, data) {
  FeathersError.call(this, message, 'BadGateway', 502, 'bad-gateway', data);
}

BadGateway.prototype = FeathersError.prototype;

// 503 - Unavailable
function Unavailable(message, data) {
  FeathersError.call(this, message, 'Unavailable', 503, 'unavailable', data);
}

Unavailable.prototype = FeathersError.prototype;

var errors = {
  FeathersError: FeathersError,
  BadRequest: BadRequest,
  NotAuthenticated: NotAuthenticated,
  PaymentError: PaymentError,
  Forbidden: Forbidden,
  NotFound: NotFound,
  MethodNotAllowed: MethodNotAllowed,
  NotAcceptable: NotAcceptable,
  Timeout: Timeout,
  Conflict: Conflict,
  LengthRequired: LengthRequired,
  Unprocessable: Unprocessable,
  TooManyRequests: TooManyRequests,
  GeneralError: GeneralError,
  NotImplemented: NotImplemented,
  BadGateway: BadGateway,
  Unavailable: Unavailable,
  400: BadRequest,
  401: NotAuthenticated,
  402: PaymentError,
  403: Forbidden,
  404: NotFound,
  405: MethodNotAllowed,
  406: NotAcceptable,
  408: Timeout,
  409: Conflict,
  411: LengthRequired,
  422: Unprocessable,
  429: TooManyRequests,
  500: GeneralError,
  501: NotImplemented,
  502: BadGateway,
  503: Unavailable
};

function convert(error) {
  if (!error) {
    return error;
  }

  var FeathersError = errors[error.name];
  var result = FeathersError ? new FeathersError(error.message, error.data) : new Error(error.message || error);

  if ((typeof error === 'undefined' ? 'undefined' : _typeof(error)) === 'object') {
    _extends(result, error);
  }

  return result;
}

exports.default = _extends({
  convert: convert,
  types: errors,
  errors: errors
}, errors);
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers-hooks/lib/commons.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isHookObject = isHookObject;
exports.processHooks = processHooks;
exports.addHookTypes = addHookTypes;
exports.getHooks = getHooks;
exports.baseMixin = baseMixin;

var _feathersCommons = __webpack_require__("./node_modules/feathers-commons/lib/commons.js");

function isHookObject(hookObject) {
  return (typeof hookObject === 'undefined' ? 'undefined' : _typeof(hookObject)) === 'object' && typeof hookObject.method === 'string' && typeof hookObject.type === 'string';
}

function processHooks(hooks, initialHookObject) {
  var _this = this;

  var hookObject = initialHookObject;
  var updateCurrentHook = function updateCurrentHook(current) {
    if (current) {
      if (!isHookObject(current)) {
        throw new Error(hookObject.type + ' hook for \'' + hookObject.method + '\' method returned invalid hook object');
      }

      hookObject = current;
    }

    return hookObject;
  };
  var promise = Promise.resolve(hookObject);

  // Go through all hooks and chain them into our promise
  hooks.forEach(function (fn) {
    var hook = fn.bind(_this);

    if (hook.length === 2) {
      // function(hook, next)
      promise = promise.then(function (hookObject) {
        return new Promise(function (resolve, reject) {
          hook(hookObject, function (error, result) {
            return error ? reject(error) : resolve(result);
          });
        });
      });
    } else {
      // function(hook)
      promise = promise.then(hook);
    }

    // Use the returned hook object or the old one
    promise = promise.then(updateCurrentHook);
  });

  return promise.catch(function (error) {
    // Add the hook information to any errors
    error.hook = hookObject;
    throw error;
  });
}

function addHookTypes(target) {
  var types = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['before', 'after', 'error'];

  Object.defineProperty(target, '__hooks', {
    value: {}
  });

  types.forEach(function (type) {
    // Initialize properties where hook functions are stored
    target.__hooks[type] = {};
  });
}

function getHooks(app, service, type, method) {
  var appLast = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var appHooks = app.__hooks[type][method] || [];
  var serviceHooks = service.__hooks[type][method] || [];

  if (appLast) {
    return serviceHooks.concat(appHooks);
  }

  return appHooks.concat(serviceHooks);
}

function baseMixin(methods) {
  var mixin = {
    hooks: function hooks(allHooks) {
      var _this2 = this;

      (0, _feathersCommons.each)(allHooks, function (obj, type) {
        if (!_this2.__hooks[type]) {
          throw new Error('\'' + type + '\' is not a valid hook type');
        }

        var hooks = _feathersCommons.hooks.convertHookData(obj);

        (0, _feathersCommons.each)(hooks, function (value, method) {
          if (method !== 'all' && methods.indexOf(method) === -1) {
            throw new Error('\'' + method + '\' is not a valid hook method');
          }
        });

        methods.forEach(function (method) {
          if (!(hooks[method] || hooks.all)) {
            return;
          }

          var myHooks = _this2.__hooks[type][method] || (_this2.__hooks[type][method] = []);

          if (hooks.all) {
            myHooks.push.apply(myHooks, hooks.all);
          }

          if (hooks[method]) {
            myHooks.push.apply(myHooks, hooks[method]);
          }
        });
      });

      return this;
    }
  };

  for (var _len = arguments.length, objs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    objs[_key - 1] = arguments[_key];
  }

  return Object.assign.apply(Object, [mixin].concat(objs));
}

/***/ }),

/***/ "./node_modules/feathers-hooks/lib/hooks.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _uberproto = __webpack_require__("./node_modules/uberproto/lib/proto.js");

var _uberproto2 = _interopRequireDefault(_uberproto);

var _feathersCommons = __webpack_require__("./node_modules/feathers-commons/lib/commons.js");

var _commons = __webpack_require__("./node_modules/feathers-hooks/lib/commons.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function isPromise(result) {
  return typeof result !== 'undefined' && typeof result.then === 'function';
}

function hookMixin(service) {
  if (typeof service.hooks === 'function') {
    return;
  }

  var app = this;
  var methods = app.methods;
  var old = {
    before: service.before,
    after: service.after
  };
  var mixin = (0, _commons.baseMixin)(methods, {
    before: function before(_before) {
      return this.hooks({ before: _before });
    },
    after: function after(_after) {
      return this.hooks({ after: _after });
    }
  });

  (0, _commons.addHookTypes)(service);

  methods.forEach(function (method) {
    if (typeof service[method] !== 'function') {
      return;
    }

    mixin[method] = function () {
      var _this = this;

      var service = this;
      // A reference to the original method
      var _super = this._super.bind(this);
      // Additional data to add to the hook object
      var hookData = {
        app: app,
        service: service,
        get path() {
          return Object.keys(app.services).find(function (path) {
            return app.services[path] === service;
          });
        }
      };
      // Create the hook object that gets passed through
      var hookObject = _feathersCommons.hooks.hookObject(method, 'before', arguments, hookData);
      // Get all hooks
      var hooks = {
        // For before hooks the app hooks will run first
        before: (0, _commons.getHooks)(app, this, 'before', method),
        // For after and error hooks the app hooks will run last
        after: (0, _commons.getHooks)(app, this, 'after', method, true),
        error: (0, _commons.getHooks)(app, this, 'error', method, true)
      };

      // Process all before hooks
      return _commons.processHooks.call(this, hooks.before, hookObject)
      // Use the hook object to call the original method
      .then(function (hookObject) {
        if (typeof hookObject.result !== 'undefined') {
          return Promise.resolve(hookObject);
        }

        return new Promise(function (resolve, reject) {
          var args = _feathersCommons.hooks.makeArguments(hookObject);
          // The method may not be normalized yet so we have to handle both
          // ways, either by callback or by Promise
          var callback = function callback(error, result) {
            if (error) {
              reject(error);
            } else {
              hookObject.result = result;
              resolve(hookObject);
            }
          };

          // We replace the callback with resolving the promise
          args.splice(args.length - 1, 1, callback);

          var result = _super.apply(undefined, _toConsumableArray(args));

          if (isPromise(result)) {
            result.then(function (data) {
              return callback(null, data);
            }, callback);
          }
        });
      })
      // Make a copy of hookObject from `before` hooks and update type
      .then(function (hookObject) {
        return Object.assign({}, hookObject, { type: 'after' });
      })
      // Run through all `after` hooks
      .then(_commons.processHooks.bind(this, hooks.after))
      // Finally, return the result
      .then(function (hookObject) {
        return hookObject.result;
      })
      // Handle errors
      .catch(function (error) {
        var errorHook = Object.assign({}, error.hook || hookObject, {
          type: 'error',
          result: null,
          original: error.hook,
          error: error
        });

        return _commons.processHooks.call(_this, hooks.error, errorHook).then(function (hook) {
          return hook.result || Promise.reject(hook.error);
        });
      });
    };
  });

  service.mixin(mixin);

  // Before hooks that were registered in the service
  if (old.before) {
    service.before(old.before);
  }

  // After hooks that were registered in the service
  if (old.after) {
    service.after(old.after);
  }
}

function configure() {
  return function () {
    var app = this;

    if (app.version && app.version >= '3.0.0') {
      throw new Error('You are using Feathers v' + app.version + ' which already includes feathers-hooks. You can remove this module from your application.');
    }

    (0, _commons.addHookTypes)(app);

    _uberproto2.default.mixin((0, _commons.baseMixin)(app.methods), app);

    this.mixins.unshift(hookMixin);
  };
}

exports.default = configure;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers-socket-commons/client.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/feathers-socket-commons/lib/client.js");


/***/ }),

/***/ "./node_modules/feathers-socket-commons/lib/client.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("./node_modules/feathers-socket-commons/lib/utils.js");

var _feathersErrors = __webpack_require__("./node_modules/feathers-errors/lib/index.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = __webpack_require__("./node_modules/debug/src/browser.js")('feathers-socket-commons:client');
var namespacedEmitterMethods = ['addListener', 'emit', 'listenerCount', 'listeners', 'on', 'once', 'prependListener', 'prependOnceListener', 'removeAllListeners', 'removeListener'];
var otherEmitterMethods = ['eventNames', 'getMaxListeners', 'setMaxListeners'];

var addEmitterMethods = function addEmitterMethods(service) {
  otherEmitterMethods.forEach(function (method) {
    service[method] = function () {
      var _connection;

      if (typeof this.connection[method] !== 'function') {
        throw new Error('Can not call \'' + method + '\' on the client service connection.');
      }

      return (_connection = this.connection)[method].apply(_connection, arguments);
    };
  });

  namespacedEmitterMethods.forEach(function (method) {
    service[method] = function (name) {
      var _connection2;

      if (typeof this.connection[method] !== 'function') {
        throw new Error('Can not call \'' + method + '\' on the client service connection.');
      }

      var eventName = this.path + ' ' + name;

      debug('Calling emitter method ' + method + ' with ' + ('namespaced event \'' + eventName + '\''));

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var result = (_connection2 = this.connection)[method].apply(_connection2, [eventName].concat(args));

      return result === this.connection ? this : result;
    };
  });
};

var Service = function () {
  function Service(options) {
    _classCallCheck(this, Service);

    this.events = _utils.events;
    this.path = options.name;
    this.connection = options.connection;
    this.method = options.method;
    this.timeout = options.timeout || 5000;

    addEmitterMethods(this);
  }

  _createClass(Service, [{
    key: 'send',
    value: function send(method) {
      var _this = this;

      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      var callback = null;
      if (typeof args[args.length - 1] === 'function') {
        callback = args.pop();
      }

      return new Promise(function (resolve, reject) {
        var _connection3;

        var event = _this.path + '::' + method;
        var timeoutId = setTimeout(function () {
          return reject(new Error('Timeout of ' + _this.timeout + 'ms exceeded calling ' + event));
        }, _this.timeout);

        args.unshift(event);
        args.push(function (error, data) {
          error = (0, _feathersErrors.convert)(error);
          clearTimeout(timeoutId);

          if (callback) {
            callback(error, data);
          }

          return error ? reject(error) : resolve(data);
        });

        debug('Sending socket.' + _this.method, args);

        (_connection3 = _this.connection)[_this.method].apply(_connection3, args);
      });
    }
  }, {
    key: 'find',
    value: function find() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return this.send('find', params.query || {});
    }
  }, {
    key: 'get',
    value: function get(id) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.send('get', id, params.query || {});
    }
  }, {
    key: 'create',
    value: function create(data) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.send('create', data, params.query || {});
    }
  }, {
    key: 'update',
    value: function update(id, data) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.send('update', id, data, params.query || {});
    }
  }, {
    key: 'patch',
    value: function patch(id, data) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.send('patch', id, data, params.query || {});
    }
  }, {
    key: 'remove',
    value: function remove(id) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.send('remove', id, params.query || {});
    }
  }, {
    key: 'off',
    value: function off(name) {
      for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      if (typeof this.connection.off === 'function') {
        var _connection4;

        return (_connection4 = this.connection).off.apply(_connection4, [this.path + ' ' + name].concat(args));
      } else if (args.length === 0) {
        return this.removeAllListeners(name);
      }

      return this.removeListener.apply(this, [name].concat(args));
    }
  }]);

  return Service;
}();

exports.default = Service;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers-socket-commons/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.events = exports.eventMappings = undefined;
exports.convertFilterData = convertFilterData;
exports.promisify = promisify;
exports.normalizeError = normalizeError;
exports.normalizeArgs = normalizeArgs;

var _feathersCommons = __webpack_require__("./node_modules/feathers-commons/lib/commons.js");

var eventMappings = exports.eventMappings = {
  create: 'created',
  update: 'updated',
  patch: 'patched',
  remove: 'removed'
};

var events = exports.events = Object.keys(eventMappings).map(function (method) {
  return eventMappings[method];
});

function convertFilterData(obj) {
  return _feathersCommons.hooks.convertHookData(obj);
}

function promisify(method, context) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return new Promise(function (resolve, reject) {
    method.apply(context, args.concat(function (error, result) {
      if (error) {
        return reject(error);
      }

      resolve(result);
    }));
  });
}

function normalizeError(e) {
  var result = {};

  Object.getOwnPropertyNames(e).forEach(function (key) {
    return result[key] = e[key];
  });

  if (true) {
    delete result.stack;
  }

  delete result.hook;

  return result;
}

function normalizeArgs(args) {
  var ret = [];
  if (args.length === 2 && Array.isArray(args['0'])) {
    ret = args[0];
    ret.push(args[1]);
    return ret;
  }
  return args;
}

/***/ }),

/***/ "./node_modules/feathers-socketio/client.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/feathers-socketio/lib/client.js");


/***/ }),

/***/ "./node_modules/feathers-socketio/lib/client.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (connection, options) {
  if (!connection) {
    throw new Error('Socket.io connection needs to be provided');
  }

  var defaultService = function defaultService(name) {
    var settings = _extends({}, options, {
      name: name,
      connection: connection,
      method: 'emit'
    });

    return new _client2.default(settings);
  };

  var initialize = function initialize() {
    if (typeof this.defaultService === 'function') {
      throw new Error('Only one default client provider can be configured');
    }

    this.io = connection;
    this.defaultService = defaultService;
  };

  initialize.Service = _client2.default;
  initialize.service = defaultService;

  return initialize;
};

var _client = __webpack_require__("./node_modules/feathers-socket-commons/client.js");

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers/client.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/feathers/lib/client/index.js");


/***/ }),

/***/ "./node_modules/feathers/lib/application.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _from = __webpack_require__("./node_modules/babel-runtime/core-js/array/from.js");

var _from2 = _interopRequireDefault(_from);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _debug = __webpack_require__("./node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _feathersCommons = __webpack_require__("./node_modules/feathers-commons/lib/commons.js");

var _uberproto = __webpack_require__("./node_modules/uberproto/lib/proto.js");

var _uberproto2 = _interopRequireDefault(_uberproto);

var _index = __webpack_require__("./node_modules/feathers/lib/mixins/index.js");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debug = (0, _debug2.default)('feathers:application');
var methods = ['find', 'get', 'create', 'update', 'patch', 'remove'];
var Proto = _uberproto2.default.extend({
  create: null
});

exports.default = {
  init: function init() {
    (0, _assign2.default)(this, {
      methods: methods,
      mixins: (0, _index2.default)(),
      services: {},
      providers: [],
      _setup: false
    });
  },
  service: function service(location, _service) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    location = (0, _feathersCommons.stripSlashes)(location);

    if (!_service) {
      var current = this.services[location];

      if (typeof current === 'undefined' && typeof this.defaultService === 'function') {
        return this.service(location, this.defaultService(location), options);
      }

      return current;
    }

    var protoService = Proto.extend(_service);

    debug('Registering new service at `' + location + '`');

    // Add all the mixins
    this.mixins.forEach(function (fn) {
      return fn.call(_this, protoService);
    });

    if (typeof protoService._setup === 'function') {
      protoService._setup(this, location);
    }

    // Run the provider functions to register the service
    this.providers.forEach(function (provider) {
      return provider.call(_this, location, protoService, options);
    });

    // If we ran setup already, set this service up explicitly
    if (this._isSetup && typeof protoService.setup === 'function') {
      debug('Setting up service for `' + location + '`');
      protoService.setup(this, location);
    }

    return this.services[location] = protoService;
  },
  use: function use(location) {
    var service = void 0;
    var middleware = (0, _from2.default)(arguments).slice(1).reduce(function (middleware, arg) {
      if (typeof arg === 'function') {
        middleware[service ? 'after' : 'before'].push(arg);
      } else if (!service) {
        service = arg;
      } else {
        throw new Error('invalid arg passed to app.use');
      }
      return middleware;
    }, {
      before: [],
      after: []
    });

    var hasMethod = function hasMethod(methods) {
      return methods.some(function (name) {
        return service && typeof service[name] === 'function';
      });
    };

    // Check for service (any object with at least one service method)
    if (hasMethod(['handle', 'set']) || !hasMethod(this.methods.concat('setup'))) {
      return this._super.apply(this, arguments);
    }

    // Any arguments left over are other middleware that we want to pass to the providers
    this.service(location, service, { middleware: middleware });

    return this;
  },
  setup: function setup() {
    var _this2 = this;

    // Setup each service (pass the app so that they can look up other services etc.)
    (0, _keys2.default)(this.services).forEach(function (path) {
      var service = _this2.services[path];

      debug('Setting up service for `' + path + '`');
      if (typeof service.setup === 'function') {
        service.setup(_this2, path);
      }
    });

    this._isSetup = true;

    return this;
  },


  // Express 3.x configure is gone in 4.x but we'll keep a more basic version
  // That just takes a function in order to keep Feathers plugin configuration easier.
  // Environment specific configurations should be done as suggested in the 4.x migration guide:
  // https://github.com/visionmedia/express/wiki/Migrating-from-3.x-to-4.x
  configure: function configure(fn) {
    fn.call(this);

    return this;
  },
  listen: function listen() {
    var server = this._super.apply(this, arguments);

    this.setup(server);
    debug('Feathers application listening');

    return server;
  }
};
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers/lib/client/express.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var app = {
    settings: {},

    get: function get(name) {
      return this.settings[name];
    },
    set: function set(name, value) {
      this.settings[name] = value;
      return this;
    },
    disable: function disable(name) {
      this.settings[name] = false;
      return this;
    },
    disabled: function disabled(name) {
      return !this.settings[name];
    },
    enable: function enable(name) {
      this.settings[name] = true;
      return this;
    },
    enabled: function enabled(name) {
      return !!this.settings[name];
    },
    use: function use() {
      throw new Error('Middleware functions can not be used in the Feathers client');
    },
    listen: function listen() {
      return {};
    }
  };

  _uberproto2.default.mixin(_events.EventEmitter.prototype, app);

  return app;
};

var _events = __webpack_require__("./node_modules/events/events.js");

var _uberproto = __webpack_require__("./node_modules/uberproto/lib/proto.js");

var _uberproto2 = _interopRequireDefault(_uberproto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers/lib/client/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createApplication;

var _feathers = __webpack_require__("./node_modules/feathers/lib/feathers.js");

var _feathers2 = _interopRequireDefault(_feathers);

var _express = __webpack_require__("./node_modules/feathers/lib/client/express.js");

var _express2 = _interopRequireDefault(_express);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createApplication() {
  return (0, _feathers2.default)(_express2.default.apply(undefined, arguments));
}

createApplication.version = '2.0.1';
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers/lib/feathers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createApplication;

var _uberproto = __webpack_require__("./node_modules/uberproto/lib/proto.js");

var _uberproto2 = _interopRequireDefault(_uberproto);

var _application = __webpack_require__("./node_modules/feathers/lib/application.js");

var _application2 = _interopRequireDefault(_application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Create a Feathers application that extends Express.
 *
 * @return {Function}
 * @api public
 */
function createApplication(app) {
  _uberproto2.default.mixin(_application2.default, app);
  app.init();
  return app;
}
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers/lib/mixins/event.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

exports.default = function (service) {
  var app = this;
  var isEmitter = typeof service.on === 'function' && typeof service.emit === 'function';
  var emitter = service._rubberDuck = _rubberduck2.default.emitter(service);

  if (typeof service.mixin === 'function' && !isEmitter) {
    service.mixin(_events.EventEmitter.prototype);
  }

  service._serviceEvents = Array.isArray(service.events) ? service.events.slice() : [];

  // Pass the Rubberduck error event through
  // TODO deal with error events properly
  emitter.on('error', function (errors) {
    service.emit('serviceError', errors[0]);
  });

  (0, _keys2.default)(eventMappings).forEach(function (method) {
    var event = eventMappings[method];
    var alreadyEmits = service._serviceEvents.indexOf(event) !== -1;

    if (typeof service[method] === 'function' && !alreadyEmits) {
      // The Rubberduck event name (e.g. afterCreate, afterUpdate or afterDestroy)
      var eventName = 'after' + upperCase(method);
      service._serviceEvents.push(event);
      // Punch the given method
      emitter.punch(method, -1);
      // Pass the event and error event through
      emitter.on(eventName, function (results, args) {
        if (!results[0]) {
          // callback without error
          var hook = hookObject(method, 'after', args);
          var data = Array.isArray(results[1]) ? results[1] : [results[1]];

          hook.app = app;
          data.forEach(function (current) {
            return service.emit(event, current, hook);
          });
        } else {
          service.emit('serviceError', results[0]);
        }
      });
    }
  });
};

var _rubberduck = __webpack_require__("./node_modules/rubberduck/lib/rubberduck.js");

var _rubberduck2 = _interopRequireDefault(_rubberduck);

var _events = __webpack_require__("./node_modules/events/events.js");

var _feathersCommons = __webpack_require__("./node_modules/feathers-commons/lib/commons.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hookObject = _feathersCommons.hooks.hookObject;
var eventMappings = {
  create: 'created',
  update: 'updated',
  remove: 'removed',
  patch: 'patched'
};

function upperCase(name) {
  return name.charAt(0).toUpperCase() + name.substring(1);
}

module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers/lib/mixins/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__("./node_modules/babel-runtime/core-js/array/from.js");

var _from2 = _interopRequireDefault(_from);

exports.default = function () {
  var mixins = [__webpack_require__("./node_modules/feathers/lib/mixins/promise.js"), __webpack_require__("./node_modules/feathers/lib/mixins/event.js"), __webpack_require__("./node_modules/feathers/lib/mixins/normalizer.js")];

  // Override push to make sure that normalize is always the last
  mixins.push = function () {
    var args = [this.length - 1, 0].concat((0, _from2.default)(arguments));
    this.splice.apply(this, args);
    return this.length;
  };

  return mixins;
};

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers/lib/mixins/normalizer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (service) {
  if (typeof service.mixin === 'function') {
    var mixin = {};

    this.methods.forEach(function (method) {
      if (typeof service[method] === 'function') {
        mixin[method] = function () {
          return this._super.apply(this, (0, _feathersCommons.getArguments)(method, arguments));
        };
      }
    });

    service.mixin(mixin);
  }
};

var _feathersCommons = __webpack_require__("./node_modules/feathers-commons/lib/commons.js");

module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/feathers/lib/mixins/promise.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (service) {
  if (typeof service.mixin === 'function') {
    var mixin = {};

    this.methods.forEach(function (method) {
      if (typeof service[method] === 'function') {
        mixin[method] = wrapper;
      }
    });

    service.mixin(mixin);
  }
};

function isPromise(result) {
  return typeof result !== 'undefined' && typeof result.then === 'function';
}

function wrapper() {
  var result = this._super.apply(this, arguments);
  var callback = arguments[arguments.length - 1];

  if (typeof callback === 'function' && isPromise(result)) {
    result.then(function (data) {
      return callback(null, data);
    }, function (error) {
      return callback(error);
    });
  }
  return result;
}

module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/has-binary2/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/* global Blob File */

/*
 * Module requirements.
 */

var isArray = __webpack_require__("./node_modules/isarray/index.js");

var toString = Object.prototype.toString;
var withNativeBlob = typeof global.Blob === 'function' || toString.call(global.Blob) === '[object BlobConstructor]';
var withNativeFile = typeof global.File === 'function' || toString.call(global.File) === '[object FileConstructor]';

/**
 * Module exports.
 */

module.exports = hasBinary;

/**
 * Checks for binary data.
 *
 * Supports Buffer, ArrayBuffer, Blob and File.
 *
 * @param {Object} anything
 * @api public
 */

function hasBinary (obj) {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  if (isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      if (hasBinary(obj[i])) {
        return true;
      }
    }
    return false;
  }

  if ((typeof global.Buffer === 'function' && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
     (typeof global.ArrayBuffer === 'function' && obj instanceof ArrayBuffer) ||
     (withNativeBlob && obj instanceof Blob) ||
     (withNativeFile && obj instanceof File)
    ) {
    return true;
  }

  // see: https://github.com/Automattic/has-binary/pull/4
  if (obj.toJSON && typeof obj.toJSON === 'function' && arguments.length === 1) {
    return hasBinary(obj.toJSON(), true);
  }

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
      return true;
    }
  }

  return false;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/has-cors/index.js":
/***/ (function(module, exports) {


/**
 * Module exports.
 *
 * Logic borrowed from Modernizr:
 *
 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
 */

try {
  module.exports = typeof XMLHttpRequest !== 'undefined' &&
    'withCredentials' in new XMLHttpRequest();
} catch (err) {
  // if XMLHttp support is disabled in IE then it will throw
  // when trying to create
  module.exports = false;
}


/***/ }),

/***/ "./node_modules/history/esm/history.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createBrowserHistory", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createHashHistory", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createMemoryHistory", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createLocation", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "locationsAreEqual", function() { return locationsAreEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parsePath", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPath", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__("./node_modules/@babel/runtime/helpers/esm/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__("./node_modules/resolve-pathname/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__("./node_modules/value-equal/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__("./node_modules/tiny-warning/dist/tiny-warning.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__("./node_modules/tiny-invariant/dist/tiny-invariant.esm.js");






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');
  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),

/***/ "./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__("./node_modules/react-is/index.js");
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ "./node_modules/ieee754/index.js":
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "./node_modules/indexof/index.js":
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),

/***/ "./node_modules/invariant/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),

/***/ "./node_modules/isarray/index.js":
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "./node_modules/jwt-decode/lib/atob.js":
/***/ (function(module, exports) {

/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function InvalidCharacterError(message) {
  this.message = message;
}

InvalidCharacterError.prototype = new Error();
InvalidCharacterError.prototype.name = 'InvalidCharacterError';

function polyfill (input) {
  var str = String(input).replace(/=+$/, '');
  if (str.length % 4 == 1) {
    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
  }
  for (
    // initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = '';
    // get next character
    buffer = str.charAt(idx++);
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
      // and if not first of each 4 characters,
      // convert the first 8 bits to one ascii character
      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
  ) {
    // try to find character in table (0-63, not found => -1)
    buffer = chars.indexOf(buffer);
  }
  return output;
}


module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ }),

/***/ "./node_modules/jwt-decode/lib/base64_url_decode.js":
/***/ (function(module, exports, __webpack_require__) {

var atob = __webpack_require__("./node_modules/jwt-decode/lib/atob.js");

function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
    var code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = '0' + code;
    }
    return '%' + code;
  }));
}

module.exports = function(str) {
  var output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }

  try{
    return b64DecodeUnicode(output);
  } catch (err) {
    return atob(output);
  }
};


/***/ }),

/***/ "./node_modules/jwt-decode/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var base64_url_decode = __webpack_require__("./node_modules/jwt-decode/lib/base64_url_decode.js");

function InvalidTokenError(message) {
  this.message = message;
}

InvalidTokenError.prototype = new Error();
InvalidTokenError.prototype.name = 'InvalidTokenError';

module.exports = function (token,options) {
  if (typeof token !== 'string') {
    throw new InvalidTokenError('Invalid token specified');
  }

  options = options || {};
  var pos = options.header === true ? 0 : 1;
  try {
    return JSON.parse(base64_url_decode(token.split('.')[pos]));
  } catch (e) {
    throw new InvalidTokenError('Invalid token specified: ' + e.message);
  }
};

module.exports.InvalidTokenError = InvalidTokenError;


/***/ }),

/***/ "./node_modules/localforage/dist/localforage.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;/*!
    localForage -- Offline Storage, Improved
    Version 1.7.3
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.localforage = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
(function (global){
'use strict';
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(_dereq_,module,exports){
'use strict';
var immediate = _dereq_(1);

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

},{"1":1}],3:[function(_dereq_,module,exports){
(function (global){
'use strict';
if (typeof global.Promise !== 'function') {
  global.Promise = _dereq_(2);
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"2":2}],4:[function(_dereq_,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getIDB() {
    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
    try {
        if (typeof indexedDB !== 'undefined') {
            return indexedDB;
        }
        if (typeof webkitIndexedDB !== 'undefined') {
            return webkitIndexedDB;
        }
        if (typeof mozIndexedDB !== 'undefined') {
            return mozIndexedDB;
        }
        if (typeof OIndexedDB !== 'undefined') {
            return OIndexedDB;
        }
        if (typeof msIndexedDB !== 'undefined') {
            return msIndexedDB;
        }
    } catch (e) {
        return;
    }
}

var idb = getIDB();

function isIndexedDBValid() {
    try {
        // Initialize IndexedDB; fall back to vendor-prefixed versions
        // if needed.
        if (!idb) {
            return false;
        }
        // We mimic PouchDB here;
        //
        // We test for openDatabase because IE Mobile identifies itself
        // as Safari. Oh the lulz...
        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

        // Safari <10.1 does not meet our requirements for IDB support (#5572)
        // since Safari 10.1 shipped with fetch, we can use that to detect it
        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
        // some outdated implementations of IDB that appear on Samsung
        // and HTC Android devices <4.4 are missing IDBKeyRange
        // See: https://github.com/mozilla/localForage/issues/128
        // See: https://github.com/mozilla/localForage/issues/272
        typeof IDBKeyRange !== 'undefined';
    } catch (e) {
        return false;
    }
}

// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
function createBlob(parts, properties) {
    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
    parts = parts || [];
    properties = properties || {};
    try {
        return new Blob(parts, properties);
    } catch (e) {
        if (e.name !== 'TypeError') {
            throw e;
        }
        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
        var builder = new Builder();
        for (var i = 0; i < parts.length; i += 1) {
            builder.append(parts[i]);
        }
        return builder.getBlob(properties.type);
    }
}

// This is CommonJS because lie is an external dependency, so Rollup
// can just ignore it.
if (typeof Promise === 'undefined') {
    // In the "nopromises" build this will just throw if you don't have
    // a global promise object, but it would throw anyway later.
    _dereq_(3);
}
var Promise$1 = Promise;

function executeCallback(promise, callback) {
    if (callback) {
        promise.then(function (result) {
            callback(null, result);
        }, function (error) {
            callback(error);
        });
    }
}

function executeTwoCallbacks(promise, callback, errorCallback) {
    if (typeof callback === 'function') {
        promise.then(callback);
    }

    if (typeof errorCallback === 'function') {
        promise["catch"](errorCallback);
    }
}

function normalizeKey(key) {
    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    return key;
}

function getCallback() {
    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
        return arguments[arguments.length - 1];
    }
}

// Some code originally from async_storage.js in
// [Gaia](https://github.com/mozilla-b2g/gaia).

var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
var supportsBlobs = void 0;
var dbContexts = {};
var toString = Object.prototype.toString;

// Transaction Modes
var READ_ONLY = 'readonly';
var READ_WRITE = 'readwrite';

// Transform a binary string to an array buffer, because otherwise
// weird stuff happens when you try to work with the binary string directly.
// It is known.
// From http://stackoverflow.com/questions/14967647/ (continues on next line)
// encode-decode-image-with-base64-breaks-image (2013-04-21)
function _binStringToArrayBuffer(bin) {
    var length = bin.length;
    var buf = new ArrayBuffer(length);
    var arr = new Uint8Array(buf);
    for (var i = 0; i < length; i++) {
        arr[i] = bin.charCodeAt(i);
    }
    return buf;
}

//
// Blobs are not supported in all versions of IndexedDB, notably
// Chrome <37 and Android <5. In those versions, storing a blob will throw.
//
// Various other blob bugs exist in Chrome v37-42 (inclusive).
// Detecting them is expensive and confusing to users, and Chrome 37-42
// is at very low usage worldwide, so we do a hacky userAgent check instead.
//
// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
//
// Code borrowed from PouchDB. See:
// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
//
function _checkBlobSupportWithoutCaching(idb) {
    return new Promise$1(function (resolve) {
        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
        var blob = createBlob(['']);
        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

        txn.onabort = function (e) {
            // If the transaction aborts now its due to not being able to
            // write to the database, likely due to the disk being full
            e.preventDefault();
            e.stopPropagation();
            resolve(false);
        };

        txn.oncomplete = function () {
            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
            var matchedEdge = navigator.userAgent.match(/Edge\//);
            // MS Edge pretends to be Chrome 42:
            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
        };
    })["catch"](function () {
        return false; // error, so assume unsupported
    });
}

function _checkBlobSupport(idb) {
    if (typeof supportsBlobs === 'boolean') {
        return Promise$1.resolve(supportsBlobs);
    }
    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
        supportsBlobs = value;
        return supportsBlobs;
    });
}

function _deferReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Create a deferred object representing the current database operation.
    var deferredOperation = {};

    deferredOperation.promise = new Promise$1(function (resolve, reject) {
        deferredOperation.resolve = resolve;
        deferredOperation.reject = reject;
    });

    // Enqueue the deferred operation.
    dbContext.deferredOperations.push(deferredOperation);

    // Chain its promise to the database readiness.
    if (!dbContext.dbReady) {
        dbContext.dbReady = deferredOperation.promise;
    } else {
        dbContext.dbReady = dbContext.dbReady.then(function () {
            return deferredOperation.promise;
        });
    }
}

function _advanceReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Resolve its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.resolve();
        return deferredOperation.promise;
    }
}

function _rejectReadiness(dbInfo, err) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Reject its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.reject(err);
        return deferredOperation.promise;
    }
}

function _getConnection(dbInfo, upgradeNeeded) {
    return new Promise$1(function (resolve, reject) {
        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();

        if (dbInfo.db) {
            if (upgradeNeeded) {
                _deferReadiness(dbInfo);
                dbInfo.db.close();
            } else {
                return resolve(dbInfo.db);
            }
        }

        var dbArgs = [dbInfo.name];

        if (upgradeNeeded) {
            dbArgs.push(dbInfo.version);
        }

        var openreq = idb.open.apply(idb, dbArgs);

        if (upgradeNeeded) {
            openreq.onupgradeneeded = function (e) {
                var db = openreq.result;
                try {
                    db.createObjectStore(dbInfo.storeName);
                    if (e.oldVersion <= 1) {
                        // Added when support for blob shims was added
                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                    }
                } catch (ex) {
                    if (ex.name === 'ConstraintError') {
                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                    } else {
                        throw ex;
                    }
                }
            };
        }

        openreq.onerror = function (e) {
            e.preventDefault();
            reject(openreq.error);
        };

        openreq.onsuccess = function () {
            resolve(openreq.result);
            _advanceReadiness(dbInfo);
        };
    });
}

function _getOriginalConnection(dbInfo) {
    return _getConnection(dbInfo, false);
}

function _getUpgradedConnection(dbInfo) {
    return _getConnection(dbInfo, true);
}

function _isUpgradeNeeded(dbInfo, defaultVersion) {
    if (!dbInfo.db) {
        return true;
    }

    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
    var isDowngrade = dbInfo.version < dbInfo.db.version;
    var isUpgrade = dbInfo.version > dbInfo.db.version;

    if (isDowngrade) {
        // If the version is not the default one
        // then warn for impossible downgrade.
        if (dbInfo.version !== defaultVersion) {
            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
        }
        // Align the versions to prevent errors.
        dbInfo.version = dbInfo.db.version;
    }

    if (isUpgrade || isNewStore) {
        // If the store is new then increment the version (if needed).
        // This will trigger an "upgradeneeded" event which is required
        // for creating a store.
        if (isNewStore) {
            var incVersion = dbInfo.db.version + 1;
            if (incVersion > dbInfo.version) {
                dbInfo.version = incVersion;
            }
        }

        return true;
    }

    return false;
}

// encode a blob for indexeddb engines that don't support blobs
function _encodeBlob(blob) {
    return new Promise$1(function (resolve, reject) {
        var reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = function (e) {
            var base64 = btoa(e.target.result || '');
            resolve({
                __local_forage_encoded_blob: true,
                data: base64,
                type: blob.type
            });
        };
        reader.readAsBinaryString(blob);
    });
}

// decode an encoded blob
function _decodeBlob(encodedBlob) {
    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
    return createBlob([arrayBuff], { type: encodedBlob.type });
}

// is this one of our fancy encoded blobs?
function _isEncodedBlob(value) {
    return value && value.__local_forage_encoded_blob;
}

// Specialize the default `ready()` function by making it dependent
// on the current database operations. Thus, the driver will be actually
// ready when it's been initialized (default) *and* there are no pending
// operations on the database (initiated by some other instances).
function _fullyReady(callback) {
    var self = this;

    var promise = self._initReady().then(function () {
        var dbContext = dbContexts[self._dbInfo.name];

        if (dbContext && dbContext.dbReady) {
            return dbContext.dbReady;
        }
    });

    executeTwoCallbacks(promise, callback, callback);
    return promise;
}

// Try to establish a new db connection to replace the
// current one which is broken (i.e. experiencing
// InvalidStateError while creating a transaction).
function _tryReconnect(dbInfo) {
    _deferReadiness(dbInfo);

    var dbContext = dbContexts[dbInfo.name];
    var forages = dbContext.forages;

    for (var i = 0; i < forages.length; i++) {
        var forage = forages[i];
        if (forage._dbInfo.db) {
            forage._dbInfo.db.close();
            forage._dbInfo.db = null;
        }
    }
    dbInfo.db = null;

    return _getOriginalConnection(dbInfo).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        // store the latest db reference
        // in case the db was upgraded
        dbInfo.db = dbContext.db = db;
        for (var i = 0; i < forages.length; i++) {
            forages[i]._dbInfo.db = db;
        }
    })["catch"](function (err) {
        _rejectReadiness(dbInfo, err);
        throw err;
    });
}

// FF doesn't like Promises (micro-tasks) and IDDB store operations,
// so we have to do it with callbacks
function createTransaction(dbInfo, mode, callback, retries) {
    if (retries === undefined) {
        retries = 1;
    }

    try {
        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
        callback(null, tx);
    } catch (err) {
        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
            return Promise$1.resolve().then(function () {
                if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                    // increase the db version, to create the new ObjectStore
                    if (dbInfo.db) {
                        dbInfo.version = dbInfo.db.version + 1;
                    }
                    // Reopen the database for upgrading.
                    return _getUpgradedConnection(dbInfo);
                }
            }).then(function () {
                return _tryReconnect(dbInfo).then(function () {
                    createTransaction(dbInfo, mode, callback, retries - 1);
                });
            })["catch"](callback);
        }

        callback(err);
    }
}

function createDbContext() {
    return {
        // Running localForages sharing a database.
        forages: [],
        // Shared database.
        db: null,
        // Database readiness (promise).
        dbReady: null,
        // Deferred operations on the database.
        deferredOperations: []
    };
}

// Open the IndexedDB database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    // Get the current context of the database;
    var dbContext = dbContexts[dbInfo.name];

    // ...or create a new context.
    if (!dbContext) {
        dbContext = createDbContext();
        // Register the new context in the global container.
        dbContexts[dbInfo.name] = dbContext;
    }

    // Register itself as a running localForage in the current context.
    dbContext.forages.push(self);

    // Replace the default `ready()` function with the specialized one.
    if (!self._initReady) {
        self._initReady = self.ready;
        self.ready = _fullyReady;
    }

    // Create an array of initialization states of the related localForages.
    var initPromises = [];

    function ignoreErrors() {
        // Don't handle errors here,
        // just makes sure related localForages aren't pending.
        return Promise$1.resolve();
    }

    for (var j = 0; j < dbContext.forages.length; j++) {
        var forage = dbContext.forages[j];
        if (forage !== self) {
            // Don't wait for itself...
            initPromises.push(forage._initReady()["catch"](ignoreErrors));
        }
    }

    // Take a snapshot of the related localForages.
    var forages = dbContext.forages.slice(0);

    // Initialize the connection process only when
    // all the related localForages aren't pending.
    return Promise$1.all(initPromises).then(function () {
        dbInfo.db = dbContext.db;
        // Get the connection or open a new one without upgrade.
        return _getOriginalConnection(dbInfo);
    }).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        dbInfo.db = dbContext.db = db;
        self._dbInfo = dbInfo;
        // Share the final connection amongst related localForages.
        for (var k = 0; k < forages.length; k++) {
            var forage = forages[k];
            if (forage !== self) {
                // Self is already up-to-date.
                forage._dbInfo.db = dbInfo.db;
                forage._dbInfo.version = dbInfo.version;
            }
        }
    });
}

function getItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.get(key);

                    req.onsuccess = function () {
                        var value = req.result;
                        if (value === undefined) {
                            value = null;
                        }
                        if (_isEncodedBlob(value)) {
                            value = _decodeBlob(value);
                        }
                        resolve(value);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items stored in database.
function iterate(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openCursor();
                    var iterationNumber = 1;

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (cursor) {
                            var value = cursor.value;
                            if (_isEncodedBlob(value)) {
                                value = _decodeBlob(value);
                            }
                            var result = iterator(value, cursor.key, iterationNumber++);

                            // when the iterator callback retuns any
                            // (non-`undefined`) value, then we stop
                            // the iteration immediately
                            if (result !== void 0) {
                                resolve(result);
                            } else {
                                cursor["continue"]();
                            }
                        } else {
                            resolve();
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);

    return promise;
}

function setItem(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        var dbInfo;
        self.ready().then(function () {
            dbInfo = self._dbInfo;
            if (toString.call(value) === '[object Blob]') {
                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
                    if (blobSupport) {
                        return value;
                    }
                    return _encodeBlob(value);
                });
            }
            return value;
        }).then(function (value) {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);

                    // The reason we don't _save_ null is because IE 10 does
                    // not support saving the `null` type in IndexedDB. How
                    // ironic, given the bug below!
                    // See: https://github.com/mozilla/localForage/issues/161
                    if (value === null) {
                        value = undefined;
                    }

                    var req = store.put(value, key);

                    transaction.oncomplete = function () {
                        // Cast to undefined so the value passed to
                        // callback/promise is the same as what one would get out
                        // of `getItem()` later. This leads to some weirdness
                        // (setItem('foo', undefined) will return `null`), but
                        // it's not my fault localStorage is our baseline and that
                        // it's weird.
                        if (value === undefined) {
                            value = null;
                        }

                        resolve(value);
                    };
                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function removeItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    // We use a Grunt task to make this safe for IE and some
                    // versions of Android (including those used by Cordova).
                    // Normally IE won't like `.delete()` and will insist on
                    // using `['delete']()`, but we have a build step that
                    // fixes this for us now.
                    var req = store["delete"](key);
                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onerror = function () {
                        reject(req.error);
                    };

                    // The request will be also be aborted if we've exceeded our storage
                    // space.
                    transaction.onabort = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function clear(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.clear();

                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function length(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.count();

                    req.onsuccess = function () {
                        resolve(req.result);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function key(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        if (n < 0) {
            resolve(null);

            return;
        }

        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var advanced = false;
                    var req = store.openCursor();

                    req.onsuccess = function () {
                        var cursor = req.result;
                        if (!cursor) {
                            // this means there weren't enough keys
                            resolve(null);

                            return;
                        }

                        if (n === 0) {
                            // We have the first key, return it if that's what they
                            // wanted.
                            resolve(cursor.key);
                        } else {
                            if (!advanced) {
                                // Otherwise, ask the cursor to skip ahead n
                                // records.
                                advanced = true;
                                cursor.advance(n);
                            } else {
                                // When we get here, we've got the nth key.
                                resolve(cursor.key);
                            }
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openCursor();
                    var keys = [];

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (!cursor) {
                            resolve(keys);
                            return;
                        }

                        keys.push(cursor.key);
                        cursor["continue"]();
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;

        var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
            var dbContext = dbContexts[options.name];
            var forages = dbContext.forages;
            dbContext.db = db;
            for (var i = 0; i < forages.length; i++) {
                forages[i]._dbInfo.db = db;
            }
            return db;
        });

        if (!options.storeName) {
            promise = dbPromise.then(function (db) {
                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                }

                var dropDBPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.deleteDatabase(options.name);

                    req.onerror = req.onblocked = function (err) {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        reject(err);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        resolve(db);
                    };
                });

                return dropDBPromise.then(function (db) {
                    dbContext.db = db;
                    for (var i = 0; i < forages.length; i++) {
                        var _forage = forages[i];
                        _advanceReadiness(_forage._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        } else {
            promise = dbPromise.then(function (db) {
                if (!db.objectStoreNames.contains(options.storeName)) {
                    return;
                }

                var newVersion = db.version + 1;

                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                    forage._dbInfo.version = newVersion;
                }

                var dropObjectPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.open(options.name, newVersion);

                    req.onerror = function (err) {
                        var db = req.result;
                        db.close();
                        reject(err);
                    };

                    req.onupgradeneeded = function () {
                        var db = req.result;
                        db.deleteObjectStore(options.storeName);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        db.close();
                        resolve(db);
                    };
                });

                return dropObjectPromise.then(function (db) {
                    dbContext.db = db;
                    for (var j = 0; j < forages.length; j++) {
                        var _forage2 = forages[j];
                        _forage2._dbInfo.db = db;
                        _advanceReadiness(_forage2._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        }
    }

    executeCallback(promise, callback);
    return promise;
}

var asyncStorage = {
    _driver: 'asyncStorage',
    _initStorage: _initStorage,
    _support: isIndexedDBValid(),
    iterate: iterate,
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem,
    clear: clear,
    length: length,
    key: key,
    keys: keys,
    dropInstance: dropInstance
};

function isWebSQLValid() {
    return typeof openDatabase === 'function';
}

// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
// it to Base64, so this is how we store it to prevent very strange errors with less
// verbose ways of binary <-> string data storage.
var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

var BLOB_TYPE_PREFIX = '~~local_forage_type~';
var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

var SERIALIZED_MARKER = '__lfsc__:';
var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

// OMG the serializations!
var TYPE_ARRAYBUFFER = 'arbf';
var TYPE_BLOB = 'blob';
var TYPE_INT8ARRAY = 'si08';
var TYPE_UINT8ARRAY = 'ui08';
var TYPE_UINT8CLAMPEDARRAY = 'uic8';
var TYPE_INT16ARRAY = 'si16';
var TYPE_INT32ARRAY = 'si32';
var TYPE_UINT16ARRAY = 'ur16';
var TYPE_UINT32ARRAY = 'ui32';
var TYPE_FLOAT32ARRAY = 'fl32';
var TYPE_FLOAT64ARRAY = 'fl64';
var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

var toString$1 = Object.prototype.toString;

function stringToBuffer(serializedString) {
    // Fill the string into a ArrayBuffer.
    var bufferLength = serializedString.length * 0.75;
    var len = serializedString.length;
    var i;
    var p = 0;
    var encoded1, encoded2, encoded3, encoded4;

    if (serializedString[serializedString.length - 1] === '=') {
        bufferLength--;
        if (serializedString[serializedString.length - 2] === '=') {
            bufferLength--;
        }
    }

    var buffer = new ArrayBuffer(bufferLength);
    var bytes = new Uint8Array(buffer);

    for (i = 0; i < len; i += 4) {
        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

        /*jslint bitwise: true */
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return buffer;
}

// Converts a buffer to a string to store, serialized, in the backend
// storage library.
function bufferToString(buffer) {
    // base64-arraybuffer
    var bytes = new Uint8Array(buffer);
    var base64String = '';
    var i;

    for (i = 0; i < bytes.length; i += 3) {
        /*jslint bitwise: true */
        base64String += BASE_CHARS[bytes[i] >> 2];
        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64String += BASE_CHARS[bytes[i + 2] & 63];
    }

    if (bytes.length % 3 === 2) {
        base64String = base64String.substring(0, base64String.length - 1) + '=';
    } else if (bytes.length % 3 === 1) {
        base64String = base64String.substring(0, base64String.length - 2) + '==';
    }

    return base64String;
}

// Serialize a value, afterwards executing a callback (which usually
// instructs the `setItem()` callback/promise to be executed). This is how
// we store binary data with localStorage.
function serialize(value, callback) {
    var valueType = '';
    if (value) {
        valueType = toString$1.call(value);
    }

    // Cannot use `value instanceof ArrayBuffer` or such here, as these
    // checks fail when running the tests using casper.js...
    //
    // TODO: See why those tests fail and use a better solution.
    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
        // Convert binary arrays to a string and prefix the string with
        // a special marker.
        var buffer;
        var marker = SERIALIZED_MARKER;

        if (value instanceof ArrayBuffer) {
            buffer = value;
            marker += TYPE_ARRAYBUFFER;
        } else {
            buffer = value.buffer;

            if (valueType === '[object Int8Array]') {
                marker += TYPE_INT8ARRAY;
            } else if (valueType === '[object Uint8Array]') {
                marker += TYPE_UINT8ARRAY;
            } else if (valueType === '[object Uint8ClampedArray]') {
                marker += TYPE_UINT8CLAMPEDARRAY;
            } else if (valueType === '[object Int16Array]') {
                marker += TYPE_INT16ARRAY;
            } else if (valueType === '[object Uint16Array]') {
                marker += TYPE_UINT16ARRAY;
            } else if (valueType === '[object Int32Array]') {
                marker += TYPE_INT32ARRAY;
            } else if (valueType === '[object Uint32Array]') {
                marker += TYPE_UINT32ARRAY;
            } else if (valueType === '[object Float32Array]') {
                marker += TYPE_FLOAT32ARRAY;
            } else if (valueType === '[object Float64Array]') {
                marker += TYPE_FLOAT64ARRAY;
            } else {
                callback(new Error('Failed to get type for BinaryArray'));
            }
        }

        callback(marker + bufferToString(buffer));
    } else if (valueType === '[object Blob]') {
        // Conver the blob to a binaryArray and then to a string.
        var fileReader = new FileReader();

        fileReader.onload = function () {
            // Backwards-compatible prefix for the blob type.
            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
        };

        fileReader.readAsArrayBuffer(value);
    } else {
        try {
            callback(JSON.stringify(value));
        } catch (e) {
            console.error("Couldn't convert value into a JSON string: ", value);

            callback(null, e);
        }
    }
}

// Deserialize data we've inserted into a value column/field. We place
// special markers into our strings to mark them as encoded; this isn't
// as nice as a meta field, but it's the only sane thing we can do whilst
// keeping localStorage support intact.
//
// Oftentimes this will just deserialize JSON content, but if we have a
// special marker (SERIALIZED_MARKER, defined above), we will extract
// some kind of arraybuffer/binary data/typed array out of the string.
function deserialize(value) {
    // If we haven't marked this string as being specially serialized (i.e.
    // something other than serialized JSON), we can just return it and be
    // done with it.
    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
        return JSON.parse(value);
    }

    // The following code deals with deserializing some kind of Blob or
    // TypedArray. First we separate out the type of data we're dealing
    // with from the data itself.
    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

    var blobType;
    // Backwards-compatible blob type serialization strategy.
    // DBs created with older versions of localForage will simply not have the blob type.
    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
        blobType = matcher[1];
        serializedString = serializedString.substring(matcher[0].length);
    }
    var buffer = stringToBuffer(serializedString);

    // Return the right type based on the code/type set during
    // serialization.
    switch (type) {
        case TYPE_ARRAYBUFFER:
            return buffer;
        case TYPE_BLOB:
            return createBlob([buffer], { type: blobType });
        case TYPE_INT8ARRAY:
            return new Int8Array(buffer);
        case TYPE_UINT8ARRAY:
            return new Uint8Array(buffer);
        case TYPE_UINT8CLAMPEDARRAY:
            return new Uint8ClampedArray(buffer);
        case TYPE_INT16ARRAY:
            return new Int16Array(buffer);
        case TYPE_UINT16ARRAY:
            return new Uint16Array(buffer);
        case TYPE_INT32ARRAY:
            return new Int32Array(buffer);
        case TYPE_UINT32ARRAY:
            return new Uint32Array(buffer);
        case TYPE_FLOAT32ARRAY:
            return new Float32Array(buffer);
        case TYPE_FLOAT64ARRAY:
            return new Float64Array(buffer);
        default:
            throw new Error('Unkown type: ' + type);
    }
}

var localforageSerializer = {
    serialize: serialize,
    deserialize: deserialize,
    stringToBuffer: stringToBuffer,
    bufferToString: bufferToString
};

/*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */

function createDbTable(t, dbInfo, callback, errorCallback) {
    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
}

// Open the WebSQL database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage$1(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
        }
    }

    var dbInfoPromise = new Promise$1(function (resolve, reject) {
        // Open the database; the openDatabase API will automatically
        // create it for us if it doesn't exist.
        try {
            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
        } catch (e) {
            return reject(e);
        }

        // Create our key/value table if it doesn't exist.
        dbInfo.db.transaction(function (t) {
            createDbTable(t, dbInfo, function () {
                self._dbInfo = dbInfo;
                resolve();
            }, function (t, error) {
                reject(error);
            });
        }, reject);
    });

    dbInfo.serializer = localforageSerializer;
    return dbInfoPromise;
}

function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
    t.executeSql(sqlStatement, args, callback, function (t, error) {
        if (error.code === error.SYNTAX_ERR) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
                if (!results.rows.length) {
                    // if the table is missing (was deleted)
                    // re-create it table and retry
                    createDbTable(t, dbInfo, function () {
                        t.executeSql(sqlStatement, args, callback, errorCallback);
                    }, errorCallback);
                } else {
                    errorCallback(t, error);
                }
            }, errorCallback);
        } else {
            errorCallback(t, error);
        }
    }, errorCallback);
}

function getItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).value : null;

                    // Check to see if this is serialized content we need to
                    // unpack.
                    if (result) {
                        result = dbInfo.serializer.deserialize(result);
                    }

                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function iterate$1(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;

            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
                    var rows = results.rows;
                    var length = rows.length;

                    for (var i = 0; i < length; i++) {
                        var item = rows.item(i);
                        var result = item.value;

                        // Check to see if this is serialized content
                        // we need to unpack.
                        if (result) {
                            result = dbInfo.serializer.deserialize(result);
                        }

                        result = iterator(result, item.key, i + 1);

                        // void(0) prevents problems with redefinition
                        // of `undefined`.
                        if (result !== void 0) {
                            resolve(result);
                            return;
                        }
                    }

                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function _setItem(key, value, callback, retriesLeft) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            // The localStorage API doesn't return undefined values in an
            // "expected" way, so undefined is always cast to null in all
            // drivers. See: https://github.com/mozilla/localForage/pull/42
            if (value === undefined) {
                value = null;
            }

            // Save the original value to pass to the callback.
            var originalValue = value;

            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    dbInfo.db.transaction(function (t) {
                        tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
                            resolve(originalValue);
                        }, function (t, error) {
                            reject(error);
                        });
                    }, function (sqlError) {
                        // The transaction failed; check
                        // to see if it's a quota error.
                        if (sqlError.code === sqlError.QUOTA_ERR) {
                            // We reject the callback outright for now, but
                            // it's worth trying to re-run the transaction.
                            // Even if the user accepts the prompt to use
                            // more storage on Safari, this error will
                            // be called.
                            //
                            // Try to re-run the transaction.
                            if (retriesLeft > 0) {
                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
                                return;
                            }
                            reject(sqlError);
                        }
                    });
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function setItem$1(key, value, callback) {
    return _setItem.apply(this, [key, value, callback, 1]);
}

function removeItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Deletes every item in the table.
// TODO: Find out if this resets the AUTO_INCREMENT number.
function clear$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Does a simple `COUNT(key)` to get the number of items stored in
// localForage.
function length$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                // Ahhh, SQL makes this one soooooo easy.
                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
                    var result = results.rows.item(0).c;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Return the key located at key index X; essentially gets the key from a
// `WHERE id = ?`. This is the most efficient way I can think to implement
// this rarely-used (in my experience) part of the API, but it can seem
// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
// the ID of each key will change every time it's updated. Perhaps a stored
// procedure for the `setItem()` SQL would solve this problem?
// TODO: Don't change ID on `setItem()`.
function key$1(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).key : null;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
                    var keys = [];

                    for (var i = 0; i < results.rows.length; i++) {
                        keys.push(results.rows.item(i).key);
                    }

                    resolve(keys);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// https://www.w3.org/TR/webdatabase/#databases
// > There is no way to enumerate or delete the databases available for an origin from this API.
function getAllStoreNames(db) {
    return new Promise$1(function (resolve, reject) {
        db.transaction(function (t) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
                var storeNames = [];

                for (var i = 0; i < results.rows.length; i++) {
                    storeNames.push(results.rows.item(i).name);
                }

                resolve({
                    db: db,
                    storeNames: storeNames
                });
            }, function (t, error) {
                reject(error);
            });
        }, function (sqlError) {
            reject(sqlError);
        });
    });
}

function dropInstance$1(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            var db;
            if (options.name === currentConfig.name) {
                // use the db reference of the current instance
                db = self._dbInfo.db;
            } else {
                db = openDatabase(options.name, '', '', 0);
            }

            if (!options.storeName) {
                // drop all database tables
                resolve(getAllStoreNames(db));
            } else {
                resolve({
                    db: db,
                    storeNames: [options.storeName]
                });
            }
        }).then(function (operationInfo) {
            return new Promise$1(function (resolve, reject) {
                operationInfo.db.transaction(function (t) {
                    function dropTable(storeName) {
                        return new Promise$1(function (resolve, reject) {
                            t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
                                resolve();
                            }, function (t, error) {
                                reject(error);
                            });
                        });
                    }

                    var operations = [];
                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
                        operations.push(dropTable(operationInfo.storeNames[i]));
                    }

                    Promise$1.all(operations).then(function () {
                        resolve();
                    })["catch"](function (e) {
                        reject(e);
                    });
                }, function (sqlError) {
                    reject(sqlError);
                });
            });
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var webSQLStorage = {
    _driver: 'webSQLStorage',
    _initStorage: _initStorage$1,
    _support: isWebSQLValid(),
    iterate: iterate$1,
    getItem: getItem$1,
    setItem: setItem$1,
    removeItem: removeItem$1,
    clear: clear$1,
    length: length$1,
    key: key$1,
    keys: keys$1,
    dropInstance: dropInstance$1
};

function isLocalStorageValid() {
    try {
        return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
        // in IE8 typeof localStorage.setItem === 'object'
        !!localStorage.setItem;
    } catch (e) {
        return false;
    }
}

function _getKeyPrefix(options, defaultConfig) {
    var keyPrefix = options.name + '/';

    if (options.storeName !== defaultConfig.storeName) {
        keyPrefix += options.storeName + '/';
    }
    return keyPrefix;
}

// Check if localStorage throws when saving an item
function checkIfLocalStorageThrows() {
    var localStorageTestKey = '_localforage_support_test';

    try {
        localStorage.setItem(localStorageTestKey, true);
        localStorage.removeItem(localStorageTestKey);

        return false;
    } catch (e) {
        return true;
    }
}

// Check if localStorage is usable and allows to save an item
// This method checks if localStorage is usable in Safari Private Browsing
// mode, or in any other case where the available quota for localStorage
// is 0 and there wasn't any saved items yet.
function _isLocalStorageUsable() {
    return !checkIfLocalStorageThrows() || localStorage.length > 0;
}

// Config the localStorage backend, using options set in the config.
function _initStorage$2(options) {
    var self = this;
    var dbInfo = {};
    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);

    if (!_isLocalStorageUsable()) {
        return Promise$1.reject();
    }

    self._dbInfo = dbInfo;
    dbInfo.serializer = localforageSerializer;

    return Promise$1.resolve();
}

// Remove all keys from the datastore, effectively destroying all data in
// the app's key/value store!
function clear$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var keyPrefix = self._dbInfo.keyPrefix;

        for (var i = localStorage.length - 1; i >= 0; i--) {
            var key = localStorage.key(i);

            if (key.indexOf(keyPrefix) === 0) {
                localStorage.removeItem(key);
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Retrieve an item from the store. Unlike the original async_storage
// library in Gaia, we don't modify return values at all. If a key's value
// is `undefined`, we pass that value to the callback function.
function getItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result = localStorage.getItem(dbInfo.keyPrefix + key);

        // If a result was found, parse it from the serialized
        // string into a JS object. If result isn't truthy, the key
        // is likely undefined and we'll pass it straight to the
        // callback.
        if (result) {
            result = dbInfo.serializer.deserialize(result);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items in the store.
function iterate$2(iterator, callback) {
    var self = this;

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var keyPrefix = dbInfo.keyPrefix;
        var keyPrefixLength = keyPrefix.length;
        var length = localStorage.length;

        // We use a dedicated iterator instead of the `i` variable below
        // so other keys we fetch in localStorage aren't counted in
        // the `iterationNumber` argument passed to the `iterate()`
        // callback.
        //
        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
        var iterationNumber = 1;

        for (var i = 0; i < length; i++) {
            var key = localStorage.key(i);
            if (key.indexOf(keyPrefix) !== 0) {
                continue;
            }
            var value = localStorage.getItem(key);

            // If a result was found, parse it from the serialized
            // string into a JS object. If result isn't truthy, the
            // key is likely undefined and we'll pass it straight
            // to the iterator.
            if (value) {
                value = dbInfo.serializer.deserialize(value);
            }

            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

            if (value !== void 0) {
                return value;
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Same as localStorage's key() method, except takes a callback.
function key$2(n, callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result;
        try {
            result = localStorage.key(n);
        } catch (error) {
            result = null;
        }

        // Remove the prefix from the key, if a key is found.
        if (result) {
            result = result.substring(dbInfo.keyPrefix.length);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var length = localStorage.length;
        var keys = [];

        for (var i = 0; i < length; i++) {
            var itemKey = localStorage.key(i);
            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
                keys.push(itemKey.substring(dbInfo.keyPrefix.length));
            }
        }

        return keys;
    });

    executeCallback(promise, callback);
    return promise;
}

// Supply the number of keys in the datastore to the callback function.
function length$2(callback) {
    var self = this;
    var promise = self.keys().then(function (keys) {
        return keys.length;
    });

    executeCallback(promise, callback);
    return promise;
}

// Remove an item from the store, nice and simple.
function removeItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        localStorage.removeItem(dbInfo.keyPrefix + key);
    });

    executeCallback(promise, callback);
    return promise;
}

// Set a key's value and run an optional callback once the value is set.
// Unlike Gaia's implementation, the callback function is passed the value,
// in case you want to operate on that value only after you're sure it
// saved, or something like that.
function setItem$2(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        // Convert undefined values to null.
        // https://github.com/mozilla/localForage/pull/42
        if (value === undefined) {
            value = null;
        }

        // Save the original value to pass to the callback.
        var originalValue = value;

        return new Promise$1(function (resolve, reject) {
            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    try {
                        localStorage.setItem(dbInfo.keyPrefix + key, value);
                        resolve(originalValue);
                    } catch (e) {
                        // localStorage capacity exceeded.
                        // TODO: Make this a specific error/event.
                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                            reject(e);
                        }
                        reject(e);
                    }
                }
            });
        });
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance$2(options, callback) {
    callback = getCallback.apply(this, arguments);

    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        var currentConfig = this.config();
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            if (!options.storeName) {
                resolve(options.name + '/');
            } else {
                resolve(_getKeyPrefix(options, self._defaultConfig));
            }
        }).then(function (keyPrefix) {
            for (var i = localStorage.length - 1; i >= 0; i--) {
                var key = localStorage.key(i);

                if (key.indexOf(keyPrefix) === 0) {
                    localStorage.removeItem(key);
                }
            }
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var localStorageWrapper = {
    _driver: 'localStorageWrapper',
    _initStorage: _initStorage$2,
    _support: isLocalStorageValid(),
    iterate: iterate$2,
    getItem: getItem$2,
    setItem: setItem$2,
    removeItem: removeItem$2,
    clear: clear$2,
    length: length$2,
    key: key$2,
    keys: keys$2,
    dropInstance: dropInstance$2
};

var sameValue = function sameValue(x, y) {
    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
};

var includes = function includes(array, searchElement) {
    var len = array.length;
    var i = 0;
    while (i < len) {
        if (sameValue(array[i], searchElement)) {
            return true;
        }
        i++;
    }

    return false;
};

var isArray = Array.isArray || function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
};

// Drivers are stored here when `defineDriver()` is called.
// They are shared across all instances of localForage.
var DefinedDrivers = {};

var DriverSupport = {};

var DefaultDrivers = {
    INDEXEDDB: asyncStorage,
    WEBSQL: webSQLStorage,
    LOCALSTORAGE: localStorageWrapper
};

var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];

var OptionalDriverMethods = ['dropInstance'];

var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);

var DefaultConfig = {
    description: '',
    driver: DefaultDriverOrder.slice(),
    name: 'localforage',
    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
    // we can use without a prompt.
    size: 4980736,
    storeName: 'keyvaluepairs',
    version: 1.0
};

function callWhenReady(localForageInstance, libraryMethod) {
    localForageInstance[libraryMethod] = function () {
        var _args = arguments;
        return localForageInstance.ready().then(function () {
            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
        });
    };
}

function extend() {
    for (var i = 1; i < arguments.length; i++) {
        var arg = arguments[i];

        if (arg) {
            for (var _key in arg) {
                if (arg.hasOwnProperty(_key)) {
                    if (isArray(arg[_key])) {
                        arguments[0][_key] = arg[_key].slice();
                    } else {
                        arguments[0][_key] = arg[_key];
                    }
                }
            }
        }
    }

    return arguments[0];
}

var LocalForage = function () {
    function LocalForage(options) {
        _classCallCheck(this, LocalForage);

        for (var driverTypeKey in DefaultDrivers) {
            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                var driver = DefaultDrivers[driverTypeKey];
                var driverName = driver._driver;
                this[driverTypeKey] = driverName;

                if (!DefinedDrivers[driverName]) {
                    // we don't need to wait for the promise,
                    // since the default drivers can be defined
                    // in a blocking manner
                    this.defineDriver(driver);
                }
            }
        }

        this._defaultConfig = extend({}, DefaultConfig);
        this._config = extend({}, this._defaultConfig, options);
        this._driverSet = null;
        this._initDriver = null;
        this._ready = false;
        this._dbInfo = null;

        this._wrapLibraryMethodsWithReady();
        this.setDriver(this._config.driver)["catch"](function () {});
    }

    // Set any config values for localForage; can be called anytime before
    // the first API call (e.g. `getItem`, `setItem`).
    // We loop through options so we don't overwrite existing config
    // values.


    LocalForage.prototype.config = function config(options) {
        // If the options argument is an object, we use it to set values.
        // Otherwise, we return either a specified config value or all
        // config values.
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            // If localforage is ready and fully initialized, we can't set
            // any new configuration values. Instead, we return an error.
            if (this._ready) {
                return new Error("Can't call config() after localforage " + 'has been used.');
            }

            for (var i in options) {
                if (i === 'storeName') {
                    options[i] = options[i].replace(/\W/g, '_');
                }

                if (i === 'version' && typeof options[i] !== 'number') {
                    return new Error('Database version must be a number.');
                }

                this._config[i] = options[i];
            }

            // after all config options are set and
            // the driver option is used, try setting it
            if ('driver' in options && options.driver) {
                return this.setDriver(this._config.driver);
            }

            return true;
        } else if (typeof options === 'string') {
            return this._config[options];
        } else {
            return this._config;
        }
    };

    // Used to define a custom driver, shared across all instances of
    // localForage.


    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
        var promise = new Promise$1(function (resolve, reject) {
            try {
                var driverName = driverObject._driver;
                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');

                // A driver name should be defined and not overlap with the
                // library-defined, default drivers.
                if (!driverObject._driver) {
                    reject(complianceError);
                    return;
                }

                var driverMethods = LibraryMethods.concat('_initStorage');
                for (var i = 0, len = driverMethods.length; i < len; i++) {
                    var driverMethodName = driverMethods[i];

                    // when the property is there,
                    // it should be a method even when optional
                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
                        reject(complianceError);
                        return;
                    }
                }

                var configureMissingMethods = function configureMissingMethods() {
                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                        return function () {
                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
                            var promise = Promise$1.reject(error);
                            executeCallback(promise, arguments[arguments.length - 1]);
                            return promise;
                        };
                    };

                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
                        var optionalDriverMethod = OptionalDriverMethods[_i];
                        if (!driverObject[optionalDriverMethod]) {
                            driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                        }
                    }
                };

                configureMissingMethods();

                var setDriverSupport = function setDriverSupport(support) {
                    if (DefinedDrivers[driverName]) {
                        console.info('Redefining LocalForage driver: ' + driverName);
                    }
                    DefinedDrivers[driverName] = driverObject;
                    DriverSupport[driverName] = support;
                    // don't use a then, so that we can define
                    // drivers that have simple _support methods
                    // in a blocking manner
                    resolve();
                };

                if ('_support' in driverObject) {
                    if (driverObject._support && typeof driverObject._support === 'function') {
                        driverObject._support().then(setDriverSupport, reject);
                    } else {
                        setDriverSupport(!!driverObject._support);
                    }
                } else {
                    setDriverSupport(true);
                }
            } catch (e) {
                reject(e);
            }
        });

        executeTwoCallbacks(promise, callback, errorCallback);
        return promise;
    };

    LocalForage.prototype.driver = function driver() {
        return this._driver || null;
    };

    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));

        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
        return getDriverPromise;
    };

    LocalForage.prototype.getSerializer = function getSerializer(callback) {
        var serializerPromise = Promise$1.resolve(localforageSerializer);
        executeTwoCallbacks(serializerPromise, callback);
        return serializerPromise;
    };

    LocalForage.prototype.ready = function ready(callback) {
        var self = this;

        var promise = self._driverSet.then(function () {
            if (self._ready === null) {
                self._ready = self._initDriver();
            }

            return self._ready;
        });

        executeTwoCallbacks(promise, callback, callback);
        return promise;
    };

    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
        var self = this;

        if (!isArray(drivers)) {
            drivers = [drivers];
        }

        var supportedDrivers = this._getSupportedDrivers(drivers);

        function setDriverToConfig() {
            self._config.driver = self.driver();
        }

        function extendSelfWithDriver(driver) {
            self._extend(driver);
            setDriverToConfig();

            self._ready = self._initStorage(self._config);
            return self._ready;
        }

        function initDriver(supportedDrivers) {
            return function () {
                var currentDriverIndex = 0;

                function driverPromiseLoop() {
                    while (currentDriverIndex < supportedDrivers.length) {
                        var driverName = supportedDrivers[currentDriverIndex];
                        currentDriverIndex++;

                        self._dbInfo = null;
                        self._ready = null;

                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                    }

                    setDriverToConfig();
                    var error = new Error('No available storage method found.');
                    self._driverSet = Promise$1.reject(error);
                    return self._driverSet;
                }

                return driverPromiseLoop();
            };
        }

        // There might be a driver initialization in progress
        // so wait for it to finish in order to avoid a possible
        // race condition to set _dbInfo
        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
            return Promise$1.resolve();
        }) : Promise$1.resolve();

        this._driverSet = oldDriverSetDone.then(function () {
            var driverName = supportedDrivers[0];
            self._dbInfo = null;
            self._ready = null;

            return self.getDriver(driverName).then(function (driver) {
                self._driver = driver._driver;
                setDriverToConfig();
                self._wrapLibraryMethodsWithReady();
                self._initDriver = initDriver(supportedDrivers);
            });
        })["catch"](function () {
            setDriverToConfig();
            var error = new Error('No available storage method found.');
            self._driverSet = Promise$1.reject(error);
            return self._driverSet;
        });

        executeTwoCallbacks(this._driverSet, callback, errorCallback);
        return this._driverSet;
    };

    LocalForage.prototype.supports = function supports(driverName) {
        return !!DriverSupport[driverName];
    };

    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
        extend(this, libraryMethodsAndProperties);
    };

    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
        var supportedDrivers = [];
        for (var i = 0, len = drivers.length; i < len; i++) {
            var driverName = drivers[i];
            if (this.supports(driverName)) {
                supportedDrivers.push(driverName);
            }
        }
        return supportedDrivers;
    };

    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
        // Add a stub for each driver API method that delays the call to the
        // corresponding driver method until localForage is ready. These stubs
        // will be replaced by the driver methods as soon as the driver is
        // loaded, so there is no performance impact.
        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
            callWhenReady(this, LibraryMethods[i]);
        }
    };

    LocalForage.prototype.createInstance = function createInstance(options) {
        return new LocalForage(options);
    };

    return LocalForage;
}();

// The actual localForage object that we expose as a module or via a
// global. It's extended by pulling in one of our other libraries.


var localforage_js = new LocalForage();

module.exports = localforage_js;

},{"3":3}]},{},[4])(4)
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/lodash-es/_DataView.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__("./node_modules/lodash-es/_getNative.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");



/* Built-in method references that are verified to be native. */
var DataView = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),

/***/ "./node_modules/lodash-es/_Hash.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hashClear_js__ = __webpack_require__("./node_modules/lodash-es/_hashClear.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__ = __webpack_require__("./node_modules/lodash-es/_hashDelete.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hashGet_js__ = __webpack_require__("./node_modules/lodash-es/_hashGet.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashHas_js__ = __webpack_require__("./node_modules/lodash-es/_hashHas.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hashSet_js__ = __webpack_require__("./node_modules/lodash-es/_hashSet.js");






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__hashClear_js__["a" /* default */];
Hash.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__["a" /* default */];
Hash.prototype.get = __WEBPACK_IMPORTED_MODULE_2__hashGet_js__["a" /* default */];
Hash.prototype.has = __WEBPACK_IMPORTED_MODULE_3__hashHas_js__["a" /* default */];
Hash.prototype.set = __WEBPACK_IMPORTED_MODULE_4__hashSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Hash);


/***/ }),

/***/ "./node_modules/lodash-es/_ListCache.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__ = __webpack_require__("./node_modules/lodash-es/_listCacheClear.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__ = __webpack_require__("./node_modules/lodash-es/_listCacheDelete.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__ = __webpack_require__("./node_modules/lodash-es/_listCacheGet.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__ = __webpack_require__("./node_modules/lodash-es/_listCacheHas.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__ = __webpack_require__("./node_modules/lodash-es/_listCacheSet.js");






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__["a" /* default */];
ListCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__["a" /* default */];
ListCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__["a" /* default */];
ListCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__["a" /* default */];
ListCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (ListCache);


/***/ }),

/***/ "./node_modules/lodash-es/_Map.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__("./node_modules/lodash-es/_getNative.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),

/***/ "./node_modules/lodash-es/_MapCache.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__ = __webpack_require__("./node_modules/lodash-es/_mapCacheClear.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__ = __webpack_require__("./node_modules/lodash-es/_mapCacheDelete.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__ = __webpack_require__("./node_modules/lodash-es/_mapCacheGet.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__ = __webpack_require__("./node_modules/lodash-es/_mapCacheHas.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__ = __webpack_require__("./node_modules/lodash-es/_mapCacheSet.js");






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__["a" /* default */];
MapCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__["a" /* default */];
MapCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__["a" /* default */];
MapCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__["a" /* default */];
MapCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (MapCache);


/***/ }),

/***/ "./node_modules/lodash-es/_Promise.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__("./node_modules/lodash-es/_getNative.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");



/* Built-in method references that are verified to be native. */
var Promise = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),

/***/ "./node_modules/lodash-es/_Set.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__("./node_modules/lodash-es/_getNative.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),

/***/ "./node_modules/lodash-es/_SetCache.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__("./node_modules/lodash-es/_MapCache.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__ = __webpack_require__("./node_modules/lodash-es/_setCacheAdd.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__ = __webpack_require__("./node_modules/lodash-es/_setCacheHas.js");




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__["a" /* default */];
SetCache.prototype.has = __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (SetCache);


/***/ }),

/***/ "./node_modules/lodash-es/_Stack.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__("./node_modules/lodash-es/_ListCache.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stackClear_js__ = __webpack_require__("./node_modules/lodash-es/_stackClear.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__ = __webpack_require__("./node_modules/lodash-es/_stackDelete.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stackGet_js__ = __webpack_require__("./node_modules/lodash-es/_stackGet.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stackHas_js__ = __webpack_require__("./node_modules/lodash-es/_stackHas.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stackSet_js__ = __webpack_require__("./node_modules/lodash-es/_stackSet.js");







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */](entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = __WEBPACK_IMPORTED_MODULE_1__stackClear_js__["a" /* default */];
Stack.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__["a" /* default */];
Stack.prototype.get = __WEBPACK_IMPORTED_MODULE_3__stackGet_js__["a" /* default */];
Stack.prototype.has = __WEBPACK_IMPORTED_MODULE_4__stackHas_js__["a" /* default */];
Stack.prototype.set = __WEBPACK_IMPORTED_MODULE_5__stackSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Stack);


/***/ }),

/***/ "./node_modules/lodash-es/_Symbol.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),

/***/ "./node_modules/lodash-es/_Uint8Array.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");


/** Built-in value references. */
var Uint8Array = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Uint8Array;

/* harmony default export */ __webpack_exports__["a"] = (Uint8Array);


/***/ }),

/***/ "./node_modules/lodash-es/_WeakMap.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__("./node_modules/lodash-es/_getNative.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),

/***/ "./node_modules/lodash-es/_arrayFilter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayFilter);


/***/ }),

/***/ "./node_modules/lodash-es/_arrayLikeKeys.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__("./node_modules/lodash-es/_baseTimes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__("./node_modules/lodash-es/isArguments.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__("./node_modules/lodash-es/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__("./node_modules/lodash-es/isBuffer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__("./node_modules/lodash-es/_isIndex.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__("./node_modules/lodash-es/isTypedArray.js");







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && Object(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? Object(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),

/***/ "./node_modules/lodash-es/_arrayMap.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),

/***/ "./node_modules/lodash-es/_arrayPush.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayPush);


/***/ }),

/***/ "./node_modules/lodash-es/_arraySome.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (arraySome);


/***/ }),

/***/ "./node_modules/lodash-es/_asciiSize.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseProperty_js__ = __webpack_require__("./node_modules/lodash-es/_baseProperty.js");


/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = Object(__WEBPACK_IMPORTED_MODULE_0__baseProperty_js__["a" /* default */])('length');

/* harmony default export */ __webpack_exports__["a"] = (asciiSize);


/***/ }),

/***/ "./node_modules/lodash-es/_asciiToArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/* harmony default export */ __webpack_exports__["a"] = (asciiToArray);


/***/ }),

/***/ "./node_modules/lodash-es/_assocIndexOf.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__("./node_modules/lodash-es/eq.js");


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (assocIndexOf);


/***/ }),

/***/ "./node_modules/lodash-es/_baseFindIndex.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (baseFindIndex);


/***/ }),

/***/ "./node_modules/lodash-es/_baseGet.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__("./node_modules/lodash-es/_castPath.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toKey_js__ = __webpack_require__("./node_modules/lodash-es/_toKey.js");



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[Object(__WEBPACK_IMPORTED_MODULE_1__toKey_js__["a" /* default */])(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (baseGet);


/***/ }),

/***/ "./node_modules/lodash-es/_baseGetAllKeys.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__("./node_modules/lodash-es/_arrayPush.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__("./node_modules/lodash-es/isArray.js");



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(object) ? result : Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, symbolsFunc(object));
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetAllKeys);


/***/ }),

/***/ "./node_modules/lodash-es/_baseGetTag.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__("./node_modules/lodash-es/_Symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__("./node_modules/lodash-es/_getRawTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__("./node_modules/lodash-es/_objectToString.js");




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),

/***/ "./node_modules/lodash-es/_baseHas.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHas);


/***/ }),

/***/ "./node_modules/lodash-es/_baseHasIn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHasIn);


/***/ }),

/***/ "./node_modules/lodash-es/_baseIsArguments.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("./node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__("./node_modules/lodash-es/isObjectLike.js");



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),

/***/ "./node_modules/lodash-es/_baseIsEqual.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__ = __webpack_require__("./node_modules/lodash-es/_baseIsEqualDeep.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__("./node_modules/lodash-es/isObjectLike.js");



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(other))) {
    return value !== value && other !== other;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__["a" /* default */])(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqual);


/***/ }),

/***/ "./node_modules/lodash-es/_baseIsEqualDeep.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__("./node_modules/lodash-es/_Stack.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equalArrays_js__ = __webpack_require__("./node_modules/lodash-es/_equalArrays.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equalByTag_js__ = __webpack_require__("./node_modules/lodash-es/_equalByTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalObjects_js__ = __webpack_require__("./node_modules/lodash-es/_equalObjects.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getTag_js__ = __webpack_require__("./node_modules/lodash-es/_getTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArray_js__ = __webpack_require__("./node_modules/lodash-es/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isBuffer_js__ = __webpack_require__("./node_modules/lodash-es/isBuffer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__("./node_modules/lodash-es/isTypedArray.js");









/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(object),
      othIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(other),
      objTag = objIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(object),
      othTag = othIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(object)) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    return (objIsArr || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(object))
      ? Object(__WEBPACK_IMPORTED_MODULE_1__equalArrays_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack)
      : Object(__WEBPACK_IMPORTED_MODULE_2__equalByTag_js__["a" /* default */])(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  return Object(__WEBPACK_IMPORTED_MODULE_3__equalObjects_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqualDeep);


/***/ }),

/***/ "./node_modules/lodash-es/_baseIsMatch.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__("./node_modules/lodash-es/_Stack.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__ = __webpack_require__("./node_modules/lodash-es/_baseIsEqual.js");



/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */];
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? Object(__WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMatch);


/***/ }),

/***/ "./node_modules/lodash-es/_baseIsNative.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__("./node_modules/lodash-es/isFunction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__("./node_modules/lodash-es/_isMasked.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__("./node_modules/lodash-es/isObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__("./node_modules/lodash-es/_toSource.js");





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),

/***/ "./node_modules/lodash-es/_baseIsTypedArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("./node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__("./node_modules/lodash-es/isLength.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__("./node_modules/lodash-es/isObjectLike.js");




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),

/***/ "./node_modules/lodash-es/_baseIteratee.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMatches_js__ = __webpack_require__("./node_modules/lodash-es/_baseMatches.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__ = __webpack_require__("./node_modules/lodash-es/_baseMatchesProperty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__("./node_modules/lodash-es/identity.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__("./node_modules/lodash-es/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__property_js__ = __webpack_require__("./node_modules/lodash-es/property.js");






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */];
  }
  if (typeof value == 'object') {
    return Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value)
      ? Object(__WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__["a" /* default */])(value[0], value[1])
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseMatches_js__["a" /* default */])(value);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_4__property_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIteratee);


/***/ }),

/***/ "./node_modules/lodash-es/_baseKeys.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__("./node_modules/lodash-es/_isPrototype.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__("./node_modules/lodash-es/_nativeKeys.js");



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),

/***/ "./node_modules/lodash-es/_baseMatches.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__ = __webpack_require__("./node_modules/lodash-es/_baseIsMatch.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getMatchData_js__ = __webpack_require__("./node_modules/lodash-es/_getMatchData.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__ = __webpack_require__("./node_modules/lodash-es/_matchesStrictComparable.js");




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = Object(__WEBPACK_IMPORTED_MODULE_1__getMatchData_js__["a" /* default */])(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__["a" /* default */])(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || Object(__WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__["a" /* default */])(object, source, matchData);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatches);


/***/ }),

/***/ "./node_modules/lodash-es/_baseMatchesProperty.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__("./node_modules/lodash-es/_baseIsEqual.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_js__ = __webpack_require__("./node_modules/lodash-es/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasIn_js__ = __webpack_require__("./node_modules/lodash-es/hasIn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isKey_js__ = __webpack_require__("./node_modules/lodash-es/_isKey.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__ = __webpack_require__("./node_modules/lodash-es/_isStrictComparable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__ = __webpack_require__("./node_modules/lodash-es/_matchesStrictComparable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toKey_js__ = __webpack_require__("./node_modules/lodash-es/_toKey.js");








/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isKey_js__["a" /* default */])(path) && Object(__WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__["a" /* default */])(srcValue)) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toKey_js__["a" /* default */])(path), srcValue);
  }
  return function(object) {
    var objValue = Object(__WEBPACK_IMPORTED_MODULE_1__get_js__["a" /* default */])(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? Object(__WEBPACK_IMPORTED_MODULE_2__hasIn_js__["a" /* default */])(object, path)
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatchesProperty);


/***/ }),

/***/ "./node_modules/lodash-es/_baseProperty.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseProperty);


/***/ }),

/***/ "./node_modules/lodash-es/_basePropertyDeep.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__("./node_modules/lodash-es/_baseGet.js");


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (basePropertyDeep);


/***/ }),

/***/ "./node_modules/lodash-es/_baseRepeat.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor;

/**
 * The base implementation of `_.repeat` which doesn't coerce arguments.
 *
 * @private
 * @param {string} string The string to repeat.
 * @param {number} n The number of times to repeat the string.
 * @returns {string} Returns the repeated string.
 */
function baseRepeat(string, n) {
  var result = '';
  if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
    return result;
  }
  // Leverage the exponentiation by squaring algorithm for a faster repeat.
  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
  do {
    if (n % 2) {
      result += string;
    }
    n = nativeFloor(n / 2);
    if (n) {
      string += string;
    }
  } while (n);

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseRepeat);


/***/ }),

/***/ "./node_modules/lodash-es/_baseSlice.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseSlice);


/***/ }),

/***/ "./node_modules/lodash-es/_baseTimes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),

/***/ "./node_modules/lodash-es/_baseToString.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__("./node_modules/lodash-es/_Symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__("./node_modules/lodash-es/_arrayMap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__("./node_modules/lodash-es/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__("./node_modules/lodash-es/isSymbol.js");





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),

/***/ "./node_modules/lodash-es/_baseUnary.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),

/***/ "./node_modules/lodash-es/_cacheHas.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (cacheHas);


/***/ }),

/***/ "./node_modules/lodash-es/_castPath.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__("./node_modules/lodash-es/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isKey_js__ = __webpack_require__("./node_modules/lodash-es/_isKey.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToPath_js__ = __webpack_require__("./node_modules/lodash-es/_stringToPath.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__("./node_modules/lodash-es/toString.js");





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return value;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__isKey_js__["a" /* default */])(value, object) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_2__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["default"])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (castPath);


/***/ }),

/***/ "./node_modules/lodash-es/_castSlice.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSlice_js__ = __webpack_require__("./node_modules/lodash-es/_baseSlice.js");


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : Object(__WEBPACK_IMPORTED_MODULE_0__baseSlice_js__["a" /* default */])(array, start, end);
}

/* harmony default export */ __webpack_exports__["a"] = (castSlice);


/***/ }),

/***/ "./node_modules/lodash-es/_coreJsData.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),

/***/ "./node_modules/lodash-es/_createCaseFirst.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castSlice_js__ = __webpack_require__("./node_modules/lodash-es/_castSlice.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__ = __webpack_require__("./node_modules/lodash-es/_hasUnicode.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToArray_js__ = __webpack_require__("./node_modules/lodash-es/_stringToArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__("./node_modules/lodash-es/toString.js");





/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["default"])(string);

    var strSymbols = Object(__WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__["a" /* default */])(string)
      ? Object(__WEBPACK_IMPORTED_MODULE_2__stringToArray_js__["a" /* default */])(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? Object(__WEBPACK_IMPORTED_MODULE_0__castSlice_js__["a" /* default */])(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createCaseFirst);


/***/ }),

/***/ "./node_modules/lodash-es/_createPadding.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRepeat_js__ = __webpack_require__("./node_modules/lodash-es/_baseRepeat.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseToString_js__ = __webpack_require__("./node_modules/lodash-es/_baseToString.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__castSlice_js__ = __webpack_require__("./node_modules/lodash-es/_castSlice.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hasUnicode_js__ = __webpack_require__("./node_modules/lodash-es/_hasUnicode.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stringSize_js__ = __webpack_require__("./node_modules/lodash-es/_stringSize.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stringToArray_js__ = __webpack_require__("./node_modules/lodash-es/_stringToArray.js");







/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil;

/**
 * Creates the padding for `string` based on `length`. The `chars` string
 * is truncated if the number of characters exceeds `length`.
 *
 * @private
 * @param {number} length The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padding for `string`.
 */
function createPadding(length, chars) {
  chars = chars === undefined ? ' ' : Object(__WEBPACK_IMPORTED_MODULE_1__baseToString_js__["a" /* default */])(chars);

  var charsLength = chars.length;
  if (charsLength < 2) {
    return charsLength ? Object(__WEBPACK_IMPORTED_MODULE_0__baseRepeat_js__["a" /* default */])(chars, length) : chars;
  }
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__baseRepeat_js__["a" /* default */])(chars, nativeCeil(length / Object(__WEBPACK_IMPORTED_MODULE_4__stringSize_js__["a" /* default */])(chars)));
  return Object(__WEBPACK_IMPORTED_MODULE_3__hasUnicode_js__["a" /* default */])(chars)
    ? Object(__WEBPACK_IMPORTED_MODULE_2__castSlice_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__stringToArray_js__["a" /* default */])(result), 0, length).join('')
    : result.slice(0, length);
}

/* harmony default export */ __webpack_exports__["a"] = (createPadding);


/***/ }),

/***/ "./node_modules/lodash-es/_equalArrays.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__("./node_modules/lodash-es/_SetCache.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arraySome_js__ = __webpack_require__("./node_modules/lodash-es/_arraySome.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cacheHas_js__ = __webpack_require__("./node_modules/lodash-es/_cacheHas.js");




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */] : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__arraySome_js__["a" /* default */])(other, function(othValue, othIndex) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__cacheHas_js__["a" /* default */])(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalArrays);


/***/ }),

/***/ "./node_modules/lodash-es/_equalByTag.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__("./node_modules/lodash-es/_Symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__ = __webpack_require__("./node_modules/lodash-es/_Uint8Array.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eq_js__ = __webpack_require__("./node_modules/lodash-es/eq.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalArrays_js__ = __webpack_require__("./node_modules/lodash-es/_equalArrays.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__ = __webpack_require__("./node_modules/lodash-es/_mapToArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setToArray_js__ = __webpack_require__("./node_modules/lodash-es/_setToArray.js");







/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](object), new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return Object(__WEBPACK_IMPORTED_MODULE_2__eq_js__["a" /* default */])(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__["a" /* default */];

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = __WEBPACK_IMPORTED_MODULE_5__setToArray_js__["a" /* default */]);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = Object(__WEBPACK_IMPORTED_MODULE_3__equalArrays_js__["a" /* default */])(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (equalByTag);


/***/ }),

/***/ "./node_modules/lodash-es/_equalObjects.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__ = __webpack_require__("./node_modules/lodash-es/_getAllKeys.js");


/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(object),
      objLength = objProps.length,
      othProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalObjects);


/***/ }),

/***/ "./node_modules/lodash-es/_freeGlobal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/lodash-es/_getAllKeys.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__("./node_modules/lodash-es/_baseGetAllKeys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__("./node_modules/lodash-es/_getSymbols.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__("./node_modules/lodash-es/keys.js");




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeys);


/***/ }),

/***/ "./node_modules/lodash-es/_getMapData.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isKeyable_js__ = __webpack_require__("./node_modules/lodash-es/_isKeyable.js");


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return Object(__WEBPACK_IMPORTED_MODULE_0__isKeyable_js__["a" /* default */])(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ __webpack_exports__["a"] = (getMapData);


/***/ }),

/***/ "./node_modules/lodash-es/_getMatchData.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__ = __webpack_require__("./node_modules/lodash-es/_isStrictComparable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__("./node_modules/lodash-es/keys.js");



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, Object(__WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__["a" /* default */])(value)];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getMatchData);


/***/ }),

/***/ "./node_modules/lodash-es/_getNative.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__("./node_modules/lodash-es/_baseIsNative.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__("./node_modules/lodash-es/_getValue.js");



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),

/***/ "./node_modules/lodash-es/_getRawTag.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__("./node_modules/lodash-es/_Symbol.js");


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),

/***/ "./node_modules/lodash-es/_getSymbols.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__("./node_modules/lodash-es/_arrayFilter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubArray_js__ = __webpack_require__("./node_modules/lodash-es/stubArray.js");



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_1__stubArray_js__["a" /* default */] : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbols);


/***/ }),

/***/ "./node_modules/lodash-es/_getTag.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__("./node_modules/lodash-es/_DataView.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__("./node_modules/lodash-es/_Map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__("./node_modules/lodash-es/_Promise.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__("./node_modules/lodash-es/_Set.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__("./node_modules/lodash-es/_WeakMap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__("./node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__("./node_modules/lodash-es/_toSource.js");








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),

/***/ "./node_modules/lodash-es/_getValue.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),

/***/ "./node_modules/lodash-es/_hasPath.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__("./node_modules/lodash-es/_castPath.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__("./node_modules/lodash-es/isArguments.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__("./node_modules/lodash-es/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIndex_js__ = __webpack_require__("./node_modules/lodash-es/_isIndex.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isLength_js__ = __webpack_require__("./node_modules/lodash-es/isLength.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__("./node_modules/lodash-es/_toKey.js");







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = Object(__WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */])(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && Object(__WEBPACK_IMPORTED_MODULE_4__isLength_js__["a" /* default */])(length) && Object(__WEBPACK_IMPORTED_MODULE_3__isIndex_js__["a" /* default */])(key, length) &&
    (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(object) || Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (hasPath);


/***/ }),

/***/ "./node_modules/lodash-es/_hasUnicode.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/* harmony default export */ __webpack_exports__["a"] = (hasUnicode);


/***/ }),

/***/ "./node_modules/lodash-es/_hashClear.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__("./node_modules/lodash-es/_nativeCreate.js");


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? Object(__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */])(null) : {};
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (hashClear);


/***/ }),

/***/ "./node_modules/lodash-es/_hashDelete.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (hashDelete);


/***/ }),

/***/ "./node_modules/lodash-es/_hashGet.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__("./node_modules/lodash-es/_nativeCreate.js");


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */]) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (hashGet);


/***/ }),

/***/ "./node_modules/lodash-es/_hashHas.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__("./node_modules/lodash-es/_nativeCreate.js");


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/* harmony default export */ __webpack_exports__["a"] = (hashHas);


/***/ }),

/***/ "./node_modules/lodash-es/_hashSet.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__("./node_modules/lodash-es/_nativeCreate.js");


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (hashSet);


/***/ }),

/***/ "./node_modules/lodash-es/_isIndex.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),

/***/ "./node_modules/lodash-es/_isKey.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__("./node_modules/lodash-es/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__("./node_modules/lodash-es/isSymbol.js");



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ __webpack_exports__["a"] = (isKey);


/***/ }),

/***/ "./node_modules/lodash-es/_isKeyable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ __webpack_exports__["a"] = (isKeyable);


/***/ }),

/***/ "./node_modules/lodash-es/_isMasked.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__("./node_modules/lodash-es/_coreJsData.js");


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),

/***/ "./node_modules/lodash-es/_isPrototype.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),

/***/ "./node_modules/lodash-es/_isStrictComparable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__("./node_modules/lodash-es/isObject.js");


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isStrictComparable);


/***/ }),

/***/ "./node_modules/lodash-es/_listCacheClear.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheClear);


/***/ }),

/***/ "./node_modules/lodash-es/_listCacheDelete.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__("./node_modules/lodash-es/_assocIndexOf.js");


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheDelete);


/***/ }),

/***/ "./node_modules/lodash-es/_listCacheGet.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__("./node_modules/lodash-es/_assocIndexOf.js");


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheGet);


/***/ }),

/***/ "./node_modules/lodash-es/_listCacheHas.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__("./node_modules/lodash-es/_assocIndexOf.js");


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(this.__data__, key) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheHas);


/***/ }),

/***/ "./node_modules/lodash-es/_listCacheSet.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__("./node_modules/lodash-es/_assocIndexOf.js");


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheSet);


/***/ }),

/***/ "./node_modules/lodash-es/_mapCacheClear.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hash_js__ = __webpack_require__("./node_modules/lodash-es/_Hash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListCache_js__ = __webpack_require__("./node_modules/lodash-es/_ListCache.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_js__ = __webpack_require__("./node_modules/lodash-es/_Map.js");




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */],
    'map': new (__WEBPACK_IMPORTED_MODULE_2__Map_js__["a" /* default */] || __WEBPACK_IMPORTED_MODULE_1__ListCache_js__["a" /* default */]),
    'string': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheClear);


/***/ }),

/***/ "./node_modules/lodash-es/_mapCacheDelete.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__("./node_modules/lodash-es/_getMapData.js");


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheDelete);


/***/ }),

/***/ "./node_modules/lodash-es/_mapCacheGet.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__("./node_modules/lodash-es/_getMapData.js");


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheGet);


/***/ }),

/***/ "./node_modules/lodash-es/_mapCacheHas.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__("./node_modules/lodash-es/_getMapData.js");


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheHas);


/***/ }),

/***/ "./node_modules/lodash-es/_mapCacheSet.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__("./node_modules/lodash-es/_getMapData.js");


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheSet);


/***/ }),

/***/ "./node_modules/lodash-es/_mapToArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapToArray);


/***/ }),

/***/ "./node_modules/lodash-es/_matchesStrictComparable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (matchesStrictComparable);


/***/ }),

/***/ "./node_modules/lodash-es/_memoizeCapped.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoize_js__ = __webpack_require__("./node_modules/lodash-es/memoize.js");


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__memoize_js__["a" /* default */])(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeCapped);


/***/ }),

/***/ "./node_modules/lodash-es/_nativeCreate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__("./node_modules/lodash-es/_getNative.js");


/* Built-in method references that are verified to be native. */
var nativeCreate = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'create');

/* harmony default export */ __webpack_exports__["a"] = (nativeCreate);


/***/ }),

/***/ "./node_modules/lodash-es/_nativeKeys.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__("./node_modules/lodash-es/_overArg.js");


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),

/***/ "./node_modules/lodash-es/_nodeUtil.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__("./node_modules/lodash-es/_freeGlobal.js");


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/webpack/buildin/harmony-module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash-es/_objectToString.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),

/***/ "./node_modules/lodash-es/_overArg.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),

/***/ "./node_modules/lodash-es/_root.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__("./node_modules/lodash-es/_freeGlobal.js");


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),

/***/ "./node_modules/lodash-es/_setCacheAdd.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheAdd);


/***/ }),

/***/ "./node_modules/lodash-es/_setCacheHas.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheHas);


/***/ }),

/***/ "./node_modules/lodash-es/_setToArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (setToArray);


/***/ }),

/***/ "./node_modules/lodash-es/_stackClear.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__("./node_modules/lodash-es/_ListCache.js");


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (stackClear);


/***/ }),

/***/ "./node_modules/lodash-es/_stackDelete.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (stackDelete);


/***/ }),

/***/ "./node_modules/lodash-es/_stackGet.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackGet);


/***/ }),

/***/ "./node_modules/lodash-es/_stackHas.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackHas);


/***/ }),

/***/ "./node_modules/lodash-es/_stackSet.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__("./node_modules/lodash-es/_ListCache.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__("./node_modules/lodash-es/_Map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapCache_js__ = __webpack_require__("./node_modules/lodash-es/_MapCache.js");




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */]) {
    var pairs = data.__data__;
    if (!__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_2__MapCache_js__["a" /* default */](pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (stackSet);


/***/ }),

/***/ "./node_modules/lodash-es/_stringSize.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__asciiSize_js__ = __webpack_require__("./node_modules/lodash-es/_asciiSize.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__ = __webpack_require__("./node_modules/lodash-es/_hasUnicode.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unicodeSize_js__ = __webpack_require__("./node_modules/lodash-es/_unicodeSize.js");




/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__["a" /* default */])(string)
    ? Object(__WEBPACK_IMPORTED_MODULE_2__unicodeSize_js__["a" /* default */])(string)
    : Object(__WEBPACK_IMPORTED_MODULE_0__asciiSize_js__["a" /* default */])(string);
}

/* harmony default export */ __webpack_exports__["a"] = (stringSize);


/***/ }),

/***/ "./node_modules/lodash-es/_stringToArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__asciiToArray_js__ = __webpack_require__("./node_modules/lodash-es/_asciiToArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__ = __webpack_require__("./node_modules/lodash-es/_hasUnicode.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unicodeToArray_js__ = __webpack_require__("./node_modules/lodash-es/_unicodeToArray.js");




/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__["a" /* default */])(string)
    ? Object(__WEBPACK_IMPORTED_MODULE_2__unicodeToArray_js__["a" /* default */])(string)
    : Object(__WEBPACK_IMPORTED_MODULE_0__asciiToArray_js__["a" /* default */])(string);
}

/* harmony default export */ __webpack_exports__["a"] = (stringToArray);


/***/ }),

/***/ "./node_modules/lodash-es/_stringToPath.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__ = __webpack_require__("./node_modules/lodash-es/_memoizeCapped.js");


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = Object(__WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__["a" /* default */])(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (stringToPath);


/***/ }),

/***/ "./node_modules/lodash-es/_toKey.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__("./node_modules/lodash-es/isSymbol.js");


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (toKey);


/***/ }),

/***/ "./node_modules/lodash-es/_toSource.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),

/***/ "./node_modules/lodash-es/_unicodeSize.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (unicodeSize);


/***/ }),

/***/ "./node_modules/lodash-es/_unicodeToArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/* harmony default export */ __webpack_exports__["a"] = (unicodeToArray);


/***/ }),

/***/ "./node_modules/lodash-es/capitalize.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toString_js__ = __webpack_require__("./node_modules/lodash-es/toString.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__upperFirst_js__ = __webpack_require__("./node_modules/lodash-es/upperFirst.js");



/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__upperFirst_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__toString_js__["default"])(string).toLowerCase());
}

/* harmony default export */ __webpack_exports__["default"] = (capitalize);


/***/ }),

/***/ "./node_modules/lodash-es/debounce.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__("./node_modules/lodash-es/isObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__now_js__ = __webpack_require__("./node_modules/lodash-es/now.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toNumber_js__ = __webpack_require__("./node_modules/lodash-es/toNumber.js");




/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(wait) || 0;
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(Object(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])());
  }

  function debounced() {
    var time = Object(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/* harmony default export */ __webpack_exports__["default"] = (debounce);


/***/ }),

/***/ "./node_modules/lodash-es/eq.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["a"] = (eq);


/***/ }),

/***/ "./node_modules/lodash-es/findIndex.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__ = __webpack_require__("./node_modules/lodash-es/_baseFindIndex.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__("./node_modules/lodash-es/_baseIteratee.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_js__ = __webpack_require__("./node_modules/lodash-es/toInteger.js");




/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__["a" /* default */])(array, Object(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(predicate, 3), index);
}

/* harmony default export */ __webpack_exports__["default"] = (findIndex);


/***/ }),

/***/ "./node_modules/lodash-es/get.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__("./node_modules/lodash-es/_baseGet.js");


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ __webpack_exports__["a"] = (get);


/***/ }),

/***/ "./node_modules/lodash-es/has.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHas_js__ = __webpack_require__("./node_modules/lodash-es/_baseHas.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__("./node_modules/lodash-es/_hasPath.js");



/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && Object(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHas_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["default"] = (has);


/***/ }),

/***/ "./node_modules/lodash-es/hasIn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__ = __webpack_require__("./node_modules/lodash-es/_baseHasIn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__("./node_modules/lodash-es/_hasPath.js");



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && Object(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (hasIn);


/***/ }),

/***/ "./node_modules/lodash-es/identity.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),

/***/ "./node_modules/lodash-es/isArguments.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__("./node_modules/lodash-es/_baseIsArguments.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__("./node_modules/lodash-es/isObjectLike.js");



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),

/***/ "./node_modules/lodash-es/isArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),

/***/ "./node_modules/lodash-es/isArrayLike.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__("./node_modules/lodash-es/isFunction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__("./node_modules/lodash-es/isLength.js");



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),

/***/ "./node_modules/lodash-es/isBuffer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__("./node_modules/lodash-es/stubFalse.js");



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/webpack/buildin/harmony-module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash-es/isEqual.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__("./node_modules/lodash-es/_baseIsEqual.js");


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other);
}

/* harmony default export */ __webpack_exports__["default"] = (isEqual);


/***/ }),

/***/ "./node_modules/lodash-es/isFunction.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("./node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__("./node_modules/lodash-es/isObject.js");



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),

/***/ "./node_modules/lodash-es/isLength.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),

/***/ "./node_modules/lodash-es/isNil.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

/* harmony default export */ __webpack_exports__["default"] = (isNil);


/***/ }),

/***/ "./node_modules/lodash-es/isObject.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),

/***/ "./node_modules/lodash-es/isObjectLike.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),

/***/ "./node_modules/lodash-es/isSymbol.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("./node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__("./node_modules/lodash-es/isObjectLike.js");



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),

/***/ "./node_modules/lodash-es/isTypedArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__("./node_modules/lodash-es/_baseIsTypedArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__("./node_modules/lodash-es/_baseUnary.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__("./node_modules/lodash-es/_nodeUtil.js");




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),

/***/ "./node_modules/lodash-es/keys.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__("./node_modules/lodash-es/_arrayLikeKeys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__("./node_modules/lodash-es/_baseKeys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__("./node_modules/lodash-es/isArrayLike.js");




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),

/***/ "./node_modules/lodash-es/memoize.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__("./node_modules/lodash-es/_MapCache.js");


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */]);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),

/***/ "./node_modules/lodash-es/now.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Date.now();
};

/* harmony default export */ __webpack_exports__["a"] = (now);


/***/ }),

/***/ "./node_modules/lodash-es/padStart.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPadding_js__ = __webpack_require__("./node_modules/lodash-es/_createPadding.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringSize_js__ = __webpack_require__("./node_modules/lodash-es/_stringSize.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_js__ = __webpack_require__("./node_modules/lodash-es/toInteger.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__("./node_modules/lodash-es/toString.js");





/**
 * Pads `string` on the left side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padStart('abc', 6);
 * // => '   abc'
 *
 * _.padStart('abc', 6, '_-');
 * // => '_-_abc'
 *
 * _.padStart('abc', 3);
 * // => 'abc'
 */
function padStart(string, length, chars) {
  string = Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["default"])(string);
  length = Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(length);

  var strLength = length ? Object(__WEBPACK_IMPORTED_MODULE_1__stringSize_js__["a" /* default */])(string) : 0;
  return (length && strLength < length)
    ? (Object(__WEBPACK_IMPORTED_MODULE_0__createPadding_js__["a" /* default */])(length - strLength, chars) + string)
    : string;
}

/* harmony default export */ __webpack_exports__["default"] = (padStart);


/***/ }),

/***/ "./node_modules/lodash-es/property.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseProperty_js__ = __webpack_require__("./node_modules/lodash-es/_baseProperty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__ = __webpack_require__("./node_modules/lodash-es/_basePropertyDeep.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isKey_js__ = __webpack_require__("./node_modules/lodash-es/_isKey.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toKey_js__ = __webpack_require__("./node_modules/lodash-es/_toKey.js");





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isKey_js__["a" /* default */])(path) ? Object(__WEBPACK_IMPORTED_MODULE_0__baseProperty_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toKey_js__["a" /* default */])(path)) : Object(__WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__["a" /* default */])(path);
}

/* harmony default export */ __webpack_exports__["a"] = (property);


/***/ }),

/***/ "./node_modules/lodash-es/stubArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (stubArray);


/***/ }),

/***/ "./node_modules/lodash-es/stubFalse.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),

/***/ "./node_modules/lodash-es/toFinite.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toNumber_js__ = __webpack_require__("./node_modules/lodash-es/toNumber.js");


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = Object(__WEBPACK_IMPORTED_MODULE_0__toNumber_js__["a" /* default */])(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (toFinite);


/***/ }),

/***/ "./node_modules/lodash-es/toInteger.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toFinite_js__ = __webpack_require__("./node_modules/lodash-es/toFinite.js");


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__toFinite_js__["a" /* default */])(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (toInteger);


/***/ }),

/***/ "./node_modules/lodash-es/toNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__("./node_modules/lodash-es/isObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__("./node_modules/lodash-es/isSymbol.js");



/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return NAN;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* harmony default export */ __webpack_exports__["a"] = (toNumber);


/***/ }),

/***/ "./node_modules/lodash-es/toString.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__("./node_modules/lodash-es/_baseToString.js");


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["default"] = (toString);


/***/ }),

/***/ "./node_modules/lodash-es/upperFirst.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCaseFirst_js__ = __webpack_require__("./node_modules/lodash-es/_createCaseFirst.js");


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = Object(__WEBPACK_IMPORTED_MODULE_0__createCaseFirst_js__["a" /* default */])('toUpperCase');

/* harmony default export */ __webpack_exports__["a"] = (upperFirst);


/***/ }),

/***/ "./node_modules/lunr/lunr.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.6
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.6"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().trim().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null. This token will not be passed to any downstream pipeline functions and will not be
 * added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),

/***/ "./node_modules/mobx-react-devtools/index.js":
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__("./node_modules/react/react.js"),__webpack_require__("./node_modules/mobx/lib/mobx.module.js"),__webpack_require__("./node_modules/mobx-react/index.module.js")):"function"==typeof define&&define.amd?define(["react","mobx","mobx-react"],t):"object"==typeof exports?exports.mobxDevtools=t(require("react"),require("mobx"),require("mobx-react")):e.mobxDevtools=t(e.React,e.mobx,e.mobxReact)}(this,function(e,t,n){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.setLogEnabled=t.setGraphEnabled=t.setUpdatesEnabled=t.configureDevtool=t.UpdatesControl=t.LogControl=t.GraphControl=t.default=void 0;var o=n(1);Object.defineProperty(t,"default",{enumerable:!0,get:function(){return r(o).default}});var i=n(19);Object.defineProperty(t,"GraphControl",{enumerable:!0,get:function(){return r(i).default}});var a=n(20);Object.defineProperty(t,"LogControl",{enumerable:!0,get:function(){return r(a).default}});var u=n(21);Object.defineProperty(t,"UpdatesControl",{enumerable:!0,get:function(){return r(u).default}});var l=n(37),s=r(l),c=n(12);s.default.polyfill();var f=t.configureDevtool=function(e){var t=e.logEnabled,n=e.updatesEnabled,r=e.graphEnabled,o=e.logFilter,i={};void 0!==t&&(i.logEnabled=Boolean(t)),void 0!==n&&(i.updatesEnabled=Boolean(n)),void 0!==r&&(i.graphEnabled=Boolean(r)),"function"==typeof o&&(i.logFilter=o),(0,c.setGlobalState)(i)};t.setUpdatesEnabled=function(e){return f({updatesEnabled:e})},t.setGraphEnabled=function(e){return f({graphEnabled:e})},t.setLogEnabled=function(e){return f({logEnabled:e})}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(2),s=r(l),c=n(3),f=r(c),d=n(12),p=n(18),h=r(p),g=n(31),y=r(g),b=n(33),v=r(b),m=function(e){function t(){var e,n,r,a;o(this,t);for(var u=arguments.length,l=Array(u),s=0;s<u;s++)l[s]=arguments[s];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),r.handleUpdate=function(){return r.setState((0,d.getGlobalState)())},r.handleToggleGraph=function(){r.setState({hoverBoxes:[],graphEnabled:!r.state.graphEnabled})},a=n,i(r,a)}return a(t,e),u(t,[{key:"componentWillMount",value:function(){this.setState((0,d.getGlobalState)())}},{key:"componentDidMount",value:function(){d.eventEmitter.on("update",this.handleUpdate)}},{key:"componentWillUnmount",value:function(){d.eventEmitter.removeListener("update",this.handleUpdate)}},{key:"render",value:function(){var e=this.props,t=e.noPanel,n=e.highlightTimeout,r=this.state,o=r.renderingBoxes,i=r.hoverBoxes;return s.default.createElement("div",null,t!==!0&&s.default.createElement(h.default,{position:this.props.position,highlightTimeout:n}),s.default.createElement(y.default,{boxes:o.concat(i)}),s.default.createElement(v.default,null))}}]),t}(l.Component);m.propTypes={highlightTimeout:f.default.number,position:f.default.object,noPanel:f.default.bool},m.defaultProps={noPanel:!1},t.default=m},function(t,n){t.exports=e},function(e,t,n){(function(t){if("production"!==t.env.NODE_ENV){var r="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103,o=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===r},i=!0;e.exports=n(5)(o,i)}else e.exports=n(11)()}).call(t,n(4))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(c===setTimeout)return setTimeout(e,0);if((c===n||!c)&&setTimeout)return c=setTimeout,setTimeout(e,0);try{return c(e,0)}catch(t){try{return c.call(null,e,0)}catch(t){return c.call(this,e,0)}}}function i(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function a(){g&&p&&(g=!1,p.length?h=p.concat(h):y=-1,h.length&&u())}function u(){if(!g){var e=o(a);g=!0;for(var t=h.length;t;){for(p=h,h=[];++y<t;)p&&p[y].run();y=-1,t=h.length}p=null,g=!1,i(e)}}function l(e,t){this.fun=e,this.array=t}function s(){}var c,f,d=e.exports={};!function(){try{c="function"==typeof setTimeout?setTimeout:n}catch(e){c=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var p,h=[],g=!1,y=-1;d.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];h.push(new l(e,t)),1!==h.length||g||o(u)},l.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=s,d.addListener=s,d.once=s,d.off=s,d.removeListener=s,d.removeAllListeners=s,d.emit=s,d.prependListener=s,d.prependOnceListener=s,d.listeners=function(e){return[]},d.binding=function(e){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(e){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(e,t,n){(function(t){"use strict";var r=n(6),o=n(7),i=n(8),a=n(9),u=n(10);e.exports=function(e,n){function l(e){var t=e&&(P&&e[P]||e[T]);if("function"==typeof t)return t}function s(e,t){return e===t?0!==e||1/e===1/t:e!==e&&t!==t}function c(e){this.message=e,this.stack=""}function f(e){function r(r,s,f,d,p,h,g){if(d=d||A,h=h||f,g!==a)if(n)o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");else if("production"!==t.env.NODE_ENV&&"undefined"!=typeof console){var y=d+":"+f;!u[y]&&l<3&&(i(!1,"You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.",h,d),u[y]=!0,l++)}return null==s[f]?r?new c(null===s[f]?"The "+p+" `"+h+"` is marked as required "+("in `"+d+"`, but its value is `null`."):"The "+p+" `"+h+"` is marked as required in "+("`"+d+"`, but its value is `undefined`.")):null:e(s,f,d,p,h)}if("production"!==t.env.NODE_ENV)var u={},l=0;var s=r.bind(null,!1);return s.isRequired=r.bind(null,!0),s}function d(e){function t(t,n,r,o,i,a){var u=t[n],l=E(u);if(l!==e){var s=j(u);return new c("Invalid "+o+" `"+i+"` of type "+("`"+s+"` supplied to `"+r+"`, expected ")+("`"+e+"`."))}return null}return f(t)}function p(){return f(r.thatReturnsNull)}function h(e){function t(t,n,r,o,i){if("function"!=typeof e)return new c("Property `"+i+"` of component `"+r+"` has invalid PropType notation inside arrayOf.");var u=t[n];if(!Array.isArray(u)){var l=E(u);return new c("Invalid "+o+" `"+i+"` of type "+("`"+l+"` supplied to `"+r+"`, expected an array."))}for(var s=0;s<u.length;s++){var f=e(u,s,r,o,i+"["+s+"]",a);if(f instanceof Error)return f}return null}return f(t)}function g(){function t(t,n,r,o,i){var a=t[n];if(!e(a)){var u=E(a);return new c("Invalid "+o+" `"+i+"` of type "+("`"+u+"` supplied to `"+r+"`, expected a single ReactElement."))}return null}return f(t)}function y(e){function t(t,n,r,o,i){if(!(t[n]instanceof e)){var a=e.name||A,u=C(t[n]);return new c("Invalid "+o+" `"+i+"` of type "+("`"+u+"` supplied to `"+r+"`, expected ")+("instance of `"+a+"`."))}return null}return f(t)}function b(e){function n(t,n,r,o,i){for(var a=t[n],u=0;u<e.length;u++)if(s(a,e[u]))return null;var l=JSON.stringify(e);return new c("Invalid "+o+" `"+i+"` of value `"+a+"` "+("supplied to `"+r+"`, expected one of "+l+"."))}return Array.isArray(e)?f(n):("production"!==t.env.NODE_ENV?i(!1,"Invalid argument supplied to oneOf, expected an instance of array."):void 0,r.thatReturnsNull)}function v(e){function t(t,n,r,o,i){if("function"!=typeof e)return new c("Property `"+i+"` of component `"+r+"` has invalid PropType notation inside objectOf.");var u=t[n],l=E(u);if("object"!==l)return new c("Invalid "+o+" `"+i+"` of type "+("`"+l+"` supplied to `"+r+"`, expected an object."));for(var s in u)if(u.hasOwnProperty(s)){var f=e(u,s,r,o,i+"."+s,a);if(f instanceof Error)return f}return null}return f(t)}function m(e){function n(t,n,r,o,i){for(var u=0;u<e.length;u++){var l=e[u];if(null==l(t,n,r,o,i,a))return null}return new c("Invalid "+o+" `"+i+"` supplied to "+("`"+r+"`."))}if(!Array.isArray(e))return"production"!==t.env.NODE_ENV?i(!1,"Invalid argument supplied to oneOfType, expected an instance of array."):void 0,r.thatReturnsNull;for(var o=0;o<e.length;o++){var u=e[o];if("function"!=typeof u)return i(!1,"Invalid argument supplid to oneOfType. Expected an array of check functions, but received %s at index %s.",O(u),o),r.thatReturnsNull}return f(n)}function I(){function e(e,t,n,r,o){return x(e[t])?null:new c("Invalid "+r+" `"+o+"` supplied to "+("`"+n+"`, expected a ReactNode."))}return f(e)}function w(e){function t(t,n,r,o,i){var u=t[n],l=E(u);if("object"!==l)return new c("Invalid "+o+" `"+i+"` of type `"+l+"` "+("supplied to `"+r+"`, expected `object`."));for(var s in e){var f=e[s];if(f){var d=f(u,s,r,o,i+"."+s,a);if(d)return d}}return null}return f(t)}function x(t){switch(typeof t){case"number":case"string":case"undefined":return!0;case"boolean":return!t;case"object":if(Array.isArray(t))return t.every(x);if(null===t||e(t))return!0;var n=l(t);if(!n)return!1;var r,o=n.call(t);if(n!==t.entries){for(;!(r=o.next()).done;)if(!x(r.value))return!1}else for(;!(r=o.next()).done;){var i=r.value;if(i&&!x(i[1]))return!1}return!0;default:return!1}}function _(e,t){return"symbol"===e||("Symbol"===t["@@toStringTag"]||"function"==typeof Symbol&&t instanceof Symbol)}function E(e){var t=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":_(t,e)?"symbol":t}function j(e){if("undefined"==typeof e||null===e)return""+e;var t=E(e);if("object"===t){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return t}function O(e){var t=j(e);switch(t){case"array":case"object":return"an "+t;case"boolean":case"date":case"regexp":return"a "+t;default:return t}}function C(e){return e.constructor&&e.constructor.name?e.constructor.name:A}var P="function"==typeof Symbol&&Symbol.iterator,T="@@iterator",A="<<anonymous>>",M={array:d("array"),bool:d("boolean"),func:d("function"),number:d("number"),object:d("object"),string:d("string"),symbol:d("symbol"),any:p(),arrayOf:h,element:g(),instanceOf:y,node:I(),objectOf:v,oneOf:b,oneOfType:m,shape:w};return c.prototype=Error.prototype,M.checkPropTypes=u,M.PropTypes=M,M}}).call(t,n(4))},function(e,t){"use strict";function n(e){return function(){return e}}var r=function(){};r.thatReturns=n,r.thatReturnsFalse=n(!1),r.thatReturnsTrue=n(!0),r.thatReturnsNull=n(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){(function(t){"use strict";function n(e,t,n,o,i,a,u,l){if(r(t),!e){var s;if(void 0===t)s=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var c=[n,o,i,a,u,l],f=0;s=new Error(t.replace(/%s/g,function(){return c[f++]})),s.name="Invariant Violation"}throw s.framesToPop=1,s}}var r=function(e){};"production"!==t.env.NODE_ENV&&(r=function(e){if(void 0===e)throw new Error("invariant requires an error message argument")}),e.exports=n}).call(t,n(4))},function(e,t,n){(function(t){"use strict";var r=n(6),o=r;"production"!==t.env.NODE_ENV&&!function(){var e=function(e){for(var t=arguments.length,n=Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=0,i="Warning: "+e.replace(/%s/g,function(){return n[o++]});"undefined"!=typeof console&&console.error(i);try{throw new Error(i)}catch(e){}};o=function(t,n){if(void 0===n)throw new Error("`warning(condition, format, ...args)` requires a warning message argument");if(0!==n.indexOf("Failed Composite propType: ")&&!t){for(var r=arguments.length,o=Array(r>2?r-2:0),i=2;i<r;i++)o[i-2]=arguments[i];e.apply(void 0,[n].concat(o))}}}(),e.exports=o}).call(t,n(4))},function(e,t){"use strict";var n="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=n},function(e,t,n){(function(t){"use strict";function r(e,n,r,l,s){if("production"!==t.env.NODE_ENV)for(var c in e)if(e.hasOwnProperty(c)){var f;try{o("function"==typeof e[c],"%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.",l||"React class",r,c),f=e[c](n,c,l,r,null,a)}catch(e){f=e}if(i(!f||f instanceof Error,"%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",l||"React class",r,c,typeof f),f instanceof Error&&!(f.message in u)){u[f.message]=!0;var d=s?s():"";i(!1,"Failed %s type: %s%s",r,f.message,null!=d?d:"")}}}if("production"!==t.env.NODE_ENV)var o=n(7),i=n(8),a=n(9),u={};e.exports=r}).call(t,n(4))},function(e,t,n){"use strict";var r=n(6),o=n(7),i=n(9);e.exports=function(){function e(e,t,n,r,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t._handleClick=t._handleMouseMove=t.restoreLogFromLocalstorage=t.restoreUpdatesFromLocalstorage=t.getGlobalState=t.setGlobalState=t.eventEmitter=void 0;var o=n(13),i=n(14),a=n(15),u=r(a),l=n(16),s=r(l),c=n(17),f=r(c),d="mobx-react-devtool__updatesEnabled",p="mobx-react-devtool__logEnabled",h={updatesEnabled:!1,graphEnabled:!1,logEnabled:!1,hoverBoxes:[],renderingBoxes:[],logFilter:function(){return!0}},g=t.eventEmitter=new u.default;g.setMaxListeners(1/0);var y=void 0,b=t.setGlobalState=function(e){h.logEnabled!==e.logEnabled&&(e.logEnabled===!0?(y&&y(),y=(0,o.spy)(function(e){return(0,f.default)(e,h.logFilter)})):e.logEnabled===!1&&y&&y()),"undefined"!=typeof window&&window.localStorage&&(e.updatesEnabled===!0?window.localStorage.setItem(d,"YES"):e.updatesEnabled===!1&&window.localStorage.removeItem(d),e.logEnabled===!0?window.localStorage.setItem(p,"YES"):e.logEnabled===!1&&window.localStorage.removeItem(p)),e.graphEnabled===!1&&(e.hoverBoxes=[]),h=Object.assign({},h,e),g.emit("update")},v=(t.getGlobalState=function(){return h},t.restoreUpdatesFromLocalstorage=function(){if("undefined"!=typeof window&&window.localStorage){var e="YES"===window.localStorage.getItem(d);b({updatesEnabled:e})}},t.restoreLogFromLocalstorage=function(){if("undefined"!=typeof window&&window.localStorage){var e="YES"===window.localStorage.getItem(p);b({logEnabled:e})}},function(e){for(var t=e,n=void 0;t;){if(n=i.componentByNodeRegistery.get(t))return{component:n,node:t};t=t.parentNode}return{component:void 0,node:void 0}});t._handleMouseMove=function(e){if(h.graphEnabled){var t=e.target,n=v(t).node;if(n){var r=n.getBoundingClientRect();b({hoverBoxes:[{id:"the hovered node",type:"hover",x:r.left,y:r.top,width:r.width,height:r.height,lifeTime:1/0}]})}}},t._handleClick=function(e){if(h.graphEnabled){var t=e.target,n=v(t).component;if(n){e.stopPropagation(),e.preventDefault();var r=o.extras.getDependencyTree(n.render.$mobx);(0,s.default)(r),b({dependencyTree:r,hoverBoxes:[],graphEnabled:!1})}}}},function(e,n){e.exports=t},function(e,t){e.exports=n},function(e,t){function n(){this._events=this._events||{},this._maxListeners=this._maxListeners||void 0}function r(e){return"function"==typeof e}function o(e){return"number"==typeof e}function i(e){return"object"==typeof e&&null!==e}function a(e){return void 0===e}e.exports=n,n.EventEmitter=n,n.prototype._events=void 0,n.prototype._maxListeners=void 0,n.defaultMaxListeners=10,n.prototype.setMaxListeners=function(e){if(!o(e)||e<0||isNaN(e))throw TypeError("n must be a positive number");return this._maxListeners=e,this},n.prototype.emit=function(e){var t,n,o,u,l,s;if(this._events||(this._events={}),"error"===e&&(!this._events.error||i(this._events.error)&&!this._events.error.length)){if(t=arguments[1],t instanceof Error)throw t;var c=new Error('Uncaught, unspecified "error" event. ('+t+")");throw c.context=t,c}if(n=this._events[e],a(n))return!1;if(r(n))switch(arguments.length){case 1:n.call(this);break;case 2:n.call(this,arguments[1]);break;case 3:n.call(this,arguments[1],arguments[2]);break;default:u=Array.prototype.slice.call(arguments,1),n.apply(this,u)}else if(i(n))for(u=Array.prototype.slice.call(arguments,1),s=n.slice(),o=s.length,l=0;l<o;l++)s[l].apply(this,u);return!0},n.prototype.addListener=function(e,t){var o;if(!r(t))throw TypeError("listener must be a function");return this._events||(this._events={}),this._events.newListener&&this.emit("newListener",e,r(t.listener)?t.listener:t),this._events[e]?i(this._events[e])?this._events[e].push(t):this._events[e]=[this._events[e],t]:this._events[e]=t,i(this._events[e])&&!this._events[e].warned&&(o=a(this._maxListeners)?n.defaultMaxListeners:this._maxListeners,o&&o>0&&this._events[e].length>o&&(this._events[e].warned=!0,console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",this._events[e].length),"function"==typeof console.trace&&console.trace())),this},n.prototype.on=n.prototype.addListener,n.prototype.once=function(e,t){function n(){this.removeListener(e,n),o||(o=!0,t.apply(this,arguments))}if(!r(t))throw TypeError("listener must be a function");var o=!1;return n.listener=t,this.on(e,n),this},n.prototype.removeListener=function(e,t){var n,o,a,u;if(!r(t))throw TypeError("listener must be a function");if(!this._events||!this._events[e])return this;if(n=this._events[e],a=n.length,o=-1,n===t||r(n.listener)&&n.listener===t)delete this._events[e],this._events.removeListener&&this.emit("removeListener",e,t);else if(i(n)){for(u=a;u-- >0;)if(n[u]===t||n[u].listener&&n[u].listener===t){o=u;break}if(o<0)return this;1===n.length?(n.length=0,delete this._events[e]):n.splice(o,1),this._events.removeListener&&this.emit("removeListener",e,t)}return this},n.prototype.removeAllListeners=function(e){var t,n;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[e]&&delete this._events[e],this;if(0===arguments.length){for(t in this._events)"removeListener"!==t&&this.removeAllListeners(t);return this.removeAllListeners("removeListener"),this._events={},this}if(n=this._events[e],r(n))this.removeListener(e,n);else if(n)for(;n.length;)this.removeListener(e,n[n.length-1]);return delete this._events[e],this},n.prototype.listeners=function(e){var t;return t=this._events&&this._events[e]?r(this._events[e])?[this._events[e]]:this._events[e].slice():[]},n.prototype.listenerCount=function(e){if(this._events){var t=this._events[e];if(r(t))return 1;if(t)return t.length}return 0},n.listenerCount=function(e,t){return e.listenerCount(t)}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function e(t){if(t.dependencies){for(var n=t.dependencies.length-1;n>=0;n--)for(var r=t.dependencies[n].name,o=n-1;o>=0;o--)if(t.dependencies[o].name===r){t.dependencies[o].dependencies=[].concat(t.dependencies[o].dependencies||[],t.dependencies[n].dependencies||[]),t.dependencies.splice(n,1);break}t.dependencies.forEach(e)}};t.default=n},function(e,t,n){"use strict";function r(e,t){b===!1&&"undefined"!=typeof navigator&&navigator.userAgent.indexOf("Chrome")===-1&&(console.warn("The output of the MobX logger is optimized for Chrome"),b=!0);var n=e.spyReportStart===!0,r=e.spyReportEnd===!0,h=void 0;if(0===v?(h=t(e),n&&!h&&(m=!0)):r&&m&&1===v?(h=!1,m=!1):h=m!==!0,h&&r)i(e.time);else if(h){var g=n?o:a;switch(e.type){case"action":g("%caction '%s' %s","color:dodgerblue",e.name,c("(",p(e.target))),a(e.arguments),l();break;case"transaction":g("%ctransaction '%s' %s","color:gray",e.name,c("(",p(e.target)));break;case"scheduled-reaction":g("%cscheduled async reaction '%s'","color:#10a210",f(e.object));break;case"reaction":g("%creaction '%s'","color:#10a210",f(e.object)),l();break;case"compute":o("%ccomputed '%s' %s","color:#10a210",f(e.object),c("(",p(e.target))),i();break;case"error":g("%cerror: %s","color:tomato",e.message),l(),s();break;case"update":(0,y.isObservableArray)(e.object)?g("updated '%s[%s]': %s (was: %s)",f(e.object),e.index,d(e.newValue),d(e.oldValue)):(0,y.isObservableObject)(e.object)?g("updated '%s.%s': %s (was: %s)",f(e.object),e.name,d(e.newValue),d(e.oldValue)):g("updated '%s': %s (was: %s)",f(e.object),d(e.newValue),d(e.oldValue)),u({newValue:e.newValue,oldValue:e.oldValue}),l();break;case"splice":g("spliced '%s': index %d, added %d, removed %d",f(e.object),e.index,e.addedCount,e.removedCount),u({added:e.added,removed:e.removed}),l();break;case"add":g("set '%s.%s': %s",f(e.object),e.name,d(e.newValue)),u({newValue:e.newValue}),l();break;case"delete":g("removed '%s.%s' (was %s)",f(e.object),e.name,d(e.oldValue)),u({oldValue:e.oldValue}),l();break;case"create":g("set '%s': %s",f(e.object),d(e.newValue)),u({newValue:e.newValue}),l();break;default:g(e.type),u(e)}}n&&v++,r&&v--}function o(){console[I?"groupCollapsed":"log"].apply(console,arguments),w++}function i(e){w--,"number"==typeof e&&a("%ctotal time: %sms","color:gray",e),I&&console.groupEnd()}function a(){console.log.apply(console,arguments)}function u(){console.dir.apply(console,arguments)}function l(){console.trace("stack")}function s(){for(var e=0,t=w;e<t;e++)i()}function c(e,t){return t?(e||"")+t+(x[e]||""):""}function f(e){return e?y.extras.getDebugName(e):String(e)}function d(e){return h(e)?"string"==typeof e&&e.length>100?e.substr(0,97)+"...":e:c("(",p(e))}function p(e){if(null===e||void 0===e)return"";if(e&&"object"===("undefined"==typeof e?"undefined":g(e))){if(e&&e.$mobx)return e.$mobx.name;if(e.constructor)return e.constructor.name||"object"}return""+("undefined"==typeof e?"undefined":g(e))}function h(e){return null===e||void 0===e||"string"==typeof e||"number"==typeof e||"boolean"==typeof e}Object.defineProperty(t,"__esModule",{value:!0});var g="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=r;var y=n(13),b=!1,v=0,m=!1,I="function"==typeof console.groupCollapsed,w=0,x={'"':'"',"'":"'","(":")","[":"]","<":"]","#":""}},function(e,t,n){"use strict";function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}function o(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(2),c=o(s),f=n(3),d=o(f),p=n(12),h=n(19),g=o(h),y=n(20),b=o(y),v=n(21),m=o(v),I=n(23),w=o(I),x=n(24),_=r(x),E=function(e){function t(){var e,n,r,o;i(this,t);for(var u=arguments.length,l=Array(u),s=0;s<u;s++)l[s]=arguments[s];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),r.handleUpdate=function(){return r.setState({})},o=n,a(r,o)}return u(t,e),l(t,[{key:"componentDidMount",value:function(){p.eventEmitter.on("update",this.handleUpdate)}},{key:"componentWillUnmount",value:function(){p.eventEmitter.removeListener("update",this.handleUpdate)}},{key:"render",value:function(){var e=this.props,t=e.position,n=e.highlightTimeout,r={};return t?(r.top=t.top,r.right=t.right,r.bottom=t.bottom,r.left=t.left):(r.top="0px",r.right="20px"),c.default.createElement("div",null,c.default.createElement("div",{style:Object.assign({},_.panel,r)},c.default.createElement(m.default,{highlightTimeout:n},c.default.createElement(w.default,{id:"buttonUpdates"})),c.default.createElement(g.default,null,c.default.createElement(w.default,{id:"buttonGraph"})),c.default.createElement(b.default,null,c.default.createElement(w.default,{id:"buttonLog"}))))}}]),t}(s.Component);E.propTypes={highlightTimeout:d.default.number},t.default=E},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(2),s=r(l),c=n(3),f=(r(c),n(14)),d=n(12),p=function(e){function t(){var e,n,r,a;o(this,t);for(var u=arguments.length,l=Array(u),s=0;s<u;s++)l[s]=arguments[s];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),r.handleUpdate=function(){return r.setState({})},r.handleToggleGraph=function(){var e=(0,d.getGlobalState)(),t=e.graphEnabled;(0,d.setGlobalState)({hoverBoxes:[],graphEnabled:!t})},a=n,i(r,a)}return a(t,e),u(t,[{key:"componentWillMount",value:function(){this.setState({})}},{key:"componentDidMount",value:function(){(0,f.trackComponents)(),d.eventEmitter.on("update",this.handleUpdate),"undefined"!=typeof window&&"undefined"!=typeof document&&(document.body.addEventListener("mousemove",d._handleMouseMove,!0),document.body.addEventListener("click",d._handleClick,!0))}},{key:"componentWillUnmount",value:function(){d.eventEmitter.removeListener("update",this.handleUpdate),"undefined"!=typeof document&&(document.body.removeEventListener("mousemove",d._handleMouseMove,!0),document.body.removeEventListener("click",d._handleMouseMove,!0))}},{key:"render",value:function(){var e=(0,d.getGlobalState)(),t=e.graphEnabled,n=this.props.children;return s.default.cloneElement(n,{onToggle:this.handleToggleGraph,active:t})}}]),t}(l.Component);t.default=p},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(2),s=r(l),c=n(3),f=(r(c),n(12)),d=function(e){function t(){var e,n,r,a;o(this,t);for(var u=arguments.length,l=Array(u),s=0;s<u;s++)l[s]=arguments[s];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),r.handleUpdate=function(){r.setState({})},r.handleToggleLog=function(){var e=(0,f.getGlobalState)(),t=e.logEnabled;(0,f.setGlobalState)({logEnabled:!t})},a=n,i(r,a)}return a(t,e),u(t,[{key:"componentDidMount",value:function(){f.eventEmitter.on("update",this.handleUpdate),(0,f.restoreLogFromLocalstorage)()}},{key:"componentWillUnmount",value:function(){f.eventEmitter.removeListener("update",this.handleUpdate)}},{key:"render",value:function(){var e=(0,f.getGlobalState)(),t=e.logEnabled,n=this.props.children;return s.default.cloneElement(n,{onToggle:this.handleToggleLog,active:t})}}]),t}(l.Component);t.default=d},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(2),s=r(l),c=n(3),f=r(c),d=n(22),p=r(d),h=n(12),g=function(e){function t(){var e,n,r,a;o(this,t);for(var u=arguments.length,l=Array(u),s=0;s<u;s++)l[s]=arguments[s];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),r.handleUpdate=function(){return r.setState({})},r.handleToggleUpdates=function(){var e=(0,h.getGlobalState)(),t=e.updatesEnabled;(0,h.setGlobalState)({updatesEnabled:!t})},a=n,i(r,a)}return a(t,e),u(t,[{key:"componentDidMount",value:function(){h.eventEmitter.on("update",this.handleUpdate);var e=this.props.highlightTimeout;this.renderingMonitor=new p.default({highlightTimeout:e}),(0,h.restoreUpdatesFromLocalstorage)()}},{key:"componentWillUnmount",value:function(){h.eventEmitter.removeListener("update",this.handleUpdate),this.renderingMonitor.dispose()}},{key:"render",value:function(){
var e=(0,h.getGlobalState)(),t=e.updatesEnabled,n=this.props.children;return s.default.cloneElement(n,{onToggle:this.handleToggleUpdates,active:t})}}]),t}(l.Component);g.propTypes={highlightTimeout:f.default.number},g.defaultProps={highlightTimeout:1500},t.default=g},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),i=n(14),a=n(12),u=function(e){switch(!0){case e<25:return"cheap";case e<100:return"acceptable";default:return"expensive"}},l=function(){function e(t){var n=this,o=t.highlightTimeout;r(this,e),this._boxesRegistry="undefined"!=typeof WeakMap?new WeakMap:new Map,this._renderReporterDisposer=i.renderReporter.on(function(e){if((0,a.getGlobalState)().updatesEnabled===!0)switch(e.event){case"render":if(!e.node||isNaN(e.renderTime))return;var t=e.node.getBoundingClientRect(),r=n.getBoxForNode(e.node);r.type="rendering",r.y=t.top,r.x=t.left,r.width=t.width,r.height=t.height,r.renderInfo={count:r.renderInfo&&++r.renderInfo.count||1,renderTime:e.renderTime,totalTime:e.totalTime,cost:u(e.renderTime)},r.lifeTime=o;var i=(0,a.getGlobalState)().renderingBoxes;return i.indexOf(r)===-1&&(i=i.concat([r])),(0,a.setGlobalState)({renderingBoxes:i}),r._timeout&&clearTimeout(r._timeout),void(r._timeout=setTimeout(function(){return n.removeBox(e.node,!0)},o));case"destroy":return n.removeBox(e.node),void n._boxesRegistry.delete(e.node);default:return}})}return o(e,[{key:"getBoxForNode",value:function(e){if(this._boxesRegistry.has(e))return this._boxesRegistry.get(e);var t={id:Math.random().toString(32).substr(2)};return this._boxesRegistry.set(e,t),t}},{key:"dispose",value:function(){this._renderReporterDisposer()}},{key:"removeBox",value:function(e){if(this._boxesRegistry.has(e)!==!1){var t=(0,a.getGlobalState)().renderingBoxes,n=t.indexOf(this._boxesRegistry.get(e));n!==-1&&(t=t.slice(0,n).concat(t.slice(n+1)),(0,a.setGlobalState)({renderingBoxes:t}))}}}]),e}();t.default=l},function(e,t,n){"use strict";function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}function o(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(2),c=o(s),f=n(3),d=o(f),p=n(24),h=r(p),g=function(e){function t(){var e,n,r,o;i(this,t);for(var u=arguments.length,l=Array(u),s=0;s<u;s++)l[s]=arguments[s];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),r.state={hovered:!1},r.handleMouseOver=function(){return r.setState({hovered:!0})},r.handleMouseOut=function(){return r.setState({hovered:!1})},o=n,a(r,o)}return u(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.active,n=e.id,r=e.onToggle,o=this.state.hovered,i=function(){switch(n){case"buttonUpdates":return t?h.buttonUpdatesActive:h.buttonUpdates;case"buttonGraph":return t?h.buttonGraphActive:h.buttonGraph;case"buttonLog":return t?h.buttonLogActive:h.buttonLog}}(),a=function(){switch(n){case"buttonUpdates":return"Visualize component re-renders";case"buttonGraph":return"Select a component and show its dependency tree";case"buttonLog":return"Log all MobX state changes and reactions to the browser console (use F12 to show / hide the console). Use Chrome / Chromium for an optimal experience"}}(),u=Object.assign({},h.button,i,t&&h.button.active,o&&h.button.hover);return c.default.createElement("button",{type:"button",onClick:r,title:a,style:u,onMouseOver:this.handleMouseOver,onMouseOut:this.handleMouseOut})}}]),t}(s.Component);g.props={onToggle:d.default.bool.isRequired,active:d.default.bool.isRequired,name:d.default.oneOf(["buttonUpdates","buttonGraph","buttonLog"]).isRequired},t.default=g},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});t.panel={position:"fixed",height:"26px",backgroundColor:"#fff",color:"rgba(0, 0, 0, 0.8)",borderRadius:"0 0 2px 2px",borderStyle:"solid",borderWidth:"0 1px 1px",borderColor:"rgba(0, 0, 0, 0.1)",zIndex:"65000",fontFamily:"Helvetica, sans-serif",display:"flex",padding:"0 5px"},t.button={opacity:.45,background:"transparent none center / 16px 16px no-repeat",width:"26px",margin:"0 10px",cursor:"pointer",border:"none",hover:{opacity:.7},active:{opacity:1,":hover":{opacity:1}}},t.buttonLog={backgroundImage:"url("+n(25)+")"},t.buttonLogActive={backgroundImage:"url("+n(26)+")"},t.buttonUpdates={backgroundImage:"url("+n(27)+")"},t.buttonUpdatesActive={backgroundImage:"url("+n(28)+")"},t.buttonGraph={backgroundImage:"url("+n(29)+")"},t.buttonGraphActive={backgroundImage:"url("+n(30)+")"}},function(e,t){e.exports="data:image/svg+xml;base64,PHN2ZyBiYXNlUHJvZmlsZT0iYmFzaWMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE2IDE2IiBoZWlnaHQ9IjE2IiB3aWR0aD0iMTYiPgogICAgPGcgc3Ryb2tlPSIjMDAwIiBmaWxsPSJub25lIiBzdHJva2Utd2lkdGg9IjEiPgogICAgICAgIDxwYXRoIGQ9Ik0xMi41IDMuNWgtOGMtMS4xIDAtMiAuOS0yIDJ2NWMwIDEuMS45IDIgMiAyaDF2Mmw1LTJoMmMxLjEgMCAyLS45IDItMnYtNWMwLTEuMS0uOS0yLTItMnoiLz4KICAgICAgICA8cGF0aCBkPSJNNSA2LjVoNyIvPgogICAgICAgIDxwYXRoIGQ9Ik01IDkuNWg3Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="},function(e,t){e.exports="data:image/svg+xml;base64,PHN2ZyBiYXNlUHJvZmlsZT0iYmFzaWMiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiIgaGVpZ2h0PSIxNiIgd2lkdGg9IjE2Ij4KICAgIDxnIHN0cm9rZT0iIzE3ODBmYSIgZmlsbD0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxLjI1Ij4KICAgICAgICA8cGF0aCBkPSJNMTIuNSAzLjVoLThjLTEuMSAwLTIgLjktMiAydjVjMCAxLjEuOSAyIDIgMmgxdjJsNS0yaDJjMS4xIDAgMi0uOSAyLTJ2LTVjMC0xLjEtLjktMi0yLTJ6Ii8+CiAgICAgICAgPHBhdGggZD0iTTUgNi41aDciLz4KICAgICAgICA8cGF0aCBkPSJNNSA5LjVoNyIvPgogICAgPC9nPgo8L3N2Zz4K"},function(e,t){e.exports="data:image/svg+xml;base64,PHN2ZyBiYXNlUHJvZmlsZT0iYmFzaWMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE2IDE2IiBoZWlnaHQ9IjE2IiB3aWR0aD0iMTYiPgogICAgPGcgc3Ryb2tlPSIjMDAwIiBmaWxsPSJub25lIiBzdHJva2Utd2lkdGg9IjEiPgogICAgICAgIDxjaXJjbGUgY3g9IjguNSIgY3k9IjguNSIgcj0iNiIvPgogICAgICAgIDxwYXRoIGQ9Ik04LjUgMTBWNCIvPgogICAgPC9nPgogICAgPGcgc3Ryb2tlPSJub25lIiBmaWxsPSIjMDAwIj4KICAgICAgICA8Y2lyY2xlIGN4PSI4LjUiIGN5PSI4LjUiIHI9IjEiLz4KICAgICAgICA8cGF0aCBkPSJNNy41IDFoMnYxLjVoLTJ6Ii8+CiAgICAgICAgPHBhdGggZD0iTTE0IDEuNmwtLjcuNy4zLjMtLjcuOC43LjcuOC0uNy4zLjMuNy0uN3oiLz4KICAgIDwvZz4KPC9zdmc+Cg=="},function(e,t){e.exports="data:image/svg+xml;base64,PHN2ZyBiYXNlUHJvZmlsZT0iYmFzaWMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE2IDE2IiBoZWlnaHQ9IjE2IiB3aWR0aD0iMTYiPgogICAgPGcgc3Ryb2tlPSIjMTc4MGZhIiBmaWxsPSJub25lIiBzdHJva2Utd2lkdGg9IjEuMjUiPgogICAgICAgIDxjaXJjbGUgY3g9IjguNSIgY3k9IjguNSIgcj0iNiIvPgogICAgICAgIDxwYXRoIGQ9Ik04LjUgMTBWNCIvPgogICAgPC9nPgogICAgPGcgc3Ryb2tlPSJub25lIiBmaWxsPSIjMTc4MGZhIj4KICAgICAgICA8Y2lyY2xlIGN4PSI4LjUiIGN5PSI4LjUiIHI9IjEiLz4KICAgICAgICA8cGF0aCBkPSJNNy41IDFoMnYxLjVoLTJ6Ii8+CiAgICAgICAgPHBhdGggZD0iTTE0IDEuNmwtLjcuNy4zLjMtLjcuOC43LjcuOC0uNy4zLjMuNy0uN3oiLz4KICAgIDwvZz4KPC9zdmc+Cg=="},function(e,t){e.exports="data:image/svg+xml;base64,PHN2ZyBiYXNlUHJvZmlsZT0iYmFzaWMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE2IDE2IiBoZWlnaHQ9IjE2IiB3aWR0aD0iMTYiPgogICAgPGcgc3Ryb2tlPSIjMDAwIiBmaWxsPSJub25lIiBzdHJva2Utd2lkdGg9IjEiPgogICAgICAgIDxwYXRoIGQ9Ik0yLjUgMi41aDl2MmgtOXoiLz4KICAgICAgICA8cGF0aCBkPSJNNy41IDcuNWg3djJoLTd6Ii8+CiAgICAgICAgPHBhdGggZD0iTTcuNSAxMi41aDd2MmgtN3oiLz4KICAgICAgICA8cGF0aCBkPSJNNC41IDQuNXY5aDMiLz4KICAgICAgICA8cGF0aCBkPSJNNy41IDguNWgtMyIvPgogICAgPC9nPgo8L3N2Zz4K"},function(e,t){e.exports="data:image/svg+xml;base64,PHN2ZyBiYXNlUHJvZmlsZT0iYmFzaWMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE2IDE2IiBoZWlnaHQ9IjE2IiB3aWR0aD0iMTYiPgogICAgPGcgc3Ryb2tlPSIjMTc4MGZhIiBmaWxsPSJub25lIiBzdHJva2Utd2lkdGg9IjEuMjUiPgogICAgICAgIDxwYXRoIGQ9Ik0yLjUgMi41aDl2MmgtOXoiLz4KICAgICAgICA8cGF0aCBkPSJNNy41IDcuNWg3djJoLTd6Ii8+CiAgICAgICAgPHBhdGggZD0iTTcuNSAxMi41aDd2MmgtN3oiLz4KICAgICAgICA8cGF0aCBkPSJNNC41IDQuNXY5aDMiLz4KICAgICAgICA8cGF0aCBkPSJNNy41IDguNWgtMyIvPgogICAgPC9nPgo8L3N2Zz4K"},function(e,t,n){"use strict";function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}function o(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(2),c=o(s),f=n(3),d=o(f),p=n(32),h=r(p),g=function(e){function t(){return i(this,t),a(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return u(t,e),l(t,[{key:"componentWillAppear",value:function(e){this.props.willAppear(e)}},{key:"componentWillLeave",value:function(){this.props.willLeave()}},{key:"render",value:function(){return this.props.children}}]),t}(s.Component);g.propTypes={willAppear:d.default.function,willLeave:d.default.function},g.defaultProps={willAppear:function(){},willLeave:function(){}};var y=function(e){function t(){return i(this,t),a(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return u(t,e),l(t,[{key:"renderBox",value:function(e){switch(e.type){case"rendering":var t=h.rendering[e.renderInfo.cost]||{};return c.default.createElement("div",{key:e.id,ref:function(t){return setTimeout(function(){t&&(t.style.opacity=0)},e.lifeTime-500)},style:Object.assign({},h.box,h.rendering,t,{left:e.x,top:e.y,width:e.width,height:e.height})},c.default.createElement("span",{style:Object.assign({},h.text,t.text)},e.renderInfo.count,"x | ",e.renderInfo.renderTime," / ",e.renderInfo.totalTime," ms"));case"hover":return c.default.createElement("div",{key:e.id,style:Object.assign({},h.box,h.hover,{left:e.x,top:e.y,width:e.width,height:e.height})});default:throw new Error}}},{key:"render",value:function(){var e=this,t=this.props.boxes;return c.default.createElement("div",null,t.map(function(t){return e.renderBox(t)}))}}]),t}(s.Component);y.propTypes={boxes:d.default.arrayOf(d.default.shape({type:d.default.oneOf(["rendering","hover"]).isRequired,x:d.default.number.isRequired,y:d.default.number.isRequired,width:d.default.number.isRequired,height:d.default.number.isRequired,renderInfo:d.default.shape({count:d.default.number.isRequired,renderTime:d.default.number.isRequired,totalTime:d.default.number.isRequired,cost:d.default.oneOf(["cheap","acceptable","expensive"]).isRequired}),lifeTime:d.default.number.isRequired})).isRequired},t.default=y},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});t.box={display:"block",position:"fixed",zIndex:"64998",minWidth:"60px",outline:"3px solid",pointerEvents:"none",transition:"opacity 500ms ease-in"},t.text={fontFamily:"verdana, sans-serif",padding:"0 4px 2px",color:"rgba(0, 0, 0, 0.6)",fontSize:"10px",lineHeight:"12px",pointerEvents:"none",float:"right",borderBottomRightRadius:"2px",maxWidth:"100%",maxHeight:"100%",overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"},t.rendering={cheap:{outlineColor:"rgba(182, 218, 146, 0.75)",text:{backgroundColor:"rgba(182, 218, 146, 0.75)"}},acceptable:{outlineColor:"rgba(228, 195, 66, 0.85)",text:{backgroundColor:"rgba(228, 195, 66, 0.85)"}},expensive:{outlineColor:"rgba(228, 171, 171, 0.95)",text:{backgroundColor:"rgba(228, 171, 171, 0.95)"}}},t.hover={outlineColor:"rgba(128, 128, 255, 0.5)"}},function(e,t,n){"use strict";function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}function o(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(2),c=o(s),f=n(3),d=(o(f),n(34)),p=o(d),h=n(12),g=n(36),y=r(g),b=function(e){function t(){var e,n,r,o;i(this,t);for(var u=arguments.length,l=Array(u),s=0;s<u;s++)l[s]=arguments[s];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),r.handleUpdate=function(){return r.setState({})},r.handleClose=function(){return(0,h.setGlobalState)({dependencyTree:void 0})},o=n,a(r,o)}return u(t,e),l(t,[{key:"componentDidMount",value:function(){h.eventEmitter.on("update",this.handleUpdate)}},{key:"componentWillUnmount",value:function(){h.eventEmitter.removeListener("update",this.handleUpdate)}},{key:"renderTreeItem",value:function(e,t,n){var r=e.name,o=e.dependencies,i=this;return c.default.createElement("div",{style:y.item,key:r},c.default.createElement("span",{style:Object.assign({},y.box,n&&y.box.root)},r),o&&c.default.createElement("div",{style:y.tree},o.map(function(e,t){return i.renderTreeItem(e,t==o.length-1)})),!n&&c.default.createElement("span",{style:y.itemHorisontalDash}),!n&&c.default.createElement("span",{style:Object.assign({},y.itemVericalStick,t&&y.itemVericalStick.short)}))}},{key:"render",value:function(){var e=(0,h.getGlobalState)(),t=e.dependencyTree;return c.default.createElement(p.default,{onOverlayClick:this.handleClose},t&&c.default.createElement("div",{style:y.graph},c.default.createElement("span",{style:y.close,onClick:this.handleClose},"×"),c.default.createElement("div",{style:y.tree},this.renderTreeItem(t,!0,!0))))}}]),t}(s.Component);t.default=b},function(e,t,n){"use strict";function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}function o(e){return e&&e.__esModule?e:{default:e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(2),c=o(s),f=n(3),d=o(f),p=n(35),h=r(p),g=function(e){function t(){var e,n,r,o;i(this,t);for(var u=arguments.length,l=Array(u),s=0;s<u;s++)l[s]=arguments[s];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),r.stopPropogation=function(e){return e.stopPropagation()},o=n,a(r,o)}return u(t,e),l(t,[{key:"componentDidUpdate",value:function(e){var t=document.body.parentNode;if(e.children&&!this.props.children)this.rightOffset=0,t.style.borderRight=null,t.style.overflow=null;else if(!e.children&&this.props.children){var n=t.offsetWidth;t.style.overflow="hidden";var r=t.offsetWidth,o=Math.max(0,r-n);t.style.borderRight=o+"px solid transparent"}}},{key:"render",value:function(){var e=this.props,t=e.children,n=e.onOverlayClick;return t?c.default.createElement("div",{style:h.overlay,onClick:n},c.default.createElement("div",{key:"content",style:h.modal,onClick:this.stopPropogation},t)):null}}]),t}(s.Component);g.propTypes={children:d.default.node,onOverlayClick:d.default.func.isRequired},t.default=g},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});t.overlay={position:"fixed",top:0,right:0,bottom:0,left:0,zIndex:66e3,overflow:"auto",WebkitOverflowScrolling:"touch",outline:0,backgroundColor:"rgba(40, 40, 50, 0.5)",transformOrigin:"50% 25%"},t.modal={position:"relative",width:"auto",margin:"5% 10%",zIndex:1060}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});t.graph={background:"white",padding:"40px"},t.close={color:"rgba(0, 0, 0, 0.2)",fontSize:"36px",position:"absolute",top:"5px",right:"5px",width:"40px",height:"40px",lineHeight:"34px",textAlign:"center",cursor:"pointer",":hover":{color:"rgba(0, 0, 0, 0.5)"}},t.tree={position:"relative",paddingLeft:"25px"},t.item={position:"relative"},t.box={padding:"4px 10px",background:"rgba(0, 0, 0, 0.05)",display:"inline-block",marginBottom:"8px",color:"#000",root:{fontSize:"15px",fontWeight:"bold",padding:"6px 13px"}},t.itemHorisontalDash={position:"absolute",left:"-12px",borderTop:"1px solid rgba(0, 0, 0, 0.2)",top:"14px",width:"12px",height:"0"},t.itemVericalStick={position:"absolute",left:"-12px",borderLeft:"1px solid rgba(0, 0, 0, 0.2)",height:"100%",width:0,top:"-8px",short:{height:"23px"}}},function(e,t){"use strict";function n(e,t){if(void 0===e||null===e)throw new TypeError("Cannot convert first argument to object");for(var n=Object(e),r=1;r<arguments.length;r++){var o=arguments[r];if(void 0!==o&&null!==o)for(var i=Object.keys(Object(o)),a=0,u=i.length;a<u;a++){var l=i[a],s=Object.getOwnPropertyDescriptor(o,l);void 0!==s&&s.enumerable&&(n[l]=o[l])}}return n}function r(){Object.assign||Object.defineProperty(Object,"assign",{enumerable:!1,configurable:!0,writable:!0,value:n})}e.exports={assign:n,polyfill:r}}])});

/***/ }),

/***/ "./node_modules/mobx-react/index.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "propTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onError", function() { return onError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observer", function() { return observer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Observer", function() { return Observer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderReporter", function() { return renderReporter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentByNodeRegistery", function() { return componentByNodeRegistery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trackComponents", function() { return trackComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useStaticRendering", function() { return useStaticRendering; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return inject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__("./node_modules/mobx/lib/mobx.module.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__("./node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);




// These functions can be stubbed out in specific environments
var unstable_batchedUpdates$1 = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var EventEmitter = function () {
    function EventEmitter() {
        classCallCheck(this, EventEmitter);
        this.listeners = [];
    }

    createClass(EventEmitter, [{
        key: "on",
        value: function on(cb) {
            var _this = this;

            this.listeners.push(cb);
            return function () {
                var index = _this.listeners.indexOf(cb);
                if (index !== -1) _this.listeners.splice(index, 1);
            };
        }
    }, {
        key: "emit",
        value: function emit(data) {
            this.listeners.forEach(function (fn) {
                return fn(data);
            });
        }
    }]);
    return EventEmitter;
}();

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

var hoistNonReactStatics = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty$1(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};

// Copied from React.PropTypes
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
            rest[_key - 6] = arguments[_key];
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else {
                return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
            }
        });
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}

// Copied from React.PropTypes
function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") {
        return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") {
        return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
    }

    return false;
}

// Copied from React.PropTypes
function getPropType(propValue) {
    var propType = typeof propValue === "undefined" ? "undefined" : _typeof(propValue);
    if (Array.isArray(propValue)) {
        return "array";
    }
    if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
    }
    if (isSymbol(propType, propValue)) {
        return "symbol";
    }
    return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function getPreciseType(propValue) {
    var propType = getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) {
            return "date";
        } else if (propValue instanceof RegExp) {
            return "regexp";
        }
    }
    return propType;
}

function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
            if (allowNativeType) {
                if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker = void 0;
            switch (mobxType) {
                case "Array":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableArray"];
                    break;
                case "Object":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableObject"];
                    break;
                case "Map":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["isObservableMap"];
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}

function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
            rest[_key2 - 5] = arguments[_key2];
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["untracked"])(function () {
            if (typeof typeChecker !== "function") {
                return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            }
            var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
            if (error instanceof Error) return error;
            var propValue = props[propName];
            for (var i = 0; i < propValue.length; i++) {
                error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
                if (error instanceof Error) return error;
            }
            return null;
        });
    });
}

var observableArray = createObservableTypeCheckerCreator(false, "Array");
var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
var observableMap = createObservableTypeCheckerCreator(false, "Map");
var observableObject = createObservableTypeCheckerCreator(false, "Object");
var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");



var propTypes = Object.freeze({
	observableArray: observableArray,
	observableArrayOf: observableArrayOf,
	observableMap: observableMap,
	observableObject: observableObject,
	arrayOrObservableArray: arrayOrObservableArray,
	arrayOrObservableArrayOf: arrayOrObservableArrayOf,
	objectOrObservableObject: objectOrObservableObject
});

function isStateless(component) {
    // `function() {}` has prototype, but `() => {}` doesn't
    // `() => {}` via Babel has prototype too.
    return !(component.prototype && component.prototype.render);
}

var injectorContextTypes = {
    mobxStores: objectOrObservableObject
};
Object.seal(injectorContextTypes);

var proxiedInjectorProps = {
    contextTypes: {
        get: function get$$1() {
            return injectorContextTypes;
        },
        set: function set$$1(_) {
            console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
        },
        configurable: true,
        enumerable: false
    },
    isMobxInjector: {
        value: true,
        writable: true,
        configurable: true,
        enumerable: true
    }

    /**
     * Store Injection
     */
};function createStoreInjector(grabStoresFn, component, injectNames) {
    var _class, _temp2;

    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
    if (injectNames) displayName += "-with-" + injectNames;

    var Injector = (_temp2 = _class = function (_Component) {
        inherits(Injector, _Component);

        function Injector() {
            var _ref;

            var _temp, _this, _ret;

            classCallCheck(this, Injector);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
                _this.wrappedInstance = instance;
            }, _temp), possibleConstructorReturn(_this, _ret);
        }

        createClass(Injector, [{
            key: "render",
            value: function render() {
                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
                // See this test: 'using a custom injector is not too reactive' in inject.js
                var newProps = {};
                for (var key in this.props) {
                    if (this.props.hasOwnProperty(key)) {
                        newProps[key] = this.props[key];
                    }
                }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
                for (var _key2 in additionalProps) {
                    newProps[_key2] = additionalProps[_key2];
                }

                if (!isStateless(component)) {
                    newProps.ref = this.storeRef;
                }

                return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, newProps);
            }
        }]);
        return Injector;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = displayName, _temp2);

    // Static fields from component should be visible on the generated Injector

    hoistNonReactStatics(Injector, component);

    Injector.wrappedComponent = component;
    Object.defineProperties(Injector, proxiedInjectorProps);

    return Injector;
}

function grabStoresByName(storeNames) {
    return function (baseStores, nextProps) {
        storeNames.forEach(function (storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}

/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */
function inject() /* fn(stores, nextProps) or ...storeNames */{
    var grabStoresFn = void 0;
    if (typeof arguments[0] === "function") {
        grabStoresFn = arguments[0];
        return function (componentClass) {
            var injected = createStoreInjector(grabStoresFn, componentClass);
            injected.isMobxInjector = false; // supress warning
            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
            // see #111
            injected = observer(injected);
            injected.isMobxInjector = true; // restore warning
            return injected;
        };
    } else {
        var storeNames = [];
        for (var i = 0; i < arguments.length; i++) {
            storeNames[i] = arguments[i];
        }grabStoresFn = grabStoresByName(storeNames);
        return function (componentClass) {
            return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
        };
    }
}

/**
 * dev tool support
 */
var isDevtoolsEnabled = false;

var isUsingStaticRendering = false;

var warnedAboutObserverInjectDeprecation = false;

// WeakMap<Node, Object>;
var componentByNodeRegistery = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
var renderReporter = new EventEmitter();

function findDOMNode$2(component) {
    if (__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"]) {
        try {
            return Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(component);
        } catch (e) {
            // findDOMNode will throw in react-test-renderer, see:
            // See https://github.com/mobxjs/mobx-react/issues/216
            // Is there a better heuristic?
            return null;
        }
    }
    return null;
}

function reportRendering(component) {
    var node = findDOMNode$2(component);
    if (node && componentByNodeRegistery) componentByNodeRegistery.set(node, component);

    renderReporter.emit({
        event: "render",
        renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
        totalTime: Date.now() - component.__$mobRenderStart,
        component: component,
        node: node
    });
}

function trackComponents() {
    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
}

function useStaticRendering(useStaticRendering) {
    isUsingStaticRendering = useStaticRendering;
}

/**
 * Errors reporter
 */

var errorsReporter = new EventEmitter();

/**
 * Utilities
 */

function patch(target, funcName) {
    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var base = target[funcName];
    var mixinFunc = reactiveMixin[funcName];
    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
        mixinFunc.apply(this, arguments);
        base.apply(this, arguments);
    } : function () {
        base.apply(this, arguments);
        mixinFunc.apply(this, arguments);
    };

    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
    // ...but that breaks react-hot-loader, see #231...
    target[funcName] = f;
}

function shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
}

function is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
    } else {
        return x !== x && y !== y;
    }
}

/**
 * ReactiveMixin
 */
var reactiveMixin = {
    componentWillMount: function componentWillMount() {
        var _this = this;

        if (isUsingStaticRendering === true) return;
        // Generate friendly name for debugging
        var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
        var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalFiber && this._reactInternalFiber._debugID;

        /**
         * If props are shallowly modified, react will render anyway,
         * so atom.reportChanged() should not result in yet another re-render
         */
        var skipRender = false;
        /**
         * forceUpdate will re-assign this.props. We don't want that to cause a loop,
         * so detect these changes
         */
        var isForcingUpdate = false;

        function makePropertyObservableReference(propName) {
            var valueHolder = this[propName];
            var atom = new __WEBPACK_IMPORTED_MODULE_0_mobx__["Atom"]("reactive " + propName);
            Object.defineProperty(this, propName, {
                configurable: true,
                enumerable: true,
                get: function get$$1() {
                    atom.reportObserved();
                    return valueHolder;
                },
                set: function set$$1(v) {
                    if (!isForcingUpdate && !shallowEqual(valueHolder, v)) {
                        valueHolder = v;
                        skipRender = true;
                        atom.reportChanged();
                        skipRender = false;
                    } else {
                        valueHolder = v;
                    }
                }
            });
        }

        // make this.props an observable reference, see #124
        makePropertyObservableReference.call(this, "props");
        // make state an observable reference
        makePropertyObservableReference.call(this, "state");

        // wire up reactive render
        var baseRender = this.render.bind(this);
        var reaction = null;
        var isRenderingPending = false;

        var initialRender = function initialRender() {
            reaction = new __WEBPACK_IMPORTED_MODULE_0_mobx__["Reaction"](initialName + "#" + rootNodeID + ".render()", function () {
                if (!isRenderingPending) {
                    // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
                    // This unidiomatic React usage but React will correctly warn about this so we continue as usual
                    // See #85 / Pull #44
                    isRenderingPending = true;
                    if (typeof _this.componentWillReact === "function") _this.componentWillReact(); // TODO: wrap in action?
                    if (_this.__$mobxIsUnmounted !== true) {
                        // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
                        // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
                        // However, people also claim this migth happen during unit tests..
                        var hasError = true;
                        try {
                            isForcingUpdate = true;
                            if (!skipRender) __WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.forceUpdate.call(_this);
                            hasError = false;
                        } finally {
                            isForcingUpdate = false;
                            if (hasError) reaction.dispose();
                        }
                    }
                }
            });
            reaction.reactComponent = _this;
            reactiveRender.$mobx = reaction;
            _this.render = reactiveRender;
            return reactiveRender();
        };

        var reactiveRender = function reactiveRender() {
            isRenderingPending = false;
            var exception = undefined;
            var rendering = undefined;
            reaction.track(function () {
                if (isDevtoolsEnabled) {
                    _this.__$mobRenderStart = Date.now();
                }
                try {
                    rendering = __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"].allowStateChanges(false, baseRender);
                } catch (e) {
                    exception = e;
                }
                if (isDevtoolsEnabled) {
                    _this.__$mobRenderEnd = Date.now();
                }
            });
            if (exception) {
                errorsReporter.emit(exception);
                throw exception;
            }
            return rendering;
        };

        this.render = initialRender;
    },

    componentWillUnmount: function componentWillUnmount() {
        if (isUsingStaticRendering === true) return;
        this.render.$mobx && this.render.$mobx.dispose();
        this.__$mobxIsUnmounted = true;
        if (isDevtoolsEnabled) {
            var node = findDOMNode$2(this);
            if (node && componentByNodeRegistery) {
                componentByNodeRegistery.delete(node);
            }
            renderReporter.emit({
                event: "destroy",
                component: this,
                node: node
            });
        }
    },

    componentDidMount: function componentDidMount() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    componentDidUpdate: function componentDidUpdate() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        if (isUsingStaticRendering) {
            console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
        }
        // update on any state changes (as is the default)
        if (this.state !== nextState) {
            return true;
        }
        // update if props are shallowly not equal, inspired by PureRenderMixin
        // we could return just 'false' here, and avoid the `skipRender` checks etc
        // however, it is nicer if lifecycle events are triggered like usually,
        // so we return true here if props are shallowly modified.
        return !shallowEqual(this.props, nextProps);
    }

    /**
     * Observer function / decorator
     */
};function observer(arg1, arg2) {
    if (typeof arg1 === "string") {
        throw new Error("Store names should be provided as array");
    }
    if (Array.isArray(arg1)) {
        // component needs stores
        if (!warnedAboutObserverInjectDeprecation) {
            warnedAboutObserverInjectDeprecation = true;
            console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
        }
        if (!arg2) {
            // invoked as decorator
            return function (componentClass) {
                return observer(arg1, componentClass);
            };
        } else {
            return inject.apply(null, arg1)(observer(arg2));
        }
    }
    var componentClass = arg1;

    if (componentClass.isMobxInjector === true) {
        console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
    }

    // Stateless function component:
    // If it is function but doesn't seem to be a react class constructor,
    // wrap it to a react class automatically
    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !__WEBPACK_IMPORTED_MODULE_1_react__["Component"].isPrototypeOf(componentClass)) {
        var _class, _temp;

        return observer((_temp = _class = function (_Component) {
            inherits(_class, _Component);

            function _class() {
                classCallCheck(this, _class);
                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            createClass(_class, [{
                key: "render",
                value: function render() {
                    return componentClass.call(this, this.props, this.context);
                }
            }]);
            return _class;
        }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
    }

    if (!componentClass) {
        throw new Error("Please pass a valid component to 'observer'");
    }

    var target = componentClass.prototype || componentClass;
    mixinLifecycleEvents(target);
    componentClass.isMobXReactObserver = true;
    return componentClass;
}

function mixinLifecycleEvents(target) {
    patch(target, "componentWillMount", true);["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
        patch(target, funcName);
    });
    if (!target.shouldComponentUpdate) {
        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
    }
}

// TODO: support injection somehow as well?
var Observer = observer(function (_ref) {
    var children = _ref.children,
        observerInject = _ref.inject,
        render = _ref.render;

    var component = children || render;
    if (typeof component === "undefined") {
        return null;
    }
    if (!observerInject) {
        return component();
    }
    var InjectComponent = inject(observerInject)(component);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InjectComponent, null);
});

Observer.displayName = "Observer";

var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
        return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
    }

    if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
        return;
    }
    return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
};

Observer.propTypes = {
    render: ObserverPropsCheck,
    children: ObserverPropsCheck
};

var _class;
var _temp;

var specialReactKeys = { children: true, key: true, ref: true };

var Provider = (_temp = _class = function (_Component) {
    inherits(Provider, _Component);

    function Provider() {
        classCallCheck(this, Provider);
        return possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
    }

    createClass(Provider, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
        }
    }, {
        key: "getChildContext",
        value: function getChildContext() {
            var stores = {};
            // inherit stores
            var baseStores = this.context.mobxStores;
            if (baseStores) for (var key in baseStores) {
                stores[key] = baseStores[key];
            }
            // add own stores
            for (var _key in this.props) {
                if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
            }return {
                mobxStores: stores
            };
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            // Maybe this warning is too aggressive?
            if (Object.keys(nextProps).length !== Object.keys(this.props).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
            if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
                if (!specialReactKeys[key] && this.props[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
            }
        }
    }]);
    return Provider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.contextTypes = {
    mobxStores: objectOrObservableObject
}, _class.childContextTypes = {
    mobxStores: objectOrObservableObject.isRequired
}, _temp);

if (!__WEBPACK_IMPORTED_MODULE_1_react__["Component"]) throw new Error("mobx-react requires React to be available");
if (!__WEBPACK_IMPORTED_MODULE_0_mobx__["extras"]) throw new Error("mobx-react requires mobx to be available");

if (typeof __WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"] === "function") __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"].setReactionScheduler(__WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"]);else if (typeof unstable_batchedUpdates$1 === "function") __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"].setReactionScheduler(unstable_batchedUpdates$1);

var onError = function onError(fn) {
    return errorsReporter.on(fn);
};

/* DevTool support */
// See: https://github.com/andykog/mobx-devtools/blob/d8976c24b8cb727ed59f9a0bc905a009df79e221/src/backend/installGlobalHook.js

if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
    var mobx$1 = { spy: __WEBPACK_IMPORTED_MODULE_0_mobx__["spy"], extras: __WEBPACK_IMPORTED_MODULE_0_mobx__["extras"] };
    var mobxReact = { renderReporter: renderReporter, componentByNodeRegistery: componentByNodeRegistery, trackComponents: trackComponents };
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
}




/***/ }),

/***/ "./node_modules/mobx/lib/mobx.module.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extras", function() { return extras; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Reaction", function() { return Reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "untracked", function() { return untracked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IDerivationState", function() { return IDerivationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Atom", function() { return Atom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseAtom", function() { return BaseAtom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useStrict", function() { return useStrict; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStrictModeEnabled", function() { return isStrictModeEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "spy", function() { return spy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "comparer", function() { return comparer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asReference", function() { return asReference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asFlat", function() { return asFlat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asStructure", function() { return asStructure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asMap", function() { return asMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isModifierDescriptor", function() { return isModifierDescriptor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableObject", function() { return isObservableObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBoxedObservable", function() { return isObservableValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableArray", function() { return isObservableArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableMap", function() { return ObservableMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservableMap", function() { return isObservableMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transaction", function() { return transaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observable", function() { return observable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computed", function() { return computed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObservable", function() { return isObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isComputed", function() { return isComputed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendObservable", function() { return extendObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendShallowObservable", function() { return extendShallowObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "observe", function() { return observe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intercept", function() { return intercept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autorun", function() { return autorun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autorunAsync", function() { return autorunAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "when", function() { return when; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reaction", function() { return reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "action", function() { return action; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAction", function() { return isAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runInAction", function() { return runInAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expr", function() { return expr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toJS", function() { return toJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTransformer", function() { return createTransformer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "whyRun", function() { return whyRun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trace", function() { return trace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArrayLike", function() { return isArrayLike; });
/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

/**
 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
 *
 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
 */
var BaseAtom = /** @class */ (function () {
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function BaseAtom(name) {
        if (name === void 0) { name = "Atom@" + getNextId(); }
        this.name = name;
        this.isPendingUnobservation = true; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.NOT_TRACKING;
    }
    BaseAtom.prototype.onBecomeUnobserved = function () {
        // noop
    };
    /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     */
    BaseAtom.prototype.reportObserved = function () {
        reportObserved(this);
    };
    /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
    BaseAtom.prototype.reportChanged = function () {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    BaseAtom.prototype.toString = function () {
        return this.name;
    };
    return BaseAtom;
}());
var Atom = /** @class */ (function (_super) {
    __extends(Atom, _super);
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function Atom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
        if (name === void 0) { name = "Atom@" + getNextId(); }
        if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
        if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
        var _this = _super.call(this, name) || this;
        _this.name = name;
        _this.onBecomeObservedHandler = onBecomeObservedHandler;
        _this.onBecomeUnobservedHandler = onBecomeUnobservedHandler;
        _this.isPendingUnobservation = false; // for effective unobserving.
        _this.isBeingTracked = false;
        return _this;
    }
    Atom.prototype.reportObserved = function () {
        startBatch();
        _super.prototype.reportObserved.call(this);
        if (!this.isBeingTracked) {
            this.isBeingTracked = true;
            this.onBecomeObservedHandler();
        }
        endBatch();
        return !!globalState.trackingDerivation;
        // return doesn't really give useful info, because it can be as well calling computed which calls atom (no reactions)
        // also it could not trigger when calculating reaction dependent on Atom because Atom's value was cached by computed called by given reaction.
    };
    Atom.prototype.onBecomeUnobserved = function () {
        this.isBeingTracked = false;
        this.onBecomeUnobservedHandler();
    };
    return Atom;
}(BaseAtom));
var isAtom = createInstanceofPredicate("Atom", BaseAtom);

function hasInterceptors(interceptable) {
    return interceptable.interceptors && interceptable.interceptors.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1)
            interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        var interceptors = interceptable.interceptors;
        if (interceptors)
            for (var i = 0, l = interceptors.length; i < l; i++) {
                change = interceptors[i](change);
                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
                if (!change)
                    break;
            }
        return change;
    }
    finally {
        untrackedEnd(prevU);
    }
}

function hasListeners(listenable) {
    return listenable.changeListeners && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1)
            listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners;
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd(prevU);
}

function isSpyEnabled() {
    return !!globalState.spyListeners.length;
}
function spyReport(event) {
    if (!globalState.spyListeners.length)
        return;
    var listeners = globalState.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++)
        listeners[i](event);
}
function spyReportStart(event) {
    var change = objectAssign({}, event, { spyReportStart: true });
    spyReport(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd(change) {
    if (change)
        spyReport(objectAssign({}, change, END_EVENT));
    else
        spyReport(END_EVENT);
}
function spy(listener) {
    globalState.spyListeners.push(listener);
    return once(function () {
        var idx = globalState.spyListeners.indexOf(listener);
        if (idx !== -1)
            globalState.spyListeners.splice(idx, 1);
    });
}

function iteratorSymbol() {
    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
}
var IS_ITERATING_MARKER = "__$$iterating";
function arrayAsIterator(array) {
    // returning an array for entries(), values() etc for maps was a mis-interpretation of the specs..,
    // yet it is quite convenient to be able to use the response both as array directly and as iterator
    // it is suboptimal, but alas...
    invariant(array[IS_ITERATING_MARKER] !== true, "Illegal state: cannot recycle array as iterator");
    addHiddenFinalProp(array, IS_ITERATING_MARKER, true);
    var idx = -1;
    addHiddenFinalProp(array, "next", function next() {
        idx++;
        return {
            done: idx >= this.length,
            value: idx < this.length ? this[idx] : undefined
        };
    });
    return array;
}
function declareIterator(prototType, iteratorFactory) {
    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
}

var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
var safariPrototypeSetterInheritanceBug = (function () {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function () {
            v = true;
        }
    });
    Object.create(p)["0"] = 1;
    return v === false;
})();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */
var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = /** @class */ (function () {
    function StubArray() {
    }
    return StubArray;
}());
function inherit(ctor, proto) {
    if (typeof Object["setPrototypeOf"] !== "undefined") {
        Object["setPrototypeOf"](ctor.prototype, proto);
    }
    else if (typeof ctor.prototype.__proto__ !== "undefined") {
        ctor.prototype.__proto__ = proto;
    }
    else {
        ctor["prototype"] = proto;
    }
}
inherit(StubArray, Array.prototype);
// Weex freeze Array.prototype
// Make them writeable and configurable in prototype chain
// https://github.com/alibaba/weex/pull/1529
if (Object.isFrozen(Array)) {
    
    [
        "constructor",
        "push",
        "shift",
        "concat",
        "pop",
        "unshift",
        "replace",
        "find",
        "findIndex",
        "splice",
        "reverse",
        "sort"
    ].forEach(function (key) {
        Object.defineProperty(StubArray.prototype, key, {
            configurable: true,
            writable: true,
            value: Array.prototype[key]
        });
    });
}
var ObservableArrayAdministration = /** @class */ (function () {
    function ObservableArrayAdministration(name, enhancer, array, owned) {
        this.array = array;
        this.owned = owned;
        this.values = [];
        this.lastKnownLength = 0;
        this.interceptors = null;
        this.changeListeners = null;
        this.atom = new BaseAtom(name || "ObservableArray@" + getNextId());
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
        if (this.dehancer !== undefined)
            return values.map(this.dehancer);
        return values;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        if (fireImmediately) {
            listener({
                object: this.array,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0)
            throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength)
            return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++)
                newItems[i] = undefined; // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        }
        else
            this.spliceWithArray(newLength, currentLength - newLength);
    };
    // adds / removes the necessary numeric properties to this object
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength)
            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
        this.lastKnownLength += delta;
        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
            reserveArrayBuffer(oldLength + delta + 1);
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom);
        var length = this.values.length;
        if (index === undefined)
            index = 0;
        else if (index > length)
            index = length;
        else if (index < 0)
            index = Math.max(0, length + index);
        if (arguments.length === 1)
            deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null)
            deleteCount = 0;
        else
            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined)
            newItems = [];
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.array,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change)
                return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.map(function (v) { return _this.enhancer(v, undefined); });
        var lengthDelta = newItems.length - deleteCount;
        this.updateArrayLength(length, lengthDelta); // create or remove new entries
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0)
            this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, [index, deleteCount].concat(newItems));
        }
        else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values
                .slice(0, index)
                .concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
        var _a;
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "update",
                index: index,
                newValue: newValue,
                oldValue: oldValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        this.atom.reportChanged();
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "splice",
                index: index,
                removed: removed,
                added: added,
                removedCount: removed.length,
                addedCount: added.length
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    return ObservableArrayAdministration;
}());
var ObservableArray = /** @class */ (function (_super) {
    __extends(ObservableArray, _super);
    function ObservableArray(initialValues, enhancer, name, owned) {
        if (name === void 0) { name = "ObservableArray@" + getNextId(); }
        if (owned === void 0) { owned = false; }
        var _this = _super.call(this) || this;
        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
        addHiddenFinalProp(_this, "$mobx", adm);
        if (initialValues && initialValues.length) {
            _this.spliceWithArray(0, 0, initialValues);
        }
        if (safariPrototypeSetterInheritanceBug) {
            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(adm.array, "0", ENTRY_0);
        }
        return _this;
    }
    ObservableArray.prototype.intercept = function (handler) {
        return this.$mobx.intercept(handler);
    };
    ObservableArray.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        return this.$mobx.observe(listener, fireImmediately);
    };
    ObservableArray.prototype.clear = function () {
        return this.splice(0);
    };
    ObservableArray.prototype.concat = function () {
        var arrays = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arrays[_i] = arguments[_i];
        }
        this.$mobx.atom.reportObserved();
        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray(a) ? a.peek() : a); }));
    };
    ObservableArray.prototype.replace = function (newItems) {
        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
    };
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    ObservableArray.prototype.toJS = function () {
        return this.slice();
    };
    ObservableArray.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableArray.prototype.peek = function () {
        this.$mobx.atom.reportObserved();
        return this.$mobx.dehanceValues(this.$mobx.values);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        var idx = this.findIndex.apply(this, arguments);
        return idx === -1 ? undefined : this.get(idx);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        var items = this.peek(), l = items.length;
        for (var i = fromIndex; i < l; i++)
            if (predicate.call(thisArg, items[i], i, this))
                return i;
        return -1;
    };
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */
    ObservableArray.prototype.splice = function (index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return this.$mobx.spliceWithArray(index);
            case 2:
                return this.$mobx.spliceWithArray(index, deleteCount);
        }
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.push = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.pop = function () {
        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
    };
    ObservableArray.prototype.shift = function () {
        return this.splice(0, 1)[0];
    };
    ObservableArray.prototype.unshift = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.reverse = function () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    };
    ObservableArray.prototype.sort = function (compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    };
    ObservableArray.prototype.remove = function (value) {
        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    };
    ObservableArray.prototype.move = function (fromIndex, toIndex) {
        function checkIndex(index) {
            if (index < 0) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
            }
            var length = this.$mobx.values.length;
            if (index >= length) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
            }
        }
        checkIndex.call(this, fromIndex);
        checkIndex.call(this, toIndex);
        if (fromIndex === toIndex) {
            return;
        }
        var oldItems = this.$mobx.values;
        var newItems;
        if (fromIndex < toIndex) {
            newItems = oldItems.slice(0, fromIndex).concat(oldItems.slice(fromIndex + 1, toIndex + 1), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex + 1));
        }
        else {
            // toIndex < fromIndex
            newItems = oldItems.slice(0, toIndex).concat([
                oldItems[fromIndex]
            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
        }
        this.replace(newItems);
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.get = function (index) {
        var impl = this.$mobx;
        if (impl) {
            if (index < impl.values.length) {
                impl.atom.reportObserved();
                return impl.dehanceValue(impl.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl
                .values
                .length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.set = function (index, newValue) {
        var adm = this.$mobx;
        var values = adm.values;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(adm.atom);
            var oldValue = values[index];
            if (hasInterceptors(adm)) {
                var change = interceptChange(adm, {
                    type: "update",
                    object: this,
                    index: index,
                    newValue: newValue
                });
                if (!change)
                    return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        }
        else if (index === values.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        }
        else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
        }
    };
    return ObservableArray;
}(StubArray));
declareIterator(ObservableArray.prototype, function () {
    return arrayAsIterator(this.slice());
});
Object.defineProperty(ObservableArray.prototype, "length", {
    enumerable: false,
    configurable: true,
    get: function () {
        return this.$mobx.getArrayLength();
    },
    set: function (newLength) {
        this.$mobx.setArrayLength(newLength);
    }
});
[
    "every",
    "filter",
    "forEach",
    "indexOf",
    "join",
    "lastIndexOf",
    "map",
    "reduce",
    "reduceRight",
    "slice",
    "some",
    "toString",
    "toLocaleString"
].forEach(function (funcName) {
    var baseFunc = Array.prototype[funcName];
    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
    addHiddenProp(ObservableArray.prototype, funcName, function () {
        return baseFunc.apply(this.peek(), arguments);
    });
});
/**
 * We don't want those to show up in `for (const key in ar)` ...
 */
makeNonEnumerable(ObservableArray.prototype, [
    "constructor",
    "intercept",
    "observe",
    "clear",
    "concat",
    "get",
    "replace",
    "toJS",
    "toJSON",
    "peek",
    "find",
    "findIndex",
    "splice",
    "spliceWithArray",
    "push",
    "pop",
    "set",
    "shift",
    "unshift",
    "reverse",
    "sort",
    "remove",
    "move",
    "toString",
    "toLocaleString"
]);
// See #364
var ENTRY_0 = createArrayEntryDescriptor(0);
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: false,
        get: function () {
            // TODO: Check `this`?, see #752?
            return this.get(index);
        },
        set: function (value) {
            this.set(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
        createArrayBufferItem(index);
    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
}
reserveArrayBuffer(1000);
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
}

var UNCHANGED = {};
var ObservableValue = /** @class */ (function (_super) {
    __extends(ObservableValue, _super);
    function ObservableValue(value, enhancer, name, notifySpy) {
        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
        if (notifySpy === void 0) { notifySpy = true; }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.hasUnreportedChange = false;
        _this.dehancer = undefined;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled()) {
            // only notify spy if this is a stand-alone observable
            spyReport({ type: "create", object: _this, newValue: _this.value });
        }
        return _this;
    }
    ObservableValue.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableValue.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy) {
                spyReportStart({
                    type: "update",
                    object: this,
                    newValue: newValue,
                    oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableValue.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change)
                return UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.value !== newValue ? newValue : UNCHANGED;
    };
    ObservableValue.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners(this)) {
            notifyListeners(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        }
    };
    ObservableValue.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableValue.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately)
            listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
            });
        return registerListener(this, listener);
    };
    ObservableValue.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    return ObservableValue;
}(BaseAtom));
ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);

var messages = {
    m001: "It is not allowed to assign new values to @action fields",
    m002: "`runInAction` expects a function",
    m003: "`runInAction` expects a function without arguments",
    m004: "autorun expects a function",
    m005: "Warning: attempted to pass an action to autorun. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
    m006: "Warning: attempted to pass an action to autorunAsync. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
    m007: "reaction only accepts 2 or 3 arguments. If migrating from MobX 2, please provide an options object",
    m008: "wrapping reaction expression in `asReference` is no longer supported, use options object instead",
    m009: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'. It looks like it was used on a property.",
    m010: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'",
    m011: "First argument to `computed` should be an expression. If using computed as decorator, don't pass it arguments",
    m012: "computed takes one or two arguments if used as function",
    m013: "[mobx.expr] 'expr' should only be used inside other reactive functions.",
    m014: "extendObservable expected 2 or more arguments",
    m015: "extendObservable expects an object as first argument",
    m016: "extendObservable should not be used on maps, use map.merge instead",
    m017: "all arguments of extendObservable should be objects",
    m018: "extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540",
    m019: "[mobx.isObservable] isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.",
    m020: "modifiers can only be used for individual object properties",
    m021: "observable expects zero or one arguments",
    m022: "@observable can not be used on getters, use @computed instead",
    m024: "whyRun() can only be used if a derivation is active, or by passing an computed value / reaction explicitly. If you invoked whyRun from inside a computation; the computation is currently suspended but re-evaluating because somebody requested its value.",
    m025: "whyRun can only be used on reactions and computed values",
    m026: "`action` can only be invoked on functions",
    m028: "It is not allowed to set `useStrict` when a derivation is running",
    m029: "INTERNAL ERROR only onBecomeUnobserved shouldn't be called twice in a row",
    m030a: "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: ",
    m030b: "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ",
    m031: "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: ",
    m032: "* This computation is suspended (not in use by any reaction) and won't run automatically.\n	Didn't expect this computation to be suspended at this point?\n	  1. Make sure this computation is used by a reaction (reaction, autorun, observer).\n	  2. Check whether you are using this computation synchronously (in the same stack as they reaction that needs it).",
    m033: "`observe` doesn't support the fire immediately property for observable maps.",
    m034: "`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead",
    m035: "Cannot make the designated object observable; it is not extensible",
    m036: "It is not possible to get index atoms from arrays",
    m037: "Hi there! I'm sorry you have just run into an exception.\nIf your debugger ends up here, know that some reaction (like the render() of an observer component, autorun or reaction)\nthrew an exception and that mobx caught it, to avoid that it brings the rest of your application down.\nThe original cause of the exception (the code that caused this reaction to run (again)), is still in the stack.\n\nHowever, more interesting is the actual stack trace of the error itself.\nHopefully the error is an instanceof Error, because in that case you can inspect the original stack of the error from where it was thrown.\nSee `error.stack` property, or press the very subtle \"(...)\" link you see near the console.error message that probably brought you here.\nThat stack is more interesting than the stack of this console.error itself.\n\nIf the exception you see is an exception you created yourself, make sure to use `throw new Error(\"Oops\")` instead of `throw \"Oops\"`,\nbecause the javascript environment will only preserve the original stack trace in the first form.\n\nYou can also make sure the debugger pauses the next time this very same exception is thrown by enabling \"Pause on caught exception\".\n(Note that it might pause on many other, unrelated exception as well).\n\nIf that all doesn't help you out, feel free to open an issue https://github.com/mobxjs/mobx/issues!\n",
    m038: "Missing items in this list?\n    1. Check whether all used values are properly marked as observable (use isObservable to verify)\n    2. Make sure you didn't dereference values too early. MobX observes props, not primitives. E.g: use 'person.name' instead of 'name' in your computation.\n"
};
function getMessage(id) {
    return messages[id];
}

function createAction(actionName, fn) {
    invariant(typeof fn === "function", getMessage("m026"));
    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
    var res = function () {
        return executeAction(actionName, fn, this, arguments);
    };
    res.originalFn = fn;
    res.isMobxAction = true;
    return res;
}
function executeAction(actionName, fn, scope, args) {
    var runInfo = startAction(actionName, fn, scope, args);
    try {
        return fn.apply(scope, args);
    }
    finally {
        endAction(runInfo);
    }
}
function startAction(actionName, fn, scope, args) {
    var notifySpy = isSpyEnabled() && !!actionName;
    var startTime = 0;
    if (notifySpy) {
        startTime = Date.now();
        var l = (args && args.length) || 0;
        var flattendArgs = new Array(l);
        if (l > 0)
            for (var i = 0; i < l; i++)
                flattendArgs[i] = args[i];
        spyReportStart({
            type: "action",
            name: actionName,
            fn: fn,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart();
    startBatch();
    var prevAllowStateChanges = allowStateChangesStart(true);
    return {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        notifySpy: notifySpy,
        startTime: startTime
    };
}
function endAction(runInfo) {
    allowStateChangesEnd(runInfo.prevAllowStateChanges);
    endBatch();
    untrackedEnd(runInfo.prevDerivation);
    if (runInfo.notifySpy)
        spyReportEnd({ time: Date.now() - runInfo.startTime });
}
function useStrict(strict) {
    invariant(globalState.trackingDerivation === null, getMessage("m028"));
    globalState.strictMode = strict;
    globalState.allowStateChanges = !strict;
}
function isStrictModeEnabled() {
    return globalState.strictMode;
}
function allowStateChanges(allowStateChanges, func) {
    // TODO: deprecate / refactor this function in next major
    // Currently only used by `@observer`
    // Proposed change: remove first param, rename to `forbidStateChanges`,
    // require error callback instead of the hardcoded error message now used
    // Use `inAction` instead of allowStateChanges in derivation.ts to check strictMode
    var prev = allowStateChangesStart(allowStateChanges);
    var res;
    try {
        res = func();
    }
    finally {
        allowStateChangesEnd(prev);
    }
    return res;
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}

/**
 * Constructs a decorator, that normalizes the differences between
 * TypeScript and Babel. Mainly caused by the fact that legacy-decorator cannot assign
 * values during instance creation to properties that have a getter setter.
 *
 * - Sigh -
 *
 * Also takes care of the difference between @decorator field and @decorator(args) field, and different forms of values.
 * For performance (cpu and mem) reasons the properties are always defined on the prototype (at least initially).
 * This means that these properties despite being enumerable might not show up in Object.keys() (but they will show up in for...in loops).
 */
function createClassPropertyDecorator(
/**
 * This function is invoked once, when the property is added to a new instance.
 * When this happens is not strictly determined due to differences in TS and Babel:
 * Typescript: Usually when constructing the new instance
 * Babel, sometimes Typescript: during the first get / set
 * Both: when calling `runLazyInitializers(instance)`
 */
onInitialize, get, set, enumerable, 
/**
 * Can this decorator invoked with arguments? e.g. @decorator(args)
 */
allowCustomArguments) {
    function classPropertyDecorator(target, key, descriptor, customArgs, argLen) {
        if (argLen === void 0) { argLen = 0; }
        invariant(allowCustomArguments || quacksLikeADecorator(arguments), "This function is a decorator, but it wasn't invoked like a decorator");
        if (!descriptor) {
            // typescript (except for getter / setters)
            var newDescriptor = {
                enumerable: enumerable,
                configurable: true,
                get: function () {
                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true)
                        typescriptInitializeProperty(this, key, undefined, onInitialize, customArgs, descriptor);
                    return get.call(this, key);
                },
                set: function (v) {
                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true) {
                        typescriptInitializeProperty(this, key, v, onInitialize, customArgs, descriptor);
                    }
                    else {
                        set.call(this, key, v);
                    }
                }
            };
            if (arguments.length < 3 || (arguments.length === 5 && argLen < 3)) {
                // Typescript target is ES3, so it won't define property for us
                // or using Reflect.decorate polyfill, which will return no descriptor
                // (see https://github.com/mobxjs/mobx/issues/333)
                Object.defineProperty(target, key, newDescriptor);
            }
            return newDescriptor;
        }
        else {
            // babel and typescript getter / setter props
            if (!hasOwnProperty(target, "__mobxLazyInitializers")) {
                addHiddenProp(target, "__mobxLazyInitializers", (target.__mobxLazyInitializers && target.__mobxLazyInitializers.slice()) || [] // support inheritance
                );
            }
            var value_1 = descriptor.value, initializer_1 = descriptor.initializer;
            target.__mobxLazyInitializers.push(function (instance) {
                onInitialize(instance, key, initializer_1 ? initializer_1.call(instance) : value_1, customArgs, descriptor);
            });
            return {
                enumerable: enumerable,
                configurable: true,
                get: function () {
                    if (this.__mobxDidRunLazyInitializers !== true)
                        runLazyInitializers(this);
                    return get.call(this, key);
                },
                set: function (v) {
                    if (this.__mobxDidRunLazyInitializers !== true)
                        runLazyInitializers(this);
                    set.call(this, key, v);
                }
            };
        }
    }
    if (allowCustomArguments) {
        /** If custom arguments are allowed, we should return a function that returns a decorator */
        return function () {
            /** Direct invocation: @decorator bla */
            if (quacksLikeADecorator(arguments))
                return classPropertyDecorator.apply(null, arguments);
            /** Indirect invocation: @decorator(args) bla */
            var outerArgs = arguments;
            var argLen = arguments.length;
            return function (target, key, descriptor) {
                return classPropertyDecorator(target, key, descriptor, outerArgs, argLen);
            };
        };
    }
    return classPropertyDecorator;
}
function typescriptInitializeProperty(instance, key, v, onInitialize, customArgs, baseDescriptor) {
    if (!hasOwnProperty(instance, "__mobxInitializedProps"))
        addHiddenProp(instance, "__mobxInitializedProps", {});
    instance.__mobxInitializedProps[key] = true;
    onInitialize(instance, key, v, customArgs, baseDescriptor);
}
function runLazyInitializers(instance) {
    if (instance.__mobxDidRunLazyInitializers === true)
        return;
    if (instance.__mobxLazyInitializers) {
        addHiddenProp(instance, "__mobxDidRunLazyInitializers", true);
        instance.__mobxDidRunLazyInitializers &&
            instance.__mobxLazyInitializers.forEach(function (initializer) { return initializer(instance); });
    }
}
function quacksLikeADecorator(args) {
    return (args.length === 2 || args.length === 3) && typeof args[1] === "string";
}

var actionFieldDecorator = createClassPropertyDecorator(function (target, key, value, args, originalDescriptor) {
    var actionName = args && args.length === 1 ? args[0] : value.name || key || "<unnamed action>";
    var wrappedAction = action(actionName, value);
    addHiddenProp(target, key, wrappedAction);
}, function (key) {
    return this[key];
}, function () {
    invariant(false, getMessage("m001"));
}, false, true);
var boundActionDecorator = createClassPropertyDecorator(function (target, key, value) {
    defineBoundAction(target, key, value);
}, function (key) {
    return this[key];
}, function () {
    invariant(false, getMessage("m001"));
}, false, false);
var action = function action(arg1, arg2, arg3, arg4) {
    if (arguments.length === 1 && typeof arg1 === "function")
        return createAction(arg1.name || "<unnamed action>", arg1);
    if (arguments.length === 2 && typeof arg2 === "function")
        return createAction(arg1, arg2);
    if (arguments.length === 1 && typeof arg1 === "string")
        return namedActionDecorator(arg1);
    return namedActionDecorator(arg2).apply(null, arguments);
};
action.bound = function boundAction(arg1, arg2, arg3) {
    if (typeof arg1 === "function") {
        var action_1 = createAction("<not yet bound action>", arg1);
        action_1.autoBind = true;
        return action_1;
    }
    return boundActionDecorator.apply(null, arguments);
};
function namedActionDecorator(name) {
    return function (target, prop, descriptor) {
        if (descriptor && typeof descriptor.value === "function") {
            // TypeScript @action method() { }. Defined on proto before being decorated
            // Don't use the field decorator if we are just decorating a method
            descriptor.value = createAction(name, descriptor.value);
            descriptor.enumerable = false;
            descriptor.configurable = true;
            return descriptor;
        }
        if (descriptor !== undefined && descriptor.get !== undefined) {
            throw new Error("[mobx] action is not expected to be used with getters");
        }
        // bound instance methods
        return actionFieldDecorator(name).apply(this, arguments);
    };
}
function runInAction(arg1, arg2, arg3) {
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    var scope = typeof arg1 === "function" ? arg2 : arg3;
    invariant(typeof fn === "function", getMessage("m002"));
    invariant(fn.length === 0, getMessage("m003"));
    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
    return executeAction(actionName, fn, scope, undefined);
}
function isAction(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
    var res = function () {
        return executeAction(propertyName, fn, target, arguments);
    };
    res.isMobxAction = true;
    addHiddenProp(target, propertyName, res);
}

var toString = Object.prototype.toString;
function deepEqual(a, b) {
    return eq(a, b);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b)
        return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null)
        return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a)
        return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object")
        return false;
    return deepEq(a, b, aStack, bStack);
}
// Internal recursive comparison function for `isEqual`.
function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b))
        return false;
    switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a)
                return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
    }
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object")
            return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor &&
            !(typeof aCtor === "function" &&
                aCtor instanceof aCtor &&
                typeof bCtor === "function" &&
                bCtor instanceof bCtor) &&
            ("constructor" in a && "constructor" in b)) {
            return false;
        }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a)
            return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length)
            return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
            if (!eq(a[length], b[length], aStack, bStack))
                return false;
        }
    }
    else {
        // Deep compare objects.
        var keys = Object.keys(a), key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length)
            return false;
        while (length--) {
            // Deep compare each member
            key = keys[length];
            if (!(has(b, key) && eq(a[key], b[key], aStack, bStack)))
                return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a))
        return a.peek();
    if (isObservableMap(a))
        return a.entries();
    if (isES6Map(a))
        return iteratorToArray(a.entries());
    return a;
}
function has(a, key) {
    return Object.prototype.hasOwnProperty.call(a, key);
}

function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function defaultComparer(a, b) {
    return areBothNaN(a, b) || identityComparer(a, b);
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer
};

function autorun(arg1, arg2, arg3) {
    var name, view, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        view = arg2;
        scope = arg3;
    }
    else {
        name = arg1.name || "Autorun@" + getNextId();
        view = arg1;
        scope = arg2;
    }
    invariant(typeof view === "function", getMessage("m004"));
    invariant(isAction(view) === false, getMessage("m005"));
    if (scope)
        view = view.bind(scope);
    var reaction = new Reaction(name, function () {
        this.track(reactionRunner);
    });
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule();
    return reaction.getDisposer();
}
function when(arg1, arg2, arg3, arg4) {
    var name, predicate, effect, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        predicate = arg2;
        effect = arg3;
        scope = arg4;
    }
    else {
        name = "When@" + getNextId();
        predicate = arg1;
        effect = arg2;
        scope = arg3;
    }
    var disposer = autorun(name, function (r) {
        if (predicate.call(scope)) {
            r.dispose();
            var prevUntracked = untrackedStart();
            effect.call(scope);
            untrackedEnd(prevUntracked);
        }
    });
    return disposer;
}
function autorunAsync(arg1, arg2, arg3, arg4) {
    var name, func, delay, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        func = arg2;
        delay = arg3;
        scope = arg4;
    }
    else {
        name = arg1.name || "AutorunAsync@" + getNextId();
        func = arg1;
        delay = arg2;
        scope = arg3;
    }
    invariant(isAction(func) === false, getMessage("m006"));
    if (delay === void 0)
        delay = 1;
    if (scope)
        func = func.bind(scope);
    var isScheduled = false;
    var r = new Reaction(name, function () {
        if (!isScheduled) {
            isScheduled = true;
            setTimeout(function () {
                isScheduled = false;
                if (!r.isDisposed)
                    r.track(reactionRunner);
            }, delay);
        }
    });
    function reactionRunner() {
        func(r);
    }
    r.schedule();
    return r.getDisposer();
}
function reaction(expression, effect, arg3) {
    if (arguments.length > 3) {
        fail(getMessage("m007"));
    }
    if (isModifierDescriptor(expression)) {
        fail(getMessage("m008"));
    }
    var opts;
    if (typeof arg3 === "object") {
        opts = arg3;
    }
    else {
        opts = {};
    }
    opts.name =
        opts.name || expression.name || effect.name || "Reaction@" + getNextId();
    opts.fireImmediately = arg3 === true || opts.fireImmediately === true;
    opts.delay = opts.delay || 0;
    opts.compareStructural = opts.compareStructural || opts.struct || false;
    // TODO: creates ugly spy events, use `effect = (r) => runInAction(opts.name, () => effect(r))` instead
    effect = action(opts.name, opts.context ? effect.bind(opts.context) : effect);
    if (opts.context) {
        expression = expression.bind(opts.context);
    }
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.equals
        ? opts.equals
        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
    var r = new Reaction(opts.name, function () {
        if (firstTime || opts.delay < 1) {
            reactionRunner();
        }
        else if (!isScheduled) {
            isScheduled = true;
            setTimeout(function () {
                isScheduled = false;
                reactionRunner();
            }, opts.delay);
        }
    });
    function reactionRunner() {
        if (r.isDisposed)
            return;
        var changed = false;
        r.track(function () {
            var nextValue = expression(r);
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately)
            effect(value, r);
        if (!firstTime && changed === true)
            effect(value, r);
        if (firstTime)
            firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = /** @class */ (function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce an new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue(derivation, scope, equals, name, setter) {
        this.derivation = derivation;
        this.scope = scope;
        this.equals = equals;
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isPendingUnobservation = false;
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.value = new CaughtException(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.isTracing = TraceMode.NONE;
        this.name = name || "ComputedValue@" + getNextId();
        if (setter)
            this.setter = createAction(name + "-setter", setter);
    }
    ComputedValue.prototype.onBecomeStale = function () {
        propagateMaybeChanged(this);
    };
    ComputedValue.prototype.onBecomeUnobserved = function () {
        clearObserving(this);
        this.value = undefined;
    };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue.prototype.get = function () {
        invariant(!this.isComputing, "Cycle detected in computation " + this.name, this.derivation);
        if (globalState.inBatch === 0) {
            // This is an minor optimization which could be omitted to simplify the code
            // The computedValue is accessed outside of any mobx stuff. Batch observing should be enough and don't need
            // tracking as it will never be called again inside this batch.
            startBatch();
            if (shouldCompute(this)) {
                if (this.isTracing !== TraceMode.NONE) {
                    console.log("[mobx.trace] '" + this
                        .name + "' is being read outside a reactive context and doing a full recompute");
                }
                this.value = this.computeValue(false);
            }
            endBatch();
        }
        else {
            reportObserved(this);
            if (shouldCompute(this))
                if (this.trackAndCompute())
                    propagateChangeConfirmed(this);
        }
        var result = this.value;
        if (isCaughtException(result))
            throw result.cause;
        return result;
    };
    ComputedValue.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException(res))
            throw res.cause;
        return res;
    };
    ComputedValue.prototype.set = function (value) {
        if (this.setter) {
            invariant(!this.isRunningSetter, "The setter of computed value '" + this
                .name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            }
            finally {
                this.isRunningSetter = false;
            }
        }
        else
            invariant(false, "[ComputedValue '" + this
                .name + "'] It is not possible to assign a new value to a computed value.");
    };
    ComputedValue.prototype.trackAndCompute = function () {
        if (isSpyEnabled()) {
            spyReport({
                object: this.scope,
                type: "compute",
                fn: this.derivation
            });
        }
        var oldValue = this.value;
        var wasSuspended = 
        /* see #1208 */ this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = (this.value = this.computeValue(true));
        return (wasSuspended ||
            isCaughtException(oldValue) ||
            isCaughtException(newValue) ||
            !this.equals(oldValue, newValue));
    };
    ComputedValue.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction(this, this.derivation, this.scope);
        }
        else {
            try {
                res = this.derivation.call(this.scope);
            }
            catch (e) {
                res = new CaughtException(e);
            }
        }
        globalState.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    ComputedValue.prototype.whyRun = function () {
        var isTracking = Boolean(globalState.trackingDerivation);
        var observing = unique(this.isComputing ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
        var observers = unique(getObservers(this).map(function (dep) { return dep.name; }));
        return ("\nWhyRun? computation '" + this.name + "':\n * Running because: " + (isTracking
            ? "[active] the value of this computation is needed by a reaction"
            : this.isComputing
                ? "[get] The value of this computed was requested outside a reaction"
                : "[idle] not running at the moment") + "\n" +
            (this.dependenciesState === IDerivationState.NOT_TRACKING
                ? getMessage("m032")
                : " * This computation will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this.isComputing && isTracking
                    ? " (... or any observable accessed during the remainder of the current run)"
                    : "") + "\n    " + getMessage("m038") + "\n\n  * If the outcome of this computation changes, the following observers will be re-run:\n    " + joinStrings(observers) + "\n"));
    };
    return ComputedValue;
}());
ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);

var ObservableObjectAdministration = /** @class */ (function () {
    function ObservableObjectAdministration(target, name) {
        this.target = target;
        this.name = name;
        this.values = {};
        this.changeListeners = null;
        this.interceptors = null;
    }
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
        invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener(this, callback);
    };
    ObservableObjectAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableObjectAdministration;
}());
function asObservableObject(target, name) {
    if (isObservableObject(target) && target.hasOwnProperty("$mobx"))
        return target.$mobx;
    invariant(Object.isExtensible(target), getMessage("m035"));
    if (!isPlainObject(target))
        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
    if (!name)
        name = "ObservableObject@" + getNextId();
    var adm = new ObservableObjectAdministration(target, name);
    addHiddenFinalProp(target, "$mobx", adm);
    return adm;
}
function defineObservablePropertyFromDescriptor(adm, propName, descriptor, defaultEnhancer) {
    if (adm.values[propName] && !isComputedValue(adm.values[propName])) {
        // already observable property
        invariant("value" in descriptor, "The property " + propName + " in " + adm.name + " is already observable, cannot redefine it as computed property");
        adm.target[propName] = descriptor.value; // the property setter will make 'value' reactive if needed.
        return;
    }
    // not yet observable property
    if ("value" in descriptor) {
        // not a computed value
        if (isModifierDescriptor(descriptor.value)) {
            // x : ref(someValue)
            var modifierDescriptor = descriptor.value;
            defineObservableProperty(adm, propName, modifierDescriptor.initialValue, modifierDescriptor.enhancer);
        }
        else if (isAction(descriptor.value) && descriptor.value.autoBind === true) {
            defineBoundAction(adm.target, propName, descriptor.value.originalFn);
        }
        else if (isComputedValue(descriptor.value)) {
            // x: computed(someExpr)
            defineComputedPropertyFromComputedValue(adm, propName, descriptor.value);
        }
        else {
            // x: someValue
            defineObservableProperty(adm, propName, descriptor.value, defaultEnhancer);
        }
    }
    else {
        // get x() { return 3 } set x(v) { }
        defineComputedProperty(adm, propName, descriptor.get, descriptor.set, comparer.default, true);
    }
}
function defineObservableProperty(adm, propName, newValue, enhancer) {
    assertPropertyConfigurable(adm.target, propName);
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            object: adm.target,
            name: propName,
            type: "add",
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    var observable = (adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false));
    newValue = observable.value; // observableValue might have changed it
    Object.defineProperty(adm.target, propName, generateObservablePropConfig(propName));
    notifyPropertyAddition(adm, adm.target, propName, newValue);
}
function defineComputedProperty(adm, propName, getter, setter, equals, asInstanceProperty) {
    if (asInstanceProperty)
        assertPropertyConfigurable(adm.target, propName);
    adm.values[propName] = new ComputedValue(getter, adm.target, equals, adm.name + "." + propName, setter);
    if (asInstanceProperty) {
        Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
    }
}
function defineComputedPropertyFromComputedValue(adm, propName, computedValue) {
    var name = adm.name + "." + propName;
    computedValue.name = name;
    if (!computedValue.scope)
        computedValue.scope = adm.target;
    adm.values[propName] = computedValue;
    Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
}
var observablePropertyConfigs = {};
var computedPropertyConfigs = {};
function generateObservablePropConfig(propName) {
    return (observablePropertyConfigs[propName] ||
        (observablePropertyConfigs[propName] = {
            configurable: true,
            enumerable: true,
            get: function () {
                return this.$mobx.values[propName].get();
            },
            set: function (v) {
                setPropertyValue(this, propName, v);
            }
        }));
}
function generateComputedPropConfig(propName) {
    return (computedPropertyConfigs[propName] ||
        (computedPropertyConfigs[propName] = {
            configurable: true,
            enumerable: false,
            get: function () {
                return this.$mobx.values[propName].get();
            },
            set: function (v) {
                return this.$mobx.values[propName].set(v);
            }
        }));
}
function setPropertyValue(instance, name, newValue) {
    var adm = instance.$mobx;
    var observable = adm.values[name];
    // intercept
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            type: "update",
            object: instance,
            name: name,
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    newValue = observable.prepareNewValue(newValue);
    // notify spy & observers
    if (newValue !== UNCHANGED) {
        var notify = hasListeners(adm);
        var notifySpy = isSpyEnabled();
        var change = notify || notifySpy
            ? {
                type: "update",
                object: instance,
                oldValue: observable.value,
                name: name,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        observable.setNewValue(newValue);
        if (notify)
            notifyListeners(adm, change);
        if (notifySpy)
            spyReportEnd();
    }
}
function notifyPropertyAddition(adm, object, name, newValue) {
    var notify = hasListeners(adm);
    var notifySpy = isSpyEnabled();
    var change = notify || notifySpy
        ? {
            type: "add",
            object: object,
            name: name,
            newValue: newValue
        }
        : null;
    if (notifySpy)
        spyReportStart(change);
    if (notify)
        notifyListeners(adm, change);
    if (notifySpy)
        spyReportEnd();
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
    if (isObject(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        runLazyInitializers(thing);
        return isObservableObjectAdministration(thing.$mobx);
    }
    return false;
}

/**
 * Returns true if the provided value is reactive.
 * @param value object, function or array
 * @param property if property is specified, checks whether value.property is reactive.
 */
function isObservable(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableArray(value) || isObservableMap(value))
            throw new Error(getMessage("m019"));
        else if (isObservableObject(value)) {
            var o = value.$mobx;
            return o.values && !!o.values[property];
        }
        return false;
    }
    // For first check, see #701
    return (isObservableObject(value) ||
        !!value.$mobx ||
        isAtom(value) ||
        isReaction(value) ||
        isComputedValue(value));
}

function createDecoratorForEnhancer(enhancer) {
    invariant(!!enhancer, ":(");
    return createClassPropertyDecorator(function (target, name, baseValue, _, baseDescriptor) {
        assertPropertyConfigurable(target, name);
        invariant(!baseDescriptor || !baseDescriptor.get, getMessage("m022"));
        var adm = asObservableObject(target, undefined);
        defineObservableProperty(adm, name, baseValue, enhancer);
    }, function (name) {
        var observable = this.$mobx.values[name];
        if (observable === undefined // See #505
        )
            return undefined;
        return observable.get();
    }, function (name, value) {
        setPropertyValue(this, name, value);
    }, true, false);
}

function extendObservable(target) {
    var properties = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        properties[_i - 1] = arguments[_i];
    }
    return extendObservableHelper(target, deepEnhancer, properties);
}
function extendShallowObservable(target) {
    var properties = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        properties[_i - 1] = arguments[_i];
    }
    return extendObservableHelper(target, referenceEnhancer, properties);
}
function extendObservableHelper(target, defaultEnhancer, properties) {
    invariant(arguments.length >= 2, getMessage("m014"));
    invariant(typeof target === "object", getMessage("m015"));
    invariant(!isObservableMap(target), getMessage("m016"));
    properties.forEach(function (propSet) {
        invariant(typeof propSet === "object", getMessage("m017"));
        invariant(!isObservable(propSet), getMessage("m018"));
    });
    var adm = asObservableObject(target);
    var definedProps = {};
    // Note could be optimised if properties.length === 1
    for (var i = properties.length - 1; i >= 0; i--) {
        var propSet = properties[i];
        for (var key in propSet)
            if (definedProps[key] !== true && hasOwnProperty(propSet, key)) {
                definedProps[key] = true;
                if (target === propSet && !isPropertyConfigurable(target, key))
                    continue; // see #111, skip non-configurable or non-writable props for `observable(object)`.
                var descriptor = Object.getOwnPropertyDescriptor(propSet, key);
                defineObservablePropertyFromDescriptor(adm, key, descriptor, defaultEnhancer);
            }
    }
    return target;
}

var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var deepStructDecorator = createDecoratorForEnhancer(deepStructEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v) {
    if (v === void 0) { v = undefined; }
    // @observable someProp;
    if (typeof arguments[1] === "string")
        return deepDecorator.apply(null, arguments);
    invariant(arguments.length <= 1, getMessage("m021"));
    invariant(!isModifierDescriptor(v), getMessage("m020"));
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    var res = deepEnhancer(v, undefined, undefined);
    // this value could be converted to a new observable data structure, return it
    if (res !== v)
        return res;
    // otherwise, just box it
    return observable.box(v);
}
var observableFactories = {
    box: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("box");
        return new ObservableValue(value, deepEnhancer, name);
    },
    shallowBox: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowBox");
        return new ObservableValue(value, referenceEnhancer, name);
    },
    array: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("array");
        return new ObservableArray(initialValues, deepEnhancer, name);
    },
    shallowArray: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowArray");
        return new ObservableArray(initialValues, referenceEnhancer, name);
    },
    map: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("map");
        return new ObservableMap(initialValues, deepEnhancer, name);
    },
    shallowMap: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowMap");
        return new ObservableMap(initialValues, referenceEnhancer, name);
    },
    object: function (props, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("object");
        var res = {};
        // convert to observable object
        asObservableObject(res, name);
        // add properties
        extendObservable(res, props);
        return res;
    },
    shallowObject: function (props, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowObject");
        var res = {};
        asObservableObject(res, name);
        extendShallowObservable(res, props);
        return res;
    },
    ref: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(referenceEnhancer, arguments[0]);
        }
        else {
            return refDecorator.apply(null, arguments);
        }
    },
    shallow: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(shallowEnhancer, arguments[0]);
        }
        else {
            return shallowDecorator.apply(null, arguments);
        }
    },
    deep: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(deepEnhancer, arguments[0]);
        }
        else {
            return deepDecorator.apply(null, arguments);
        }
    },
    struct: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(deepStructEnhancer, arguments[0]);
        }
        else {
            return deepStructDecorator.apply(null, arguments);
        }
    }
};
var observable = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
observable.deep.struct = observable.struct;
observable.ref.struct = function () {
    if (arguments.length < 2) {
        return createModifierDescriptor(refStructEnhancer, arguments[0]);
    }
    else {
        return refStructDecorator.apply(null, arguments);
    }
};
function incorrectlyUsedAsDecorator(methodName) {
    fail("Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}

function isModifierDescriptor(thing) {
    return typeof thing === "object" && thing !== null && thing.isMobxModifierDescriptor === true;
}
function createModifierDescriptor(enhancer, initialValue) {
    invariant(!isModifierDescriptor(initialValue), "Modifiers cannot be nested");
    return {
        isMobxModifierDescriptor: true,
        initialValue: initialValue,
        enhancer: enhancer
    };
}
function deepEnhancer(v, _, name) {
    if (isModifierDescriptor(v))
        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return observable.array(v, name);
    if (isPlainObject(v))
        return observable.object(v, name);
    if (isES6Map(v))
        return observable.map(v, name);
    return v;
}
function shallowEnhancer(v, _, name) {
    if (isModifierDescriptor(v))
        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
    if (v === undefined || v === null)
        return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v))
        return v;
    if (Array.isArray(v))
        return observable.shallowArray(v, name);
    if (isPlainObject(v))
        return observable.shallowObject(v, name);
    if (isES6Map(v))
        return observable.shallowMap(v, name);
    return fail("The shallow modifier / decorator can only used in combination with arrays, objects and maps");
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function deepStructEnhancer(v, oldValue, name) {
    // don't confuse structurally compare enhancer with ref enhancer! The latter is probably
    // more suited for immutable objects
    if (deepEqual(v, oldValue))
        return oldValue;
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return new ObservableArray(v, deepStructEnhancer, name);
    if (isES6Map(v))
        return new ObservableMap(v, deepStructEnhancer, name);
    if (isPlainObject(v)) {
        var res = {};
        asObservableObject(res, name);
        extendObservableHelper(res, deepStructEnhancer, [v]);
        return res;
    }
    return v;
}
function refStructEnhancer(v, oldValue, name) {
    if (deepEqual(v, oldValue))
        return oldValue;
    return v;
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
    if (thisArg === void 0) { thisArg = undefined; }
    startBatch();
    try {
        return action.apply(thisArg);
    }
    finally {
        endBatch();
    }
}

var ObservableMapMarker = {};
var ObservableMap = /** @class */ (function () {
    function ObservableMap(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer; }
        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
        this.enhancer = enhancer;
        this.name = name;
        this.$mobx = ObservableMapMarker;
        this._data = Object.create(null);
        this._hasMap = Object.create(null); // hasMap, not hashMap >-).
        this._keys = new ObservableArray(undefined, referenceEnhancer, this.name + ".keys()", true);
        this.interceptors = null;
        this.changeListeners = null;
        this.dehancer = undefined;
        this.merge(initialData);
    }
    ObservableMap.prototype._has = function (key) {
        return typeof this._data[key] !== "undefined";
    };
    ObservableMap.prototype.has = function (key) {
        if (!this.isValidKey(key))
            return false;
        key = "" + key;
        if (this._hasMap[key])
            return this._hasMap[key].get();
        return this._updateHasMapEntry(key, false).get();
    };
    ObservableMap.prototype.set = function (key, value) {
        this.assertValidKey(key);
        key = "" + key;
        var hasKey = this._has(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change)
                return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        }
        else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap.prototype.delete = function (key) {
        var _this = this;
        this.assertValidKey(key);
        key = "" + key;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change)
                return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: this._data[key].value,
                    name: key
                }
                : null;
            if (notifySpy)
                spyReportStart(change);
            transaction(function () {
                _this._keys.remove(key);
                _this._updateHasMapEntry(key, false);
                var observable$$1 = _this._data[key];
                observable$$1.setNewValue(undefined);
                _this._data[key] = undefined;
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
        var entry = this._hasMap[key];
        if (entry) {
            entry.setNewValue(value);
        }
        else {
            entry = this._hasMap[key] = new ObservableValue(value, referenceEnhancer, this.name + "." + key + "?", false);
        }
        return entry;
    };
    ObservableMap.prototype._updateValue = function (name, newValue) {
        var observable$$1 = this._data[name];
        newValue = observable$$1.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this,
                    oldValue: observable$$1.value,
                    name: name,
                    newValue: newValue
                }
                : null;
            if (notifySpy)
                spyReportStart(change);
            observable$$1.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableMap.prototype._addValue = function (name, newValue) {
        var _this = this;
        transaction(function () {
            var observable$$1 = (_this._data[name] = new ObservableValue(newValue, _this.enhancer, _this.name + "." + name, false));
            newValue = observable$$1.value; // value might have been changed
            _this._updateHasMapEntry(name, true);
            _this._keys.push(name);
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this,
                name: name,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableMap.prototype.get = function (key) {
        key = "" + key;
        if (this.has(key))
            return this.dehanceValue(this._data[key].get());
        return this.dehanceValue(undefined);
    };
    ObservableMap.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap.prototype.keys = function () {
        return arrayAsIterator(this._keys.slice());
    };
    ObservableMap.prototype.values = function () {
        return arrayAsIterator(this._keys.map(this.get, this));
    };
    ObservableMap.prototype.entries = function () {
        var _this = this;
        return arrayAsIterator(this._keys.map(function (key) { return [key, _this.get(key)]; }));
    };
    ObservableMap.prototype.forEach = function (callback, thisArg) {
        var _this = this;
        this.keys().forEach(function (key) { return callback.call(thisArg, _this.get(key), key, _this); });
    };
    /** Merge another object into this object, returns this. */
    ObservableMap.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap(other)) {
            other = other.toJS();
        }
        transaction(function () {
            if (isPlainObject(other))
                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
            else if (Array.isArray(other))
                other.forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    return _this.set(key, value);
                });
            else if (isES6Map(other))
                other.forEach(function (value, key) { return _this.set(key, value); });
            else if (other !== null && other !== undefined)
                fail("Cannot initialize map from " + other);
        });
        return this;
    };
    ObservableMap.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                _this.keys().forEach(_this.delete, _this);
            });
        });
    };
    ObservableMap.prototype.replace = function (values) {
        var _this = this;
        transaction(function () {
            // grab all the keys that are present in the new map but not present in the current map
            // and delete them from the map, then merge the new map
            // this will cause reactions only on changed values
            var newKeys = getMapLikeKeys(values);
            var oldKeys = _this.keys();
            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
            missingKeys.forEach(function (k) { return _this.delete(k); });
            _this.merge(values);
        });
        return this;
    };
    Object.defineProperty(ObservableMap.prototype, "size", {
        get: function () {
            return this._keys.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values might still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap.prototype.toJS = function () {
        var _this = this;
        var res = {};
        this.keys().forEach(function (key) { return (res[key] = _this.get(key)); });
        return res;
    };
    ObservableMap.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableMap.prototype.isValidKey = function (key) {
        if (key === null || key === undefined)
            return false;
        if (typeof key === "string" || typeof key === "number" || typeof key === "boolean")
            return true;
        return false;
    };
    ObservableMap.prototype.assertValidKey = function (key) {
        if (!this.isValidKey(key))
            throw new Error("[mobx.map] Invalid key: '" + key + "', only strings, numbers and booleans are accepted as key in observable maps.");
    };
    ObservableMap.prototype.toString = function () {
        var _this = this;
        return (this.name +
            "[{ " +
            this.keys().map(function (key) { return key + ": " + ("" + _this.get(key)); }).join(", ") +
            " }]");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap.prototype.observe = function (listener, fireImmediately) {
        invariant(fireImmediately !== true, getMessage("m033"));
        return registerListener(this, listener);
    };
    ObservableMap.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableMap;
}());
declareIterator(ObservableMap.prototype, function () {
    return this.entries();
});
function map(initialValues) {
    deprecated("`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead");
    return observable.map(initialValues);
}
/* 'var' fixes small-build issue */
var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);

var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
function getGlobal() {
    return typeof window !== "undefined" ? window : global;
}
function getNextId() {
    return ++globalState.mobxGuid;
}
function fail(message, thing) {
    invariant(false, message, thing);
    throw "X"; // unreachable
}
function invariant(check, message, thing) {
    if (!check)
        throw new Error("[mobx] Invariant failed: " + message + (thing ? " in '" + thing + "'" : ""));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated(msg) {
    if (deprecatedMessages.indexOf(msg) !== -1)
        return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
    var invoked = false;
    return function () {
        if (invoked)
            return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function () { };
function unique(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1)
            res.push(item);
    });
    return res;
}
function joinStrings(things, limit, separator) {
    if (limit === void 0) { limit = 100; }
    if (separator === void 0) { separator = " - "; }
    if (!things)
        return "";
    var sliced = things.slice(0, limit);
    return "" + sliced.join(separator) + (things.length > limit
        ? " (... and " + (things.length - limit) + "more)"
        : "");
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
function objectAssign() {
    var res = arguments[0];
    for (var i = 1, l = arguments.length; i < l; i++) {
        var source = arguments[i];
        for (var key in source)
            if (hasOwnProperty(source, key)) {
                res[key] = source[key];
            }
    }
    return res;
}
var prototypeHasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwnProperty(object, propName) {
    return prototypeHasOwnProperty.call(object, propName);
}
function makeNonEnumerable(object, propNames) {
    for (var i = 0; i < propNames.length; i++) {
        addHiddenProp(object, propNames[i], object[propNames[i]]);
    }
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
}
function assertPropertyConfigurable(object, prop) {
    invariant(isPropertyConfigurable(object, prop), "Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
}
function createInstanceofPredicate(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject(x) && x[propName] === true;
    };
}
function areBothNaN(a, b) {
    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */
function isArrayLike(x) {
    return Array.isArray(x) || isObservableArray(x);
}
function isES6Map(thing) {
    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map)
        return true;
    return false;
}
function getMapLikeKeys(map$$1) {
    if (isPlainObject(map$$1))
        return Object.keys(map$$1);
    if (Array.isArray(map$$1))
        return map$$1.map(function (_a) {
            var key = _a[0];
            return key;
        });
    if (isES6Map(map$$1))
        return Array.from(map$$1.keys());
    if (isObservableMap(map$$1))
        return map$$1.keys();
    return fail("Cannot get keys from " + map$$1);
}
function iteratorToArray(it) {
    var res = [];
    while (true) {
        var r = it.next();
        if (r.done)
            break;
        res.push(r.value);
    }
    return res;
}
function primitiveSymbol() {
    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}

/**
 * These values will persist if global state is reset
 */
var persistentKeys = ["mobxGuid", "resetId", "spyListeners", "strictMode", "runId"];
var MobXGlobals = /** @class */ (function () {
    function MobXGlobals() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         */
        this.version = 5;
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.strictMode = false;
        /**
         * Used by createTransformer to detect that the global state has been reset.
         */
        this.resetId = 0;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
    }
    return MobXGlobals;
}());
var globalState = new MobXGlobals();
var shareGlobalStateCalled = false;
var runInIsolationCalled = false;
var warnedAboutMultipleInstances = false;
{
    var global_1 = getGlobal();
    if (!global_1.__mobxInstanceCount) {
        global_1.__mobxInstanceCount = 1;
    }
    else {
        global_1.__mobxInstanceCount++;
        setTimeout(function () {
            if (!shareGlobalStateCalled && !runInIsolationCalled && !warnedAboutMultipleInstances) {
                warnedAboutMultipleInstances = true;
                console.warn("[mobx] Warning: there are multiple mobx instances active. This might lead to unexpected results. See https://github.com/mobxjs/mobx/issues/1082 for details.");
            }
        }, 1);
    }
}
function isolateGlobalState() {
    runInIsolationCalled = true;
    getGlobal().__mobxInstanceCount--;
}
function shareGlobalState() {
    // TODO: remove in 4.0; just use peer dependencies instead.
    deprecated("Using `shareGlobalState` is not recommended, use peer dependencies instead. See https://github.com/mobxjs/mobx/issues/1082 for details.");
    shareGlobalStateCalled = true;
    var global = getGlobal();
    var ownState = globalState;
    /**
     * Backward compatibility check
     */
    if (global.__mobservableTrackingStack || global.__mobservableViewStack)
        throw new Error("[mobx] An incompatible version of mobservable is already loaded.");
    if (global.__mobxGlobal && global.__mobxGlobal.version !== ownState.version)
        throw new Error("[mobx] An incompatible version of mobx is already loaded.");
    if (global.__mobxGlobal)
        globalState = global.__mobxGlobal;
    else
        global.__mobxGlobal = ownState;
}
function getGlobalState() {
    return globalState;
}

/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState() {
    globalState.resetId++;
    var defaultGlobals = new MobXGlobals();
    for (var key in defaultGlobals)
        if (persistentKeys.indexOf(key) === -1)
            globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.strictMode;
}

function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            invariant(property === undefined, getMessage("m036"));
            return thing.$mobx.atom;
        }
        if (isObservableMap(thing)) {
            var anyThing = thing;
            if (property === undefined)
                return getAtom(anyThing._keys);
            var observable = anyThing._data[property] || anyThing._hasMap[property];
            invariant(!!observable, "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
            return observable;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        runLazyInitializers(thing);
        if (property && !thing.$mobx)
            thing[property]; // See #1072 // TODO: remove in 4.0
        if (isObservableObject(thing)) {
            if (!property)
                return fail("please specify a property");
            var observable = thing.$mobx.values[property];
            invariant(!!observable, "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
            return observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
            return thing;
        }
    }
    else if (typeof thing === "function") {
        if (isReaction(thing.$mobx)) {
            // disposer function
            return thing.$mobx;
        }
    }
    return fail("Cannot obtain atom from " + thing);
}
function getAdministration(thing, property) {
    invariant(thing, "Expecting some object");
    if (property !== undefined)
        return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
        return thing;
    if (isObservableMap(thing))
        return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    runLazyInitializers(thing);
    if (thing.$mobx)
        return thing.$mobx;
    invariant(false, "Cannot obtain administration from " + thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined)
        named = getAtom(thing, property);
    else if (isObservableObject(thing) || isObservableMap(thing))
        named = getAdministration(thing);
    else
        named = getAtom(thing); // valid for arrays as well
    return named.name;
}

function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0)
        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers(node))
        result.observers = getObservers(node).map(nodeToObserverTree);
    return result;
}

function hasObservers(observable) {
    return observable.observers && observable.observers.length > 0;
}
function getObservers(observable) {
    return observable.observers;
}
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    var l = observable.observers.length;
    if (l) {
        // because object assignment is relatively expensive, let's not store data about index 0.
        observable.observersIndexes[node.__mapid] = l;
    }
    observable.observers[l] = node;
    if (observable.lowestObserverState > node.dependenciesState)
        observable.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    if (observable.observers.length === 1) {
        // deleting last observer
        observable.observers.length = 0;
        queueForUnobservation(observable);
    }
    else {
        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
        var list = observable.observers;
        var map = observable.observersIndexes;
        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
        if (filler !== node) {
            // otherwise node was the last element, which already got removed from array
            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
            if (index) {
                // map store all indexes but 0, see comment in `addObserver`
                map[filler.__mapid] = index;
            }
            else {
                delete map[filler.__mapid];
            }
            list[index] = filler;
        }
        delete map[node.__mapid];
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (!observable.isPendingUnobservation) {
        // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers.length === 0) {
                observable.onBecomeUnobserved();
                // NOTE: onBecomeUnobserved might push to `pendingUnobservations`
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable.lastAccessedBy) {
            observable.lastAccessedBy = derivation.runId;
            derivation.newObserving[derivation.unboundDepsCount++] = observable;
        }
    }
    else if (observable.observers.length === 0) {
        queueForUnobservation(observable);
    }
}
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
        d.dependenciesState = IDerivationState.STALE;
    }
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE)
            d.dependenciesState = IDerivationState.STALE;
        else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        )
            observable.lowestObserverState = IDerivationState.UP_TO_DATE;
    }
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE)
        return;
    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
    }
    // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
    if (derivation.isTracing === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString() : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies)
        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
}

var IDerivationState;
(function (IDerivationState) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var TraceMode;
(function (TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = /** @class */ (function () {
    function CaughtException(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException;
}());
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE: {
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing, l = obs.length;
            for (var i = 0; i < l; i++) {
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    try {
                        obj.get();
                    }
                    catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            return false;
        }
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers$$1 = atom.observers.length > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState.computationDepth > 0 && hasObservers$$1)
        fail(getMessage("m031") + atom.name);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && hasObservers$$1)
        fail(getMessage(globalState.strictMode ? "m030a" : "m030b") + atom.name);
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    var result;
    try {
        result = f.call(context);
    }
    catch (e) {
        result = new CaughtException(e);
    }
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    return result;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = (derivation.observing = derivation.newObserving);
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i)
                observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--)
        removeObserver(obs[i], derivation);
    derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action) {
    var prev = untrackedStart();
    var res = action();
    untrackedEnd(prev);
    return res;
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE)
        return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--)
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}

function log(msg) {
    console.log(msg);
    return msg;
}
function whyRun(thing, prop) {
    deprecated("`whyRun` is deprecated in favor of `trace`");
    thing = getAtomFromArgs(arguments);
    if (!thing)
        return log(getMessage("m024"));
    if (isComputedValue(thing) || isReaction(thing))
        return log(thing.whyRun());
    return fail(getMessage("m025"));
}
function trace() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var enterBreakPoint = false;
    if (typeof args[args.length - 1] === "boolean")
        enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) {
        return fail("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    }
    if (derivation.isTracing === TraceMode.NONE) {
        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
    }
    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch (args.length) {
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}

var Reaction = /** @class */ (function () {
    function Reaction(name, onInvalidate) {
        if (name === void 0) { name = "Reaction@" + getNextId(); }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
        this.isTracing = TraceMode.NONE;
    }
    Reaction.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    Reaction.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch();
            this._isScheduled = false;
            if (shouldCompute(this)) {
                this._isTrackPending = true;
                this.onInvalidate();
                if (this._isTrackPending && isSpyEnabled()) {
                    // onInvalidate didn't trigger track right away..
                    spyReport({
                        object: this,
                        type: "scheduled-reaction"
                    });
                }
            }
            endBatch();
        }
    };
    Reaction.prototype.track = function (fn) {
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify) {
            startTime = Date.now();
            spyReportStart({
                object: this,
                type: "reaction",
                fn: fn
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving(this);
        }
        if (isCaughtException(result))
            this.reportExceptionInDerivation(result.cause);
        if (notify) {
            spyReportEnd({
                time: Date.now() - startTime
            });
        }
        endBatch();
    };
    Reaction.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this;
        var messageToUser = getMessage("m037");
        console.error(message || messageToUser /* latter will not be true, make sure uglify doesn't remove */, error);
        /** If debugging brought you here, please, read the above message :-). Tnx! */
        if (isSpyEnabled()) {
            spyReport({
                type: "error",
                message: message,
                error: error,
                object: this
            });
        }
        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
    };
    Reaction.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    Reaction.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r.$mobx = this;
        r.onError = registerErrorHandler;
        return r;
    };
    Reaction.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction.prototype.whyRun = function () {
        var observing = unique(this._isRunning ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
        return "\nWhyRun? reaction '" + this.name + "':\n * Status: [" + (this.isDisposed
            ? "stopped"
            : this._isRunning ? "running" : this.isScheduled() ? "scheduled" : "idle") + "]\n * This reaction will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this._isRunning
            ? " (... or any observable accessed during the remainder of the current run)"
            : "") + "\n\t" + getMessage("m038") + "\n";
    };
    Reaction.prototype.trace = function (enterBreakPoint) {
        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
        trace(this, enterBreakPoint);
    };
    return Reaction;
}());
function registerErrorHandler(handler) {
    invariant(this && this.$mobx && isReaction(this.$mobx), "Invalid `this`");
    invariant(!this.$mobx.errorHandler, "Only one onErrorHandler can be registered");
    this.$mobx.errorHandler = handler;
}
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function () {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0)
            globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function (f) { return f(); };
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions)
        return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++)
            remainingReactions[i].runReaction();
    }
    globalState.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
}

function asReference(value) {
    deprecated("asReference is deprecated, use observable.ref instead");
    return observable.ref(value);
}
function asStructure(value) {
    deprecated("asStructure is deprecated. Use observable.struct, computed.struct or reaction options instead.");
    return observable.struct(value);
}
function asFlat(value) {
    deprecated("asFlat is deprecated, use observable.shallow instead");
    return observable.shallow(value);
}
function asMap(data) {
    deprecated("asMap is deprecated, use observable.map or observable.shallowMap instead");
    return observable.map(data || {});
}

function createComputedDecorator(equals) {
    return createClassPropertyDecorator(function (target, name, _, __, originalDescriptor) {
        invariant(typeof originalDescriptor !== "undefined", getMessage("m009"));
        invariant(typeof originalDescriptor.get === "function", getMessage("m010"));
        var adm = asObservableObject(target, "");
        defineComputedProperty(adm, name, originalDescriptor.get, originalDescriptor.set, equals, false);
    }, function (name) {
        var observable = this.$mobx.values[name];
        if (observable === undefined // See #505
        )
            return undefined;
        return observable.get();
    }, function (name, value) {
        this.$mobx.values[name].set(value);
    }, false, false);
}
var computedDecorator = createComputedDecorator(comparer.default);
var computedStructDecorator = createComputedDecorator(comparer.structural);
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = function computed(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        return computedDecorator.apply(null, arguments);
    }
    invariant(typeof arg1 === "function", getMessage("m011"));
    invariant(arguments.length < 3, getMessage("m012"));
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.setter = typeof arg2 === "function" ? arg2 : opts.setter;
    var equals = opts.equals
        ? opts.equals
        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
    return new ComputedValue(arg1, opts.context, equals, opts.name || arg1.name || "", opts.setter);
};
computed.struct = computedStructDecorator;
computed.equals = createComputedDecorator;

function isComputed(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableObject(value) === false)
            return false;
        if (!value.$mobx.values[property])
            return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}

function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function")
        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else
        return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe(listener, fireImmediately);
}

function intercept(thing, propOrHandler, handler) {
    if (typeof handler === "function")
        return interceptProperty(thing, propOrHandler, handler);
    else
        return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept(handler);
}

/**
 * expr can be used to create temporarily views inside views.
 * This can be improved to improve performance if a value changes often, but usually doesn't affect the outcome of an expression.
 *
 * In the following example the expression prevents that a component is rerender _each time_ the selection changes;
 * instead it will only rerenders when the current todo is (de)selected.
 *
 * reactiveComponent((props) => {
 *     const todo = props.todo;
 *     const isSelected = mobx.expr(() => props.viewState.selection === todo);
 *     return <div className={isSelected ? "todo todo-selected" : "todo"}>{todo.title}</div>
 * });
 *
 */
function expr(expr, scope) {
    if (!isComputingDerivation())
        console.warn(getMessage("m013"));
    // optimization: would be more efficient if the expr itself wouldn't be evaluated first on the next change, but just a 'changed' signal would be fired
    return computed(expr, { context: scope }).get();
}

function toJS(source, detectCycles, __alreadySeen) {
    if (detectCycles === void 0) { detectCycles = true; }
    if (__alreadySeen === void 0) { __alreadySeen = []; }
    // optimization: using ES6 map would be more efficient!
    // optimization: lift this function outside toJS, this makes recursion expensive
    function cache(value) {
        if (detectCycles)
            __alreadySeen.push([source, value]);
        return value;
    }
    if (isObservable(source)) {
        if (detectCycles && __alreadySeen === null)
            __alreadySeen = [];
        if (detectCycles && source !== null && typeof source === "object") {
            for (var i = 0, l = __alreadySeen.length; i < l; i++)
                if (__alreadySeen[i][0] === source)
                    return __alreadySeen[i][1];
        }
        if (isObservableArray(source)) {
            var res = cache([]);
            var toAdd = source.map(function (value) { return toJS(value, detectCycles, __alreadySeen); });
            res.length = toAdd.length;
            for (var i = 0, l = toAdd.length; i < l; i++)
                res[i] = toAdd[i];
            return res;
        }
        if (isObservableObject(source)) {
            var res = cache({});
            for (var key in source)
                res[key] = toJS(source[key], detectCycles, __alreadySeen);
            return res;
        }
        if (isObservableMap(source)) {
            var res_1 = cache({});
            source.forEach(function (value, key) { return (res_1[key] = toJS(value, detectCycles, __alreadySeen)); });
            return res_1;
        }
        if (isObservableValue(source))
            return toJS(source.get(), detectCycles, __alreadySeen);
    }
    return source;
}

function createTransformer(transformer, onCleanup) {
    invariant(typeof transformer === "function" && transformer.length < 2, "createTransformer expects a function that accepts one argument");
    // Memoizes: object id -> reactive view that applies transformer to the object
    var objectCache = {};
    // If the resetId changes, we will clear the object cache, see #163
    // This construction is used to avoid leaking refs to the objectCache directly
    var resetId = globalState.resetId;
    // Local transformer class specifically for this transformer
    var Transformer = /** @class */ (function (_super) {
        __extends(Transformer, _super);
        function Transformer(sourceIdentifier, sourceObject) {
            var _this = _super.call(this, function () { return transformer(sourceObject); }, undefined, comparer.default, "Transformer-" + transformer.name + "-" + sourceIdentifier, undefined) || this;
            _this.sourceIdentifier = sourceIdentifier;
            _this.sourceObject = sourceObject;
            return _this;
        }
        Transformer.prototype.onBecomeUnobserved = function () {
            var lastValue = this.value;
            _super.prototype.onBecomeUnobserved.call(this);
            delete objectCache[this.sourceIdentifier];
            if (onCleanup)
                onCleanup(lastValue, this.sourceObject);
        };
        return Transformer;
    }(ComputedValue));
    return function (object) {
        if (resetId !== globalState.resetId) {
            objectCache = {};
            resetId = globalState.resetId;
        }
        var identifier = getMemoizationId(object);
        var reactiveTransformer = objectCache[identifier];
        if (reactiveTransformer)
            return reactiveTransformer.get();
        // Not in cache; create a reactive view
        reactiveTransformer = objectCache[identifier] = new Transformer(identifier, object);
        return reactiveTransformer.get();
    };
}
function getMemoizationId(object) {
    if (typeof object === "string" || typeof object === "number")
        return object;
    if (object === null || typeof object !== "object")
        throw new Error("[mobx] transform expected some kind of object or primitive value, got: " + object);
    var tid = object.$transformId;
    if (tid === undefined) {
        tid = getNextId();
        addHiddenProp(object, "$transformId", tid);
    }
    return tid;
}

function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
        target = getAdministration(thing);
    }
    else if (isObservableObject(thing)) {
        if (typeof propOrHandler !== "string")
            return fail("InterceptReads can only be used with a specific property, not with an object in general");
        target = getAdministration(thing, propOrHandler);
    }
    else {
        return fail("Expected observable map, object or array as first array");
    }
    if (target.dehancer !== undefined)
        return fail("An intercept reader was already established");
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function () {
        target.dehancer = undefined;
    };
}

/**
 * (c) Michel Weststrate 2015 - 2016
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
var extras = {
    allowStateChanges: allowStateChanges,
    deepEqual: deepEqual,
    getAtom: getAtom,
    getDebugName: getDebugName,
    getDependencyTree: getDependencyTree,
    getAdministration: getAdministration,
    getGlobalState: getGlobalState,
    getObserverTree: getObserverTree,
    interceptReads: interceptReads,
    isComputingDerivation: isComputingDerivation,
    isSpyEnabled: isSpyEnabled,
    onReactionError: onReactionError,
    reserveArrayBuffer: reserveArrayBuffer,
    resetGlobalState: resetGlobalState,
    isolateGlobalState: isolateGlobalState,
    shareGlobalState: shareGlobalState,
    spyReport: spyReport,
    spyReportEnd: spyReportEnd,
    spyReportStart: spyReportStart,
    setReactionScheduler: setReactionScheduler
};
var everything = {
    Reaction: Reaction,
    untracked: untracked,
    Atom: Atom,
    BaseAtom: BaseAtom,
    useStrict: useStrict,
    isStrictModeEnabled: isStrictModeEnabled,
    spy: spy,
    comparer: comparer,
    asReference: asReference,
    asFlat: asFlat,
    asStructure: asStructure,
    asMap: asMap,
    isModifierDescriptor: isModifierDescriptor,
    isObservableObject: isObservableObject,
    isBoxedObservable: isObservableValue,
    isObservableArray: isObservableArray,
    ObservableMap: ObservableMap,
    isObservableMap: isObservableMap,
    map: map,
    transaction: transaction,
    observable: observable,
    computed: computed,
    isObservable: isObservable,
    isComputed: isComputed,
    extendObservable: extendObservable,
    extendShallowObservable: extendShallowObservable,
    observe: observe,
    intercept: intercept,
    autorun: autorun,
    autorunAsync: autorunAsync,
    when: when,
    reaction: reaction,
    action: action,
    isAction: isAction,
    runInAction: runInAction,
    expr: expr,
    toJS: toJS,
    createTransformer: createTransformer,
    whyRun: whyRun,
    isArrayLike: isArrayLike,
    extras: extras
};
var warnedAboutDefaultExport = false;
var _loop_1 = function (p) {
    var val = everything[p];
    Object.defineProperty(everything, p, {
        get: function () {
            if (!warnedAboutDefaultExport) {
                warnedAboutDefaultExport = true;
                console.warn("Using default export (`import mobx from 'mobx'`) is deprecated " +
                    "and won’t work in mobx@4.0.0\n" +
                    "Use `import * as mobx from 'mobx'` instead");
            }
            return val;
        }
    });
};
for (var p in everything) {
    _loop_1(p);
}
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({ spy: spy, extras: extras });
}

/* harmony default export */ __webpack_exports__["default"] = (everything);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/moment/moment.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/ms/index.js":
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/buffer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("./node_modules/base64-js/index.js")
var ieee754 = __webpack_require__("./node_modules/ieee754/index.js")
var isArray = __webpack_require__("./node_modules/isarray/index.js")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/object-assign/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ "./node_modules/parseqs/index.js":
/***/ (function(module, exports) {

/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */

exports.encode = function (obj) {
  var str = '';

  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      if (str.length) str += '&';
      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
  }

  return str;
};

/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */

exports.decode = function(qs){
  var qry = {};
  var pairs = qs.split('&');
  for (var i = 0, l = pairs.length; i < l; i++) {
    var pair = pairs[i].split('=');
    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return qry;
};


/***/ }),

/***/ "./node_modules/parseuri/index.js":
/***/ (function(module, exports) {

/**
 * Parses an URI
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */

var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

var parts = [
    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
];

module.exports = function parseuri(str) {
    var src = str,
        b = str.indexOf('['),
        e = str.indexOf(']');

    if (b != -1 && e != -1) {
        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    }

    var m = re.exec(str || ''),
        uri = {},
        i = 14;

    while (i--) {
        uri[parts[i]] = m[i] || '';
    }

    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }

    return uri;
};


/***/ }),

/***/ "./node_modules/path-to-regexp/index.js":
/***/ (function(module, exports) {

/**
 * Expose `pathtoRegexp`.
 */

module.exports = pathtoRegexp;

/**
 * Match matching groups in a regular expression.
 */
var MATCHING_GROUP_REGEXP = /\((?!\?)/g;

/**
 * Normalize the given path string,
 * returning a regular expression.
 *
 * An empty array should be passed,
 * which will contain the placeholder
 * key names. For example "/user/:id" will
 * then contain ["id"].
 *
 * @param  {String|RegExp|Array} path
 * @param  {Array} keys
 * @param  {Object} options
 * @return {RegExp}
 * @api private
 */

function pathtoRegexp(path, keys, options) {
  options = options || {};
  keys = keys || [];
  var strict = options.strict;
  var end = options.end !== false;
  var flags = options.sensitive ? '' : 'i';
  var extraOffset = 0;
  var keysOffset = keys.length;
  var i = 0;
  var name = 0;
  var m;

  if (path instanceof RegExp) {
    while (m = MATCHING_GROUP_REGEXP.exec(path.source)) {
      keys.push({
        name: name++,
        optional: false,
        offset: m.index
      });
    }

    return path;
  }

  if (Array.isArray(path)) {
    // Map array parts into regexps and return their source. We also pass
    // the same keys and options instance into every generation to get
    // consistent matching groups before we join the sources together.
    path = path.map(function (value) {
      return pathtoRegexp(value, keys, options).source;
    });

    return new RegExp('(?:' + path.join('|') + ')', flags);
  }

  path = ('^' + path + (strict ? '' : path[path.length - 1] === '/' ? '?' : '/?'))
    .replace(/\/\(/g, '/(?:')
    .replace(/([\/\.])/g, '\\$1')
    .replace(/(\\\/)?(\\\.)?:(\w+)(\(.*?\))?(\*)?(\?)?/g, function (match, slash, format, key, capture, star, optional, offset) {
      slash = slash || '';
      format = format || '';
      capture = capture || '([^\\/' + format + ']+?)';
      optional = optional || '';

      keys.push({
        name: key,
        optional: !!optional,
        offset: offset + extraOffset
      });

      var result = ''
        + (optional ? '' : slash)
        + '(?:'
        + format + (optional ? slash : '') + capture
        + (star ? '((?:[\\/' + format + '].+?)?)' : '')
        + ')'
        + optional;

      extraOffset += result.length - match.length;

      return result;
    })
    .replace(/\*/g, function (star, index) {
      var len = keys.length

      while (len-- > keysOffset && keys[len].offset > index) {
        keys[len].offset += 3; // Replacement length minus asterisk length.
      }

      return '(.*)';
    });

  // This is a workaround for handling unnamed matching groups.
  while (m = MATCHING_GROUP_REGEXP.exec(path)) {
    var escapeCount = 0;
    var index = m.index;

    while (path.charAt(--index) === '\\') {
      escapeCount++;
    }

    // It's possible to escape the bracket.
    if (escapeCount % 2 === 1) {
      continue;
    }

    if (keysOffset + i === keys.length || keys[keysOffset + i].offset > m.index) {
      keys.splice(keysOffset + i, 0, {
        name: name++, // Unnamed matching groups must be consistently linear.
        optional: false,
        offset: m.index
      });
    }

    i++;
  }

  // If the path is non-ending, match until the end or a slash.
  path += (end ? '$' : (path[path.length - 1] === '/' ? '' : '(?=\\/|$)'));

  return new RegExp(path, flags);
};


/***/ }),

/***/ "./node_modules/process/browser.js":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "./node_modules/prop-types/checkPropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (false) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),

/***/ "./node_modules/prop-types/factory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__("./node_modules/prop-types/factoryWithTypeCheckers.js");
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),

/***/ "./node_modules/prop-types/factoryWithThrowingShims.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("./node_modules/prop-types/lib/ReactPropTypesSecret.js");

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "./node_modules/prop-types/factoryWithTypeCheckers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__("./node_modules/react-is/index.js");
var assign = __webpack_require__("./node_modules/object-assign/index.js");

var ReactPropTypesSecret = __webpack_require__("./node_modules/prop-types/lib/ReactPropTypesSecret.js");
var checkPropTypes = __webpack_require__("./node_modules/prop-types/checkPropTypes.js");

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "./node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("./node_modules/prop-types/factoryWithThrowingShims.js")();
}


/***/ }),

/***/ "./node_modules/prop-types/lib/ReactPropTypesSecret.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "./node_modules/react-dom/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__("./node_modules/react-dom/lib/ReactDOM.js");


/***/ }),

/***/ "./node_modules/react-dom/lib/ARIADOMPropertyConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),

/***/ "./node_modules/react-dom/lib/AutoFocusUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");

var focusNode = __webpack_require__("./node_modules/fbjs/lib/focusNode.js");

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),

/***/ "./node_modules/react-dom/lib/BeforeInputEventPlugin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__("./node_modules/react-dom/lib/EventPropagators.js");
var ExecutionEnvironment = __webpack_require__("./node_modules/fbjs/lib/ExecutionEnvironment.js");
var FallbackCompositionState = __webpack_require__("./node_modules/react-dom/lib/FallbackCompositionState.js");
var SyntheticCompositionEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticCompositionEvent.js");
var SyntheticInputEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticInputEvent.js");

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),

/***/ "./node_modules/react-dom/lib/CSSProperty.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),

/***/ "./node_modules/react-dom/lib/CSSPropertyOperations.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__("./node_modules/react-dom/lib/CSSProperty.js");
var ExecutionEnvironment = __webpack_require__("./node_modules/fbjs/lib/ExecutionEnvironment.js");
var ReactInstrumentation = __webpack_require__("./node_modules/react-dom/lib/ReactInstrumentation.js");

var camelizeStyleName = __webpack_require__("./node_modules/fbjs/lib/camelizeStyleName.js");
var dangerousStyleValue = __webpack_require__("./node_modules/react-dom/lib/dangerousStyleValue.js");
var hyphenateStyleName = __webpack_require__("./node_modules/fbjs/lib/hyphenateStyleName.js");
var memoizeStringOnly = __webpack_require__("./node_modules/fbjs/lib/memoizeStringOnly.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),

/***/ "./node_modules/react-dom/lib/CallbackQueue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__("./node_modules/react-dom/lib/PooledClass.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),

/***/ "./node_modules/react-dom/lib/ChangeEventPlugin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__("./node_modules/react-dom/lib/EventPluginHub.js");
var EventPropagators = __webpack_require__("./node_modules/react-dom/lib/EventPropagators.js");
var ExecutionEnvironment = __webpack_require__("./node_modules/fbjs/lib/ExecutionEnvironment.js");
var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");
var ReactUpdates = __webpack_require__("./node_modules/react-dom/lib/ReactUpdates.js");
var SyntheticEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticEvent.js");

var inputValueTracking = __webpack_require__("./node_modules/react-dom/lib/inputValueTracking.js");
var getEventTarget = __webpack_require__("./node_modules/react-dom/lib/getEventTarget.js");
var isEventSupported = __webpack_require__("./node_modules/react-dom/lib/isEventSupported.js");
var isTextInputElement = __webpack_require__("./node_modules/react-dom/lib/isTextInputElement.js");

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),

/***/ "./node_modules/react-dom/lib/DOMChildrenOperations.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMLazyTree = __webpack_require__("./node_modules/react-dom/lib/DOMLazyTree.js");
var Danger = __webpack_require__("./node_modules/react-dom/lib/Danger.js");
var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");
var ReactInstrumentation = __webpack_require__("./node_modules/react-dom/lib/ReactInstrumentation.js");

var createMicrosoftUnsafeLocalFunction = __webpack_require__("./node_modules/react-dom/lib/createMicrosoftUnsafeLocalFunction.js");
var setInnerHTML = __webpack_require__("./node_modules/react-dom/lib/setInnerHTML.js");
var setTextContent = __webpack_require__("./node_modules/react-dom/lib/setTextContent.js");

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),

/***/ "./node_modules/react-dom/lib/DOMLazyTree.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = __webpack_require__("./node_modules/react-dom/lib/DOMNamespaces.js");
var setInnerHTML = __webpack_require__("./node_modules/react-dom/lib/setInnerHTML.js");

var createMicrosoftUnsafeLocalFunction = __webpack_require__("./node_modules/react-dom/lib/createMicrosoftUnsafeLocalFunction.js");
var setTextContent = __webpack_require__("./node_modules/react-dom/lib/setTextContent.js");

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),

/***/ "./node_modules/react-dom/lib/DOMNamespaces.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),

/***/ "./node_modules/react-dom/lib/DOMProperty.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),

/***/ "./node_modules/react-dom/lib/DOMPropertyOperations.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__("./node_modules/react-dom/lib/DOMProperty.js");
var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");
var ReactInstrumentation = __webpack_require__("./node_modules/react-dom/lib/ReactInstrumentation.js");

var quoteAttributeValueForBrowser = __webpack_require__("./node_modules/react-dom/lib/quoteAttributeValueForBrowser.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),

/***/ "./node_modules/react-dom/lib/Danger.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var DOMLazyTree = __webpack_require__("./node_modules/react-dom/lib/DOMLazyTree.js");
var ExecutionEnvironment = __webpack_require__("./node_modules/fbjs/lib/ExecutionEnvironment.js");

var createNodesFromMarkup = __webpack_require__("./node_modules/fbjs/lib/createNodesFromMarkup.js");
var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),

/***/ "./node_modules/react-dom/lib/DefaultEventPluginOrder.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),

/***/ "./node_modules/react-dom/lib/EnterLeaveEventPlugin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__("./node_modules/react-dom/lib/EventPropagators.js");
var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");
var SyntheticMouseEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticMouseEvent.js");

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),

/***/ "./node_modules/react-dom/lib/EventPluginHub.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var EventPluginRegistry = __webpack_require__("./node_modules/react-dom/lib/EventPluginRegistry.js");
var EventPluginUtils = __webpack_require__("./node_modules/react-dom/lib/EventPluginUtils.js");
var ReactErrorUtils = __webpack_require__("./node_modules/react-dom/lib/ReactErrorUtils.js");

var accumulateInto = __webpack_require__("./node_modules/react-dom/lib/accumulateInto.js");
var forEachAccumulated = __webpack_require__("./node_modules/react-dom/lib/forEachAccumulated.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),

/***/ "./node_modules/react-dom/lib/EventPluginRegistry.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),

/***/ "./node_modules/react-dom/lib/EventPluginUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var ReactErrorUtils = __webpack_require__("./node_modules/react-dom/lib/ReactErrorUtils.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),

/***/ "./node_modules/react-dom/lib/EventPropagators.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__("./node_modules/react-dom/lib/EventPluginHub.js");
var EventPluginUtils = __webpack_require__("./node_modules/react-dom/lib/EventPluginUtils.js");

var accumulateInto = __webpack_require__("./node_modules/react-dom/lib/accumulateInto.js");
var forEachAccumulated = __webpack_require__("./node_modules/react-dom/lib/forEachAccumulated.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),

/***/ "./node_modules/react-dom/lib/FallbackCompositionState.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("./node_modules/object-assign/index.js");

var PooledClass = __webpack_require__("./node_modules/react-dom/lib/PooledClass.js");

var getTextContentAccessor = __webpack_require__("./node_modules/react-dom/lib/getTextContentAccessor.js");

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),

/***/ "./node_modules/react-dom/lib/HTMLDOMPropertyConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__("./node_modules/react-dom/lib/DOMProperty.js");

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),

/***/ "./node_modules/react-dom/lib/KeyEscapeUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),

/***/ "./node_modules/react-dom/lib/LinkedValueUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var ReactPropTypesSecret = __webpack_require__("./node_modules/react-dom/lib/ReactPropTypesSecret.js");
var propTypesFactory = __webpack_require__("./node_modules/prop-types/factory.js");

var React = __webpack_require__("./node_modules/react/lib/React.js");
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),

/***/ "./node_modules/react-dom/lib/PooledClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactBrowserEventEmitter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("./node_modules/object-assign/index.js");

var EventPluginRegistry = __webpack_require__("./node_modules/react-dom/lib/EventPluginRegistry.js");
var ReactEventEmitterMixin = __webpack_require__("./node_modules/react-dom/lib/ReactEventEmitterMixin.js");
var ViewportMetrics = __webpack_require__("./node_modules/react-dom/lib/ViewportMetrics.js");

var getVendorPrefixedEventName = __webpack_require__("./node_modules/react-dom/lib/getVendorPrefixedEventName.js");
var isEventSupported = __webpack_require__("./node_modules/react-dom/lib/isEventSupported.js");

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactChildReconciler.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactReconciler = __webpack_require__("./node_modules/react-dom/lib/ReactReconciler.js");

var instantiateReactComponent = __webpack_require__("./node_modules/react-dom/lib/instantiateReactComponent.js");
var KeyEscapeUtils = __webpack_require__("./node_modules/react-dom/lib/KeyEscapeUtils.js");
var shouldUpdateReactComponent = __webpack_require__("./node_modules/react-dom/lib/shouldUpdateReactComponent.js");
var traverseAllChildren = __webpack_require__("./node_modules/react-dom/lib/traverseAllChildren.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__("./node_modules/react/lib/ReactComponentTreeHook.js");
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactComponentBrowserEnvironment.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__("./node_modules/react-dom/lib/DOMChildrenOperations.js");
var ReactDOMIDOperations = __webpack_require__("./node_modules/react-dom/lib/ReactDOMIDOperations.js");

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactComponentEnvironment.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactCompositeComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js"),
    _assign = __webpack_require__("./node_modules/object-assign/index.js");

var React = __webpack_require__("./node_modules/react/lib/React.js");
var ReactComponentEnvironment = __webpack_require__("./node_modules/react-dom/lib/ReactComponentEnvironment.js");
var ReactCurrentOwner = __webpack_require__("./node_modules/react/lib/ReactCurrentOwner.js");
var ReactErrorUtils = __webpack_require__("./node_modules/react-dom/lib/ReactErrorUtils.js");
var ReactInstanceMap = __webpack_require__("./node_modules/react-dom/lib/ReactInstanceMap.js");
var ReactInstrumentation = __webpack_require__("./node_modules/react-dom/lib/ReactInstrumentation.js");
var ReactNodeTypes = __webpack_require__("./node_modules/react-dom/lib/ReactNodeTypes.js");
var ReactReconciler = __webpack_require__("./node_modules/react-dom/lib/ReactReconciler.js");

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__("./node_modules/fbjs/lib/emptyObject.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var shallowEqual = __webpack_require__("./node_modules/fbjs/lib/shallowEqual.js");
var shouldUpdateReactComponent = __webpack_require__("./node_modules/react-dom/lib/shouldUpdateReactComponent.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactDOM.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");
var ReactDefaultInjection = __webpack_require__("./node_modules/react-dom/lib/ReactDefaultInjection.js");
var ReactMount = __webpack_require__("./node_modules/react-dom/lib/ReactMount.js");
var ReactReconciler = __webpack_require__("./node_modules/react-dom/lib/ReactReconciler.js");
var ReactUpdates = __webpack_require__("./node_modules/react-dom/lib/ReactUpdates.js");
var ReactVersion = __webpack_require__("./node_modules/react-dom/lib/ReactVersion.js");

var findDOMNode = __webpack_require__("./node_modules/react-dom/lib/findDOMNode.js");
var getHostComponentFromComposite = __webpack_require__("./node_modules/react-dom/lib/getHostComponentFromComposite.js");
var renderSubtreeIntoContainer = __webpack_require__("./node_modules/react-dom/lib/renderSubtreeIntoContainer.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactDOMComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js"),
    _assign = __webpack_require__("./node_modules/object-assign/index.js");

var AutoFocusUtils = __webpack_require__("./node_modules/react-dom/lib/AutoFocusUtils.js");
var CSSPropertyOperations = __webpack_require__("./node_modules/react-dom/lib/CSSPropertyOperations.js");
var DOMLazyTree = __webpack_require__("./node_modules/react-dom/lib/DOMLazyTree.js");
var DOMNamespaces = __webpack_require__("./node_modules/react-dom/lib/DOMNamespaces.js");
var DOMProperty = __webpack_require__("./node_modules/react-dom/lib/DOMProperty.js");
var DOMPropertyOperations = __webpack_require__("./node_modules/react-dom/lib/DOMPropertyOperations.js");
var EventPluginHub = __webpack_require__("./node_modules/react-dom/lib/EventPluginHub.js");
var EventPluginRegistry = __webpack_require__("./node_modules/react-dom/lib/EventPluginRegistry.js");
var ReactBrowserEventEmitter = __webpack_require__("./node_modules/react-dom/lib/ReactBrowserEventEmitter.js");
var ReactDOMComponentFlags = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentFlags.js");
var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");
var ReactDOMInput = __webpack_require__("./node_modules/react-dom/lib/ReactDOMInput.js");
var ReactDOMOption = __webpack_require__("./node_modules/react-dom/lib/ReactDOMOption.js");
var ReactDOMSelect = __webpack_require__("./node_modules/react-dom/lib/ReactDOMSelect.js");
var ReactDOMTextarea = __webpack_require__("./node_modules/react-dom/lib/ReactDOMTextarea.js");
var ReactInstrumentation = __webpack_require__("./node_modules/react-dom/lib/ReactInstrumentation.js");
var ReactMultiChild = __webpack_require__("./node_modules/react-dom/lib/ReactMultiChild.js");
var ReactServerRenderingTransaction = __webpack_require__("./node_modules/react-dom/lib/ReactServerRenderingTransaction.js");

var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");
var escapeTextContentForBrowser = __webpack_require__("./node_modules/react-dom/lib/escapeTextContentForBrowser.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var isEventSupported = __webpack_require__("./node_modules/react-dom/lib/isEventSupported.js");
var shallowEqual = __webpack_require__("./node_modules/fbjs/lib/shallowEqual.js");
var inputValueTracking = __webpack_require__("./node_modules/react-dom/lib/inputValueTracking.js");
var validateDOMNesting = __webpack_require__("./node_modules/react-dom/lib/validateDOMNesting.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);

        // We also check that we haven't missed a value update, such as a
        // Radio group shifting the checked value to another named radio input.
        inputValueTracking.updateValueIfChanged(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactDOMComponentFlags.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactDOMComponentTree.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var DOMProperty = __webpack_require__("./node_modules/react-dom/lib/DOMProperty.js");
var ReactDOMComponentFlags = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentFlags.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactDOMContainerInfo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var validateDOMNesting = __webpack_require__("./node_modules/react-dom/lib/validateDOMNesting.js");

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactDOMEmptyComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("./node_modules/object-assign/index.js");

var DOMLazyTree = __webpack_require__("./node_modules/react-dom/lib/DOMLazyTree.js");
var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactDOMFeatureFlags.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactDOMIDOperations.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__("./node_modules/react-dom/lib/DOMChildrenOperations.js");
var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactDOMInput.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js"),
    _assign = __webpack_require__("./node_modules/object-assign/index.js");

var DOMPropertyOperations = __webpack_require__("./node_modules/react-dom/lib/DOMPropertyOperations.js");
var LinkedValueUtils = __webpack_require__("./node_modules/react-dom/lib/LinkedValueUtils.js");
var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");
var ReactUpdates = __webpack_require__("./node_modules/react-dom/lib/ReactUpdates.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactDOMOption.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("./node_modules/object-assign/index.js");

var React = __webpack_require__("./node_modules/react/lib/React.js");
var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");
var ReactDOMSelect = __webpack_require__("./node_modules/react-dom/lib/ReactDOMSelect.js");

var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactDOMSelect.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("./node_modules/object-assign/index.js");

var LinkedValueUtils = __webpack_require__("./node_modules/react-dom/lib/LinkedValueUtils.js");
var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");
var ReactUpdates = __webpack_require__("./node_modules/react-dom/lib/ReactUpdates.js");

var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactDOMSelection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__("./node_modules/fbjs/lib/ExecutionEnvironment.js");

var getNodeForCharacterOffset = __webpack_require__("./node_modules/react-dom/lib/getNodeForCharacterOffset.js");
var getTextContentAccessor = __webpack_require__("./node_modules/react-dom/lib/getTextContentAccessor.js");

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactDOMTextComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js"),
    _assign = __webpack_require__("./node_modules/object-assign/index.js");

var DOMChildrenOperations = __webpack_require__("./node_modules/react-dom/lib/DOMChildrenOperations.js");
var DOMLazyTree = __webpack_require__("./node_modules/react-dom/lib/DOMLazyTree.js");
var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");

var escapeTextContentForBrowser = __webpack_require__("./node_modules/react-dom/lib/escapeTextContentForBrowser.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var validateDOMNesting = __webpack_require__("./node_modules/react-dom/lib/validateDOMNesting.js");

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactDOMTextarea.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js"),
    _assign = __webpack_require__("./node_modules/object-assign/index.js");

var LinkedValueUtils = __webpack_require__("./node_modules/react-dom/lib/LinkedValueUtils.js");
var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");
var ReactUpdates = __webpack_require__("./node_modules/react-dom/lib/ReactUpdates.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactDOMTreeTraversal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactDefaultBatchingStrategy.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("./node_modules/object-assign/index.js");

var ReactUpdates = __webpack_require__("./node_modules/react-dom/lib/ReactUpdates.js");
var Transaction = __webpack_require__("./node_modules/react-dom/lib/Transaction.js");

var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactDefaultInjection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__("./node_modules/react-dom/lib/ARIADOMPropertyConfig.js");
var BeforeInputEventPlugin = __webpack_require__("./node_modules/react-dom/lib/BeforeInputEventPlugin.js");
var ChangeEventPlugin = __webpack_require__("./node_modules/react-dom/lib/ChangeEventPlugin.js");
var DefaultEventPluginOrder = __webpack_require__("./node_modules/react-dom/lib/DefaultEventPluginOrder.js");
var EnterLeaveEventPlugin = __webpack_require__("./node_modules/react-dom/lib/EnterLeaveEventPlugin.js");
var HTMLDOMPropertyConfig = __webpack_require__("./node_modules/react-dom/lib/HTMLDOMPropertyConfig.js");
var ReactComponentBrowserEnvironment = __webpack_require__("./node_modules/react-dom/lib/ReactComponentBrowserEnvironment.js");
var ReactDOMComponent = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponent.js");
var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");
var ReactDOMEmptyComponent = __webpack_require__("./node_modules/react-dom/lib/ReactDOMEmptyComponent.js");
var ReactDOMTreeTraversal = __webpack_require__("./node_modules/react-dom/lib/ReactDOMTreeTraversal.js");
var ReactDOMTextComponent = __webpack_require__("./node_modules/react-dom/lib/ReactDOMTextComponent.js");
var ReactDefaultBatchingStrategy = __webpack_require__("./node_modules/react-dom/lib/ReactDefaultBatchingStrategy.js");
var ReactEventListener = __webpack_require__("./node_modules/react-dom/lib/ReactEventListener.js");
var ReactInjection = __webpack_require__("./node_modules/react-dom/lib/ReactInjection.js");
var ReactReconcileTransaction = __webpack_require__("./node_modules/react-dom/lib/ReactReconcileTransaction.js");
var SVGDOMPropertyConfig = __webpack_require__("./node_modules/react-dom/lib/SVGDOMPropertyConfig.js");
var SelectEventPlugin = __webpack_require__("./node_modules/react-dom/lib/SelectEventPlugin.js");
var SimpleEventPlugin = __webpack_require__("./node_modules/react-dom/lib/SimpleEventPlugin.js");

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactElementSymbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactEmptyComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactErrorUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = function () {
        func(a);
      };
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactEventEmitterMixin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__("./node_modules/react-dom/lib/EventPluginHub.js");

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactEventListener.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("./node_modules/object-assign/index.js");

var EventListener = __webpack_require__("./node_modules/fbjs/lib/EventListener.js");
var ExecutionEnvironment = __webpack_require__("./node_modules/fbjs/lib/ExecutionEnvironment.js");
var PooledClass = __webpack_require__("./node_modules/react-dom/lib/PooledClass.js");
var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");
var ReactUpdates = __webpack_require__("./node_modules/react-dom/lib/ReactUpdates.js");

var getEventTarget = __webpack_require__("./node_modules/react-dom/lib/getEventTarget.js");
var getUnboundedScrollPosition = __webpack_require__("./node_modules/fbjs/lib/getUnboundedScrollPosition.js");

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactFeatureFlags.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactHostComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactInjection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__("./node_modules/react-dom/lib/DOMProperty.js");
var EventPluginHub = __webpack_require__("./node_modules/react-dom/lib/EventPluginHub.js");
var EventPluginUtils = __webpack_require__("./node_modules/react-dom/lib/EventPluginUtils.js");
var ReactComponentEnvironment = __webpack_require__("./node_modules/react-dom/lib/ReactComponentEnvironment.js");
var ReactEmptyComponent = __webpack_require__("./node_modules/react-dom/lib/ReactEmptyComponent.js");
var ReactBrowserEventEmitter = __webpack_require__("./node_modules/react-dom/lib/ReactBrowserEventEmitter.js");
var ReactHostComponent = __webpack_require__("./node_modules/react-dom/lib/ReactHostComponent.js");
var ReactUpdates = __webpack_require__("./node_modules/react-dom/lib/ReactUpdates.js");

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactInputSelection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMSelection = __webpack_require__("./node_modules/react-dom/lib/ReactDOMSelection.js");

var containsNode = __webpack_require__("./node_modules/fbjs/lib/containsNode.js");
var focusNode = __webpack_require__("./node_modules/fbjs/lib/focusNode.js");
var getActiveElement = __webpack_require__("./node_modules/fbjs/lib/getActiveElement.js");

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactInstanceMap.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactInstrumentation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactMarkupChecksum.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var adler32 = __webpack_require__("./node_modules/react-dom/lib/adler32.js");

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactMount.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var DOMLazyTree = __webpack_require__("./node_modules/react-dom/lib/DOMLazyTree.js");
var DOMProperty = __webpack_require__("./node_modules/react-dom/lib/DOMProperty.js");
var React = __webpack_require__("./node_modules/react/lib/React.js");
var ReactBrowserEventEmitter = __webpack_require__("./node_modules/react-dom/lib/ReactBrowserEventEmitter.js");
var ReactCurrentOwner = __webpack_require__("./node_modules/react/lib/ReactCurrentOwner.js");
var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");
var ReactDOMContainerInfo = __webpack_require__("./node_modules/react-dom/lib/ReactDOMContainerInfo.js");
var ReactDOMFeatureFlags = __webpack_require__("./node_modules/react-dom/lib/ReactDOMFeatureFlags.js");
var ReactFeatureFlags = __webpack_require__("./node_modules/react-dom/lib/ReactFeatureFlags.js");
var ReactInstanceMap = __webpack_require__("./node_modules/react-dom/lib/ReactInstanceMap.js");
var ReactInstrumentation = __webpack_require__("./node_modules/react-dom/lib/ReactInstrumentation.js");
var ReactMarkupChecksum = __webpack_require__("./node_modules/react-dom/lib/ReactMarkupChecksum.js");
var ReactReconciler = __webpack_require__("./node_modules/react-dom/lib/ReactReconciler.js");
var ReactUpdateQueue = __webpack_require__("./node_modules/react-dom/lib/ReactUpdateQueue.js");
var ReactUpdates = __webpack_require__("./node_modules/react-dom/lib/ReactUpdates.js");

var emptyObject = __webpack_require__("./node_modules/fbjs/lib/emptyObject.js");
var instantiateReactComponent = __webpack_require__("./node_modules/react-dom/lib/instantiateReactComponent.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var setInnerHTML = __webpack_require__("./node_modules/react-dom/lib/setInnerHTML.js");
var shouldUpdateReactComponent = __webpack_require__("./node_modules/react-dom/lib/shouldUpdateReactComponent.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactMultiChild.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var ReactComponentEnvironment = __webpack_require__("./node_modules/react-dom/lib/ReactComponentEnvironment.js");
var ReactInstanceMap = __webpack_require__("./node_modules/react-dom/lib/ReactInstanceMap.js");
var ReactInstrumentation = __webpack_require__("./node_modules/react-dom/lib/ReactInstrumentation.js");

var ReactCurrentOwner = __webpack_require__("./node_modules/react/lib/ReactCurrentOwner.js");
var ReactReconciler = __webpack_require__("./node_modules/react-dom/lib/ReactReconciler.js");
var ReactChildReconciler = __webpack_require__("./node_modules/react-dom/lib/ReactChildReconciler.js");

var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");
var flattenChildren = __webpack_require__("./node_modules/react-dom/lib/flattenChildren.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactNodeTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var React = __webpack_require__("./node_modules/react/lib/React.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactOwner.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactPropTypesSecret.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactReconcileTransaction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("./node_modules/object-assign/index.js");

var CallbackQueue = __webpack_require__("./node_modules/react-dom/lib/CallbackQueue.js");
var PooledClass = __webpack_require__("./node_modules/react-dom/lib/PooledClass.js");
var ReactBrowserEventEmitter = __webpack_require__("./node_modules/react-dom/lib/ReactBrowserEventEmitter.js");
var ReactInputSelection = __webpack_require__("./node_modules/react-dom/lib/ReactInputSelection.js");
var ReactInstrumentation = __webpack_require__("./node_modules/react-dom/lib/ReactInstrumentation.js");
var Transaction = __webpack_require__("./node_modules/react-dom/lib/Transaction.js");
var ReactUpdateQueue = __webpack_require__("./node_modules/react-dom/lib/ReactUpdateQueue.js");

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactReconciler.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactRef = __webpack_require__("./node_modules/react-dom/lib/ReactRef.js");
var ReactInstrumentation = __webpack_require__("./node_modules/react-dom/lib/ReactInstrumentation.js");

var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactRef.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactOwner = __webpack_require__("./node_modules/react-dom/lib/ReactOwner.js");

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactServerRenderingTransaction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("./node_modules/object-assign/index.js");

var PooledClass = __webpack_require__("./node_modules/react-dom/lib/PooledClass.js");
var Transaction = __webpack_require__("./node_modules/react-dom/lib/Transaction.js");
var ReactInstrumentation = __webpack_require__("./node_modules/react-dom/lib/ReactInstrumentation.js");
var ReactServerUpdateQueue = __webpack_require__("./node_modules/react-dom/lib/ReactServerUpdateQueue.js");

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactServerUpdateQueue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__("./node_modules/react-dom/lib/ReactUpdateQueue.js");

var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactUpdateQueue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var ReactCurrentOwner = __webpack_require__("./node_modules/react/lib/ReactCurrentOwner.js");
var ReactInstanceMap = __webpack_require__("./node_modules/react-dom/lib/ReactInstanceMap.js");
var ReactInstrumentation = __webpack_require__("./node_modules/react-dom/lib/ReactInstrumentation.js");
var ReactUpdates = __webpack_require__("./node_modules/react-dom/lib/ReactUpdates.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactUpdates.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js"),
    _assign = __webpack_require__("./node_modules/object-assign/index.js");

var CallbackQueue = __webpack_require__("./node_modules/react-dom/lib/CallbackQueue.js");
var PooledClass = __webpack_require__("./node_modules/react-dom/lib/PooledClass.js");
var ReactFeatureFlags = __webpack_require__("./node_modules/react-dom/lib/ReactFeatureFlags.js");
var ReactReconciler = __webpack_require__("./node_modules/react-dom/lib/ReactReconciler.js");
var Transaction = __webpack_require__("./node_modules/react-dom/lib/Transaction.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),

/***/ "./node_modules/react-dom/lib/ReactVersion.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),

/***/ "./node_modules/react-dom/lib/SVGDOMPropertyConfig.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),

/***/ "./node_modules/react-dom/lib/SelectEventPlugin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__("./node_modules/react-dom/lib/EventPropagators.js");
var ExecutionEnvironment = __webpack_require__("./node_modules/fbjs/lib/ExecutionEnvironment.js");
var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");
var ReactInputSelection = __webpack_require__("./node_modules/react-dom/lib/ReactInputSelection.js");
var SyntheticEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticEvent.js");

var getActiveElement = __webpack_require__("./node_modules/fbjs/lib/getActiveElement.js");
var isTextInputElement = __webpack_require__("./node_modules/react-dom/lib/isTextInputElement.js");
var shallowEqual = __webpack_require__("./node_modules/fbjs/lib/shallowEqual.js");

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),

/***/ "./node_modules/react-dom/lib/SimpleEventPlugin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var EventListener = __webpack_require__("./node_modules/fbjs/lib/EventListener.js");
var EventPropagators = __webpack_require__("./node_modules/react-dom/lib/EventPropagators.js");
var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");
var SyntheticAnimationEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticAnimationEvent.js");
var SyntheticClipboardEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticClipboardEvent.js");
var SyntheticEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticEvent.js");
var SyntheticFocusEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticFocusEvent.js");
var SyntheticKeyboardEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticKeyboardEvent.js");
var SyntheticMouseEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticMouseEvent.js");
var SyntheticDragEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticDragEvent.js");
var SyntheticTouchEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticTouchEvent.js");
var SyntheticTransitionEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticTransitionEvent.js");
var SyntheticUIEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticUIEvent.js");
var SyntheticWheelEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticWheelEvent.js");

var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");
var getEventCharCode = __webpack_require__("./node_modules/react-dom/lib/getEventCharCode.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),

/***/ "./node_modules/react-dom/lib/SyntheticAnimationEvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticEvent.js");

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),

/***/ "./node_modules/react-dom/lib/SyntheticClipboardEvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticEvent.js");

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),

/***/ "./node_modules/react-dom/lib/SyntheticCompositionEvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticEvent.js");

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),

/***/ "./node_modules/react-dom/lib/SyntheticDragEvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticMouseEvent.js");

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),

/***/ "./node_modules/react-dom/lib/SyntheticEvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("./node_modules/object-assign/index.js");

var PooledClass = __webpack_require__("./node_modules/react-dom/lib/PooledClass.js");

var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),

/***/ "./node_modules/react-dom/lib/SyntheticFocusEvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticUIEvent.js");

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),

/***/ "./node_modules/react-dom/lib/SyntheticInputEvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticEvent.js");

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),

/***/ "./node_modules/react-dom/lib/SyntheticKeyboardEvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticUIEvent.js");

var getEventCharCode = __webpack_require__("./node_modules/react-dom/lib/getEventCharCode.js");
var getEventKey = __webpack_require__("./node_modules/react-dom/lib/getEventKey.js");
var getEventModifierState = __webpack_require__("./node_modules/react-dom/lib/getEventModifierState.js");

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),

/***/ "./node_modules/react-dom/lib/SyntheticMouseEvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticUIEvent.js");
var ViewportMetrics = __webpack_require__("./node_modules/react-dom/lib/ViewportMetrics.js");

var getEventModifierState = __webpack_require__("./node_modules/react-dom/lib/getEventModifierState.js");

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),

/***/ "./node_modules/react-dom/lib/SyntheticTouchEvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticUIEvent.js");

var getEventModifierState = __webpack_require__("./node_modules/react-dom/lib/getEventModifierState.js");

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),

/***/ "./node_modules/react-dom/lib/SyntheticTransitionEvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticEvent.js");

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),

/***/ "./node_modules/react-dom/lib/SyntheticUIEvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticEvent.js");

var getEventTarget = __webpack_require__("./node_modules/react-dom/lib/getEventTarget.js");

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),

/***/ "./node_modules/react-dom/lib/SyntheticWheelEvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__("./node_modules/react-dom/lib/SyntheticMouseEvent.js");

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),

/***/ "./node_modules/react-dom/lib/Transaction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),

/***/ "./node_modules/react-dom/lib/ViewportMetrics.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),

/***/ "./node_modules/react-dom/lib/accumulateInto.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),

/***/ "./node_modules/react-dom/lib/adler32.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),

/***/ "./node_modules/react-dom/lib/createMicrosoftUnsafeLocalFunction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),

/***/ "./node_modules/react-dom/lib/dangerousStyleValue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__("./node_modules/react-dom/lib/CSSProperty.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),

/***/ "./node_modules/react-dom/lib/escapeTextContentForBrowser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),

/***/ "./node_modules/react-dom/lib/findDOMNode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var ReactCurrentOwner = __webpack_require__("./node_modules/react/lib/ReactCurrentOwner.js");
var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");
var ReactInstanceMap = __webpack_require__("./node_modules/react-dom/lib/ReactInstanceMap.js");

var getHostComponentFromComposite = __webpack_require__("./node_modules/react-dom/lib/getHostComponentFromComposite.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),

/***/ "./node_modules/react-dom/lib/flattenChildren.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__("./node_modules/react-dom/lib/KeyEscapeUtils.js");
var traverseAllChildren = __webpack_require__("./node_modules/react-dom/lib/traverseAllChildren.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__("./node_modules/react/lib/ReactComponentTreeHook.js");
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/react-dom/lib/forEachAccumulated.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),

/***/ "./node_modules/react-dom/lib/getEventCharCode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),

/***/ "./node_modules/react-dom/lib/getEventKey.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var getEventCharCode = __webpack_require__("./node_modules/react-dom/lib/getEventCharCode.js");

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),

/***/ "./node_modules/react-dom/lib/getEventModifierState.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),

/***/ "./node_modules/react-dom/lib/getEventTarget.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),

/***/ "./node_modules/react-dom/lib/getHostComponentFromComposite.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactNodeTypes = __webpack_require__("./node_modules/react-dom/lib/ReactNodeTypes.js");

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),

/***/ "./node_modules/react-dom/lib/getIteratorFn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),

/***/ "./node_modules/react-dom/lib/getNodeForCharacterOffset.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),

/***/ "./node_modules/react-dom/lib/getTextContentAccessor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__("./node_modules/fbjs/lib/ExecutionEnvironment.js");

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),

/***/ "./node_modules/react-dom/lib/getVendorPrefixedEventName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__("./node_modules/fbjs/lib/ExecutionEnvironment.js");

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),

/***/ "./node_modules/react-dom/lib/inputValueTracking.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__("./node_modules/react-dom/lib/ReactDOMComponentTree.js");

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  inst._wrapperState.valueTracker = null;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),

/***/ "./node_modules/react-dom/lib/instantiateReactComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js"),
    _assign = __webpack_require__("./node_modules/object-assign/index.js");

var ReactCompositeComponent = __webpack_require__("./node_modules/react-dom/lib/ReactCompositeComponent.js");
var ReactEmptyComponent = __webpack_require__("./node_modules/react-dom/lib/ReactEmptyComponent.js");
var ReactHostComponent = __webpack_require__("./node_modules/react-dom/lib/ReactHostComponent.js");

var getNextDebugID = __webpack_require__("./node_modules/react/lib/getNextDebugID.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),

/***/ "./node_modules/react-dom/lib/isEventSupported.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__("./node_modules/fbjs/lib/ExecutionEnvironment.js");

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),

/***/ "./node_modules/react-dom/lib/isTextInputElement.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),

/***/ "./node_modules/react-dom/lib/quoteAttributeValueForBrowser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var escapeTextContentForBrowser = __webpack_require__("./node_modules/react-dom/lib/escapeTextContentForBrowser.js");

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),

/***/ "./node_modules/react-dom/lib/reactProdInvariant.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),

/***/ "./node_modules/react-dom/lib/renderSubtreeIntoContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactMount = __webpack_require__("./node_modules/react-dom/lib/ReactMount.js");

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),

/***/ "./node_modules/react-dom/lib/setInnerHTML.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__("./node_modules/fbjs/lib/ExecutionEnvironment.js");
var DOMNamespaces = __webpack_require__("./node_modules/react-dom/lib/DOMNamespaces.js");

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__("./node_modules/react-dom/lib/createMicrosoftUnsafeLocalFunction.js");

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),

/***/ "./node_modules/react-dom/lib/setTextContent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__("./node_modules/fbjs/lib/ExecutionEnvironment.js");
var escapeTextContentForBrowser = __webpack_require__("./node_modules/react-dom/lib/escapeTextContentForBrowser.js");
var setInnerHTML = __webpack_require__("./node_modules/react-dom/lib/setInnerHTML.js");

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),

/***/ "./node_modules/react-dom/lib/shouldUpdateReactComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),

/***/ "./node_modules/react-dom/lib/traverseAllChildren.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react-dom/lib/reactProdInvariant.js");

var ReactCurrentOwner = __webpack_require__("./node_modules/react/lib/ReactCurrentOwner.js");
var REACT_ELEMENT_TYPE = __webpack_require__("./node_modules/react-dom/lib/ReactElementSymbol.js");

var getIteratorFn = __webpack_require__("./node_modules/react-dom/lib/getIteratorFn.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var KeyEscapeUtils = __webpack_require__("./node_modules/react-dom/lib/KeyEscapeUtils.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),

/***/ "./node_modules/react-dom/lib/validateDOMNesting.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("./node_modules/object-assign/index.js");

var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),

/***/ "./node_modules/react-hot-loader/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/react-hot-loader/lib/index.js")


/***/ }),

/***/ "./node_modules/react-hot-loader/lib/AppContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__("./node_modules/react-hot-loader/lib/AppContainer.prod.js");
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),

/***/ "./node_modules/react-hot-loader/lib/AppContainer.prod.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__("./node_modules/react/react.js");

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),

/***/ "./node_modules/react-hot-loader/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__("./node_modules/react-hot-loader/lib/index.prod.js");
} else {
  module.exports = require('./index.dev');
}

/***/ }),

/***/ "./node_modules/react-hot-loader/lib/index.prod.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__("./node_modules/react-hot-loader/lib/AppContainer.js");

/***/ }),

/***/ "./node_modules/react-is/cjs/react-is.production.min.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),

/***/ "./node_modules/react-is/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__("./node_modules/react-is/cjs/react-is.production.min.js");
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),

/***/ "./node_modules/react-router-dom/es/BrowserRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("./node_modules/warning/warning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__("./node_modules/history/esm/history.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__("./node_modules/react-router-dom/es/Router.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["createBrowserHistory"])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),

/***/ "./node_modules/react-router-dom/es/HashRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("./node_modules/warning/warning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__("./node_modules/history/esm/history.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__("./node_modules/react-router-dom/es/Router.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["createHashHistory"])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),

/***/ "./node_modules/react-router-dom/es/Link.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__("./node_modules/history/esm/history.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["createLocation"])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),

/***/ "./node_modules/react-router-dom/es/MemoryRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__("./node_modules/react-router/es/MemoryRouter.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/es/NavLink.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__("./node_modules/react-router-dom/es/Route.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__("./node_modules/react-router-dom/es/Link.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),

/***/ "./node_modules/react-router-dom/es/Prompt.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__("./node_modules/react-router/es/Prompt.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/es/Redirect.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__("./node_modules/react-router/es/Redirect.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/es/Route.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__("./node_modules/react-router/es/Route.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/es/Router.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__("./node_modules/react-router/es/Router.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/es/StaticRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__("./node_modules/react-router/es/StaticRouter.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/es/Switch.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__("./node_modules/react-router/es/Switch.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/es/generatePath.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__("./node_modules/react-router/es/generatePath.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__("./node_modules/react-router-dom/es/BrowserRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__("./node_modules/react-router-dom/es/HashRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__("./node_modules/react-router-dom/es/Link.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__("./node_modules/react-router-dom/es/MemoryRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__("./node_modules/react-router-dom/es/NavLink.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__("./node_modules/react-router-dom/es/Prompt.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__("./node_modules/react-router-dom/es/Redirect.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__("./node_modules/react-router-dom/es/Route.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__("./node_modules/react-router-dom/es/Router.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__("./node_modules/react-router-dom/es/StaticRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__("./node_modules/react-router-dom/es/Switch.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__("./node_modules/react-router-dom/es/generatePath.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_11__generatePath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__("./node_modules/react-router-dom/es/matchPath.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_12__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__("./node_modules/react-router-dom/es/withRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),

/***/ "./node_modules/react-router-dom/es/matchPath.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__("./node_modules/react-router/es/matchPath.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router-dom/es/withRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__("./node_modules/react-router/es/withRouter.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),

/***/ "./node_modules/react-router/es/MemoryRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("./node_modules/warning/warning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__("./node_modules/history/esm/history.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__("./node_modules/react-router/es/Router.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["createMemoryHistory"])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),

/***/ "./node_modules/react-router/es/Prompt.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),

/***/ "./node_modules/react-router/es/Redirect.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__("./node_modules/warning/warning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__("./node_modules/history/esm/history.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__("./node_modules/react-router/es/generatePath.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["createLocation"])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["createLocation"])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["locationsAreEqual"])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),

/***/ "./node_modules/react-router/es/Route.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("./node_modules/warning/warning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__("./node_modules/react-router/es/matchPath.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),

/***/ "./node_modules/react-router/es/Router.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("./node_modules/warning/warning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),

/***/ "./node_modules/react-router/es/StaticRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("./node_modules/warning/warning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__("./node_modules/history/esm/history.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__("./node_modules/react-router/es/Router.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["createLocation"])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["createLocation"])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["createLocation"])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),

/***/ "./node_modules/react-router/es/Switch.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__("./node_modules/warning/warning.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__("./node_modules/react-router/es/matchPath.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),

/***/ "./node_modules/react-router/es/generatePath.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__("./node_modules/path-to-regexp/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),

/***/ "./node_modules/react-router/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__("./node_modules/react-router/es/MemoryRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__("./node_modules/react-router/es/Prompt.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_1__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__("./node_modules/react-router/es/Redirect.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__("./node_modules/react-router/es/Route.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__("./node_modules/react-router/es/Router.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__("./node_modules/react-router/es/StaticRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_5__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__("./node_modules/react-router/es/Switch.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__("./node_modules/react-router/es/generatePath.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_7__generatePath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__("./node_modules/react-router/es/matchPath.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_8__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__("./node_modules/react-router/es/withRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__withRouter__["a"]; });





















/***/ }),

/***/ "./node_modules/react-router/es/matchPath.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__("./node_modules/path-to-regexp/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),

/***/ "./node_modules/react-router/es/withRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__("./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__("./node_modules/react-router/es/Route.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),

/***/ "./node_modules/react-transition-group/CSSTransitionGroup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__("./node_modules/react-transition-group/TransitionGroup.js");

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__("./node_modules/react-transition-group/CSSTransitionGroupChild.js");

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__("./node_modules/react-transition-group/utils/PropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/CSSTransitionGroupChild.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__("./node_modules/dom-helpers/class/addClass.js");

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__("./node_modules/dom-helpers/class/removeClass.js");

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__("./node_modules/dom-helpers/util/requestAnimationFrame.js");

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__("./node_modules/dom-helpers/transition/properties.js");

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _PropTypes = __webpack_require__("./node_modules/react-transition-group/utils/PropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/TransitionGroup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__("./node_modules/chain-function/index.js");

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__("./node_modules/warning/warning.js");

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__("./node_modules/react-transition-group/utils/ChildMapping.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransitionGroup = __webpack_require__("./node_modules/react-transition-group/CSSTransitionGroup.js");

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _TransitionGroup = __webpack_require__("./node_modules/react-transition-group/TransitionGroup.js");

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  TransitionGroup: _TransitionGroup2.default,
  CSSTransitionGroup: _CSSTransitionGroup2.default
};

/***/ }),

/***/ "./node_modules/react-transition-group/utils/ChildMapping.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__("./node_modules/react/react.js");

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),

/***/ "./node_modules/react-transition-group/utils/PropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),

/***/ "./node_modules/react/lib/KeyEscapeUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),

/***/ "./node_modules/react/lib/PooledClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__("./node_modules/react/lib/reactProdInvariant.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),

/***/ "./node_modules/react/lib/React.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("./node_modules/object-assign/index.js");

var ReactBaseClasses = __webpack_require__("./node_modules/react/lib/ReactBaseClasses.js");
var ReactChildren = __webpack_require__("./node_modules/react/lib/ReactChildren.js");
var ReactDOMFactories = __webpack_require__("./node_modules/react/lib/ReactDOMFactories.js");
var ReactElement = __webpack_require__("./node_modules/react/lib/ReactElement.js");
var ReactPropTypes = __webpack_require__("./node_modules/react/lib/ReactPropTypes.js");
var ReactVersion = __webpack_require__("./node_modules/react/lib/ReactVersion.js");

var createReactClass = __webpack_require__("./node_modules/react/lib/createClass.js");
var onlyChild = __webpack_require__("./node_modules/react/lib/onlyChild.js");

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),

/***/ "./node_modules/react/lib/ReactBaseClasses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react/lib/reactProdInvariant.js"),
    _assign = __webpack_require__("./node_modules/object-assign/index.js");

var ReactNoopUpdateQueue = __webpack_require__("./node_modules/react/lib/ReactNoopUpdateQueue.js");

var canDefineProperty = __webpack_require__("./node_modules/react/lib/canDefineProperty.js");
var emptyObject = __webpack_require__("./node_modules/fbjs/lib/emptyObject.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var lowPriorityWarning = __webpack_require__("./node_modules/react/lib/lowPriorityWarning.js");

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),

/***/ "./node_modules/react/lib/ReactChildren.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__("./node_modules/react/lib/PooledClass.js");
var ReactElement = __webpack_require__("./node_modules/react/lib/ReactElement.js");

var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");
var traverseAllChildren = __webpack_require__("./node_modules/react/lib/traverseAllChildren.js");

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),

/***/ "./node_modules/react/lib/ReactComponentTreeHook.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__("./node_modules/react/lib/reactProdInvariant.js");

var ReactCurrentOwner = __webpack_require__("./node_modules/react/lib/ReactCurrentOwner.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),

/***/ "./node_modules/react/lib/ReactCurrentOwner.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),

/***/ "./node_modules/react/lib/ReactDOMFactories.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__("./node_modules/react/lib/ReactElement.js");

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),

/***/ "./node_modules/react/lib/ReactElement.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("./node_modules/object-assign/index.js");

var ReactCurrentOwner = __webpack_require__("./node_modules/react/lib/ReactCurrentOwner.js");

var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");
var canDefineProperty = __webpack_require__("./node_modules/react/lib/canDefineProperty.js");
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__("./node_modules/react/lib/ReactElementSymbol.js");

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),

/***/ "./node_modules/react/lib/ReactElementSymbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),

/***/ "./node_modules/react/lib/ReactNoopUpdateQueue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),

/***/ "./node_modules/react/lib/ReactPropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__("./node_modules/react/lib/ReactElement.js"),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__("./node_modules/prop-types/factory.js");

module.exports = factory(isValidElement);

/***/ }),

/***/ "./node_modules/react/lib/ReactVersion.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),

/***/ "./node_modules/react/lib/canDefineProperty.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),

/***/ "./node_modules/react/lib/createClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__("./node_modules/react/lib/ReactBaseClasses.js"),
    Component = _require.Component;

var _require2 = __webpack_require__("./node_modules/react/lib/ReactElement.js"),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__("./node_modules/react/lib/ReactNoopUpdateQueue.js");
var factory = __webpack_require__("./node_modules/create-react-class/factory.js");

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),

/***/ "./node_modules/react/lib/getIteratorFn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),

/***/ "./node_modules/react/lib/getNextDebugID.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),

/***/ "./node_modules/react/lib/lowPriorityWarning.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),

/***/ "./node_modules/react/lib/onlyChild.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__("./node_modules/react/lib/reactProdInvariant.js");

var ReactElement = __webpack_require__("./node_modules/react/lib/ReactElement.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),

/***/ "./node_modules/react/lib/reactProdInvariant.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),

/***/ "./node_modules/react/lib/traverseAllChildren.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/react/lib/reactProdInvariant.js");

var ReactCurrentOwner = __webpack_require__("./node_modules/react/lib/ReactCurrentOwner.js");
var REACT_ELEMENT_TYPE = __webpack_require__("./node_modules/react/lib/ReactElementSymbol.js");

var getIteratorFn = __webpack_require__("./node_modules/react/lib/getIteratorFn.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var KeyEscapeUtils = __webpack_require__("./node_modules/react/lib/KeyEscapeUtils.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),

/***/ "./node_modules/react/react.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__("./node_modules/react/lib/React.js");


/***/ }),

/***/ "./node_modules/resolve-pathname/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),

/***/ "./node_modules/rubberduck/lib/rubberduck.js":
/***/ (function(module, exports, __webpack_require__) {

var events = __webpack_require__("./node_modules/events/events.js");
var utils = __webpack_require__("./node_modules/rubberduck/lib/utils.js");
var wrap = exports.wrap = {
  /**
   * Wrap an anonymous or named function to notify an Emitter and
   * return the wrapper function.
   * @param {events.EventEmitter} emitter The emitter to notify
   * @param {Function} fn The function to wrap
   * @param {String} name The optional name
   */
  fn: function(emitter, fn, strict, name, scope) {
    var wrapped = function() {
      var result;
      utils.emitEvents(emitter, 'before', name, [arguments, this, name]);

      try {
        result = fn.apply(scope || this, arguments);
      } catch (e) {
        utils.emitEvents(emitter, 'error', name, [ e, arguments, this, name ]);
        throw e;
      }

      utils.emitEvents(emitter, 'after', name, [ result, arguments, this, name ]);
      return result;
    };

    if (strict) {
      eval('wrapped = ' + utils.addArgs(wrapped.toString(), fn.length));
    }

    return wrapped;
  },
  /**
   * Wrap an anonymous or named function that calls a callback asynchronously
   * to notify an Emitter and return the wrapper function.
   * @param {events.EventEmitter} emitter The emitter to notify
   * @param {Function} fn The function to wrap
   * @param {Integer} position The position of the callback in the arguments
   * array (defaults to 0). Set to -1 if the callback is the last argument.
   * @param {String} name The optional name
   */
  async: function(emitter, fn, position, strict, name, scope) {
    var wrapped = function() {
      var pos = position == -1 ? arguments.length - 1 : (position || 0);
      var callback = arguments[pos];
      var context = this;
      var methodArgs = arguments;
      var callbackWrapper = function() {
        try {
          callback.apply(context, arguments);
        } catch (e) {
          utils.emitEvents(emitter, 'error', name, [ e, methodArgs, context, name ]);
          throw e;
        }
        var eventType = arguments[0] instanceof Error ? 'error' : 'after';
        utils.emitEvents(emitter, eventType, name, [ arguments, methodArgs, context, name ]);
      };

      utils.emitEvents(emitter, 'before', name, [ methodArgs, this, name ]);
      methodArgs[pos] = callbackWrapper;

      try {
        return fn.apply(scope || this, methodArgs);
      } catch (e) {
        utils.emitEvents(emitter, 'error', name, [ e, methodArgs, context, name ]);
        throw e;
      }
    };

    if (strict) {
      eval('wrapped = ' + utils.addArgs(wrapped.toString(), fn.length));
    }

    return wrapped;
  }
};

var Emitter = exports.Emitter = function(obj) {
  this.obj = obj;
};

Emitter.prototype = Object.create(events.EventEmitter.prototype);

/**
 * Punch a method with the given name, with
 * @param {String | Array} method The name of the method or a list of
 * method names.
 * @param {Integer} position The optional position of the asynchronous callback
 * in the arguments list.
 */
Emitter.prototype.punch = function(method, position, strict) {
  if (Array.isArray(method)) {
    var self = this;
    method.forEach(function(method) {
      self.punch(method, position, strict);
    });
  } else {
    var old = this.obj[method];
    if (typeof old == 'function') {
      this.obj[method] = (!position && position !== 0) ?
        wrap.fn(this, old, strict, method) :
        wrap.async(this, old, position, strict, method);
    }
  }
  return this;
};

exports.emitter = function(obj) {
  return new Emitter(obj);
};


/***/ }),

/***/ "./node_modules/rubberduck/lib/utils.js":
/***/ (function(module, exports) {

exports.toBase26 = function(num) {
  var outString = '';
  var letters = 'abcdefghijklmnopqrstuvwxyz';
  while (num > 25) {
    var remainder = num % 26;
    outString = letters.charAt(remainder) + outString;
    num = Math.floor(num / 26) - 1;
  }
  outString = letters.charAt(num) + outString;
  return outString;
};

exports.makeFakeArgs = function(len) {
  var argArr = [];
  for (var i = 0; i < len; i++) {
    argArr.push(exports.toBase26(i));
  }
  return argArr.join(",");
};

exports.addArgs = function(fnString, argLen) {
  return fnString.replace(/function\s*\(\)/, 'function(' + exports.makeFakeArgs(argLen) + ')');
};

exports.emitEvents = function(emitter, type, name, args) {
  var ucName = name ? name.replace(/^\w/, function(first) {
    return first.toUpperCase();
  }) : null;

  emitter.emit.apply(emitter, [type].concat(args));
  if (ucName) {
    emitter.emit.apply(emitter, [type + ucName].concat(args));
  }
};


/***/ }),

/***/ "./node_modules/socket.io-client/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var url = __webpack_require__("./node_modules/socket.io-client/lib/url.js");
var parser = __webpack_require__("./node_modules/socket.io-parser/index.js");
var Manager = __webpack_require__("./node_modules/socket.io-client/lib/manager.js");
var debug = __webpack_require__("./node_modules/debug/src/browser.js")('socket.io-client');

/**
 * Module exports.
 */

module.exports = exports = lookup;

/**
 * Managers cache.
 */

var cache = exports.managers = {};

/**
 * Looks up an existing `Manager` for multiplexing.
 * If the user summons:
 *
 *   `io('http://localhost/a');`
 *   `io('http://localhost/b');`
 *
 * We reuse the existing instance based on same scheme/port/host,
 * and we initialize sockets for each namespace.
 *
 * @api public
 */

function lookup (uri, opts) {
  if (typeof uri === 'object') {
    opts = uri;
    uri = undefined;
  }

  opts = opts || {};

  var parsed = url(uri);
  var source = parsed.source;
  var id = parsed.id;
  var path = parsed.path;
  var sameNamespace = cache[id] && path in cache[id].nsps;
  var newConnection = opts.forceNew || opts['force new connection'] ||
                      false === opts.multiplex || sameNamespace;

  var io;

  if (newConnection) {
    debug('ignoring socket cache for %s', source);
    io = Manager(source, opts);
  } else {
    if (!cache[id]) {
      debug('new io instance for %s', source);
      cache[id] = Manager(source, opts);
    }
    io = cache[id];
  }
  if (parsed.query && !opts.query) {
    opts.query = parsed.query;
  }
  return io.socket(parsed.path, opts);
}

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = parser.protocol;

/**
 * `connect`.
 *
 * @param {String} uri
 * @api public
 */

exports.connect = lookup;

/**
 * Expose constructors for standalone build.
 *
 * @api public
 */

exports.Manager = __webpack_require__("./node_modules/socket.io-client/lib/manager.js");
exports.Socket = __webpack_require__("./node_modules/socket.io-client/lib/socket.js");


/***/ }),

/***/ "./node_modules/socket.io-client/lib/manager.js":
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var eio = __webpack_require__("./node_modules/engine.io-client/lib/index.js");
var Socket = __webpack_require__("./node_modules/socket.io-client/lib/socket.js");
var Emitter = __webpack_require__("./node_modules/component-emitter/index.js");
var parser = __webpack_require__("./node_modules/socket.io-parser/index.js");
var on = __webpack_require__("./node_modules/socket.io-client/lib/on.js");
var bind = __webpack_require__("./node_modules/component-bind/index.js");
var debug = __webpack_require__("./node_modules/debug/src/browser.js")('socket.io-client:manager');
var indexOf = __webpack_require__("./node_modules/indexof/index.js");
var Backoff = __webpack_require__("./node_modules/backo2/index.js");

/**
 * IE6+ hasOwnProperty
 */

var has = Object.prototype.hasOwnProperty;

/**
 * Module exports
 */

module.exports = Manager;

/**
 * `Manager` constructor.
 *
 * @param {String} engine instance or engine uri/opts
 * @param {Object} options
 * @api public
 */

function Manager (uri, opts) {
  if (!(this instanceof Manager)) return new Manager(uri, opts);
  if (uri && ('object' === typeof uri)) {
    opts = uri;
    uri = undefined;
  }
  opts = opts || {};

  opts.path = opts.path || '/socket.io';
  this.nsps = {};
  this.subs = [];
  this.opts = opts;
  this.reconnection(opts.reconnection !== false);
  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
  this.reconnectionDelay(opts.reconnectionDelay || 1000);
  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
  this.randomizationFactor(opts.randomizationFactor || 0.5);
  this.backoff = new Backoff({
    min: this.reconnectionDelay(),
    max: this.reconnectionDelayMax(),
    jitter: this.randomizationFactor()
  });
  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
  this.readyState = 'closed';
  this.uri = uri;
  this.connecting = [];
  this.lastPing = null;
  this.encoding = false;
  this.packetBuffer = [];
  var _parser = opts.parser || parser;
  this.encoder = new _parser.Encoder();
  this.decoder = new _parser.Decoder();
  this.autoConnect = opts.autoConnect !== false;
  if (this.autoConnect) this.open();
}

/**
 * Propagate given event to sockets and emit on `this`
 *
 * @api private
 */

Manager.prototype.emitAll = function () {
  this.emit.apply(this, arguments);
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
    }
  }
};

/**
 * Update `socket.id` of all sockets
 *
 * @api private
 */

Manager.prototype.updateSocketIds = function () {
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].id = this.generateId(nsp);
    }
  }
};

/**
 * generate `socket.id` for the given `nsp`
 *
 * @param {String} nsp
 * @return {String}
 * @api private
 */

Manager.prototype.generateId = function (nsp) {
  return (nsp === '/' ? '' : (nsp + '#')) + this.engine.id;
};

/**
 * Mix in `Emitter`.
 */

Emitter(Manager.prototype);

/**
 * Sets the `reconnection` config.
 *
 * @param {Boolean} true/false if it should automatically reconnect
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnection = function (v) {
  if (!arguments.length) return this._reconnection;
  this._reconnection = !!v;
  return this;
};

/**
 * Sets the reconnection attempts config.
 *
 * @param {Number} max reconnection attempts before giving up
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionAttempts = function (v) {
  if (!arguments.length) return this._reconnectionAttempts;
  this._reconnectionAttempts = v;
  return this;
};

/**
 * Sets the delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelay = function (v) {
  if (!arguments.length) return this._reconnectionDelay;
  this._reconnectionDelay = v;
  this.backoff && this.backoff.setMin(v);
  return this;
};

Manager.prototype.randomizationFactor = function (v) {
  if (!arguments.length) return this._randomizationFactor;
  this._randomizationFactor = v;
  this.backoff && this.backoff.setJitter(v);
  return this;
};

/**
 * Sets the maximum delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelayMax = function (v) {
  if (!arguments.length) return this._reconnectionDelayMax;
  this._reconnectionDelayMax = v;
  this.backoff && this.backoff.setMax(v);
  return this;
};

/**
 * Sets the connection timeout. `false` to disable
 *
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.timeout = function (v) {
  if (!arguments.length) return this._timeout;
  this._timeout = v;
  return this;
};

/**
 * Starts trying to reconnect if reconnection is enabled and we have not
 * started reconnecting yet
 *
 * @api private
 */

Manager.prototype.maybeReconnectOnOpen = function () {
  // Only try to reconnect if it's the first time we're connecting
  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
    // keeps reconnection from firing twice for the same reconnection loop
    this.reconnect();
  }
};

/**
 * Sets the current transport `socket`.
 *
 * @param {Function} optional, callback
 * @return {Manager} self
 * @api public
 */

Manager.prototype.open =
Manager.prototype.connect = function (fn, opts) {
  debug('readyState %s', this.readyState);
  if (~this.readyState.indexOf('open')) return this;

  debug('opening %s', this.uri);
  this.engine = eio(this.uri, this.opts);
  var socket = this.engine;
  var self = this;
  this.readyState = 'opening';
  this.skipReconnect = false;

  // emit `open`
  var openSub = on(socket, 'open', function () {
    self.onopen();
    fn && fn();
  });

  // emit `connect_error`
  var errorSub = on(socket, 'error', function (data) {
    debug('connect_error');
    self.cleanup();
    self.readyState = 'closed';
    self.emitAll('connect_error', data);
    if (fn) {
      var err = new Error('Connection error');
      err.data = data;
      fn(err);
    } else {
      // Only do this if there is no fn to handle the error
      self.maybeReconnectOnOpen();
    }
  });

  // emit `connect_timeout`
  if (false !== this._timeout) {
    var timeout = this._timeout;
    debug('connect attempt will timeout after %d', timeout);

    // set timer
    var timer = setTimeout(function () {
      debug('connect attempt timed out after %d', timeout);
      openSub.destroy();
      socket.close();
      socket.emit('error', 'timeout');
      self.emitAll('connect_timeout', timeout);
    }, timeout);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }

  this.subs.push(openSub);
  this.subs.push(errorSub);

  return this;
};

/**
 * Called upon transport open.
 *
 * @api private
 */

Manager.prototype.onopen = function () {
  debug('open');

  // clear old subs
  this.cleanup();

  // mark as open
  this.readyState = 'open';
  this.emit('open');

  // add new subs
  var socket = this.engine;
  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
};

/**
 * Called upon a ping.
 *
 * @api private
 */

Manager.prototype.onping = function () {
  this.lastPing = new Date();
  this.emitAll('ping');
};

/**
 * Called upon a packet.
 *
 * @api private
 */

Manager.prototype.onpong = function () {
  this.emitAll('pong', new Date() - this.lastPing);
};

/**
 * Called with data.
 *
 * @api private
 */

Manager.prototype.ondata = function (data) {
  this.decoder.add(data);
};

/**
 * Called when parser fully decodes a packet.
 *
 * @api private
 */

Manager.prototype.ondecoded = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon socket error.
 *
 * @api private
 */

Manager.prototype.onerror = function (err) {
  debug('error', err);
  this.emitAll('error', err);
};

/**
 * Creates a new socket for the given `nsp`.
 *
 * @return {Socket}
 * @api public
 */

Manager.prototype.socket = function (nsp, opts) {
  var socket = this.nsps[nsp];
  if (!socket) {
    socket = new Socket(this, nsp, opts);
    this.nsps[nsp] = socket;
    var self = this;
    socket.on('connecting', onConnecting);
    socket.on('connect', function () {
      socket.id = self.generateId(nsp);
    });

    if (this.autoConnect) {
      // manually call here since connecting event is fired before listening
      onConnecting();
    }
  }

  function onConnecting () {
    if (!~indexOf(self.connecting, socket)) {
      self.connecting.push(socket);
    }
  }

  return socket;
};

/**
 * Called upon a socket close.
 *
 * @param {Socket} socket
 */

Manager.prototype.destroy = function (socket) {
  var index = indexOf(this.connecting, socket);
  if (~index) this.connecting.splice(index, 1);
  if (this.connecting.length) return;

  this.close();
};

/**
 * Writes a packet.
 *
 * @param {Object} packet
 * @api private
 */

Manager.prototype.packet = function (packet) {
  debug('writing packet %j', packet);
  var self = this;
  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;

  if (!self.encoding) {
    // encode, then write to engine with result
    self.encoding = true;
    this.encoder.encode(packet, function (encodedPackets) {
      for (var i = 0; i < encodedPackets.length; i++) {
        self.engine.write(encodedPackets[i], packet.options);
      }
      self.encoding = false;
      self.processPacketQueue();
    });
  } else { // add packet to the queue
    self.packetBuffer.push(packet);
  }
};

/**
 * If packet buffer is non-empty, begins encoding the
 * next packet in line.
 *
 * @api private
 */

Manager.prototype.processPacketQueue = function () {
  if (this.packetBuffer.length > 0 && !this.encoding) {
    var pack = this.packetBuffer.shift();
    this.packet(pack);
  }
};

/**
 * Clean up transport subscriptions and packet buffer.
 *
 * @api private
 */

Manager.prototype.cleanup = function () {
  debug('cleanup');

  var subsLength = this.subs.length;
  for (var i = 0; i < subsLength; i++) {
    var sub = this.subs.shift();
    sub.destroy();
  }

  this.packetBuffer = [];
  this.encoding = false;
  this.lastPing = null;

  this.decoder.destroy();
};

/**
 * Close the current socket.
 *
 * @api private
 */

Manager.prototype.close =
Manager.prototype.disconnect = function () {
  debug('disconnect');
  this.skipReconnect = true;
  this.reconnecting = false;
  if ('opening' === this.readyState) {
    // `onclose` will not fire because
    // an open event never happened
    this.cleanup();
  }
  this.backoff.reset();
  this.readyState = 'closed';
  if (this.engine) this.engine.close();
};

/**
 * Called upon engine close.
 *
 * @api private
 */

Manager.prototype.onclose = function (reason) {
  debug('onclose');

  this.cleanup();
  this.backoff.reset();
  this.readyState = 'closed';
  this.emit('close', reason);

  if (this._reconnection && !this.skipReconnect) {
    this.reconnect();
  }
};

/**
 * Attempt a reconnection.
 *
 * @api private
 */

Manager.prototype.reconnect = function () {
  if (this.reconnecting || this.skipReconnect) return this;

  var self = this;

  if (this.backoff.attempts >= this._reconnectionAttempts) {
    debug('reconnect failed');
    this.backoff.reset();
    this.emitAll('reconnect_failed');
    this.reconnecting = false;
  } else {
    var delay = this.backoff.duration();
    debug('will wait %dms before reconnect attempt', delay);

    this.reconnecting = true;
    var timer = setTimeout(function () {
      if (self.skipReconnect) return;

      debug('attempting reconnect');
      self.emitAll('reconnect_attempt', self.backoff.attempts);
      self.emitAll('reconnecting', self.backoff.attempts);

      // check again for the case socket closed in above events
      if (self.skipReconnect) return;

      self.open(function (err) {
        if (err) {
          debug('reconnect attempt error');
          self.reconnecting = false;
          self.reconnect();
          self.emitAll('reconnect_error', err.data);
        } else {
          debug('reconnect success');
          self.onreconnect();
        }
      });
    }, delay);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }
};

/**
 * Called upon successful reconnect.
 *
 * @api private
 */

Manager.prototype.onreconnect = function () {
  var attempt = this.backoff.attempts;
  this.reconnecting = false;
  this.backoff.reset();
  this.updateSocketIds();
  this.emitAll('reconnect', attempt);
};


/***/ }),

/***/ "./node_modules/socket.io-client/lib/on.js":
/***/ (function(module, exports) {


/**
 * Module exports.
 */

module.exports = on;

/**
 * Helper for subscriptions.
 *
 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
 * @param {String} event name
 * @param {Function} callback
 * @api public
 */

function on (obj, ev, fn) {
  obj.on(ev, fn);
  return {
    destroy: function () {
      obj.removeListener(ev, fn);
    }
  };
}


/***/ }),

/***/ "./node_modules/socket.io-client/lib/socket.js":
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var parser = __webpack_require__("./node_modules/socket.io-parser/index.js");
var Emitter = __webpack_require__("./node_modules/component-emitter/index.js");
var toArray = __webpack_require__("./node_modules/to-array/index.js");
var on = __webpack_require__("./node_modules/socket.io-client/lib/on.js");
var bind = __webpack_require__("./node_modules/component-bind/index.js");
var debug = __webpack_require__("./node_modules/debug/src/browser.js")('socket.io-client:socket');
var parseqs = __webpack_require__("./node_modules/parseqs/index.js");
var hasBin = __webpack_require__("./node_modules/has-binary2/index.js");

/**
 * Module exports.
 */

module.exports = exports = Socket;

/**
 * Internal events (blacklisted).
 * These events can't be emitted by the user.
 *
 * @api private
 */

var events = {
  connect: 1,
  connect_error: 1,
  connect_timeout: 1,
  connecting: 1,
  disconnect: 1,
  error: 1,
  reconnect: 1,
  reconnect_attempt: 1,
  reconnect_failed: 1,
  reconnect_error: 1,
  reconnecting: 1,
  ping: 1,
  pong: 1
};

/**
 * Shortcut to `Emitter#emit`.
 */

var emit = Emitter.prototype.emit;

/**
 * `Socket` constructor.
 *
 * @api public
 */

function Socket (io, nsp, opts) {
  this.io = io;
  this.nsp = nsp;
  this.json = this; // compat
  this.ids = 0;
  this.acks = {};
  this.receiveBuffer = [];
  this.sendBuffer = [];
  this.connected = false;
  this.disconnected = true;
  this.flags = {};
  if (opts && opts.query) {
    this.query = opts.query;
  }
  if (this.io.autoConnect) this.open();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Subscribe to open, close and packet events
 *
 * @api private
 */

Socket.prototype.subEvents = function () {
  if (this.subs) return;

  var io = this.io;
  this.subs = [
    on(io, 'open', bind(this, 'onopen')),
    on(io, 'packet', bind(this, 'onpacket')),
    on(io, 'close', bind(this, 'onclose'))
  ];
};

/**
 * "Opens" the socket.
 *
 * @api public
 */

Socket.prototype.open =
Socket.prototype.connect = function () {
  if (this.connected) return this;

  this.subEvents();
  this.io.open(); // ensure open
  if ('open' === this.io.readyState) this.onopen();
  this.emit('connecting');
  return this;
};

/**
 * Sends a `message` event.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.send = function () {
  var args = toArray(arguments);
  args.unshift('message');
  this.emit.apply(this, args);
  return this;
};

/**
 * Override `emit`.
 * If the event is in `events`, it's emitted normally.
 *
 * @param {String} event name
 * @return {Socket} self
 * @api public
 */

Socket.prototype.emit = function (ev) {
  if (events.hasOwnProperty(ev)) {
    emit.apply(this, arguments);
    return this;
  }

  var args = toArray(arguments);
  var packet = {
    type: (this.flags.binary !== undefined ? this.flags.binary : hasBin(args)) ? parser.BINARY_EVENT : parser.EVENT,
    data: args
  };

  packet.options = {};
  packet.options.compress = !this.flags || false !== this.flags.compress;

  // event ack callback
  if ('function' === typeof args[args.length - 1]) {
    debug('emitting packet with ack id %d', this.ids);
    this.acks[this.ids] = args.pop();
    packet.id = this.ids++;
  }

  if (this.connected) {
    this.packet(packet);
  } else {
    this.sendBuffer.push(packet);
  }

  this.flags = {};

  return this;
};

/**
 * Sends a packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.packet = function (packet) {
  packet.nsp = this.nsp;
  this.io.packet(packet);
};

/**
 * Called upon engine `open`.
 *
 * @api private
 */

Socket.prototype.onopen = function () {
  debug('transport is open - connecting');

  // write connect packet if necessary
  if ('/' !== this.nsp) {
    if (this.query) {
      var query = typeof this.query === 'object' ? parseqs.encode(this.query) : this.query;
      debug('sending connect packet with query %s', query);
      this.packet({type: parser.CONNECT, query: query});
    } else {
      this.packet({type: parser.CONNECT});
    }
  }
};

/**
 * Called upon engine `close`.
 *
 * @param {String} reason
 * @api private
 */

Socket.prototype.onclose = function (reason) {
  debug('close (%s)', reason);
  this.connected = false;
  this.disconnected = true;
  delete this.id;
  this.emit('disconnect', reason);
};

/**
 * Called with socket packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onpacket = function (packet) {
  var sameNamespace = packet.nsp === this.nsp;
  var rootNamespaceError = packet.type === parser.ERROR && packet.nsp === '/';

  if (!sameNamespace && !rootNamespaceError) return;

  switch (packet.type) {
    case parser.CONNECT:
      this.onconnect();
      break;

    case parser.EVENT:
      this.onevent(packet);
      break;

    case parser.BINARY_EVENT:
      this.onevent(packet);
      break;

    case parser.ACK:
      this.onack(packet);
      break;

    case parser.BINARY_ACK:
      this.onack(packet);
      break;

    case parser.DISCONNECT:
      this.ondisconnect();
      break;

    case parser.ERROR:
      this.emit('error', packet.data);
      break;
  }
};

/**
 * Called upon a server event.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onevent = function (packet) {
  var args = packet.data || [];
  debug('emitting event %j', args);

  if (null != packet.id) {
    debug('attaching ack callback to event');
    args.push(this.ack(packet.id));
  }

  if (this.connected) {
    emit.apply(this, args);
  } else {
    this.receiveBuffer.push(args);
  }
};

/**
 * Produces an ack callback to emit with an event.
 *
 * @api private
 */

Socket.prototype.ack = function (id) {
  var self = this;
  var sent = false;
  return function () {
    // prevent double callbacks
    if (sent) return;
    sent = true;
    var args = toArray(arguments);
    debug('sending ack %j', args);

    self.packet({
      type: hasBin(args) ? parser.BINARY_ACK : parser.ACK,
      id: id,
      data: args
    });
  };
};

/**
 * Called upon a server acknowlegement.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onack = function (packet) {
  var ack = this.acks[packet.id];
  if ('function' === typeof ack) {
    debug('calling ack %s with %j', packet.id, packet.data);
    ack.apply(this, packet.data);
    delete this.acks[packet.id];
  } else {
    debug('bad ack %s', packet.id);
  }
};

/**
 * Called upon server connect.
 *
 * @api private
 */

Socket.prototype.onconnect = function () {
  this.connected = true;
  this.disconnected = false;
  this.emit('connect');
  this.emitBuffered();
};

/**
 * Emit buffered events (received and emitted).
 *
 * @api private
 */

Socket.prototype.emitBuffered = function () {
  var i;
  for (i = 0; i < this.receiveBuffer.length; i++) {
    emit.apply(this, this.receiveBuffer[i]);
  }
  this.receiveBuffer = [];

  for (i = 0; i < this.sendBuffer.length; i++) {
    this.packet(this.sendBuffer[i]);
  }
  this.sendBuffer = [];
};

/**
 * Called upon server disconnect.
 *
 * @api private
 */

Socket.prototype.ondisconnect = function () {
  debug('server disconnect (%s)', this.nsp);
  this.destroy();
  this.onclose('io server disconnect');
};

/**
 * Called upon forced client/server side disconnections,
 * this method ensures the manager stops tracking us and
 * that reconnections don't get triggered for this.
 *
 * @api private.
 */

Socket.prototype.destroy = function () {
  if (this.subs) {
    // clean subscriptions to avoid reconnections
    for (var i = 0; i < this.subs.length; i++) {
      this.subs[i].destroy();
    }
    this.subs = null;
  }

  this.io.destroy(this);
};

/**
 * Disconnects the socket manually.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.close =
Socket.prototype.disconnect = function () {
  if (this.connected) {
    debug('performing disconnect (%s)', this.nsp);
    this.packet({ type: parser.DISCONNECT });
  }

  // remove socket from pool
  this.destroy();

  if (this.connected) {
    // fire events
    this.onclose('io client disconnect');
  }
  return this;
};

/**
 * Sets the compress flag.
 *
 * @param {Boolean} if `true`, compresses the sending data
 * @return {Socket} self
 * @api public
 */

Socket.prototype.compress = function (compress) {
  this.flags.compress = compress;
  return this;
};

/**
 * Sets the binary flag
 *
 * @param {Boolean} whether the emitted data contains binary
 * @return {Socket} self
 * @api public
 */

Socket.prototype.binary = function (binary) {
  this.flags.binary = binary;
  return this;
};


/***/ }),

/***/ "./node_modules/socket.io-client/lib/url.js":
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var parseuri = __webpack_require__("./node_modules/parseuri/index.js");
var debug = __webpack_require__("./node_modules/debug/src/browser.js")('socket.io-client:url');

/**
 * Module exports.
 */

module.exports = url;

/**
 * URL parser.
 *
 * @param {String} url
 * @param {Object} An object meant to mimic window.location.
 *                 Defaults to window.location.
 * @api public
 */

function url (uri, loc) {
  var obj = uri;

  // default to window.location
  loc = loc || (typeof location !== 'undefined' && location);
  if (null == uri) uri = loc.protocol + '//' + loc.host;

  // relative path support
  if ('string' === typeof uri) {
    if ('/' === uri.charAt(0)) {
      if ('/' === uri.charAt(1)) {
        uri = loc.protocol + uri;
      } else {
        uri = loc.host + uri;
      }
    }

    if (!/^(https?|wss?):\/\//.test(uri)) {
      debug('protocol-less url %s', uri);
      if ('undefined' !== typeof loc) {
        uri = loc.protocol + '//' + uri;
      } else {
        uri = 'https://' + uri;
      }
    }

    // parse
    debug('parse %s', uri);
    obj = parseuri(uri);
  }

  // make sure we treat `localhost:80` and `localhost` equally
  if (!obj.port) {
    if (/^(http|ws)$/.test(obj.protocol)) {
      obj.port = '80';
    } else if (/^(http|ws)s$/.test(obj.protocol)) {
      obj.port = '443';
    }
  }

  obj.path = obj.path || '/';

  var ipv6 = obj.host.indexOf(':') !== -1;
  var host = ipv6 ? '[' + obj.host + ']' : obj.host;

  // define unique id
  obj.id = obj.protocol + '://' + host + ':' + obj.port;
  // define href
  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));

  return obj;
}


/***/ }),

/***/ "./node_modules/socket.io-parser/binary.js":
/***/ (function(module, exports, __webpack_require__) {

/*global Blob,File*/

/**
 * Module requirements
 */

var isArray = __webpack_require__("./node_modules/isarray/index.js");
var isBuf = __webpack_require__("./node_modules/socket.io-parser/is-buffer.js");
var toString = Object.prototype.toString;
var withNativeBlob = typeof Blob === 'function' || (typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]');
var withNativeFile = typeof File === 'function' || (typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]');

/**
 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
 * Anything with blobs or files should be fed through removeBlobs before coming
 * here.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @api public
 */

exports.deconstructPacket = function(packet) {
  var buffers = [];
  var packetData = packet.data;
  var pack = packet;
  pack.data = _deconstructPacket(packetData, buffers);
  pack.attachments = buffers.length; // number of binary 'attachments'
  return {packet: pack, buffers: buffers};
};

function _deconstructPacket(data, buffers) {
  if (!data) return data;

  if (isBuf(data)) {
    var placeholder = { _placeholder: true, num: buffers.length };
    buffers.push(data);
    return placeholder;
  } else if (isArray(data)) {
    var newData = new Array(data.length);
    for (var i = 0; i < data.length; i++) {
      newData[i] = _deconstructPacket(data[i], buffers);
    }
    return newData;
  } else if (typeof data === 'object' && !(data instanceof Date)) {
    var newData = {};
    for (var key in data) {
      newData[key] = _deconstructPacket(data[key], buffers);
    }
    return newData;
  }
  return data;
}

/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @api public
 */

exports.reconstructPacket = function(packet, buffers) {
  packet.data = _reconstructPacket(packet.data, buffers);
  packet.attachments = undefined; // no longer useful
  return packet;
};

function _reconstructPacket(data, buffers) {
  if (!data) return data;

  if (data && data._placeholder) {
    return buffers[data.num]; // appropriate buffer (should be natural order anyway)
  } else if (isArray(data)) {
    for (var i = 0; i < data.length; i++) {
      data[i] = _reconstructPacket(data[i], buffers);
    }
  } else if (typeof data === 'object') {
    for (var key in data) {
      data[key] = _reconstructPacket(data[key], buffers);
    }
  }

  return data;
}

/**
 * Asynchronously removes Blobs or Files from data via
 * FileReader's readAsArrayBuffer method. Used before encoding
 * data as msgpack. Calls callback with the blobless data.
 *
 * @param {Object} data
 * @param {Function} callback
 * @api private
 */

exports.removeBlobs = function(data, callback) {
  function _removeBlobs(obj, curKey, containingObject) {
    if (!obj) return obj;

    // convert any blob
    if ((withNativeBlob && obj instanceof Blob) ||
        (withNativeFile && obj instanceof File)) {
      pendingBlobs++;

      // async filereader
      var fileReader = new FileReader();
      fileReader.onload = function() { // this.result == arraybuffer
        if (containingObject) {
          containingObject[curKey] = this.result;
        }
        else {
          bloblessData = this.result;
        }

        // if nothing pending its callback time
        if(! --pendingBlobs) {
          callback(bloblessData);
        }
      };

      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
    } else if (isArray(obj)) { // handle array
      for (var i = 0; i < obj.length; i++) {
        _removeBlobs(obj[i], i, obj);
      }
    } else if (typeof obj === 'object' && !isBuf(obj)) { // and object
      for (var key in obj) {
        _removeBlobs(obj[key], key, obj);
      }
    }
  }

  var pendingBlobs = 0;
  var bloblessData = data;
  _removeBlobs(bloblessData);
  if (!pendingBlobs) {
    callback(bloblessData);
  }
};


/***/ }),

/***/ "./node_modules/socket.io-parser/index.js":
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var debug = __webpack_require__("./node_modules/debug/src/browser.js")('socket.io-parser');
var Emitter = __webpack_require__("./node_modules/component-emitter/index.js");
var binary = __webpack_require__("./node_modules/socket.io-parser/binary.js");
var isArray = __webpack_require__("./node_modules/isarray/index.js");
var isBuf = __webpack_require__("./node_modules/socket.io-parser/is-buffer.js");

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = 4;

/**
 * Packet types.
 *
 * @api public
 */

exports.types = [
  'CONNECT',
  'DISCONNECT',
  'EVENT',
  'ACK',
  'ERROR',
  'BINARY_EVENT',
  'BINARY_ACK'
];

/**
 * Packet type `connect`.
 *
 * @api public
 */

exports.CONNECT = 0;

/**
 * Packet type `disconnect`.
 *
 * @api public
 */

exports.DISCONNECT = 1;

/**
 * Packet type `event`.
 *
 * @api public
 */

exports.EVENT = 2;

/**
 * Packet type `ack`.
 *
 * @api public
 */

exports.ACK = 3;

/**
 * Packet type `error`.
 *
 * @api public
 */

exports.ERROR = 4;

/**
 * Packet type 'binary event'
 *
 * @api public
 */

exports.BINARY_EVENT = 5;

/**
 * Packet type `binary ack`. For acks with binary arguments.
 *
 * @api public
 */

exports.BINARY_ACK = 6;

/**
 * Encoder constructor.
 *
 * @api public
 */

exports.Encoder = Encoder;

/**
 * Decoder constructor.
 *
 * @api public
 */

exports.Decoder = Decoder;

/**
 * A socket.io Encoder instance
 *
 * @api public
 */

function Encoder() {}

var ERROR_PACKET = exports.ERROR + '"encode error"';

/**
 * Encode a packet as a single string if non-binary, or as a
 * buffer sequence, depending on packet type.
 *
 * @param {Object} obj - packet object
 * @param {Function} callback - function to handle encodings (likely engine.write)
 * @return Calls callback with Array of encodings
 * @api public
 */

Encoder.prototype.encode = function(obj, callback){
  debug('encoding packet %j', obj);

  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
    encodeAsBinary(obj, callback);
  } else {
    var encoding = encodeAsString(obj);
    callback([encoding]);
  }
};

/**
 * Encode packet as string.
 *
 * @param {Object} packet
 * @return {String} encoded
 * @api private
 */

function encodeAsString(obj) {

  // first is type
  var str = '' + obj.type;

  // attachments if we have them
  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
    str += obj.attachments + '-';
  }

  // if we have a namespace other than `/`
  // we append it followed by a comma `,`
  if (obj.nsp && '/' !== obj.nsp) {
    str += obj.nsp + ',';
  }

  // immediately followed by the id
  if (null != obj.id) {
    str += obj.id;
  }

  // json data
  if (null != obj.data) {
    var payload = tryStringify(obj.data);
    if (payload !== false) {
      str += payload;
    } else {
      return ERROR_PACKET;
    }
  }

  debug('encoded %j as %s', obj, str);
  return str;
}

function tryStringify(str) {
  try {
    return JSON.stringify(str);
  } catch(e){
    return false;
  }
}

/**
 * Encode packet as 'buffer sequence' by removing blobs, and
 * deconstructing packet into object with placeholders and
 * a list of buffers.
 *
 * @param {Object} packet
 * @return {Buffer} encoded
 * @api private
 */

function encodeAsBinary(obj, callback) {

  function writeEncoding(bloblessData) {
    var deconstruction = binary.deconstructPacket(bloblessData);
    var pack = encodeAsString(deconstruction.packet);
    var buffers = deconstruction.buffers;

    buffers.unshift(pack); // add packet info to beginning of data list
    callback(buffers); // write all the buffers
  }

  binary.removeBlobs(obj, writeEncoding);
}

/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 * @api public
 */

function Decoder() {
  this.reconstructor = null;
}

/**
 * Mix in `Emitter` with Decoder.
 */

Emitter(Decoder.prototype);

/**
 * Decodes an encoded packet string into packet JSON.
 *
 * @param {String} obj - encoded packet
 * @return {Object} packet
 * @api public
 */

Decoder.prototype.add = function(obj) {
  var packet;
  if (typeof obj === 'string') {
    packet = decodeString(obj);
    if (exports.BINARY_EVENT === packet.type || exports.BINARY_ACK === packet.type) { // binary packet's json
      this.reconstructor = new BinaryReconstructor(packet);

      // no attachments, labeled binary but no binary data to follow
      if (this.reconstructor.reconPack.attachments === 0) {
        this.emit('decoded', packet);
      }
    } else { // non-binary full packet
      this.emit('decoded', packet);
    }
  } else if (isBuf(obj) || obj.base64) { // raw binary data
    if (!this.reconstructor) {
      throw new Error('got binary data when not reconstructing a packet');
    } else {
      packet = this.reconstructor.takeBinaryData(obj);
      if (packet) { // received final buffer
        this.reconstructor = null;
        this.emit('decoded', packet);
      }
    }
  } else {
    throw new Error('Unknown type: ' + obj);
  }
};

/**
 * Decode a packet String (JSON data)
 *
 * @param {String} str
 * @return {Object} packet
 * @api private
 */

function decodeString(str) {
  var i = 0;
  // look up type
  var p = {
    type: Number(str.charAt(0))
  };

  if (null == exports.types[p.type]) {
    return error('unknown packet type ' + p.type);
  }

  // look up attachments if type binary
  if (exports.BINARY_EVENT === p.type || exports.BINARY_ACK === p.type) {
    var buf = '';
    while (str.charAt(++i) !== '-') {
      buf += str.charAt(i);
      if (i == str.length) break;
    }
    if (buf != Number(buf) || str.charAt(i) !== '-') {
      throw new Error('Illegal attachments');
    }
    p.attachments = Number(buf);
  }

  // look up namespace (if any)
  if ('/' === str.charAt(i + 1)) {
    p.nsp = '';
    while (++i) {
      var c = str.charAt(i);
      if (',' === c) break;
      p.nsp += c;
      if (i === str.length) break;
    }
  } else {
    p.nsp = '/';
  }

  // look up id
  var next = str.charAt(i + 1);
  if ('' !== next && Number(next) == next) {
    p.id = '';
    while (++i) {
      var c = str.charAt(i);
      if (null == c || Number(c) != c) {
        --i;
        break;
      }
      p.id += str.charAt(i);
      if (i === str.length) break;
    }
    p.id = Number(p.id);
  }

  // look up json data
  if (str.charAt(++i)) {
    var payload = tryParse(str.substr(i));
    var isPayloadValid = payload !== false && (p.type === exports.ERROR || isArray(payload));
    if (isPayloadValid) {
      p.data = payload;
    } else {
      return error('invalid payload');
    }
  }

  debug('decoded %s as %j', str, p);
  return p;
}

function tryParse(str) {
  try {
    return JSON.parse(str);
  } catch(e){
    return false;
  }
}

/**
 * Deallocates a parser's resources
 *
 * @api public
 */

Decoder.prototype.destroy = function() {
  if (this.reconstructor) {
    this.reconstructor.finishedReconstruction();
  }
};

/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 * @api private
 */

function BinaryReconstructor(packet) {
  this.reconPack = packet;
  this.buffers = [];
}

/**
 * Method to be called when binary data received from connection
 * after a BINARY_EVENT packet.
 *
 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
 * @return {null | Object} returns null if more binary data is expected or
 *   a reconstructed packet object if all buffers have been received.
 * @api private
 */

BinaryReconstructor.prototype.takeBinaryData = function(binData) {
  this.buffers.push(binData);
  if (this.buffers.length === this.reconPack.attachments) { // done with buffer list
    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
    this.finishedReconstruction();
    return packet;
  }
  return null;
};

/**
 * Cleans up binary packet reconstruction variables.
 *
 * @api private
 */

BinaryReconstructor.prototype.finishedReconstruction = function() {
  this.reconPack = null;
  this.buffers = [];
};

function error(msg) {
  return {
    type: exports.ERROR,
    data: 'parser error: ' + msg
  };
}


/***/ }),

/***/ "./node_modules/socket.io-parser/is-buffer.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {
module.exports = isBuf;

var withNativeBuffer = typeof Buffer === 'function' && typeof Buffer.isBuffer === 'function';
var withNativeArrayBuffer = typeof ArrayBuffer === 'function';

var isView = function (obj) {
  return typeof ArrayBuffer.isView === 'function' ? ArrayBuffer.isView(obj) : (obj.buffer instanceof ArrayBuffer);
};

/**
 * Returns true if obj is a buffer or an arraybuffer.
 *
 * @api private
 */

function isBuf(obj) {
  return (withNativeBuffer && Buffer.isBuffer(obj)) ||
          (withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj)));
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/style-loader/lib/addStyles.js":
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target, parent) {
  if (parent){
    return parent.querySelector(target);
  }
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target, parent) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target, parent);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__("./node_modules/style-loader/lib/urls.js");

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertAt.before, target);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}

	if(options.attrs.nonce === undefined) {
		var nonce = getNonce();
		if (nonce) {
			options.attrs.nonce = nonce;
		}
	}

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function getNonce() {
	if (false) {
		return null;
	}

	return __webpack_require__.nc;
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = typeof options.transform === 'function'
		 ? options.transform(obj.css) 
		 : options.transform.default(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ "./node_modules/style-loader/lib/urls.js":
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),

/***/ "./node_modules/tiny-invariant/dist/tiny-invariant.esm.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),

/***/ "./node_modules/tiny-warning/dist/tiny-warning.esm.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),

/***/ "./node_modules/to-array/index.js":
/***/ (function(module, exports) {

module.exports = toArray

function toArray(list, index) {
    var array = []

    index = index || 0

    for (var i = index || 0; i < list.length; i++) {
        array[i - index] = list[i]
    }

    return array
}


/***/ }),

/***/ "./node_modules/uberproto/lib/proto.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* global define */
/**
 * A base object for ECMAScript 5 style prototypal inheritance.
 *
 * @see https://github.com/rauschma/proto-js/
 * @see http://ejohn.org/blog/simple-javascript-inheritance/
 * @see http://uxebu.com/blog/2011/02/23/object-based-inheritance-for-ecmascript-5/
 */
(function (root, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		module.exports = factory();
	} else {
		root.Proto = factory();
	}
}(this, function () {

	function makeSuper(_super, old, name, fn) {
		return function () {
			var tmp = this._super;

			// Add a new ._super() method that is the same method
			// but either pointing to the prototype method
			// or to the overwritten method
			this._super = (typeof old === 'function') ? old : _super[name];

			// The method only need to be bound temporarily, so we
			// remove it when we're done executing
			var ret = fn.apply(this, arguments);
			this._super = tmp;

			return ret;
		};
	}

	function legacyMixin(prop, obj) {
		var self = obj || this;
		var fnTest = /\b_super\b/;
		var _super = Object.getPrototypeOf(self) || self.prototype;
		var _old;

		// Copy the properties over
		for (var name in prop) {
			// store the old function which would be overwritten
			_old = self[name];

			// Check if we're overwriting an existing function
			if(
					((
						typeof prop[name] === 'function' &&
						typeof _super[name] === 'function'
					) || (
						typeof _old === 'function' &&
						typeof prop[name] === 'function'
					)) && fnTest.test(prop[name])
			) {
				self[name] = makeSuper(_super, _old, name, prop[name]);
			} else {
				self[name] = prop[name];
			}
		}

		return self;
	}

	function es5Mixin(prop, obj) {
		var self = obj || this;
		var fnTest = /\b_super\b/;
		var _super = Object.getPrototypeOf(self) || self.prototype;
		var descriptors = {};
		var proto = prop;
		var processProperty = function(name) {
			if(!descriptors[name]) {
				descriptors[name] = Object.getOwnPropertyDescriptor(proto, name);
			}
		};

		// Collect all property descriptors
		do {
			Object.getOwnPropertyNames(proto).forEach(processProperty);
    } while((proto = Object.getPrototypeOf(proto)) && Object.getPrototypeOf(proto));
		
		Object.keys(descriptors).forEach(function(name) {
			var descriptor = descriptors[name];

			if(typeof descriptor.value === 'function' && fnTest.test(descriptor.value)) {
				descriptor.value = makeSuper(_super, self[name], name, descriptor.value);
			}

			Object.defineProperty(self, name, descriptor);
		});

		return self;
	}

	return {
		/**
		 * Create a new object using Object.create. The arguments will be
		 * passed to the new instances init method or to a method name set in
		 * __init.
		 */
		create: function () {
			var instance = Object.create(this);
			var init = typeof instance.__init === 'string' ? instance.__init : 'init';

			if (typeof instance[init] === 'function') {
				instance[init].apply(instance, arguments);
			}
			return instance;
		},
		/**
		 * Mixin a given set of properties
		 * @param prop The properties to mix in
		 * @param obj [optional] The object to add the mixin
		 */
		mixin: typeof Object.defineProperty === 'function' ? es5Mixin : legacyMixin,
		/**
		 * Extend the current or a given object with the given property
		 * and return the extended object.
		 * @param prop The properties to extend with
		 * @param obj [optional] The object to extend from
		 * @returns The extended object
		 */
		extend: function (prop, obj) {
			return this.mixin(prop, Object.create(obj || this));
		},
		/**
		 * Return a callback function with this set to the current or a given context object.
		 * @param name Name of the method to proxy
		 * @param args... [optional] Arguments to use for partial application
		 */
		proxy: function (name) {
			var fn = this[name];
			var args = Array.prototype.slice.call(arguments, 1);

			args.unshift(this);
			return fn.bind.apply(fn, args);
		}
	};

}));


/***/ }),

/***/ "./node_modules/value-equal/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),

/***/ "./node_modules/warning/warning.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./node_modules/webpack/buildin/harmony-module.js":
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "./node_modules/webpack/buildin/module.js":
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "./node_modules/yeast/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
  , length = 64
  , map = {}
  , seed = 0
  , i = 0
  , prev;

/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */
function encode(num) {
  var encoded = '';

  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);

  return encoded;
}

/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */
function decode(str) {
  var decoded = 0;

  for (i = 0; i < str.length; i++) {
    decoded = decoded * length + map[str.charAt(i)];
  }

  return decoded;
}

/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */
function yeast() {
  var now = encode(+new Date());

  if (now !== prev) return seed = 0, prev = now;
  return now +'.'+ encode(seed++);
}

//
// Map each character to its index.
//
for (; i < length; i++) map[alphabet[i]] = i;

//
// Expose the `yeast`, `encode` and `decode` functions.
//
yeast.encode = encode;
yeast.decode = decode;
module.exports = yeast;


/***/ }),

/***/ "./node_modules/zenscroll/zenscroll.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Zenscroll 4.0.2
 * https://github.com/zengabor/zenscroll/
 *
 * Copyright 2015–2018 Gabor Lenard
 *
 * This is free and unencumbered software released into the public domain.
 * 
 * Anyone is free to copy, modify, publish, use, compile, sell, or
 * distribute this software, either in source code form or as a compiled
 * binary, for any purpose, commercial or non-commercial, and by any
 * means.
 * 
 * In jurisdictions that recognize copyright laws, the author or authors
 * of this software dedicate any and all copyright interest in the
 * software to the public domain. We make this dedication for the benefit
 * of the public at large and to the detriment of our heirs and
 * successors. We intend this dedication to be an overt act of
 * relinquishment in perpetuity of all present and future rights to this
 * software under copyright law.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR
 * OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
 * ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 * 
 * For more information, please refer to <http://unlicense.org>
 * 
 */

/*jshint devel:true, asi:true */

/*global define, module */


(function (root, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory()),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	} else if (typeof module === "object" && module.exports) {
		module.exports = factory()
	} else {
		(function install() {
			// To make sure Zenscroll can be referenced from the header, before `body` is available
			if (document && document.body) {
				root.zenscroll = factory()
			} else {
				// retry 9ms later
				setTimeout(install, 9)
			}
		})()
	}
}(this, function () {
	"use strict"


	// Detect if the browser already supports native smooth scrolling (e.g., Firefox 36+ and Chrome 49+) and it is enabled:
	var isNativeSmoothScrollEnabledOn = function (elem) {
		return elem && "getComputedStyle" in window &&
			window.getComputedStyle(elem)["scroll-behavior"] === "smooth"
	}


	// Exit if it’s not a browser environment:
	if (typeof window === "undefined" || !("document" in window)) {
		return {}
	}


	var makeScroller = function (container, defaultDuration, edgeOffset) {

		// Use defaults if not provided
		defaultDuration = defaultDuration || 999 //ms
		if (!edgeOffset && edgeOffset !== 0) {
			// When scrolling, this amount of distance is kept from the edges of the container:
			edgeOffset = 9 //px
		}

		// Handling the life-cycle of the scroller
		var scrollTimeoutId
		var setScrollTimeoutId = function (newValue) {
			scrollTimeoutId = newValue
		}

		/**
		 * Stop the current smooth scroll operation immediately
		 */
		var stopScroll = function () {
			clearTimeout(scrollTimeoutId)
			setScrollTimeoutId(0)
		}

		var getTopWithEdgeOffset = function (elem) {
			return Math.max(0, container.getTopOf(elem) - edgeOffset)
		}

		/**
		 * Scrolls to a specific vertical position in the document.
		 *
		 * @param {targetY} The vertical position within the document.
		 * @param {duration} Optionally the duration of the scroll operation.
		 *        If not provided the default duration is used.
		 * @param {onDone} An optional callback function to be invoked once the scroll finished.
		 */
		var scrollToY = function (targetY, duration, onDone) {
			stopScroll()
			if (duration === 0 || (duration && duration < 0) || isNativeSmoothScrollEnabledOn(container.body)) {
				container.toY(targetY)
				if (onDone) {
					onDone()
				}
			} else {
				var startY = container.getY()
				var distance = Math.max(0, targetY) - startY
				var startTime = new Date().getTime()
				duration = duration || Math.min(Math.abs(distance), defaultDuration);
				(function loopScroll() {
					setScrollTimeoutId(setTimeout(function () {
						// Calculate percentage:
						var p = Math.min(1, (new Date().getTime() - startTime) / duration)
						// Calculate the absolute vertical position:
						var y = Math.max(0, Math.floor(startY + distance*(p < 0.5 ? 2*p*p : p*(4 - p*2)-1)))
						container.toY(y)
						if (p < 1 && (container.getHeight() + y) < container.body.scrollHeight) {
							loopScroll()
						} else {
							setTimeout(stopScroll, 99) // with cooldown time
							if (onDone) {
								onDone()
							}
						}
					}, 9))
				})()
			}
		}

		/**
		 * Scrolls to the top of a specific element.
		 *
		 * @param {elem} The element to scroll to.
		 * @param {duration} Optionally the duration of the scroll operation.
		 * @param {onDone} An optional callback function to be invoked once the scroll finished.
		 */
		var scrollToElem = function (elem, duration, onDone) {
			scrollToY(getTopWithEdgeOffset(elem), duration, onDone)
		}

		/**
		 * Scrolls an element into view if necessary.
		 *
		 * @param {elem} The element.
		 * @param {duration} Optionally the duration of the scroll operation.
		 * @param {onDone} An optional callback function to be invoked once the scroll finished.
		 */
		var scrollIntoView = function (elem, duration, onDone) {
			var elemHeight = elem.getBoundingClientRect().height
			var elemBottom = container.getTopOf(elem) + elemHeight
			var containerHeight = container.getHeight()
			var y = container.getY()
			var containerBottom = y + containerHeight
			if (getTopWithEdgeOffset(elem) < y || (elemHeight + edgeOffset) > containerHeight) {
				// Element is clipped at top or is higher than screen.
				scrollToElem(elem, duration, onDone)
			} else if ((elemBottom + edgeOffset) > containerBottom) {
				// Element is clipped at the bottom.
				scrollToY(elemBottom - containerHeight + edgeOffset, duration, onDone)
			} else if (onDone) {
				onDone()
			}
		}

		/**
		 * Scrolls to the center of an element.
		 *
		 * @param {elem} The element.
		 * @param {duration} Optionally the duration of the scroll operation.
		 * @param {offset} Optionally the offset of the top of the element from the center of the screen.
		 *        A value of 0 is ignored.
		 * @param {onDone} An optional callback function to be invoked once the scroll finished.
		 */
		var scrollToCenterOf = function (elem, duration, offset, onDone) {
			scrollToY(Math.max(0, container.getTopOf(elem) - container.getHeight()/2 + (offset || elem.getBoundingClientRect().height/2)), duration, onDone)
		}

		/**
		 * Changes default settings for this scroller.
		 *
		 * @param {newDefaultDuration} Optionally a new value for default duration, used for each scroll method by default.
		 *        Ignored if null or undefined.
		 * @param {newEdgeOffset} Optionally a new value for the edge offset, used by each scroll method by default. Ignored if null or undefined.
		 * @returns An object with the current values.
		 */
		var setup = function (newDefaultDuration, newEdgeOffset) {
			if (newDefaultDuration === 0 || newDefaultDuration) {
				defaultDuration = newDefaultDuration
			}
			if (newEdgeOffset === 0 || newEdgeOffset) {
				edgeOffset = newEdgeOffset
			}
			return {
				defaultDuration: defaultDuration,
				edgeOffset: edgeOffset
			}
		}

		return {
			setup: setup,
			to: scrollToElem,
			toY: scrollToY,
			intoView: scrollIntoView,
			center: scrollToCenterOf,
			stop: stopScroll,
			moving: function () { return !!scrollTimeoutId },
			getY: container.getY,
			getTopOf: container.getTopOf
		}

	}


	var docElem = document.documentElement
	var getDocY = function () { return window.scrollY || docElem.scrollTop }

	// Create a scroller for the document:
	var zenscroll = makeScroller({
		body: document.scrollingElement || document.body,
		toY: function (y) { window.scrollTo(0, y) },
		getY: getDocY,
		getHeight: function () { return window.innerHeight || docElem.clientHeight },
		getTopOf: function (elem) { return elem.getBoundingClientRect().top + getDocY() - docElem.offsetTop }
	})


	/**
	 * Creates a scroller from the provided container element (e.g., a DIV)
	 *
	 * @param {scrollContainer} The vertical position within the document.
	 * @param {defaultDuration} Optionally a value for default duration, used for each scroll method by default.
	 *        Ignored if 0 or null or undefined.
	 * @param {edgeOffset} Optionally a value for the edge offset, used by each scroll method by default. 
	 *        Ignored if null or undefined.
	 * @returns A scroller object, similar to `zenscroll` but controlling the provided element.
	 */
	zenscroll.createScroller = function (scrollContainer, defaultDuration, edgeOffset) {
		return makeScroller({
			body: scrollContainer,
			toY: function (y) { scrollContainer.scrollTop = y },
			getY: function () { return scrollContainer.scrollTop },
			getHeight: function () { return Math.min(scrollContainer.clientHeight, window.innerHeight || docElem.clientHeight) },
			getTopOf: function (elem) { return elem.offsetTop }
		}, defaultDuration, edgeOffset)
	}


	// Automatic link-smoothing on achors
	// Exclude IE8- or when native is enabled or Zenscroll auto- is disabled
	if ("addEventListener" in window && !window.noZensmooth && !isNativeSmoothScrollEnabledOn(document.body)) {

		var isHistorySupported = "history" in window && "pushState" in history
		var isScrollRestorationSupported = isHistorySupported && "scrollRestoration" in history

		// On first load & refresh make sure the browser restores the position first
		if (isScrollRestorationSupported) {
			history.scrollRestoration = "auto"
		}

		window.addEventListener("load", function () {

			if (isScrollRestorationSupported) {
				// Set it to manual
				setTimeout(function () { history.scrollRestoration = "manual" }, 9)
				window.addEventListener("popstate", function (event) {
					if (event.state && "zenscrollY" in event.state) {
						zenscroll.toY(event.state.zenscrollY)
					}
				}, false)
			}

			// Add edge offset on first load if necessary
			// This may not work on IE (or older computer?) as it requires more timeout, around 100 ms
			if (window.location.hash) {
				setTimeout(function () {
					// Adjustment is only needed if there is an edge offset:
					var edgeOffset = zenscroll.setup().edgeOffset
					if (edgeOffset) {
						var targetElem = document.getElementById(window.location.href.split("#")[1])
						if (targetElem) {
							var targetY = Math.max(0, zenscroll.getTopOf(targetElem) - edgeOffset)
							var diff = zenscroll.getY() - targetY
							// Only do the adjustment if the browser is very close to the element:
							if (0 <= diff && diff < 9 ) {
								window.scrollTo(0, targetY)
							}
						}
					}
				}, 9)
			}

		}, false)

		// Handling clicks on anchors
		var RE_noZensmooth = new RegExp("(^|\\s)noZensmooth(\\s|$)")
		window.addEventListener("click", function (event) {
			var anchor = event.target
			while (anchor && anchor.tagName !== "A") {
				anchor = anchor.parentNode
			}
			// Let the browser handle the click if it wasn't with the primary button, or with some modifier keys:
			if (!anchor || event.which !== 1 || event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) {
				return
			}
			// Save the current scrolling position so it can be used for scroll restoration:
			if (isScrollRestorationSupported) {
				var historyState = history.state && typeof history.state === "object" ? history.state : {}
				historyState.zenscrollY = zenscroll.getY()
				try {
					history.replaceState(historyState, "")
				} catch (e) {
					// Avoid the Chrome Security exception on file protocol, e.g., file://index.html
				}
			}
			// Find the referenced ID:
			var href = anchor.getAttribute("href") || ""
			if (href.indexOf("#") === 0 && !RE_noZensmooth.test(anchor.className)) {
				var targetY = 0
				var targetElem = document.getElementById(href.substring(1))
				if (href !== "#") {
					if (!targetElem) {
						// Let the browser handle the click if the target ID is not found.
						return
					}
					targetY = zenscroll.getTopOf(targetElem)
				}
				event.preventDefault()
				// By default trigger the browser's `hashchange` event...
				var onDone = function () { window.location = href }
				// ...unless there is an edge offset specified
				var edgeOffset = zenscroll.setup().edgeOffset
				if (edgeOffset) {
					targetY = Math.max(0, targetY - edgeOffset)
					if (isHistorySupported) {
						onDone = function () { history.pushState({}, "", href) }
					}
				}
				zenscroll.toY(targetY, null, onDone)
			}
		}, false)

	}


	return zenscroll


}));


/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./app/web/index.tsx");


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.js